webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
//! version : 2.15.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, function () { 'use strict';

    var hookCallback;

    function utils_hooks__hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        var k;
        for (k in obj) {
            // even if its not own property I'd still call it non-empty
            return false;
        }
        return true;
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function create_utc__createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function valid__isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function valid__createInvalid (flags) {
        var m = create_utc__createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    function isUndefined(input) {
        return input === void 0;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = utils_hooks__hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i in momentProperties) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            utils_hooks__hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (utils_hooks__hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (utils_hooks__hooks.deprecationHandler != null) {
                utils_hooks__hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (utils_hooks__hooks.deprecationHandler != null) {
            utils_hooks__hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    utils_hooks__hooks.suppressDeprecationWarnings = false;
    utils_hooks__hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function locale_set__set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _ordinalParseLenient.
        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function locale_calendar__calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                get_set__set(this, unit, value);
                utils_hooks__hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get_set__get(this, unit);
            }
        };
    }

    function get_set__get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function get_set__set (mom, unit, value) {
        if (mom.isValid()) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (typeof callback === 'number') {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return this._months;
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return this._monthsShort;
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function units_month__handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = create_utc__createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return units_month__handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (typeof value !== 'number') {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            utils_hooks__hooks.updateOffset(this, true);
            return this;
        } else {
            return get_set__get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    utils_hooks__hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function createDate (y, m, d, h, M, s, ms) {
        //can't just apply() to create a date:
        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
        var date = new Date(y, m, d, h, M, s, ms);

        //the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        //the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return this._weekdays;
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function day_of_week__handleStrictParse(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = create_utc__createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return day_of_week__handleStrictParse.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = create_utc__createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour he wants. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        ordinalParse: defaultOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return null;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                __webpack_require__(1013)("./" + name);
                // because defineLocale currently also sets the global locale, we
                // want to undo that for lazy loaded locales
                locale_locales__getSetGlobalLocale(oldLocale);
            } catch (e) { }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function locale_locales__getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = locale_locales__getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    // treat as if there is no base config
                    deprecateSimple('parentLocaleUndefined',
                            'specified parentLocale is not defined yet. See http://momentjs.com/guides/#/warnings/parent-locale/');
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            // backwards compat for now: also set the locale
            locale_locales__getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, parentConfig = baseConfig;
            // MERGE
            if (locales[name] != null) {
                parentConfig = locales[name]._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            locale_locales__getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function locale_locales__getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function locale_locales__listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
            utils_hooks__hooks.createFromInputFallback(config);
        }
    }

    utils_hooks__hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(utils_hooks__hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse)) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
            week = defaults(w.w, 1);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    utils_hooks__hooks.ISO_8601 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === utils_hooks__hooks.ISO_8601) {
            configFromISO(config);
            return;
        }

        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!valid__isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || locale_locales__getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return valid__createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (isDate(input)) {
            config._d = input;
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!valid__isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (input === undefined) {
            config._d = new Date(utils_hooks__hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (typeof(input) === 'object') {
            configFromObject(config);
        } else if (typeof(input) === 'number') {
            // from milliseconds
            config._d = new Date(input);
        } else {
            utils_hooks__hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (typeof(locale) === 'boolean') {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function local__createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = local__createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return valid__createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = local__createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return valid__createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return local__createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = locale_locales__getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = ((string || '').match(matcher) || []);
        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : local__createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            utils_hooks__hooks.updateOffset(res, false);
            return res;
        } else {
            return local__createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    utils_hooks__hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
            } else if (Math.abs(input) < 16) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    utils_hooks__hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm) {
            this.utcOffset(this._tzm);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);

            if (tZone === 0) {
                this.utcOffset(0, true);
            } else {
                this.utcOffset(offsetFromString(matchOffset, this._i));
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? local__createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

    function create__createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (typeof input === 'number') {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    create__createDuration.fn = Duration.prototype;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = create__createDuration(val, period);
            add_subtract__addSubtract(this, dur, direction);
            return this;
        };
    }

    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (days) {
            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
        }
        if (months) {
            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
        }
        if (updateOffset) {
            utils_hooks__hooks.updateOffset(mom, days || months);
        }
    }

    var add_subtract__add      = createAdder(1, 'add');
    var add_subtract__subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function moment_calendar__calendar (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || local__createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = utils_hooks__hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, local__createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            delta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        if (units === 'year' || units === 'month' || units === 'quarter') {
            output = monthDiff(this, that);
            if (units === 'quarter') {
                output = output / 3;
            } else if (units === 'year') {
                output = output / 12;
            }
        } else {
            delta = this - that;
            output = units === 'second' ? delta / 1e3 : // 1000
                units === 'minute' ? delta / 6e4 : // 1000 * 60
                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
                delta;
        }
        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    utils_hooks__hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function moment_format__toISOString () {
        var m = this.clone().utc();
        if (0 < m.year() && m.year() <= 9999) {
            if (isFunction(Date.prototype.toISOString)) {
                // native implementation is ~50x faster, use it when we can
                return this.toDate().toISOString();
            } else {
                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            }
        } else {
            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
        }
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? utils_hooks__hooks.defaultFormatUtc : utils_hooks__hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 local__createLocal(time).isValid())) {
            return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(local__createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 local__createLocal(time).isValid())) {
            return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(local__createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = locale_locales__getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function to_type__valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function moment_valid__isValid () {
        return valid__isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIOROITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0], 10);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var momentPrototype__proto = Moment.prototype;

    momentPrototype__proto.add               = add_subtract__add;
    momentPrototype__proto.calendar          = moment_calendar__calendar;
    momentPrototype__proto.clone             = clone;
    momentPrototype__proto.diff              = diff;
    momentPrototype__proto.endOf             = endOf;
    momentPrototype__proto.format            = format;
    momentPrototype__proto.from              = from;
    momentPrototype__proto.fromNow           = fromNow;
    momentPrototype__proto.to                = to;
    momentPrototype__proto.toNow             = toNow;
    momentPrototype__proto.get               = stringGet;
    momentPrototype__proto.invalidAt         = invalidAt;
    momentPrototype__proto.isAfter           = isAfter;
    momentPrototype__proto.isBefore          = isBefore;
    momentPrototype__proto.isBetween         = isBetween;
    momentPrototype__proto.isSame            = isSame;
    momentPrototype__proto.isSameOrAfter     = isSameOrAfter;
    momentPrototype__proto.isSameOrBefore    = isSameOrBefore;
    momentPrototype__proto.isValid           = moment_valid__isValid;
    momentPrototype__proto.lang              = lang;
    momentPrototype__proto.locale            = locale;
    momentPrototype__proto.localeData        = localeData;
    momentPrototype__proto.max               = prototypeMax;
    momentPrototype__proto.min               = prototypeMin;
    momentPrototype__proto.parsingFlags      = parsingFlags;
    momentPrototype__proto.set               = stringSet;
    momentPrototype__proto.startOf           = startOf;
    momentPrototype__proto.subtract          = add_subtract__subtract;
    momentPrototype__proto.toArray           = toArray;
    momentPrototype__proto.toObject          = toObject;
    momentPrototype__proto.toDate            = toDate;
    momentPrototype__proto.toISOString       = moment_format__toISOString;
    momentPrototype__proto.toJSON            = toJSON;
    momentPrototype__proto.toString          = toString;
    momentPrototype__proto.unix              = unix;
    momentPrototype__proto.valueOf           = to_type__valueOf;
    momentPrototype__proto.creationData      = creationData;

    // Year
    momentPrototype__proto.year       = getSetYear;
    momentPrototype__proto.isLeapYear = getIsLeapYear;

    // Week Year
    momentPrototype__proto.weekYear    = getSetWeekYear;
    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;

    // Quarter
    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;

    // Month
    momentPrototype__proto.month       = getSetMonth;
    momentPrototype__proto.daysInMonth = getDaysInMonth;

    // Week
    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
    momentPrototype__proto.weeksInYear    = getWeeksInYear;
    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;

    // Day
    momentPrototype__proto.date       = getSetDayOfMonth;
    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
    momentPrototype__proto.dayOfYear  = getSetDayOfYear;

    // Hour
    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;

    // Minute
    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;

    // Second
    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;

    // Millisecond
    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;

    // Offset
    momentPrototype__proto.utcOffset            = getSetOffset;
    momentPrototype__proto.utc                  = setOffsetToUTC;
    momentPrototype__proto.local                = setOffsetToLocal;
    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
    momentPrototype__proto.isDST                = isDaylightSavingTime;
    momentPrototype__proto.isLocal              = isLocal;
    momentPrototype__proto.isUtcOffset          = isUtcOffset;
    momentPrototype__proto.isUtc                = isUtc;
    momentPrototype__proto.isUTC                = isUtc;

    // Timezone
    momentPrototype__proto.zoneAbbr = getZoneAbbr;
    momentPrototype__proto.zoneName = getZoneName;

    // Deprecations
    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    momentPrototype__proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    var momentPrototype = momentPrototype__proto;

    function moment__createUnix (input) {
        return local__createLocal(input * 1000);
    }

    function moment__createInZone () {
        return local__createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var prototype__proto = Locale.prototype;

    prototype__proto.calendar        = locale_calendar__calendar;
    prototype__proto.longDateFormat  = longDateFormat;
    prototype__proto.invalidDate     = invalidDate;
    prototype__proto.ordinal         = ordinal;
    prototype__proto.preparse        = preParsePostFormat;
    prototype__proto.postformat      = preParsePostFormat;
    prototype__proto.relativeTime    = relative__relativeTime;
    prototype__proto.pastFuture      = pastFuture;
    prototype__proto.set             = locale_set__set;

    // Month
    prototype__proto.months            =        localeMonths;
    prototype__proto.monthsShort       =        localeMonthsShort;
    prototype__proto.monthsParse       =        localeMonthsParse;
    prototype__proto.monthsRegex       = monthsRegex;
    prototype__proto.monthsShortRegex  = monthsShortRegex;

    // Week
    prototype__proto.week = localeWeek;
    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;

    // Day of Week
    prototype__proto.weekdays       =        localeWeekdays;
    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
    prototype__proto.weekdaysParse  =        localeWeekdaysParse;

    prototype__proto.weekdaysRegex       =        weekdaysRegex;
    prototype__proto.weekdaysShortRegex  =        weekdaysShortRegex;
    prototype__proto.weekdaysMinRegex    =        weekdaysMinRegex;

    // Hours
    prototype__proto.isPM = localeIsPM;
    prototype__proto.meridiem = localeMeridiem;

    function lists__get (format, index, field, setter) {
        var locale = locale_locales__getLocale();
        var utc = create_utc__createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (typeof format === 'number') {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return lists__get(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = lists__get(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (typeof format === 'number') {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (typeof format === 'number') {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = locale_locales__getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return lists__get(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = lists__get(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function lists__listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function lists__listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function lists__listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function lists__listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function lists__listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    locale_locales__getSetGlobalLocale('en', {
        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports
    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);

    var mathAbs = Math.abs;

    function duration_abs__abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function duration_add_subtract__addSubtract (duration, input, value, direction) {
        var other = create__createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function duration_add_subtract__add (input, value) {
        return duration_add_subtract__addSubtract(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function duration_add_subtract__subtract (input, value) {
        return duration_add_subtract__addSubtract(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function duration_as__valueOf () {
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function duration_get__get (units) {
        units = normalizeUnits(units);
        return this[units + 's']();
    }

    function makeGetter(name) {
        return function () {
            return this._data[name];
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        s: 45,  // seconds to minute
        m: 45,  // minutes to hour
        h: 22,  // hours to day
        d: 26,  // days to month
        M: 11   // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
        var duration = create__createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds < thresholds.s && ['s', seconds]  ||
                minutes <= 1           && ['m']           ||
                minutes < thresholds.m && ['mm', minutes] ||
                hours   <= 1           && ['h']           ||
                hours   < thresholds.h && ['hh', hours]   ||
                days    <= 1           && ['d']           ||
                days    < thresholds.d && ['dd', days]    ||
                months  <= 1           && ['M']           ||
                months  < thresholds.M && ['MM', months]  ||
                years   <= 1           && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function duration_humanize__getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        return true;
    }

    function humanize (withSuffix) {
        var locale = this.localeData();
        var output = duration_humanize__relativeTime(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var iso_string__abs = Math.abs;

    function iso_string__toISOString() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        var seconds = iso_string__abs(this._milliseconds) / 1000;
        var days         = iso_string__abs(this._days);
        var months       = iso_string__abs(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds;
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        return (total < 0 ? '-' : '') +
            'P' +
            (Y ? Y + 'Y' : '') +
            (M ? M + 'M' : '') +
            (D ? D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? h + 'H' : '') +
            (m ? m + 'M' : '') +
            (s ? s + 'S' : '');
    }

    var duration_prototype__proto = Duration.prototype;

    duration_prototype__proto.abs            = duration_abs__abs;
    duration_prototype__proto.add            = duration_add_subtract__add;
    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
    duration_prototype__proto.as             = as;
    duration_prototype__proto.asMilliseconds = asMilliseconds;
    duration_prototype__proto.asSeconds      = asSeconds;
    duration_prototype__proto.asMinutes      = asMinutes;
    duration_prototype__proto.asHours        = asHours;
    duration_prototype__proto.asDays         = asDays;
    duration_prototype__proto.asWeeks        = asWeeks;
    duration_prototype__proto.asMonths       = asMonths;
    duration_prototype__proto.asYears        = asYears;
    duration_prototype__proto.valueOf        = duration_as__valueOf;
    duration_prototype__proto._bubble        = bubble;
    duration_prototype__proto.get            = duration_get__get;
    duration_prototype__proto.milliseconds   = milliseconds;
    duration_prototype__proto.seconds        = seconds;
    duration_prototype__proto.minutes        = minutes;
    duration_prototype__proto.hours          = hours;
    duration_prototype__proto.days           = days;
    duration_prototype__proto.weeks          = weeks;
    duration_prototype__proto.months         = months;
    duration_prototype__proto.years          = years;
    duration_prototype__proto.humanize       = humanize;
    duration_prototype__proto.toISOString    = iso_string__toISOString;
    duration_prototype__proto.toString       = iso_string__toISOString;
    duration_prototype__proto.toJSON         = iso_string__toISOString;
    duration_prototype__proto.locale         = locale;
    duration_prototype__proto.localeData     = localeData;

    // Deprecations
    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
    duration_prototype__proto.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    utils_hooks__hooks.version = '2.15.1';

    setHookCallback(local__createLocal);

    utils_hooks__hooks.fn                    = momentPrototype;
    utils_hooks__hooks.min                   = min;
    utils_hooks__hooks.max                   = max;
    utils_hooks__hooks.now                   = now;
    utils_hooks__hooks.utc                   = create_utc__createUTC;
    utils_hooks__hooks.unix                  = moment__createUnix;
    utils_hooks__hooks.months                = lists__listMonths;
    utils_hooks__hooks.isDate                = isDate;
    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
    utils_hooks__hooks.invalid               = valid__createInvalid;
    utils_hooks__hooks.duration              = create__createDuration;
    utils_hooks__hooks.isMoment              = isMoment;
    utils_hooks__hooks.weekdays              = lists__listWeekdays;
    utils_hooks__hooks.parseZone             = moment__createInZone;
    utils_hooks__hooks.localeData            = locale_locales__getLocale;
    utils_hooks__hooks.isDuration            = isDuration;
    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
    utils_hooks__hooks.defineLocale          = defineLocale;
    utils_hooks__hooks.updateLocale          = updateLocale;
    utils_hooks__hooks.locales               = locale_locales__listLocales;
    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
    utils_hooks__hooks.relativeTimeRounding = duration_humanize__getSetRelativeTimeRounding;
    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
    utils_hooks__hooks.calendarFormat        = getCalendarFormat;
    utils_hooks__hooks.prototype             = momentPrototype;

    var _moment = utils_hooks__hooks;

    return _moment;

}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(761)(module)))

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(727));
__export(__webpack_require__(726));
__export(__webpack_require__(259));
__export(__webpack_require__(158));
__export(__webpack_require__(1016));
//# sourceMappingURL=ng2-toastr.js.map

/***/ },
/* 7 */
/***/ function(module, exports) {

"use strict";
//
// ===== File globals.ts    
//
'use strict';
exports.baseApiUrl1 = 'http://localhost:4372/';
exports.baseApiUrl = 'http://northwindapi.codebhagat.com/';
exports.version = "1.0.0.0";
exports.pageSize = 10;
// declare some global variable using with datepicker
exports.languare = "en";


/***/ },
/* 8 */,
/* 9 */,
/* 10 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_forms__ = __webpack_require__(847);
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AbstractControlDirective", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AbstractFormGroupDirective", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "CheckboxControlValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ControlContainer", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NG_VALUE_ACCESSOR", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "DefaultValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NgControl", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NgControlStatusGroup", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NgControlStatus", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NgForm", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NgModel", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NgModelGroup", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "RadioControlValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "FormControlDirective", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "FormControlName", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "FormGroupDirective", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "FormArrayName", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "FormGroupName", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NgSelectOption", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "SelectControlValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "SelectMultipleControlValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "MaxLengthValidator", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "MinLengthValidator", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "PatternValidator", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "RequiredValidator", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "FormBuilder", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AbstractControl", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "FormArray", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["B"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "FormControl", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["C"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "FormGroup", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["D"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NG_ASYNC_VALIDATORS", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["E"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NG_VALIDATORS", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["F"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Validators", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["G"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "FormsModule", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["H"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ReactiveFormsModule", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["I"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the forms package.
 */

//# sourceMappingURL=index.js.map

/***/ },
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var ng2_bootstrap_1 = __webpack_require__(1012);
var datepicker_dropdown_component_1 = __webpack_require__(944);
var SharedModule = (function () {
    function SharedModule() {
    }
    SharedModule = __decorate([
        core_1.NgModule({
            imports: [
                ng2_bootstrap_1.DatepickerModule,
                common_1.CommonModule
            ],
            declarations: [
                datepicker_dropdown_component_1.DatePickerDropDownComponent,
            ],
            exports: [
                datepicker_dropdown_component_1.DatePickerDropDownComponent,
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], SharedModule);
    return SharedModule;
}());
exports.SharedModule = SharedModule;


/***/ },
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: EmployeesService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var EmployeesData = (function () {
    function EmployeesData() {
    }
    return EmployeesData;
}());
exports.EmployeesData = EmployeesData;
var EmployeesService = (function () {
    function EmployeesService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    EmployeesService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/Employees';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    EmployeesService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/Employees?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    EmployeesService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/Employees?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    EmployeesService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/Employees/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    EmployeesService.prototype.addEmployeesData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/Employees';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    EmployeesService.prototype.updateEmployeesData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/Employees';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    EmployeesService.prototype.deleteEmployees = function (id) {
        var url = this.baseUrl + "api/Employees/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    EmployeesService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    EmployeesService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    EmployeesService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    EmployeesService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], EmployeesService);
    return EmployeesService;
    var _a;
}());
exports.EmployeesService = EmployeesService;
/*
    function mapEmployees(response:Response): EmployeesData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toEmployees);
    }

    function toEmployees(r:any): EmployeesData {
        let region = <EmployeesData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NG_VALUE_ACCESSOR; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * Used to provide a {@link ControlValueAccessor} for form controls.
 *
 * See {@link DefaultValueAccessor} for how to implement one.
 * @stable
 */
var NG_VALUE_ACCESSOR = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('NgValueAccessor');
//# sourceMappingURL=control_value_accessor.js.map

/***/ },
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_toPromise__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_collection__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__facade_lang__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__private_import_core__ = __webpack_require__(339);
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return NG_VALIDATORS; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return NG_ASYNC_VALIDATORS; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return Validators; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */





function isEmptyInputValue(value) {
    return value == null || typeof value === 'string' && value.length === 0;
}
/**
 * Providers for validators to be used for {@link FormControl}s in a form.
 *
 * Provide this using `multi: true` to add validators.
 *
 * ### Example
 *
 * {@example core/forms/ts/ng_validators/ng_validators.ts region='ng_validators'}
 * @stable
 */
var NG_VALIDATORS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('NgValidators');
/**
 * Providers for asynchronous validators to be used for {@link FormControl}s
 * in a form.
 *
 * Provide this using `multi: true` to add validators.
 *
 * See {@link NG_VALIDATORS} for more details.
 *
 * @stable
 */
var NG_ASYNC_VALIDATORS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('NgAsyncValidators');
/**
 * Provides a set of validators used by form controls.
 *
 * A validator is a function that processes a {@link FormControl} or collection of
 * controls and returns a map of errors. A null map means that validation has passed.
 *
 * ### Example
 *
 * ```typescript
 * var loginControl = new FormControl("", Validators.required)
 * ```
 *
 * @stable
 */
var Validators = (function () {
    function Validators() {
    }
    /**
     * Validator that requires controls to have a non-empty value.
     */
    Validators.required = function (control) {
        return isEmptyInputValue(control.value) ? { 'required': true } : null;
    };
    /**
     * Validator that requires controls to have a value of a minimum length.
     */
    Validators.minLength = function (minLength) {
        return function (control) {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }
            var length = typeof control.value === 'string' ? control.value.length : 0;
            return length < minLength ?
                { 'minlength': { 'requiredLength': minLength, 'actualLength': length } } :
                null;
        };
    };
    /**
     * Validator that requires controls to have a value of a maximum length.
     */
    Validators.maxLength = function (maxLength) {
        return function (control) {
            var length = typeof control.value === 'string' ? control.value.length : 0;
            return length > maxLength ?
                { 'maxlength': { 'requiredLength': maxLength, 'actualLength': length } } :
                null;
        };
    };
    /**
     * Validator that requires a control to match a regex to its value.
     */
    Validators.pattern = function (pattern) {
        if (!pattern)
            return Validators.nullValidator;
        var regex;
        var regexStr;
        if (typeof pattern === 'string') {
            regexStr = "^" + pattern + "$";
            regex = new RegExp(regexStr);
        }
        else {
            regexStr = pattern.toString();
            regex = pattern;
        }
        return function (control) {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }
            var value = control.value;
            return regex.test(value) ? null :
                { 'pattern': { 'requiredPattern': regexStr, 'actualValue': value } };
        };
    };
    /**
     * No-op validator.
     */
    Validators.nullValidator = function (c) { return null; };
    /**
     * Compose multiple validators into a single function that returns the union
     * of the individual error maps.
     */
    Validators.compose = function (validators) {
        if (!validators)
            return null;
        var presentValidators = validators.filter(__WEBPACK_IMPORTED_MODULE_3__facade_lang__["c" /* isPresent */]);
        if (presentValidators.length == 0)
            return null;
        return function (control) {
            return _mergeErrors(_executeValidators(control, presentValidators));
        };
    };
    Validators.composeAsync = function (validators) {
        if (!validators)
            return null;
        var presentValidators = validators.filter(__WEBPACK_IMPORTED_MODULE_3__facade_lang__["c" /* isPresent */]);
        if (presentValidators.length == 0)
            return null;
        return function (control) {
            var promises = _executeAsyncValidators(control, presentValidators).map(_convertToPromise);
            return Promise.all(promises).then(_mergeErrors);
        };
    };
    return Validators;
}());
function _convertToPromise(obj) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__private_import_core__["a" /* isPromise */])(obj) ? obj : __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_toPromise__["toPromise"].call(obj);
}
function _executeValidators(control, validators) {
    return validators.map(function (v) { return v(control); });
}
function _executeAsyncValidators(control, validators) {
    return validators.map(function (v) { return v(control); });
}
function _mergeErrors(arrayOfErrors) {
    var res = arrayOfErrors.reduce(function (res, errors) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__facade_lang__["c" /* isPresent */])(errors) ? __WEBPACK_IMPORTED_MODULE_2__facade_collection__["a" /* StringMapWrapper */].merge(res, errors) : res;
    }, {});
    return Object.keys(res).length === 0 ? null : res;
}
//# sourceMappingURL=validators.js.map

/***/ },
/* 39 */,
/* 40 */,
/* 41 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: CategoriesService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var CategoriesData = (function () {
    function CategoriesData() {
    }
    return CategoriesData;
}());
exports.CategoriesData = CategoriesData;
var CategoriesService = (function () {
    function CategoriesService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    CategoriesService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/Categories';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CategoriesService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/Categories?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CategoriesService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/Categories?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CategoriesService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/Categories/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CategoriesService.prototype.addCategoriesData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/Categories';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    CategoriesService.prototype.updateCategoriesData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/Categories';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    CategoriesService.prototype.deleteCategories = function (id) {
        var url = this.baseUrl + "api/Categories/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    CategoriesService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    CategoriesService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    CategoriesService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    CategoriesService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], CategoriesService);
    return CategoriesService;
    var _a;
}());
exports.CategoriesService = CategoriesService;
/*
    function mapCategories(response:Response): CategoriesData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toCategories);
    }

    function toCategories(r:any): CategoriesData {
        let region = <CategoriesData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: CustomersService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var CustomersData = (function () {
    function CustomersData() {
    }
    return CustomersData;
}());
exports.CustomersData = CustomersData;
var CustomersService = (function () {
    function CustomersService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    CustomersService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/Customers';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CustomersService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/Customers?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CustomersService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/Customers?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CustomersService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/Customers/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CustomersService.prototype.addCustomersData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/Customers';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    CustomersService.prototype.updateCustomersData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/Customers';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    CustomersService.prototype.deleteCustomers = function (id) {
        var url = this.baseUrl + "api/Customers/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    CustomersService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    CustomersService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    CustomersService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    CustomersService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], CustomersService);
    return CustomersService;
    var _a;
}());
exports.CustomersService = CustomersService;
/*
    function mapCustomers(response:Response): CustomersData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toCustomers);
    }

    function toCustomers(r:any): CustomersData {
        let region = <CustomersData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: OrdersService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var OrdersData = (function () {
    function OrdersData() {
    }
    return OrdersData;
}());
exports.OrdersData = OrdersData;
var OrdersService = (function () {
    function OrdersService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    OrdersService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/Orders';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    OrdersService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/Orders?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    OrdersService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/Orders?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    OrdersService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/Orders/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    OrdersService.prototype.addOrdersData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/Orders';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    OrdersService.prototype.updateOrdersData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/Orders';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    OrdersService.prototype.deleteOrders = function (id) {
        var url = this.baseUrl + "api/Orders/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    OrdersService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    OrdersService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    OrdersService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    OrdersService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], OrdersService);
    return OrdersService;
    var _a;
}());
exports.OrdersService = OrdersService;
/*
    function mapOrders(response:Response): OrdersData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toOrders);
    }

    function toOrders(r:any): OrdersData {
        let region = <OrdersData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: ProductsService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var ProductsData = (function () {
    function ProductsData() {
    }
    return ProductsData;
}());
exports.ProductsData = ProductsData;
var ProductsService = (function () {
    function ProductsService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    ProductsService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/Products';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    ProductsService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/Products?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    ProductsService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/Products?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    ProductsService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/Products/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    ProductsService.prototype.addProductsData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/Products';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    ProductsService.prototype.updateProductsData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/Products';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    ProductsService.prototype.deleteProducts = function (id) {
        var url = this.baseUrl + "api/Products/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    ProductsService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    ProductsService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    ProductsService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    ProductsService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], ProductsService);
    return ProductsService;
    var _a;
}());
exports.ProductsService = ProductsService;
/*
    function mapProducts(response:Response): ProductsData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toProducts);
    }

    function toProducts(r:any): ProductsData {
        let region = <ProductsData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: RegionService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var RegionData = (function () {
    function RegionData() {
    }
    return RegionData;
}());
exports.RegionData = RegionData;
var RegionService = (function () {
    function RegionService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    RegionService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/Region';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    RegionService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/Region?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    RegionService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/Region?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    RegionService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/Region/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    RegionService.prototype.addRegionData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/Region';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    RegionService.prototype.updateRegionData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/Region';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    RegionService.prototype.deleteRegion = function (id) {
        var url = this.baseUrl + "api/Region/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    RegionService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    RegionService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    RegionService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    RegionService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], RegionService);
    return RegionService;
    var _a;
}());
exports.RegionService = RegionService;
/*
    function mapRegion(response:Response): RegionData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toRegion);
    }

    function toRegion(r:any): RegionData {
        let region = <RegionData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: ShippersService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var ShippersData = (function () {
    function ShippersData() {
    }
    return ShippersData;
}());
exports.ShippersData = ShippersData;
var ShippersService = (function () {
    function ShippersService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    ShippersService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/Shippers';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    ShippersService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/Shippers?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    ShippersService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/Shippers?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    ShippersService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/Shippers/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    ShippersService.prototype.addShippersData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/Shippers';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    ShippersService.prototype.updateShippersData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/Shippers';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    ShippersService.prototype.deleteShippers = function (id) {
        var url = this.baseUrl + "api/Shippers/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    ShippersService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    ShippersService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    ShippersService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    ShippersService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], ShippersService);
    return ShippersService;
    var _a;
}());
exports.ShippersService = ShippersService;
/*
    function mapShippers(response:Response): ShippersData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toShippers);
    }

    function toShippers(r:any): ShippersData {
        let region = <ShippersData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: SuppliersService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var SuppliersData = (function () {
    function SuppliersData() {
    }
    return SuppliersData;
}());
exports.SuppliersData = SuppliersData;
var SuppliersService = (function () {
    function SuppliersService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    SuppliersService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/Suppliers';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    SuppliersService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/Suppliers?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    SuppliersService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/Suppliers?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    SuppliersService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/Suppliers/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    SuppliersService.prototype.addSuppliersData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/Suppliers';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    SuppliersService.prototype.updateSuppliersData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/Suppliers';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    SuppliersService.prototype.deleteSuppliers = function (id) {
        var url = this.baseUrl + "api/Suppliers/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    SuppliersService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    SuppliersService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    SuppliersService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    SuppliersService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], SuppliersService);
    return SuppliersService;
    var _a;
}());
exports.SuppliersService = SuppliersService;
/*
    function mapSuppliers(response:Response): SuppliersData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toSuppliers);
    }

    function toSuppliers(r:any): SuppliersData {
        let region = <SuppliersData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: TerritoriesService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var TerritoriesData = (function () {
    function TerritoriesData() {
    }
    return TerritoriesData;
}());
exports.TerritoriesData = TerritoriesData;
var TerritoriesService = (function () {
    function TerritoriesService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    TerritoriesService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/Territories';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    TerritoriesService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/Territories?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    TerritoriesService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/Territories?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    TerritoriesService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/Territories/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    TerritoriesService.prototype.addTerritoriesData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/Territories';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    TerritoriesService.prototype.updateTerritoriesData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/Territories';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    TerritoriesService.prototype.deleteTerritories = function (id) {
        var url = this.baseUrl + "api/Territories/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    TerritoriesService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    TerritoriesService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    TerritoriesService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    TerritoriesService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], TerritoriesService);
    return TerritoriesService;
    var _a;
}());
exports.TerritoriesService = TerritoriesService;
/*
    function mapTerritories(response:Response): TerritoriesData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toTerritories);
    }

    function toTerritories(r:any): TerritoriesData {
        let region = <TerritoriesData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 49 */,
/* 50 */,
/* 51 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abstract_control_directive__ = __webpack_require__(207);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return ControlContainer; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

/**
 * A directive that contains multiple {@link NgControl}s.
 *
 * Only used by the forms module.
 *
 * @stable
 */
var ControlContainer = (function (_super) {
    __extends(ControlContainer, _super);
    function ControlContainer() {
        _super.apply(this, arguments);
    }
    Object.defineProperty(ControlContainer.prototype, "formDirective", {
        /**
         * Get the form to which this container belongs.
         */
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ControlContainer.prototype, "path", {
        /**
         * Get the path to this container.
         */
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    return ControlContainer;
}(__WEBPACK_IMPORTED_MODULE_0__abstract_control_directive__["a" /* AbstractControlDirective */]));
//# sourceMappingURL=control_container.js.map

/***/ },
/* 52 */,
/* 53 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(62);
/**
 * Components helper class to easily work with
 * allows to:
 * - get application root view container ref
 */
var ComponentsHelper = (function () {
    function ComponentsHelper(applicationRef, componentFactoryResolver, injector) {
        this.applicationRef = applicationRef;
        this.componentFactoryResolver = componentFactoryResolver;
        this.injector = injector;
    }
    ComponentsHelper.prototype.getDocument = function () {
        return this.injector.get(platform_browser_1.DOCUMENT);
    };
    /**
     * In some cases, like using ngUpgrate,
     * you need to explicitly set view container ref
     * to made this method working you need to add:
     * ```typescript
     *  @Component({
     *   selector: 'my-app',
     *   ...
     *   })
     *  export class MyApp {
     *    constructor(componentsHelper:ComponentsHelper, viewContainerRef: ViewContainerRef) {
     *        // A Default view container ref, usually the app root container ref.
     *        // Has to be set manually until we can find a way to get it automatically.
     *        componentsHelper.setRootViewContainerRef(viewContainerRef)
     *      }
     *  }
     * ```
     */
    ComponentsHelper.prototype.setRootViewContainerRef = function (value) {
        this.root = value;
    };
    /**
     * This is a name conventional class to get application root view component ref
     * @returns {ViewContainerRef} - application root view component ref
     */
    ComponentsHelper.prototype.getRootViewContainerRef = function () {
        // https://github.com/angular/angular/issues/9293
        if (this.root) {
            return this.root;
        }
        var comps = this.applicationRef.components;
        if (!comps.length) {
            throw new Error("ApplicationRef instance not found");
        }
        try {
            /* one more ugly hack, read issue above for details */
            var rootComponent = this.applicationRef._rootComponents[0];
            this.root = rootComponent._hostElement.vcRef;
            return this.root;
        }
        catch (e) {
            throw new Error("ApplicationRef instance not found");
        }
    };
    /**
     * Creates an instance of a Component and attaches it to the View Container found at the
     * `location` specified as {@link ViewContainerRef}.
     *
     * You can optionally provide `providers` to configure the {@link Injector} provisioned for this
     * Component Instance.
     *
     * Returns {@link ComponentRef} representing the newly created Component.
     * @param ComponentClass - @Component class
     * @param location - reference to the location
     * @param providers - optional array of providers
     * @returns {ComponentRef<T>} - returns ComponentRef<T>
     */
    ComponentsHelper.prototype.appendNextToLocation = function (ComponentClass, location, providers) {
        var componentFactory = this.componentFactoryResolver.resolveComponentFactory(ComponentClass);
        var parentInjector = location.parentInjector;
        var childInjector = parentInjector;
        if (providers && providers.length > 0) {
            childInjector = core_1.ReflectiveInjector.fromResolvedProviders(providers, parentInjector);
        }
        return location.createComponent(componentFactory, location.length, childInjector);
    };
    /**
     * Helper methods to add ComponentClass(like modal backdrop) with options
     * of type ComponentOptionsClass to element next to application root
     * or next to provided instance of view container
     * @param ComponentClass - @Component class
     * @param ComponentOptionsClass - options class
     * @param options - instance of options
     * @returns {ComponentRef<T>} - returns ComponentRef<T>
     */
    ComponentsHelper.prototype.appendNextToRoot = function (ComponentClass, ComponentOptionsClass, options) {
        var location = this.getRootViewContainerRef();
        var providers = core_1.ReflectiveInjector.resolve([
            { provide: ComponentOptionsClass, useValue: options }
        ]);
        return this.appendNextToLocation(ComponentClass, location, providers);
    };
    ComponentsHelper.decorators = [
        { type: core_1.Injectable },
    ];
    /** @nocollapse */
    ComponentsHelper.ctorParameters = [
        { type: core_1.ApplicationRef, },
        { type: core_1.ComponentFactoryResolver, },
        { type: core_1.Injector, },
    ];
    return ComponentsHelper;
}());
exports.ComponentsHelper = ComponentsHelper;


/***/ },
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_lang__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validators__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__checkbox_value_accessor__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_value_accessor__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__normalize_validator__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__number_value_accessor__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__radio_control_value_accessor__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__range_value_accessor__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__select_control_value_accessor__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__select_multiple_control_value_accessor__ = __webpack_require__(133);
/* harmony export (immutable) */ exports["a"] = controlPath;
/* harmony export (immutable) */ exports["d"] = setUpControl;
/* harmony export (immutable) */ exports["h"] = cleanUpControl;
/* harmony export (immutable) */ exports["e"] = setUpFormContainer;
/* harmony export (immutable) */ exports["b"] = composeValidators;
/* harmony export (immutable) */ exports["c"] = composeAsyncValidators;
/* harmony export (immutable) */ exports["g"] = isPropertyUpdated;
/* unused harmony export isBuiltInAccessor */
/* harmony export (immutable) */ exports["f"] = selectValueAccessor;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */










function controlPath(name, parent) {
    return parent.path.concat([name]);
}
function setUpControl(control, dir) {
    if (!control)
        _throwError(dir, 'Cannot find control with');
    if (!dir.valueAccessor)
        _throwError(dir, 'No value accessor for form control with');
    control.validator = __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].compose([control.validator, dir.validator]);
    control.asyncValidator = __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].composeAsync([control.asyncValidator, dir.asyncValidator]);
    dir.valueAccessor.writeValue(control.value);
    // view -> model
    dir.valueAccessor.registerOnChange(function (newValue) {
        dir.viewToModelUpdate(newValue);
        control.markAsDirty();
        control.setValue(newValue, { emitModelToViewChange: false });
    });
    // touched
    dir.valueAccessor.registerOnTouched(function () { return control.markAsTouched(); });
    control.registerOnChange(function (newValue, emitModelEvent) {
        // control -> view
        dir.valueAccessor.writeValue(newValue);
        // control -> ngModel
        if (emitModelEvent)
            dir.viewToModelUpdate(newValue);
    });
    if (dir.valueAccessor.setDisabledState) {
        control.registerOnDisabledChange(function (isDisabled) { dir.valueAccessor.setDisabledState(isDisabled); });
    }
    // re-run validation when validator binding changes, e.g. minlength=3 -> minlength=4
    dir._rawValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange)
            validator.registerOnValidatorChange(function () { return control.updateValueAndValidity(); });
    });
    dir._rawAsyncValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange)
            validator.registerOnValidatorChange(function () { return control.updateValueAndValidity(); });
    });
}
function cleanUpControl(control, dir) {
    dir.valueAccessor.registerOnChange(function () { return _noControlError(dir); });
    dir.valueAccessor.registerOnTouched(function () { return _noControlError(dir); });
    dir._rawValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange) {
            validator.registerOnValidatorChange(null);
        }
    });
    dir._rawAsyncValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange) {
            validator.registerOnValidatorChange(null);
        }
    });
    if (control)
        control._clearChangeFns();
}
function setUpFormContainer(control, dir) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["f" /* isBlank */])(control))
        _throwError(dir, 'Cannot find control with');
    control.validator = __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].compose([control.validator, dir.validator]);
    control.asyncValidator = __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].composeAsync([control.asyncValidator, dir.asyncValidator]);
}
function _noControlError(dir) {
    return _throwError(dir, 'There is no FormControl instance attached to form control element with');
}
function _throwError(dir, message) {
    var messageEnd;
    if (dir.path.length > 1) {
        messageEnd = "path: '" + dir.path.join(' -> ') + "'";
    }
    else if (dir.path[0]) {
        messageEnd = "name: '" + dir.path + "'";
    }
    else {
        messageEnd = 'unspecified name attribute';
    }
    throw new Error(message + " " + messageEnd);
}
function composeValidators(validators) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["c" /* isPresent */])(validators) ? __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].compose(validators.map(__WEBPACK_IMPORTED_MODULE_4__normalize_validator__["a" /* normalizeValidator */])) : null;
}
function composeAsyncValidators(validators) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["c" /* isPresent */])(validators) ? __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].composeAsync(validators.map(__WEBPACK_IMPORTED_MODULE_4__normalize_validator__["b" /* normalizeAsyncValidator */])) :
        null;
}
function isPropertyUpdated(changes, viewModel) {
    if (!changes.hasOwnProperty('model'))
        return false;
    var change = changes['model'];
    if (change.isFirstChange())
        return true;
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["e" /* looseIdentical */])(viewModel, change.currentValue);
}
var BUILTIN_ACCESSORS = [
    __WEBPACK_IMPORTED_MODULE_2__checkbox_value_accessor__["a" /* CheckboxControlValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_7__range_value_accessor__["a" /* RangeValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_5__number_value_accessor__["a" /* NumberValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_8__select_control_value_accessor__["a" /* SelectControlValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_9__select_multiple_control_value_accessor__["a" /* SelectMultipleControlValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_6__radio_control_value_accessor__["a" /* RadioControlValueAccessor */],
];
function isBuiltInAccessor(valueAccessor) {
    return BUILTIN_ACCESSORS.some(function (a) { return valueAccessor.constructor === a; });
}
// TODO: vsavkin remove it once https://github.com/angular/angular/issues/3011 is implemented
function selectValueAccessor(dir, valueAccessors) {
    if (!valueAccessors)
        return null;
    var defaultAccessor;
    var builtinAccessor;
    var customAccessor;
    valueAccessors.forEach(function (v) {
        if (v.constructor === __WEBPACK_IMPORTED_MODULE_3__default_value_accessor__["a" /* DefaultValueAccessor */]) {
            defaultAccessor = v;
        }
        else if (isBuiltInAccessor(v)) {
            if (builtinAccessor)
                _throwError(dir, 'More than one built-in value accessor matches form control with');
            builtinAccessor = v;
        }
        else {
            if (customAccessor)
                _throwError(dir, 'More than one custom value accessor matches form control with');
            customAccessor = v;
        }
    });
    if (customAccessor)
        return customAccessor;
    if (builtinAccessor)
        return builtinAccessor;
    if (defaultAccessor)
        return defaultAccessor;
    _throwError(dir, 'No valid value accessor for form control with');
    return null;
}
//# sourceMappingURL=shared.js.map

/***/ },
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abstract_control_directive__ = __webpack_require__(207);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NgControl; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

function unimplemented() {
    throw new Error('unimplemented');
}
/**
 * A base class that all control directive extend.
 * It binds a {@link FormControl} object to a DOM element.
 *
 * Used internally by Angular forms.
 *
 * @stable
 */
var NgControl = (function (_super) {
    __extends(NgControl, _super);
    function NgControl() {
        _super.apply(this, arguments);
        /** @internal */
        this._parent = null;
        this.name = null;
        this.valueAccessor = null;
        /** @internal */
        this._rawValidators = [];
        /** @internal */
        this._rawAsyncValidators = [];
    }
    Object.defineProperty(NgControl.prototype, "validator", {
        get: function () { return unimplemented(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgControl.prototype, "asyncValidator", {
        get: function () { return unimplemented(); },
        enumerable: true,
        configurable: true
    });
    return NgControl;
}(__WEBPACK_IMPORTED_MODULE_0__abstract_control_directive__["a" /* AbstractControlDirective */]));
//# sourceMappingURL=ng_control.js.map

/***/ },
/* 67 */,
/* 68 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var Observable_1 = __webpack_require__(1);
__webpack_require__(260);
__webpack_require__(732);
__webpack_require__(731);
var AuthService = (function () {
    function AuthService() {
        this.isLoggedIn = false;
    }
    AuthService.prototype.login = function () {
        var _this = this;
        return Observable_1.Observable.of(true).delay(1000).do(function (val) { return _this.isLoggedIn = true; });
    };
    AuthService.prototype.logout = function () {
        this.isLoggedIn = false;
    };
    AuthService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [])
    ], AuthService);
    return AuthService;
}());
exports.AuthService = AuthService;


/***/ },
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* unused harmony reexport Observable */
/* unused harmony reexport Subject */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return EventEmitter; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};



/**
 * Use by directives and components to emit custom Events.
 *
 * ### Examples
 *
 * In the following example, `Zippy` alternatively emits `open` and `close` events when its
 * title gets clicked:
 *
 * ```
 * @Component({
 *   selector: 'zippy',
 *   template: `
 *   <div class="zippy">
 *     <div (click)="toggle()">Toggle</div>
 *     <div [hidden]="!visible">
 *       <ng-content></ng-content>
 *     </div>
 *  </div>`})
 * export class Zippy {
 *   visible: boolean = true;
 *   @Output() open: EventEmitter<any> = new EventEmitter();
 *   @Output() close: EventEmitter<any> = new EventEmitter();
 *
 *   toggle() {
 *     this.visible = !this.visible;
 *     if (this.visible) {
 *       this.open.emit(null);
 *     } else {
 *       this.close.emit(null);
 *     }
 *   }
 * }
 * ```
 *
 * The events payload can be accessed by the parameter `$event` on the components output event
 * handler:
 *
 * ```
 * <zippy (open)="onOpen($event)" (close)="onClose($event)"></zippy>
 * ```
 *
 * Uses Rx.Observable but provides an adapter to make it work as specified here:
 * https://github.com/jhusain/observable-spec
 *
 * Once a reference implementation of the spec is available, switch to it.
 * @stable
 */
var EventEmitter = (function (_super) {
    __extends(EventEmitter, _super);
    /**
     * Creates an instance of [EventEmitter], which depending on [isAsync],
     * delivers events synchronously or asynchronously.
     */
    function EventEmitter(isAsync) {
        if (isAsync === void 0) { isAsync = false; }
        _super.call(this);
        this.__isAsync = isAsync;
    }
    EventEmitter.prototype.emit = function (value) { _super.prototype.next.call(this, value); };
    EventEmitter.prototype.subscribe = function (generatorOrNext, error, complete) {
        var schedulerFn;
        var errorFn = function (err) { return null; };
        var completeFn = function () { return null; };
        if (generatorOrNext && typeof generatorOrNext === 'object') {
            schedulerFn = this.__isAsync ? function (value) {
                setTimeout(function () { return generatorOrNext.next(value); });
            } : function (value) { generatorOrNext.next(value); };
            if (generatorOrNext.error) {
                errorFn = this.__isAsync ? function (err) { setTimeout(function () { return generatorOrNext.error(err); }); } :
                    function (err) { generatorOrNext.error(err); };
            }
            if (generatorOrNext.complete) {
                completeFn = this.__isAsync ? function () { setTimeout(function () { return generatorOrNext.complete(); }); } :
                    function () { generatorOrNext.complete(); };
            }
        }
        else {
            schedulerFn = this.__isAsync ? function (value) { setTimeout(function () { return generatorOrNext(value); }); } :
                function (value) { generatorOrNext(value); };
            if (error) {
                errorFn =
                    this.__isAsync ? function (err) { setTimeout(function () { return error(err); }); } : function (err) { error(err); };
            }
            if (complete) {
                completeFn =
                    this.__isAsync ? function () { setTimeout(function () { return complete(); }); } : function () { complete(); };
            }
        }
        return _super.prototype.subscribe.call(this, schedulerFn, errorFn, completeFn);
    };
    return EventEmitter;
}(__WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__["Subject"]));
//# sourceMappingURL=async.js.map

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export scheduleMicroTask */
/* unused harmony export global */
/* unused harmony export getTypeNameForDebugging */
/* harmony export (immutable) */ exports["c"] = isPresent;
/* harmony export (immutable) */ exports["f"] = isBlank;
/* unused harmony export isStrictStringMap */
/* unused harmony export isDate */
/* unused harmony export stringify */
/* unused harmony export NumberWrapper */
/* harmony export (immutable) */ exports["e"] = looseIdentical;
/* harmony export (immutable) */ exports["a"] = isJsObject;
/* unused harmony export print */
/* unused harmony export warn */
/* unused harmony export setValueOnPath */
/* harmony export (immutable) */ exports["b"] = getSymbolIterator;
/* harmony export (immutable) */ exports["d"] = isPrimitive;
/* unused harmony export escapeRegExp */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var globalScope;
if (typeof window === 'undefined') {
    if (typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope) {
        // TODO: Replace any with WorkerGlobalScope from lib.webworker.d.ts #3492
        globalScope = self;
    }
    else {
        globalScope = global;
    }
}
else {
    globalScope = window;
}
function scheduleMicroTask(fn) {
    Zone.current.scheduleMicroTask('scheduleMicrotask', fn);
}
// Need to declare a new variable for global here since TypeScript
// exports the original value of the symbol.
var _global = globalScope;

function getTypeNameForDebugging(type) {
    return type['name'] || typeof type;
}
// TODO: remove calls to assert in production environment
// Note: Can't just export this and import in in other files
// as `assert` is a reserved keyword in Dart
_global.assert = function assert(condition) {
    // TODO: to be fixed properly via #2830, noop for now
};
function isPresent(obj) {
    return obj != null;
}
function isBlank(obj) {
    return obj == null;
}
var STRING_MAP_PROTO = Object.getPrototypeOf({});
function isStrictStringMap(obj) {
    return typeof obj === 'object' && obj !== null && Object.getPrototypeOf(obj) === STRING_MAP_PROTO;
}
function isDate(obj) {
    return obj instanceof Date && !isNaN(obj.valueOf());
}
function stringify(token) {
    if (typeof token === 'string') {
        return token;
    }
    if (token == null) {
        return '' + token;
    }
    if (token.overriddenName) {
        return token.overriddenName;
    }
    if (token.name) {
        return token.name;
    }
    var res = token.toString();
    var newLineIndex = res.indexOf('\n');
    return newLineIndex === -1 ? res : res.substring(0, newLineIndex);
}
var NumberWrapper = (function () {
    function NumberWrapper() {
    }
    NumberWrapper.parseIntAutoRadix = function (text) {
        var result = parseInt(text);
        if (isNaN(result)) {
            throw new Error('Invalid integer literal when parsing ' + text);
        }
        return result;
    };
    NumberWrapper.isNumeric = function (value) { return !isNaN(value - parseFloat(value)); };
    return NumberWrapper;
}());
// JS has NaN !== NaN
function looseIdentical(a, b) {
    return a === b || typeof a === 'number' && typeof b === 'number' && isNaN(a) && isNaN(b);
}
function isJsObject(o) {
    return o !== null && (typeof o === 'function' || typeof o === 'object');
}
function print(obj) {
    console.log(obj);
}
function warn(obj) {
    console.warn(obj);
}
function setValueOnPath(global, path, value) {
    var parts = path.split('.');
    var obj = global;
    while (parts.length > 1) {
        var name_1 = parts.shift();
        if (obj.hasOwnProperty(name_1) && obj[name_1] != null) {
            obj = obj[name_1];
        }
        else {
            obj = obj[name_1] = {};
        }
    }
    if (obj === undefined || obj === null) {
        obj = {};
    }
    obj[parts.shift()] = value;
}
var _symbolIterator = null;
function getSymbolIterator() {
    if (!_symbolIterator) {
        if (globalScope.Symbol && Symbol.iterator) {
            _symbolIterator = Symbol.iterator;
        }
        else {
            // es6-shim specific logic
            var keys = Object.getOwnPropertyNames(Map.prototype);
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (key !== 'entries' && key !== 'size' &&
                    Map.prototype[key] === Map.prototype['entries']) {
                    _symbolIterator = key;
                }
            }
        }
    }
    return _symbolIterator;
}
function isPrimitive(obj) {
    return !isJsObject(obj);
}
function escapeRegExp(s) {
    return s.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
}
//# sourceMappingURL=lang.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23)))

/***/ },
/* 77 */,
/* 78 */,
/* 79 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: CustomerCustomerDemoService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var CustomerCustomerDemoData = (function () {
    function CustomerCustomerDemoData() {
    }
    return CustomerCustomerDemoData;
}());
exports.CustomerCustomerDemoData = CustomerCustomerDemoData;
var CustomerCustomerDemoService = (function () {
    function CustomerCustomerDemoService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    CustomerCustomerDemoService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/CustomerCustomerDemo';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CustomerCustomerDemoService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/CustomerCustomerDemo?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CustomerCustomerDemoService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/CustomerCustomerDemo?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CustomerCustomerDemoService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/CustomerCustomerDemo/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CustomerCustomerDemoService.prototype.addCustomerCustomerDemoData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/CustomerCustomerDemo';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    CustomerCustomerDemoService.prototype.updateCustomerCustomerDemoData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/CustomerCustomerDemo';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    CustomerCustomerDemoService.prototype.deleteCustomerCustomerDemo = function (id) {
        var url = this.baseUrl + "api/CustomerCustomerDemo/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    CustomerCustomerDemoService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    CustomerCustomerDemoService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    CustomerCustomerDemoService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    CustomerCustomerDemoService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], CustomerCustomerDemoService);
    return CustomerCustomerDemoService;
    var _a;
}());
exports.CustomerCustomerDemoService = CustomerCustomerDemoService;
/*
    function mapCustomerCustomerDemo(response:Response): CustomerCustomerDemoData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toCustomerCustomerDemo);
    }

    function toCustomerCustomerDemo(r:any): CustomerCustomerDemoData {
        let region = <CustomerCustomerDemoData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: CustomerDemographicsService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var CustomerDemographicsData = (function () {
    function CustomerDemographicsData() {
    }
    return CustomerDemographicsData;
}());
exports.CustomerDemographicsData = CustomerDemographicsData;
var CustomerDemographicsService = (function () {
    function CustomerDemographicsService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    CustomerDemographicsService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/CustomerDemographics';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CustomerDemographicsService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/CustomerDemographics?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CustomerDemographicsService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/CustomerDemographics?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CustomerDemographicsService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/CustomerDemographics/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CustomerDemographicsService.prototype.addCustomerDemographicsData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/CustomerDemographics';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    CustomerDemographicsService.prototype.updateCustomerDemographicsData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/CustomerDemographics';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    CustomerDemographicsService.prototype.deleteCustomerDemographics = function (id) {
        var url = this.baseUrl + "api/CustomerDemographics/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    CustomerDemographicsService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    CustomerDemographicsService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    CustomerDemographicsService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    CustomerDemographicsService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], CustomerDemographicsService);
    return CustomerDemographicsService;
    var _a;
}());
exports.CustomerDemographicsService = CustomerDemographicsService;
/*
    function mapCustomerDemographics(response:Response): CustomerDemographicsData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toCustomerDemographics);
    }

    function toCustomerDemographics(r:any): CustomerDemographicsData {
        let region = <CustomerDemographicsData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: EmployeeTerritoriesService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var EmployeeTerritoriesData = (function () {
    function EmployeeTerritoriesData() {
    }
    return EmployeeTerritoriesData;
}());
exports.EmployeeTerritoriesData = EmployeeTerritoriesData;
var EmployeeTerritoriesService = (function () {
    function EmployeeTerritoriesService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    EmployeeTerritoriesService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/EmployeeTerritories';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    EmployeeTerritoriesService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/EmployeeTerritories?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    EmployeeTerritoriesService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/EmployeeTerritories?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    EmployeeTerritoriesService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/EmployeeTerritories/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    EmployeeTerritoriesService.prototype.addEmployeeTerritoriesData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/EmployeeTerritories';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    EmployeeTerritoriesService.prototype.updateEmployeeTerritoriesData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/EmployeeTerritories';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    EmployeeTerritoriesService.prototype.deleteEmployeeTerritories = function (id) {
        var url = this.baseUrl + "api/EmployeeTerritories/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    EmployeeTerritoriesService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    EmployeeTerritoriesService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    EmployeeTerritoriesService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    EmployeeTerritoriesService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], EmployeeTerritoriesService);
    return EmployeeTerritoriesService;
    var _a;
}());
exports.EmployeeTerritoriesService = EmployeeTerritoriesService;
/*
    function mapEmployeeTerritories(response:Response): EmployeeTerritoriesData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toEmployeeTerritories);
    }

    function toEmployeeTerritories(r:any): EmployeeTerritoriesData {
        let region = <EmployeeTerritoriesData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: OrderDetailsService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var OrderDetailsData = (function () {
    function OrderDetailsData() {
    }
    return OrderDetailsData;
}());
exports.OrderDetailsData = OrderDetailsData;
var OrderDetailsService = (function () {
    function OrderDetailsService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    OrderDetailsService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/OrderDetails';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    OrderDetailsService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/OrderDetails?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    OrderDetailsService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/OrderDetails?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    OrderDetailsService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/OrderDetails/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    OrderDetailsService.prototype.addOrderDetailsData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/OrderDetails';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    OrderDetailsService.prototype.updateOrderDetailsData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/OrderDetails';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    OrderDetailsService.prototype.deleteOrderDetails = function (id) {
        var url = this.baseUrl + "api/OrderDetails/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    OrderDetailsService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    OrderDetailsService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    OrderDetailsService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    OrderDetailsService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], OrderDetailsService);
    return OrderDetailsService;
    var _a;
}());
exports.OrderDetailsService = OrderDetailsService;
/*
    function mapOrderDetails(response:Response): OrderDetailsData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toOrderDetails);
    }

    function toOrderDetails(r:any): OrderDetailsData {
        let region = <OrderDetailsData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var browser_1 = __webpack_require__(258);
(function (Ng2BootstrapTheme) {
    Ng2BootstrapTheme[Ng2BootstrapTheme["BS3"] = 1] = "BS3";
    Ng2BootstrapTheme[Ng2BootstrapTheme["BS4"] = 2] = "BS4";
})(exports.Ng2BootstrapTheme || (exports.Ng2BootstrapTheme = {}));
var Ng2BootstrapTheme = exports.Ng2BootstrapTheme;
var Ng2BootstrapConfig = (function () {
    function Ng2BootstrapConfig() {
    }
    Object.defineProperty(Ng2BootstrapConfig, "theme", {
        get: function () {
            // hack as for now
            if (browser_1.window.__theme === 'bs4') {
                return Ng2BootstrapTheme.BS4;
            }
            return (this._theme || Ng2BootstrapTheme.BS3);
        },
        set: function (v) {
            this._theme = v;
        },
        enumerable: true,
        configurable: true
    });
    return Ng2BootstrapConfig;
}());
exports.Ng2BootstrapConfig = Ng2BootstrapConfig;


/***/ },
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__control_container__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared__ = __webpack_require__(58);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return AbstractFormGroupDirective; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};


/**
 * This is a base class for code shared between {@link NgModelGroup} and {@link FormGroupName}.
 *
 * @stable
 */
var AbstractFormGroupDirective = (function (_super) {
    __extends(AbstractFormGroupDirective, _super);
    function AbstractFormGroupDirective() {
        _super.apply(this, arguments);
    }
    AbstractFormGroupDirective.prototype.ngOnInit = function () {
        this._checkParentType();
        this.formDirective.addFormGroup(this);
    };
    AbstractFormGroupDirective.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeFormGroup(this);
        }
    };
    Object.defineProperty(AbstractFormGroupDirective.prototype, "control", {
        /**
         * Get the {@link FormGroup} backing this binding.
         */
        get: function () { return this.formDirective.getFormGroup(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "path", {
        /**
         * Get the path to this control group.
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared__["a" /* controlPath */])(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "formDirective", {
        /**
         * Get the {@link Form} to which this group belongs.
         */
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "validator", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared__["b" /* composeValidators */])(this._validators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "asyncValidator", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared__["c" /* composeAsyncValidators */])(this._asyncValidators); },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    AbstractFormGroupDirective.prototype._checkParentType = function () { };
    return AbstractFormGroupDirective;
}(__WEBPACK_IMPORTED_MODULE_0__control_container__["a" /* ControlContainer */]));
//# sourceMappingURL=abstract_form_group_directive.js.map

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_async__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validators__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__control_container__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared__ = __webpack_require__(58);
/* unused harmony export formDirectiveProvider */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NgForm; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};






var formDirectiveProvider = {
    provide: __WEBPACK_IMPORTED_MODULE_4__control_container__["a" /* ControlContainer */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgForm; })
};
var resolvedPromise = Promise.resolve(null);
/**
 * @whatItDoes Creates a top-level {@link FormGroup} instance and binds it to a form
 * to track aggregate form value and validation status.
 *
 * @howToUse
 *
 * As soon as you import the `FormsModule`, this directive becomes active by default on
 * all `<form>` tags.  You don't need to add a special selector.
 *
 * You can export the directive into a local template variable using `ngForm` as the key
 * (ex: `#myForm="ngForm"`). This is optional, but useful.  Many properties from the underlying
 * {@link FormGroup} instance are duplicated on the directive itself, so a reference to it
 * will give you access to the aggregate value and validity status of the form, as well as
 * user interaction properties like `dirty` and `touched`.
 *
 * To register child controls with the form, you'll want to use {@link NgModel} with a
 * `name` attribute.  You can also use {@link NgModelGroup} if you'd like to create
 * sub-groups within the form.
 *
 * You can listen to the directive's `ngSubmit` event to be notified when the user has
 * triggered a form submission. The `ngSubmit` event will be emitted with the original form
 * submission event.
 *
 * {@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
 *
 * * **npm package**: `@angular/forms`
 *
 * * **NgModule**: `FormsModule`
 *
 *  @stable
 */
var NgForm = (function (_super) {
    __extends(NgForm, _super);
    function NgForm(validators, asyncValidators) {
        _super.call(this);
        this._submitted = false;
        this.ngSubmit = new __WEBPACK_IMPORTED_MODULE_1__facade_async__["a" /* EventEmitter */]();
        this.form =
            new __WEBPACK_IMPORTED_MODULE_2__model__["a" /* FormGroup */]({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["b" /* composeValidators */])(validators), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["c" /* composeAsyncValidators */])(asyncValidators));
    }
    Object.defineProperty(NgForm.prototype, "submitted", {
        get: function () { return this._submitted; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "formDirective", {
        get: function () { return this; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "control", {
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "path", {
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "controls", {
        get: function () { return this.form.controls; },
        enumerable: true,
        configurable: true
    });
    NgForm.prototype.addControl = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var container = _this._findContainer(dir.path);
            dir._control = container.registerControl(dir.name, dir.control);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["d" /* setUpControl */])(dir.control, dir);
            dir.control.updateValueAndValidity({ emitEvent: false });
        });
    };
    NgForm.prototype.getControl = function (dir) { return this.form.get(dir.path); };
    NgForm.prototype.removeControl = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var container = _this._findContainer(dir.path);
            if (container) {
                container.removeControl(dir.name);
            }
        });
    };
    NgForm.prototype.addFormGroup = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var container = _this._findContainer(dir.path);
            var group = new __WEBPACK_IMPORTED_MODULE_2__model__["a" /* FormGroup */]({});
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["e" /* setUpFormContainer */])(group, dir);
            container.registerControl(dir.name, group);
            group.updateValueAndValidity({ emitEvent: false });
        });
    };
    NgForm.prototype.removeFormGroup = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var container = _this._findContainer(dir.path);
            if (container) {
                container.removeControl(dir.name);
            }
        });
    };
    NgForm.prototype.getFormGroup = function (dir) { return this.form.get(dir.path); };
    NgForm.prototype.updateModel = function (dir, value) {
        var _this = this;
        resolvedPromise.then(function () {
            var ctrl = _this.form.get(dir.path);
            ctrl.setValue(value);
        });
    };
    NgForm.prototype.setValue = function (value) { this.control.setValue(value); };
    NgForm.prototype.onSubmit = function ($event) {
        this._submitted = true;
        this.ngSubmit.emit($event);
        return false;
    };
    NgForm.prototype.onReset = function () { this.resetForm(); };
    NgForm.prototype.resetForm = function (value) {
        if (value === void 0) { value = undefined; }
        this.form.reset(value);
        this._submitted = false;
    };
    /** @internal */
    NgForm.prototype._findContainer = function (path) {
        path.pop();
        return path.length ? this.form.get(path) : this.form;
    };
    NgForm.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'form:not([ngNoForm]):not([formGroup]),ngForm,[ngForm]',
                    providers: [formDirectiveProvider],
                    host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
                    outputs: ['ngSubmit'],
                    exportAs: 'ngForm'
                },] },
    ];
    /** @nocollapse */
    NgForm.ctorParameters = [
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
    ];
    return NgForm;
}(__WEBPACK_IMPORTED_MODULE_4__control_container__["a" /* ControlContainer */]));
//# sourceMappingURL=ng_form.js.map

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ng_control__ = __webpack_require__(66);
/* unused harmony export RADIO_VALUE_ACCESSOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return RadioControlRegistry; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return RadioControlValueAccessor; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



var RADIO_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return RadioControlValueAccessor; }),
    multi: true
};
/**
 * Internal class used by Angular to uncheck radio buttons with the matching name.
 */
var RadioControlRegistry = (function () {
    function RadioControlRegistry() {
        this._accessors = [];
    }
    RadioControlRegistry.prototype.add = function (control, accessor) {
        this._accessors.push([control, accessor]);
    };
    RadioControlRegistry.prototype.remove = function (accessor) {
        for (var i = this._accessors.length - 1; i >= 0; --i) {
            if (this._accessors[i][1] === accessor) {
                this._accessors.splice(i, 1);
                return;
            }
        }
    };
    RadioControlRegistry.prototype.select = function (accessor) {
        var _this = this;
        this._accessors.forEach(function (c) {
            if (_this._isSameGroup(c, accessor) && c[1] !== accessor) {
                c[1].fireUncheck(accessor.value);
            }
        });
    };
    RadioControlRegistry.prototype._isSameGroup = function (controlPair, accessor) {
        if (!controlPair[0].control)
            return false;
        return controlPair[0]._parent === accessor._control._parent &&
            controlPair[1].name === accessor.name;
    };
    RadioControlRegistry.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    RadioControlRegistry.ctorParameters = [];
    return RadioControlRegistry;
}());
/**
 * @whatItDoes  Writes radio control values and listens to radio control changes.
 *
 * Used by {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName}
 * to keep the view synced with the {@link FormControl} model.
 *
 * @howToUse
 *
 * If you have imported the {@link FormsModule} or the {@link ReactiveFormsModule}, this
 * value accessor will be active on any radio control that has a form directive. You do
 * **not** need to add a special selector to activate it.
 *
 * ### How to use radio buttons with form directives
 *
 * To use radio buttons in a template-driven form, you'll want to ensure that radio buttons
 * in the same group have the same `name` attribute.  Radio buttons with different `name`
 * attributes do not affect each other.
 *
 * {@example forms/ts/radioButtons/radio_button_example.ts region='TemplateDriven'}
 *
 * When using radio buttons in a reactive form, radio buttons in the same group should have the
 * same `formControlName`. You can also add a `name` attribute, but it's optional.
 *
 * {@example forms/ts/reactiveRadioButtons/reactive_radio_button_example.ts region='Reactive'}
 *
 *  * **npm package**: `@angular/forms`
 *
 *  @stable
 */
var RadioControlValueAccessor = (function () {
    function RadioControlValueAccessor(_renderer, _elementRef, _registry, _injector) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._registry = _registry;
        this._injector = _injector;
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    RadioControlValueAccessor.prototype.ngOnInit = function () {
        this._control = this._injector.get(__WEBPACK_IMPORTED_MODULE_2__ng_control__["a" /* NgControl */]);
        this._checkName();
        this._registry.add(this._control, this);
    };
    RadioControlValueAccessor.prototype.ngOnDestroy = function () { this._registry.remove(this); };
    RadioControlValueAccessor.prototype.writeValue = function (value) {
        this._state = value === this.value;
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', this._state);
    };
    RadioControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this._fn = fn;
        this.onChange = function () {
            fn(_this.value);
            _this._registry.select(_this);
        };
    };
    RadioControlValueAccessor.prototype.fireUncheck = function (value) { this.writeValue(value); };
    RadioControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    RadioControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    RadioControlValueAccessor.prototype._checkName = function () {
        if (this.name && this.formControlName && this.name !== this.formControlName) {
            this._throwNameError();
        }
        if (!this.name && this.formControlName)
            this.name = this.formControlName;
    };
    RadioControlValueAccessor.prototype._throwNameError = function () {
        throw new Error("\n      If you define both a name and a formControlName attribute on your radio button, their values\n      must match. Ex: <input type=\"radio\" formControlName=\"food\" name=\"food\">\n    ");
    };
    RadioControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]',
                    host: { '(change)': 'onChange()', '(blur)': 'onTouched()' },
                    providers: [RADIO_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    RadioControlValueAccessor.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: RadioControlRegistry, },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], },
    ];
    RadioControlValueAccessor.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'formControlName': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return RadioControlValueAccessor;
}());
//# sourceMappingURL=radio_control_value_accessor.js.map

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_async__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_collection__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validators__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__control_container__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reactive_errors__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared__ = __webpack_require__(58);
/* unused harmony export formDirectiveProvider */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormGroupDirective; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};







var formDirectiveProvider = {
    provide: __WEBPACK_IMPORTED_MODULE_4__control_container__["a" /* ControlContainer */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormGroupDirective; })
};
/**
 * @whatItDoes Binds an existing {@link FormGroup} to a DOM element.
 *
 * @howToUse
 *
 * This directive accepts an existing {@link FormGroup} instance. It will then use this
 * {@link FormGroup} instance to match any child {@link FormControl}, {@link FormGroup},
 * and {@link FormArray} instances to child {@link FormControlName}, {@link FormGroupName},
 * and {@link FormArrayName} directives.
 *
 * **Set value**: You can set the form's initial value when instantiating the
 * {@link FormGroup}, or you can set it programmatically later using the {@link FormGroup}'s
 * {@link AbstractControl.setValue} or {@link AbstractControl.patchValue} methods.
 *
 * **Listen to value**: If you want to listen to changes in the value of the form, you can subscribe
 * to the {@link FormGroup}'s {@link AbstractControl.valueChanges} event.  You can also listen to
 * its {@link AbstractControl.statusChanges} event to be notified when the validation status is
 * re-calculated.
 *
 * Furthermore, you can listen to the directive's `ngSubmit` event to be notified when the user has
 * triggered a form submission. The `ngSubmit` event will be emitted with the original form
 * submission event.
 *
 * ### Example
 *
 * In this example, we create form controls for first name and last name.
 *
 * {@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
 *
 * **npm package**: `@angular/forms`
 *
 * **NgModule**: {@link ReactiveFormsModule}
 *
 *  @stable
 */
var FormGroupDirective = (function (_super) {
    __extends(FormGroupDirective, _super);
    function FormGroupDirective(_validators, _asyncValidators) {
        _super.call(this);
        this._validators = _validators;
        this._asyncValidators = _asyncValidators;
        this._submitted = false;
        this.directives = [];
        this.form = null;
        this.ngSubmit = new __WEBPACK_IMPORTED_MODULE_1__facade_async__["a" /* EventEmitter */]();
    }
    FormGroupDirective.prototype.ngOnChanges = function (changes) {
        this._checkFormPresent();
        if (changes.hasOwnProperty('form')) {
            this._updateValidators();
            this._updateDomValue();
            this._updateRegistrations();
        }
    };
    Object.defineProperty(FormGroupDirective.prototype, "submitted", {
        get: function () { return this._submitted; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "formDirective", {
        get: function () { return this; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "control", {
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "path", {
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    FormGroupDirective.prototype.addControl = function (dir) {
        var ctrl = this.form.get(dir.path);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["d" /* setUpControl */])(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
        this.directives.push(dir);
        return ctrl;
    };
    FormGroupDirective.prototype.getControl = function (dir) { return this.form.get(dir.path); };
    FormGroupDirective.prototype.removeControl = function (dir) { __WEBPACK_IMPORTED_MODULE_2__facade_collection__["b" /* ListWrapper */].remove(this.directives, dir); };
    FormGroupDirective.prototype.addFormGroup = function (dir) {
        var ctrl = this.form.get(dir.path);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["e" /* setUpFormContainer */])(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
    };
    FormGroupDirective.prototype.removeFormGroup = function (dir) { };
    FormGroupDirective.prototype.getFormGroup = function (dir) { return this.form.get(dir.path); };
    FormGroupDirective.prototype.addFormArray = function (dir) {
        var ctrl = this.form.get(dir.path);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["e" /* setUpFormContainer */])(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
    };
    FormGroupDirective.prototype.removeFormArray = function (dir) { };
    FormGroupDirective.prototype.getFormArray = function (dir) { return this.form.get(dir.path); };
    FormGroupDirective.prototype.updateModel = function (dir, value) {
        var ctrl = this.form.get(dir.path);
        ctrl.setValue(value);
    };
    FormGroupDirective.prototype.onSubmit = function ($event) {
        this._submitted = true;
        this.ngSubmit.emit($event);
        return false;
    };
    FormGroupDirective.prototype.onReset = function () { this.resetForm(); };
    FormGroupDirective.prototype.resetForm = function (value) {
        if (value === void 0) { value = undefined; }
        this.form.reset(value);
        this._submitted = false;
    };
    /** @internal */
    FormGroupDirective.prototype._updateDomValue = function () {
        var _this = this;
        this.directives.forEach(function (dir) {
            var newCtrl = _this.form.get(dir.path);
            if (dir._control !== newCtrl) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["h" /* cleanUpControl */])(dir._control, dir);
                if (newCtrl)
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["d" /* setUpControl */])(newCtrl, dir);
                dir._control = newCtrl;
            }
        });
        this.form._updateTreeValidity({ emitEvent: false });
    };
    FormGroupDirective.prototype._updateRegistrations = function () {
        var _this = this;
        this.form._registerOnCollectionChange(function () { return _this._updateDomValue(); });
        if (this._oldForm)
            this._oldForm._registerOnCollectionChange(function () { });
        this._oldForm = this.form;
    };
    FormGroupDirective.prototype._updateValidators = function () {
        var sync = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["b" /* composeValidators */])(this._validators);
        this.form.validator = __WEBPACK_IMPORTED_MODULE_3__validators__["a" /* Validators */].compose([this.form.validator, sync]);
        var async = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["c" /* composeAsyncValidators */])(this._asyncValidators);
        this.form.asyncValidator = __WEBPACK_IMPORTED_MODULE_3__validators__["a" /* Validators */].composeAsync([this.form.asyncValidator, async]);
    };
    FormGroupDirective.prototype._checkFormPresent = function () {
        if (!this.form) {
            __WEBPACK_IMPORTED_MODULE_5__reactive_errors__["a" /* ReactiveErrors */].missingFormException();
        }
    };
    FormGroupDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[formGroup]',
                    providers: [formDirectiveProvider],
                    host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
                    exportAs: 'ngForm'
                },] },
    ];
    /** @nocollapse */
    FormGroupDirective.ctorParameters = [
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
    ];
    FormGroupDirective.propDecorators = {
        'form': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formGroup',] },],
        'ngSubmit': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return FormGroupDirective;
}(__WEBPACK_IMPORTED_MODULE_4__control_container__["a" /* ControlContainer */]));
//# sourceMappingURL=form_group_directive.js.map

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validators__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__abstract_form_group_directive__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__control_container__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reactive_errors__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_group_directive__ = __webpack_require__(96);
/* unused harmony export formGroupNameProvider */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormGroupName; });
/* unused harmony export formArrayNameProvider */
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return FormArrayName; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};







var formGroupNameProvider = {
    provide: __WEBPACK_IMPORTED_MODULE_3__control_container__["a" /* ControlContainer */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormGroupName; })
};
/**
 * @whatItDoes Syncs a nested {@link FormGroup} to a DOM element.
 *
 * @howToUse
 *
 * This directive can only be used with a parent {@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the nested {@link FormGroup} you want to link, and
 * will look for a {@link FormGroup} registered with that name in the parent
 * {@link FormGroup} instance you passed into {@link FormGroupDirective}.
 *
 * Nested form groups can come in handy when you want to validate a sub-group of a
 * form separately from the rest or when you'd like to group the values of certain
 * controls into their own nested object.
 *
 * **Access the group**: You can access the associated {@link FormGroup} using the
 * {@link AbstractControl.get} method. Ex: `this.form.get('name')`.
 *
 * You can also access individual controls within the group using dot syntax.
 * Ex: `this.form.get('name.first')`
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {@link FormGroup}. See a full list of available properties in {@link AbstractControl}.
 *
 * **Set the value**: You can set an initial value for each child control when instantiating
 * the {@link FormGroup}, or you can set it programmatically later using
 * {@link AbstractControl.setValue} or {@link AbstractControl.patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the group, you can
 * subscribe to the {@link AbstractControl.valueChanges} event.  You can also listen to
 * {@link AbstractControl.statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * {@example forms/ts/nestedFormGroup/nested_form_group_example.ts region='Component'}
 *
 * * **npm package**: `@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 * @stable
 */
var FormGroupName = (function (_super) {
    __extends(FormGroupName, _super);
    function FormGroupName(parent, validators, asyncValidators) {
        _super.call(this);
        this._parent = parent;
        this._validators = validators;
        this._asyncValidators = asyncValidators;
    }
    /** @internal */
    FormGroupName.prototype._checkParentType = function () {
        if (_hasInvalidParent(this._parent)) {
            __WEBPACK_IMPORTED_MODULE_4__reactive_errors__["a" /* ReactiveErrors */].groupParentException();
        }
    };
    FormGroupName.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formGroupName]', providers: [formGroupNameProvider] },] },
    ];
    /** @nocollapse */
    FormGroupName.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_3__control_container__["a" /* ControlContainer */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
    ];
    FormGroupName.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formGroupName',] },],
    };
    return FormGroupName;
}(__WEBPACK_IMPORTED_MODULE_2__abstract_form_group_directive__["a" /* AbstractFormGroupDirective */]));
var formArrayNameProvider = {
    provide: __WEBPACK_IMPORTED_MODULE_3__control_container__["a" /* ControlContainer */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormArrayName; })
};
/**
 * @whatItDoes Syncs a nested {@link FormArray} to a DOM element.
 *
 * @howToUse
 *
 * This directive is designed to be used with a parent {@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the nested {@link FormArray} you want to link, and
 * will look for a {@link FormArray} registered with that name in the parent
 * {@link FormGroup} instance you passed into {@link FormGroupDirective}.
 *
 * Nested form arrays can come in handy when you have a group of form controls but
 * you're not sure how many there will be. Form arrays allow you to create new
 * form controls dynamically.
 *
 * **Access the array**: You can access the associated {@link FormArray} using the
 * {@link AbstractControl.get} method on the parent {@link FormGroup}.
 * Ex: `this.form.get('cities')`.
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {@link FormArray}. See a full list of available properties in {@link AbstractControl}.
 *
 * **Set the value**: You can set an initial value for each child control when instantiating
 * the {@link FormArray}, or you can set the value programmatically later using the
 * {@link FormArray}'s {@link AbstractControl.setValue} or {@link AbstractControl.patchValue}
 * methods.
 *
 * **Listen to value**: If you want to listen to changes in the value of the array, you can
 * subscribe to the {@link FormArray}'s {@link AbstractControl.valueChanges} event.  You can also
 * listen to its {@link AbstractControl.statusChanges} event to be notified when the validation
 * status is re-calculated.
 *
 * **Add new controls**: You can add new controls to the {@link FormArray} dynamically by
 * calling its {@link FormArray.push} method.
 *  Ex: `this.form.get('cities').push(new FormControl());`
 *
 * ### Example
 *
 * {@example forms/ts/nestedFormArray/nested_form_array_example.ts region='Component'}
 *
 * * **npm package**: `@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 * @stable
 */
var FormArrayName = (function (_super) {
    __extends(FormArrayName, _super);
    function FormArrayName(parent, validators, asyncValidators) {
        _super.call(this);
        this._parent = parent;
        this._validators = validators;
        this._asyncValidators = asyncValidators;
    }
    FormArrayName.prototype.ngOnInit = function () {
        this._checkParentType();
        this.formDirective.addFormArray(this);
    };
    FormArrayName.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeFormArray(this);
        }
    };
    Object.defineProperty(FormArrayName.prototype, "control", {
        get: function () { return this.formDirective.getFormArray(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "formDirective", {
        get: function () {
            return this._parent ? this._parent.formDirective : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "path", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["a" /* controlPath */])(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "validator", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["b" /* composeValidators */])(this._validators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "asyncValidator", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["c" /* composeAsyncValidators */])(this._asyncValidators); },
        enumerable: true,
        configurable: true
    });
    FormArrayName.prototype._checkParentType = function () {
        if (_hasInvalidParent(this._parent)) {
            __WEBPACK_IMPORTED_MODULE_4__reactive_errors__["a" /* ReactiveErrors */].arrayParentException();
        }
    };
    FormArrayName.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formArrayName]', providers: [formArrayNameProvider] },] },
    ];
    /** @nocollapse */
    FormArrayName.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_3__control_container__["a" /* ControlContainer */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
    ];
    FormArrayName.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formArrayName',] },],
    };
    return FormArrayName;
}(__WEBPACK_IMPORTED_MODULE_3__control_container__["a" /* ControlContainer */]));
function _hasInvalidParent(parent) {
    return !(parent instanceof FormGroupName) && !(parent instanceof __WEBPACK_IMPORTED_MODULE_6__form_group_directive__["a" /* FormGroupDirective */]) &&
        !(parent instanceof FormArrayName);
}
//# sourceMappingURL=form_group_name.js.map

/***/ },
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var date_formatter_1 = __webpack_require__(603);
var FORMAT_DAY = 'DD';
var FORMAT_MONTH = 'MMMM';
var FORMAT_YEAR = 'YYYY';
var FORMAT_DAY_HEADER = 'dd';
var FORMAT_DAY_TITLE = 'MMMM YYYY';
var FORMAT_MONTH_TITLE = 'YYYY';
var DATEPICKER_MODE = 'day';
var MIN_MODE = 'day';
var MAX_MODE = 'year';
var SHOW_WEEKS = true;
var ONLY_CURRENT_MONTH = false;
var STARTING_DAY = 0;
var YEAR_RANGE = 20;
var MONTH_COL_LIMIT = 3;
var YEAR_COL_LIMIT = 5;
// const MIN_DATE:Date = void 0;
// const MAX_DATE:Date = void 0;
var SHORTCUT_PROPAGATION = false;
// const DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
/*
 const KEYS = {
 13: 'enter',
 32: 'space',
 33: 'pageup',
 34: 'pagedown',
 35: 'end',
 36: 'home',
 37: 'left',
 38: 'up',
 39: 'right',
 40: 'down'
 };
 */
var DatePickerInnerComponent = (function () {
    function DatePickerInnerComponent() {
        this.selectionDone = new core_1.EventEmitter(undefined);
        this.update = new core_1.EventEmitter(false);
        this.stepDay = {};
        this.stepMonth = {};
        this.stepYear = {};
        this.modes = ['day', 'month', 'year'];
        this.dateFormatter = new date_formatter_1.DateFormatter();
    }
    Object.defineProperty(DatePickerInnerComponent.prototype, "activeDate", {
        get: function () {
            return this._activeDate;
        },
        set: function (value) {
            this._activeDate = value;
        },
        enumerable: true,
        configurable: true
    });
    // todo: add formatter value to Date object
    DatePickerInnerComponent.prototype.ngOnInit = function () {
        this.formatDay = this.formatDay || FORMAT_DAY;
        this.formatMonth = this.formatMonth || FORMAT_MONTH;
        this.formatYear = this.formatYear || FORMAT_YEAR;
        this.formatDayHeader = this.formatDayHeader || FORMAT_DAY_HEADER;
        this.formatDayTitle = this.formatDayTitle || FORMAT_DAY_TITLE;
        this.formatMonthTitle = this.formatMonthTitle || FORMAT_MONTH_TITLE;
        this.showWeeks = (this.showWeeks === undefined
            ? SHOW_WEEKS
            : this.showWeeks);
        this.onlyCurrentMonth = (this.onlyCurrentMonth === undefined
            ? ONLY_CURRENT_MONTH
            : this.onlyCurrentMonth);
        this.startingDay = this.startingDay || STARTING_DAY;
        this.yearRange = this.yearRange || YEAR_RANGE;
        this.shortcutPropagation = this.shortcutPropagation || SHORTCUT_PROPAGATION;
        this.datepickerMode = this.datepickerMode || DATEPICKER_MODE;
        this.minMode = this.minMode || MIN_MODE;
        this.maxMode = this.maxMode || MAX_MODE;
        this.monthColLimit = this.monthColLimit || MONTH_COL_LIMIT;
        this.yearColLimit = this.yearColLimit || YEAR_COL_LIMIT;
        // todo: use date for unique value
        this.uniqueId = 'datepicker-' + '-' + Math.floor(Math.random() * 10000);
        if (this.initDate) {
            this.activeDate = this.initDate;
            this.selectedDate = new Date(this.activeDate.valueOf());
            this.update.emit(this.activeDate);
        }
        else if (this.activeDate === undefined) {
            this.activeDate = new Date();
        }
    };
    // this.refreshView should be called here to reflect the changes on the fly
    // tslint:disable-next-line:no-unused-variable
    DatePickerInnerComponent.prototype.ngOnChanges = function (changes) {
        this.refreshView();
    };
    DatePickerInnerComponent.prototype.setCompareHandler = function (handler, type) {
        if (type === 'day') {
            this.compareHandlerDay = handler;
        }
        if (type === 'month') {
            this.compareHandlerMonth = handler;
        }
        if (type === 'year') {
            this.compareHandlerYear = handler;
        }
    };
    DatePickerInnerComponent.prototype.compare = function (date1, date2) {
        if (date1 === undefined || date2 === undefined) {
            return undefined;
        }
        if (this.datepickerMode === 'day' && this.compareHandlerDay) {
            return this.compareHandlerDay(date1, date2);
        }
        if (this.datepickerMode === 'month' && this.compareHandlerMonth) {
            return this.compareHandlerMonth(date1, date2);
        }
        if (this.datepickerMode === 'year' && this.compareHandlerYear) {
            return this.compareHandlerYear(date1, date2);
        }
        return void 0;
    };
    DatePickerInnerComponent.prototype.setRefreshViewHandler = function (handler, type) {
        if (type === 'day') {
            this.refreshViewHandlerDay = handler;
        }
        if (type === 'month') {
            this.refreshViewHandlerMonth = handler;
        }
        if (type === 'year') {
            this.refreshViewHandlerYear = handler;
        }
    };
    DatePickerInnerComponent.prototype.refreshView = function () {
        if (this.datepickerMode === 'day' && this.refreshViewHandlerDay) {
            this.refreshViewHandlerDay();
        }
        if (this.datepickerMode === 'month' && this.refreshViewHandlerMonth) {
            this.refreshViewHandlerMonth();
        }
        if (this.datepickerMode === 'year' && this.refreshViewHandlerYear) {
            this.refreshViewHandlerYear();
        }
    };
    DatePickerInnerComponent.prototype.dateFilter = function (date, format) {
        return this.dateFormatter.format(date, format);
    };
    DatePickerInnerComponent.prototype.isActive = function (dateObject) {
        if (this.compare(dateObject.date, this.activeDate) === 0) {
            this.activeDateId = dateObject.uid;
            return true;
        }
        return false;
    };
    DatePickerInnerComponent.prototype.createDateObject = function (date, format) {
        var dateObject = {};
        dateObject.date = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        dateObject.label = this.dateFilter(date, format);
        dateObject.selected = this.compare(date, this.selectedDate) === 0;
        dateObject.disabled = this.isDisabled(date);
        dateObject.current = this.compare(date, new Date()) === 0;
        dateObject.customClass = this.getCustomClassForDate(dateObject.date);
        return dateObject;
    };
    DatePickerInnerComponent.prototype.split = function (arr, size) {
        var arrays = [];
        while (arr.length > 0) {
            arrays.push(arr.splice(0, size));
        }
        return arrays;
    };
    // Fix a hard-reproducible bug with timezones
    // The bug depends on OS, browser, current timezone and current date
    // i.e.
    // var date = new Date(2014, 0, 1);
    // console.log(date.getFullYear(), date.getMonth(), date.getDate(),
    // date.getHours()); can result in "2013 11 31 23" because of the bug.
    DatePickerInnerComponent.prototype.fixTimeZone = function (date) {
        var hours = date.getHours();
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours === 23 ? hours + 2 : 0);
    };
    DatePickerInnerComponent.prototype.select = function (date, isManual) {
        if (isManual === void 0) { isManual = true; }
        if (this.datepickerMode === this.minMode) {
            if (!this.activeDate) {
                this.activeDate = new Date(0, 0, 0, 0, 0, 0, 0);
            }
            this.activeDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            if (isManual) {
                this.selectionDone.emit(this.activeDate);
            }
        }
        else {
            this.activeDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            this.datepickerMode = this.modes[this.modes.indexOf(this.datepickerMode) - 1];
        }
        this.selectedDate = new Date(this.activeDate.valueOf());
        this.update.emit(this.activeDate);
        this.refreshView();
    };
    DatePickerInnerComponent.prototype.move = function (direction) {
        var expectedStep;
        if (this.datepickerMode === 'day') {
            expectedStep = this.stepDay;
        }
        if (this.datepickerMode === 'month') {
            expectedStep = this.stepMonth;
        }
        if (this.datepickerMode === 'year') {
            expectedStep = this.stepYear;
        }
        if (expectedStep) {
            var year = this.activeDate.getFullYear() + direction * (expectedStep.years || 0);
            var month = this.activeDate.getMonth() + direction * (expectedStep.months || 0);
            this.activeDate = new Date(year, month, 1);
            this.refreshView();
        }
    };
    DatePickerInnerComponent.prototype.toggleMode = function (direction) {
        direction = direction || 1;
        if ((this.datepickerMode === this.maxMode && direction === 1) ||
            (this.datepickerMode === this.minMode && direction === -1)) {
            return;
        }
        this.datepickerMode = this.modes[this.modes.indexOf(this.datepickerMode) + direction];
        this.refreshView();
    };
    DatePickerInnerComponent.prototype.getCustomClassForDate = function (date) {
        var _this = this;
        if (!this.customClass) {
            return '';
        }
        // todo: build a hash of custom classes, it will work faster
        var customClassObject = this.customClass
            .find(function (customClass) {
            return customClass.date.valueOf() === date.valueOf() &&
                customClass.mode === _this.datepickerMode;
        }, this);
        return customClassObject === undefined ? '' : customClassObject.clazz;
    };
    DatePickerInnerComponent.prototype.isDisabled = function (date) {
        // todo: implement dateDisabled attribute
        return ((this.minDate && this.compare(date, this.minDate) < 0) ||
            (this.maxDate && this.compare(date, this.maxDate) > 0));
    };
    DatePickerInnerComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'datepicker-inner',
                    template: "\n    <div *ngIf=\"datepickerMode\" class=\"well well-sm bg-faded p-a card\" role=\"application\" ><!--&lt;!&ndash;ng-keydown=\"keydown($event)\"&ndash;&gt;-->\n      <ng-content></ng-content>\n    </div>\n  "
                },] },
    ];
    /** @nocollapse */
    DatePickerInnerComponent.ctorParameters = [];
    DatePickerInnerComponent.propDecorators = {
        'datepickerMode': [{ type: core_1.Input },],
        'startingDay': [{ type: core_1.Input },],
        'yearRange': [{ type: core_1.Input },],
        'minDate': [{ type: core_1.Input },],
        'maxDate': [{ type: core_1.Input },],
        'minMode': [{ type: core_1.Input },],
        'maxMode': [{ type: core_1.Input },],
        'showWeeks': [{ type: core_1.Input },],
        'formatDay': [{ type: core_1.Input },],
        'formatMonth': [{ type: core_1.Input },],
        'formatYear': [{ type: core_1.Input },],
        'formatDayHeader': [{ type: core_1.Input },],
        'formatDayTitle': [{ type: core_1.Input },],
        'formatMonthTitle': [{ type: core_1.Input },],
        'onlyCurrentMonth': [{ type: core_1.Input },],
        'shortcutPropagation': [{ type: core_1.Input },],
        'customClass': [{ type: core_1.Input },],
        'monthColLimit': [{ type: core_1.Input },],
        'yearColLimit': [{ type: core_1.Input },],
        'dateDisabled': [{ type: core_1.Input },],
        'initDate': [{ type: core_1.Input },],
        'selectionDone': [{ type: core_1.Output },],
        'update': [{ type: core_1.Output },],
        'activeDate': [{ type: core_1.Input },],
    };
    return DatePickerInnerComponent;
}());
exports.DatePickerInnerComponent = DatePickerInnerComponent;


/***/ },
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__ = __webpack_require__(34);
/* unused harmony export CHECKBOX_VALUE_ACCESSOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return CheckboxControlValueAccessor; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var CHECKBOX_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return CheckboxControlValueAccessor; }),
    multi: true,
};
/**
 * The accessor for writing a value and listening to changes on a checkbox input element.
 *
 *  ### Example
 *  ```
 *  <input type="checkbox" name="rememberLogin" ngModel>
 *  ```
 *
 *  @stable
 */
var CheckboxControlValueAccessor = (function () {
    function CheckboxControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    CheckboxControlValueAccessor.prototype.writeValue = function (value) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', value);
    };
    CheckboxControlValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    CheckboxControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    CheckboxControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    CheckboxControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]',
                    host: { '(change)': 'onChange($event.target.checked)', '(blur)': 'onTouched()' },
                    providers: [CHECKBOX_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    CheckboxControlValueAccessor.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ];
    return CheckboxControlValueAccessor;
}());
//# sourceMappingURL=checkbox_value_accessor.js.map

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__ = __webpack_require__(34);
/* unused harmony export DEFAULT_VALUE_ACCESSOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return DefaultValueAccessor; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var DEFAULT_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return DefaultValueAccessor; }),
    multi: true
};
/**
 * The default accessor for writing a value and listening to changes that is used by the
 * {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName} directives.
 *
 *  ### Example
 *  ```
 *  <input type="text" name="searchQuery" ngModel>
 *  ```
 *
 *  @stable
 */
var DefaultValueAccessor = (function () {
    function DefaultValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    DefaultValueAccessor.prototype.writeValue = function (value) {
        var normalizedValue = value == null ? '' : value;
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', normalizedValue);
    };
    DefaultValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    DefaultValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    DefaultValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    DefaultValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]',
                    // TODO: vsavkin replace the above selector with the one below it once
                    // https://github.com/angular/angular/issues/3011 is implemented
                    // selector: '[ngControl],[ngModel],[ngFormControl]',
                    host: { '(input)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
                    providers: [DEFAULT_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    DefaultValueAccessor.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ];
    return DefaultValueAccessor;
}());
//# sourceMappingURL=default_value_accessor.js.map

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validators__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__abstract_form_group_directive__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__control_container__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ng_form__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__template_driven_errors__ = __webpack_require__(336);
/* unused harmony export modelGroupProvider */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NgModelGroup; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};






var modelGroupProvider = {
    provide: __WEBPACK_IMPORTED_MODULE_3__control_container__["a" /* ControlContainer */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgModelGroup; })
};
/**
 * @whatItDoes Creates and binds a {@link FormGroup} instance to a DOM element.
 *
 * @howToUse
 *
 * This directive can only be used as a child of {@link NgForm} (or in other words,
 * within `<form>` tags).
 *
 * Use this directive if you'd like to create a sub-group within a form. This can
 * come in handy if you want to validate a sub-group of your form separately from
 * the rest of your form, or if some values in your domain model make more sense to
 * consume together in a nested object.
 *
 * Pass in the name you'd like this sub-group to have and it will become the key
 * for the sub-group in the form's full value. You can also export the directive into
 * a local template variable using `ngModelGroup` (ex: `#myGroup="ngModelGroup"`).
 *
 * {@example forms/ts/ngModelGroup/ng_model_group_example.ts region='Component'}
 *
 * * **npm package**: `@angular/forms`
 *
 * * **NgModule**: `FormsModule`
 *
 * @stable
 */
var NgModelGroup = (function (_super) {
    __extends(NgModelGroup, _super);
    function NgModelGroup(parent, validators, asyncValidators) {
        _super.call(this);
        this._parent = parent;
        this._validators = validators;
        this._asyncValidators = asyncValidators;
    }
    /** @internal */
    NgModelGroup.prototype._checkParentType = function () {
        if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof __WEBPACK_IMPORTED_MODULE_4__ng_form__["a" /* NgForm */])) {
            __WEBPACK_IMPORTED_MODULE_5__template_driven_errors__["a" /* TemplateDrivenErrors */].modelGroupParentException();
        }
    };
    NgModelGroup.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngModelGroup]', providers: [modelGroupProvider], exportAs: 'ngModelGroup' },] },
    ];
    /** @nocollapse */
    NgModelGroup.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_3__control_container__["a" /* ControlContainer */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
    ];
    NgModelGroup.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModelGroup',] },],
    };
    return NgModelGroup;
}(__WEBPACK_IMPORTED_MODULE_2__abstract_form_group_directive__["a" /* AbstractFormGroupDirective */]));
//# sourceMappingURL=ng_model_group.js.map

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_examples__ = __webpack_require__(335);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return ReactiveErrors; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

var ReactiveErrors = (function () {
    function ReactiveErrors() {
    }
    ReactiveErrors.controlParentException = function () {
        throw new Error("formControlName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formControlName);
    };
    ReactiveErrors.ngModelGroupException = function () {
        throw new Error("formControlName cannot be used with an ngModelGroup parent. It is only compatible with parents\n       that also have a \"form\" prefix: formGroupName, formArrayName, or formGroup.\n\n       Option 1:  Update the parent to be formGroupName (reactive form strategy)\n\n        " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formGroupName + "\n\n        Option 2: Use ngModel instead of formControlName (template-driven strategy)\n\n        " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].ngModelGroup);
    };
    ReactiveErrors.missingFormException = function () {
        throw new Error("formGroup expects a FormGroup instance. Please pass one in.\n\n       Example:\n\n       " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formControlName);
    };
    ReactiveErrors.groupParentException = function () {
        throw new Error("formGroupName must be used with a parent formGroup directive.  You'll want to add a formGroup\n      directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formGroupName);
    };
    ReactiveErrors.arrayParentException = function () {
        throw new Error("formArrayName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n        Example:\n\n        " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formArrayName);
    };
    ReactiveErrors.disabledAttrWarning = function () {
        console.warn("\n      It looks like you're using the disabled attribute with a reactive form directive. If you set disabled to true\n      when you set up this control in your component class, the disabled attribute will actually be set in the DOM for\n      you. We recommend using this approach to avoid 'changed after checked' errors.\n       \n      Example: \n      form = new FormGroup({\n        first: new FormControl({value: 'Nancy', disabled: true}, Validators.required),\n        last: new FormControl('Drew', Validators.required)\n      });\n    ");
    };
    return ReactiveErrors;
}());
//# sourceMappingURL=reactive_errors.js.map

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__control_value_accessor__ = __webpack_require__(34);
/* unused harmony export SELECT_VALUE_ACCESSOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return SelectControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return NgSelectOption; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



var SELECT_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_2__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return SelectControlValueAccessor; }),
    multi: true
};
function _buildValueString(id, value) {
    if (id == null)
        return "" + value;
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPrimitive */])(value))
        value = 'Object';
    return (id + ": " + value).slice(0, 50);
}
function _extractId(valueString) {
    return valueString.split(':')[0];
}
/**
 * @whatItDoes Writes values and listens to changes on a select element.
 *
 * Used by {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName}
 * to keep the view synced with the {@link FormControl} model.
 *
 * @howToUse
 *
 * If you have imported the {@link FormsModule} or the {@link ReactiveFormsModule}, this
 * value accessor will be active on any select control that has a form directive. You do
 * **not** need to add a special selector to activate it.
 *
 * ### How to use select controls with form directives
 *
 * To use a select in a template-driven form, simply add an `ngModel` and a `name`
 * attribute to the main `<select>` tag.
 *
 * If your option values are simple strings, you can bind to the normal `value` property
 * on the option.  If your option values happen to be objects (and you'd like to save the
 * selection in your form as an object), use `ngValue` instead:
 *
 * {@example forms/ts/selectControl/select_control_example.ts region='Component'}
 *
 * In reactive forms, you'll also want to add your form directive (`formControlName` or
 * `formControl`) on the main `<select>` tag. Like in the former example, you have the
 * choice of binding to the  `value` or `ngValue` property on the select's options.
 *
 * {@example forms/ts/reactiveSelectControl/reactive_select_control_example.ts region='Component'}
 *
 * Note: We listen to the 'change' event because 'input' events aren't fired
 * for selects in Firefox and IE:
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1024350
 * https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/4660045/
 *
 * * **npm package**: `@angular/forms`
 *
 * @stable
 */
var SelectControlValueAccessor = (function () {
    function SelectControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        /** @internal */
        this._optionMap = new Map();
        /** @internal */
        this._idCounter = 0;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    SelectControlValueAccessor.prototype.writeValue = function (value) {
        this.value = value;
        var valueString = _buildValueString(this._getOptionId(value), value);
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', valueString);
    };
    SelectControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this.onChange = function (valueString) {
            _this.value = valueString;
            fn(_this._getOptionValue(valueString));
        };
    };
    SelectControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    SelectControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /** @internal */
    SelectControlValueAccessor.prototype._registerOption = function () { return (this._idCounter++).toString(); };
    /** @internal */
    SelectControlValueAccessor.prototype._getOptionId = function (value) {
        for (var _i = 0, _a = Array.from(this._optionMap.keys()); _i < _a.length; _i++) {
            var id = _a[_i];
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["e" /* looseIdentical */])(this._optionMap.get(id), value))
                return id;
        }
        return null;
    };
    /** @internal */
    SelectControlValueAccessor.prototype._getOptionValue = function (valueString) {
        var id = _extractId(valueString);
        return this._optionMap.has(id) ? this._optionMap.get(id) : valueString;
    };
    SelectControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]',
                    host: { '(change)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
                    providers: [SELECT_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    SelectControlValueAccessor.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ];
    return SelectControlValueAccessor;
}());
/**
 * @whatItDoes Marks `<option>` as dynamic, so Angular can be notified when options change.
 *
 * @howToUse
 *
 * See docs for {@link SelectControlValueAccessor} for usage examples.
 *
 * @stable
 */
var NgSelectOption = (function () {
    function NgSelectOption(_element, _renderer, _select) {
        this._element = _element;
        this._renderer = _renderer;
        this._select = _select;
        if (this._select)
            this.id = this._select._registerOption();
    }
    Object.defineProperty(NgSelectOption.prototype, "ngValue", {
        set: function (value) {
            if (this._select == null)
                return;
            this._select._optionMap.set(this.id, value);
            this._setElementValue(_buildValueString(this.id, value));
            this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgSelectOption.prototype, "value", {
        set: function (value) {
            this._setElementValue(value);
            if (this._select)
                this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    NgSelectOption.prototype._setElementValue = function (value) {
        this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
    };
    NgSelectOption.prototype.ngOnDestroy = function () {
        if (this._select) {
            this._select._optionMap.delete(this.id);
            this._select.writeValue(this._select.value);
        }
    };
    NgSelectOption.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'option' },] },
    ];
    /** @nocollapse */
    NgSelectOption.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: SelectControlValueAccessor, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
    ];
    NgSelectOption.propDecorators = {
        'ngValue': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngValue',] },],
        'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['value',] },],
    };
    return NgSelectOption;
}());
//# sourceMappingURL=select_control_value_accessor.js.map

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__control_value_accessor__ = __webpack_require__(34);
/* unused harmony export SELECT_MULTIPLE_VALUE_ACCESSOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return SelectMultipleControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return NgSelectMultipleOption; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



var SELECT_MULTIPLE_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_2__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return SelectMultipleControlValueAccessor; }),
    multi: true
};
function _buildValueString(id, value) {
    if (id == null)
        return "" + value;
    if (typeof value === 'string')
        value = "'" + value + "'";
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPrimitive */])(value))
        value = 'Object';
    return (id + ": " + value).slice(0, 50);
}
function _extractId(valueString) {
    return valueString.split(':')[0];
}
/** Mock interface for HTMLCollection */
var HTMLCollection = (function () {
    function HTMLCollection() {
    }
    return HTMLCollection;
}());
/**
 * The accessor for writing a value and listening to changes on a select element.
 *
 * @stable
 */
var SelectMultipleControlValueAccessor = (function () {
    function SelectMultipleControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        /** @internal */
        this._optionMap = new Map();
        /** @internal */
        this._idCounter = 0;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    SelectMultipleControlValueAccessor.prototype.writeValue = function (value) {
        var _this = this;
        this.value = value;
        if (value == null)
            return;
        var values = value;
        // convert values to ids
        var ids = values.map(function (v) { return _this._getOptionId(v); });
        this._optionMap.forEach(function (opt, o) { opt._setSelected(ids.indexOf(o.toString()) > -1); });
    };
    SelectMultipleControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this.onChange = function (_) {
            var selected = [];
            if (_.hasOwnProperty('selectedOptions')) {
                var options = _.selectedOptions;
                for (var i = 0; i < options.length; i++) {
                    var opt = options.item(i);
                    var val = _this._getOptionValue(opt.value);
                    selected.push(val);
                }
            }
            else {
                var options = _.options;
                for (var i = 0; i < options.length; i++) {
                    var opt = options.item(i);
                    if (opt.selected) {
                        var val = _this._getOptionValue(opt.value);
                        selected.push(val);
                    }
                }
            }
            fn(selected);
        };
    };
    SelectMultipleControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    SelectMultipleControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /** @internal */
    SelectMultipleControlValueAccessor.prototype._registerOption = function (value) {
        var id = (this._idCounter++).toString();
        this._optionMap.set(id, value);
        return id;
    };
    /** @internal */
    SelectMultipleControlValueAccessor.prototype._getOptionId = function (value) {
        for (var _i = 0, _a = Array.from(this._optionMap.keys()); _i < _a.length; _i++) {
            var id = _a[_i];
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["e" /* looseIdentical */])(this._optionMap.get(id)._value, value))
                return id;
        }
        return null;
    };
    /** @internal */
    SelectMultipleControlValueAccessor.prototype._getOptionValue = function (valueString) {
        var id = _extractId(valueString);
        return this._optionMap.has(id) ? this._optionMap.get(id)._value : valueString;
    };
    SelectMultipleControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'select[multiple][formControlName],select[multiple][formControl],select[multiple][ngModel]',
                    host: { '(change)': 'onChange($event.target)', '(blur)': 'onTouched()' },
                    providers: [SELECT_MULTIPLE_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    SelectMultipleControlValueAccessor.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ];
    return SelectMultipleControlValueAccessor;
}());
/**
 * Marks `<option>` as dynamic, so Angular can be notified when options change.
 *
 * ### Example
 *
 * ```
 * <select multiple name="city" ngModel>
 *   <option *ngFor="let c of cities" [value]="c"></option>
 * </select>
 * ```
 */
var NgSelectMultipleOption = (function () {
    function NgSelectMultipleOption(_element, _renderer, _select) {
        this._element = _element;
        this._renderer = _renderer;
        this._select = _select;
        if (this._select) {
            this.id = this._select._registerOption(this);
        }
    }
    Object.defineProperty(NgSelectMultipleOption.prototype, "ngValue", {
        set: function (value) {
            if (this._select == null)
                return;
            this._value = value;
            this._setElementValue(_buildValueString(this.id, value));
            this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgSelectMultipleOption.prototype, "value", {
        set: function (value) {
            if (this._select) {
                this._value = value;
                this._setElementValue(_buildValueString(this.id, value));
                this._select.writeValue(this._select.value);
            }
            else {
                this._setElementValue(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    NgSelectMultipleOption.prototype._setElementValue = function (value) {
        this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
    };
    /** @internal */
    NgSelectMultipleOption.prototype._setSelected = function (selected) {
        this._renderer.setElementProperty(this._element.nativeElement, 'selected', selected);
    };
    NgSelectMultipleOption.prototype.ngOnDestroy = function () {
        if (this._select) {
            this._select._optionMap.delete(this.id);
            this._select.writeValue(this._select.value);
        }
    };
    NgSelectMultipleOption.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'option' },] },
    ];
    /** @nocollapse */
    NgSelectMultipleOption.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: SelectMultipleControlValueAccessor, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
    ];
    NgSelectMultipleOption.propDecorators = {
        'ngValue': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngValue',] },],
        'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['value',] },],
    };
    return NgSelectMultipleOption;
}());
//# sourceMappingURL=select_multiple_control_value_accessor.js.map

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_observable_fromPromise__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_shared__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_async__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__private_import_core__ = __webpack_require__(339);
/* unused harmony export VALID */
/* unused harmony export INVALID */
/* unused harmony export PENDING */
/* unused harmony export DISABLED */
/* unused harmony export isControl */
/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return AbstractControl; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return FormControl; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormGroup; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return FormArray; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};




/**
 * Indicates that a FormControl is valid, i.e. that no errors exist in the input value.
 */
var VALID = 'VALID';
/**
 * Indicates that a FormControl is invalid, i.e. that an error exists in the input value.
 */
var INVALID = 'INVALID';
/**
 * Indicates that a FormControl is pending, i.e. that async validation is occurring and
 * errors are not yet available for the input value.
 */
var PENDING = 'PENDING';
/**
 * Indicates that a FormControl is disabled, i.e. that the control is exempt from ancestor
 * calculations of validity or value.
 */
var DISABLED = 'DISABLED';
function isControl(control) {
    return control instanceof AbstractControl;
}
function _find(control, path, delimiter) {
    if (path == null)
        return null;
    if (!(path instanceof Array)) {
        path = path.split(delimiter);
    }
    if (path instanceof Array && (path.length === 0))
        return null;
    return path.reduce(function (v, name) {
        if (v instanceof FormGroup) {
            return v.controls[name] || null;
        }
        if (v instanceof FormArray) {
            return v.at(name) || null;
        }
        return null;
    }, control);
}
function toObservable(r) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__private_import_core__["a" /* isPromise */])(r) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_rxjs_observable_fromPromise__["fromPromise"])(r) : r;
}
function coerceToValidator(validator) {
    return Array.isArray(validator) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__directives_shared__["b" /* composeValidators */])(validator) : validator;
}
function coerceToAsyncValidator(asyncValidator) {
    return Array.isArray(asyncValidator) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__directives_shared__["c" /* composeAsyncValidators */])(asyncValidator) : asyncValidator;
}
/**
 * @whatItDoes This is the base class for {@link FormControl}, {@link FormGroup}, and
 * {@link FormArray}.
 *
 * It provides some of the shared behavior that all controls and groups of controls have, like
 * running validators, calculating status, and resetting state. It also defines the properties
 * that are shared between all sub-classes, like `value`, `valid`, and `dirty`. It shouldn't be
 * instantiated directly.
 *
 * @stable
 */
var AbstractControl = (function () {
    function AbstractControl(validator, asyncValidator) {
        this.validator = validator;
        this.asyncValidator = asyncValidator;
        /** @internal */
        this._onCollectionChange = function () { };
        this._pristine = true;
        this._touched = false;
        /** @internal */
        this._onDisabledChange = [];
    }
    Object.defineProperty(AbstractControl.prototype, "value", {
        /**
         * The value of the control.
         */
        get: function () { return this._value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "parent", {
        /**
         * The parent control.
         */
        get: function () { return this._parent; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "status", {
        /**
         * The validation status of the control. There are four possible
         * validation statuses:
         *
         * * **VALID**:  control has passed all validation checks
         * * **INVALID**: control has failed at least one validation check
         * * **PENDING**: control is in the midst of conducting a validation check
         * * **DISABLED**: control is exempt from validation checks
         *
         * These statuses are mutually exclusive, so a control cannot be
         * both valid AND invalid or invalid AND disabled.
         */
        get: function () { return this._status; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "valid", {
        /**
         * A control is `valid` when its `status === VALID`.
         *
         * In order to have this status, the control must have passed all its
         * validation checks.
         */
        get: function () { return this._status === VALID; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "invalid", {
        /**
         * A control is `invalid` when its `status === INVALID`.
         *
         * In order to have this status, the control must have failed
         * at least one of its validation checks.
         */
        get: function () { return this._status === INVALID; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "pending", {
        /**
         * A control is `pending` when its `status === PENDING`.
         *
         * In order to have this status, the control must be in the
         * middle of conducting a validation check.
         */
        get: function () { return this._status == PENDING; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "disabled", {
        /**
         * A control is `disabled` when its `status === DISABLED`.
         *
         * Disabled controls are exempt from validation checks and
         * are not included in the aggregate value of their ancestor
         * controls.
         */
        get: function () { return this._status === DISABLED; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "enabled", {
        /**
         * A control is `enabled` as long as its `status !== DISABLED`.
         *
         * In other words, it has a status of `VALID`, `INVALID`, or
         * `PENDING`.
         */
        get: function () { return this._status !== DISABLED; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "errors", {
        /**
         * Returns any errors generated by failing validation. If there
         * are no errors, it will return null.
         */
        get: function () { return this._errors; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "pristine", {
        /**
         * A control is `pristine` if the user has not yet changed
         * the value in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         */
        get: function () { return this._pristine; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "dirty", {
        /**
         * A control is `dirty` if the user has changed the value
         * in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         */
        get: function () { return !this.pristine; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "touched", {
        /**
        * A control is marked `touched` once the user has triggered
        * a `blur` event on it.
        */
        get: function () { return this._touched; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "untouched", {
        /**
         * A control is `untouched` if the user has not yet triggered
         * a `blur` event on it.
         */
        get: function () { return !this._touched; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "valueChanges", {
        /**
         * Emits an event every time the value of the control changes, in
         * the UI or programmatically.
         */
        get: function () { return this._valueChanges; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "statusChanges", {
        /**
         * Emits an event every time the validation status of the control
         * is re-calculated.
         */
        get: function () { return this._statusChanges; },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the synchronous validators that are active on this control.  Calling
     * this will overwrite any existing sync validators.
     */
    AbstractControl.prototype.setValidators = function (newValidator) {
        this.validator = coerceToValidator(newValidator);
    };
    /**
     * Sets the async validators that are active on this control. Calling this
     * will overwrite any existing async validators.
     */
    AbstractControl.prototype.setAsyncValidators = function (newValidator) {
        this.asyncValidator = coerceToAsyncValidator(newValidator);
    };
    /**
     * Empties out the sync validator list.
     */
    AbstractControl.prototype.clearValidators = function () { this.validator = null; };
    /**
     * Empties out the async validator list.
     */
    AbstractControl.prototype.clearAsyncValidators = function () { this.asyncValidator = null; };
    /**
     * Marks the control as `touched`.
     *
     * This will also mark all direct ancestors as `touched` to maintain
     * the model.
     */
    AbstractControl.prototype.markAsTouched = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._touched = true;
        if (this._parent && !onlySelf) {
            this._parent.markAsTouched({ onlySelf: onlySelf });
        }
    };
    /**
     * Marks the control as `untouched`.
     *
     * If the control has any children, it will also mark all children as `untouched`
     * to maintain the model, and re-calculate the `touched` status of all parent
     * controls.
     */
    AbstractControl.prototype.markAsUntouched = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._touched = false;
        this._forEachChild(function (control) { control.markAsUntouched({ onlySelf: true }); });
        if (this._parent && !onlySelf) {
            this._parent._updateTouched({ onlySelf: onlySelf });
        }
    };
    /**
     * Marks the control as `dirty`.
     *
     * This will also mark all direct ancestors as `dirty` to maintain
     * the model.
     */
    AbstractControl.prototype.markAsDirty = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._pristine = false;
        if (this._parent && !onlySelf) {
            this._parent.markAsDirty({ onlySelf: onlySelf });
        }
    };
    /**
     * Marks the control as `pristine`.
     *
     * If the control has any children, it will also mark all children as `pristine`
     * to maintain the model, and re-calculate the `pristine` status of all parent
     * controls.
     */
    AbstractControl.prototype.markAsPristine = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._pristine = true;
        this._forEachChild(function (control) { control.markAsPristine({ onlySelf: true }); });
        if (this._parent && !onlySelf) {
            this._parent._updatePristine({ onlySelf: onlySelf });
        }
    };
    /**
     * Marks the control as `pending`.
     */
    AbstractControl.prototype.markAsPending = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._status = PENDING;
        if (this._parent && !onlySelf) {
            this._parent.markAsPending({ onlySelf: onlySelf });
        }
    };
    /**
     * Disables the control. This means the control will be exempt from validation checks and
     * excluded from the aggregate value of any parent. Its status is `DISABLED`.
     *
     * If the control has children, all children will be disabled to maintain the model.
     */
    AbstractControl.prototype.disable = function (_a) {
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._status = DISABLED;
        this._errors = null;
        this._forEachChild(function (control) { control.disable({ onlySelf: true }); });
        this._updateValue();
        if (emitEvent !== false) {
            this._valueChanges.emit(this._value);
            this._statusChanges.emit(this._status);
        }
        this._updateAncestors(onlySelf);
        this._onDisabledChange.forEach(function (changeFn) { return changeFn(true); });
    };
    /**
     * Enables the control. This means the control will be included in validation checks and
     * the aggregate value of its parent. Its status is re-calculated based on its value and
     * its validators.
     *
     * If the control has children, all children will be enabled.
     */
    AbstractControl.prototype.enable = function (_a) {
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._status = VALID;
        this._forEachChild(function (control) { control.enable({ onlySelf: true }); });
        this.updateValueAndValidity({ onlySelf: true, emitEvent: emitEvent });
        this._updateAncestors(onlySelf);
        this._onDisabledChange.forEach(function (changeFn) { return changeFn(false); });
    };
    AbstractControl.prototype._updateAncestors = function (onlySelf) {
        if (this._parent && !onlySelf) {
            this._parent.updateValueAndValidity();
            this._parent._updatePristine();
            this._parent._updateTouched();
        }
    };
    AbstractControl.prototype.setParent = function (parent) { this._parent = parent; };
    /**
     * Re-calculates the value and validation status of the control.
     *
     * By default, it will also update the value and validity of its ancestors.
     */
    AbstractControl.prototype.updateValueAndValidity = function (_a) {
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._setInitialStatus();
        this._updateValue();
        if (this.enabled) {
            this._errors = this._runValidator();
            this._status = this._calculateStatus();
            if (this._status === VALID || this._status === PENDING) {
                this._runAsyncValidator(emitEvent);
            }
        }
        if (emitEvent !== false) {
            this._valueChanges.emit(this._value);
            this._statusChanges.emit(this._status);
        }
        if (this._parent && !onlySelf) {
            this._parent.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
        }
    };
    /** @internal */
    AbstractControl.prototype._updateTreeValidity = function (_a) {
        var emitEvent = (_a === void 0 ? { emitEvent: true } : _a).emitEvent;
        this._forEachChild(function (ctrl) { return ctrl._updateTreeValidity({ emitEvent: emitEvent }); });
        this.updateValueAndValidity({ onlySelf: true, emitEvent: emitEvent });
    };
    AbstractControl.prototype._setInitialStatus = function () { this._status = this._allControlsDisabled() ? DISABLED : VALID; };
    AbstractControl.prototype._runValidator = function () {
        return this.validator ? this.validator(this) : null;
    };
    AbstractControl.prototype._runAsyncValidator = function (emitEvent) {
        var _this = this;
        if (this.asyncValidator) {
            this._status = PENDING;
            this._cancelExistingSubscription();
            var obs = toObservable(this.asyncValidator(this));
            this._asyncValidationSubscription =
                obs.subscribe({ next: function (res) { return _this.setErrors(res, { emitEvent: emitEvent }); } });
        }
    };
    AbstractControl.prototype._cancelExistingSubscription = function () {
        if (this._asyncValidationSubscription) {
            this._asyncValidationSubscription.unsubscribe();
        }
    };
    /**
     * Sets errors on a form control.
     *
     * This is used when validations are run manually by the user, rather than automatically.
     *
     * Calling `setErrors` will also update the validity of the parent control.
     *
     * ### Example
     *
     * ```
     * const login = new FormControl("someLogin");
     * login.setErrors({
     *   "notUnique": true
     * });
     *
     * expect(login.valid).toEqual(false);
     * expect(login.errors).toEqual({"notUnique": true});
     *
     * login.setValue("someOtherLogin");
     *
     * expect(login.valid).toEqual(true);
     * ```
     */
    AbstractControl.prototype.setErrors = function (errors, _a) {
        var emitEvent = (_a === void 0 ? {} : _a).emitEvent;
        this._errors = errors;
        this._updateControlsErrors(emitEvent !== false);
    };
    /**
     * Retrieves a child control given the control's name or path.
     *
     * Paths can be passed in as an array or a string delimited by a dot.
     *
     * To get a control nested within a `person` sub-group:
     *
     * * `this.form.get('person.name');`
     *
     * -OR-
     *
     * * `this.form.get(['person', 'name']);`
     */
    AbstractControl.prototype.get = function (path) { return _find(this, path, '.'); };
    /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns null or undefined.
     *
     * If no path is given, it checks for the error on the present control.
     */
    AbstractControl.prototype.getError = function (errorCode, path) {
        if (path === void 0) { path = null; }
        var control = path ? this.get(path) : this;
        return control && control._errors ? control._errors[errorCode] : null;
    };
    /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns false.
     *
     * If no path is given, it checks for the error on the present control.
     */
    AbstractControl.prototype.hasError = function (errorCode, path) {
        if (path === void 0) { path = null; }
        return !!this.getError(errorCode, path);
    };
    Object.defineProperty(AbstractControl.prototype, "root", {
        /**
         * Retrieves the top-level ancestor of this control.
         */
        get: function () {
            var x = this;
            while (x._parent) {
                x = x._parent;
            }
            return x;
        },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    AbstractControl.prototype._updateControlsErrors = function (emitEvent) {
        this._status = this._calculateStatus();
        if (emitEvent) {
            this._statusChanges.emit(this._status);
        }
        if (this._parent) {
            this._parent._updateControlsErrors(emitEvent);
        }
    };
    /** @internal */
    AbstractControl.prototype._initObservables = function () {
        this._valueChanges = new __WEBPACK_IMPORTED_MODULE_2__facade_async__["a" /* EventEmitter */]();
        this._statusChanges = new __WEBPACK_IMPORTED_MODULE_2__facade_async__["a" /* EventEmitter */]();
    };
    AbstractControl.prototype._calculateStatus = function () {
        if (this._allControlsDisabled())
            return DISABLED;
        if (this._errors)
            return INVALID;
        if (this._anyControlsHaveStatus(PENDING))
            return PENDING;
        if (this._anyControlsHaveStatus(INVALID))
            return INVALID;
        return VALID;
    };
    /** @internal */
    AbstractControl.prototype._anyControlsHaveStatus = function (status) {
        return this._anyControls(function (control) { return control.status === status; });
    };
    /** @internal */
    AbstractControl.prototype._anyControlsDirty = function () {
        return this._anyControls(function (control) { return control.dirty; });
    };
    /** @internal */
    AbstractControl.prototype._anyControlsTouched = function () {
        return this._anyControls(function (control) { return control.touched; });
    };
    /** @internal */
    AbstractControl.prototype._updatePristine = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._pristine = !this._anyControlsDirty();
        if (this._parent && !onlySelf) {
            this._parent._updatePristine({ onlySelf: onlySelf });
        }
    };
    /** @internal */
    AbstractControl.prototype._updateTouched = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._touched = this._anyControlsTouched();
        if (this._parent && !onlySelf) {
            this._parent._updateTouched({ onlySelf: onlySelf });
        }
    };
    /** @internal */
    AbstractControl.prototype._isBoxedValue = function (formState) {
        return typeof formState === 'object' && formState !== null &&
            Object.keys(formState).length === 2 && 'value' in formState && 'disabled' in formState;
    };
    /** @internal */
    AbstractControl.prototype._registerOnCollectionChange = function (fn) { this._onCollectionChange = fn; };
    return AbstractControl;
}());
/**
 * @whatItDoes Tracks the value and validation status of an individual form control.
 *
 * It is one of the three fundamental building blocks of Angular forms, along with
 * {@link FormGroup} and {@link FormArray}.
 *
 * @howToUse
 *
 * When instantiating a {@link FormControl}, you can pass in an initial value as the
 * first argument. Example:
 *
 * ```ts
 * const ctrl = new FormControl('some value');
 * console.log(ctrl.value);     // 'some value'
 *```
 *
 * You can also initialize the control with a form state object on instantiation,
 * which includes both the value and whether or not the control is disabled.
 * You can't use the value key without the disabled key; both are required
 * to use this way of initialization.
 *
 * ```ts
 * const ctrl = new FormControl({value: 'n/a', disabled: true});
 * console.log(ctrl.value);     // 'n/a'
 * console.log(ctrl.status);   // 'DISABLED'
 * ```
 *
 * To include a sync validator (or an array of sync validators) with the control,
 * pass it in as the second argument. Async validators are also supported, but
 * have to be passed in separately as the third arg.
 *
 * ```ts
 * const ctrl = new FormControl('', Validators.required);
 * console.log(ctrl.value);     // ''
 * console.log(ctrl.status);   // 'INVALID'
 * ```
 *
 * See its superclass, {@link AbstractControl}, for more properties and methods.
 *
 * * **npm package**: `@angular/forms`
 *
 * @stable
 */
var FormControl = (function (_super) {
    __extends(FormControl, _super);
    function FormControl(formState, validator, asyncValidator) {
        if (formState === void 0) { formState = null; }
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        _super.call(this, coerceToValidator(validator), coerceToAsyncValidator(asyncValidator));
        /** @internal */
        this._onChange = [];
        this._applyFormState(formState);
        this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        this._initObservables();
    }
    /**
     * Set the value of the form control to `value`.
     *
     * If `onlySelf` is `true`, this change will only affect the validation of this `FormControl`
     * and not its parent component. This defaults to false.
     *
     * If `emitEvent` is `true`, this
     * change will cause a `valueChanges` event on the `FormControl` to be emitted. This defaults
     * to true (as it falls through to `updateValueAndValidity`).
     *
     * If `emitModelToViewChange` is `true`, the view will be notified about the new value
     * via an `onChange` event. This is the default behavior if `emitModelToViewChange` is not
     * specified.
     *
     * If `emitViewToModelChange` is `true`, an ngModelChange event will be fired to update the
     * model.  This is the default behavior if `emitViewToModelChange` is not specified.
     */
    FormControl.prototype.setValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent, emitModelToViewChange = _b.emitModelToViewChange, emitViewToModelChange = _b.emitViewToModelChange;
        this._value = value;
        if (this._onChange.length && emitModelToViewChange !== false) {
            this._onChange.forEach(function (changeFn) { return changeFn(_this._value, emitViewToModelChange !== false); });
        }
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     * Patches the value of a control.
     *
     * This function is functionally the same as {@link FormControl.setValue} at this level.
     * It exists for symmetry with {@link FormGroup.patchValue} on `FormGroups` and `FormArrays`,
     * where it does behave differently.
     */
    FormControl.prototype.patchValue = function (value, options) {
        if (options === void 0) { options = {}; }
        this.setValue(value, options);
    };
    /**
     * Resets the form control. This means by default:
     *
     * * it is marked as `pristine`
     * * it is marked as `untouched`
     * * value is set to null
     *
     * You can also reset to a specific form state by passing through a standalone
     * value or a form state object that contains both a value and a disabled state
     * (these are the only two properties that cannot be calculated).
     *
     * Ex:
     *
     * ```ts
     * this.control.reset('Nancy');
     *
     * console.log(this.control.value);  // 'Nancy'
     * ```
     *
     * OR
     *
     * ```
     * this.control.reset({value: 'Nancy', disabled: true});
     *
     * console.log(this.control.value);  // 'Nancy'
     * console.log(this.control.status);  // 'DISABLED'
     * ```
     */
    FormControl.prototype.reset = function (formState, _a) {
        if (formState === void 0) { formState = null; }
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._applyFormState(formState);
        this.markAsPristine({ onlySelf: onlySelf });
        this.markAsUntouched({ onlySelf: onlySelf });
        this.setValue(this._value, { onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     * @internal
     */
    FormControl.prototype._updateValue = function () { };
    /**
     * @internal
     */
    FormControl.prototype._anyControls = function (condition) { return false; };
    /**
     * @internal
     */
    FormControl.prototype._allControlsDisabled = function () { return this.disabled; };
    /**
     * Register a listener for change events.
     */
    FormControl.prototype.registerOnChange = function (fn) { this._onChange.push(fn); };
    /**
     * @internal
     */
    FormControl.prototype._clearChangeFns = function () {
        this._onChange = [];
        this._onDisabledChange = [];
        this._onCollectionChange = function () { };
    };
    /**
     * Register a listener for disabled events.
     */
    FormControl.prototype.registerOnDisabledChange = function (fn) {
        this._onDisabledChange.push(fn);
    };
    /**
     * @internal
     */
    FormControl.prototype._forEachChild = function (cb) { };
    FormControl.prototype._applyFormState = function (formState) {
        if (this._isBoxedValue(formState)) {
            this._value = formState.value;
            formState.disabled ? this.disable({ onlySelf: true, emitEvent: false }) :
                this.enable({ onlySelf: true, emitEvent: false });
        }
        else {
            this._value = formState;
        }
    };
    return FormControl;
}(AbstractControl));
/**
 * @whatItDoes Tracks the value and validity state of a group of {@link FormControl}
 * instances.
 *
 * A `FormGroup` aggregates the values of each child {@link FormControl} into one object,
 * with each control name as the key.  It calculates its status by reducing the statuses
 * of its children. For example, if one of the controls in a group is invalid, the entire
 * group becomes invalid.
 *
 * `FormGroup` is one of the three fundamental building blocks used to define forms in Angular,
 * along with {@link FormControl} and {@link FormArray}.
 *
 * @howToUse
 *
 * When instantiating a {@link FormGroup}, pass in a collection of child controls as the first
 * argument. The key for each child will be the name under which it is registered.
 *
 * ### Example
 *
 * ```
 * const form = new FormGroup({
 *   first: new FormControl('Nancy', Validators.minLength(2)),
 *   last: new FormControl('Drew'),
 * });
 *
 * console.log(form.value);   // {first: 'Nancy', last; 'Drew'}
 * console.log(form.status);  // 'VALID'
 * ```
 *
 * You can also include group-level validators as the second arg, or group-level async
 * validators as the third arg. These come in handy when you want to perform validation
 * that considers the value of more than one child control.
 *
 * ### Example
 *
 * ```
 * const form = new FormGroup({
 *   password: new FormControl('', Validators.minLength(2)),
 *   passwordConfirm: new FormControl('', Validators.minLength(2)),
 * }, passwordMatchValidator);
 *
 *
 * function passwordMatchValidator(g: FormGroup) {
 *    return g.get('password').value === g.get('passwordConfirm').value
 *       ? null : {'mismatch': true};
 * }
 * ```
 *
 * * **npm package**: `@angular/forms`
 *
 * @stable
 */
var FormGroup = (function (_super) {
    __extends(FormGroup, _super);
    function FormGroup(controls, validator, asyncValidator) {
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        _super.call(this, validator, asyncValidator);
        this.controls = controls;
        this._initObservables();
        this._setUpControls();
        this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    }
    /**
     * Registers a control with the group's list of controls.
     *
     * This method does not update value or validity of the control, so for
     * most cases you'll want to use {@link FormGroup.addControl} instead.
     */
    FormGroup.prototype.registerControl = function (name, control) {
        if (this.controls[name])
            return this.controls[name];
        this.controls[name] = control;
        control.setParent(this);
        control._registerOnCollectionChange(this._onCollectionChange);
        return control;
    };
    /**
     * Add a control to this group.
     */
    FormGroup.prototype.addControl = function (name, control) {
        this.registerControl(name, control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Remove a control from this group.
     */
    FormGroup.prototype.removeControl = function (name) {
        if (this.controls[name])
            this.controls[name]._registerOnCollectionChange(function () { });
        delete (this.controls[name]);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Replace an existing control.
     */
    FormGroup.prototype.setControl = function (name, control) {
        if (this.controls[name])
            this.controls[name]._registerOnCollectionChange(function () { });
        delete (this.controls[name]);
        if (control)
            this.registerControl(name, control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Check whether there is an enabled control with the given name in the group.
     *
     * It will return false for disabled controls. If you'd like to check for
     * existence in the group only, use {@link AbstractControl.get} instead.
     */
    FormGroup.prototype.contains = function (controlName) {
        return this.controls.hasOwnProperty(controlName) && this.controls[controlName].enabled;
    };
    /**
     *  Sets the value of the {@link FormGroup}. It accepts an object that matches
     *  the structure of the group, with control names as keys.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.setValue({first: 'Nancy', last: 'Drew'});
     *  console.log(form.value);   // {first: 'Nancy', last: 'Drew'}
     *
     *  ```
     */
    FormGroup.prototype.setValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._checkAllValuesPresent(value);
        Object.keys(value).forEach(function (name) {
            _this._throwIfControlMissing(name);
            _this.controls[name].setValue(value[name], { onlySelf: true, emitEvent: emitEvent });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     *  Patches the value of the {@link FormGroup}. It accepts an object with control
     *  names as keys, and will do its best to match the values to the correct controls
     *  in the group.
     *
     *  It accepts both super-sets and sub-sets of the group without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.patchValue({first: 'Nancy'});
     *  console.log(form.value);   // {first: 'Nancy', last: null}
     *
     *  ```
     */
    FormGroup.prototype.patchValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        Object.keys(value).forEach(function (name) {
            if (_this.controls[name]) {
                _this.controls[name].patchValue(value[name], { onlySelf: true, emitEvent: emitEvent });
            }
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     * Resets the {@link FormGroup}. This means by default:
     *
     * * The group and all descendants are marked `pristine`
     * * The group and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in a map of states
     * that matches the structure of your form, with control names as keys. The state
     * can be a standalone value or a form state object with both a value and a disabled
     * status.
     *
     * ### Example
     *
     * ```ts
     * this.form.reset({first: 'name', last: 'last name'});
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * ```
     *
     * - OR -
     *
     * ```
     * this.form.reset({
     *   first: {value: 'name', disabled: true},
     *   last: 'last'
     * });
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * console.log(this.form.get('first').status);  // 'DISABLED'
     * ```
     */
    FormGroup.prototype.reset = function (value, _a) {
        if (value === void 0) { value = {}; }
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._forEachChild(function (control, name) {
            control.reset(value[name], { onlySelf: true, emitEvent: emitEvent });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
        this._updatePristine({ onlySelf: onlySelf });
        this._updateTouched({ onlySelf: onlySelf });
    };
    /**
     * The aggregate value of the {@link FormGroup}, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the group.
     */
    FormGroup.prototype.getRawValue = function () {
        return this._reduceChildren({}, function (acc, control, name) {
            acc[name] = control.value;
            return acc;
        });
    };
    /** @internal */
    FormGroup.prototype._throwIfControlMissing = function (name) {
        if (!Object.keys(this.controls).length) {
            throw new Error("\n        There are no form controls registered with this group yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
        }
        if (!this.controls[name]) {
            throw new Error("Cannot find form control with name: " + name + ".");
        }
    };
    /** @internal */
    FormGroup.prototype._forEachChild = function (cb) {
        var _this = this;
        Object.keys(this.controls).forEach(function (k) { return cb(_this.controls[k], k); });
    };
    /** @internal */
    FormGroup.prototype._setUpControls = function () {
        var _this = this;
        this._forEachChild(function (control) {
            control.setParent(_this);
            control._registerOnCollectionChange(_this._onCollectionChange);
        });
    };
    /** @internal */
    FormGroup.prototype._updateValue = function () { this._value = this._reduceValue(); };
    /** @internal */
    FormGroup.prototype._anyControls = function (condition) {
        var _this = this;
        var res = false;
        this._forEachChild(function (control, name) {
            res = res || (_this.contains(name) && condition(control));
        });
        return res;
    };
    /** @internal */
    FormGroup.prototype._reduceValue = function () {
        var _this = this;
        return this._reduceChildren({}, function (acc, control, name) {
            if (control.enabled || _this.disabled) {
                acc[name] = control.value;
            }
            return acc;
        });
    };
    /** @internal */
    FormGroup.prototype._reduceChildren = function (initValue, fn) {
        var res = initValue;
        this._forEachChild(function (control, name) { res = fn(res, control, name); });
        return res;
    };
    /** @internal */
    FormGroup.prototype._allControlsDisabled = function () {
        for (var _i = 0, _a = Object.keys(this.controls); _i < _a.length; _i++) {
            var controlName = _a[_i];
            if (this.controls[controlName].enabled) {
                return false;
            }
        }
        return Object.keys(this.controls).length > 0 || this.disabled;
    };
    /** @internal */
    FormGroup.prototype._checkAllValuesPresent = function (value) {
        this._forEachChild(function (control, name) {
            if (value[name] === undefined) {
                throw new Error("Must supply a value for form control with name: '" + name + "'.");
            }
        });
    };
    return FormGroup;
}(AbstractControl));
/**
 * @whatItDoes Tracks the value and validity state of an array of {@link FormControl}
 * instances.
 *
 * A `FormArray` aggregates the values of each child {@link FormControl} into an array.
 * It calculates its status by reducing the statuses of its children. For example, if one of
 * the controls in a `FormArray` is invalid, the entire array becomes invalid.
 *
 * `FormArray` is one of the three fundamental building blocks used to define forms in Angular,
 * along with {@link FormControl} and {@link FormGroup}.
 *
 * @howToUse
 *
 * When instantiating a {@link FormArray}, pass in an array of child controls as the first
 * argument.
 *
 * ### Example
 *
 * ```
 * const arr = new FormArray([
 *   new FormControl('Nancy', Validators.minLength(2)),
 *   new FormControl('Drew'),
 * ]);
 *
 * console.log(arr.value);   // ['Nancy', 'Drew']
 * console.log(arr.status);  // 'VALID'
 * ```
 *
 * You can also include array-level validators as the second arg, or array-level async
 * validators as the third arg. These come in handy when you want to perform validation
 * that considers the value of more than one child control.
 *
 * ### Adding or removing controls
 *
 * To change the controls in the array, use the `push`, `insert`, or `removeAt` methods
 * in `FormArray` itself. These methods ensure the controls are properly tracked in the
 * form's hierarchy. Do not modify the array of `AbstractControl`s used to instantiate
 * the `FormArray` directly, as that will result in strange and unexpected behavior such
 * as broken change detection.
 *
 * * **npm package**: `@angular/forms`
 *
 * @stable
 */
var FormArray = (function (_super) {
    __extends(FormArray, _super);
    function FormArray(controls, validator, asyncValidator) {
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        _super.call(this, validator, asyncValidator);
        this.controls = controls;
        this._initObservables();
        this._setUpControls();
        this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    }
    /**
     * Get the {@link AbstractControl} at the given `index` in the array.
     */
    FormArray.prototype.at = function (index) { return this.controls[index]; };
    /**
     * Insert a new {@link AbstractControl} at the end of the array.
     */
    FormArray.prototype.push = function (control) {
        this.controls.push(control);
        this._registerControl(control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Insert a new {@link AbstractControl} at the given `index` in the array.
     */
    FormArray.prototype.insert = function (index, control) {
        this.controls.splice(index, 0, control);
        this._registerControl(control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Remove the control at the given `index` in the array.
     */
    FormArray.prototype.removeAt = function (index) {
        if (this.controls[index])
            this.controls[index]._registerOnCollectionChange(function () { });
        this.controls.splice(index, 1);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Replace an existing control.
     */
    FormArray.prototype.setControl = function (index, control) {
        if (this.controls[index])
            this.controls[index]._registerOnCollectionChange(function () { });
        this.controls.splice(index, 1);
        if (control) {
            this.controls.splice(index, 0, control);
            this._registerControl(control);
        }
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    Object.defineProperty(FormArray.prototype, "length", {
        /**
         * Length of the control array.
         */
        get: function () { return this.controls.length; },
        enumerable: true,
        configurable: true
    });
    /**
     *  Sets the value of the {@link FormArray}. It accepts an array that matches
     *  the structure of the control.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.setValue(['Nancy', 'Drew']);
     *  console.log(arr.value);   // ['Nancy', 'Drew']
     *  ```
     */
    FormArray.prototype.setValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._checkAllValuesPresent(value);
        value.forEach(function (newValue, index) {
            _this._throwIfControlMissing(index);
            _this.at(index).setValue(newValue, { onlySelf: true, emitEvent: emitEvent });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     *  Patches the value of the {@link FormArray}. It accepts an array that matches the
     *  structure of the control, and will do its best to match the values to the correct
     *  controls in the group.
     *
     *  It accepts both super-sets and sub-sets of the array without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.patchValue(['Nancy']);
     *  console.log(arr.value);   // ['Nancy', null]
     *  ```
     */
    FormArray.prototype.patchValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        value.forEach(function (newValue, index) {
            if (_this.at(index)) {
                _this.at(index).patchValue(newValue, { onlySelf: true, emitEvent: emitEvent });
            }
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     * Resets the {@link FormArray}. This means by default:
     *
     * * The array and all descendants are marked `pristine`
     * * The array and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in an array of states
     * that matches the structure of the control. The state can be a standalone value
     * or a form state object with both a value and a disabled status.
     *
     * ### Example
     *
     * ```ts
     * this.arr.reset(['name', 'last name']);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * ```
     *
     * - OR -
     *
     * ```
     * this.arr.reset([
     *   {value: 'name', disabled: true},
     *   'last'
     * ]);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * console.log(this.arr.get(0).status);  // 'DISABLED'
     * ```
     */
    FormArray.prototype.reset = function (value, _a) {
        if (value === void 0) { value = []; }
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._forEachChild(function (control, index) {
            control.reset(value[index], { onlySelf: true, emitEvent: emitEvent });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
        this._updatePristine({ onlySelf: onlySelf });
        this._updateTouched({ onlySelf: onlySelf });
    };
    /**
     * The aggregate value of the array, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the array.
     */
    FormArray.prototype.getRawValue = function () { return this.controls.map(function (control) { return control.value; }); };
    /** @internal */
    FormArray.prototype._throwIfControlMissing = function (index) {
        if (!this.controls.length) {
            throw new Error("\n        There are no form controls registered with this array yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
        }
        if (!this.at(index)) {
            throw new Error("Cannot find form control at index " + index);
        }
    };
    /** @internal */
    FormArray.prototype._forEachChild = function (cb) {
        this.controls.forEach(function (control, index) { cb(control, index); });
    };
    /** @internal */
    FormArray.prototype._updateValue = function () {
        var _this = this;
        this._value = this.controls.filter(function (control) { return control.enabled || _this.disabled; })
            .map(function (control) { return control.value; });
    };
    /** @internal */
    FormArray.prototype._anyControls = function (condition) {
        return this.controls.some(function (control) { return control.enabled && condition(control); });
    };
    /** @internal */
    FormArray.prototype._setUpControls = function () {
        var _this = this;
        this._forEachChild(function (control) { return _this._registerControl(control); });
    };
    /** @internal */
    FormArray.prototype._checkAllValuesPresent = function (value) {
        this._forEachChild(function (control, i) {
            if (value[i] === undefined) {
                throw new Error("Must supply a value for form control at index: " + i + ".");
            }
        });
    };
    /** @internal */
    FormArray.prototype._allControlsDisabled = function () {
        for (var _i = 0, _a = this.controls; _i < _a.length; _i++) {
            var control = _a[_i];
            if (control.enabled)
                return false;
        }
        return this.controls.length > 0 || this.disabled;
    };
    FormArray.prototype._registerControl = function (control) {
        control.setParent(this);
        control._registerOnCollectionChange(this._onCollectionChange);
    };
    return FormArray;
}(AbstractControl));
//# sourceMappingURL=model.js.map

/***/ },
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: AlphabeticallistofproductsService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var AlphabeticallistofproductsData = (function () {
    function AlphabeticallistofproductsData() {
    }
    return AlphabeticallistofproductsData;
}());
exports.AlphabeticallistofproductsData = AlphabeticallistofproductsData;
var AlphabeticallistofproductsService = (function () {
    function AlphabeticallistofproductsService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    AlphabeticallistofproductsService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/Alphabeticallistofproducts';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    AlphabeticallistofproductsService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/Alphabeticallistofproducts?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    AlphabeticallistofproductsService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/Alphabeticallistofproducts?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    AlphabeticallistofproductsService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/Alphabeticallistofproducts/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    AlphabeticallistofproductsService.prototype.addAlphabeticallistofproductsData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/Alphabeticallistofproducts';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    AlphabeticallistofproductsService.prototype.updateAlphabeticallistofproductsData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/Alphabeticallistofproducts';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    AlphabeticallistofproductsService.prototype.deleteAlphabeticallistofproducts = function (id) {
        var url = this.baseUrl + "api/Alphabeticallistofproducts/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    AlphabeticallistofproductsService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    AlphabeticallistofproductsService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    AlphabeticallistofproductsService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    AlphabeticallistofproductsService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], AlphabeticallistofproductsService);
    return AlphabeticallistofproductsService;
    var _a;
}());
exports.AlphabeticallistofproductsService = AlphabeticallistofproductsService;
/*
    function mapAlphabeticallistofproducts(response:Response): AlphabeticallistofproductsData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toAlphabeticallistofproducts);
    }

    function toAlphabeticallistofproducts(r:any): AlphabeticallistofproductsData {
        let region = <AlphabeticallistofproductsData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: CategorySalesfor1997Service
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var CategorySalesfor1997Data = (function () {
    function CategorySalesfor1997Data() {
    }
    return CategorySalesfor1997Data;
}());
exports.CategorySalesfor1997Data = CategorySalesfor1997Data;
var CategorySalesfor1997Service = (function () {
    function CategorySalesfor1997Service(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    CategorySalesfor1997Service.prototype.getAll = function () {
        var url = this.baseUrl + 'api/CategorySalesfor1997';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CategorySalesfor1997Service.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/CategorySalesfor1997?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CategorySalesfor1997Service.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/CategorySalesfor1997?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CategorySalesfor1997Service.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/CategorySalesfor1997/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CategorySalesfor1997Service.prototype.addCategorySalesfor1997Data = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/CategorySalesfor1997';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    CategorySalesfor1997Service.prototype.updateCategorySalesfor1997Data = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/CategorySalesfor1997';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    CategorySalesfor1997Service.prototype.deleteCategorySalesfor1997 = function (id) {
        var url = this.baseUrl + "api/CategorySalesfor1997/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    CategorySalesfor1997Service.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    CategorySalesfor1997Service.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    CategorySalesfor1997Service.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    CategorySalesfor1997Service = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], CategorySalesfor1997Service);
    return CategorySalesfor1997Service;
    var _a;
}());
exports.CategorySalesfor1997Service = CategorySalesfor1997Service;
/*
    function mapCategorySalesfor1997(response:Response): CategorySalesfor1997Data[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toCategorySalesfor1997);
    }

    function toCategorySalesfor1997(r:any): CategorySalesfor1997Data {
        let region = <CategorySalesfor1997Data>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: CurrentProductListService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var CurrentProductListData = (function () {
    function CurrentProductListData() {
    }
    return CurrentProductListData;
}());
exports.CurrentProductListData = CurrentProductListData;
var CurrentProductListService = (function () {
    function CurrentProductListService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    CurrentProductListService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/CurrentProductList';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CurrentProductListService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/CurrentProductList?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CurrentProductListService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/CurrentProductList?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CurrentProductListService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/CurrentProductList/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CurrentProductListService.prototype.addCurrentProductListData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/CurrentProductList';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    CurrentProductListService.prototype.updateCurrentProductListData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/CurrentProductList';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    CurrentProductListService.prototype.deleteCurrentProductList = function (id) {
        var url = this.baseUrl + "api/CurrentProductList/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    CurrentProductListService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    CurrentProductListService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    CurrentProductListService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    CurrentProductListService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], CurrentProductListService);
    return CurrentProductListService;
    var _a;
}());
exports.CurrentProductListService = CurrentProductListService;
/*
    function mapCurrentProductList(response:Response): CurrentProductListData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toCurrentProductList);
    }

    function toCurrentProductList(r:any): CurrentProductListData {
        let region = <CurrentProductListData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: CustomerandSuppliersbyCityService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var CustomerandSuppliersbyCityData = (function () {
    function CustomerandSuppliersbyCityData() {
    }
    return CustomerandSuppliersbyCityData;
}());
exports.CustomerandSuppliersbyCityData = CustomerandSuppliersbyCityData;
var CustomerandSuppliersbyCityService = (function () {
    function CustomerandSuppliersbyCityService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    CustomerandSuppliersbyCityService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/CustomerandSuppliersbyCity';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CustomerandSuppliersbyCityService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/CustomerandSuppliersbyCity?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CustomerandSuppliersbyCityService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/CustomerandSuppliersbyCity?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CustomerandSuppliersbyCityService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/CustomerandSuppliersbyCity/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    CustomerandSuppliersbyCityService.prototype.addCustomerandSuppliersbyCityData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/CustomerandSuppliersbyCity';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    CustomerandSuppliersbyCityService.prototype.updateCustomerandSuppliersbyCityData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/CustomerandSuppliersbyCity';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    CustomerandSuppliersbyCityService.prototype.deleteCustomerandSuppliersbyCity = function (id) {
        var url = this.baseUrl + "api/CustomerandSuppliersbyCity/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    CustomerandSuppliersbyCityService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    CustomerandSuppliersbyCityService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    CustomerandSuppliersbyCityService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    CustomerandSuppliersbyCityService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], CustomerandSuppliersbyCityService);
    return CustomerandSuppliersbyCityService;
    var _a;
}());
exports.CustomerandSuppliersbyCityService = CustomerandSuppliersbyCityService;
/*
    function mapCustomerandSuppliersbyCity(response:Response): CustomerandSuppliersbyCityData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toCustomerandSuppliersbyCity);
    }

    function toCustomerandSuppliersbyCity(r:any): CustomerandSuppliersbyCityData {
        let region = <CustomerandSuppliersbyCityData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: InvoicesService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var InvoicesData = (function () {
    function InvoicesData() {
    }
    return InvoicesData;
}());
exports.InvoicesData = InvoicesData;
var InvoicesService = (function () {
    function InvoicesService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    InvoicesService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/Invoices';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    InvoicesService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/Invoices?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    InvoicesService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/Invoices?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    InvoicesService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/Invoices/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    InvoicesService.prototype.addInvoicesData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/Invoices';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    InvoicesService.prototype.updateInvoicesData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/Invoices';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    InvoicesService.prototype.deleteInvoices = function (id) {
        var url = this.baseUrl + "api/Invoices/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    InvoicesService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    InvoicesService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    InvoicesService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    InvoicesService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], InvoicesService);
    return InvoicesService;
    var _a;
}());
exports.InvoicesService = InvoicesService;
/*
    function mapInvoices(response:Response): InvoicesData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toInvoices);
    }

    function toInvoices(r:any): InvoicesData {
        let region = <InvoicesData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: OrderDetailsExtendedService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var OrderDetailsExtendedData = (function () {
    function OrderDetailsExtendedData() {
    }
    return OrderDetailsExtendedData;
}());
exports.OrderDetailsExtendedData = OrderDetailsExtendedData;
var OrderDetailsExtendedService = (function () {
    function OrderDetailsExtendedService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    OrderDetailsExtendedService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/OrderDetailsExtended';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    OrderDetailsExtendedService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/OrderDetailsExtended?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    OrderDetailsExtendedService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/OrderDetailsExtended?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    OrderDetailsExtendedService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/OrderDetailsExtended/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    OrderDetailsExtendedService.prototype.addOrderDetailsExtendedData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/OrderDetailsExtended';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    OrderDetailsExtendedService.prototype.updateOrderDetailsExtendedData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/OrderDetailsExtended';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    OrderDetailsExtendedService.prototype.deleteOrderDetailsExtended = function (id) {
        var url = this.baseUrl + "api/OrderDetailsExtended/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    OrderDetailsExtendedService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    OrderDetailsExtendedService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    OrderDetailsExtendedService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    OrderDetailsExtendedService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], OrderDetailsExtendedService);
    return OrderDetailsExtendedService;
    var _a;
}());
exports.OrderDetailsExtendedService = OrderDetailsExtendedService;
/*
    function mapOrderDetailsExtended(response:Response): OrderDetailsExtendedData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toOrderDetailsExtended);
    }

    function toOrderDetailsExtended(r:any): OrderDetailsExtendedData {
        let region = <OrderDetailsExtendedData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: OrderSubtotalsService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var OrderSubtotalsData = (function () {
    function OrderSubtotalsData() {
    }
    return OrderSubtotalsData;
}());
exports.OrderSubtotalsData = OrderSubtotalsData;
var OrderSubtotalsService = (function () {
    function OrderSubtotalsService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    OrderSubtotalsService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/OrderSubtotals';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    OrderSubtotalsService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/OrderSubtotals?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    OrderSubtotalsService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/OrderSubtotals?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    OrderSubtotalsService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/OrderSubtotals/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    OrderSubtotalsService.prototype.addOrderSubtotalsData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/OrderSubtotals';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    OrderSubtotalsService.prototype.updateOrderSubtotalsData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/OrderSubtotals';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    OrderSubtotalsService.prototype.deleteOrderSubtotals = function (id) {
        var url = this.baseUrl + "api/OrderSubtotals/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    OrderSubtotalsService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    OrderSubtotalsService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    OrderSubtotalsService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    OrderSubtotalsService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], OrderSubtotalsService);
    return OrderSubtotalsService;
    var _a;
}());
exports.OrderSubtotalsService = OrderSubtotalsService;
/*
    function mapOrderSubtotals(response:Response): OrderSubtotalsData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toOrderSubtotals);
    }

    function toOrderSubtotals(r:any): OrderSubtotalsData {
        let region = <OrderSubtotalsData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: OrdersQryService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var OrdersQryData = (function () {
    function OrdersQryData() {
    }
    return OrdersQryData;
}());
exports.OrdersQryData = OrdersQryData;
var OrdersQryService = (function () {
    function OrdersQryService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    OrdersQryService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/OrdersQry';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    OrdersQryService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/OrdersQry?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    OrdersQryService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/OrdersQry?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    OrdersQryService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/OrdersQry/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    OrdersQryService.prototype.addOrdersQryData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/OrdersQry';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    OrdersQryService.prototype.updateOrdersQryData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/OrdersQry';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    OrdersQryService.prototype.deleteOrdersQry = function (id) {
        var url = this.baseUrl + "api/OrdersQry/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    OrdersQryService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    OrdersQryService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    OrdersQryService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    OrdersQryService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], OrdersQryService);
    return OrdersQryService;
    var _a;
}());
exports.OrdersQryService = OrdersQryService;
/*
    function mapOrdersQry(response:Response): OrdersQryData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toOrdersQry);
    }

    function toOrdersQry(r:any): OrdersQryData {
        let region = <OrdersQryData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: ProductSalesfor1997Service
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var ProductSalesfor1997Data = (function () {
    function ProductSalesfor1997Data() {
    }
    return ProductSalesfor1997Data;
}());
exports.ProductSalesfor1997Data = ProductSalesfor1997Data;
var ProductSalesfor1997Service = (function () {
    function ProductSalesfor1997Service(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    ProductSalesfor1997Service.prototype.getAll = function () {
        var url = this.baseUrl + 'api/ProductSalesfor1997';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    ProductSalesfor1997Service.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/ProductSalesfor1997?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    ProductSalesfor1997Service.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/ProductSalesfor1997?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    ProductSalesfor1997Service.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/ProductSalesfor1997/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    ProductSalesfor1997Service.prototype.addProductSalesfor1997Data = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/ProductSalesfor1997';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    ProductSalesfor1997Service.prototype.updateProductSalesfor1997Data = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/ProductSalesfor1997';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    ProductSalesfor1997Service.prototype.deleteProductSalesfor1997 = function (id) {
        var url = this.baseUrl + "api/ProductSalesfor1997/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    ProductSalesfor1997Service.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    ProductSalesfor1997Service.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    ProductSalesfor1997Service.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    ProductSalesfor1997Service = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], ProductSalesfor1997Service);
    return ProductSalesfor1997Service;
    var _a;
}());
exports.ProductSalesfor1997Service = ProductSalesfor1997Service;
/*
    function mapProductSalesfor1997(response:Response): ProductSalesfor1997Data[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toProductSalesfor1997);
    }

    function toProductSalesfor1997(r:any): ProductSalesfor1997Data {
        let region = <ProductSalesfor1997Data>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: ProductsAboveAveragePriceService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var ProductsAboveAveragePriceData = (function () {
    function ProductsAboveAveragePriceData() {
    }
    return ProductsAboveAveragePriceData;
}());
exports.ProductsAboveAveragePriceData = ProductsAboveAveragePriceData;
var ProductsAboveAveragePriceService = (function () {
    function ProductsAboveAveragePriceService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    ProductsAboveAveragePriceService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/ProductsAboveAveragePrice';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    ProductsAboveAveragePriceService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/ProductsAboveAveragePrice?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    ProductsAboveAveragePriceService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/ProductsAboveAveragePrice?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    ProductsAboveAveragePriceService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/ProductsAboveAveragePrice/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    ProductsAboveAveragePriceService.prototype.addProductsAboveAveragePriceData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/ProductsAboveAveragePrice';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    ProductsAboveAveragePriceService.prototype.updateProductsAboveAveragePriceData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/ProductsAboveAveragePrice';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    ProductsAboveAveragePriceService.prototype.deleteProductsAboveAveragePrice = function (id) {
        var url = this.baseUrl + "api/ProductsAboveAveragePrice/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    ProductsAboveAveragePriceService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    ProductsAboveAveragePriceService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    ProductsAboveAveragePriceService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    ProductsAboveAveragePriceService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], ProductsAboveAveragePriceService);
    return ProductsAboveAveragePriceService;
    var _a;
}());
exports.ProductsAboveAveragePriceService = ProductsAboveAveragePriceService;
/*
    function mapProductsAboveAveragePrice(response:Response): ProductsAboveAveragePriceData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toProductsAboveAveragePrice);
    }

    function toProductsAboveAveragePrice(r:any): ProductsAboveAveragePriceData {
        let region = <ProductsAboveAveragePriceData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: ProductsbyCategoryService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var ProductsbyCategoryData = (function () {
    function ProductsbyCategoryData() {
    }
    return ProductsbyCategoryData;
}());
exports.ProductsbyCategoryData = ProductsbyCategoryData;
var ProductsbyCategoryService = (function () {
    function ProductsbyCategoryService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    ProductsbyCategoryService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/ProductsbyCategory';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    ProductsbyCategoryService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/ProductsbyCategory?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    ProductsbyCategoryService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/ProductsbyCategory?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    ProductsbyCategoryService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/ProductsbyCategory/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    ProductsbyCategoryService.prototype.addProductsbyCategoryData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/ProductsbyCategory';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    ProductsbyCategoryService.prototype.updateProductsbyCategoryData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/ProductsbyCategory';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    ProductsbyCategoryService.prototype.deleteProductsbyCategory = function (id) {
        var url = this.baseUrl + "api/ProductsbyCategory/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    ProductsbyCategoryService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    ProductsbyCategoryService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    ProductsbyCategoryService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    ProductsbyCategoryService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], ProductsbyCategoryService);
    return ProductsbyCategoryService;
    var _a;
}());
exports.ProductsbyCategoryService = ProductsbyCategoryService;
/*
    function mapProductsbyCategory(response:Response): ProductsbyCategoryData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toProductsbyCategory);
    }

    function toProductsbyCategory(r:any): ProductsbyCategoryData {
        let region = <ProductsbyCategoryData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: QuarterlyOrdersService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var QuarterlyOrdersData = (function () {
    function QuarterlyOrdersData() {
    }
    return QuarterlyOrdersData;
}());
exports.QuarterlyOrdersData = QuarterlyOrdersData;
var QuarterlyOrdersService = (function () {
    function QuarterlyOrdersService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    QuarterlyOrdersService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/QuarterlyOrders';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    QuarterlyOrdersService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/QuarterlyOrders?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    QuarterlyOrdersService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/QuarterlyOrders?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    QuarterlyOrdersService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/QuarterlyOrders/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    QuarterlyOrdersService.prototype.addQuarterlyOrdersData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/QuarterlyOrders';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    QuarterlyOrdersService.prototype.updateQuarterlyOrdersData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/QuarterlyOrders';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    QuarterlyOrdersService.prototype.deleteQuarterlyOrders = function (id) {
        var url = this.baseUrl + "api/QuarterlyOrders/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    QuarterlyOrdersService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    QuarterlyOrdersService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    QuarterlyOrdersService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    QuarterlyOrdersService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], QuarterlyOrdersService);
    return QuarterlyOrdersService;
    var _a;
}());
exports.QuarterlyOrdersService = QuarterlyOrdersService;
/*
    function mapQuarterlyOrders(response:Response): QuarterlyOrdersData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toQuarterlyOrders);
    }

    function toQuarterlyOrders(r:any): QuarterlyOrdersData {
        let region = <QuarterlyOrdersData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: SalesTotalsbyAmountService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var SalesTotalsbyAmountData = (function () {
    function SalesTotalsbyAmountData() {
    }
    return SalesTotalsbyAmountData;
}());
exports.SalesTotalsbyAmountData = SalesTotalsbyAmountData;
var SalesTotalsbyAmountService = (function () {
    function SalesTotalsbyAmountService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    SalesTotalsbyAmountService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/SalesTotalsbyAmount';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    SalesTotalsbyAmountService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/SalesTotalsbyAmount?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    SalesTotalsbyAmountService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/SalesTotalsbyAmount?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    SalesTotalsbyAmountService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/SalesTotalsbyAmount/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    SalesTotalsbyAmountService.prototype.addSalesTotalsbyAmountData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/SalesTotalsbyAmount';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    SalesTotalsbyAmountService.prototype.updateSalesTotalsbyAmountData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/SalesTotalsbyAmount';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    SalesTotalsbyAmountService.prototype.deleteSalesTotalsbyAmount = function (id) {
        var url = this.baseUrl + "api/SalesTotalsbyAmount/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    SalesTotalsbyAmountService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    SalesTotalsbyAmountService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    SalesTotalsbyAmountService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    SalesTotalsbyAmountService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], SalesTotalsbyAmountService);
    return SalesTotalsbyAmountService;
    var _a;
}());
exports.SalesTotalsbyAmountService = SalesTotalsbyAmountService;
/*
    function mapSalesTotalsbyAmount(response:Response): SalesTotalsbyAmountData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toSalesTotalsbyAmount);
    }

    function toSalesTotalsbyAmount(r:any): SalesTotalsbyAmountData {
        let region = <SalesTotalsbyAmountData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: SalesbyCategoryService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var SalesbyCategoryData = (function () {
    function SalesbyCategoryData() {
    }
    return SalesbyCategoryData;
}());
exports.SalesbyCategoryData = SalesbyCategoryData;
var SalesbyCategoryService = (function () {
    function SalesbyCategoryService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    SalesbyCategoryService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/SalesbyCategory';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    SalesbyCategoryService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/SalesbyCategory?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    SalesbyCategoryService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/SalesbyCategory?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    SalesbyCategoryService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/SalesbyCategory/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    SalesbyCategoryService.prototype.addSalesbyCategoryData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/SalesbyCategory';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    SalesbyCategoryService.prototype.updateSalesbyCategoryData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/SalesbyCategory';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    SalesbyCategoryService.prototype.deleteSalesbyCategory = function (id) {
        var url = this.baseUrl + "api/SalesbyCategory/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    SalesbyCategoryService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    SalesbyCategoryService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    SalesbyCategoryService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    SalesbyCategoryService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], SalesbyCategoryService);
    return SalesbyCategoryService;
    var _a;
}());
exports.SalesbyCategoryService = SalesbyCategoryService;
/*
    function mapSalesbyCategory(response:Response): SalesbyCategoryData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toSalesbyCategory);
    }

    function toSalesbyCategory(r:any): SalesbyCategoryData {
        let region = <SalesbyCategoryData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: SummaryofSalesbyQuarterService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var SummaryofSalesbyQuarterData = (function () {
    function SummaryofSalesbyQuarterData() {
    }
    return SummaryofSalesbyQuarterData;
}());
exports.SummaryofSalesbyQuarterData = SummaryofSalesbyQuarterData;
var SummaryofSalesbyQuarterService = (function () {
    function SummaryofSalesbyQuarterService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    SummaryofSalesbyQuarterService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/SummaryofSalesbyQuarter';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    SummaryofSalesbyQuarterService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/SummaryofSalesbyQuarter?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    SummaryofSalesbyQuarterService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/SummaryofSalesbyQuarter?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    SummaryofSalesbyQuarterService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/SummaryofSalesbyQuarter/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    SummaryofSalesbyQuarterService.prototype.addSummaryofSalesbyQuarterData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/SummaryofSalesbyQuarter';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    SummaryofSalesbyQuarterService.prototype.updateSummaryofSalesbyQuarterData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/SummaryofSalesbyQuarter';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    SummaryofSalesbyQuarterService.prototype.deleteSummaryofSalesbyQuarter = function (id) {
        var url = this.baseUrl + "api/SummaryofSalesbyQuarter/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    SummaryofSalesbyQuarterService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    SummaryofSalesbyQuarterService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    SummaryofSalesbyQuarterService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    SummaryofSalesbyQuarterService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], SummaryofSalesbyQuarterService);
    return SummaryofSalesbyQuarterService;
    var _a;
}());
exports.SummaryofSalesbyQuarterService = SummaryofSalesbyQuarterService;
/*
    function mapSummaryofSalesbyQuarter(response:Response): SummaryofSalesbyQuarterData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toSummaryofSalesbyQuarter);
    }

    function toSummaryofSalesbyQuarter(r:any): SummaryofSalesbyQuarterData {
        let region = <SummaryofSalesbyQuarterData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Service Name	: SummaryofSalesbyYearService
 * Purpose		: This service contains methods to perform Data Access Layer operations using Http/Web API calls
 * Instructions	: You may modify code inside code generation template and re-generate the code.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(15);
var Observable_1 = __webpack_require__(1);
// import 'rxjs/add/operator/catch';
var myGlobals = __webpack_require__(7);
var SummaryofSalesbyYearData = (function () {
    function SummaryofSalesbyYearData() {
    }
    return SummaryofSalesbyYearData;
}());
exports.SummaryofSalesbyYearData = SummaryofSalesbyYearData;
var SummaryofSalesbyYearService = (function () {
    function SummaryofSalesbyYearService(_http) {
        this._http = _http;
        this.baseUrl = myGlobals.baseApiUrl;
    }
    SummaryofSalesbyYearService.prototype.getAll = function () {
        var url = this.baseUrl + 'api/SummaryofSalesbyYear';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    SummaryofSalesbyYearService.prototype.getAllBy = function (filterExpression) {
        var url = this.baseUrl + 'api/SummaryofSalesbyYear?filterExpression=${filterExpression}';
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    SummaryofSalesbyYearService.prototype.getAllByPaging = function (filterExpression, sortExpression, pageIndex, pageSize) {
        filterExpression = encodeURIComponent(filterExpression);
        var url = this.baseUrl + ("api/SummaryofSalesbyYear?filterExpression=" + filterExpression + "&sortExpression=" + sortExpression + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    SummaryofSalesbyYearService.prototype.getByID = function (id) {
        var url = this.baseUrl + "api/SummaryofSalesbyYear/" + id;
        return this._http
            .get(url, { headers: this.getHeaders() })
            .map(function (response) { return response.json(); })
            .do(function (data) { return console.log(data); })
            .catch(this.handleError);
    };
    SummaryofSalesbyYearService.prototype.addSummaryofSalesbyYearData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'post' });
        var url = this.baseUrl + 'api/SummaryofSalesbyYear';
        return this._http.post(url, bodyString, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    SummaryofSalesbyYearService.prototype.updateSummaryofSalesbyYearData = function (body) {
        var bodyString = JSON.stringify(body); // Stringify payload
        var options = new http_1.RequestOptions({ headers: this.getHeaders(), method: 'put' });
        var url = this.baseUrl + 'api/SummaryofSalesbyYear';
        return this._http.put(url, bodyString, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    SummaryofSalesbyYearService.prototype.deleteSummaryofSalesbyYear = function (id) {
        var url = this.baseUrl + "api/SummaryofSalesbyYear/" + id;
        return this._http.delete(url)
            .map(function (res) { return res; })
            .catch(this.handleError);
    };
    SummaryofSalesbyYearService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');
        // headers.append('Access-Control-Allow-Methods', 'GET');
        // headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    };
    SummaryofSalesbyYearService.prototype.extractData = function (res) {
        var body;
        // check if empty, before call json
        if (res.text()) {
            body = res.json();
        }
        return body || {};
    };
    SummaryofSalesbyYearService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    SummaryofSalesbyYearService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], SummaryofSalesbyYearService);
    return SummaryofSalesbyYearService;
    var _a;
}());
exports.SummaryofSalesbyYearService = SummaryofSalesbyYearService;
/*
    function mapSummaryofSalesbyYear(response:Response): SummaryofSalesbyYearData[] {
        // The response of the API has a results
        // property with the actual results
        return response.json().map(toSummaryofSalesbyYear);
    }

    function toSummaryofSalesbyYear(r:any): SummaryofSalesbyYearData {
        let region = <SummaryofSalesbyYearData>({
            RegionID: r.RegionID,
            RegionDescription: r.RegionDescription
        });
        console.log('Parsed region:', region);
        return region;
    }
*/


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var collapse_directive_1 = __webpack_require__(601);
var CollapseModule = (function () {
    function CollapseModule() {
    }
    CollapseModule.decorators = [
        { type: core_1.NgModule, args: [{
                    declarations: [collapse_directive_1.CollapseDirective],
                    exports: [collapse_directive_1.CollapseDirective]
                },] },
    ];
    /** @nocollapse */
    CollapseModule.ctorParameters = [];
    return CollapseModule;
}());
exports.CollapseModule = CollapseModule;


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var dropdown_service_1 = __webpack_require__(610);
var DropdownDirective = (function () {
    function DropdownDirective(el, ref) {
        this.onToggle = new core_1.EventEmitter(false);
        this.isOpenChange = new core_1.EventEmitter(false);
        this.addClass = true;
        // @Query('dropdownMenu', {descendants: false})
        // dropdownMenuList:QueryList<ElementRef>) {
        this.el = el;
        this._changeDetector = ref;
        // todo: bind to route change event
    }
    Object.defineProperty(DropdownDirective.prototype, "isOpen", {
        get: function () {
            return this._isOpen;
        },
        set: function (value) {
            this._isOpen = !!value;
            // todo: implement after porting position
            // if (this.appendToBody && this.menuEl) {
            //
            // }
            // todo: $animate open<->close transitions, as soon as ng2Animate will be
            // ready
            if (this.isOpen) {
                this.focusToggleElement();
                dropdown_service_1.dropdownService.open(this);
            }
            else {
                dropdown_service_1.dropdownService.close(this);
                this.selectedOption = void 0;
            }
            this.onToggle.emit(this.isOpen);
            this.isOpenChange.emit(this.isOpen);
            this._changeDetector.markForCheck();
            // todo: implement call to setIsOpen if set and function
        },
        enumerable: true,
        configurable: true
    });
    DropdownDirective.prototype.ngOnInit = function () {
        this.autoClose = this.autoClose || dropdown_service_1.NONINPUT;
        if (this.isOpen) {
        }
    };
    DropdownDirective.prototype.ngOnDestroy = function () {
        if (this.appendToBody && this.menuEl) {
            this.menuEl.nativeElement.remove();
        }
    };
    Object.defineProperty(DropdownDirective.prototype, "dropDownMenu", {
        set: function (dropdownMenu) {
            // init drop down menu
            this.menuEl = dropdownMenu.el;
            if (this.appendToBody) {
                window.document.body.appendChild(this.menuEl.nativeElement);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DropdownDirective.prototype, "dropDownToggle", {
        set: function (dropdownToggle) {
            // init toggle element
            this.toggleEl = dropdownToggle.el;
        },
        enumerable: true,
        configurable: true
    });
    DropdownDirective.prototype.toggle = function (open) {
        return this.isOpen = arguments.length ? !!open : !this.isOpen;
    };
    DropdownDirective.prototype.focusDropdownEntry = function (keyCode) {
        // If append to body is used.
        var hostEl = this.menuEl ?
            this.menuEl.nativeElement :
            this.el.nativeElement.getElementsByTagName('ul')[0];
        if (!hostEl) {
            // todo: throw exception?
            return;
        }
        var elems = hostEl.getElementsByTagName('a');
        if (!elems || !elems.length) {
            // todo: throw exception?
            return;
        }
        // todo: use parseInt to detect isNumber?
        // todo: or implement selectedOption as a get\set pair with parseInt on set
        switch (keyCode) {
            case (40):
                if (typeof this.selectedOption !== 'number') {
                    this.selectedOption = 0;
                    break;
                }
                if (this.selectedOption === elems.length - 1) {
                    break;
                }
                this.selectedOption++;
                break;
            case (38):
                if (typeof this.selectedOption !== 'number') {
                    return;
                }
                if (this.selectedOption === 0) {
                    // todo: return?
                    break;
                }
                this.selectedOption--;
                break;
            default:
                break;
        }
        elems[this.selectedOption].focus();
    };
    DropdownDirective.prototype.focusToggleElement = function () {
        if (this.toggleEl) {
            this.toggleEl.nativeElement.focus();
        }
    };
    DropdownDirective.decorators = [
        { type: core_1.Directive, args: [{
                    selector: '[dropdown]',
                    exportAs: 'bs-dropdown'
                },] },
    ];
    /** @nocollapse */
    DropdownDirective.ctorParameters = [
        { type: core_1.ElementRef, },
        { type: core_1.ChangeDetectorRef, },
    ];
    DropdownDirective.propDecorators = {
        'isOpen': [{ type: core_1.HostBinding, args: ['class.open',] }, { type: core_1.Input },],
        'autoClose': [{ type: core_1.Input },],
        'keyboardNav': [{ type: core_1.Input },],
        'appendToBody': [{ type: core_1.Input },],
        'onToggle': [{ type: core_1.Output },],
        'isOpenChange': [{ type: core_1.Output },],
        'addClass': [{ type: core_1.HostBinding, args: ['class.dropdown',] },],
    };
    return DropdownDirective;
}());
exports.DropdownDirective = DropdownDirective;


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var ToastOptions = (function () {
    function ToastOptions(options) {
        this.newestOnTop = false;
        this.animate = 'fade';
        this.enableHTML = false;
        this.showCloseButton = false;
        Object.assign(this, options);
    }
    ToastOptions.decorators = [
        { type: core_1.Injectable },
    ];
    /** @nocollapse */
    ToastOptions.ctorParameters = [
        { type: Object, },
    ];
    return ToastOptions;
}());
exports.ToastOptions = ToastOptions;
//# sourceMappingURL=toast-options.js.map

/***/ },
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return AbstractControlDirective; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Base class for control directives.
 *
 * Only used internally in the forms module.
 *
 * @stable
 */
var AbstractControlDirective = (function () {
    function AbstractControlDirective() {
    }
    Object.defineProperty(AbstractControlDirective.prototype, "control", {
        get: function () { throw new Error('unimplemented'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "value", {
        get: function () { return this.control ? this.control.value : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "valid", {
        get: function () { return this.control ? this.control.valid : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "invalid", {
        get: function () { return this.control ? this.control.invalid : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "pending", {
        get: function () { return this.control ? this.control.pending : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "errors", {
        get: function () { return this.control ? this.control.errors : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "pristine", {
        get: function () { return this.control ? this.control.pristine : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "dirty", {
        get: function () { return this.control ? this.control.dirty : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "touched", {
        get: function () { return this.control ? this.control.touched : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "untouched", {
        get: function () { return this.control ? this.control.untouched : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "disabled", {
        get: function () { return this.control ? this.control.disabled : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "enabled", {
        get: function () { return this.control ? this.control.enabled : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "statusChanges", {
        get: function () { return this.control ? this.control.statusChanges : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "valueChanges", {
        get: function () { return this.control ? this.control.valueChanges : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "path", {
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    AbstractControlDirective.prototype.reset = function (value) {
        if (value === void 0) { value = undefined; }
        if (this.control)
            this.control.reset(value);
    };
    AbstractControlDirective.prototype.hasError = function (errorCode, path) {
        if (path === void 0) { path = null; }
        return this.control ? this.control.hasError(errorCode, path) : false;
    };
    AbstractControlDirective.prototype.getError = function (errorCode, path) {
        if (path === void 0) { path = null; }
        return this.control ? this.control.getError(errorCode, path) : null;
    };
    return AbstractControlDirective;
}());
//# sourceMappingURL=abstract_control_directive.js.map

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__control_container__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ng_control__ = __webpack_require__(66);
/* unused harmony export AbstractControlStatus */
/* unused harmony export ngControlStatusHost */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NgControlStatus; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return NgControlStatusGroup; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};



var AbstractControlStatus = (function () {
    function AbstractControlStatus(cd) {
        this._cd = cd;
    }
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassUntouched", {
        get: function () { return this._cd.control ? this._cd.control.untouched : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassTouched", {
        get: function () { return this._cd.control ? this._cd.control.touched : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassPristine", {
        get: function () { return this._cd.control ? this._cd.control.pristine : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassDirty", {
        get: function () { return this._cd.control ? this._cd.control.dirty : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassValid", {
        get: function () { return this._cd.control ? this._cd.control.valid : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassInvalid", {
        get: function () { return this._cd.control ? this._cd.control.invalid : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassPending", {
        get: function () { return this._cd.control ? this._cd.control.pending : false; },
        enumerable: true,
        configurable: true
    });
    return AbstractControlStatus;
}());
var ngControlStatusHost = {
    '[class.ng-untouched]': 'ngClassUntouched',
    '[class.ng-touched]': 'ngClassTouched',
    '[class.ng-pristine]': 'ngClassPristine',
    '[class.ng-dirty]': 'ngClassDirty',
    '[class.ng-valid]': 'ngClassValid',
    '[class.ng-invalid]': 'ngClassInvalid',
    '[class.ng-pending]': 'ngClassPending',
};
/**
 * Directive automatically applied to Angular form controls that sets CSS classes
 * based on control status (valid/invalid/dirty/etc).
 *
 * @stable
 */
var NgControlStatus = (function (_super) {
    __extends(NgControlStatus, _super);
    function NgControlStatus(cd) {
        _super.call(this, cd);
    }
    NgControlStatus.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formControlName],[ngModel],[formControl]', host: ngControlStatusHost },] },
    ];
    /** @nocollapse */
    NgControlStatus.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_2__ng_control__["a" /* NgControl */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] },] },
    ];
    return NgControlStatus;
}(AbstractControlStatus));
/**
 * Directive automatically applied to Angular form groups that sets CSS classes
 * based on control status (valid/invalid/dirty/etc).
 *
 * @stable
 */
var NgControlStatusGroup = (function (_super) {
    __extends(NgControlStatusGroup, _super);
    function NgControlStatusGroup(cd) {
        _super.call(this, cd);
    }
    NgControlStatusGroup.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]',
                    host: ngControlStatusHost
                },] },
    ];
    /** @nocollapse */
    NgControlStatusGroup.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_1__control_container__["a" /* ControlContainer */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] },] },
    ];
    return NgControlStatusGroup;
}(AbstractControlStatus));
//# sourceMappingURL=ng_control_status.js.map

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_async__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validators__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__abstract_form_group_directive__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__control_container__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__control_value_accessor__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ng_control__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ng_form__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ng_model_group__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__template_driven_errors__ = __webpack_require__(336);
/* unused harmony export formControlBinding */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NgModel; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};












var formControlBinding = {
    provide: __WEBPACK_IMPORTED_MODULE_7__ng_control__["a" /* NgControl */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgModel; })
};
/**
 * `ngModel` forces an additional change detection run when its inputs change:
 * E.g.:
 * ```
 * <div>{{myModel.valid}}</div>
 * <input [(ngModel)]="myValue" #myModel="ngModel">
 * ```
 * I.e. `ngModel` can export itself on the element and then be used in the template.
 * Normally, this would result in expressions before the `input` that use the exported directive
 * to have and old value as they have been
 * dirty checked before. As this is a very common case for `ngModel`, we added this second change
 * detection run.
 *
 * Notes:
 * - this is just one extra run no matter how many `ngModel` have been changed.
 * - this is a general problem when using `exportAs` for directives!
 */
var resolvedPromise = Promise.resolve(null);
/**
 * @whatItDoes Creates a {@link FormControl} instance from a domain model and binds it
 * to a form control element.
 *
 * The {@link FormControl} instance will track the value, user interaction, and
 * validation status of the control and keep the view synced with the model. If used
 * within a parent form, the directive will also register itself with the form as a child
 * control.
 *
 * @howToUse
 *
 * This directive can be used by itself or as part of a larger form. All you need is the
 * `ngModel` selector to activate it.
 *
 * It accepts a domain model as an optional {@link @Input}. If you have a one-way binding
 * to `ngModel` with `[]` syntax, changing the value of the domain model in the component
 * class will set the value in the view. If you have a two-way binding with `[()]` syntax
 * (also known as 'banana-box syntax'), the value in the UI will always be synced back to
 * the domain model in your class as well.
 *
 * If you wish to inspect the properties of the associated {@link FormControl} (like
 * validity state), you can also export the directive into a local template variable using
 * `ngModel` as the key (ex: `#myVar="ngModel"`). You can then access the control using the
 * directive's `control` property, but most properties you'll need (like `valid` and `dirty`)
 * will fall through to the control anyway, so you can access them directly. You can see a
 * full list of properties directly available in {@link AbstractControlDirective}.
 *
 * The following is an example of a simple standalone control using `ngModel`:
 *
 * {@example forms/ts/simpleNgModel/simple_ng_model_example.ts region='Component'}
 *
 * When using the `ngModel` within `<form>` tags, you'll also need to supply a `name` attribute
 * so that the control can be registered with the parent form under that name.
 *
 * It's worth noting that in the context of a parent form, you often can skip one-way or
 * two-way binding because the parent form will sync the value for you. You can access
 * its properties by exporting it into a local template variable using `ngForm` (ex:
 * `#f="ngForm"`). Then you can pass it where it needs to go on submit.
 *
 * If you do need to populate initial values into your form, using a one-way binding for
 * `ngModel` tends to be sufficient as long as you use the exported form's value rather
 * than the domain model's value on submit.
 *
 * Take a look at an example of using `ngModel` within a form:
 *
 * {@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
 *
 * To see `ngModel` examples with different form control types, see:
 *
 * * Radio buttons: {@link RadioControlValueAccessor}
 * * Selects: {@link SelectControlValueAccessor}
 *
 * **npm package**: `@angular/forms`
 *
 * **NgModule**: `FormsModule`
 *
 *  @stable
 */
var NgModel = (function (_super) {
    __extends(NgModel, _super);
    function NgModel(parent, validators, asyncValidators, valueAccessors) {
        _super.call(this);
        /** @internal */
        this._control = new __WEBPACK_IMPORTED_MODULE_2__model__["b" /* FormControl */]();
        /** @internal */
        this._registered = false;
        this.update = new __WEBPACK_IMPORTED_MODULE_1__facade_async__["a" /* EventEmitter */]();
        this._parent = parent;
        this._rawValidators = validators || [];
        this._rawAsyncValidators = asyncValidators || [];
        this.valueAccessor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["f" /* selectValueAccessor */])(this, valueAccessors);
    }
    NgModel.prototype.ngOnChanges = function (changes) {
        this._checkForErrors();
        if (!this._registered)
            this._setUpControl();
        if ('isDisabled' in changes) {
            this._updateDisabled(changes);
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["g" /* isPropertyUpdated */])(changes, this.viewModel)) {
            this._updateValue(this.model);
            this.viewModel = this.model;
        }
    };
    NgModel.prototype.ngOnDestroy = function () { this.formDirective && this.formDirective.removeControl(this); };
    Object.defineProperty(NgModel.prototype, "control", {
        get: function () { return this._control; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "path", {
        get: function () {
            return this._parent ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["a" /* controlPath */])(this.name, this._parent) : [this.name];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "formDirective", {
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "validator", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["b" /* composeValidators */])(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "asyncValidator", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["c" /* composeAsyncValidators */])(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    NgModel.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    NgModel.prototype._setUpControl = function () {
        this._isStandalone() ? this._setUpStandalone() :
            this.formDirective.addControl(this);
        this._registered = true;
    };
    NgModel.prototype._isStandalone = function () {
        return !this._parent || (this.options && this.options.standalone);
    };
    NgModel.prototype._setUpStandalone = function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["d" /* setUpControl */])(this._control, this);
        this._control.updateValueAndValidity({ emitEvent: false });
    };
    NgModel.prototype._checkForErrors = function () {
        if (!this._isStandalone()) {
            this._checkParentType();
        }
        this._checkName();
    };
    NgModel.prototype._checkParentType = function () {
        if (!(this._parent instanceof __WEBPACK_IMPORTED_MODULE_9__ng_model_group__["a" /* NgModelGroup */]) &&
            this._parent instanceof __WEBPACK_IMPORTED_MODULE_4__abstract_form_group_directive__["a" /* AbstractFormGroupDirective */]) {
            __WEBPACK_IMPORTED_MODULE_11__template_driven_errors__["a" /* TemplateDrivenErrors */].formGroupNameException();
        }
        else if (!(this._parent instanceof __WEBPACK_IMPORTED_MODULE_9__ng_model_group__["a" /* NgModelGroup */]) && !(this._parent instanceof __WEBPACK_IMPORTED_MODULE_8__ng_form__["a" /* NgForm */])) {
            __WEBPACK_IMPORTED_MODULE_11__template_driven_errors__["a" /* TemplateDrivenErrors */].modelParentException();
        }
    };
    NgModel.prototype._checkName = function () {
        if (this.options && this.options.name)
            this.name = this.options.name;
        if (!this._isStandalone() && !this.name) {
            __WEBPACK_IMPORTED_MODULE_11__template_driven_errors__["a" /* TemplateDrivenErrors */].missingNameException();
        }
    };
    NgModel.prototype._updateValue = function (value) {
        var _this = this;
        resolvedPromise.then(function () { _this.control.setValue(value, { emitViewToModelChange: false }); });
    };
    NgModel.prototype._updateDisabled = function (changes) {
        var _this = this;
        var disabledValue = changes['isDisabled'].currentValue;
        var isDisabled = disabledValue === '' || (disabledValue && disabledValue !== 'false');
        resolvedPromise.then(function () {
            if (isDisabled && !_this.control.disabled) {
                _this.control.disable();
            }
            else if (!isDisabled && _this.control.disabled) {
                _this.control.enable();
            }
        });
    };
    NgModel.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[ngModel]:not([formControlName]):not([formControl])',
                    providers: [formControlBinding],
                    exportAs: 'ngModel'
                },] },
    ];
    /** @nocollapse */
    NgModel.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_5__control_container__["a" /* ControlContainer */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_6__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],] },] },
    ];
    NgModel.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'isDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['disabled',] },],
        'model': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModel',] },],
        'options': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModelOptions',] },],
        'update': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['ngModelChange',] },],
    };
    return NgModel;
}(__WEBPACK_IMPORTED_MODULE_7__ng_control__["a" /* NgControl */]));
//# sourceMappingURL=ng_model.js.map

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__ = __webpack_require__(34);
/* unused harmony export NUMBER_VALUE_ACCESSOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NumberValueAccessor; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var NUMBER_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NumberValueAccessor; }),
    multi: true
};
/**
 * The accessor for writing a number value and listening to changes that is used by the
 * {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName} directives.
 *
 *  ### Example
 *  ```
 *  <input type="number" [(ngModel)]="age">
 *  ```
 */
var NumberValueAccessor = (function () {
    function NumberValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    NumberValueAccessor.prototype.writeValue = function (value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        var normalizedValue = value == null ? '' : value;
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', normalizedValue);
    };
    NumberValueAccessor.prototype.registerOnChange = function (fn) {
        this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
    };
    NumberValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    NumberValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    NumberValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]',
                    host: {
                        '(change)': 'onChange($event.target.value)',
                        '(input)': 'onChange($event.target.value)',
                        '(blur)': 'onTouched()'
                    },
                    providers: [NUMBER_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    NumberValueAccessor.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ];
    return NumberValueAccessor;
}());
//# sourceMappingURL=number_value_accessor.js.map

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__ = __webpack_require__(34);
/* unused harmony export RANGE_VALUE_ACCESSOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return RangeValueAccessor; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var RANGE_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return RangeValueAccessor; }),
    multi: true
};
/**
 * The accessor for writing a range value and listening to changes that is used by the
 * {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName} directives.
 *
 *  ### Example
 *  ```
 *  <input type="range" [(ngModel)]="age" >
 *  ```
 */
var RangeValueAccessor = (function () {
    function RangeValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    RangeValueAccessor.prototype.writeValue = function (value) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', parseFloat(value));
    };
    RangeValueAccessor.prototype.registerOnChange = function (fn) {
        this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
    };
    RangeValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    RangeValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    RangeValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'input[type=range][formControlName],input[type=range][formControl],input[type=range][ngModel]',
                    host: {
                        '(change)': 'onChange($event.target.value)',
                        '(input)': 'onChange($event.target.value)',
                        '(blur)': 'onTouched()'
                    },
                    providers: [RANGE_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    RangeValueAccessor.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ];
    return RangeValueAccessor;
}());
//# sourceMappingURL=range_value_accessor.js.map

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_async__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validators__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__control_value_accessor__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ng_control__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reactive_errors__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared__ = __webpack_require__(58);
/* unused harmony export formControlBinding */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormControlDirective; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};







var formControlBinding = {
    provide: __WEBPACK_IMPORTED_MODULE_4__ng_control__["a" /* NgControl */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormControlDirective; })
};
/**
 * @whatItDoes Syncs a standalone {@link FormControl} instance to a form control element.
 *
 * In other words, this directive ensures that any values written to the {@link FormControl}
 * instance programmatically will be written to the DOM element (model -> view). Conversely,
 * any values written to the DOM element through user input will be reflected in the
 * {@link FormControl} instance (view -> model).
 *
 * @howToUse
 *
 * Use this directive if you'd like to create and manage a {@link FormControl} instance directly.
 * Simply create a {@link FormControl}, save it to your component class, and pass it into the
 * {@link FormControlDirective}.
 *
 * This directive is designed to be used as a standalone control.  Unlike {@link FormControlName},
 * it does not require that your {@link FormControl} instance be part of any parent
 * {@link FormGroup}, and it won't be registered to any {@link FormGroupDirective} that
 * exists above it.
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {@link FormControl} instance. See a full list of available properties in
 * {@link AbstractControl}.
 *
 * **Set the value**: You can pass in an initial value when instantiating the {@link FormControl},
 * or you can set it programmatically later using {@link AbstractControl.setValue} or
 * {@link AbstractControl.patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the control, you can
 * subscribe to the {@link AbstractControl.valueChanges} event.  You can also listen to
 * {@link AbstractControl.statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * {@example forms/ts/simpleFormControl/simple_form_control_example.ts region='Component'}
 *
 * * **npm package**: `@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 *  @stable
 */
var FormControlDirective = (function (_super) {
    __extends(FormControlDirective, _super);
    function FormControlDirective(validators, asyncValidators, valueAccessors) {
        _super.call(this);
        this.update = new __WEBPACK_IMPORTED_MODULE_1__facade_async__["a" /* EventEmitter */]();
        this._rawValidators = validators || [];
        this._rawAsyncValidators = asyncValidators || [];
        this.valueAccessor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["f" /* selectValueAccessor */])(this, valueAccessors);
    }
    Object.defineProperty(FormControlDirective.prototype, "isDisabled", {
        set: function (isDisabled) { __WEBPACK_IMPORTED_MODULE_5__reactive_errors__["a" /* ReactiveErrors */].disabledAttrWarning(); },
        enumerable: true,
        configurable: true
    });
    FormControlDirective.prototype.ngOnChanges = function (changes) {
        if (this._isControlChanged(changes)) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["d" /* setUpControl */])(this.form, this);
            if (this.control.disabled && this.valueAccessor.setDisabledState) {
                this.valueAccessor.setDisabledState(true);
            }
            this.form.updateValueAndValidity({ emitEvent: false });
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["g" /* isPropertyUpdated */])(changes, this.viewModel)) {
            this.form.setValue(this.model);
            this.viewModel = this.model;
        }
    };
    Object.defineProperty(FormControlDirective.prototype, "path", {
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "validator", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["b" /* composeValidators */])(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "asyncValidator", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["c" /* composeAsyncValidators */])(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "control", {
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    FormControlDirective.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    FormControlDirective.prototype._isControlChanged = function (changes) {
        return changes.hasOwnProperty('form');
    };
    FormControlDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formControl]', providers: [formControlBinding], exportAs: 'ngForm' },] },
    ];
    /** @nocollapse */
    FormControlDirective.ctorParameters = [
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_2__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_2__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],] },] },
    ];
    FormControlDirective.propDecorators = {
        'form': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formControl',] },],
        'model': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModel',] },],
        'update': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['ngModelChange',] },],
        'isDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['disabled',] },],
    };
    return FormControlDirective;
}(__WEBPACK_IMPORTED_MODULE_4__ng_control__["a" /* NgControl */]));
//# sourceMappingURL=form_control_directive.js.map

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_async__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validators__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__abstract_form_group_directive__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__control_container__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__control_value_accessor__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ng_control__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reactive_errors__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_group_directive__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__form_group_name__ = __webpack_require__(97);
/* unused harmony export controlNameBinding */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormControlName; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};











var controlNameBinding = {
    provide: __WEBPACK_IMPORTED_MODULE_6__ng_control__["a" /* NgControl */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormControlName; })
};
/**
 * @whatItDoes  Syncs a {@link FormControl} in an existing {@link FormGroup} to a form control
 * element by name.
 *
 * In other words, this directive ensures that any values written to the {@link FormControl}
 * instance programmatically will be written to the DOM element (model -> view). Conversely,
 * any values written to the DOM element through user input will be reflected in the
 * {@link FormControl} instance (view -> model).
 *
 * @howToUse
 *
 * This directive is designed to be used with a parent {@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the {@link FormControl} instance you want to
 * link, and will look for a {@link FormControl} registered with that name in the
 * closest {@link FormGroup} or {@link FormArray} above it.
 *
 * **Access the control**: You can access the {@link FormControl} associated with
 * this directive by using the {@link AbstractControl.get} method.
 * Ex: `this.form.get('first');`
 *
 * **Get value**: the `value` property is always synced and available on the {@link FormControl}.
 * See a full list of available properties in {@link AbstractControl}.
 *
 *  **Set value**: You can set an initial value for the control when instantiating the
 *  {@link FormControl}, or you can set it programmatically later using
 *  {@link AbstractControl.setValue} or {@link AbstractControl.patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the control, you can
 * subscribe to the {@link AbstractControl.valueChanges} event.  You can also listen to
 * {@link AbstractControl.statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * In this example, we create form controls for first name and last name.
 *
 * {@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
 *
 * To see `formControlName` examples with different form control types, see:
 *
 * * Radio buttons: {@link RadioControlValueAccessor}
 * * Selects: {@link SelectControlValueAccessor}
 *
 * **npm package**: `@angular/forms`
 *
 * **NgModule**: {@link ReactiveFormsModule}
 *
 *  @stable
 */
var FormControlName = (function (_super) {
    __extends(FormControlName, _super);
    function FormControlName(parent, validators, asyncValidators, valueAccessors) {
        _super.call(this);
        this._added = false;
        this.update = new __WEBPACK_IMPORTED_MODULE_1__facade_async__["a" /* EventEmitter */]();
        this._parent = parent;
        this._rawValidators = validators || [];
        this._rawAsyncValidators = asyncValidators || [];
        this.valueAccessor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared__["f" /* selectValueAccessor */])(this, valueAccessors);
    }
    Object.defineProperty(FormControlName.prototype, "isDisabled", {
        set: function (isDisabled) { __WEBPACK_IMPORTED_MODULE_7__reactive_errors__["a" /* ReactiveErrors */].disabledAttrWarning(); },
        enumerable: true,
        configurable: true
    });
    FormControlName.prototype.ngOnChanges = function (changes) {
        if (!this._added)
            this._setUpControl();
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared__["g" /* isPropertyUpdated */])(changes, this.viewModel)) {
            this.viewModel = this.model;
            this.formDirective.updateModel(this, this.model);
        }
    };
    FormControlName.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeControl(this);
        }
    };
    FormControlName.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    Object.defineProperty(FormControlName.prototype, "path", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared__["a" /* controlPath */])(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "formDirective", {
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "validator", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared__["b" /* composeValidators */])(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "asyncValidator", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared__["c" /* composeAsyncValidators */])(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "control", {
        get: function () { return this._control; },
        enumerable: true,
        configurable: true
    });
    FormControlName.prototype._checkParentType = function () {
        if (!(this._parent instanceof __WEBPACK_IMPORTED_MODULE_10__form_group_name__["a" /* FormGroupName */]) &&
            this._parent instanceof __WEBPACK_IMPORTED_MODULE_3__abstract_form_group_directive__["a" /* AbstractFormGroupDirective */]) {
            __WEBPACK_IMPORTED_MODULE_7__reactive_errors__["a" /* ReactiveErrors */].ngModelGroupException();
        }
        else if (!(this._parent instanceof __WEBPACK_IMPORTED_MODULE_10__form_group_name__["a" /* FormGroupName */]) && !(this._parent instanceof __WEBPACK_IMPORTED_MODULE_9__form_group_directive__["a" /* FormGroupDirective */]) &&
            !(this._parent instanceof __WEBPACK_IMPORTED_MODULE_10__form_group_name__["b" /* FormArrayName */])) {
            __WEBPACK_IMPORTED_MODULE_7__reactive_errors__["a" /* ReactiveErrors */].controlParentException();
        }
    };
    FormControlName.prototype._setUpControl = function () {
        this._checkParentType();
        this._control = this.formDirective.addControl(this);
        if (this.control.disabled && this.valueAccessor.setDisabledState) {
            this.valueAccessor.setDisabledState(true);
        }
        this._added = true;
    };
    FormControlName.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formControlName]', providers: [controlNameBinding] },] },
    ];
    /** @nocollapse */
    FormControlName.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_4__control_container__["a" /* ControlContainer */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_2__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_2__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_5__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],] },] },
    ];
    FormControlName.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formControlName',] },],
        'model': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModel',] },],
        'update': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['ngModelChange',] },],
        'isDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['disabled',] },],
    };
    return FormControlName;
}(__WEBPACK_IMPORTED_MODULE_6__ng_control__["a" /* NgControl */]));
//# sourceMappingURL=form_control_name.js.map

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validators__ = __webpack_require__(38);
/* unused harmony export REQUIRED_VALIDATOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return RequiredValidator; });
/* unused harmony export MIN_LENGTH_VALIDATOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return MinLengthValidator; });
/* unused harmony export MAX_LENGTH_VALIDATOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return MaxLengthValidator; });
/* unused harmony export PATTERN_VALIDATOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return PatternValidator; });


var REQUIRED_VALIDATOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__validators__["b" /* NG_VALIDATORS */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return RequiredValidator; }),
    multi: true
};
/**
 * A Directive that adds the `required` validator to any controls marked with the
 * `required` attribute, via the {@link NG_VALIDATORS} binding.
 *
 * ### Example
 *
 * ```
 * <input name="fullName" ngModel required>
 * ```
 *
 * @stable
 */
var RequiredValidator = (function () {
    function RequiredValidator() {
    }
    Object.defineProperty(RequiredValidator.prototype, "required", {
        get: function () { return this._required; },
        set: function (value) {
            this._required = value != null && value !== false && "" + value !== 'false';
            if (this._onChange)
                this._onChange();
        },
        enumerable: true,
        configurable: true
    });
    RequiredValidator.prototype.validate = function (c) {
        return this.required ? __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].required(c) : null;
    };
    RequiredValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    RequiredValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[required][formControlName],[required][formControl],[required][ngModel]',
                    providers: [REQUIRED_VALIDATOR],
                    host: { '[attr.required]': 'required ? "" : null' }
                },] },
    ];
    /** @nocollapse */
    RequiredValidator.ctorParameters = [];
    RequiredValidator.propDecorators = {
        'required': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return RequiredValidator;
}());
/**
 * Provider which adds {@link MinLengthValidator} to {@link NG_VALIDATORS}.
 *
 * ## Example:
 *
 * {@example common/forms/ts/validators/validators.ts region='min'}
 */
var MIN_LENGTH_VALIDATOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__validators__["b" /* NG_VALIDATORS */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return MinLengthValidator; }),
    multi: true
};
/**
 * A directive which installs the {@link MinLengthValidator} for any `formControlName`,
 * `formControl`, or control with `ngModel` that also has a `minlength` attribute.
 *
 * @stable
 */
var MinLengthValidator = (function () {
    function MinLengthValidator() {
    }
    MinLengthValidator.prototype.ngOnChanges = function (changes) {
        if ('minlength' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    MinLengthValidator.prototype.validate = function (c) {
        return this.minlength == null ? null : this._validator(c);
    };
    MinLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    MinLengthValidator.prototype._createValidator = function () {
        this._validator = __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].minLength(parseInt(this.minlength, 10));
    };
    MinLengthValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[minlength][formControlName],[minlength][formControl],[minlength][ngModel]',
                    providers: [MIN_LENGTH_VALIDATOR],
                    host: { '[attr.minlength]': 'minlength ? minlength : null' }
                },] },
    ];
    /** @nocollapse */
    MinLengthValidator.ctorParameters = [];
    MinLengthValidator.propDecorators = {
        'minlength': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return MinLengthValidator;
}());
/**
 * Provider which adds {@link MaxLengthValidator} to {@link NG_VALIDATORS}.
 *
 * ## Example:
 *
 * {@example common/forms/ts/validators/validators.ts region='max'}
 */
var MAX_LENGTH_VALIDATOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__validators__["b" /* NG_VALIDATORS */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return MaxLengthValidator; }),
    multi: true
};
/**
 * A directive which installs the {@link MaxLengthValidator} for any `formControlName,
 * `formControl`,
 * or control with `ngModel` that also has a `maxlength` attribute.
 *
 * @stable
 */
var MaxLengthValidator = (function () {
    function MaxLengthValidator() {
    }
    MaxLengthValidator.prototype.ngOnChanges = function (changes) {
        if ('maxlength' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    MaxLengthValidator.prototype.validate = function (c) {
        return this.maxlength != null ? this._validator(c) : null;
    };
    MaxLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    MaxLengthValidator.prototype._createValidator = function () {
        this._validator = __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].maxLength(parseInt(this.maxlength, 10));
    };
    MaxLengthValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]',
                    providers: [MAX_LENGTH_VALIDATOR],
                    host: { '[attr.maxlength]': 'maxlength ? maxlength : null' }
                },] },
    ];
    /** @nocollapse */
    MaxLengthValidator.ctorParameters = [];
    MaxLengthValidator.propDecorators = {
        'maxlength': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return MaxLengthValidator;
}());
var PATTERN_VALIDATOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__validators__["b" /* NG_VALIDATORS */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return PatternValidator; }),
    multi: true
};
/**
 * A Directive that adds the `pattern` validator to any controls marked with the
 * `pattern` attribute, via the {@link NG_VALIDATORS} binding. Uses attribute value
 * as the regex to validate Control value against.  Follows pattern attribute
 * semantics; i.e. regex must match entire Control value.
 *
 * ### Example
 *
 * ```
 * <input [name]="fullName" pattern="[a-zA-Z ]*" ngModel>
 * ```
 * @stable
 */
var PatternValidator = (function () {
    function PatternValidator() {
    }
    PatternValidator.prototype.ngOnChanges = function (changes) {
        if ('pattern' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    PatternValidator.prototype.validate = function (c) { return this._validator(c); };
    PatternValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    PatternValidator.prototype._createValidator = function () { this._validator = __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].pattern(this.pattern); };
    PatternValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[pattern][formControlName],[pattern][formControl],[pattern][ngModel]',
                    providers: [PATTERN_VALIDATOR],
                    host: { '[attr.pattern]': 'pattern ? pattern : null' }
                },] },
    ];
    /** @nocollapse */
    PatternValidator.ctorParameters = [];
    PatternValidator.propDecorators = {
        'pattern': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return PatternValidator;
}());
//# sourceMappingURL=validators.js.map

/***/ },
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var auth_service_1 = __webpack_require__(68);
var AuthGuard = (function () {
    function AuthGuard(authService, router) {
        this.authService = authService;
        this.router = router;
    }
    AuthGuard.prototype.canActivate = function (route, state) {
        var url = state.url;
        return this.checkLogin(url);
    };
    AuthGuard.prototype.canActivateChild = function (route, state) {
        return this.canActivate(route, state);
    };
    AuthGuard.prototype.canLoad = function (route) {
        var url = "/" + route.path;
        return this.checkLogin(url);
    };
    AuthGuard.prototype.checkLogin = function (url) {
        if (this.authService.isLoggedIn) {
            return true;
        }
        // Store the attempted URL for redirecting
        this.authService.redirectUrl = url;
        // Create a dummy session id
        var sessionId = 123456789;
        // Set our navigation extras object
        // that contains our global query params and fragment
        var navigationExtras = {
            queryParams: { 'session_id': sessionId },
            fragment: 'anchor'
        };
        // Navigate to the login page with extras
        this.router.navigate(['/login'], navigationExtras);
        return false;
    };
    AuthGuard = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
    ], AuthGuard);
    return AuthGuard;
    var _a, _b;
}());
exports.AuthGuard = AuthGuard;


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var AboutComponent = (function () {
    function AboutComponent() {
        // Do stuff
    }
    AboutComponent.prototype.ngOnInit = function () {
        console.log('Hello About');
    };
    AboutComponent = __decorate([
        core_1.Component({
            selector: 'my-about',
            template: __webpack_require__(1135),
        }), 
        __metadata('design:paramtypes', [])
    ], AboutComponent);
    return AboutComponent;
}());
exports.AboutComponent = AboutComponent;


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
// TODO SOMEDAY: Feature Componetized like CrisisCenter
__webpack_require__(3);
var core_1 = __webpack_require__(0);
var ContactComponent = (function () {
    function ContactComponent() {
    }
    ContactComponent.prototype.ngOnInit = function () {
    };
    ContactComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1137)
        }), 
        __metadata('design:paramtypes', [])
    ], ContactComponent);
    return ContactComponent;
}());
exports.ContactComponent = ContactComponent;


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var HomeComponent = (function () {
    function HomeComponent() {
        // Do stuff
    }
    HomeComponent.prototype.ngOnInit = function () {
        console.log('Hello Home');
    };
    HomeComponent = __decorate([
        core_1.Component({
            selector: 'my-home',
            template: __webpack_require__(1139),
        }), 
        __metadata('design:paramtypes', [])
    ], HomeComponent);
    return HomeComponent;
}());
exports.HomeComponent = HomeComponent;


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
// todo: support template url
var AccordionComponent = (function () {
    function AccordionComponent() {
        /* tslint:disable:no-unused-variable */
        this.addClass = true;
        /* tslint:enable:no-unused-variable */
        this.groups = [];
    }
    AccordionComponent.prototype.closeOtherPanels = function (openGroup) {
        if (!this.closeOthers) {
            return;
        }
        this.groups.forEach(function (group) {
            if (group !== openGroup) {
                group.isOpen = false;
            }
        });
    };
    AccordionComponent.prototype.addGroup = function (group) {
        this.groups.push(group);
    };
    AccordionComponent.prototype.removeGroup = function (group) {
        var index = this.groups.indexOf(group);
        if (index !== -1) {
            this.groups.splice(index, 1);
        }
    };
    AccordionComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'accordion',
                    template: "<ng-content></ng-content>"
                },] },
    ];
    /** @nocollapse */
    AccordionComponent.ctorParameters = [];
    AccordionComponent.propDecorators = {
        'closeOthers': [{ type: core_1.Input },],
        'addClass': [{ type: core_1.HostBinding, args: ['class.panel-group',] },],
    };
    return AccordionComponent;
}());
exports.AccordionComponent = AccordionComponent;


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var common_1 = __webpack_require__(9);
var core_1 = __webpack_require__(0);
var collapse_module_1 = __webpack_require__(156);
var accordion_group_component_1 = __webpack_require__(596);
var accordion_component_1 = __webpack_require__(231);
var AccordionModule = (function () {
    function AccordionModule() {
    }
    AccordionModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [common_1.CommonModule, collapse_module_1.CollapseModule],
                    declarations: [accordion_component_1.AccordionComponent, accordion_group_component_1.AccordionPanelComponent],
                    exports: [accordion_component_1.AccordionComponent, accordion_group_component_1.AccordionPanelComponent]
                },] },
    ];
    /** @nocollapse */
    AccordionModule.ctorParameters = [];
    return AccordionModule;
}());
exports.AccordionModule = AccordionModule;


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var common_1 = __webpack_require__(9);
var core_1 = __webpack_require__(0);
var alert_component_1 = __webpack_require__(597);
var AlertModule = (function () {
    function AlertModule() {
    }
    AlertModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [common_1.CommonModule],
                    declarations: [alert_component_1.AlertComponent],
                    exports: [alert_component_1.AlertComponent]
                },] },
    ];
    /** @nocollapse */
    AlertModule.ctorParameters = [];
    return AlertModule;
}());
exports.AlertModule = AlertModule;


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(10);
var button_checkbox_directive_1 = __webpack_require__(598);
var button_radio_directive_1 = __webpack_require__(599);
var ButtonsModule = (function () {
    function ButtonsModule() {
    }
    ButtonsModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [forms_1.FormsModule],
                    declarations: [button_checkbox_directive_1.ButtonCheckboxDirective, button_radio_directive_1.ButtonRadioDirective],
                    exports: [button_checkbox_directive_1.ButtonCheckboxDirective, button_radio_directive_1.ButtonRadioDirective, forms_1.FormsModule]
                },] },
    ];
    /** @nocollapse */
    ButtonsModule.ctorParameters = [];
    return ButtonsModule;
}());
exports.ButtonsModule = ButtonsModule;


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
// todo: add animate
"use strict";
var core_1 = __webpack_require__(0);
var ng2_bootstrap_config_1 = __webpack_require__(83);
(function (Direction) {
    Direction[Direction["UNKNOWN"] = 0] = "UNKNOWN";
    Direction[Direction["NEXT"] = 1] = "NEXT";
    Direction[Direction["PREV"] = 2] = "PREV";
})(exports.Direction || (exports.Direction = {}));
var Direction = exports.Direction;
// todo:
// (ng-swipe-right)="prev()" (ng-swipe-left)="next()"
/**
 * Problems:
 * 1) if we set an active slide via model changes, .active class remains on a current slide.
 * 2) if we have only one slide, we shouldn't show prev/next nav buttons
 * 3) if first or last slide is active and noWrap is true, there should be "disabled" class on the nav buttons.
 * 4) default interval should be equal 5000
 */
var CarouselComponent = (function () {
    function CarouselComponent() {
        this.slides = [];
        this.destroyed = false;
    }
    Object.defineProperty(CarouselComponent.prototype, "interval", {
        get: function () {
            return this._interval;
        },
        set: function (value) {
            this._interval = value;
            this.restartTimer();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CarouselComponent.prototype, "isBS4", {
        get: function () {
            return ng2_bootstrap_config_1.Ng2BootstrapConfig.theme === ng2_bootstrap_config_1.Ng2BootstrapTheme.BS4;
        },
        enumerable: true,
        configurable: true
    });
    CarouselComponent.prototype.ngOnDestroy = function () {
        this.destroyed = true;
    };
    CarouselComponent.prototype.select = function (nextSlide, direction) {
        if (direction === void 0) { direction = Direction.UNKNOWN; }
        var nextIndex = nextSlide.index;
        if (direction === Direction.UNKNOWN) {
            direction = nextIndex > this.getCurrentIndex()
                ? Direction.NEXT
                : Direction.PREV;
        }
        // Prevent this user-triggered transition from occurring if there is
        // already one in progress
        if (nextSlide && nextSlide !== this.currentSlide) {
            this.goNext(nextSlide, direction);
        }
    };
    CarouselComponent.prototype.play = function () {
        if (!this.isPlaying) {
            this.isPlaying = true;
            this.restartTimer();
        }
    };
    CarouselComponent.prototype.pause = function () {
        if (!this.noPause) {
            this.isPlaying = false;
            this.resetTimer();
        }
    };
    CarouselComponent.prototype.next = function () {
        var newIndex = (this.getCurrentIndex() + 1) % this.slides.length;
        if (newIndex === 0 && this.noWrap) {
            this.pause();
            return;
        }
        return this.select(this.getSlideByIndex(newIndex), Direction.NEXT);
    };
    CarouselComponent.prototype.prev = function () {
        var newIndex = this.getCurrentIndex() - 1 < 0
            ? this.slides.length - 1
            : this.getCurrentIndex() - 1;
        if (this.noWrap && newIndex === this.slides.length - 1) {
            this.pause();
            return;
        }
        return this.select(this.getSlideByIndex(newIndex), Direction.PREV);
    };
    CarouselComponent.prototype.addSlide = function (slide) {
        slide.index = this.slides.length;
        this.slides.push(slide);
        if (this.slides.length === 1 || slide.active) {
            this.select(this.slides[this.slides.length - 1]);
            if (this.slides.length === 1) {
                this.play();
            }
        }
        else {
            slide.active = false;
        }
    };
    CarouselComponent.prototype.removeSlide = function (slide) {
        this.slides.splice(slide.index, 1);
        if (this.slides.length === 0) {
            this.currentSlide = void 0;
            return;
        }
        for (var i = 0; i < this.slides.length; i++) {
            this.slides[i].index = i;
        }
    };
    CarouselComponent.prototype.goNext = function (slide, direction) {
        if (this.destroyed) {
            return;
        }
        slide.direction = direction;
        slide.active = true;
        if (this.currentSlide) {
            this.currentSlide.direction = direction;
            this.currentSlide.active = false;
        }
        this.currentSlide = slide;
        // every time you change slides, reset the timer
        this.restartTimer();
    };
    CarouselComponent.prototype.getSlideByIndex = function (index) {
        var len = this.slides.length;
        for (var i = 0; i < len; ++i) {
            if (this.slides[i].index === index) {
                return this.slides[i];
            }
        }
        return void 0;
    };
    CarouselComponent.prototype.getCurrentIndex = function () {
        return !this.currentSlide ? 0 : this.currentSlide.index;
    };
    CarouselComponent.prototype.restartTimer = function () {
        var _this = this;
        this.resetTimer();
        var interval = +this.interval;
        if (!isNaN(interval) && interval > 0) {
            this.currentInterval = setInterval(function () {
                var nInterval = +_this.interval;
                if (_this.isPlaying && !isNaN(_this.interval) && nInterval > 0 && _this.slides.length) {
                    _this.next();
                }
                else {
                    _this.pause();
                }
            }, interval);
        }
    };
    CarouselComponent.prototype.resetTimer = function () {
        if (this.currentInterval) {
            clearInterval(this.currentInterval);
            this.currentInterval = void 0;
        }
    };
    CarouselComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'carousel',
                    template: "\n    <div (mouseenter)=\"pause()\" (mouseleave)=\"play()\" class=\"carousel slide\">\n      <ol class=\"carousel-indicators\" *ngIf=\"slides.length > 1\">\n         <li *ngFor=\"let slidez of slides\" [class.active]=\"slidez.active === true\" (click)=\"select(slidez)\"></li>\n      </ol>\n      <div class=\"carousel-inner\"><ng-content></ng-content></div>\n      <a class=\"left carousel-control\" (click)=\"prev()\" *ngIf=\"slides.length\">\n        <span class=\"icon-prev\" aria-hidden=\"true\"></span>\n        <span *ngIf=\"isBS4\" class=\"sr-only\">Previous</span>\n      </a>\n      <a class=\"right carousel-control\" (click)=\"next()\" *ngIf=\"slides.length\">\n        <span class=\"icon-next\" aria-hidden=\"true\"></span>\n        <span *ngIf=\"isBS4\" class=\"sr-only\">Next</span>\n      </a>\n    </div>\n  "
                },] },
    ];
    /** @nocollapse */
    CarouselComponent.ctorParameters = [];
    CarouselComponent.propDecorators = {
        'noWrap': [{ type: core_1.Input },],
        'noPause': [{ type: core_1.Input },],
        'noTransition': [{ type: core_1.Input },],
        'interval': [{ type: core_1.Input },],
    };
    return CarouselComponent;
}());
exports.CarouselComponent = CarouselComponent;


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var common_1 = __webpack_require__(9);
var core_1 = __webpack_require__(0);
var carousel_component_1 = __webpack_require__(235);
var slide_component_1 = __webpack_require__(600);
var CarouselModule = (function () {
    function CarouselModule() {
    }
    CarouselModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [common_1.CommonModule],
                    declarations: [slide_component_1.SlideComponent, carousel_component_1.CarouselComponent],
                    exports: [slide_component_1.SlideComponent, carousel_component_1.CarouselComponent]
                },] },
    ];
    /** @nocollapse */
    CarouselModule.ctorParameters = [];
    return CarouselModule;
}());
exports.CarouselModule = CarouselModule;


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var common_1 = __webpack_require__(9);
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(10);
var datepicker_inner_component_1 = __webpack_require__(102);
var datepicker_component_1 = __webpack_require__(604);
var daypicker_component_1 = __webpack_require__(605);
var monthpicker_component_1 = __webpack_require__(606);
var yearpicker_component_1 = __webpack_require__(607);
var components_helper_service_1 = __webpack_require__(53);
var DatepickerModule = (function () {
    function DatepickerModule() {
    }
    DatepickerModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [common_1.CommonModule, forms_1.FormsModule],
                    declarations: [datepicker_component_1.DatePickerComponent, datepicker_inner_component_1.DatePickerInnerComponent, daypicker_component_1.DayPickerComponent,
                        monthpicker_component_1.MonthPickerComponent, yearpicker_component_1.YearPickerComponent],
                    exports: [datepicker_component_1.DatePickerComponent, datepicker_inner_component_1.DatePickerInnerComponent, daypicker_component_1.DayPickerComponent, forms_1.FormsModule,
                        monthpicker_component_1.MonthPickerComponent, yearpicker_component_1.YearPickerComponent],
                    providers: [components_helper_service_1.ComponentsHelper]
                },] },
    ];
    /** @nocollapse */
    DatepickerModule.ctorParameters = [];
    return DatepickerModule;
}());
exports.DatepickerModule = DatepickerModule;


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var dropdown_menu_directive_1 = __webpack_require__(608);
var dropdown_toggle_directive_1 = __webpack_require__(609);
var dropdown_directive_1 = __webpack_require__(157);
var DropdownModule = (function () {
    function DropdownModule() {
    }
    DropdownModule.decorators = [
        { type: core_1.NgModule, args: [{
                    declarations: [dropdown_directive_1.DropdownDirective, dropdown_menu_directive_1.DropdownMenuDirective, dropdown_toggle_directive_1.DropdownToggleDirective],
                    exports: [dropdown_directive_1.DropdownDirective, dropdown_menu_directive_1.DropdownMenuDirective, dropdown_toggle_directive_1.DropdownToggleDirective]
                },] },
    ];
    /** @nocollapse */
    DropdownModule.ctorParameters = [];
    return DropdownModule;
}());
exports.DropdownModule = DropdownModule;


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var modal_options_class_1 = __webpack_require__(240);
var ModalBackdropOptions = (function () {
    function ModalBackdropOptions(options) {
        this.animate = true;
        Object.assign(this, options);
    }
    return ModalBackdropOptions;
}());
exports.ModalBackdropOptions = ModalBackdropOptions;
var ModalBackdropComponent = (function () {
    function ModalBackdropComponent(options, element, renderer) {
        this._isShown = false;
        this.element = element;
        this.renderer = renderer;
        this.isAnimated = options.animate !== false;
    }
    Object.defineProperty(ModalBackdropComponent.prototype, "isAnimated", {
        get: function () {
            return this._isAnimated;
        },
        set: function (value) {
            this._isAnimated = value;
            this.renderer.setElementClass(this.element.nativeElement, "" + modal_options_class_1.ClassName.FADE, value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModalBackdropComponent.prototype, "isShown", {
        get: function () {
            return this._isShown;
        },
        set: function (value) {
            this._isShown = value;
            this.renderer.setElementClass(this.element.nativeElement, "" + modal_options_class_1.ClassName.IN, value);
        },
        enumerable: true,
        configurable: true
    });
    ModalBackdropComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'bs-modal-backdrop',
                    template: '',
                    host: { 'class': modal_options_class_1.ClassName.BACKDROP }
                },] },
    ];
    /** @nocollapse */
    ModalBackdropComponent.ctorParameters = [
        { type: ModalBackdropOptions, },
        { type: core_1.ElementRef, },
        { type: core_1.Renderer, },
    ];
    return ModalBackdropComponent;
}());
exports.ModalBackdropComponent = ModalBackdropComponent;


/***/ },
/* 240 */
/***/ function(module, exports) {

"use strict";
"use strict";
exports.modalConfigDefaults = {
    backdrop: true,
    keyboard: true,
    focus: true,
    show: true,
    ignoreBackdropClick: false
};
exports.ClassName = {
    SCROLLBAR_MEASURER: 'modal-scrollbar-measure',
    BACKDROP: 'modal-backdrop',
    OPEN: 'modal-open',
    FADE: 'fade',
    IN: 'in'
};
exports.Selector = {
    DIALOG: '.modal-dialog',
    DATA_TOGGLE: '[data-toggle="modal"]',
    DATA_DISMISS: '[data-dismiss="modal"]',
    FIXED_CONTENT: '.navbar-fixed-top, .navbar-fixed-bottom, .is-fixed'
};


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var modal_backdrop_component_1 = __webpack_require__(239);
var modal_component_1 = __webpack_require__(611);
var components_helper_service_1 = __webpack_require__(53);
var ModalModule = (function () {
    function ModalModule() {
    }
    ModalModule.decorators = [
        { type: core_1.NgModule, args: [{
                    declarations: [modal_backdrop_component_1.ModalBackdropComponent, modal_component_1.ModalDirective],
                    exports: [modal_backdrop_component_1.ModalBackdropComponent, modal_component_1.ModalDirective],
                    entryComponents: [modal_backdrop_component_1.ModalBackdropComponent],
                    providers: [components_helper_service_1.ComponentsHelper]
                },] },
    ];
    /** @nocollapse */
    ModalModule.ctorParameters = [];
    return ModalModule;
}());
exports.ModalModule = ModalModule;


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {"use strict";
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(10);
/* tslint:disable-next-line */
var MouseEvent = global.MouseEvent;
var paginationConfig = {
    maxSize: void 0,
    itemsPerPage: 10,
    boundaryLinks: false,
    directionLinks: true,
    firstText: 'First',
    previousText: 'Previous',
    nextText: 'Next',
    lastText: 'Last',
    pageBtnClass: '',
    rotate: true
};
var PAGINATION_TEMPLATE = "\n  <ul class=\"pagination\" [ngClass]=\"classMap\">\n    <li class=\"pagination-first page-item\"\n        *ngIf=\"boundaryLinks\"\n        [class.disabled]=\"noPrevious()||disabled\">\n      <a class=\"page-link\" href (click)=\"selectPage(1, $event)\" [innerHTML]=\"getText('first')\"></a>\n    </li>\n\n    <li class=\"pagination-prev page-item\"\n        *ngIf=\"directionLinks\"\n        [class.disabled]=\"noPrevious()||disabled\">\n      <a class=\"page-link\" href (click)=\"selectPage(page - 1, $event)\" [innerHTML]=\"getText('previous')\"></a>\n      </li>\n\n    <li *ngFor=\"let pg of pages\"\n        [class.active]=\"pg.active\"\n        [class.disabled]=\"disabled&&!pg.active\"\n        class=\"pagination-page page-item\">\n      <a class=\"page-link\" href (click)=\"selectPage(pg.number, $event)\" [innerHTML]=\"pg.text\"></a>\n    </li>\n\n    <li class=\"pagination-next page-item\"\n        *ngIf=\"directionLinks\"\n        [class.disabled]=\"noNext()||disabled\">\n      <a class=\"page-link\" href (click)=\"selectPage(page + 1, $event)\" [innerHTML]=\"getText('next')\"></a></li>\n\n    <li class=\"pagination-last page-item\"\n        *ngIf=\"boundaryLinks\"\n        [class.disabled]=\"noNext()||disabled\">\n      <a class=\"page-link\" href (click)=\"selectPage(totalPages, $event)\" [innerHTML]=\"getText('last')\"></a></li>\n  </ul>\n  ";
/* tslint:disable */
/* tslint:enable */
var PaginationComponent = (function () {
    function PaginationComponent(cd, renderer, elementRef) {
        this.numPages = new core_1.EventEmitter(false);
        this.pageChanged = new core_1.EventEmitter(false);
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
        this.inited = false;
        this.cd = cd;
        this.renderer = renderer;
        this.elementRef = elementRef;
        cd.valueAccessor = this;
        this.config = this.config || paginationConfig;
    }
    Object.defineProperty(PaginationComponent.prototype, "itemsPerPage", {
        get: function () {
            return this._itemsPerPage;
        },
        set: function (v) {
            this._itemsPerPage = v;
            this.totalPages = this.calculateTotalPages();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaginationComponent.prototype, "totalItems", {
        get: function () {
            return this._totalItems;
        },
        set: function (v) {
            this._totalItems = v;
            this.totalPages = this.calculateTotalPages();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaginationComponent.prototype, "totalPages", {
        get: function () {
            return this._totalPages;
        },
        set: function (v) {
            this._totalPages = v;
            this.numPages.emit(v);
            if (this.inited) {
                this.selectPage(this.page);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaginationComponent.prototype, "page", {
        get: function () {
            return this._page;
        },
        set: function (value) {
            var _previous = this._page;
            this._page = (value > this.totalPages) ? this.totalPages : (value || 1);
            if (_previous === this._page || typeof _previous === 'undefined') {
                return;
            }
            this.pageChanged.emit({
                page: this._page,
                itemsPerPage: this.itemsPerPage
            });
        },
        enumerable: true,
        configurable: true
    });
    PaginationComponent.prototype.ngOnInit = function () {
        this.classMap = this.elementRef.nativeElement.getAttribute('class') || '';
        // watch for maxSize
        this.maxSize = typeof this.maxSize !== 'undefined'
            ? this.maxSize
            : paginationConfig.maxSize;
        this.rotate = typeof this.rotate !== 'undefined'
            ? this.rotate
            : paginationConfig.rotate;
        this.boundaryLinks = typeof this.boundaryLinks !== 'undefined'
            ? this.boundaryLinks
            : paginationConfig.boundaryLinks;
        this.directionLinks = typeof this.directionLinks !== 'undefined'
            ? this.directionLinks
            : paginationConfig.directionLinks;
        this.pageBtnClass = typeof this.pageBtnClass !== 'undefined'
            ? this.pageBtnClass
            : paginationConfig.pageBtnClass;
        // base class
        this.itemsPerPage = typeof this.itemsPerPage !== 'undefined'
            ? this.itemsPerPage
            : paginationConfig.itemsPerPage;
        this.totalPages = this.calculateTotalPages();
        // this class
        this.pages = this.getPages(this.page, this.totalPages);
        this.page = this.cd.value;
        this.inited = true;
    };
    PaginationComponent.prototype.writeValue = function (value) {
        this.page = value;
        this.pages = this.getPages(this.page, this.totalPages);
    };
    PaginationComponent.prototype.getText = function (key) {
        return this[key + 'Text'] || paginationConfig[key + 'Text'];
    };
    PaginationComponent.prototype.noPrevious = function () {
        return this.page === 1;
    };
    PaginationComponent.prototype.noNext = function () {
        return this.page === this.totalPages;
    };
    PaginationComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    PaginationComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    PaginationComponent.prototype.selectPage = function (page, event) {
        if (event) {
            event.preventDefault();
        }
        if (!this.disabled) {
            if (event && event.target) {
                var target = event.target;
                target.blur();
            }
            this.writeValue(page);
            this.cd.viewToModelUpdate(this.page);
        }
    };
    // Create page object used in template
    PaginationComponent.prototype.makePage = function (num, text, isActive) {
        return {
            number: num,
            text: text,
            active: isActive
        };
    };
    PaginationComponent.prototype.getPages = function (currentPage, totalPages) {
        var pages = [];
        // Default page limits
        var startPage = 1;
        var endPage = totalPages;
        var isMaxSized = typeof this.maxSize !== 'undefined' && this.maxSize < totalPages;
        // recompute if maxSize
        if (isMaxSized) {
            if (this.rotate) {
                // Current page is displayed in the middle of the visible ones
                startPage = Math.max(currentPage - Math.floor(this.maxSize / 2), 1);
                endPage = startPage + this.maxSize - 1;
                // Adjust if limit is exceeded
                if (endPage > totalPages) {
                    endPage = totalPages;
                    startPage = endPage - this.maxSize + 1;
                }
            }
            else {
                // Visible pages are paginated with maxSize
                startPage = ((Math.ceil(currentPage / this.maxSize) - 1) * this.maxSize) + 1;
                // Adjust last page if limit is exceeded
                endPage = Math.min(startPage + this.maxSize - 1, totalPages);
            }
        }
        // Add page number links
        for (var num = startPage; num <= endPage; num++) {
            var page = this.makePage(num, num.toString(), num === currentPage);
            pages.push(page);
        }
        // Add links to move between page sets
        if (isMaxSized && !this.rotate) {
            if (startPage > 1) {
                var previousPageSet = this.makePage(startPage - 1, '...', false);
                pages.unshift(previousPageSet);
            }
            if (endPage < totalPages) {
                var nextPageSet = this.makePage(endPage + 1, '...', false);
                pages.push(nextPageSet);
            }
        }
        return pages;
    };
    // base class
    PaginationComponent.prototype.calculateTotalPages = function () {
        var totalPages = this.itemsPerPage < 1
            ? 1
            : Math.ceil(this.totalItems / this.itemsPerPage);
        return Math.max(totalPages || 0, 1);
    };
    PaginationComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'pagination[ngModel]',
                    template: PAGINATION_TEMPLATE,
                    providers: [forms_1.NgModel]
                },] },
    ];
    /** @nocollapse */
    PaginationComponent.ctorParameters = [
        { type: forms_1.NgModel, decorators: [{ type: core_1.Self },] },
        { type: core_1.Renderer, },
        { type: core_1.ElementRef, },
    ];
    PaginationComponent.propDecorators = {
        'align': [{ type: core_1.Input },],
        'maxSize': [{ type: core_1.Input },],
        'boundaryLinks': [{ type: core_1.Input },],
        'directionLinks': [{ type: core_1.Input },],
        'firstText': [{ type: core_1.Input },],
        'previousText': [{ type: core_1.Input },],
        'nextText': [{ type: core_1.Input },],
        'lastText': [{ type: core_1.Input },],
        'rotate': [{ type: core_1.Input },],
        'pageBtnClass': [{ type: core_1.Input },],
        'disabled': [{ type: core_1.Input },],
        'numPages': [{ type: core_1.Output },],
        'pageChanged': [{ type: core_1.Output },],
        'itemsPerPage': [{ type: core_1.Input },],
        'totalItems': [{ type: core_1.Input },],
    };
    return PaginationComponent;
}());
exports.PaginationComponent = PaginationComponent;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23)))

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var common_1 = __webpack_require__(9);
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(10);
var pager_component_1 = __webpack_require__(612);
var pagination_component_1 = __webpack_require__(242);
var PaginationModule = (function () {
    function PaginationModule() {
    }
    PaginationModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [common_1.CommonModule, forms_1.FormsModule],
                    declarations: [pager_component_1.PagerComponent, pagination_component_1.PaginationComponent],
                    exports: [forms_1.FormsModule, pager_component_1.PagerComponent, pagination_component_1.PaginationComponent]
                },] },
    ];
    /** @nocollapse */
    PaginationModule.ctorParameters = [];
    return PaginationModule;
}());
exports.PaginationModule = PaginationModule;


/***/ },
/* 244 */
/***/ function(module, exports) {

"use strict";
"use strict";
var PositionService = (function () {
    function PositionService() {
    }
    /**
     * Provides read-only equivalent of jQuery's position function:
     * http://api.jquery.com/position/
     */
    PositionService.prototype.position = function (nativeEl) {
        var elBCR = this.offset(nativeEl);
        var offsetParentBCR = { top: 0, left: 0 };
        var offsetParentEl = this.parentOffsetEl(nativeEl);
        if (offsetParentEl !== this.document) {
            offsetParentBCR = this.offset(offsetParentEl);
            offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
            offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
        }
        var boundingClientRect = nativeEl.getBoundingClientRect();
        return {
            width: boundingClientRect.width || nativeEl.offsetWidth,
            height: boundingClientRect.height || nativeEl.offsetHeight,
            top: elBCR.top - offsetParentBCR.top,
            left: elBCR.left - offsetParentBCR.left
        };
    };
    /**
     * Provides read-only equivalent of jQuery's offset function:
     * http://api.jquery.com/offset/
     */
    PositionService.prototype.offset = function (nativeEl) {
        var boundingClientRect = nativeEl.getBoundingClientRect();
        return {
            width: boundingClientRect.width || nativeEl.offsetWidth,
            height: boundingClientRect.height || nativeEl.offsetHeight,
            top: boundingClientRect.top + (this.window.pageYOffset || this.document.documentElement.scrollTop),
            left: boundingClientRect.left + (this.window.pageXOffset || this.document.documentElement.scrollLeft)
        };
    };
    /**
     * Provides coordinates for the targetEl in relation to hostEl
     */
    PositionService.prototype.positionElements = function (hostEl, targetEl, positionStr, appendToBody) {
        var positionStrParts = positionStr.split('-');
        var pos0 = positionStrParts[0];
        var pos1 = positionStrParts[1] || 'center';
        var hostElPos = appendToBody ?
            this.offset(hostEl) :
            this.position(hostEl);
        var targetElWidth = targetEl.offsetWidth;
        var targetElHeight = targetEl.offsetHeight;
        var shiftWidth = {
            center: function () {
                return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
            },
            left: function () {
                return hostElPos.left;
            },
            right: function () {
                return hostElPos.left + hostElPos.width;
            }
        };
        var shiftHeight = {
            center: function () {
                return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
            },
            top: function () {
                return hostElPos.top;
            },
            bottom: function () {
                return hostElPos.top + hostElPos.height;
            }
        };
        var targetElPos;
        switch (pos0) {
            case 'right':
                targetElPos = {
                    top: shiftHeight[pos1](),
                    left: shiftWidth[pos0]()
                };
                break;
            case 'left':
                targetElPos = {
                    top: shiftHeight[pos1](),
                    left: hostElPos.left - targetElWidth
                };
                break;
            case 'bottom':
                targetElPos = {
                    top: shiftHeight[pos0](),
                    left: shiftWidth[pos1]()
                };
                break;
            default:
                targetElPos = {
                    top: hostElPos.top - targetElHeight,
                    left: shiftWidth[pos1]()
                };
                break;
        }
        return targetElPos;
    };
    Object.defineProperty(PositionService.prototype, "window", {
        get: function () {
            return window;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PositionService.prototype, "document", {
        get: function () {
            return window.document;
        },
        enumerable: true,
        configurable: true
    });
    PositionService.prototype.getStyle = function (nativeEl, cssProp) {
        // IE
        if (nativeEl.currentStyle) {
            return nativeEl.currentStyle[cssProp];
        }
        if (this.window.getComputedStyle) {
            return this.window.getComputedStyle(nativeEl)[cssProp];
        }
        // finally try and get inline style
        return nativeEl.style[cssProp];
    };
    /**
     * Checks if a given element is statically positioned
     * @param nativeEl - raw DOM element
     */
    PositionService.prototype.isStaticPositioned = function (nativeEl) {
        return (this.getStyle(nativeEl, 'position') || 'static') === 'static';
    };
    /**
     * returns the closest, non-statically positioned parentOffset of a given
     * element
     * @param nativeEl
     */
    PositionService.prototype.parentOffsetEl = function (nativeEl) {
        var offsetParent = nativeEl.offsetParent || this.document;
        while (offsetParent && offsetParent !== this.document &&
            this.isStaticPositioned(offsetParent)) {
            offsetParent = offsetParent.offsetParent;
        }
        return offsetParent || this.document;
    };
    ;
    return PositionService;
}());
exports.PositionService = PositionService;
exports.positionService = new PositionService();


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var progressConfig = {
    animate: true,
    max: 100
};
// todo: progress element conflict with bootstrap.css
// todo: need hack: replace host element with div
/* tslint:disable */
/* tslint:enable */
var ProgressDirective = (function () {
    function ProgressDirective() {
        this.addClass = true;
        this.bars = [];
    }
    Object.defineProperty(ProgressDirective.prototype, "max", {
        get: function () {
            return this._max;
        },
        set: function (v) {
            this._max = v;
            this.bars.forEach(function (bar) {
                bar.recalculatePercentage();
            });
        },
        enumerable: true,
        configurable: true
    });
    ProgressDirective.prototype.ngOnInit = function () {
        this.animate = this.animate !== false;
        this.max = typeof this.max === 'number' ? this.max : progressConfig.max;
    };
    ProgressDirective.prototype.addBar = function (bar) {
        if (!this.animate) {
            bar.transition = 'none';
        }
        this.bars.push(bar);
    };
    ProgressDirective.prototype.removeBar = function (bar) {
        this.bars.splice(this.bars.indexOf(bar), 1);
    };
    ProgressDirective.decorators = [
        { type: core_1.Directive, args: [{ selector: 'bs-progress, [progress]' },] },
    ];
    /** @nocollapse */
    ProgressDirective.ctorParameters = [];
    ProgressDirective.propDecorators = {
        'animate': [{ type: core_1.Input },],
        'max': [{ type: core_1.HostBinding, args: ['attr.max',] }, { type: core_1.Input },],
        'addClass': [{ type: core_1.HostBinding, args: ['class.progress',] },],
    };
    return ProgressDirective;
}());
exports.ProgressDirective = ProgressDirective;


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var common_1 = __webpack_require__(9);
var core_1 = __webpack_require__(0);
var bar_component_1 = __webpack_require__(613);
var progress_directive_1 = __webpack_require__(245);
var progressbar_component_1 = __webpack_require__(614);
var ProgressbarModule = (function () {
    function ProgressbarModule() {
    }
    ProgressbarModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [common_1.CommonModule],
                    declarations: [progress_directive_1.ProgressDirective, bar_component_1.BarComponent, progressbar_component_1.ProgressbarComponent],
                    exports: [progress_directive_1.ProgressDirective, bar_component_1.BarComponent, progressbar_component_1.ProgressbarComponent]
                },] },
    ];
    /** @nocollapse */
    ProgressbarModule.ctorParameters = [];
    return ProgressbarModule;
}());
exports.ProgressbarModule = ProgressbarModule;


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var common_1 = __webpack_require__(9);
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(10);
var rating_component_1 = __webpack_require__(615);
var RatingModule = (function () {
    function RatingModule() {
    }
    RatingModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [common_1.CommonModule, forms_1.FormsModule],
                    declarations: [rating_component_1.RatingComponent],
                    exports: [forms_1.FormsModule, rating_component_1.RatingComponent]
                },] },
    ];
    /** @nocollapse */
    RatingModule.ctorParameters = [];
    return RatingModule;
}());
exports.RatingModule = RatingModule;


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var tabset_component_1 = __webpack_require__(250);
/* tslint:disable */
/* tslint:enable */
var TabDirective = (function () {
    function TabDirective(tabset) {
        this.select = new core_1.EventEmitter(false);
        this.deselect = new core_1.EventEmitter(false);
        this.removed = new core_1.EventEmitter(false);
        this.addClass = true;
        this.tabset = tabset;
        this.tabset.addTab(this);
    }
    Object.defineProperty(TabDirective.prototype, "active", {
        /** tab active state toggle */
        get: function () {
            return this._active;
        },
        set: function (active) {
            var _this = this;
            if (this.disabled && active || !active) {
                if (!active) {
                    this._active = active;
                }
                this.deselect.emit(this);
                return;
            }
            this._active = active;
            this.select.emit(this);
            this.tabset.tabs.forEach(function (tab) {
                if (tab !== _this) {
                    tab.active = false;
                }
            });
        },
        enumerable: true,
        configurable: true
    });
    TabDirective.prototype.ngOnInit = function () {
        this.removable = !!this.removable;
    };
    TabDirective.prototype.ngOnDestroy = function () {
        this.tabset.removeTab(this);
    };
    TabDirective.decorators = [
        { type: core_1.Directive, args: [{ selector: 'tab, [tab]' },] },
    ];
    /** @nocollapse */
    TabDirective.ctorParameters = [
        { type: tabset_component_1.TabsetComponent, },
    ];
    TabDirective.propDecorators = {
        'heading': [{ type: core_1.Input },],
        'disabled': [{ type: core_1.Input },],
        'removable': [{ type: core_1.Input },],
        'customClass': [{ type: core_1.Input },],
        'active': [{ type: core_1.HostBinding, args: ['class.active',] }, { type: core_1.Input },],
        'select': [{ type: core_1.Output },],
        'deselect': [{ type: core_1.Output },],
        'removed': [{ type: core_1.Output },],
        'addClass': [{ type: core_1.HostBinding, args: ['class.tab-pane',] },],
    };
    return TabDirective;
}());
exports.TabDirective = TabDirective;


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var common_1 = __webpack_require__(9);
var core_1 = __webpack_require__(0);
var common_2 = __webpack_require__(602);
var tab_heading_directive_1 = __webpack_require__(616);
var tab_directive_1 = __webpack_require__(248);
var tabset_component_1 = __webpack_require__(250);
var TabsModule = (function () {
    function TabsModule() {
    }
    TabsModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [common_1.CommonModule],
                    declarations: [common_2.NgTranscludeDirective, tab_directive_1.TabDirective, tabset_component_1.TabsetComponent, tab_heading_directive_1.TabHeadingDirective],
                    exports: [tab_directive_1.TabDirective, tabset_component_1.TabsetComponent, tab_heading_directive_1.TabHeadingDirective]
                },] },
    ];
    /** @nocollapse */
    TabsModule.ctorParameters = [];
    return TabsModule;
}());
exports.TabsModule = TabsModule;


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
// todo: add active event to tab
// todo: fix? mixing static and dynamic tabs position tabs in order of creation
var TabsetComponent = (function () {
    function TabsetComponent() {
        this.clazz = true;
        this.tabs = [];
        this.classMap = {};
    }
    Object.defineProperty(TabsetComponent.prototype, "vertical", {
        get: function () {
            return this._vertical;
        },
        set: function (value) {
            this._vertical = value;
            this.setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(TabsetComponent.prototype, "justified", {
        get: function () {
            return this._justified;
        },
        set: function (value) {
            this._justified = value;
            this.setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(TabsetComponent.prototype, "type", {
        get: function () {
            return this._type;
        },
        set: function (value) {
            this._type = value;
            this.setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    ;
    TabsetComponent.prototype.ngOnInit = function () {
        this.type = this.type !== 'undefined' ? this.type : 'tabs';
    };
    TabsetComponent.prototype.ngOnDestroy = function () {
        this.isDestroyed = true;
    };
    TabsetComponent.prototype.addTab = function (tab) {
        this.tabs.push(tab);
        tab.active = this.tabs.length === 1 && tab.active !== false;
    };
    TabsetComponent.prototype.removeTab = function (tab) {
        var index = this.tabs.indexOf(tab);
        if (index === -1 || this.isDestroyed) {
            return;
        }
        // Select a new tab if the tab to be removed is selected and not destroyed
        if (tab.active && this.hasAvailableTabs(index)) {
            var newActiveIndex = this.getClosestTabIndex(index);
            this.tabs[newActiveIndex].active = true;
        }
        tab.removed.emit(tab);
        this.tabs.splice(index, 1);
    };
    TabsetComponent.prototype.getClosestTabIndex = function (index) {
        var tabsLength = this.tabs.length;
        if (!tabsLength) {
            return -1;
        }
        for (var step = 1; step <= tabsLength; step += 1) {
            var prevIndex = index - step;
            var nextIndex = index + step;
            if (this.tabs[prevIndex] && !this.tabs[prevIndex].disabled) {
                return prevIndex;
            }
            if (this.tabs[nextIndex] && !this.tabs[nextIndex].disabled) {
                return nextIndex;
            }
        }
        return -1;
    };
    TabsetComponent.prototype.hasAvailableTabs = function (index) {
        var tabsLength = this.tabs.length;
        if (!tabsLength) {
            return false;
        }
        for (var i = 0; i < tabsLength; i += 1) {
            if (!this.tabs[i].disabled && i !== index) {
                return true;
            }
        }
        return false;
    };
    TabsetComponent.prototype.setClassMap = function () {
        this.classMap = (_a = {
                'nav-stacked': this.vertical,
                'nav-justified': this.justified
            },
            _a['nav-' + (this.type || 'tabs')] = true,
            _a
        );
        var _a;
    };
    TabsetComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'tabset',
                    template: "\n    <ul class=\"nav\" [ngClass]=\"classMap\" (click)=\"$event.preventDefault()\">\n        <li *ngFor=\"let tabz of tabs\" class=\"nav-item {{tabz.customClass}}\"\n          [class.active]=\"tabz.active\" [class.disabled]=\"tabz.disabled\">\n          <a href=\"javascript:void(0);\" class=\"nav-link\"\n            [class.active]=\"tabz.active\" [class.disabled]=\"tabz.disabled\"\n            (click)=\"tabz.active = true\">\n            <span [ngTransclude]=\"tabz.headingRef\">{{tabz.heading}}</span>\n            <span *ngIf=\"tabz.removable\">\n              <span (click)=\"$event.preventDefault(); removeTab(tabz);\" class=\"glyphicon glyphicon-remove-circle\"></span>\n            </span>\n          </a>\n        </li>\n    </ul>\n    <div class=\"tab-content\">\n      <ng-content></ng-content>\n    </div>\n  "
                },] },
    ];
    /** @nocollapse */
    TabsetComponent.ctorParameters = [];
    TabsetComponent.propDecorators = {
        'vertical': [{ type: core_1.Input },],
        'justified': [{ type: core_1.Input },],
        'type': [{ type: core_1.Input },],
        'clazz': [{ type: core_1.HostBinding, args: ['class.tab-container',] },],
    };
    return TabsetComponent;
}());
exports.TabsetComponent = TabsetComponent;


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var common_1 = __webpack_require__(9);
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(10);
var timepicker_component_1 = __webpack_require__(617);
var TimepickerModule = (function () {
    function TimepickerModule() {
    }
    TimepickerModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [common_1.CommonModule, forms_1.FormsModule],
                    declarations: [timepicker_component_1.TimepickerComponent],
                    exports: [forms_1.FormsModule, timepicker_component_1.TimepickerComponent]
                },] },
    ];
    /** @nocollapse */
    TimepickerModule.ctorParameters = [];
    return TimepickerModule;
}());
exports.TimepickerModule = TimepickerModule;


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var position_1 = __webpack_require__(244);
var tooltip_options_class_1 = __webpack_require__(618);
var TooltipContainerComponent = (function () {
    function TooltipContainerComponent(element, cdr, options) {
        this.top = '-1000px';
        this.left = '-1000px';
        this.display = 'block';
        this.element = element;
        this.cdr = cdr;
        Object.assign(this, options);
        this.classMap = { 'in': false, 'fade': false };
        this.classMap[options.placement] = true;
        this.classMap['tooltip-' + options.placement] = true;
    }
    TooltipContainerComponent.prototype.ngAfterViewInit = function () {
        var p = position_1.positionService
            .positionElements(this.hostEl.nativeElement, this.element.nativeElement.children[0], this.placement, this.appendToBody);
        this.top = p.top + 'px';
        this.left = p.left + 'px';
        this.classMap.in = true;
        if (this.animation) {
            this.classMap.fade = true;
        }
        if (this.popupClass) {
            this.classMap[this.popupClass] = true;
        }
        this.cdr.detectChanges();
    };
    Object.defineProperty(TooltipContainerComponent.prototype, "isTemplate", {
        get: function () {
            return this.htmlContent instanceof core_1.TemplateRef;
        },
        enumerable: true,
        configurable: true
    });
    TooltipContainerComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'tooltip-container',
                    // changeDetection: ChangeDetectionStrategy.OnPush,
                    template: "<div class=\"tooltip\" role=\"tooltip\"\n     [ngStyle]=\"{top: top, left: left, display: display}\"\n     [ngClass]=\"classMap\">\n      <div class=\"tooltip-arrow\"></div>\n      <div class=\"tooltip-inner\"\n           *ngIf=\"htmlContent && !isTemplate\" \n           innerHtml=\"{{htmlContent}}\">\n      </div>\n      <div class=\"tooltip-inner\"\n           *ngIf=\"htmlContent && isTemplate\">\n        <template [ngTemplateOutlet]=\"htmlContent\"\n                  [ngOutletContext]=\"{model: context}\">\n        </template>\n      </div>\n      <div class=\"tooltip-inner\"\n           *ngIf=\"content\">\n        {{content}}\n      </div>\n    </div>"
                },] },
    ];
    /** @nocollapse */
    TooltipContainerComponent.ctorParameters = [
        { type: core_1.ElementRef, },
        { type: core_1.ChangeDetectorRef, },
        { type: tooltip_options_class_1.TooltipOptions, decorators: [{ type: core_1.Inject, args: [tooltip_options_class_1.TooltipOptions,] },] },
    ];
    return TooltipContainerComponent;
}());
exports.TooltipContainerComponent = TooltipContainerComponent;


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var common_1 = __webpack_require__(9);
var core_1 = __webpack_require__(0);
var tooltip_container_component_1 = __webpack_require__(252);
var tooltip_directive_1 = __webpack_require__(619);
var components_helper_service_1 = __webpack_require__(53);
var TooltipModule = (function () {
    function TooltipModule() {
    }
    TooltipModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [common_1.CommonModule],
                    declarations: [tooltip_directive_1.TooltipDirective, tooltip_container_component_1.TooltipContainerComponent],
                    exports: [tooltip_directive_1.TooltipDirective, tooltip_container_component_1.TooltipContainerComponent],
                    providers: [components_helper_service_1.ComponentsHelper],
                    entryComponents: [tooltip_container_component_1.TooltipContainerComponent]
                },] },
    ];
    /** @nocollapse */
    TooltipModule.ctorParameters = [];
    return TooltipModule;
}());
exports.TooltipModule = TooltipModule;


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var ng2_bootstrap_config_1 = __webpack_require__(83);
var position_1 = __webpack_require__(244);
var typeahead_options_class_1 = __webpack_require__(255);
var typeahead_utils_1 = __webpack_require__(256);
var bs4 = "\n  <div class=\"dropdown-menu\"\n       [ngStyle]=\"{top: top, left: left, display: 'block'}\"\n       (mouseleave)=\"focusLost()\">\n    <template ngFor let-match let-i=\"index\" [ngForOf]=\"matches\">\n       <h6 *ngIf=\"match.isHeader()\" class=\"dropdown-header\">{{match}}</h6>\n       <div *ngIf=\"!match.isHeader() && !itemTemplate\">\n          <a href=\"#\"\n            class=\"dropdown-item\"\n            (click)=\"selectMatch(match, $event)\"\n            (mouseenter)=\"selectActive(match)\"\n            [class.active]=\"isActive(match)\"\n            [innerHtml]=\"hightlight(match, query)\"></a>\n      </div>\n      <div *ngIf=\"!match.isHeader() && itemTemplate\">\n        <a href=\"#\"\n         class=\"dropdown-item\"\n         (click)=\"selectMatch(match, $event)\"\n         (mouseenter)=\"selectActive(match)\"\n         [class.active]=\"isActive(match)\">\n          <template [ngTemplateOutlet]=\"itemTemplate\"\n                    [ngOutletContext]=\"{item: match.item, index: i}\">\n          </template>\n         </a>\n      </div>\n    </template>\n  </div>\n";
var bs3 = "\n  <ul class=\"dropdown-menu\"\n      [ngStyle]=\"{top: top, left: left, display: 'block'}\"\n      (mouseleave)=\"focusLost()\">\n    <template ngFor let-match let-i=\"index\" [ngForOf]=\"matches\">\n      <li *ngIf=\"match.isHeader()\" class=\"dropdown-header\">{{match}}</li>\n      <li *ngIf=\"!match.isHeader()\"\n        [class.active]=\"isActive(match)\"\n        (mouseenter)=\"selectActive(match)\">\n        <a href=\"#\"\n           *ngIf=\"!itemTemplate\"\n           (click)=\"selectMatch(match, $event)\"\n           tabindex=\"-1\"\n           [innerHtml]=\"hightlight(match, query)\"></a>\n        <a href=\"#\"\n           *ngIf=\"itemTemplate\"\n           (click)=\"selectMatch(match, $event)\"\n           tabindex=\"-1\">\n            <template [ngTemplateOutlet]=\"itemTemplate\"\n                      [ngOutletContext]=\"{item: match.item, index: i}\">\n            </template>\n        </a>\n      </li>\n    </template>\n  </ul>\n";
var isBS4 = ng2_bootstrap_config_1.Ng2BootstrapConfig.theme === ng2_bootstrap_config_1.Ng2BootstrapTheme.BS4;
var TypeaheadContainerComponent = (function () {
    function TypeaheadContainerComponent(element, options) {
        this.isFocused = false;
        this._matches = [];
        this.element = element;
        Object.assign(this, options);
    }
    Object.defineProperty(TypeaheadContainerComponent.prototype, "matches", {
        get: function () {
            return this._matches;
        },
        set: function (value) {
            this._matches = value;
            if (this._matches.length > 0) {
                this._active = this._matches[0];
                if (this._active.isHeader()) {
                    this.nextActiveMatch();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TypeaheadContainerComponent.prototype, "itemTemplate", {
        get: function () {
            return this.parent ? this.parent.typeaheadItemTemplate : undefined;
        },
        enumerable: true,
        configurable: true
    });
    TypeaheadContainerComponent.prototype.position = function (hostEl) {
        this.top = '0px';
        this.left = '0px';
        var p = position_1.positionService
            .positionElements(hostEl.nativeElement, this.element.nativeElement.children[0], this.placement, false);
        this.top = p.top + 'px';
        this.left = p.left + 'px';
    };
    TypeaheadContainerComponent.prototype.selectActiveMatch = function () {
        this.selectMatch(this._active);
    };
    TypeaheadContainerComponent.prototype.prevActiveMatch = function () {
        var index = this.matches.indexOf(this._active);
        this._active = this.matches[index - 1 < 0
            ? this.matches.length - 1
            : index - 1];
        if (this._active.isHeader()) {
            this.prevActiveMatch();
        }
    };
    TypeaheadContainerComponent.prototype.nextActiveMatch = function () {
        var index = this.matches.indexOf(this._active);
        this._active = this.matches[index + 1 > this.matches.length - 1
            ? 0
            : index + 1];
        if (this._active.isHeader()) {
            this.nextActiveMatch();
        }
    };
    TypeaheadContainerComponent.prototype.selectActive = function (value) {
        this.isFocused = true;
        this._active = value;
    };
    TypeaheadContainerComponent.prototype.hightlight = function (match, query) {
        var itemStr = match.value;
        var itemStrHelper = (this.parent && this.parent.typeaheadLatinize
            ? typeahead_utils_1.TypeaheadUtils.latinize(itemStr)
            : itemStr).toLowerCase();
        var startIdx;
        var tokenLen;
        // Replaces the capture string with the same string inside of a "strong" tag
        if (typeof query === 'object') {
            var queryLen = query.length;
            for (var i = 0; i < queryLen; i += 1) {
                // query[i] is already latinized and lower case
                startIdx = itemStrHelper.indexOf(query[i]);
                tokenLen = query[i].length;
                if (startIdx >= 0 && tokenLen > 0) {
                    itemStr = itemStr.substring(0, startIdx) + '<strong>' + itemStr.substring(startIdx, startIdx + tokenLen) + '</strong>' + itemStr.substring(startIdx + tokenLen);
                    itemStrHelper = itemStrHelper.substring(0, startIdx) + '        ' + ' '.repeat(tokenLen) + '         ' + itemStrHelper.substring(startIdx + tokenLen);
                }
            }
        }
        else if (query) {
            // query is already latinized and lower case
            startIdx = itemStrHelper.indexOf(query);
            tokenLen = query.length;
            if (startIdx >= 0 && tokenLen > 0) {
                itemStr = itemStr.substring(0, startIdx) + '<strong>' + itemStr.substring(startIdx, startIdx + tokenLen) + '</strong>' + itemStr.substring(startIdx + tokenLen);
            }
        }
        return itemStr;
    };
    TypeaheadContainerComponent.prototype.focusLost = function () {
        this.isFocused = false;
    };
    TypeaheadContainerComponent.prototype.isActive = function (value) {
        return this._active === value;
    };
    TypeaheadContainerComponent.prototype.selectMatch = function (value, e) {
        var _this = this;
        if (e === void 0) { e = void 0; }
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        this.parent.changeModel(value);
        setTimeout(function () {
            return _this.parent.typeaheadOnSelect.emit(value);
        }, 0);
        return false;
    };
    TypeaheadContainerComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'typeahead-container',
                    template: isBS4 ? bs4 : bs3,
                    encapsulation: core_1.ViewEncapsulation.None
                },] },
    ];
    /** @nocollapse */
    TypeaheadContainerComponent.ctorParameters = [
        { type: core_1.ElementRef, },
        { type: typeahead_options_class_1.TypeaheadOptions, },
    ];
    return TypeaheadContainerComponent;
}());
exports.TypeaheadContainerComponent = TypeaheadContainerComponent;


/***/ },
/* 255 */
/***/ function(module, exports) {

"use strict";
"use strict";
var TypeaheadOptions = (function () {
    function TypeaheadOptions(options) {
        Object.assign(this, options);
    }
    return TypeaheadOptions;
}());
exports.TypeaheadOptions = TypeaheadOptions;


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var latin_map_1 = __webpack_require__(1010);
var TypeaheadUtils = (function () {
    function TypeaheadUtils() {
    }
    TypeaheadUtils.latinize = function (str) {
        if (!str) {
            return '';
        }
        return str.replace(/[^A-Za-z0-9\[\] ]/g, function (a) {
            return TypeaheadUtils.latinMap[a] || a;
        });
    };
    TypeaheadUtils.escapeRegexp = function (queryToEscape) {
        // Regex: capture the whole query string and replace it with the string
        // that will be used to match the results, for example if the capture is
        // 'a' the result will be \a
        return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    };
    /* tslint:disable */
    TypeaheadUtils.tokenize = function (str, wordRegexDelimiters, phraseRegexDelimiters) {
        if (wordRegexDelimiters === void 0) { wordRegexDelimiters = ' '; }
        if (phraseRegexDelimiters === void 0) { phraseRegexDelimiters = ''; }
        /* tslint:enable */
        var regexStr = '(?:[' + phraseRegexDelimiters + '])([^' + phraseRegexDelimiters + ']+)(?:[' + phraseRegexDelimiters + '])|([^' + wordRegexDelimiters + ']+)';
        var preTokenized = str.split(new RegExp(regexStr, 'g'));
        var result = [];
        var preTokenizedLength = preTokenized.length;
        var token;
        var replacePhraseDelimiters = new RegExp('[' + phraseRegexDelimiters + ']+', 'g');
        for (var i = 0; i < preTokenizedLength; i += 1) {
            token = preTokenized[i];
            if (token && token.length && token !== wordRegexDelimiters) {
                result.push(token.replace(replacePhraseDelimiters, ''));
            }
        }
        return result;
    };
    TypeaheadUtils.getValueFromObject = function (object, option) {
        if (!option || typeof object !== 'object') {
            return object.toString();
        }
        if (option.endsWith('()')) {
            var functionName = option.slice(0, option.length - 2);
            return object[functionName]().toString();
        }
        var properties = option.replace(/\[(\w+)\]/g, '.$1')
            .replace(/^\./, '');
        var propertiesArray = properties.split('.');
        for (var _i = 0, propertiesArray_1 = propertiesArray; _i < propertiesArray_1.length; _i++) {
            var property = propertiesArray_1[_i];
            if (property in object) {
                object = object[property];
            }
        }
        return object.toString();
    };
    TypeaheadUtils.latinMap = latin_map_1.latinMap;
    return TypeaheadUtils;
}());
exports.TypeaheadUtils = TypeaheadUtils;


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var common_1 = __webpack_require__(9);
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(10);
var typeahead_container_component_1 = __webpack_require__(254);
var typeahead_directive_1 = __webpack_require__(621);
var components_helper_service_1 = __webpack_require__(53);
var TypeaheadModule = (function () {
    function TypeaheadModule() {
    }
    TypeaheadModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [common_1.CommonModule, forms_1.FormsModule],
                    declarations: [typeahead_container_component_1.TypeaheadContainerComponent, typeahead_directive_1.TypeaheadDirective],
                    exports: [forms_1.FormsModule, typeahead_container_component_1.TypeaheadContainerComponent, typeahead_directive_1.TypeaheadDirective],
                    providers: [components_helper_service_1.ComponentsHelper],
                    entryComponents: [typeahead_container_component_1.TypeaheadContainerComponent]
                },] },
    ];
    /** @nocollapse */
    TypeaheadModule.ctorParameters = [];
    return TypeaheadModule;
}());
exports.TypeaheadModule = TypeaheadModule;


/***/ },
/* 258 */
/***/ function(module, exports) {

"use strict";
/*tslint:disable */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
"use strict";
/**
 * JS version of browser APIs. This library can only run in the browser.
 */
var win = typeof window !== 'undefined' && window || {};
exports.window = win;
exports.document = win.document;
exports.location = win.location;
exports.gc = win['gc'] ? function () { return win['gc'](); } : function () { return null; };
exports.performance = win['performance'] ? win['performance'] : null;
exports.Event = win['Event'];
exports.MouseEvent = win['MouseEvent'];
exports.KeyboardEvent = win['KeyboardEvent'];
exports.EventTarget = win['EventTarget'];
exports.History = win['History'];
exports.Location = win['Location'];
exports.EventListener = win['EventListener'];


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var toast_options_1 = __webpack_require__(158);
var platform_browser_1 = __webpack_require__(62);
var ToastContainer = (function () {
    function ToastContainer(sanitizer, cdr, options) {
        this.sanitizer = sanitizer;
        this.cdr = cdr;
        this.position = 'fixed';
        this.messageClass = 'toast-message';
        this.titleClass = 'toast-title';
        this.positionClass = 'toast-top-right';
        this.toasts = [];
        this.maxShown = 5;
        this.newestOnTop = false;
        this.animate = 'fade';
        if (options) {
            Object.assign(this, options);
        }
    }
    ToastContainer.prototype.addToast = function (toast) {
        if (this.positionClass.indexOf('top') > 0) {
            if (this.newestOnTop) {
                this.toasts.unshift(toast);
            }
            else {
                this.toasts.push(toast);
            }
            if (this.toasts.length > this.maxShown) {
                var diff = this.toasts.length - this.maxShown;
                if (this.newestOnTop) {
                    this.toasts.splice(this.maxShown);
                }
                else {
                    this.toasts.splice(0, diff);
                }
            }
        }
        else {
            this.toasts.unshift(toast);
            if (this.toasts.length > this.maxShown) {
                this.toasts.splice(this.maxShown);
            }
        }
        this.cdr.detectChanges();
    };
    ToastContainer.prototype.removeToast = function (toast) {
        if (toast.timeoutId) {
            clearTimeout(toast.timeoutId);
            toast.timeoutId = null;
        }
        this.toasts = this.toasts.filter(function (t) {
            return t.id !== toast.id;
        });
    };
    ToastContainer.prototype.removeAllToasts = function () {
        this.toasts = [];
    };
    ToastContainer.prototype.clicked = function (toast) {
        if (this.onToastClicked) {
            this.onToastClicked(toast);
        }
    };
    ToastContainer.prototype.anyToast = function () {
        return this.toasts.length > 0;
    };
    ToastContainer.prototype.findToast = function (toastId) {
        for (var _i = 0, _a = this.toasts; _i < _a.length; _i++) {
            var toast = _a[_i];
            if (toast.id === toastId) {
                return toast;
            }
        }
        return null;
    };
    ToastContainer.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'toast-container',
                    template: "\n    <div #toastContainer id=\"toast-container\" [style.position]=\"position\" class=\"{{positionClass}}\">\n      <div *ngFor=\"let toast of toasts\" [@inOut]=\"animate\" class=\"toast toast-{{toast.type}}\" \n      (click)=\"clicked(toast)\">\n        <div class=\"toast-close-button\" *ngIf=\"toast.config.showCloseButton\" (click)=\"removeToast(toast)\">&times;\n        </div> \n        <div *ngIf=\"toast.title\" class=\"{{toast.config.titleClass || titleClass}}\">{{toast.title}}</div>\n        <div [ngSwitch]=\"toast.config.enableHTML\">\n          <span *ngSwitchCase=\"true\" [innerHTML]=\"sanitizer.bypassSecurityTrustHtml(toast.message)\"></span>\n          <span *ngSwitchDefault class=\"{{toast.config.messageClass || messageClass}}\">{{toast.message}}</span>\n        </div>             \n      </div>\n    </div>\n    ",
                    animations: [
                        core_1.trigger('inOut', [
                            core_1.state('flyRight, flyLeft', core_1.style({ opacity: 1, transform: 'translateX(0)' })),
                            core_1.state('fade', core_1.style({ opacity: 1 })),
                            core_1.state('slideDown, slideUp', core_1.style({ opacity: 1, transform: 'translateY(0)' })),
                            core_1.transition('void => flyRight', [
                                core_1.style({
                                    opacity: 0,
                                    transform: 'translateX(100%)'
                                }),
                                core_1.animate('0.2s ease-in')
                            ]),
                            core_1.transition('flyRight => void', [
                                core_1.animate('0.2s 10 ease-out', core_1.style({
                                    opacity: 0,
                                    transform: 'translateX(100%)'
                                }))
                            ]),
                            core_1.transition('void => flyLeft', [
                                core_1.style({
                                    opacity: 0,
                                    transform: 'translateX(-100%)'
                                }),
                                core_1.animate('0.2s ease-in')
                            ]),
                            core_1.transition('flyLeft => void', [
                                core_1.animate('0.2s 10 ease-out', core_1.style({
                                    opacity: 0,
                                    transform: 'translateX(-100%)'
                                }))
                            ]),
                            core_1.transition('void => fade', [
                                core_1.style({
                                    opacity: 0,
                                }),
                                core_1.animate('0.3s ease-in')
                            ]),
                            core_1.transition('fade => void', [
                                core_1.animate('0.3s 10 ease-out', core_1.style({
                                    opacity: 0,
                                }))
                            ]),
                            core_1.transition('void => slideDown', [
                                core_1.style({
                                    opacity: 0,
                                    transform: 'translateY(-200%)'
                                }),
                                core_1.animate('0.3s ease-in')
                            ]),
                            core_1.transition('slideDown => void', [
                                core_1.animate('0.3s 10 ease-out', core_1.style({
                                    opacity: 0,
                                    transform: 'translateY(-200%)'
                                }))
                            ]),
                            core_1.transition('void => slideUp', [
                                core_1.style({
                                    opacity: 0,
                                    transform: 'translateY(200%)'
                                }),
                                core_1.animate('0.3s ease-in')
                            ]),
                            core_1.transition('slideUp => void', [
                                core_1.animate('0.3s 10 ease-out', core_1.style({
                                    opacity: 0,
                                    transform: 'translateY(200%)'
                                }))
                            ]),
                        ]),
                    ],
                },] },
    ];
    /** @nocollapse */
    ToastContainer.ctorParameters = [
        { type: platform_browser_1.DomSanitizer, },
        { type: core_1.ChangeDetectorRef, },
        { type: toast_options_1.ToastOptions, decorators: [{ type: core_1.Optional },] },
    ];
    return ToastContainer;
}());
exports.ToastContainer = ToastContainer;
//# sourceMappingURL=toast-container.component.js.map

/***/ },
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormErrorExamples; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var FormErrorExamples = {
    formControlName: "\n    <div [formGroup]=\"myGroup\">\n      <input formControlName=\"firstName\">\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       firstName: new FormControl()\n    });",
    formGroupName: "\n    <div [formGroup]=\"myGroup\">\n       <div formGroupName=\"person\">\n          <input formControlName=\"firstName\">\n       </div>\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       person: new FormGroup({ firstName: new FormControl() })\n    });",
    formArrayName: "\n    <div [formGroup]=\"myGroup\">\n      <div formArrayName=\"cities\">\n        <div *ngFor=\"let city of cityArray.controls; let i=index\">\n          <input [formControlName]=\"i\">\n        </div>\n      </div>\n    </div>\n\n    In your class:\n\n    this.cityArray = new FormArray([new FormControl('SF')]);\n    this.myGroup = new FormGroup({\n      cities: this.cityArray\n    });",
    ngModelGroup: "\n    <form>\n       <div ngModelGroup=\"person\">\n          <input [(ngModel)]=\"person.name\" name=\"firstName\">\n       </div>\n    </form>",
    ngModelWithFormGroup: "\n    <div [formGroup]=\"myGroup\">\n       <input formControlName=\"firstName\">\n       <input [(ngModel)]=\"showMoreControls\" [ngModelOptions]=\"{standalone: true}\">\n    </div>\n  "
};
//# sourceMappingURL=error_examples.js.map

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_examples__ = __webpack_require__(335);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return TemplateDrivenErrors; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

var TemplateDrivenErrors = (function () {
    function TemplateDrivenErrors() {
    }
    TemplateDrivenErrors.modelParentException = function () {
        throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroup directive.  Try using\n      formGroup's partner directive \"formControlName\" instead.  Example:\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formControlName + "\n\n      Or, if you'd like to avoid registering this form control, indicate that it's standalone in ngModelOptions:\n\n      Example:\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].ngModelWithFormGroup);
    };
    TemplateDrivenErrors.formGroupNameException = function () {
        throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroupName or formArrayName directive.\n\n      Option 1: Use formControlName instead of ngModel (reactive strategy):\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formGroupName + "\n\n      Option 2:  Update ngModel's parent be ngModelGroup (template-driven strategy):\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].ngModelGroup);
    };
    TemplateDrivenErrors.missingNameException = function () {
        throw new Error("If ngModel is used within a form tag, either the name attribute must be set or the form\n      control must be defined as 'standalone' in ngModelOptions.\n\n      Example 1: <input [(ngModel)]=\"person.firstName\" name=\"first\">\n      Example 2: <input [(ngModel)]=\"person.firstName\" [ngModelOptions]=\"{standalone: true}\">");
    };
    TemplateDrivenErrors.modelGroupParentException = function () {
        throw new Error("\n      ngModelGroup cannot be used with a parent formGroup directive.\n\n      Option 1: Use formGroupName instead of ngModelGroup (reactive strategy):\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formGroupName + "\n\n      Option 2:  Use a regular form tag instead of the formGroup directive (template-driven strategy):\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].ngModelGroup);
    };
    return TemplateDrivenErrors;
}());
//# sourceMappingURL=template_driven_errors.js.map

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang__ = __webpack_require__(76);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return StringMapWrapper; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return ListWrapper; });
/* unused harmony export isListLikeIterable */
/* unused harmony export areIterablesEqual */
/* unused harmony export iterateListLike */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * Wraps Javascript Objects
 */
var StringMapWrapper = (function () {
    function StringMapWrapper() {
    }
    StringMapWrapper.merge = function (m1, m2) {
        var m = {};
        for (var _i = 0, _a = Object.keys(m1); _i < _a.length; _i++) {
            var k = _a[_i];
            m[k] = m1[k];
        }
        for (var _b = 0, _c = Object.keys(m2); _b < _c.length; _b++) {
            var k = _c[_b];
            m[k] = m2[k];
        }
        return m;
    };
    StringMapWrapper.equals = function (m1, m2) {
        var k1 = Object.keys(m1);
        var k2 = Object.keys(m2);
        if (k1.length != k2.length) {
            return false;
        }
        for (var i = 0; i < k1.length; i++) {
            var key = k1[i];
            if (m1[key] !== m2[key]) {
                return false;
            }
        }
        return true;
    };
    return StringMapWrapper;
}());
var ListWrapper = (function () {
    function ListWrapper() {
    }
    ListWrapper.removeAll = function (list, items) {
        for (var i = 0; i < items.length; ++i) {
            var index = list.indexOf(items[i]);
            if (index > -1) {
                list.splice(index, 1);
            }
        }
    };
    ListWrapper.remove = function (list, el) {
        var index = list.indexOf(el);
        if (index > -1) {
            list.splice(index, 1);
            return true;
        }
        return false;
    };
    ListWrapper.equals = function (a, b) {
        if (a.length != b.length)
            return false;
        for (var i = 0; i < a.length; ++i) {
            if (a[i] !== b[i])
                return false;
        }
        return true;
    };
    ListWrapper.flatten = function (list) {
        return list.reduce(function (flat, item) {
            var flatItem = Array.isArray(item) ? ListWrapper.flatten(item) : item;
            return flat.concat(flatItem);
        }, []);
    };
    return ListWrapper;
}());
function isListLikeIterable(obj) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lang__["a" /* isJsObject */])(obj))
        return false;
    return Array.isArray(obj) ||
        (!(obj instanceof Map) &&
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lang__["b" /* getSymbolIterator */])() in obj); // JS Iterable have a Symbol.iterator prop
}
function areIterablesEqual(a, b, comparator) {
    var iterator1 = a[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lang__["b" /* getSymbolIterator */])()]();
    var iterator2 = b[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lang__["b" /* getSymbolIterator */])()]();
    while (true) {
        var item1 = iterator1.next();
        var item2 = iterator2.next();
        if (item1.done && item2.done)
            return true;
        if (item1.done || item2.done)
            return false;
        if (!comparator(item1.value, item2.value))
            return false;
    }
}
function iterateListLike(obj, fn) {
    if (Array.isArray(obj)) {
        for (var i = 0; i < obj.length; i++) {
            fn(obj[i]);
        }
    }
    else {
        var iterator = obj[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lang__["b" /* getSymbolIterator */])()]();
        var item = void 0;
        while (!((item = iterator.next()).done)) {
            fn(item.value);
        }
    }
}
//# sourceMappingURL=collection.js.map

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model__ = __webpack_require__(134);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormBuilder; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * @whatItDoes Creates an {@link AbstractControl} from a user-specified configuration.
 *
 * It is essentially syntactic sugar that shortens the `new FormGroup()`,
 * `new FormControl()`, and `new FormArray()` boilerplate that can build up in larger
 * forms.
 *
 * @howToUse
 *
 * To use, inject `FormBuilder` into your component class. You can then call its methods
 * directly.
 *
 * {@example forms/ts/formBuilder/form_builder_example.ts region='Component'}
 *
 *  * **npm package**: `@angular/forms`
 *
 *  * **NgModule**: {@link ReactiveFormsModule}
 *
 * @stable
 */
var FormBuilder = (function () {
    function FormBuilder() {
    }
    /**
     * Construct a new {@link FormGroup} with the given map of configuration.
     * Valid keys for the `extra` parameter map are `validator` and `asyncValidator`.
     *
     * See the {@link FormGroup} constructor for more details.
     */
    FormBuilder.prototype.group = function (controlsConfig, extra) {
        if (extra === void 0) { extra = null; }
        var controls = this._reduceControls(controlsConfig);
        var validator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["c" /* isPresent */])(extra) ? extra['validator'] : null;
        var asyncValidator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["c" /* isPresent */])(extra) ? extra['asyncValidator'] : null;
        return new __WEBPACK_IMPORTED_MODULE_2__model__["a" /* FormGroup */](controls, validator, asyncValidator);
    };
    /**
     * Construct a new {@link FormControl} with the given `formState`,`validator`, and
     * `asyncValidator`.
     *
     * `formState` can either be a standalone value for the form control or an object
     * that contains both a value and a disabled status.
     *
     */
    FormBuilder.prototype.control = function (formState, validator, asyncValidator) {
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        return new __WEBPACK_IMPORTED_MODULE_2__model__["b" /* FormControl */](formState, validator, asyncValidator);
    };
    /**
     * Construct a {@link FormArray} from the given `controlsConfig` array of
     * configuration, with the given optional `validator` and `asyncValidator`.
     */
    FormBuilder.prototype.array = function (controlsConfig, validator, asyncValidator) {
        var _this = this;
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        var controls = controlsConfig.map(function (c) { return _this._createControl(c); });
        return new __WEBPACK_IMPORTED_MODULE_2__model__["c" /* FormArray */](controls, validator, asyncValidator);
    };
    /** @internal */
    FormBuilder.prototype._reduceControls = function (controlsConfig) {
        var _this = this;
        var controls = {};
        Object.keys(controlsConfig).forEach(function (controlName) {
            controls[controlName] = _this._createControl(controlsConfig[controlName]);
        });
        return controls;
    };
    /** @internal */
    FormBuilder.prototype._createControl = function (controlConfig) {
        if (controlConfig instanceof __WEBPACK_IMPORTED_MODULE_2__model__["b" /* FormControl */] || controlConfig instanceof __WEBPACK_IMPORTED_MODULE_2__model__["a" /* FormGroup */] ||
            controlConfig instanceof __WEBPACK_IMPORTED_MODULE_2__model__["c" /* FormArray */]) {
            return controlConfig;
        }
        else if (Array.isArray(controlConfig)) {
            var value = controlConfig[0];
            var validator = controlConfig.length > 1 ? controlConfig[1] : null;
            var asyncValidator = controlConfig.length > 2 ? controlConfig[2] : null;
            return this.control(value, validator, asyncValidator);
        }
        else {
            return this.control(controlConfig);
        }
    };
    FormBuilder.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    FormBuilder.ctorParameters = [];
    return FormBuilder;
}());
//# sourceMappingURL=form_builder.js.map

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return isPromise; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

var isPromise = __WEBPACK_IMPORTED_MODULE_0__angular_core__["__core_private__"].isPromise;
//# sourceMappingURL=private_import_core.js.map

/***/ },
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: AlphabeticallistofproductsAddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: AlphabeticallistofproductsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Alphabeticallistofproducts_service_1 = __webpack_require__(140);
var AlphabeticallistofproductsDetailsComponent = (function () {
    // Lookup Arrays
    function AlphabeticallistofproductsDetailsComponent(route, router, toastr, AlphabeticallistofproductsService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.AlphabeticallistofproductsService = AlphabeticallistofproductsService;
        // this.id = parseInt(params.get('id'));
        this.objAlphabeticallistofproducts = new Alphabeticallistofproducts_service_1.AlphabeticallistofproductsData();
    }
    Object.defineProperty(AlphabeticallistofproductsDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AlphabeticallistofproductsDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    AlphabeticallistofproductsDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.AlphabeticallistofproductsService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objAlphabeticallistofproducts = item; });
        this.getLookups();
    };
    AlphabeticallistofproductsDetailsComponent.prototype.deleteAlphabeticallistofproducts = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Alphabeticallistofproducts?') == true) {
            this.AlphabeticallistofproductsService.deleteAlphabeticallistofproducts(this.objAlphabeticallistofproducts.ProductID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/Alphabeticallistofproducts']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('Alphabeticallistofproducts record deleted successfully...'); });
        }
    };
    AlphabeticallistofproductsDetailsComponent.prototype.gotoAlphabeticallistofproductsEdit = function () {
        this.router.navigate(['/Alphabeticallistofproducts', this.objAlphabeticallistofproducts.ProductID]);
    };
    AlphabeticallistofproductsDetailsComponent.prototype.gotoAlphabeticallistofproducts = function () {
        this.router.navigate(['/Alphabeticallistofproducts']);
    };
    AlphabeticallistofproductsDetailsComponent.prototype.getLookups = function () {
    };
    AlphabeticallistofproductsDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], AlphabeticallistofproductsDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], AlphabeticallistofproductsDetailsComponent.prototype, "display", null);
    AlphabeticallistofproductsDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1017),
            providers: [Alphabeticallistofproducts_service_1.AlphabeticallistofproductsService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Alphabeticallistofproducts_service_1.AlphabeticallistofproductsService !== 'undefined' && Alphabeticallistofproducts_service_1.AlphabeticallistofproductsService) === 'function' && _d) || Object])
    ], AlphabeticallistofproductsDetailsComponent);
    return AlphabeticallistofproductsDetailsComponent;
    var _a, _b, _c, _d;
}());
exports.AlphabeticallistofproductsDetailsComponent = AlphabeticallistofproductsDetailsComponent;


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: AlphabeticallistofproductsListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: AlphabeticallistofproductsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var Alphabeticallistofproducts_service_1 = __webpack_require__(140);
var AlphabeticallistofproductsSearch_component_1 = __webpack_require__(364);
var AlphabeticallistofproductsListComponent = (function () {
    function AlphabeticallistofproductsListComponent(AlphabeticallistofproductsService, route, router, toastr) {
        this.AlphabeticallistofproductsService = AlphabeticallistofproductsService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "ProductID";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newAlphabeticallistofproducts = new Alphabeticallistofproducts_service_1.AlphabeticallistofproductsData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(AlphabeticallistofproductsListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AlphabeticallistofproductsListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    AlphabeticallistofproductsListComponent.prototype.ngOnInit = function () {
        // this.AlphabeticallistofproductsService.getAll().subscribe(record => this.AlphabeticallistofproductsList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getAlphabeticallistofproductsByPaging();
        /*
        this.AlphabeticallistofproductsList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    AlphabeticallistofproductsListComponent.prototype.getAlphabeticallistofproducts = function () {
        var _this = this;
        this.AlphabeticallistofproductsService.getAll()
            .subscribe(function (data) { return _this.AlphabeticallistofproductsList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on AlphabeticallistofproductsSearch Component
    AlphabeticallistofproductsListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getAlphabeticallistofproductsByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getAlphabeticallistofproductsByPaging();
    };
    AlphabeticallistofproductsListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getAlphabeticallistofproductsByPaging();
    };
    // Get records by paging
    AlphabeticallistofproductsListComponent.prototype.getAlphabeticallistofproductsByPaging = function () {
        var _this = this;
        this.AlphabeticallistofproductsService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.AlphabeticallistofproductsList = data.AlphabeticallistofproductsList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    AlphabeticallistofproductsListComponent.prototype.addAlphabeticallistofproducts = function () {
        this.AlphabeticallistofproductsService.addAlphabeticallistofproductsData(this.newAlphabeticallistofproducts).subscribe(function (record) { return console.log(record); });
        this.getAlphabeticallistofproducts();
    };
    // Updates existing record
    AlphabeticallistofproductsListComponent.prototype.updateAlphabeticallistofproducts = function () {
        this.AlphabeticallistofproductsService.updateAlphabeticallistofproductsData(this.selectedAlphabeticallistofproducts).subscribe(function (record) { return console.log(record); });
        this.getAlphabeticallistofproducts();
    };
    // Deletes record with specified id
    AlphabeticallistofproductsListComponent.prototype.deleteAlphabeticallistofproducts = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Alphabeticallistofproducts?') == true) {
            this.AlphabeticallistofproductsService.deleteAlphabeticallistofproducts(id)
                .subscribe(function (data) { return _this.getAlphabeticallistofproducts(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; });
        }
    };
    // Go to First Page
    AlphabeticallistofproductsListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getAlphabeticallistofproductsByPaging();
    };
    // Go to Previous Page
    AlphabeticallistofproductsListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getAlphabeticallistofproductsByPaging();
        }
    };
    // Go to Next Page
    AlphabeticallistofproductsListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getAlphabeticallistofproductsByPaging();
        }
    };
    // Go to Last Page
    AlphabeticallistofproductsListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getAlphabeticallistofproductsByPaging();
    };
    // Refresh - Go to First Page
    AlphabeticallistofproductsListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // On Edit - Go to Edit page
    AlphabeticallistofproductsListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/Alphabeticallistofproducts', item.ProductID]);
    };
    // On Details - Go to Details page
    AlphabeticallistofproductsListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/Alphabeticallistofproducts/Details', item.ProductID]);
    };
    // Set record as selected
    AlphabeticallistofproductsListComponent.prototype.SelectAlphabeticallistofproducts = function (item) {
        this.selectedAlphabeticallistofproducts = item;
    };
    // Submits form
    AlphabeticallistofproductsListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    AlphabeticallistofproductsListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], AlphabeticallistofproductsListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], AlphabeticallistofproductsListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(AlphabeticallistofproductsSearch_component_1.AlphabeticallistofproductsSearchComponent), 
        __metadata('design:type', (typeof (_a = typeof AlphabeticallistofproductsSearch_component_1.AlphabeticallistofproductsSearchComponent !== 'undefined' && AlphabeticallistofproductsSearch_component_1.AlphabeticallistofproductsSearchComponent) === 'function' && _a) || Object)
    ], AlphabeticallistofproductsListComponent.prototype, "filterComponent", void 0);
    AlphabeticallistofproductsListComponent = __decorate([
        core_1.Component({
            selector: 'my-Alphabeticallistofproducts',
            template: __webpack_require__(1018),
            providers: [Alphabeticallistofproducts_service_1.AlphabeticallistofproductsService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof Alphabeticallistofproducts_service_1.AlphabeticallistofproductsService !== 'undefined' && Alphabeticallistofproducts_service_1.AlphabeticallistofproductsService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], AlphabeticallistofproductsListComponent);
    return AlphabeticallistofproductsListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.AlphabeticallistofproductsListComponent = AlphabeticallistofproductsListComponent;


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: AlphabeticallistofproductsSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: AlphabeticallistofproductsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var Alphabeticallistofproducts_service_1 = __webpack_require__(140);
var AlphabeticallistofproductsSearchComponent = (function () {
    // Lookup Arrays
    function AlphabeticallistofproductsSearchComponent(route, router, AlphabeticallistofproductsService) {
        this.route = route;
        this.router = router;
        this.AlphabeticallistofproductsService = AlphabeticallistofproductsService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objAlphabeticallistofproducts = new Alphabeticallistofproducts_service_1.AlphabeticallistofproductsData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(AlphabeticallistofproductsSearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AlphabeticallistofproductsSearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    AlphabeticallistofproductsSearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    AlphabeticallistofproductsSearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objAlphabeticallistofproducts = new Alphabeticallistofproducts_service_1.AlphabeticallistofproductsData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    AlphabeticallistofproductsSearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    AlphabeticallistofproductsSearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objAlphabeticallistofproducts.ProductID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ProductID = " + this.objAlphabeticallistofproducts.ProductID;
            else
                this.filterExpression = "ProductID = " + this.objAlphabeticallistofproducts.ProductID;
        }
        if (this.objAlphabeticallistofproducts.ProductName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ProductName like '%" + this.objAlphabeticallistofproducts.ProductName + "%'";
            else
                this.filterExpression = "ProductName like '%" + this.objAlphabeticallistofproducts.ProductName + "%'";
        }
        if (this.objAlphabeticallistofproducts.SupplierID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objAlphabeticallistofproducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objAlphabeticallistofproducts.SupplierID;
        }
        if (this.objAlphabeticallistofproducts.CategoryID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objAlphabeticallistofproducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objAlphabeticallistofproducts.CategoryID;
        }
        if (this.objAlphabeticallistofproducts.QuantityPerUnit) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND QuantityPerUnit like '%" + this.objAlphabeticallistofproducts.QuantityPerUnit + "%'";
            else
                this.filterExpression = "QuantityPerUnit like '%" + this.objAlphabeticallistofproducts.QuantityPerUnit + "%'";
        }
        if (this.objAlphabeticallistofproducts.UnitPrice) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND UnitPrice = " + this.objAlphabeticallistofproducts.UnitPrice;
            else
                this.filterExpression = "UnitPrice = " + this.objAlphabeticallistofproducts.UnitPrice;
        }
        if (this.objAlphabeticallistofproducts.UnitsInStock) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND UnitsInStock = " + this.objAlphabeticallistofproducts.UnitsInStock;
            else
                this.filterExpression = "UnitsInStock = " + this.objAlphabeticallistofproducts.UnitsInStock;
        }
        if (this.objAlphabeticallistofproducts.UnitsOnOrder) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND UnitsOnOrder = " + this.objAlphabeticallistofproducts.UnitsOnOrder;
            else
                this.filterExpression = "UnitsOnOrder = " + this.objAlphabeticallistofproducts.UnitsOnOrder;
        }
        if (this.objAlphabeticallistofproducts.ReorderLevel) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ReorderLevel = " + this.objAlphabeticallistofproducts.ReorderLevel;
            else
                this.filterExpression = "ReorderLevel = " + this.objAlphabeticallistofproducts.ReorderLevel;
        }
        if (this.objAlphabeticallistofproducts.CategoryName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryName like '%" + this.objAlphabeticallistofproducts.CategoryName + "%'";
            else
                this.filterExpression = "CategoryName like '%" + this.objAlphabeticallistofproducts.CategoryName + "%'";
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    AlphabeticallistofproductsSearchComponent.prototype.getLookups = function () {
    };
    AlphabeticallistofproductsSearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], AlphabeticallistofproductsSearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], AlphabeticallistofproductsSearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], AlphabeticallistofproductsSearchComponent.prototype, "display", null);
    AlphabeticallistofproductsSearchComponent = __decorate([
        core_1.Component({
            selector: 'AlphabeticallistofproductsSearch',
            template: __webpack_require__(1019),
            providers: [Alphabeticallistofproducts_service_1.AlphabeticallistofproductsService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof Alphabeticallistofproducts_service_1.AlphabeticallistofproductsService !== 'undefined' && Alphabeticallistofproducts_service_1.AlphabeticallistofproductsService) === 'function' && _c) || Object])
    ], AlphabeticallistofproductsSearchComponent);
    return AlphabeticallistofproductsSearchComponent;
    var _a, _b, _c;
}());
exports.AlphabeticallistofproductsSearchComponent = AlphabeticallistofproductsSearchComponent;


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CategoriesAddComponent
 * Purpose		: This component allows to create new Categories record and save changes.
 * Dependency	: CategoriesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Categories_service_1 = __webpack_require__(41);
var CategoriesAddComponent = (function () {
    // Lookup Arrays
    function CategoriesAddComponent(route, router, toastr, CategoriesService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.CategoriesService = CategoriesService;
        this.objCategories = new Categories_service_1.CategoriesData();
    }
    Object.defineProperty(CategoriesAddComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CategoriesAddComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CategoriesAddComponent.prototype.ngOnInit = function () {
        this.objCategories = new Categories_service_1.CategoriesData();
        this.getLookups();
    };
    CategoriesAddComponent.prototype.addCategories = function () {
        var _this = this;
        this.CategoriesService.addCategoriesData(this.objCategories)
            .subscribe(function (record) { return _this.router.navigate(['/Categories']); }, function (error) { return _this.errorMessage = 'There was an error while adding record. Error: ' + error; }, function () {
            _this.toastr.success('Categories record added successfully...', 'Add Categories');
            console.log('Categories record added successfully...');
        });
    };
    CategoriesAddComponent.prototype.gotoCategories = function () {
        // let Id = this.objCategories ? this.objCategories.CategoryID : null;
        this.router.navigate(['/Categories']);
    };
    CategoriesAddComponent.prototype.getLookups = function () {
    };
    CategoriesAddComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CategoriesAddComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CategoriesAddComponent.prototype, "display", null);
    CategoriesAddComponent = __decorate([
        core_1.Component({
            selector: 'my-Categories-add',
            template: __webpack_require__(1020),
            providers: [Categories_service_1.CategoriesService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Categories_service_1.CategoriesService !== 'undefined' && Categories_service_1.CategoriesService) === 'function' && _d) || Object])
    ], CategoriesAddComponent);
    return CategoriesAddComponent;
    var _a, _b, _c, _d;
}());
exports.CategoriesAddComponent = CategoriesAddComponent;


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Categories_service_1 = __webpack_require__(41);
var CategoriesDetailsComponent = (function () {
    // Lookup Arrays
    function CategoriesDetailsComponent(route, router, toastr, CategoriesService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.CategoriesService = CategoriesService;
        // this.id = parseInt(params.get('id'));
        this.objCategories = new Categories_service_1.CategoriesData();
    }
    Object.defineProperty(CategoriesDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CategoriesDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CategoriesDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.CategoriesService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objCategories = item; });
        this.getLookups();
    };
    CategoriesDetailsComponent.prototype.deleteCategories = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Categories?') == true) {
            this.CategoriesService.deleteCategories(this.objCategories.CategoryID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/Categories']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('Categories record deleted successfully...'); });
        }
    };
    CategoriesDetailsComponent.prototype.gotoCategoriesEdit = function () {
        this.router.navigate(['/Categories', this.objCategories.CategoryID]);
    };
    CategoriesDetailsComponent.prototype.gotoCategories = function () {
        this.router.navigate(['/Categories']);
    };
    CategoriesDetailsComponent.prototype.getLookups = function () {
    };
    CategoriesDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CategoriesDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CategoriesDetailsComponent.prototype, "display", null);
    CategoriesDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1021),
            providers: [Categories_service_1.CategoriesService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Categories_service_1.CategoriesService !== 'undefined' && Categories_service_1.CategoriesService) === 'function' && _d) || Object])
    ], CategoriesDetailsComponent);
    return CategoriesDetailsComponent;
    var _a, _b, _c, _d;
}());
exports.CategoriesDetailsComponent = CategoriesDetailsComponent;


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CategoriesEditComponent
 * Purpose		: This component retrieves data for the specified record id and allows to edit and save changes.
 * Dependency	: CategoriesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Categories_service_1 = __webpack_require__(41);
var CategoriesEditComponent = (function () {
    // Lookup Arrays
    function CategoriesEditComponent(route, router, toastr, CategoriesService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.CategoriesService = CategoriesService;
        // this.id = parseInt(params.get('id'));
        this.objCategories = new Categories_service_1.CategoriesData();
    }
    Object.defineProperty(CategoriesEditComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CategoriesEditComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CategoriesEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.CategoriesService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objCategories = item; });
        this.getLookups();
    };
    CategoriesEditComponent.prototype.updateCategories = function () {
        var _this = this;
        this.CategoriesService.updateCategoriesData(this.objCategories)
            .subscribe(function (record) { return _this.router.navigate(['/Categories']); }, function (error) { return _this.errorMessage = 'There was an error while updating record. Error: ' + error; }, function () {
            _this.toastr.success('Categories record updated successfully...', 'Edit Categories');
            console.log('Categories record updated successfully...');
        });
    };
    CategoriesEditComponent.prototype.deleteCategories = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Categories?') == true) {
            this.CategoriesService.deleteCategories(this.objCategories.CategoryID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/Categories']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('Categories record deleted successfully...', 'Delete Categories');
                console.log('Categories record deleted successfully...');
            });
        }
    };
    CategoriesEditComponent.prototype.gotoCategories = function () {
        var Id = this.objCategories ? this.objCategories.CategoryID : null;
        this.router.navigate(['/Categories']);
    };
    CategoriesEditComponent.prototype.getLookups = function () {
    };
    CategoriesEditComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CategoriesEditComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CategoriesEditComponent.prototype, "display", null);
    CategoriesEditComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1022),
            providers: [Categories_service_1.CategoriesService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Categories_service_1.CategoriesService !== 'undefined' && Categories_service_1.CategoriesService) === 'function' && _d) || Object])
    ], CategoriesEditComponent);
    return CategoriesEditComponent;
    var _a, _b, _c, _d;
}());
exports.CategoriesEditComponent = CategoriesEditComponent;


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CategoriesListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: CategoriesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var Categories_service_1 = __webpack_require__(41);
var CategoriesSearch_component_1 = __webpack_require__(369);
var CategoriesListComponent = (function () {
    function CategoriesListComponent(CategoriesService, route, router, toastr) {
        this.CategoriesService = CategoriesService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "CategoryID";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newCategories = new Categories_service_1.CategoriesData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(CategoriesListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CategoriesListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CategoriesListComponent.prototype.ngOnInit = function () {
        //this.CategoriesService.getAll().subscribe(record => this.CategoriesList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getCategoriesByPaging();
        /*
        this.CategoriesList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    CategoriesListComponent.prototype.getCategories = function () {
        var _this = this;
        this.CategoriesService.getAll()
            .subscribe(function (data) { return _this.CategoriesList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on CategoriesSearch Component
    CategoriesListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getCategoriesByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getCategoriesByPaging();
    };
    CategoriesListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getCategoriesByPaging();
    };
    // Get records by paging
    CategoriesListComponent.prototype.getCategoriesByPaging = function () {
        var _this = this;
        this.CategoriesService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.CategoriesList = data.CategoriesList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    CategoriesListComponent.prototype.addCategories = function () {
        this.CategoriesService.addCategoriesData(this.newCategories).subscribe(function (record) { return console.log(record); });
        this.getCategories();
    };
    // Updates existing record
    CategoriesListComponent.prototype.updateCategories = function () {
        this.CategoriesService.updateCategoriesData(this.selectedCategories).subscribe(function (record) { return console.log(record); });
        this.getCategories();
    };
    // Deletes record with specified id
    CategoriesListComponent.prototype.deleteCategories = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Categories?') == true) {
            this.CategoriesService.deleteCategories(id)
                .subscribe(function (data) { return _this.getCategories(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('Categories record deleted successfully...', 'Delete Categories');
                console.log('Categories record deleted successfully...');
            });
        }
    };
    // Go to First Page
    CategoriesListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getCategoriesByPaging();
    };
    // Go to Previous Page
    CategoriesListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getCategoriesByPaging();
        }
    };
    // Refresh - Go to First Page
    CategoriesListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // Go to Next Page
    CategoriesListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getCategoriesByPaging();
        }
    };
    // Go to Last Page
    CategoriesListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getCategoriesByPaging();
    };
    // On Edit - Go to Edit page
    CategoriesListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/Categories', item.CategoryID]);
    };
    // On Details - Go to Details page
    CategoriesListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/Categories/Details', item.CategoryID]);
    };
    // Set record as selected
    CategoriesListComponent.prototype.SelectCategories = function (item) {
        this.selectedCategories = item;
    };
    // Submits form
    CategoriesListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    CategoriesListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CategoriesListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CategoriesListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(CategoriesSearch_component_1.CategoriesSearchComponent), 
        __metadata('design:type', (typeof (_a = typeof CategoriesSearch_component_1.CategoriesSearchComponent !== 'undefined' && CategoriesSearch_component_1.CategoriesSearchComponent) === 'function' && _a) || Object)
    ], CategoriesListComponent.prototype, "filterComponent", void 0);
    CategoriesListComponent = __decorate([
        core_1.Component({
            selector: 'my-Categories',
            template: __webpack_require__(1023),
            providers: [Categories_service_1.CategoriesService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof Categories_service_1.CategoriesService !== 'undefined' && Categories_service_1.CategoriesService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], CategoriesListComponent);
    return CategoriesListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.CategoriesListComponent = CategoriesListComponent;


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CategoriesSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: CategoriesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var Categories_service_1 = __webpack_require__(41);
var CategoriesSearchComponent = (function () {
    // Lookup Arrays
    function CategoriesSearchComponent(route, router, CategoriesService) {
        this.route = route;
        this.router = router;
        this.CategoriesService = CategoriesService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objCategories = new Categories_service_1.CategoriesData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(CategoriesSearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CategoriesSearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CategoriesSearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    CategoriesSearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objCategories = new Categories_service_1.CategoriesData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    CategoriesSearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    CategoriesSearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objCategories.CategoryID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objCategories.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objCategories.CategoryID;
        }
        if (this.objCategories.CategoryName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryName like '%" + this.objCategories.CategoryName + "%'";
            else
                this.filterExpression = "CategoryName like '%" + this.objCategories.CategoryName + "%'";
        }
        if (this.objCategories.Description) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Description like '%" + this.objCategories.Description + "%'";
            else
                this.filterExpression = "Description like '%" + this.objCategories.Description + "%'";
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    CategoriesSearchComponent.prototype.getLookups = function () {
    };
    CategoriesSearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], CategoriesSearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CategoriesSearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CategoriesSearchComponent.prototype, "display", null);
    CategoriesSearchComponent = __decorate([
        core_1.Component({
            selector: 'CategoriesSearch',
            template: __webpack_require__(1024),
            providers: [Categories_service_1.CategoriesService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof Categories_service_1.CategoriesService !== 'undefined' && Categories_service_1.CategoriesService) === 'function' && _c) || Object])
    ], CategoriesSearchComponent);
    return CategoriesSearchComponent;
    var _a, _b, _c;
}());
exports.CategoriesSearchComponent = CategoriesSearchComponent;


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CategorySalesfor1997AddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: CategorySalesfor1997Service
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var CategorySalesfor1997_service_1 = __webpack_require__(141);
var CategorySalesfor1997DetailsComponent = (function () {
    // Lookup Arrays
    function CategorySalesfor1997DetailsComponent(route, router, toastr, CategorySalesfor1997Service) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.CategorySalesfor1997Service = CategorySalesfor1997Service;
        // this.id = parseInt(params.get('id'));
        this.objCategorySalesfor1997 = new CategorySalesfor1997_service_1.CategorySalesfor1997Data();
    }
    Object.defineProperty(CategorySalesfor1997DetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CategorySalesfor1997DetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CategorySalesfor1997DetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.CategorySalesfor1997Service.getByID(params['id']); })
            .subscribe(function (item) { return _this.objCategorySalesfor1997 = item; });
        this.getLookups();
    };
    CategorySalesfor1997DetailsComponent.prototype.deleteCategorySalesfor1997 = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this CategorySalesfor1997?') == true) {
            this.CategorySalesfor1997Service.deleteCategorySalesfor1997(this.objCategorySalesfor1997.CategoryName.toString())
                .subscribe(function (record) { return _this.router.navigate(['/CategorySalesfor1997']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('CategorySalesfor1997 record deleted successfully...'); });
        }
    };
    CategorySalesfor1997DetailsComponent.prototype.gotoCategorySalesfor1997Edit = function () {
        this.router.navigate(['/CategorySalesfor1997', this.objCategorySalesfor1997.CategoryName]);
    };
    CategorySalesfor1997DetailsComponent.prototype.gotoCategorySalesfor1997 = function () {
        this.router.navigate(['/CategorySalesfor1997']);
    };
    CategorySalesfor1997DetailsComponent.prototype.getLookups = function () {
    };
    CategorySalesfor1997DetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CategorySalesfor1997DetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CategorySalesfor1997DetailsComponent.prototype, "display", null);
    CategorySalesfor1997DetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1025),
            providers: [CategorySalesfor1997_service_1.CategorySalesfor1997Service
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof CategorySalesfor1997_service_1.CategorySalesfor1997Service !== 'undefined' && CategorySalesfor1997_service_1.CategorySalesfor1997Service) === 'function' && _d) || Object])
    ], CategorySalesfor1997DetailsComponent);
    return CategorySalesfor1997DetailsComponent;
    var _a, _b, _c, _d;
}());
exports.CategorySalesfor1997DetailsComponent = CategorySalesfor1997DetailsComponent;


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CategorySalesfor1997ListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: CategorySalesfor1997Service
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var CategorySalesfor1997_service_1 = __webpack_require__(141);
var CategorySalesfor1997Search_component_1 = __webpack_require__(372);
var CategorySalesfor1997ListComponent = (function () {
    function CategorySalesfor1997ListComponent(CategorySalesfor1997Service, route, router, toastr) {
        this.CategorySalesfor1997Service = CategorySalesfor1997Service;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "CategoryName";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newCategorySalesfor1997 = new CategorySalesfor1997_service_1.CategorySalesfor1997Data();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(CategorySalesfor1997ListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CategorySalesfor1997ListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CategorySalesfor1997ListComponent.prototype.ngOnInit = function () {
        // this.CategorySalesfor1997Service.getAll().subscribe(record => this.CategorySalesfor1997List=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getCategorySalesfor1997ByPaging();
        /*
        this.CategorySalesfor1997List = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    CategorySalesfor1997ListComponent.prototype.getCategorySalesfor1997 = function () {
        var _this = this;
        this.CategorySalesfor1997Service.getAll()
            .subscribe(function (data) { return _this.CategorySalesfor1997List = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on CategorySalesfor1997Search Component
    CategorySalesfor1997ListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getCategorySalesfor1997ByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getCategorySalesfor1997ByPaging();
    };
    CategorySalesfor1997ListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getCategorySalesfor1997ByPaging();
    };
    // Get records by paging
    CategorySalesfor1997ListComponent.prototype.getCategorySalesfor1997ByPaging = function () {
        var _this = this;
        this.CategorySalesfor1997Service.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.CategorySalesfor1997List = data.CategorySalesfor1997List;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    CategorySalesfor1997ListComponent.prototype.addCategorySalesfor1997 = function () {
        this.CategorySalesfor1997Service.addCategorySalesfor1997Data(this.newCategorySalesfor1997).subscribe(function (record) { return console.log(record); });
        this.getCategorySalesfor1997();
    };
    // Updates existing record
    CategorySalesfor1997ListComponent.prototype.updateCategorySalesfor1997 = function () {
        this.CategorySalesfor1997Service.updateCategorySalesfor1997Data(this.selectedCategorySalesfor1997).subscribe(function (record) { return console.log(record); });
        this.getCategorySalesfor1997();
    };
    // Deletes record with specified id
    CategorySalesfor1997ListComponent.prototype.deleteCategorySalesfor1997 = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this CategorySalesfor1997?') == true) {
            this.CategorySalesfor1997Service.deleteCategorySalesfor1997(id)
                .subscribe(function (data) { return _this.getCategorySalesfor1997(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; });
        }
    };
    // Go to First Page
    CategorySalesfor1997ListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getCategorySalesfor1997ByPaging();
    };
    // Go to Previous Page
    CategorySalesfor1997ListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getCategorySalesfor1997ByPaging();
        }
    };
    // Go to Next Page
    CategorySalesfor1997ListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getCategorySalesfor1997ByPaging();
        }
    };
    // Go to Last Page
    CategorySalesfor1997ListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getCategorySalesfor1997ByPaging();
    };
    // Refresh - Go to First Page
    CategorySalesfor1997ListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // On Edit - Go to Edit page
    CategorySalesfor1997ListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/CategorySalesfor1997', item.CategoryName]);
    };
    // On Details - Go to Details page
    CategorySalesfor1997ListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/CategorySalesfor1997/Details', item.CategoryName]);
    };
    // Set record as selected
    CategorySalesfor1997ListComponent.prototype.SelectCategorySalesfor1997 = function (item) {
        this.selectedCategorySalesfor1997 = item;
    };
    // Submits form
    CategorySalesfor1997ListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    CategorySalesfor1997ListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CategorySalesfor1997ListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CategorySalesfor1997ListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(CategorySalesfor1997Search_component_1.CategorySalesfor1997SearchComponent), 
        __metadata('design:type', (typeof (_a = typeof CategorySalesfor1997Search_component_1.CategorySalesfor1997SearchComponent !== 'undefined' && CategorySalesfor1997Search_component_1.CategorySalesfor1997SearchComponent) === 'function' && _a) || Object)
    ], CategorySalesfor1997ListComponent.prototype, "filterComponent", void 0);
    CategorySalesfor1997ListComponent = __decorate([
        core_1.Component({
            selector: 'my-CategorySalesfor1997',
            template: __webpack_require__(1026),
            providers: [CategorySalesfor1997_service_1.CategorySalesfor1997Service],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof CategorySalesfor1997_service_1.CategorySalesfor1997Service !== 'undefined' && CategorySalesfor1997_service_1.CategorySalesfor1997Service) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], CategorySalesfor1997ListComponent);
    return CategorySalesfor1997ListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.CategorySalesfor1997ListComponent = CategorySalesfor1997ListComponent;


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CategorySalesfor1997SearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: CategorySalesfor1997Service
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var CategorySalesfor1997_service_1 = __webpack_require__(141);
var CategorySalesfor1997SearchComponent = (function () {
    // Lookup Arrays
    function CategorySalesfor1997SearchComponent(route, router, CategorySalesfor1997Service) {
        this.route = route;
        this.router = router;
        this.CategorySalesfor1997Service = CategorySalesfor1997Service;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objCategorySalesfor1997 = new CategorySalesfor1997_service_1.CategorySalesfor1997Data();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(CategorySalesfor1997SearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CategorySalesfor1997SearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CategorySalesfor1997SearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    CategorySalesfor1997SearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objCategorySalesfor1997 = new CategorySalesfor1997_service_1.CategorySalesfor1997Data();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    CategorySalesfor1997SearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    CategorySalesfor1997SearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objCategorySalesfor1997.CategoryName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryName like '%" + this.objCategorySalesfor1997.CategoryName + "%'";
            else
                this.filterExpression = "CategoryName like '%" + this.objCategorySalesfor1997.CategoryName + "%'";
        }
        if (this.objCategorySalesfor1997.CategorySales) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategorySales = " + this.objCategorySalesfor1997.CategorySales;
            else
                this.filterExpression = "CategorySales = " + this.objCategorySalesfor1997.CategorySales;
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    CategorySalesfor1997SearchComponent.prototype.getLookups = function () {
    };
    CategorySalesfor1997SearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], CategorySalesfor1997SearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CategorySalesfor1997SearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CategorySalesfor1997SearchComponent.prototype, "display", null);
    CategorySalesfor1997SearchComponent = __decorate([
        core_1.Component({
            selector: 'CategorySalesfor1997Search',
            template: __webpack_require__(1027),
            providers: [CategorySalesfor1997_service_1.CategorySalesfor1997Service
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof CategorySalesfor1997_service_1.CategorySalesfor1997Service !== 'undefined' && CategorySalesfor1997_service_1.CategorySalesfor1997Service) === 'function' && _c) || Object])
    ], CategorySalesfor1997SearchComponent);
    return CategorySalesfor1997SearchComponent;
    var _a, _b, _c;
}());
exports.CategorySalesfor1997SearchComponent = CategorySalesfor1997SearchComponent;


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CurrentProductListAddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: CurrentProductListService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var CurrentProductList_service_1 = __webpack_require__(142);
var CurrentProductListDetailsComponent = (function () {
    // Lookup Arrays
    function CurrentProductListDetailsComponent(route, router, toastr, CurrentProductListService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.CurrentProductListService = CurrentProductListService;
        // this.id = parseInt(params.get('id'));
        this.objCurrentProductList = new CurrentProductList_service_1.CurrentProductListData();
    }
    Object.defineProperty(CurrentProductListDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CurrentProductListDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CurrentProductListDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.CurrentProductListService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objCurrentProductList = item; });
        this.getLookups();
    };
    CurrentProductListDetailsComponent.prototype.deleteCurrentProductList = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this CurrentProductList?') == true) {
            this.CurrentProductListService.deleteCurrentProductList(this.objCurrentProductList.ProductID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/CurrentProductList']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('CurrentProductList record deleted successfully...'); });
        }
    };
    CurrentProductListDetailsComponent.prototype.gotoCurrentProductListEdit = function () {
        this.router.navigate(['/CurrentProductList', this.objCurrentProductList.ProductID]);
    };
    CurrentProductListDetailsComponent.prototype.gotoCurrentProductList = function () {
        this.router.navigate(['/CurrentProductList']);
    };
    CurrentProductListDetailsComponent.prototype.getLookups = function () {
    };
    CurrentProductListDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CurrentProductListDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CurrentProductListDetailsComponent.prototype, "display", null);
    CurrentProductListDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1028),
            providers: [CurrentProductList_service_1.CurrentProductListService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof CurrentProductList_service_1.CurrentProductListService !== 'undefined' && CurrentProductList_service_1.CurrentProductListService) === 'function' && _d) || Object])
    ], CurrentProductListDetailsComponent);
    return CurrentProductListDetailsComponent;
    var _a, _b, _c, _d;
}());
exports.CurrentProductListDetailsComponent = CurrentProductListDetailsComponent;


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CurrentProductListListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: CurrentProductListService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var CurrentProductList_service_1 = __webpack_require__(142);
var CurrentProductListSearch_component_1 = __webpack_require__(375);
var CurrentProductListListComponent = (function () {
    function CurrentProductListListComponent(CurrentProductListService, route, router, toastr) {
        this.CurrentProductListService = CurrentProductListService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "ProductID";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newCurrentProductList = new CurrentProductList_service_1.CurrentProductListData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(CurrentProductListListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CurrentProductListListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CurrentProductListListComponent.prototype.ngOnInit = function () {
        // this.CurrentProductListService.getAll().subscribe(record => this.CurrentProductListList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getCurrentProductListByPaging();
        /*
        this.CurrentProductListList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    CurrentProductListListComponent.prototype.getCurrentProductList = function () {
        var _this = this;
        this.CurrentProductListService.getAll()
            .subscribe(function (data) { return _this.CurrentProductListList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on CurrentProductListSearch Component
    CurrentProductListListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getCurrentProductListByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getCurrentProductListByPaging();
    };
    CurrentProductListListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getCurrentProductListByPaging();
    };
    // Get records by paging
    CurrentProductListListComponent.prototype.getCurrentProductListByPaging = function () {
        var _this = this;
        this.CurrentProductListService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.CurrentProductListList = data.CurrentProductListList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    CurrentProductListListComponent.prototype.addCurrentProductList = function () {
        this.CurrentProductListService.addCurrentProductListData(this.newCurrentProductList).subscribe(function (record) { return console.log(record); });
        this.getCurrentProductList();
    };
    // Updates existing record
    CurrentProductListListComponent.prototype.updateCurrentProductList = function () {
        this.CurrentProductListService.updateCurrentProductListData(this.selectedCurrentProductList).subscribe(function (record) { return console.log(record); });
        this.getCurrentProductList();
    };
    // Deletes record with specified id
    CurrentProductListListComponent.prototype.deleteCurrentProductList = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this CurrentProductList?') == true) {
            this.CurrentProductListService.deleteCurrentProductList(id)
                .subscribe(function (data) { return _this.getCurrentProductList(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; });
        }
    };
    // Go to First Page
    CurrentProductListListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getCurrentProductListByPaging();
    };
    // Go to Previous Page
    CurrentProductListListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getCurrentProductListByPaging();
        }
    };
    // Go to Next Page
    CurrentProductListListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getCurrentProductListByPaging();
        }
    };
    // Go to Last Page
    CurrentProductListListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getCurrentProductListByPaging();
    };
    // Refresh - Go to First Page
    CurrentProductListListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // On Edit - Go to Edit page
    CurrentProductListListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/CurrentProductList', item.ProductID]);
    };
    // On Details - Go to Details page
    CurrentProductListListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/CurrentProductList/Details', item.ProductID]);
    };
    // Set record as selected
    CurrentProductListListComponent.prototype.SelectCurrentProductList = function (item) {
        this.selectedCurrentProductList = item;
    };
    // Submits form
    CurrentProductListListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    CurrentProductListListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CurrentProductListListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CurrentProductListListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(CurrentProductListSearch_component_1.CurrentProductListSearchComponent), 
        __metadata('design:type', (typeof (_a = typeof CurrentProductListSearch_component_1.CurrentProductListSearchComponent !== 'undefined' && CurrentProductListSearch_component_1.CurrentProductListSearchComponent) === 'function' && _a) || Object)
    ], CurrentProductListListComponent.prototype, "filterComponent", void 0);
    CurrentProductListListComponent = __decorate([
        core_1.Component({
            selector: 'my-CurrentProductList',
            template: __webpack_require__(1029),
            providers: [CurrentProductList_service_1.CurrentProductListService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof CurrentProductList_service_1.CurrentProductListService !== 'undefined' && CurrentProductList_service_1.CurrentProductListService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], CurrentProductListListComponent);
    return CurrentProductListListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.CurrentProductListListComponent = CurrentProductListListComponent;


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CurrentProductListSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: CurrentProductListService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var CurrentProductList_service_1 = __webpack_require__(142);
var CurrentProductListSearchComponent = (function () {
    // Lookup Arrays
    function CurrentProductListSearchComponent(route, router, CurrentProductListService) {
        this.route = route;
        this.router = router;
        this.CurrentProductListService = CurrentProductListService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objCurrentProductList = new CurrentProductList_service_1.CurrentProductListData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(CurrentProductListSearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CurrentProductListSearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CurrentProductListSearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    CurrentProductListSearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objCurrentProductList = new CurrentProductList_service_1.CurrentProductListData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    CurrentProductListSearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    CurrentProductListSearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objCurrentProductList.ProductID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ProductID = " + this.objCurrentProductList.ProductID;
            else
                this.filterExpression = "ProductID = " + this.objCurrentProductList.ProductID;
        }
        if (this.objCurrentProductList.ProductName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ProductName like '%" + this.objCurrentProductList.ProductName + "%'";
            else
                this.filterExpression = "ProductName like '%" + this.objCurrentProductList.ProductName + "%'";
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    CurrentProductListSearchComponent.prototype.getLookups = function () {
    };
    CurrentProductListSearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], CurrentProductListSearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CurrentProductListSearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CurrentProductListSearchComponent.prototype, "display", null);
    CurrentProductListSearchComponent = __decorate([
        core_1.Component({
            selector: 'CurrentProductListSearch',
            template: __webpack_require__(1030),
            providers: [CurrentProductList_service_1.CurrentProductListService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof CurrentProductList_service_1.CurrentProductListService !== 'undefined' && CurrentProductList_service_1.CurrentProductListService) === 'function' && _c) || Object])
    ], CurrentProductListSearchComponent);
    return CurrentProductListSearchComponent;
    var _a, _b, _c;
}());
exports.CurrentProductListSearchComponent = CurrentProductListSearchComponent;


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerCustomerDemoAddComponent
 * Purpose		: This component allows to create new CustomerCustomerDemo record and save changes.
 * Dependency	: CustomerCustomerDemoService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var CustomerCustomerDemo_service_1 = __webpack_require__(79);
var Customers_service_1 = __webpack_require__(42);
var CustomerCustomerDemoAddComponent = (function () {
    function CustomerCustomerDemoAddComponent(route, router, toastr, CustomerCustomerDemoService, CustomersService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.CustomerCustomerDemoService = CustomerCustomerDemoService;
        this.CustomersService = CustomersService;
        this.objCustomerCustomerDemo = new CustomerCustomerDemo_service_1.CustomerCustomerDemoData();
    }
    Object.defineProperty(CustomerCustomerDemoAddComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerCustomerDemoAddComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CustomerCustomerDemoAddComponent.prototype.ngOnInit = function () {
        this.objCustomerCustomerDemo = new CustomerCustomerDemo_service_1.CustomerCustomerDemoData();
        this.getLookups();
    };
    CustomerCustomerDemoAddComponent.prototype.addCustomerCustomerDemo = function () {
        var _this = this;
        this.CustomerCustomerDemoService.addCustomerCustomerDemoData(this.objCustomerCustomerDemo)
            .subscribe(function (record) { return _this.router.navigate(['/CustomerCustomerDemo']); }, function (error) { return _this.errorMessage = 'There was an error while adding record. Error: ' + error; }, function () {
            _this.toastr.success('CustomerCustomerDemo record added successfully...', 'Add CustomerCustomerDemo');
            console.log('CustomerCustomerDemo record added successfully...');
        });
    };
    CustomerCustomerDemoAddComponent.prototype.gotoCustomerCustomerDemo = function () {
        // let Id = this.objCustomerCustomerDemo ? this.objCustomerCustomerDemo.CustomerID : null;
        this.router.navigate(['/CustomerCustomerDemo']);
    };
    // Get Lookup List for Customers
    CustomerCustomerDemoAddComponent.prototype.getCustomers = function () {
        var _this = this;
        this.CustomersService.getAll().subscribe(function (records) { return _this.CustomersList = records; });
    };
    CustomerCustomerDemoAddComponent.prototype.getLookups = function () {
        this.getCustomers();
    };
    CustomerCustomerDemoAddComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CustomerCustomerDemoAddComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CustomerCustomerDemoAddComponent.prototype, "display", null);
    CustomerCustomerDemoAddComponent = __decorate([
        core_1.Component({
            selector: 'my-CustomerCustomerDemo-add',
            template: __webpack_require__(1031),
            providers: [CustomerCustomerDemo_service_1.CustomerCustomerDemoService,
                Customers_service_1.CustomersService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof CustomerCustomerDemo_service_1.CustomerCustomerDemoService !== 'undefined' && CustomerCustomerDemo_service_1.CustomerCustomerDemoService) === 'function' && _d) || Object, (typeof (_e = typeof Customers_service_1.CustomersService !== 'undefined' && Customers_service_1.CustomersService) === 'function' && _e) || Object])
    ], CustomerCustomerDemoAddComponent);
    return CustomerCustomerDemoAddComponent;
    var _a, _b, _c, _d, _e;
}());
exports.CustomerCustomerDemoAddComponent = CustomerCustomerDemoAddComponent;


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var CustomerCustomerDemo_service_1 = __webpack_require__(79);
var Customers_service_1 = __webpack_require__(42);
var CustomerCustomerDemoDetailsComponent = (function () {
    function CustomerCustomerDemoDetailsComponent(route, router, toastr, CustomerCustomerDemoService, CustomersService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.CustomerCustomerDemoService = CustomerCustomerDemoService;
        this.CustomersService = CustomersService;
        // this.id = parseInt(params.get('id'));
        this.objCustomerCustomerDemo = new CustomerCustomerDemo_service_1.CustomerCustomerDemoData();
    }
    Object.defineProperty(CustomerCustomerDemoDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerCustomerDemoDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CustomerCustomerDemoDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.CustomerCustomerDemoService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objCustomerCustomerDemo = item; });
        this.getLookups();
    };
    CustomerCustomerDemoDetailsComponent.prototype.deleteCustomerCustomerDemo = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this CustomerCustomerDemo?') == true) {
            this.CustomerCustomerDemoService.deleteCustomerCustomerDemo(this.objCustomerCustomerDemo.CustomerID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/CustomerCustomerDemo']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('CustomerCustomerDemo record deleted successfully...'); });
        }
    };
    CustomerCustomerDemoDetailsComponent.prototype.gotoCustomerCustomerDemoEdit = function () {
        this.router.navigate(['/CustomerCustomerDemo', this.objCustomerCustomerDemo.CustomerID]);
    };
    CustomerCustomerDemoDetailsComponent.prototype.gotoCustomerCustomerDemo = function () {
        this.router.navigate(['/CustomerCustomerDemo']);
    };
    // Get Lookup List for Customers
    CustomerCustomerDemoDetailsComponent.prototype.getCustomers = function () {
        var _this = this;
        this.CustomersService.getAll().subscribe(function (records) { return _this.CustomersList = records; });
    };
    CustomerCustomerDemoDetailsComponent.prototype.getLookups = function () {
        this.getCustomers();
    };
    CustomerCustomerDemoDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CustomerCustomerDemoDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CustomerCustomerDemoDetailsComponent.prototype, "display", null);
    CustomerCustomerDemoDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1032),
            providers: [CustomerCustomerDemo_service_1.CustomerCustomerDemoService,
                Customers_service_1.CustomersService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof CustomerCustomerDemo_service_1.CustomerCustomerDemoService !== 'undefined' && CustomerCustomerDemo_service_1.CustomerCustomerDemoService) === 'function' && _d) || Object, (typeof (_e = typeof Customers_service_1.CustomersService !== 'undefined' && Customers_service_1.CustomersService) === 'function' && _e) || Object])
    ], CustomerCustomerDemoDetailsComponent);
    return CustomerCustomerDemoDetailsComponent;
    var _a, _b, _c, _d, _e;
}());
exports.CustomerCustomerDemoDetailsComponent = CustomerCustomerDemoDetailsComponent;


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerCustomerDemoEditComponent
 * Purpose		: This component retrieves data for the specified record id and allows to edit and save changes.
 * Dependency	: CustomerCustomerDemoService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var CustomerCustomerDemo_service_1 = __webpack_require__(79);
var Customers_service_1 = __webpack_require__(42);
var CustomerCustomerDemoEditComponent = (function () {
    function CustomerCustomerDemoEditComponent(route, router, toastr, CustomerCustomerDemoService, CustomersService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.CustomerCustomerDemoService = CustomerCustomerDemoService;
        this.CustomersService = CustomersService;
        // this.id = parseInt(params.get('id'));
        this.objCustomerCustomerDemo = new CustomerCustomerDemo_service_1.CustomerCustomerDemoData();
    }
    Object.defineProperty(CustomerCustomerDemoEditComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerCustomerDemoEditComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CustomerCustomerDemoEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.CustomerCustomerDemoService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objCustomerCustomerDemo = item; });
        this.getLookups();
    };
    CustomerCustomerDemoEditComponent.prototype.updateCustomerCustomerDemo = function () {
        var _this = this;
        this.CustomerCustomerDemoService.updateCustomerCustomerDemoData(this.objCustomerCustomerDemo)
            .subscribe(function (record) { return _this.router.navigate(['/CustomerCustomerDemo']); }, function (error) { return _this.errorMessage = 'There was an error while updating record. Error: ' + error; }, function () {
            _this.toastr.success('CustomerCustomerDemo record updated successfully...', 'Edit CustomerCustomerDemo');
            console.log('CustomerCustomerDemo record updated successfully...');
        });
    };
    CustomerCustomerDemoEditComponent.prototype.deleteCustomerCustomerDemo = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this CustomerCustomerDemo?') == true) {
            this.CustomerCustomerDemoService.deleteCustomerCustomerDemo(this.objCustomerCustomerDemo.CustomerID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/CustomerCustomerDemo']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('CustomerCustomerDemo record deleted successfully...', 'Delete CustomerCustomerDemo');
                console.log('CustomerCustomerDemo record deleted successfully...');
            });
        }
    };
    CustomerCustomerDemoEditComponent.prototype.gotoCustomerCustomerDemo = function () {
        var Id = this.objCustomerCustomerDemo ? this.objCustomerCustomerDemo.CustomerID : null;
        this.router.navigate(['/CustomerCustomerDemo']);
    };
    // Get Lookup List for Customers
    CustomerCustomerDemoEditComponent.prototype.getCustomers = function () {
        var _this = this;
        this.CustomersService.getAll().subscribe(function (records) { return _this.CustomersList = records; });
    };
    CustomerCustomerDemoEditComponent.prototype.getLookups = function () {
        this.getCustomers();
    };
    CustomerCustomerDemoEditComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CustomerCustomerDemoEditComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CustomerCustomerDemoEditComponent.prototype, "display", null);
    CustomerCustomerDemoEditComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1033),
            providers: [CustomerCustomerDemo_service_1.CustomerCustomerDemoService,
                Customers_service_1.CustomersService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof CustomerCustomerDemo_service_1.CustomerCustomerDemoService !== 'undefined' && CustomerCustomerDemo_service_1.CustomerCustomerDemoService) === 'function' && _d) || Object, (typeof (_e = typeof Customers_service_1.CustomersService !== 'undefined' && Customers_service_1.CustomersService) === 'function' && _e) || Object])
    ], CustomerCustomerDemoEditComponent);
    return CustomerCustomerDemoEditComponent;
    var _a, _b, _c, _d, _e;
}());
exports.CustomerCustomerDemoEditComponent = CustomerCustomerDemoEditComponent;


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerCustomerDemoListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: CustomerCustomerDemoService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var CustomerCustomerDemo_service_1 = __webpack_require__(79);
var CustomerCustomerDemoSearch_component_1 = __webpack_require__(380);
var CustomerCustomerDemoListComponent = (function () {
    function CustomerCustomerDemoListComponent(CustomerCustomerDemoService, route, router, toastr) {
        this.CustomerCustomerDemoService = CustomerCustomerDemoService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "CustomerID";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newCustomerCustomerDemo = new CustomerCustomerDemo_service_1.CustomerCustomerDemoData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(CustomerCustomerDemoListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerCustomerDemoListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CustomerCustomerDemoListComponent.prototype.ngOnInit = function () {
        //this.CustomerCustomerDemoService.getAll().subscribe(record => this.CustomerCustomerDemoList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getCustomerCustomerDemoByPaging();
        /*
        this.CustomerCustomerDemoList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    CustomerCustomerDemoListComponent.prototype.getCustomerCustomerDemo = function () {
        var _this = this;
        this.CustomerCustomerDemoService.getAll()
            .subscribe(function (data) { return _this.CustomerCustomerDemoList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on CustomerCustomerDemoSearch Component
    CustomerCustomerDemoListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getCustomerCustomerDemoByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getCustomerCustomerDemoByPaging();
    };
    CustomerCustomerDemoListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getCustomerCustomerDemoByPaging();
    };
    // Get records by paging
    CustomerCustomerDemoListComponent.prototype.getCustomerCustomerDemoByPaging = function () {
        var _this = this;
        this.CustomerCustomerDemoService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.CustomerCustomerDemoList = data.CustomerCustomerDemoList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    CustomerCustomerDemoListComponent.prototype.addCustomerCustomerDemo = function () {
        this.CustomerCustomerDemoService.addCustomerCustomerDemoData(this.newCustomerCustomerDemo).subscribe(function (record) { return console.log(record); });
        this.getCustomerCustomerDemo();
    };
    // Updates existing record
    CustomerCustomerDemoListComponent.prototype.updateCustomerCustomerDemo = function () {
        this.CustomerCustomerDemoService.updateCustomerCustomerDemoData(this.selectedCustomerCustomerDemo).subscribe(function (record) { return console.log(record); });
        this.getCustomerCustomerDemo();
    };
    // Deletes record with specified id
    CustomerCustomerDemoListComponent.prototype.deleteCustomerCustomerDemo = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this CustomerCustomerDemo?') == true) {
            this.CustomerCustomerDemoService.deleteCustomerCustomerDemo(id)
                .subscribe(function (data) { return _this.getCustomerCustomerDemo(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('CustomerCustomerDemo record deleted successfully...', 'Delete CustomerCustomerDemo');
                console.log('CustomerCustomerDemo record deleted successfully...');
            });
        }
    };
    // Go to First Page
    CustomerCustomerDemoListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getCustomerCustomerDemoByPaging();
    };
    // Go to Previous Page
    CustomerCustomerDemoListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getCustomerCustomerDemoByPaging();
        }
    };
    // Refresh - Go to First Page
    CustomerCustomerDemoListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // Go to Next Page
    CustomerCustomerDemoListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getCustomerCustomerDemoByPaging();
        }
    };
    // Go to Last Page
    CustomerCustomerDemoListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getCustomerCustomerDemoByPaging();
    };
    // On Edit - Go to Edit page
    CustomerCustomerDemoListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/CustomerCustomerDemo', item.CustomerID]);
    };
    // On Details - Go to Details page
    CustomerCustomerDemoListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/CustomerCustomerDemo/Details', item.CustomerID]);
    };
    // Set record as selected
    CustomerCustomerDemoListComponent.prototype.SelectCustomerCustomerDemo = function (item) {
        this.selectedCustomerCustomerDemo = item;
    };
    // Submits form
    CustomerCustomerDemoListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    CustomerCustomerDemoListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CustomerCustomerDemoListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CustomerCustomerDemoListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(CustomerCustomerDemoSearch_component_1.CustomerCustomerDemoSearchComponent), 
        __metadata('design:type', (typeof (_a = typeof CustomerCustomerDemoSearch_component_1.CustomerCustomerDemoSearchComponent !== 'undefined' && CustomerCustomerDemoSearch_component_1.CustomerCustomerDemoSearchComponent) === 'function' && _a) || Object)
    ], CustomerCustomerDemoListComponent.prototype, "filterComponent", void 0);
    CustomerCustomerDemoListComponent = __decorate([
        core_1.Component({
            selector: 'my-CustomerCustomerDemo',
            template: __webpack_require__(1034),
            providers: [CustomerCustomerDemo_service_1.CustomerCustomerDemoService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof CustomerCustomerDemo_service_1.CustomerCustomerDemoService !== 'undefined' && CustomerCustomerDemo_service_1.CustomerCustomerDemoService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], CustomerCustomerDemoListComponent);
    return CustomerCustomerDemoListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.CustomerCustomerDemoListComponent = CustomerCustomerDemoListComponent;


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerCustomerDemoSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: CustomerCustomerDemoService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var CustomerCustomerDemo_service_1 = __webpack_require__(79);
var Customers_service_1 = __webpack_require__(42);
var CustomerCustomerDemoSearchComponent = (function () {
    function CustomerCustomerDemoSearchComponent(route, router, CustomerCustomerDemoService, CustomersService) {
        this.route = route;
        this.router = router;
        this.CustomerCustomerDemoService = CustomerCustomerDemoService;
        this.CustomersService = CustomersService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objCustomerCustomerDemo = new CustomerCustomerDemo_service_1.CustomerCustomerDemoData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(CustomerCustomerDemoSearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerCustomerDemoSearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CustomerCustomerDemoSearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    CustomerCustomerDemoSearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objCustomerCustomerDemo = new CustomerCustomerDemo_service_1.CustomerCustomerDemoData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    CustomerCustomerDemoSearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    CustomerCustomerDemoSearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objCustomerCustomerDemo.CustomerID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CustomerID like '%" + this.objCustomerCustomerDemo.CustomerID + "%'";
            else
                this.filterExpression = "CustomerID like '%" + this.objCustomerCustomerDemo.CustomerID + "%'";
        }
        if (this.objCustomerCustomerDemo.CustomerTypeID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CustomerTypeID like '%" + this.objCustomerCustomerDemo.CustomerTypeID + "%'";
            else
                this.filterExpression = "CustomerTypeID like '%" + this.objCustomerCustomerDemo.CustomerTypeID + "%'";
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    // Get Lookup List for Customers
    CustomerCustomerDemoSearchComponent.prototype.getCustomers = function () {
        var _this = this;
        this.CustomersService.getAll().subscribe(function (records) { return _this.CustomersList = records; });
    };
    CustomerCustomerDemoSearchComponent.prototype.getLookups = function () {
        this.getCustomers();
    };
    CustomerCustomerDemoSearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], CustomerCustomerDemoSearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CustomerCustomerDemoSearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CustomerCustomerDemoSearchComponent.prototype, "display", null);
    CustomerCustomerDemoSearchComponent = __decorate([
        core_1.Component({
            selector: 'CustomerCustomerDemoSearch',
            template: __webpack_require__(1035),
            providers: [CustomerCustomerDemo_service_1.CustomerCustomerDemoService,
                Customers_service_1.CustomersService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof CustomerCustomerDemo_service_1.CustomerCustomerDemoService !== 'undefined' && CustomerCustomerDemo_service_1.CustomerCustomerDemoService) === 'function' && _c) || Object, (typeof (_d = typeof Customers_service_1.CustomersService !== 'undefined' && Customers_service_1.CustomersService) === 'function' && _d) || Object])
    ], CustomerCustomerDemoSearchComponent);
    return CustomerCustomerDemoSearchComponent;
    var _a, _b, _c, _d;
}());
exports.CustomerCustomerDemoSearchComponent = CustomerCustomerDemoSearchComponent;


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerDemographicsAddComponent
 * Purpose		: This component allows to create new CustomerDemographics record and save changes.
 * Dependency	: CustomerDemographicsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var CustomerDemographics_service_1 = __webpack_require__(80);
var CustomerDemographicsAddComponent = (function () {
    // Lookup Arrays
    function CustomerDemographicsAddComponent(route, router, toastr, CustomerDemographicsService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.CustomerDemographicsService = CustomerDemographicsService;
        this.objCustomerDemographics = new CustomerDemographics_service_1.CustomerDemographicsData();
    }
    Object.defineProperty(CustomerDemographicsAddComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerDemographicsAddComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CustomerDemographicsAddComponent.prototype.ngOnInit = function () {
        this.objCustomerDemographics = new CustomerDemographics_service_1.CustomerDemographicsData();
        this.getLookups();
    };
    CustomerDemographicsAddComponent.prototype.addCustomerDemographics = function () {
        var _this = this;
        this.CustomerDemographicsService.addCustomerDemographicsData(this.objCustomerDemographics)
            .subscribe(function (record) { return _this.router.navigate(['/CustomerDemographics']); }, function (error) { return _this.errorMessage = 'There was an error while adding record. Error: ' + error; }, function () {
            _this.toastr.success('CustomerDemographics record added successfully...', 'Add CustomerDemographics');
            console.log('CustomerDemographics record added successfully...');
        });
    };
    CustomerDemographicsAddComponent.prototype.gotoCustomerDemographics = function () {
        // let Id = this.objCustomerDemographics ? this.objCustomerDemographics.CustomerTypeID : null;
        this.router.navigate(['/CustomerDemographics']);
    };
    CustomerDemographicsAddComponent.prototype.getLookups = function () {
    };
    CustomerDemographicsAddComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CustomerDemographicsAddComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CustomerDemographicsAddComponent.prototype, "display", null);
    CustomerDemographicsAddComponent = __decorate([
        core_1.Component({
            selector: 'my-CustomerDemographics-add',
            template: __webpack_require__(1036),
            providers: [CustomerDemographics_service_1.CustomerDemographicsService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof CustomerDemographics_service_1.CustomerDemographicsService !== 'undefined' && CustomerDemographics_service_1.CustomerDemographicsService) === 'function' && _d) || Object])
    ], CustomerDemographicsAddComponent);
    return CustomerDemographicsAddComponent;
    var _a, _b, _c, _d;
}());
exports.CustomerDemographicsAddComponent = CustomerDemographicsAddComponent;


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var CustomerDemographics_service_1 = __webpack_require__(80);
var CustomerDemographicsDetailsComponent = (function () {
    // Lookup Arrays
    function CustomerDemographicsDetailsComponent(route, router, toastr, CustomerDemographicsService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.CustomerDemographicsService = CustomerDemographicsService;
        // this.id = parseInt(params.get('id'));
        this.objCustomerDemographics = new CustomerDemographics_service_1.CustomerDemographicsData();
    }
    Object.defineProperty(CustomerDemographicsDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerDemographicsDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CustomerDemographicsDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.CustomerDemographicsService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objCustomerDemographics = item; });
        this.getLookups();
    };
    CustomerDemographicsDetailsComponent.prototype.deleteCustomerDemographics = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this CustomerDemographics?') == true) {
            this.CustomerDemographicsService.deleteCustomerDemographics(this.objCustomerDemographics.CustomerTypeID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/CustomerDemographics']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('CustomerDemographics record deleted successfully...'); });
        }
    };
    CustomerDemographicsDetailsComponent.prototype.gotoCustomerDemographicsEdit = function () {
        this.router.navigate(['/CustomerDemographics', this.objCustomerDemographics.CustomerTypeID]);
    };
    CustomerDemographicsDetailsComponent.prototype.gotoCustomerDemographics = function () {
        this.router.navigate(['/CustomerDemographics']);
    };
    CustomerDemographicsDetailsComponent.prototype.getLookups = function () {
    };
    CustomerDemographicsDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CustomerDemographicsDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CustomerDemographicsDetailsComponent.prototype, "display", null);
    CustomerDemographicsDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1037),
            providers: [CustomerDemographics_service_1.CustomerDemographicsService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof CustomerDemographics_service_1.CustomerDemographicsService !== 'undefined' && CustomerDemographics_service_1.CustomerDemographicsService) === 'function' && _d) || Object])
    ], CustomerDemographicsDetailsComponent);
    return CustomerDemographicsDetailsComponent;
    var _a, _b, _c, _d;
}());
exports.CustomerDemographicsDetailsComponent = CustomerDemographicsDetailsComponent;


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerDemographicsEditComponent
 * Purpose		: This component retrieves data for the specified record id and allows to edit and save changes.
 * Dependency	: CustomerDemographicsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var CustomerDemographics_service_1 = __webpack_require__(80);
var CustomerDemographicsEditComponent = (function () {
    // Lookup Arrays
    function CustomerDemographicsEditComponent(route, router, toastr, CustomerDemographicsService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.CustomerDemographicsService = CustomerDemographicsService;
        // this.id = parseInt(params.get('id'));
        this.objCustomerDemographics = new CustomerDemographics_service_1.CustomerDemographicsData();
    }
    Object.defineProperty(CustomerDemographicsEditComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerDemographicsEditComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CustomerDemographicsEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.CustomerDemographicsService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objCustomerDemographics = item; });
        this.getLookups();
    };
    CustomerDemographicsEditComponent.prototype.updateCustomerDemographics = function () {
        var _this = this;
        this.CustomerDemographicsService.updateCustomerDemographicsData(this.objCustomerDemographics)
            .subscribe(function (record) { return _this.router.navigate(['/CustomerDemographics']); }, function (error) { return _this.errorMessage = 'There was an error while updating record. Error: ' + error; }, function () {
            _this.toastr.success('CustomerDemographics record updated successfully...', 'Edit CustomerDemographics');
            console.log('CustomerDemographics record updated successfully...');
        });
    };
    CustomerDemographicsEditComponent.prototype.deleteCustomerDemographics = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this CustomerDemographics?') == true) {
            this.CustomerDemographicsService.deleteCustomerDemographics(this.objCustomerDemographics.CustomerTypeID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/CustomerDemographics']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('CustomerDemographics record deleted successfully...', 'Delete CustomerDemographics');
                console.log('CustomerDemographics record deleted successfully...');
            });
        }
    };
    CustomerDemographicsEditComponent.prototype.gotoCustomerDemographics = function () {
        var Id = this.objCustomerDemographics ? this.objCustomerDemographics.CustomerTypeID : null;
        this.router.navigate(['/CustomerDemographics']);
    };
    CustomerDemographicsEditComponent.prototype.getLookups = function () {
    };
    CustomerDemographicsEditComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CustomerDemographicsEditComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CustomerDemographicsEditComponent.prototype, "display", null);
    CustomerDemographicsEditComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1038),
            providers: [CustomerDemographics_service_1.CustomerDemographicsService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof CustomerDemographics_service_1.CustomerDemographicsService !== 'undefined' && CustomerDemographics_service_1.CustomerDemographicsService) === 'function' && _d) || Object])
    ], CustomerDemographicsEditComponent);
    return CustomerDemographicsEditComponent;
    var _a, _b, _c, _d;
}());
exports.CustomerDemographicsEditComponent = CustomerDemographicsEditComponent;


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerDemographicsListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: CustomerDemographicsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var CustomerDemographics_service_1 = __webpack_require__(80);
var CustomerDemographicsSearch_component_1 = __webpack_require__(385);
var CustomerDemographicsListComponent = (function () {
    function CustomerDemographicsListComponent(CustomerDemographicsService, route, router, toastr) {
        this.CustomerDemographicsService = CustomerDemographicsService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "CustomerTypeID";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newCustomerDemographics = new CustomerDemographics_service_1.CustomerDemographicsData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(CustomerDemographicsListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerDemographicsListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CustomerDemographicsListComponent.prototype.ngOnInit = function () {
        //this.CustomerDemographicsService.getAll().subscribe(record => this.CustomerDemographicsList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getCustomerDemographicsByPaging();
        /*
        this.CustomerDemographicsList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    CustomerDemographicsListComponent.prototype.getCustomerDemographics = function () {
        var _this = this;
        this.CustomerDemographicsService.getAll()
            .subscribe(function (data) { return _this.CustomerDemographicsList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on CustomerDemographicsSearch Component
    CustomerDemographicsListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getCustomerDemographicsByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getCustomerDemographicsByPaging();
    };
    CustomerDemographicsListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getCustomerDemographicsByPaging();
    };
    // Get records by paging
    CustomerDemographicsListComponent.prototype.getCustomerDemographicsByPaging = function () {
        var _this = this;
        this.CustomerDemographicsService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.CustomerDemographicsList = data.CustomerDemographicsList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    CustomerDemographicsListComponent.prototype.addCustomerDemographics = function () {
        this.CustomerDemographicsService.addCustomerDemographicsData(this.newCustomerDemographics).subscribe(function (record) { return console.log(record); });
        this.getCustomerDemographics();
    };
    // Updates existing record
    CustomerDemographicsListComponent.prototype.updateCustomerDemographics = function () {
        this.CustomerDemographicsService.updateCustomerDemographicsData(this.selectedCustomerDemographics).subscribe(function (record) { return console.log(record); });
        this.getCustomerDemographics();
    };
    // Deletes record with specified id
    CustomerDemographicsListComponent.prototype.deleteCustomerDemographics = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this CustomerDemographics?') == true) {
            this.CustomerDemographicsService.deleteCustomerDemographics(id)
                .subscribe(function (data) { return _this.getCustomerDemographics(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('CustomerDemographics record deleted successfully...', 'Delete CustomerDemographics');
                console.log('CustomerDemographics record deleted successfully...');
            });
        }
    };
    // Go to First Page
    CustomerDemographicsListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getCustomerDemographicsByPaging();
    };
    // Go to Previous Page
    CustomerDemographicsListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getCustomerDemographicsByPaging();
        }
    };
    // Refresh - Go to First Page
    CustomerDemographicsListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // Go to Next Page
    CustomerDemographicsListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getCustomerDemographicsByPaging();
        }
    };
    // Go to Last Page
    CustomerDemographicsListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getCustomerDemographicsByPaging();
    };
    // On Edit - Go to Edit page
    CustomerDemographicsListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/CustomerDemographics', item.CustomerTypeID]);
    };
    // On Details - Go to Details page
    CustomerDemographicsListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/CustomerDemographics/Details', item.CustomerTypeID]);
    };
    // Set record as selected
    CustomerDemographicsListComponent.prototype.SelectCustomerDemographics = function (item) {
        this.selectedCustomerDemographics = item;
    };
    // Submits form
    CustomerDemographicsListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    CustomerDemographicsListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CustomerDemographicsListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CustomerDemographicsListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(CustomerDemographicsSearch_component_1.CustomerDemographicsSearchComponent), 
        __metadata('design:type', (typeof (_a = typeof CustomerDemographicsSearch_component_1.CustomerDemographicsSearchComponent !== 'undefined' && CustomerDemographicsSearch_component_1.CustomerDemographicsSearchComponent) === 'function' && _a) || Object)
    ], CustomerDemographicsListComponent.prototype, "filterComponent", void 0);
    CustomerDemographicsListComponent = __decorate([
        core_1.Component({
            selector: 'my-CustomerDemographics',
            template: __webpack_require__(1039),
            providers: [CustomerDemographics_service_1.CustomerDemographicsService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof CustomerDemographics_service_1.CustomerDemographicsService !== 'undefined' && CustomerDemographics_service_1.CustomerDemographicsService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], CustomerDemographicsListComponent);
    return CustomerDemographicsListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.CustomerDemographicsListComponent = CustomerDemographicsListComponent;


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerDemographicsSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: CustomerDemographicsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var CustomerDemographics_service_1 = __webpack_require__(80);
var CustomerDemographicsSearchComponent = (function () {
    // Lookup Arrays
    function CustomerDemographicsSearchComponent(route, router, CustomerDemographicsService) {
        this.route = route;
        this.router = router;
        this.CustomerDemographicsService = CustomerDemographicsService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objCustomerDemographics = new CustomerDemographics_service_1.CustomerDemographicsData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(CustomerDemographicsSearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerDemographicsSearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CustomerDemographicsSearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    CustomerDemographicsSearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objCustomerDemographics = new CustomerDemographics_service_1.CustomerDemographicsData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    CustomerDemographicsSearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    CustomerDemographicsSearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objCustomerDemographics.CustomerTypeID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CustomerTypeID like '%" + this.objCustomerDemographics.CustomerTypeID + "%'";
            else
                this.filterExpression = "CustomerTypeID like '%" + this.objCustomerDemographics.CustomerTypeID + "%'";
        }
        if (this.objCustomerDemographics.CustomerDesc) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CustomerDesc like '%" + this.objCustomerDemographics.CustomerDesc + "%'";
            else
                this.filterExpression = "CustomerDesc like '%" + this.objCustomerDemographics.CustomerDesc + "%'";
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    CustomerDemographicsSearchComponent.prototype.getLookups = function () {
    };
    CustomerDemographicsSearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], CustomerDemographicsSearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CustomerDemographicsSearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CustomerDemographicsSearchComponent.prototype, "display", null);
    CustomerDemographicsSearchComponent = __decorate([
        core_1.Component({
            selector: 'CustomerDemographicsSearch',
            template: __webpack_require__(1040),
            providers: [CustomerDemographics_service_1.CustomerDemographicsService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof CustomerDemographics_service_1.CustomerDemographicsService !== 'undefined' && CustomerDemographics_service_1.CustomerDemographicsService) === 'function' && _c) || Object])
    ], CustomerDemographicsSearchComponent);
    return CustomerDemographicsSearchComponent;
    var _a, _b, _c;
}());
exports.CustomerDemographicsSearchComponent = CustomerDemographicsSearchComponent;


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerandSuppliersbyCityAddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: CustomerandSuppliersbyCityService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var CustomerandSuppliersbyCity_service_1 = __webpack_require__(143);
var CustomerandSuppliersbyCityDetailsComponent = (function () {
    // Lookup Arrays
    function CustomerandSuppliersbyCityDetailsComponent(route, router, toastr, CustomerandSuppliersbyCityService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.CustomerandSuppliersbyCityService = CustomerandSuppliersbyCityService;
        // this.id = parseInt(params.get('id'));
        this.objCustomerandSuppliersbyCity = new CustomerandSuppliersbyCity_service_1.CustomerandSuppliersbyCityData();
    }
    Object.defineProperty(CustomerandSuppliersbyCityDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerandSuppliersbyCityDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CustomerandSuppliersbyCityDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.CustomerandSuppliersbyCityService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objCustomerandSuppliersbyCity = item; });
        this.getLookups();
    };
    CustomerandSuppliersbyCityDetailsComponent.prototype.deleteCustomerandSuppliersbyCity = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this CustomerandSuppliersbyCity?') == true) {
            this.CustomerandSuppliersbyCityService.deleteCustomerandSuppliersbyCity(this.objCustomerandSuppliersbyCity.City.toString())
                .subscribe(function (record) { return _this.router.navigate(['/CustomerandSuppliersbyCity']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('CustomerandSuppliersbyCity record deleted successfully...'); });
        }
    };
    CustomerandSuppliersbyCityDetailsComponent.prototype.gotoCustomerandSuppliersbyCityEdit = function () {
        this.router.navigate(['/CustomerandSuppliersbyCity', this.objCustomerandSuppliersbyCity.City]);
    };
    CustomerandSuppliersbyCityDetailsComponent.prototype.gotoCustomerandSuppliersbyCity = function () {
        this.router.navigate(['/CustomerandSuppliersbyCity']);
    };
    CustomerandSuppliersbyCityDetailsComponent.prototype.getLookups = function () {
    };
    CustomerandSuppliersbyCityDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CustomerandSuppliersbyCityDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CustomerandSuppliersbyCityDetailsComponent.prototype, "display", null);
    CustomerandSuppliersbyCityDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1041),
            providers: [CustomerandSuppliersbyCity_service_1.CustomerandSuppliersbyCityService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof CustomerandSuppliersbyCity_service_1.CustomerandSuppliersbyCityService !== 'undefined' && CustomerandSuppliersbyCity_service_1.CustomerandSuppliersbyCityService) === 'function' && _d) || Object])
    ], CustomerandSuppliersbyCityDetailsComponent);
    return CustomerandSuppliersbyCityDetailsComponent;
    var _a, _b, _c, _d;
}());
exports.CustomerandSuppliersbyCityDetailsComponent = CustomerandSuppliersbyCityDetailsComponent;


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerandSuppliersbyCityListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: CustomerandSuppliersbyCityService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var CustomerandSuppliersbyCity_service_1 = __webpack_require__(143);
var CustomerandSuppliersbyCitySearch_component_1 = __webpack_require__(388);
var CustomerandSuppliersbyCityListComponent = (function () {
    function CustomerandSuppliersbyCityListComponent(CustomerandSuppliersbyCityService, route, router, toastr) {
        this.CustomerandSuppliersbyCityService = CustomerandSuppliersbyCityService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "City";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newCustomerandSuppliersbyCity = new CustomerandSuppliersbyCity_service_1.CustomerandSuppliersbyCityData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(CustomerandSuppliersbyCityListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerandSuppliersbyCityListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CustomerandSuppliersbyCityListComponent.prototype.ngOnInit = function () {
        // this.CustomerandSuppliersbyCityService.getAll().subscribe(record => this.CustomerandSuppliersbyCityList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getCustomerandSuppliersbyCityByPaging();
        /*
        this.CustomerandSuppliersbyCityList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    CustomerandSuppliersbyCityListComponent.prototype.getCustomerandSuppliersbyCity = function () {
        var _this = this;
        this.CustomerandSuppliersbyCityService.getAll()
            .subscribe(function (data) { return _this.CustomerandSuppliersbyCityList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on CustomerandSuppliersbyCitySearch Component
    CustomerandSuppliersbyCityListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getCustomerandSuppliersbyCityByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getCustomerandSuppliersbyCityByPaging();
    };
    CustomerandSuppliersbyCityListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getCustomerandSuppliersbyCityByPaging();
    };
    // Get records by paging
    CustomerandSuppliersbyCityListComponent.prototype.getCustomerandSuppliersbyCityByPaging = function () {
        var _this = this;
        this.CustomerandSuppliersbyCityService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.CustomerandSuppliersbyCityList = data.CustomerandSuppliersbyCityList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    CustomerandSuppliersbyCityListComponent.prototype.addCustomerandSuppliersbyCity = function () {
        this.CustomerandSuppliersbyCityService.addCustomerandSuppliersbyCityData(this.newCustomerandSuppliersbyCity).subscribe(function (record) { return console.log(record); });
        this.getCustomerandSuppliersbyCity();
    };
    // Updates existing record
    CustomerandSuppliersbyCityListComponent.prototype.updateCustomerandSuppliersbyCity = function () {
        this.CustomerandSuppliersbyCityService.updateCustomerandSuppliersbyCityData(this.selectedCustomerandSuppliersbyCity).subscribe(function (record) { return console.log(record); });
        this.getCustomerandSuppliersbyCity();
    };
    // Deletes record with specified id
    CustomerandSuppliersbyCityListComponent.prototype.deleteCustomerandSuppliersbyCity = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this CustomerandSuppliersbyCity?') == true) {
            this.CustomerandSuppliersbyCityService.deleteCustomerandSuppliersbyCity(id)
                .subscribe(function (data) { return _this.getCustomerandSuppliersbyCity(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; });
        }
    };
    // Go to First Page
    CustomerandSuppliersbyCityListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getCustomerandSuppliersbyCityByPaging();
    };
    // Go to Previous Page
    CustomerandSuppliersbyCityListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getCustomerandSuppliersbyCityByPaging();
        }
    };
    // Go to Next Page
    CustomerandSuppliersbyCityListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getCustomerandSuppliersbyCityByPaging();
        }
    };
    // Go to Last Page
    CustomerandSuppliersbyCityListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getCustomerandSuppliersbyCityByPaging();
    };
    // Refresh - Go to First Page
    CustomerandSuppliersbyCityListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // On Edit - Go to Edit page
    CustomerandSuppliersbyCityListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/CustomerandSuppliersbyCity', item.City]);
    };
    // On Details - Go to Details page
    CustomerandSuppliersbyCityListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/CustomerandSuppliersbyCity/Details', item.City]);
    };
    // Set record as selected
    CustomerandSuppliersbyCityListComponent.prototype.SelectCustomerandSuppliersbyCity = function (item) {
        this.selectedCustomerandSuppliersbyCity = item;
    };
    // Submits form
    CustomerandSuppliersbyCityListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    CustomerandSuppliersbyCityListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CustomerandSuppliersbyCityListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CustomerandSuppliersbyCityListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(CustomerandSuppliersbyCitySearch_component_1.CustomerandSuppliersbyCitySearchComponent), 
        __metadata('design:type', (typeof (_a = typeof CustomerandSuppliersbyCitySearch_component_1.CustomerandSuppliersbyCitySearchComponent !== 'undefined' && CustomerandSuppliersbyCitySearch_component_1.CustomerandSuppliersbyCitySearchComponent) === 'function' && _a) || Object)
    ], CustomerandSuppliersbyCityListComponent.prototype, "filterComponent", void 0);
    CustomerandSuppliersbyCityListComponent = __decorate([
        core_1.Component({
            selector: 'my-CustomerandSuppliersbyCity',
            template: __webpack_require__(1042),
            providers: [CustomerandSuppliersbyCity_service_1.CustomerandSuppliersbyCityService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof CustomerandSuppliersbyCity_service_1.CustomerandSuppliersbyCityService !== 'undefined' && CustomerandSuppliersbyCity_service_1.CustomerandSuppliersbyCityService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], CustomerandSuppliersbyCityListComponent);
    return CustomerandSuppliersbyCityListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.CustomerandSuppliersbyCityListComponent = CustomerandSuppliersbyCityListComponent;


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerandSuppliersbyCitySearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: CustomerandSuppliersbyCityService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var CustomerandSuppliersbyCity_service_1 = __webpack_require__(143);
var CustomerandSuppliersbyCitySearchComponent = (function () {
    // Lookup Arrays
    function CustomerandSuppliersbyCitySearchComponent(route, router, CustomerandSuppliersbyCityService) {
        this.route = route;
        this.router = router;
        this.CustomerandSuppliersbyCityService = CustomerandSuppliersbyCityService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objCustomerandSuppliersbyCity = new CustomerandSuppliersbyCity_service_1.CustomerandSuppliersbyCityData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(CustomerandSuppliersbyCitySearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerandSuppliersbyCitySearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CustomerandSuppliersbyCitySearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    CustomerandSuppliersbyCitySearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objCustomerandSuppliersbyCity = new CustomerandSuppliersbyCity_service_1.CustomerandSuppliersbyCityData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    CustomerandSuppliersbyCitySearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    CustomerandSuppliersbyCitySearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objCustomerandSuppliersbyCity.City) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND City like '%" + this.objCustomerandSuppliersbyCity.City + "%'";
            else
                this.filterExpression = "City like '%" + this.objCustomerandSuppliersbyCity.City + "%'";
        }
        if (this.objCustomerandSuppliersbyCity.CompanyName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CompanyName like '%" + this.objCustomerandSuppliersbyCity.CompanyName + "%'";
            else
                this.filterExpression = "CompanyName like '%" + this.objCustomerandSuppliersbyCity.CompanyName + "%'";
        }
        if (this.objCustomerandSuppliersbyCity.ContactName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ContactName like '%" + this.objCustomerandSuppliersbyCity.ContactName + "%'";
            else
                this.filterExpression = "ContactName like '%" + this.objCustomerandSuppliersbyCity.ContactName + "%'";
        }
        if (this.objCustomerandSuppliersbyCity.Relationship) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Relationship like '%" + this.objCustomerandSuppliersbyCity.Relationship + "%'";
            else
                this.filterExpression = "Relationship like '%" + this.objCustomerandSuppliersbyCity.Relationship + "%'";
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    CustomerandSuppliersbyCitySearchComponent.prototype.getLookups = function () {
    };
    CustomerandSuppliersbyCitySearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], CustomerandSuppliersbyCitySearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CustomerandSuppliersbyCitySearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CustomerandSuppliersbyCitySearchComponent.prototype, "display", null);
    CustomerandSuppliersbyCitySearchComponent = __decorate([
        core_1.Component({
            selector: 'CustomerandSuppliersbyCitySearch',
            template: __webpack_require__(1043),
            providers: [CustomerandSuppliersbyCity_service_1.CustomerandSuppliersbyCityService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof CustomerandSuppliersbyCity_service_1.CustomerandSuppliersbyCityService !== 'undefined' && CustomerandSuppliersbyCity_service_1.CustomerandSuppliersbyCityService) === 'function' && _c) || Object])
    ], CustomerandSuppliersbyCitySearchComponent);
    return CustomerandSuppliersbyCitySearchComponent;
    var _a, _b, _c;
}());
exports.CustomerandSuppliersbyCitySearchComponent = CustomerandSuppliersbyCitySearchComponent;


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomersAddComponent
 * Purpose		: This component allows to create new Customers record and save changes.
 * Dependency	: CustomersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Customers_service_1 = __webpack_require__(42);
var CustomersAddComponent = (function () {
    // Lookup Arrays
    function CustomersAddComponent(route, router, toastr, CustomersService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.CustomersService = CustomersService;
        this.objCustomers = new Customers_service_1.CustomersData();
    }
    Object.defineProperty(CustomersAddComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomersAddComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CustomersAddComponent.prototype.ngOnInit = function () {
        this.objCustomers = new Customers_service_1.CustomersData();
        this.getLookups();
    };
    CustomersAddComponent.prototype.addCustomers = function () {
        var _this = this;
        this.CustomersService.addCustomersData(this.objCustomers)
            .subscribe(function (record) { return _this.router.navigate(['/Customers']); }, function (error) { return _this.errorMessage = 'There was an error while adding record. Error: ' + error; }, function () {
            _this.toastr.success('Customers record added successfully...', 'Add Customers');
            console.log('Customers record added successfully...');
        });
    };
    CustomersAddComponent.prototype.gotoCustomers = function () {
        // let Id = this.objCustomers ? this.objCustomers.CustomerID : null;
        this.router.navigate(['/Customers']);
    };
    CustomersAddComponent.prototype.getLookups = function () {
    };
    CustomersAddComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CustomersAddComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CustomersAddComponent.prototype, "display", null);
    CustomersAddComponent = __decorate([
        core_1.Component({
            selector: 'my-Customers-add',
            template: __webpack_require__(1044),
            providers: [Customers_service_1.CustomersService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Customers_service_1.CustomersService !== 'undefined' && Customers_service_1.CustomersService) === 'function' && _d) || Object])
    ], CustomersAddComponent);
    return CustomersAddComponent;
    var _a, _b, _c, _d;
}());
exports.CustomersAddComponent = CustomersAddComponent;


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Customers_service_1 = __webpack_require__(42);
var CustomersDetailsComponent = (function () {
    // Lookup Arrays
    function CustomersDetailsComponent(route, router, toastr, CustomersService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.CustomersService = CustomersService;
        // this.id = parseInt(params.get('id'));
        this.objCustomers = new Customers_service_1.CustomersData();
    }
    Object.defineProperty(CustomersDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomersDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CustomersDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.CustomersService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objCustomers = item; });
        this.getLookups();
    };
    CustomersDetailsComponent.prototype.deleteCustomers = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Customers?') == true) {
            this.CustomersService.deleteCustomers(this.objCustomers.CustomerID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/Customers']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('Customers record deleted successfully...'); });
        }
    };
    CustomersDetailsComponent.prototype.gotoCustomersEdit = function () {
        this.router.navigate(['/Customers', this.objCustomers.CustomerID]);
    };
    CustomersDetailsComponent.prototype.gotoCustomers = function () {
        this.router.navigate(['/Customers']);
    };
    CustomersDetailsComponent.prototype.getLookups = function () {
    };
    CustomersDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CustomersDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CustomersDetailsComponent.prototype, "display", null);
    CustomersDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1045),
            providers: [Customers_service_1.CustomersService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Customers_service_1.CustomersService !== 'undefined' && Customers_service_1.CustomersService) === 'function' && _d) || Object])
    ], CustomersDetailsComponent);
    return CustomersDetailsComponent;
    var _a, _b, _c, _d;
}());
exports.CustomersDetailsComponent = CustomersDetailsComponent;


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomersEditComponent
 * Purpose		: This component retrieves data for the specified record id and allows to edit and save changes.
 * Dependency	: CustomersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Customers_service_1 = __webpack_require__(42);
var CustomersEditComponent = (function () {
    // Lookup Arrays
    function CustomersEditComponent(route, router, toastr, CustomersService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.CustomersService = CustomersService;
        // this.id = parseInt(params.get('id'));
        this.objCustomers = new Customers_service_1.CustomersData();
    }
    Object.defineProperty(CustomersEditComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomersEditComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CustomersEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.CustomersService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objCustomers = item; });
        this.getLookups();
    };
    CustomersEditComponent.prototype.updateCustomers = function () {
        var _this = this;
        this.CustomersService.updateCustomersData(this.objCustomers)
            .subscribe(function (record) { return _this.router.navigate(['/Customers']); }, function (error) { return _this.errorMessage = 'There was an error while updating record. Error: ' + error; }, function () {
            _this.toastr.success('Customers record updated successfully...', 'Edit Customers');
            console.log('Customers record updated successfully...');
        });
    };
    CustomersEditComponent.prototype.deleteCustomers = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Customers?') == true) {
            this.CustomersService.deleteCustomers(this.objCustomers.CustomerID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/Customers']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('Customers record deleted successfully...', 'Delete Customers');
                console.log('Customers record deleted successfully...');
            });
        }
    };
    CustomersEditComponent.prototype.gotoCustomers = function () {
        var Id = this.objCustomers ? this.objCustomers.CustomerID : null;
        this.router.navigate(['/Customers']);
    };
    CustomersEditComponent.prototype.getLookups = function () {
    };
    CustomersEditComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CustomersEditComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CustomersEditComponent.prototype, "display", null);
    CustomersEditComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1046),
            providers: [Customers_service_1.CustomersService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Customers_service_1.CustomersService !== 'undefined' && Customers_service_1.CustomersService) === 'function' && _d) || Object])
    ], CustomersEditComponent);
    return CustomersEditComponent;
    var _a, _b, _c, _d;
}());
exports.CustomersEditComponent = CustomersEditComponent;


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomersListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: CustomersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var Customers_service_1 = __webpack_require__(42);
var CustomersSearch_component_1 = __webpack_require__(393);
var CustomersListComponent = (function () {
    function CustomersListComponent(CustomersService, route, router, toastr) {
        this.CustomersService = CustomersService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "CustomerID";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newCustomers = new Customers_service_1.CustomersData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(CustomersListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomersListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CustomersListComponent.prototype.ngOnInit = function () {
        //this.CustomersService.getAll().subscribe(record => this.CustomersList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getCustomersByPaging();
        /*
        this.CustomersList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    CustomersListComponent.prototype.getCustomers = function () {
        var _this = this;
        this.CustomersService.getAll()
            .subscribe(function (data) { return _this.CustomersList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on CustomersSearch Component
    CustomersListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getCustomersByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getCustomersByPaging();
    };
    CustomersListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getCustomersByPaging();
    };
    // Get records by paging
    CustomersListComponent.prototype.getCustomersByPaging = function () {
        var _this = this;
        this.CustomersService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.CustomersList = data.CustomersList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    CustomersListComponent.prototype.addCustomers = function () {
        this.CustomersService.addCustomersData(this.newCustomers).subscribe(function (record) { return console.log(record); });
        this.getCustomers();
    };
    // Updates existing record
    CustomersListComponent.prototype.updateCustomers = function () {
        this.CustomersService.updateCustomersData(this.selectedCustomers).subscribe(function (record) { return console.log(record); });
        this.getCustomers();
    };
    // Deletes record with specified id
    CustomersListComponent.prototype.deleteCustomers = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Customers?') == true) {
            this.CustomersService.deleteCustomers(id)
                .subscribe(function (data) { return _this.getCustomers(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('Customers record deleted successfully...', 'Delete Customers');
                console.log('Customers record deleted successfully...');
            });
        }
    };
    // Go to First Page
    CustomersListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getCustomersByPaging();
    };
    // Go to Previous Page
    CustomersListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getCustomersByPaging();
        }
    };
    // Refresh - Go to First Page
    CustomersListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // Go to Next Page
    CustomersListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getCustomersByPaging();
        }
    };
    // Go to Last Page
    CustomersListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getCustomersByPaging();
    };
    // On Edit - Go to Edit page
    CustomersListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/Customers', item.CustomerID]);
    };
    // On Details - Go to Details page
    CustomersListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/Customers/Details', item.CustomerID]);
    };
    // Set record as selected
    CustomersListComponent.prototype.SelectCustomers = function (item) {
        this.selectedCustomers = item;
    };
    // Submits form
    CustomersListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    CustomersListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CustomersListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CustomersListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(CustomersSearch_component_1.CustomersSearchComponent), 
        __metadata('design:type', (typeof (_a = typeof CustomersSearch_component_1.CustomersSearchComponent !== 'undefined' && CustomersSearch_component_1.CustomersSearchComponent) === 'function' && _a) || Object)
    ], CustomersListComponent.prototype, "filterComponent", void 0);
    CustomersListComponent = __decorate([
        core_1.Component({
            selector: 'my-Customers',
            template: __webpack_require__(1047),
            providers: [Customers_service_1.CustomersService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof Customers_service_1.CustomersService !== 'undefined' && Customers_service_1.CustomersService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], CustomersListComponent);
    return CustomersListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.CustomersListComponent = CustomersListComponent;


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomersSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: CustomersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var Customers_service_1 = __webpack_require__(42);
var CustomersSearchComponent = (function () {
    // Lookup Arrays
    function CustomersSearchComponent(route, router, CustomersService) {
        this.route = route;
        this.router = router;
        this.CustomersService = CustomersService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objCustomers = new Customers_service_1.CustomersData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(CustomersSearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomersSearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    CustomersSearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    CustomersSearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objCustomers = new Customers_service_1.CustomersData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    CustomersSearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    CustomersSearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objCustomers.CustomerID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CustomerID like '%" + this.objCustomers.CustomerID + "%'";
            else
                this.filterExpression = "CustomerID like '%" + this.objCustomers.CustomerID + "%'";
        }
        if (this.objCustomers.CompanyName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CompanyName like '%" + this.objCustomers.CompanyName + "%'";
            else
                this.filterExpression = "CompanyName like '%" + this.objCustomers.CompanyName + "%'";
        }
        if (this.objCustomers.ContactName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ContactName like '%" + this.objCustomers.ContactName + "%'";
            else
                this.filterExpression = "ContactName like '%" + this.objCustomers.ContactName + "%'";
        }
        if (this.objCustomers.ContactTitle) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ContactTitle like '%" + this.objCustomers.ContactTitle + "%'";
            else
                this.filterExpression = "ContactTitle like '%" + this.objCustomers.ContactTitle + "%'";
        }
        if (this.objCustomers.Address) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Address like '%" + this.objCustomers.Address + "%'";
            else
                this.filterExpression = "Address like '%" + this.objCustomers.Address + "%'";
        }
        if (this.objCustomers.City) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND City like '%" + this.objCustomers.City + "%'";
            else
                this.filterExpression = "City like '%" + this.objCustomers.City + "%'";
        }
        if (this.objCustomers.Region) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Region like '%" + this.objCustomers.Region + "%'";
            else
                this.filterExpression = "Region like '%" + this.objCustomers.Region + "%'";
        }
        if (this.objCustomers.PostalCode) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND PostalCode like '%" + this.objCustomers.PostalCode + "%'";
            else
                this.filterExpression = "PostalCode like '%" + this.objCustomers.PostalCode + "%'";
        }
        if (this.objCustomers.Country) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Country like '%" + this.objCustomers.Country + "%'";
            else
                this.filterExpression = "Country like '%" + this.objCustomers.Country + "%'";
        }
        if (this.objCustomers.Phone) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Phone like '%" + this.objCustomers.Phone + "%'";
            else
                this.filterExpression = "Phone like '%" + this.objCustomers.Phone + "%'";
        }
        if (this.objCustomers.Fax) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Fax like '%" + this.objCustomers.Fax + "%'";
            else
                this.filterExpression = "Fax like '%" + this.objCustomers.Fax + "%'";
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    CustomersSearchComponent.prototype.getLookups = function () {
    };
    CustomersSearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], CustomersSearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], CustomersSearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], CustomersSearchComponent.prototype, "display", null);
    CustomersSearchComponent = __decorate([
        core_1.Component({
            selector: 'CustomersSearch',
            template: __webpack_require__(1048),
            providers: [Customers_service_1.CustomersService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof Customers_service_1.CustomersService !== 'undefined' && Customers_service_1.CustomersService) === 'function' && _c) || Object])
    ], CustomersSearchComponent);
    return CustomersSearchComponent;
    var _a, _b, _c;
}());
exports.CustomersSearchComponent = CustomersSearchComponent;


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeeTerritoriesAddComponent
 * Purpose		: This component allows to create new EmployeeTerritories record and save changes.
 * Dependency	: EmployeeTerritoriesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var EmployeeTerritories_service_1 = __webpack_require__(81);
var Employees_service_1 = __webpack_require__(28);
var Territories_service_1 = __webpack_require__(48);
var EmployeeTerritoriesAddComponent = (function () {
    function EmployeeTerritoriesAddComponent(route, router, toastr, EmployeeTerritoriesService, EmployeesService, TerritoriesService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.EmployeeTerritoriesService = EmployeeTerritoriesService;
        this.EmployeesService = EmployeesService;
        this.TerritoriesService = TerritoriesService;
        this.objEmployeeTerritories = new EmployeeTerritories_service_1.EmployeeTerritoriesData();
    }
    Object.defineProperty(EmployeeTerritoriesAddComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTerritoriesAddComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    EmployeeTerritoriesAddComponent.prototype.ngOnInit = function () {
        this.objEmployeeTerritories = new EmployeeTerritories_service_1.EmployeeTerritoriesData();
        this.getLookups();
    };
    EmployeeTerritoriesAddComponent.prototype.addEmployeeTerritories = function () {
        var _this = this;
        this.EmployeeTerritoriesService.addEmployeeTerritoriesData(this.objEmployeeTerritories)
            .subscribe(function (record) { return _this.router.navigate(['/EmployeeTerritories']); }, function (error) { return _this.errorMessage = 'There was an error while adding record. Error: ' + error; }, function () {
            _this.toastr.success('EmployeeTerritories record added successfully...', 'Add EmployeeTerritories');
            console.log('EmployeeTerritories record added successfully...');
        });
    };
    EmployeeTerritoriesAddComponent.prototype.gotoEmployeeTerritories = function () {
        // let Id = this.objEmployeeTerritories ? this.objEmployeeTerritories.EmployeeID : null;
        this.router.navigate(['/EmployeeTerritories']);
    };
    // Get Lookup List for Employees
    EmployeeTerritoriesAddComponent.prototype.getEmployees = function () {
        var _this = this;
        this.EmployeesService.getAll().subscribe(function (records) { return _this.EmployeesList = records; });
    };
    // Get Lookup List for Territories
    EmployeeTerritoriesAddComponent.prototype.getTerritories = function () {
        var _this = this;
        this.TerritoriesService.getAll().subscribe(function (records) { return _this.TerritoriesList = records; });
    };
    EmployeeTerritoriesAddComponent.prototype.getLookups = function () {
        this.getEmployees();
        this.getTerritories();
    };
    EmployeeTerritoriesAddComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], EmployeeTerritoriesAddComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], EmployeeTerritoriesAddComponent.prototype, "display", null);
    EmployeeTerritoriesAddComponent = __decorate([
        core_1.Component({
            selector: 'my-EmployeeTerritories-add',
            template: __webpack_require__(1049),
            providers: [EmployeeTerritories_service_1.EmployeeTerritoriesService,
                Employees_service_1.EmployeesService, Territories_service_1.TerritoriesService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof EmployeeTerritories_service_1.EmployeeTerritoriesService !== 'undefined' && EmployeeTerritories_service_1.EmployeeTerritoriesService) === 'function' && _d) || Object, (typeof (_e = typeof Employees_service_1.EmployeesService !== 'undefined' && Employees_service_1.EmployeesService) === 'function' && _e) || Object, (typeof (_f = typeof Territories_service_1.TerritoriesService !== 'undefined' && Territories_service_1.TerritoriesService) === 'function' && _f) || Object])
    ], EmployeeTerritoriesAddComponent);
    return EmployeeTerritoriesAddComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.EmployeeTerritoriesAddComponent = EmployeeTerritoriesAddComponent;


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var EmployeeTerritories_service_1 = __webpack_require__(81);
var Employees_service_1 = __webpack_require__(28);
var Territories_service_1 = __webpack_require__(48);
var EmployeeTerritoriesDetailsComponent = (function () {
    function EmployeeTerritoriesDetailsComponent(route, router, toastr, EmployeeTerritoriesService, EmployeesService, TerritoriesService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.EmployeeTerritoriesService = EmployeeTerritoriesService;
        this.EmployeesService = EmployeesService;
        this.TerritoriesService = TerritoriesService;
        // this.id = parseInt(params.get('id'));
        this.objEmployeeTerritories = new EmployeeTerritories_service_1.EmployeeTerritoriesData();
    }
    Object.defineProperty(EmployeeTerritoriesDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTerritoriesDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    EmployeeTerritoriesDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.EmployeeTerritoriesService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objEmployeeTerritories = item; });
        this.getLookups();
    };
    EmployeeTerritoriesDetailsComponent.prototype.deleteEmployeeTerritories = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this EmployeeTerritories?') == true) {
            this.EmployeeTerritoriesService.deleteEmployeeTerritories(this.objEmployeeTerritories.EmployeeID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/EmployeeTerritories']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('EmployeeTerritories record deleted successfully...'); });
        }
    };
    EmployeeTerritoriesDetailsComponent.prototype.gotoEmployeeTerritoriesEdit = function () {
        this.router.navigate(['/EmployeeTerritories', this.objEmployeeTerritories.EmployeeID]);
    };
    EmployeeTerritoriesDetailsComponent.prototype.gotoEmployeeTerritories = function () {
        this.router.navigate(['/EmployeeTerritories']);
    };
    // Get Lookup List for Employees
    EmployeeTerritoriesDetailsComponent.prototype.getEmployees = function () {
        var _this = this;
        this.EmployeesService.getAll().subscribe(function (records) { return _this.EmployeesList = records; });
    };
    // Get Lookup List for Territories
    EmployeeTerritoriesDetailsComponent.prototype.getTerritories = function () {
        var _this = this;
        this.TerritoriesService.getAll().subscribe(function (records) { return _this.TerritoriesList = records; });
    };
    EmployeeTerritoriesDetailsComponent.prototype.getLookups = function () {
        this.getEmployees();
        this.getTerritories();
    };
    EmployeeTerritoriesDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], EmployeeTerritoriesDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], EmployeeTerritoriesDetailsComponent.prototype, "display", null);
    EmployeeTerritoriesDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1050),
            providers: [EmployeeTerritories_service_1.EmployeeTerritoriesService,
                Employees_service_1.EmployeesService, Territories_service_1.TerritoriesService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof EmployeeTerritories_service_1.EmployeeTerritoriesService !== 'undefined' && EmployeeTerritories_service_1.EmployeeTerritoriesService) === 'function' && _d) || Object, (typeof (_e = typeof Employees_service_1.EmployeesService !== 'undefined' && Employees_service_1.EmployeesService) === 'function' && _e) || Object, (typeof (_f = typeof Territories_service_1.TerritoriesService !== 'undefined' && Territories_service_1.TerritoriesService) === 'function' && _f) || Object])
    ], EmployeeTerritoriesDetailsComponent);
    return EmployeeTerritoriesDetailsComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.EmployeeTerritoriesDetailsComponent = EmployeeTerritoriesDetailsComponent;


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeeTerritoriesEditComponent
 * Purpose		: This component retrieves data for the specified record id and allows to edit and save changes.
 * Dependency	: EmployeeTerritoriesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var EmployeeTerritories_service_1 = __webpack_require__(81);
var Employees_service_1 = __webpack_require__(28);
var Territories_service_1 = __webpack_require__(48);
var EmployeeTerritoriesEditComponent = (function () {
    function EmployeeTerritoriesEditComponent(route, router, toastr, EmployeeTerritoriesService, EmployeesService, TerritoriesService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.EmployeeTerritoriesService = EmployeeTerritoriesService;
        this.EmployeesService = EmployeesService;
        this.TerritoriesService = TerritoriesService;
        // this.id = parseInt(params.get('id'));
        this.objEmployeeTerritories = new EmployeeTerritories_service_1.EmployeeTerritoriesData();
    }
    Object.defineProperty(EmployeeTerritoriesEditComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTerritoriesEditComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    EmployeeTerritoriesEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.EmployeeTerritoriesService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objEmployeeTerritories = item; });
        this.getLookups();
    };
    EmployeeTerritoriesEditComponent.prototype.updateEmployeeTerritories = function () {
        var _this = this;
        this.EmployeeTerritoriesService.updateEmployeeTerritoriesData(this.objEmployeeTerritories)
            .subscribe(function (record) { return _this.router.navigate(['/EmployeeTerritories']); }, function (error) { return _this.errorMessage = 'There was an error while updating record. Error: ' + error; }, function () {
            _this.toastr.success('EmployeeTerritories record updated successfully...', 'Edit EmployeeTerritories');
            console.log('EmployeeTerritories record updated successfully...');
        });
    };
    EmployeeTerritoriesEditComponent.prototype.deleteEmployeeTerritories = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this EmployeeTerritories?') == true) {
            this.EmployeeTerritoriesService.deleteEmployeeTerritories(this.objEmployeeTerritories.EmployeeID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/EmployeeTerritories']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('EmployeeTerritories record deleted successfully...', 'Delete EmployeeTerritories');
                console.log('EmployeeTerritories record deleted successfully...');
            });
        }
    };
    EmployeeTerritoriesEditComponent.prototype.gotoEmployeeTerritories = function () {
        var Id = this.objEmployeeTerritories ? this.objEmployeeTerritories.EmployeeID : null;
        this.router.navigate(['/EmployeeTerritories']);
    };
    // Get Lookup List for Employees
    EmployeeTerritoriesEditComponent.prototype.getEmployees = function () {
        var _this = this;
        this.EmployeesService.getAll().subscribe(function (records) { return _this.EmployeesList = records; });
    };
    // Get Lookup List for Territories
    EmployeeTerritoriesEditComponent.prototype.getTerritories = function () {
        var _this = this;
        this.TerritoriesService.getAll().subscribe(function (records) { return _this.TerritoriesList = records; });
    };
    EmployeeTerritoriesEditComponent.prototype.getLookups = function () {
        this.getEmployees();
        this.getTerritories();
    };
    EmployeeTerritoriesEditComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], EmployeeTerritoriesEditComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], EmployeeTerritoriesEditComponent.prototype, "display", null);
    EmployeeTerritoriesEditComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1051),
            providers: [EmployeeTerritories_service_1.EmployeeTerritoriesService,
                Employees_service_1.EmployeesService, Territories_service_1.TerritoriesService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof EmployeeTerritories_service_1.EmployeeTerritoriesService !== 'undefined' && EmployeeTerritories_service_1.EmployeeTerritoriesService) === 'function' && _d) || Object, (typeof (_e = typeof Employees_service_1.EmployeesService !== 'undefined' && Employees_service_1.EmployeesService) === 'function' && _e) || Object, (typeof (_f = typeof Territories_service_1.TerritoriesService !== 'undefined' && Territories_service_1.TerritoriesService) === 'function' && _f) || Object])
    ], EmployeeTerritoriesEditComponent);
    return EmployeeTerritoriesEditComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.EmployeeTerritoriesEditComponent = EmployeeTerritoriesEditComponent;


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeeTerritoriesListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: EmployeeTerritoriesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var EmployeeTerritories_service_1 = __webpack_require__(81);
var EmployeeTerritoriesSearch_component_1 = __webpack_require__(398);
var EmployeeTerritoriesListComponent = (function () {
    function EmployeeTerritoriesListComponent(EmployeeTerritoriesService, route, router, toastr) {
        this.EmployeeTerritoriesService = EmployeeTerritoriesService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "EmployeeID";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newEmployeeTerritories = new EmployeeTerritories_service_1.EmployeeTerritoriesData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(EmployeeTerritoriesListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTerritoriesListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    EmployeeTerritoriesListComponent.prototype.ngOnInit = function () {
        //this.EmployeeTerritoriesService.getAll().subscribe(record => this.EmployeeTerritoriesList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getEmployeeTerritoriesByPaging();
        /*
        this.EmployeeTerritoriesList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    EmployeeTerritoriesListComponent.prototype.getEmployeeTerritories = function () {
        var _this = this;
        this.EmployeeTerritoriesService.getAll()
            .subscribe(function (data) { return _this.EmployeeTerritoriesList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on EmployeeTerritoriesSearch Component
    EmployeeTerritoriesListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getEmployeeTerritoriesByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getEmployeeTerritoriesByPaging();
    };
    EmployeeTerritoriesListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getEmployeeTerritoriesByPaging();
    };
    // Get records by paging
    EmployeeTerritoriesListComponent.prototype.getEmployeeTerritoriesByPaging = function () {
        var _this = this;
        this.EmployeeTerritoriesService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.EmployeeTerritoriesList = data.EmployeeTerritoriesList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    EmployeeTerritoriesListComponent.prototype.addEmployeeTerritories = function () {
        this.EmployeeTerritoriesService.addEmployeeTerritoriesData(this.newEmployeeTerritories).subscribe(function (record) { return console.log(record); });
        this.getEmployeeTerritories();
    };
    // Updates existing record
    EmployeeTerritoriesListComponent.prototype.updateEmployeeTerritories = function () {
        this.EmployeeTerritoriesService.updateEmployeeTerritoriesData(this.selectedEmployeeTerritories).subscribe(function (record) { return console.log(record); });
        this.getEmployeeTerritories();
    };
    // Deletes record with specified id
    EmployeeTerritoriesListComponent.prototype.deleteEmployeeTerritories = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this EmployeeTerritories?') == true) {
            this.EmployeeTerritoriesService.deleteEmployeeTerritories(id)
                .subscribe(function (data) { return _this.getEmployeeTerritories(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('EmployeeTerritories record deleted successfully...', 'Delete EmployeeTerritories');
                console.log('EmployeeTerritories record deleted successfully...');
            });
        }
    };
    // Go to First Page
    EmployeeTerritoriesListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getEmployeeTerritoriesByPaging();
    };
    // Go to Previous Page
    EmployeeTerritoriesListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getEmployeeTerritoriesByPaging();
        }
    };
    // Refresh - Go to First Page
    EmployeeTerritoriesListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // Go to Next Page
    EmployeeTerritoriesListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getEmployeeTerritoriesByPaging();
        }
    };
    // Go to Last Page
    EmployeeTerritoriesListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getEmployeeTerritoriesByPaging();
    };
    // On Edit - Go to Edit page
    EmployeeTerritoriesListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/EmployeeTerritories', item.EmployeeID]);
    };
    // On Details - Go to Details page
    EmployeeTerritoriesListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/EmployeeTerritories/Details', item.EmployeeID]);
    };
    // Set record as selected
    EmployeeTerritoriesListComponent.prototype.SelectEmployeeTerritories = function (item) {
        this.selectedEmployeeTerritories = item;
    };
    // Submits form
    EmployeeTerritoriesListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    EmployeeTerritoriesListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], EmployeeTerritoriesListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], EmployeeTerritoriesListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(EmployeeTerritoriesSearch_component_1.EmployeeTerritoriesSearchComponent), 
        __metadata('design:type', (typeof (_a = typeof EmployeeTerritoriesSearch_component_1.EmployeeTerritoriesSearchComponent !== 'undefined' && EmployeeTerritoriesSearch_component_1.EmployeeTerritoriesSearchComponent) === 'function' && _a) || Object)
    ], EmployeeTerritoriesListComponent.prototype, "filterComponent", void 0);
    EmployeeTerritoriesListComponent = __decorate([
        core_1.Component({
            selector: 'my-EmployeeTerritories',
            template: __webpack_require__(1052),
            providers: [EmployeeTerritories_service_1.EmployeeTerritoriesService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof EmployeeTerritories_service_1.EmployeeTerritoriesService !== 'undefined' && EmployeeTerritories_service_1.EmployeeTerritoriesService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], EmployeeTerritoriesListComponent);
    return EmployeeTerritoriesListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.EmployeeTerritoriesListComponent = EmployeeTerritoriesListComponent;


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeeTerritoriesSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: EmployeeTerritoriesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var EmployeeTerritories_service_1 = __webpack_require__(81);
var Employees_service_1 = __webpack_require__(28);
var Territories_service_1 = __webpack_require__(48);
var EmployeeTerritoriesSearchComponent = (function () {
    function EmployeeTerritoriesSearchComponent(route, router, EmployeeTerritoriesService, EmployeesService, TerritoriesService) {
        this.route = route;
        this.router = router;
        this.EmployeeTerritoriesService = EmployeeTerritoriesService;
        this.EmployeesService = EmployeesService;
        this.TerritoriesService = TerritoriesService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objEmployeeTerritories = new EmployeeTerritories_service_1.EmployeeTerritoriesData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(EmployeeTerritoriesSearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeeTerritoriesSearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    EmployeeTerritoriesSearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    EmployeeTerritoriesSearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objEmployeeTerritories = new EmployeeTerritories_service_1.EmployeeTerritoriesData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    EmployeeTerritoriesSearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    EmployeeTerritoriesSearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objEmployeeTerritories.EmployeeID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND EmployeeID = " + this.objEmployeeTerritories.EmployeeID;
            else
                this.filterExpression = "EmployeeID = " + this.objEmployeeTerritories.EmployeeID;
        }
        if (this.objEmployeeTerritories.TerritoryID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND TerritoryID like '%" + this.objEmployeeTerritories.TerritoryID + "%'";
            else
                this.filterExpression = "TerritoryID like '%" + this.objEmployeeTerritories.TerritoryID + "%'";
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    // Get Lookup List for Employees
    EmployeeTerritoriesSearchComponent.prototype.getEmployees = function () {
        var _this = this;
        this.EmployeesService.getAll().subscribe(function (records) { return _this.EmployeesList = records; });
    };
    // Get Lookup List for Territories
    EmployeeTerritoriesSearchComponent.prototype.getTerritories = function () {
        var _this = this;
        this.TerritoriesService.getAll().subscribe(function (records) { return _this.TerritoriesList = records; });
    };
    EmployeeTerritoriesSearchComponent.prototype.getLookups = function () {
        this.getEmployees();
        this.getTerritories();
    };
    EmployeeTerritoriesSearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], EmployeeTerritoriesSearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], EmployeeTerritoriesSearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], EmployeeTerritoriesSearchComponent.prototype, "display", null);
    EmployeeTerritoriesSearchComponent = __decorate([
        core_1.Component({
            selector: 'EmployeeTerritoriesSearch',
            template: __webpack_require__(1053),
            providers: [EmployeeTerritories_service_1.EmployeeTerritoriesService,
                Employees_service_1.EmployeesService, Territories_service_1.TerritoriesService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof EmployeeTerritories_service_1.EmployeeTerritoriesService !== 'undefined' && EmployeeTerritories_service_1.EmployeeTerritoriesService) === 'function' && _c) || Object, (typeof (_d = typeof Employees_service_1.EmployeesService !== 'undefined' && Employees_service_1.EmployeesService) === 'function' && _d) || Object, (typeof (_e = typeof Territories_service_1.TerritoriesService !== 'undefined' && Territories_service_1.TerritoriesService) === 'function' && _e) || Object])
    ], EmployeeTerritoriesSearchComponent);
    return EmployeeTerritoriesSearchComponent;
    var _a, _b, _c, _d, _e;
}());
exports.EmployeeTerritoriesSearchComponent = EmployeeTerritoriesSearchComponent;


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeesAddComponent
 * Purpose		: This component allows to create new Employees record and save changes.
 * Dependency	: EmployeesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Employees_service_1 = __webpack_require__(28);
var EmployeesAddComponent = (function () {
    function EmployeesAddComponent(route, router, toastr, EmployeesService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.EmployeesService = EmployeesService;
        this.objEmployees = new Employees_service_1.EmployeesData();
    }
    Object.defineProperty(EmployeesAddComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeesAddComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    EmployeesAddComponent.prototype.ngOnInit = function () {
        this.objEmployees = new Employees_service_1.EmployeesData();
        this.getLookups();
    };
    EmployeesAddComponent.prototype.addEmployees = function () {
        var _this = this;
        this.EmployeesService.addEmployeesData(this.objEmployees)
            .subscribe(function (record) { return _this.router.navigate(['/Employees']); }, function (error) { return _this.errorMessage = 'There was an error while adding record. Error: ' + error; }, function () {
            _this.toastr.success('Employees record added successfully...', 'Add Employees');
            console.log('Employees record added successfully...');
        });
    };
    EmployeesAddComponent.prototype.gotoEmployees = function () {
        // let Id = this.objEmployees ? this.objEmployees.EmployeeID : null;
        this.router.navigate(['/Employees']);
    };
    // Get Lookup List for Employees
    EmployeesAddComponent.prototype.getEmployees = function () {
        var _this = this;
        this.EmployeesService.getAll().subscribe(function (records) { return _this.EmployeesList = records; });
    };
    EmployeesAddComponent.prototype.getLookups = function () {
        this.getEmployees();
    };
    EmployeesAddComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], EmployeesAddComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], EmployeesAddComponent.prototype, "display", null);
    EmployeesAddComponent = __decorate([
        core_1.Component({
            selector: 'my-Employees-add',
            template: __webpack_require__(1054),
            providers: [Employees_service_1.EmployeesService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Employees_service_1.EmployeesService !== 'undefined' && Employees_service_1.EmployeesService) === 'function' && _d) || Object])
    ], EmployeesAddComponent);
    return EmployeesAddComponent;
    var _a, _b, _c, _d;
}());
exports.EmployeesAddComponent = EmployeesAddComponent;


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Employees_service_1 = __webpack_require__(28);
var EmployeesDetailsComponent = (function () {
    function EmployeesDetailsComponent(route, router, toastr, EmployeesService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.EmployeesService = EmployeesService;
        // this.id = parseInt(params.get('id'));
        this.objEmployees = new Employees_service_1.EmployeesData();
    }
    Object.defineProperty(EmployeesDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeesDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    EmployeesDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.EmployeesService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objEmployees = item; });
        this.getLookups();
    };
    EmployeesDetailsComponent.prototype.deleteEmployees = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Employees?') == true) {
            this.EmployeesService.deleteEmployees(this.objEmployees.EmployeeID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/Employees']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('Employees record deleted successfully...'); });
        }
    };
    EmployeesDetailsComponent.prototype.gotoEmployeesEdit = function () {
        this.router.navigate(['/Employees', this.objEmployees.EmployeeID]);
    };
    EmployeesDetailsComponent.prototype.gotoEmployees = function () {
        this.router.navigate(['/Employees']);
    };
    // Get Lookup List for Employees
    EmployeesDetailsComponent.prototype.getEmployees = function () {
        var _this = this;
        this.EmployeesService.getAll().subscribe(function (records) { return _this.EmployeesList = records; });
    };
    EmployeesDetailsComponent.prototype.getLookups = function () {
        this.getEmployees();
    };
    EmployeesDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], EmployeesDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], EmployeesDetailsComponent.prototype, "display", null);
    EmployeesDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1055),
            providers: [Employees_service_1.EmployeesService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Employees_service_1.EmployeesService !== 'undefined' && Employees_service_1.EmployeesService) === 'function' && _d) || Object])
    ], EmployeesDetailsComponent);
    return EmployeesDetailsComponent;
    var _a, _b, _c, _d;
}());
exports.EmployeesDetailsComponent = EmployeesDetailsComponent;


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeesEditComponent
 * Purpose		: This component retrieves data for the specified record id and allows to edit and save changes.
 * Dependency	: EmployeesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Employees_service_1 = __webpack_require__(28);
var EmployeesEditComponent = (function () {
    function EmployeesEditComponent(route, router, toastr, EmployeesService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.EmployeesService = EmployeesService;
        // this.id = parseInt(params.get('id'));
        this.objEmployees = new Employees_service_1.EmployeesData();
    }
    Object.defineProperty(EmployeesEditComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeesEditComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    EmployeesEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.EmployeesService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objEmployees = item; });
        this.getLookups();
    };
    EmployeesEditComponent.prototype.updateEmployees = function () {
        var _this = this;
        this.EmployeesService.updateEmployeesData(this.objEmployees)
            .subscribe(function (record) { return _this.router.navigate(['/Employees']); }, function (error) { return _this.errorMessage = 'There was an error while updating record. Error: ' + error; }, function () {
            _this.toastr.success('Employees record updated successfully...', 'Edit Employees');
            console.log('Employees record updated successfully...');
        });
    };
    EmployeesEditComponent.prototype.deleteEmployees = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Employees?') == true) {
            this.EmployeesService.deleteEmployees(this.objEmployees.EmployeeID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/Employees']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('Employees record deleted successfully...', 'Delete Employees');
                console.log('Employees record deleted successfully...');
            });
        }
    };
    EmployeesEditComponent.prototype.gotoEmployees = function () {
        var Id = this.objEmployees ? this.objEmployees.EmployeeID : null;
        this.router.navigate(['/Employees']);
    };
    // Get Lookup List for Employees
    EmployeesEditComponent.prototype.getEmployees = function () {
        var _this = this;
        this.EmployeesService.getAll().subscribe(function (records) { return _this.EmployeesList = records; });
    };
    EmployeesEditComponent.prototype.getLookups = function () {
        this.getEmployees();
    };
    EmployeesEditComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], EmployeesEditComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], EmployeesEditComponent.prototype, "display", null);
    EmployeesEditComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1056),
            providers: [Employees_service_1.EmployeesService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Employees_service_1.EmployeesService !== 'undefined' && Employees_service_1.EmployeesService) === 'function' && _d) || Object])
    ], EmployeesEditComponent);
    return EmployeesEditComponent;
    var _a, _b, _c, _d;
}());
exports.EmployeesEditComponent = EmployeesEditComponent;


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeesListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: EmployeesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var Employees_service_1 = __webpack_require__(28);
var EmployeesSearch_component_1 = __webpack_require__(403);
var EmployeesListComponent = (function () {
    function EmployeesListComponent(EmployeesService, route, router, toastr) {
        this.EmployeesService = EmployeesService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "EmployeeID";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newEmployees = new Employees_service_1.EmployeesData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(EmployeesListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeesListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    EmployeesListComponent.prototype.ngOnInit = function () {
        //this.EmployeesService.getAll().subscribe(record => this.EmployeesList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getEmployeesByPaging();
        /*
        this.EmployeesList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    EmployeesListComponent.prototype.getEmployees = function () {
        var _this = this;
        this.EmployeesService.getAll()
            .subscribe(function (data) { return _this.EmployeesList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on EmployeesSearch Component
    EmployeesListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getEmployeesByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getEmployeesByPaging();
    };
    EmployeesListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getEmployeesByPaging();
    };
    // Get records by paging
    EmployeesListComponent.prototype.getEmployeesByPaging = function () {
        var _this = this;
        this.EmployeesService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.EmployeesList = data.EmployeesList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    EmployeesListComponent.prototype.addEmployees = function () {
        this.EmployeesService.addEmployeesData(this.newEmployees).subscribe(function (record) { return console.log(record); });
        this.getEmployees();
    };
    // Updates existing record
    EmployeesListComponent.prototype.updateEmployees = function () {
        this.EmployeesService.updateEmployeesData(this.selectedEmployees).subscribe(function (record) { return console.log(record); });
        this.getEmployees();
    };
    // Deletes record with specified id
    EmployeesListComponent.prototype.deleteEmployees = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Employees?') == true) {
            this.EmployeesService.deleteEmployees(id)
                .subscribe(function (data) { return _this.getEmployees(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('Employees record deleted successfully...', 'Delete Employees');
                console.log('Employees record deleted successfully...');
            });
        }
    };
    // Go to First Page
    EmployeesListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getEmployeesByPaging();
    };
    // Go to Previous Page
    EmployeesListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getEmployeesByPaging();
        }
    };
    // Refresh - Go to First Page
    EmployeesListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // Go to Next Page
    EmployeesListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getEmployeesByPaging();
        }
    };
    // Go to Last Page
    EmployeesListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getEmployeesByPaging();
    };
    // On Edit - Go to Edit page
    EmployeesListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/Employees', item.EmployeeID]);
    };
    // On Details - Go to Details page
    EmployeesListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/Employees/Details', item.EmployeeID]);
    };
    // Set record as selected
    EmployeesListComponent.prototype.SelectEmployees = function (item) {
        this.selectedEmployees = item;
    };
    // Submits form
    EmployeesListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    EmployeesListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], EmployeesListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], EmployeesListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(EmployeesSearch_component_1.EmployeesSearchComponent), 
        __metadata('design:type', (typeof (_a = typeof EmployeesSearch_component_1.EmployeesSearchComponent !== 'undefined' && EmployeesSearch_component_1.EmployeesSearchComponent) === 'function' && _a) || Object)
    ], EmployeesListComponent.prototype, "filterComponent", void 0);
    EmployeesListComponent = __decorate([
        core_1.Component({
            selector: 'my-Employees',
            template: __webpack_require__(1057),
            providers: [Employees_service_1.EmployeesService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof Employees_service_1.EmployeesService !== 'undefined' && Employees_service_1.EmployeesService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], EmployeesListComponent);
    return EmployeesListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.EmployeesListComponent = EmployeesListComponent;


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeesSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: EmployeesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var Employees_service_1 = __webpack_require__(28);
var EmployeesSearchComponent = (function () {
    function EmployeesSearchComponent(route, router, EmployeesService) {
        this.route = route;
        this.router = router;
        this.EmployeesService = EmployeesService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objEmployees = new Employees_service_1.EmployeesData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(EmployeesSearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeesSearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    EmployeesSearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    EmployeesSearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objEmployees = new Employees_service_1.EmployeesData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    EmployeesSearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    EmployeesSearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objEmployees.EmployeeID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND EmployeeID = " + this.objEmployees.EmployeeID;
            else
                this.filterExpression = "EmployeeID = " + this.objEmployees.EmployeeID;
        }
        if (this.objEmployees.LastName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND LastName like '%" + this.objEmployees.LastName + "%'";
            else
                this.filterExpression = "LastName like '%" + this.objEmployees.LastName + "%'";
        }
        if (this.objEmployees.FirstName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND FirstName like '%" + this.objEmployees.FirstName + "%'";
            else
                this.filterExpression = "FirstName like '%" + this.objEmployees.FirstName + "%'";
        }
        if (this.objEmployees.Title) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Title like '%" + this.objEmployees.Title + "%'";
            else
                this.filterExpression = "Title like '%" + this.objEmployees.Title + "%'";
        }
        if (this.objEmployees.TitleOfCourtesy) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND TitleOfCourtesy like '%" + this.objEmployees.TitleOfCourtesy + "%'";
            else
                this.filterExpression = "TitleOfCourtesy like '%" + this.objEmployees.TitleOfCourtesy + "%'";
        }
        if (this.objEmployees.Address) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Address like '%" + this.objEmployees.Address + "%'";
            else
                this.filterExpression = "Address like '%" + this.objEmployees.Address + "%'";
        }
        if (this.objEmployees.City) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND City like '%" + this.objEmployees.City + "%'";
            else
                this.filterExpression = "City like '%" + this.objEmployees.City + "%'";
        }
        if (this.objEmployees.Region) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Region like '%" + this.objEmployees.Region + "%'";
            else
                this.filterExpression = "Region like '%" + this.objEmployees.Region + "%'";
        }
        if (this.objEmployees.PostalCode) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND PostalCode like '%" + this.objEmployees.PostalCode + "%'";
            else
                this.filterExpression = "PostalCode like '%" + this.objEmployees.PostalCode + "%'";
        }
        if (this.objEmployees.Country) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Country like '%" + this.objEmployees.Country + "%'";
            else
                this.filterExpression = "Country like '%" + this.objEmployees.Country + "%'";
        }
        if (this.objEmployees.HomePhone) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND HomePhone like '%" + this.objEmployees.HomePhone + "%'";
            else
                this.filterExpression = "HomePhone like '%" + this.objEmployees.HomePhone + "%'";
        }
        if (this.objEmployees.Extension) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Extension like '%" + this.objEmployees.Extension + "%'";
            else
                this.filterExpression = "Extension like '%" + this.objEmployees.Extension + "%'";
        }
        if (this.objEmployees.Notes) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Notes like '%" + this.objEmployees.Notes + "%'";
            else
                this.filterExpression = "Notes like '%" + this.objEmployees.Notes + "%'";
        }
        if (this.objEmployees.ReportsTo) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ReportsTo = " + this.objEmployees.ReportsTo;
            else
                this.filterExpression = "ReportsTo = " + this.objEmployees.ReportsTo;
        }
        if (this.objEmployees.PhotoPath) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND PhotoPath like '%" + this.objEmployees.PhotoPath + "%'";
            else
                this.filterExpression = "PhotoPath like '%" + this.objEmployees.PhotoPath + "%'";
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    // Get Lookup List for Employees
    EmployeesSearchComponent.prototype.getEmployees = function () {
        var _this = this;
        this.EmployeesService.getAll().subscribe(function (records) { return _this.EmployeesList = records; });
    };
    EmployeesSearchComponent.prototype.getLookups = function () {
        this.getEmployees();
    };
    EmployeesSearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], EmployeesSearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], EmployeesSearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], EmployeesSearchComponent.prototype, "display", null);
    EmployeesSearchComponent = __decorate([
        core_1.Component({
            selector: 'EmployeesSearch',
            template: __webpack_require__(1058),
            providers: [Employees_service_1.EmployeesService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof Employees_service_1.EmployeesService !== 'undefined' && Employees_service_1.EmployeesService) === 'function' && _c) || Object])
    ], EmployeesSearchComponent);
    return EmployeesSearchComponent;
    var _a, _b, _c;
}());
exports.EmployeesSearchComponent = EmployeesSearchComponent;


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: InvoicesAddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: InvoicesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Invoices_service_1 = __webpack_require__(144);
var InvoicesDetailsComponent = (function () {
    // Lookup Arrays
    function InvoicesDetailsComponent(route, router, toastr, InvoicesService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.InvoicesService = InvoicesService;
        // this.id = parseInt(params.get('id'));
        this.objInvoices = new Invoices_service_1.InvoicesData();
    }
    Object.defineProperty(InvoicesDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InvoicesDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    InvoicesDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.InvoicesService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objInvoices = item; });
        this.getLookups();
    };
    InvoicesDetailsComponent.prototype.deleteInvoices = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Invoices?') == true) {
            this.InvoicesService.deleteInvoices(this.objInvoices.ShipName.toString())
                .subscribe(function (record) { return _this.router.navigate(['/Invoices']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('Invoices record deleted successfully...'); });
        }
    };
    InvoicesDetailsComponent.prototype.gotoInvoicesEdit = function () {
        this.router.navigate(['/Invoices', this.objInvoices.ShipName]);
    };
    InvoicesDetailsComponent.prototype.gotoInvoices = function () {
        this.router.navigate(['/Invoices']);
    };
    InvoicesDetailsComponent.prototype.getLookups = function () {
    };
    InvoicesDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], InvoicesDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], InvoicesDetailsComponent.prototype, "display", null);
    InvoicesDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1059),
            providers: [Invoices_service_1.InvoicesService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Invoices_service_1.InvoicesService !== 'undefined' && Invoices_service_1.InvoicesService) === 'function' && _d) || Object])
    ], InvoicesDetailsComponent);
    return InvoicesDetailsComponent;
    var _a, _b, _c, _d;
}());
exports.InvoicesDetailsComponent = InvoicesDetailsComponent;


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: InvoicesListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: InvoicesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var Invoices_service_1 = __webpack_require__(144);
var InvoicesSearch_component_1 = __webpack_require__(406);
var InvoicesListComponent = (function () {
    function InvoicesListComponent(InvoicesService, route, router, toastr) {
        this.InvoicesService = InvoicesService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "ShipName";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newInvoices = new Invoices_service_1.InvoicesData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(InvoicesListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InvoicesListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    InvoicesListComponent.prototype.ngOnInit = function () {
        // this.InvoicesService.getAll().subscribe(record => this.InvoicesList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getInvoicesByPaging();
        /*
        this.InvoicesList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    InvoicesListComponent.prototype.getInvoices = function () {
        var _this = this;
        this.InvoicesService.getAll()
            .subscribe(function (data) { return _this.InvoicesList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on InvoicesSearch Component
    InvoicesListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getInvoicesByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getInvoicesByPaging();
    };
    InvoicesListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getInvoicesByPaging();
    };
    // Get records by paging
    InvoicesListComponent.prototype.getInvoicesByPaging = function () {
        var _this = this;
        this.InvoicesService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.InvoicesList = data.InvoicesList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    InvoicesListComponent.prototype.addInvoices = function () {
        this.InvoicesService.addInvoicesData(this.newInvoices).subscribe(function (record) { return console.log(record); });
        this.getInvoices();
    };
    // Updates existing record
    InvoicesListComponent.prototype.updateInvoices = function () {
        this.InvoicesService.updateInvoicesData(this.selectedInvoices).subscribe(function (record) { return console.log(record); });
        this.getInvoices();
    };
    // Deletes record with specified id
    InvoicesListComponent.prototype.deleteInvoices = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Invoices?') == true) {
            this.InvoicesService.deleteInvoices(id)
                .subscribe(function (data) { return _this.getInvoices(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; });
        }
    };
    // Go to First Page
    InvoicesListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getInvoicesByPaging();
    };
    // Go to Previous Page
    InvoicesListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getInvoicesByPaging();
        }
    };
    // Go to Next Page
    InvoicesListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getInvoicesByPaging();
        }
    };
    // Go to Last Page
    InvoicesListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getInvoicesByPaging();
    };
    // Refresh - Go to First Page
    InvoicesListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // On Edit - Go to Edit page
    InvoicesListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/Invoices', item.ShipName]);
    };
    // On Details - Go to Details page
    InvoicesListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/Invoices/Details', item.ShipName]);
    };
    // Set record as selected
    InvoicesListComponent.prototype.SelectInvoices = function (item) {
        this.selectedInvoices = item;
    };
    // Submits form
    InvoicesListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    InvoicesListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], InvoicesListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], InvoicesListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(InvoicesSearch_component_1.InvoicesSearchComponent), 
        __metadata('design:type', (typeof (_a = typeof InvoicesSearch_component_1.InvoicesSearchComponent !== 'undefined' && InvoicesSearch_component_1.InvoicesSearchComponent) === 'function' && _a) || Object)
    ], InvoicesListComponent.prototype, "filterComponent", void 0);
    InvoicesListComponent = __decorate([
        core_1.Component({
            selector: 'my-Invoices',
            template: __webpack_require__(1060),
            providers: [Invoices_service_1.InvoicesService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof Invoices_service_1.InvoicesService !== 'undefined' && Invoices_service_1.InvoicesService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], InvoicesListComponent);
    return InvoicesListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.InvoicesListComponent = InvoicesListComponent;


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: InvoicesSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: InvoicesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var Invoices_service_1 = __webpack_require__(144);
var InvoicesSearchComponent = (function () {
    // Lookup Arrays
    function InvoicesSearchComponent(route, router, InvoicesService) {
        this.route = route;
        this.router = router;
        this.InvoicesService = InvoicesService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objInvoices = new Invoices_service_1.InvoicesData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(InvoicesSearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InvoicesSearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    InvoicesSearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    InvoicesSearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objInvoices = new Invoices_service_1.InvoicesData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    InvoicesSearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    InvoicesSearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objInvoices.ShipName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ShipName like '%" + this.objInvoices.ShipName + "%'";
            else
                this.filterExpression = "ShipName like '%" + this.objInvoices.ShipName + "%'";
        }
        if (this.objInvoices.ShipAddress) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ShipAddress like '%" + this.objInvoices.ShipAddress + "%'";
            else
                this.filterExpression = "ShipAddress like '%" + this.objInvoices.ShipAddress + "%'";
        }
        if (this.objInvoices.ShipCity) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ShipCity like '%" + this.objInvoices.ShipCity + "%'";
            else
                this.filterExpression = "ShipCity like '%" + this.objInvoices.ShipCity + "%'";
        }
        if (this.objInvoices.ShipRegion) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ShipRegion like '%" + this.objInvoices.ShipRegion + "%'";
            else
                this.filterExpression = "ShipRegion like '%" + this.objInvoices.ShipRegion + "%'";
        }
        if (this.objInvoices.ShipPostalCode) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ShipPostalCode like '%" + this.objInvoices.ShipPostalCode + "%'";
            else
                this.filterExpression = "ShipPostalCode like '%" + this.objInvoices.ShipPostalCode + "%'";
        }
        if (this.objInvoices.ShipCountry) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ShipCountry like '%" + this.objInvoices.ShipCountry + "%'";
            else
                this.filterExpression = "ShipCountry like '%" + this.objInvoices.ShipCountry + "%'";
        }
        if (this.objInvoices.CustomerID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CustomerID like '%" + this.objInvoices.CustomerID + "%'";
            else
                this.filterExpression = "CustomerID like '%" + this.objInvoices.CustomerID + "%'";
        }
        if (this.objInvoices.CustomerName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CustomerName like '%" + this.objInvoices.CustomerName + "%'";
            else
                this.filterExpression = "CustomerName like '%" + this.objInvoices.CustomerName + "%'";
        }
        if (this.objInvoices.Address) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Address like '%" + this.objInvoices.Address + "%'";
            else
                this.filterExpression = "Address like '%" + this.objInvoices.Address + "%'";
        }
        if (this.objInvoices.City) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND City like '%" + this.objInvoices.City + "%'";
            else
                this.filterExpression = "City like '%" + this.objInvoices.City + "%'";
        }
        if (this.objInvoices.Region) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Region like '%" + this.objInvoices.Region + "%'";
            else
                this.filterExpression = "Region like '%" + this.objInvoices.Region + "%'";
        }
        if (this.objInvoices.PostalCode) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND PostalCode like '%" + this.objInvoices.PostalCode + "%'";
            else
                this.filterExpression = "PostalCode like '%" + this.objInvoices.PostalCode + "%'";
        }
        if (this.objInvoices.Country) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Country like '%" + this.objInvoices.Country + "%'";
            else
                this.filterExpression = "Country like '%" + this.objInvoices.Country + "%'";
        }
        if (this.objInvoices.Salesperson) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Salesperson like '%" + this.objInvoices.Salesperson + "%'";
            else
                this.filterExpression = "Salesperson like '%" + this.objInvoices.Salesperson + "%'";
        }
        if (this.objInvoices.OrderID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND OrderID = " + this.objInvoices.OrderID;
            else
                this.filterExpression = "OrderID = " + this.objInvoices.OrderID;
        }
        if (this.objInvoices.ShipperName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ShipperName like '%" + this.objInvoices.ShipperName + "%'";
            else
                this.filterExpression = "ShipperName like '%" + this.objInvoices.ShipperName + "%'";
        }
        if (this.objInvoices.ProductID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ProductID = " + this.objInvoices.ProductID;
            else
                this.filterExpression = "ProductID = " + this.objInvoices.ProductID;
        }
        if (this.objInvoices.ProductName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ProductName like '%" + this.objInvoices.ProductName + "%'";
            else
                this.filterExpression = "ProductName like '%" + this.objInvoices.ProductName + "%'";
        }
        if (this.objInvoices.UnitPrice) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND UnitPrice = " + this.objInvoices.UnitPrice;
            else
                this.filterExpression = "UnitPrice = " + this.objInvoices.UnitPrice;
        }
        if (this.objInvoices.Quantity) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Quantity = " + this.objInvoices.Quantity;
            else
                this.filterExpression = "Quantity = " + this.objInvoices.Quantity;
        }
        if (this.objInvoices.ExtendedPrice) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ExtendedPrice = " + this.objInvoices.ExtendedPrice;
            else
                this.filterExpression = "ExtendedPrice = " + this.objInvoices.ExtendedPrice;
        }
        if (this.objInvoices.Freight) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Freight = " + this.objInvoices.Freight;
            else
                this.filterExpression = "Freight = " + this.objInvoices.Freight;
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    InvoicesSearchComponent.prototype.getLookups = function () {
    };
    InvoicesSearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], InvoicesSearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], InvoicesSearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], InvoicesSearchComponent.prototype, "display", null);
    InvoicesSearchComponent = __decorate([
        core_1.Component({
            selector: 'InvoicesSearch',
            template: __webpack_require__(1061),
            providers: [Invoices_service_1.InvoicesService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof Invoices_service_1.InvoicesService !== 'undefined' && Invoices_service_1.InvoicesService) === 'function' && _c) || Object])
    ], InvoicesSearchComponent);
    return InvoicesSearchComponent;
    var _a, _b, _c;
}());
exports.InvoicesSearchComponent = InvoicesSearchComponent;


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderDetailsExtendedAddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: OrderDetailsExtendedService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var OrderDetailsExtended_service_1 = __webpack_require__(145);
var OrderDetailsExtendedDetailsComponent = (function () {
    // Lookup Arrays
    function OrderDetailsExtendedDetailsComponent(route, router, toastr, OrderDetailsExtendedService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.OrderDetailsExtendedService = OrderDetailsExtendedService;
        // this.id = parseInt(params.get('id'));
        this.objOrderDetailsExtended = new OrderDetailsExtended_service_1.OrderDetailsExtendedData();
    }
    Object.defineProperty(OrderDetailsExtendedDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderDetailsExtendedDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    OrderDetailsExtendedDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.OrderDetailsExtendedService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objOrderDetailsExtended = item; });
        this.getLookups();
    };
    OrderDetailsExtendedDetailsComponent.prototype.deleteOrderDetailsExtended = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this OrderDetailsExtended?') == true) {
            this.OrderDetailsExtendedService.deleteOrderDetailsExtended(this.objOrderDetailsExtended.OrderID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/OrderDetailsExtended']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('OrderDetailsExtended record deleted successfully...'); });
        }
    };
    OrderDetailsExtendedDetailsComponent.prototype.gotoOrderDetailsExtendedEdit = function () {
        this.router.navigate(['/OrderDetailsExtended', this.objOrderDetailsExtended.OrderID]);
    };
    OrderDetailsExtendedDetailsComponent.prototype.gotoOrderDetailsExtended = function () {
        this.router.navigate(['/OrderDetailsExtended']);
    };
    OrderDetailsExtendedDetailsComponent.prototype.getLookups = function () {
    };
    OrderDetailsExtendedDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], OrderDetailsExtendedDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], OrderDetailsExtendedDetailsComponent.prototype, "display", null);
    OrderDetailsExtendedDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1062),
            providers: [OrderDetailsExtended_service_1.OrderDetailsExtendedService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof OrderDetailsExtended_service_1.OrderDetailsExtendedService !== 'undefined' && OrderDetailsExtended_service_1.OrderDetailsExtendedService) === 'function' && _d) || Object])
    ], OrderDetailsExtendedDetailsComponent);
    return OrderDetailsExtendedDetailsComponent;
    var _a, _b, _c, _d;
}());
exports.OrderDetailsExtendedDetailsComponent = OrderDetailsExtendedDetailsComponent;


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderDetailsExtendedListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: OrderDetailsExtendedService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var OrderDetailsExtended_service_1 = __webpack_require__(145);
var OrderDetailsExtendedSearch_component_1 = __webpack_require__(409);
var OrderDetailsExtendedListComponent = (function () {
    function OrderDetailsExtendedListComponent(OrderDetailsExtendedService, route, router, toastr) {
        this.OrderDetailsExtendedService = OrderDetailsExtendedService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "OrderID";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newOrderDetailsExtended = new OrderDetailsExtended_service_1.OrderDetailsExtendedData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(OrderDetailsExtendedListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderDetailsExtendedListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    OrderDetailsExtendedListComponent.prototype.ngOnInit = function () {
        // this.OrderDetailsExtendedService.getAll().subscribe(record => this.OrderDetailsExtendedList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getOrderDetailsExtendedByPaging();
        /*
        this.OrderDetailsExtendedList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    OrderDetailsExtendedListComponent.prototype.getOrderDetailsExtended = function () {
        var _this = this;
        this.OrderDetailsExtendedService.getAll()
            .subscribe(function (data) { return _this.OrderDetailsExtendedList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on OrderDetailsExtendedSearch Component
    OrderDetailsExtendedListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getOrderDetailsExtendedByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getOrderDetailsExtendedByPaging();
    };
    OrderDetailsExtendedListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getOrderDetailsExtendedByPaging();
    };
    // Get records by paging
    OrderDetailsExtendedListComponent.prototype.getOrderDetailsExtendedByPaging = function () {
        var _this = this;
        this.OrderDetailsExtendedService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.OrderDetailsExtendedList = data.OrderDetailsExtendedList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    OrderDetailsExtendedListComponent.prototype.addOrderDetailsExtended = function () {
        this.OrderDetailsExtendedService.addOrderDetailsExtendedData(this.newOrderDetailsExtended).subscribe(function (record) { return console.log(record); });
        this.getOrderDetailsExtended();
    };
    // Updates existing record
    OrderDetailsExtendedListComponent.prototype.updateOrderDetailsExtended = function () {
        this.OrderDetailsExtendedService.updateOrderDetailsExtendedData(this.selectedOrderDetailsExtended).subscribe(function (record) { return console.log(record); });
        this.getOrderDetailsExtended();
    };
    // Deletes record with specified id
    OrderDetailsExtendedListComponent.prototype.deleteOrderDetailsExtended = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this OrderDetailsExtended?') == true) {
            this.OrderDetailsExtendedService.deleteOrderDetailsExtended(id)
                .subscribe(function (data) { return _this.getOrderDetailsExtended(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; });
        }
    };
    // Go to First Page
    OrderDetailsExtendedListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getOrderDetailsExtendedByPaging();
    };
    // Go to Previous Page
    OrderDetailsExtendedListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getOrderDetailsExtendedByPaging();
        }
    };
    // Go to Next Page
    OrderDetailsExtendedListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getOrderDetailsExtendedByPaging();
        }
    };
    // Go to Last Page
    OrderDetailsExtendedListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getOrderDetailsExtendedByPaging();
    };
    // Refresh - Go to First Page
    OrderDetailsExtendedListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // On Edit - Go to Edit page
    OrderDetailsExtendedListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/OrderDetailsExtended', item.OrderID]);
    };
    // On Details - Go to Details page
    OrderDetailsExtendedListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/OrderDetailsExtended/Details', item.OrderID]);
    };
    // Set record as selected
    OrderDetailsExtendedListComponent.prototype.SelectOrderDetailsExtended = function (item) {
        this.selectedOrderDetailsExtended = item;
    };
    // Submits form
    OrderDetailsExtendedListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    OrderDetailsExtendedListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], OrderDetailsExtendedListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], OrderDetailsExtendedListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(OrderDetailsExtendedSearch_component_1.OrderDetailsExtendedSearchComponent), 
        __metadata('design:type', (typeof (_a = typeof OrderDetailsExtendedSearch_component_1.OrderDetailsExtendedSearchComponent !== 'undefined' && OrderDetailsExtendedSearch_component_1.OrderDetailsExtendedSearchComponent) === 'function' && _a) || Object)
    ], OrderDetailsExtendedListComponent.prototype, "filterComponent", void 0);
    OrderDetailsExtendedListComponent = __decorate([
        core_1.Component({
            selector: 'my-OrderDetailsExtended',
            template: __webpack_require__(1063),
            providers: [OrderDetailsExtended_service_1.OrderDetailsExtendedService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof OrderDetailsExtended_service_1.OrderDetailsExtendedService !== 'undefined' && OrderDetailsExtended_service_1.OrderDetailsExtendedService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], OrderDetailsExtendedListComponent);
    return OrderDetailsExtendedListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.OrderDetailsExtendedListComponent = OrderDetailsExtendedListComponent;


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderDetailsExtendedSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: OrderDetailsExtendedService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var OrderDetailsExtended_service_1 = __webpack_require__(145);
var OrderDetailsExtendedSearchComponent = (function () {
    // Lookup Arrays
    function OrderDetailsExtendedSearchComponent(route, router, OrderDetailsExtendedService) {
        this.route = route;
        this.router = router;
        this.OrderDetailsExtendedService = OrderDetailsExtendedService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objOrderDetailsExtended = new OrderDetailsExtended_service_1.OrderDetailsExtendedData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(OrderDetailsExtendedSearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderDetailsExtendedSearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    OrderDetailsExtendedSearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    OrderDetailsExtendedSearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objOrderDetailsExtended = new OrderDetailsExtended_service_1.OrderDetailsExtendedData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    OrderDetailsExtendedSearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    OrderDetailsExtendedSearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objOrderDetailsExtended.OrderID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND OrderID = " + this.objOrderDetailsExtended.OrderID;
            else
                this.filterExpression = "OrderID = " + this.objOrderDetailsExtended.OrderID;
        }
        if (this.objOrderDetailsExtended.ProductID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ProductID = " + this.objOrderDetailsExtended.ProductID;
            else
                this.filterExpression = "ProductID = " + this.objOrderDetailsExtended.ProductID;
        }
        if (this.objOrderDetailsExtended.ProductName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ProductName like '%" + this.objOrderDetailsExtended.ProductName + "%'";
            else
                this.filterExpression = "ProductName like '%" + this.objOrderDetailsExtended.ProductName + "%'";
        }
        if (this.objOrderDetailsExtended.UnitPrice) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND UnitPrice = " + this.objOrderDetailsExtended.UnitPrice;
            else
                this.filterExpression = "UnitPrice = " + this.objOrderDetailsExtended.UnitPrice;
        }
        if (this.objOrderDetailsExtended.Quantity) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Quantity = " + this.objOrderDetailsExtended.Quantity;
            else
                this.filterExpression = "Quantity = " + this.objOrderDetailsExtended.Quantity;
        }
        if (this.objOrderDetailsExtended.ExtendedPrice) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ExtendedPrice = " + this.objOrderDetailsExtended.ExtendedPrice;
            else
                this.filterExpression = "ExtendedPrice = " + this.objOrderDetailsExtended.ExtendedPrice;
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    OrderDetailsExtendedSearchComponent.prototype.getLookups = function () {
    };
    OrderDetailsExtendedSearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], OrderDetailsExtendedSearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], OrderDetailsExtendedSearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], OrderDetailsExtendedSearchComponent.prototype, "display", null);
    OrderDetailsExtendedSearchComponent = __decorate([
        core_1.Component({
            selector: 'OrderDetailsExtendedSearch',
            template: __webpack_require__(1064),
            providers: [OrderDetailsExtended_service_1.OrderDetailsExtendedService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof OrderDetailsExtended_service_1.OrderDetailsExtendedService !== 'undefined' && OrderDetailsExtended_service_1.OrderDetailsExtendedService) === 'function' && _c) || Object])
    ], OrderDetailsExtendedSearchComponent);
    return OrderDetailsExtendedSearchComponent;
    var _a, _b, _c;
}());
exports.OrderDetailsExtendedSearchComponent = OrderDetailsExtendedSearchComponent;


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderDetailsAddComponent
 * Purpose		: This component allows to create new OrderDetails record and save changes.
 * Dependency	: OrderDetailsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var OrderDetails_service_1 = __webpack_require__(82);
var Products_service_1 = __webpack_require__(44);
var Orders_service_1 = __webpack_require__(43);
var OrderDetailsAddComponent = (function () {
    function OrderDetailsAddComponent(route, router, toastr, OrderDetailsService, ProductsService, OrdersService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.OrderDetailsService = OrderDetailsService;
        this.ProductsService = ProductsService;
        this.OrdersService = OrdersService;
        this.objOrderDetails = new OrderDetails_service_1.OrderDetailsData();
    }
    Object.defineProperty(OrderDetailsAddComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderDetailsAddComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    OrderDetailsAddComponent.prototype.ngOnInit = function () {
        this.objOrderDetails = new OrderDetails_service_1.OrderDetailsData();
        this.getLookups();
    };
    OrderDetailsAddComponent.prototype.addOrderDetails = function () {
        var _this = this;
        this.OrderDetailsService.addOrderDetailsData(this.objOrderDetails)
            .subscribe(function (record) { return _this.router.navigate(['/OrderDetails']); }, function (error) { return _this.errorMessage = 'There was an error while adding record. Error: ' + error; }, function () {
            _this.toastr.success('OrderDetails record added successfully...', 'Add OrderDetails');
            console.log('OrderDetails record added successfully...');
        });
    };
    OrderDetailsAddComponent.prototype.gotoOrderDetails = function () {
        // let Id = this.objOrderDetails ? this.objOrderDetails.OrderID : null;
        this.router.navigate(['/OrderDetails']);
    };
    // Get Lookup List for Products
    OrderDetailsAddComponent.prototype.getProducts = function () {
        var _this = this;
        this.ProductsService.getAll().subscribe(function (records) { return _this.ProductsList = records; });
    };
    // Get Lookup List for Orders
    OrderDetailsAddComponent.prototype.getOrders = function () {
        var _this = this;
        this.OrdersService.getAll().subscribe(function (records) { return _this.OrdersList = records; });
    };
    OrderDetailsAddComponent.prototype.getLookups = function () {
        this.getProducts();
        this.getOrders();
    };
    OrderDetailsAddComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], OrderDetailsAddComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], OrderDetailsAddComponent.prototype, "display", null);
    OrderDetailsAddComponent = __decorate([
        core_1.Component({
            selector: 'my-OrderDetails-add',
            template: __webpack_require__(1065),
            providers: [OrderDetails_service_1.OrderDetailsService,
                Products_service_1.ProductsService, Orders_service_1.OrdersService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof OrderDetails_service_1.OrderDetailsService !== 'undefined' && OrderDetails_service_1.OrderDetailsService) === 'function' && _d) || Object, (typeof (_e = typeof Products_service_1.ProductsService !== 'undefined' && Products_service_1.ProductsService) === 'function' && _e) || Object, (typeof (_f = typeof Orders_service_1.OrdersService !== 'undefined' && Orders_service_1.OrdersService) === 'function' && _f) || Object])
    ], OrderDetailsAddComponent);
    return OrderDetailsAddComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.OrderDetailsAddComponent = OrderDetailsAddComponent;


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var OrderDetails_service_1 = __webpack_require__(82);
var Products_service_1 = __webpack_require__(44);
var Orders_service_1 = __webpack_require__(43);
var OrderDetailsDetailsComponent = (function () {
    function OrderDetailsDetailsComponent(route, router, toastr, OrderDetailsService, ProductsService, OrdersService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.OrderDetailsService = OrderDetailsService;
        this.ProductsService = ProductsService;
        this.OrdersService = OrdersService;
        // this.id = parseInt(params.get('id'));
        this.objOrderDetails = new OrderDetails_service_1.OrderDetailsData();
    }
    Object.defineProperty(OrderDetailsDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderDetailsDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    OrderDetailsDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.OrderDetailsService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objOrderDetails = item; });
        this.getLookups();
    };
    OrderDetailsDetailsComponent.prototype.deleteOrderDetails = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this OrderDetails?') == true) {
            this.OrderDetailsService.deleteOrderDetails(this.objOrderDetails.OrderID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/OrderDetails']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('OrderDetails record deleted successfully...'); });
        }
    };
    OrderDetailsDetailsComponent.prototype.gotoOrderDetailsEdit = function () {
        this.router.navigate(['/OrderDetails', this.objOrderDetails.OrderID]);
    };
    OrderDetailsDetailsComponent.prototype.gotoOrderDetails = function () {
        this.router.navigate(['/OrderDetails']);
    };
    // Get Lookup List for Products
    OrderDetailsDetailsComponent.prototype.getProducts = function () {
        var _this = this;
        this.ProductsService.getAll().subscribe(function (records) { return _this.ProductsList = records; });
    };
    // Get Lookup List for Orders
    OrderDetailsDetailsComponent.prototype.getOrders = function () {
        var _this = this;
        this.OrdersService.getAll().subscribe(function (records) { return _this.OrdersList = records; });
    };
    OrderDetailsDetailsComponent.prototype.getLookups = function () {
        this.getProducts();
        this.getOrders();
    };
    OrderDetailsDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], OrderDetailsDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], OrderDetailsDetailsComponent.prototype, "display", null);
    OrderDetailsDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1066),
            providers: [OrderDetails_service_1.OrderDetailsService,
                Products_service_1.ProductsService, Orders_service_1.OrdersService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof OrderDetails_service_1.OrderDetailsService !== 'undefined' && OrderDetails_service_1.OrderDetailsService) === 'function' && _d) || Object, (typeof (_e = typeof Products_service_1.ProductsService !== 'undefined' && Products_service_1.ProductsService) === 'function' && _e) || Object, (typeof (_f = typeof Orders_service_1.OrdersService !== 'undefined' && Orders_service_1.OrdersService) === 'function' && _f) || Object])
    ], OrderDetailsDetailsComponent);
    return OrderDetailsDetailsComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.OrderDetailsDetailsComponent = OrderDetailsDetailsComponent;


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderDetailsEditComponent
 * Purpose		: This component retrieves data for the specified record id and allows to edit and save changes.
 * Dependency	: OrderDetailsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var OrderDetails_service_1 = __webpack_require__(82);
var Products_service_1 = __webpack_require__(44);
var Orders_service_1 = __webpack_require__(43);
var OrderDetailsEditComponent = (function () {
    function OrderDetailsEditComponent(route, router, toastr, OrderDetailsService, ProductsService, OrdersService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.OrderDetailsService = OrderDetailsService;
        this.ProductsService = ProductsService;
        this.OrdersService = OrdersService;
        // this.id = parseInt(params.get('id'));
        this.objOrderDetails = new OrderDetails_service_1.OrderDetailsData();
    }
    Object.defineProperty(OrderDetailsEditComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderDetailsEditComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    OrderDetailsEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.OrderDetailsService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objOrderDetails = item; });
        this.getLookups();
    };
    OrderDetailsEditComponent.prototype.updateOrderDetails = function () {
        var _this = this;
        this.OrderDetailsService.updateOrderDetailsData(this.objOrderDetails)
            .subscribe(function (record) { return _this.router.navigate(['/OrderDetails']); }, function (error) { return _this.errorMessage = 'There was an error while updating record. Error: ' + error; }, function () {
            _this.toastr.success('OrderDetails record updated successfully...', 'Edit OrderDetails');
            console.log('OrderDetails record updated successfully...');
        });
    };
    OrderDetailsEditComponent.prototype.deleteOrderDetails = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this OrderDetails?') == true) {
            this.OrderDetailsService.deleteOrderDetails(this.objOrderDetails.OrderID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/OrderDetails']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('OrderDetails record deleted successfully...', 'Delete OrderDetails');
                console.log('OrderDetails record deleted successfully...');
            });
        }
    };
    OrderDetailsEditComponent.prototype.gotoOrderDetails = function () {
        var Id = this.objOrderDetails ? this.objOrderDetails.OrderID : null;
        this.router.navigate(['/OrderDetails']);
    };
    // Get Lookup List for Products
    OrderDetailsEditComponent.prototype.getProducts = function () {
        var _this = this;
        this.ProductsService.getAll().subscribe(function (records) { return _this.ProductsList = records; });
    };
    // Get Lookup List for Orders
    OrderDetailsEditComponent.prototype.getOrders = function () {
        var _this = this;
        this.OrdersService.getAll().subscribe(function (records) { return _this.OrdersList = records; });
    };
    OrderDetailsEditComponent.prototype.getLookups = function () {
        this.getProducts();
        this.getOrders();
    };
    OrderDetailsEditComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], OrderDetailsEditComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], OrderDetailsEditComponent.prototype, "display", null);
    OrderDetailsEditComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1067),
            providers: [OrderDetails_service_1.OrderDetailsService,
                Products_service_1.ProductsService, Orders_service_1.OrdersService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof OrderDetails_service_1.OrderDetailsService !== 'undefined' && OrderDetails_service_1.OrderDetailsService) === 'function' && _d) || Object, (typeof (_e = typeof Products_service_1.ProductsService !== 'undefined' && Products_service_1.ProductsService) === 'function' && _e) || Object, (typeof (_f = typeof Orders_service_1.OrdersService !== 'undefined' && Orders_service_1.OrdersService) === 'function' && _f) || Object])
    ], OrderDetailsEditComponent);
    return OrderDetailsEditComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.OrderDetailsEditComponent = OrderDetailsEditComponent;


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderDetailsListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: OrderDetailsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var OrderDetails_service_1 = __webpack_require__(82);
var OrderDetailsSearch_component_1 = __webpack_require__(414);
var OrderDetailsListComponent = (function () {
    function OrderDetailsListComponent(OrderDetailsService, route, router, toastr) {
        this.OrderDetailsService = OrderDetailsService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "OrderID";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newOrderDetails = new OrderDetails_service_1.OrderDetailsData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(OrderDetailsListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderDetailsListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    OrderDetailsListComponent.prototype.ngOnInit = function () {
        //this.OrderDetailsService.getAll().subscribe(record => this.OrderDetailsList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getOrderDetailsByPaging();
        /*
        this.OrderDetailsList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    OrderDetailsListComponent.prototype.getOrderDetails = function () {
        var _this = this;
        this.OrderDetailsService.getAll()
            .subscribe(function (data) { return _this.OrderDetailsList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on OrderDetailsSearch Component
    OrderDetailsListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getOrderDetailsByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getOrderDetailsByPaging();
    };
    OrderDetailsListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getOrderDetailsByPaging();
    };
    // Get records by paging
    OrderDetailsListComponent.prototype.getOrderDetailsByPaging = function () {
        var _this = this;
        this.OrderDetailsService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.OrderDetailsList = data.OrderDetailsList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    OrderDetailsListComponent.prototype.addOrderDetails = function () {
        this.OrderDetailsService.addOrderDetailsData(this.newOrderDetails).subscribe(function (record) { return console.log(record); });
        this.getOrderDetails();
    };
    // Updates existing record
    OrderDetailsListComponent.prototype.updateOrderDetails = function () {
        this.OrderDetailsService.updateOrderDetailsData(this.selectedOrderDetails).subscribe(function (record) { return console.log(record); });
        this.getOrderDetails();
    };
    // Deletes record with specified id
    OrderDetailsListComponent.prototype.deleteOrderDetails = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this OrderDetails?') == true) {
            this.OrderDetailsService.deleteOrderDetails(id)
                .subscribe(function (data) { return _this.getOrderDetails(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('OrderDetails record deleted successfully...', 'Delete OrderDetails');
                console.log('OrderDetails record deleted successfully...');
            });
        }
    };
    // Go to First Page
    OrderDetailsListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getOrderDetailsByPaging();
    };
    // Go to Previous Page
    OrderDetailsListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getOrderDetailsByPaging();
        }
    };
    // Refresh - Go to First Page
    OrderDetailsListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // Go to Next Page
    OrderDetailsListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getOrderDetailsByPaging();
        }
    };
    // Go to Last Page
    OrderDetailsListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getOrderDetailsByPaging();
    };
    // On Edit - Go to Edit page
    OrderDetailsListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/OrderDetails', item.OrderID]);
    };
    // On Details - Go to Details page
    OrderDetailsListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/OrderDetails/Details', item.OrderID]);
    };
    // Set record as selected
    OrderDetailsListComponent.prototype.SelectOrderDetails = function (item) {
        this.selectedOrderDetails = item;
    };
    // Submits form
    OrderDetailsListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    OrderDetailsListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], OrderDetailsListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], OrderDetailsListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(OrderDetailsSearch_component_1.OrderDetailsSearchComponent), 
        __metadata('design:type', (typeof (_a = typeof OrderDetailsSearch_component_1.OrderDetailsSearchComponent !== 'undefined' && OrderDetailsSearch_component_1.OrderDetailsSearchComponent) === 'function' && _a) || Object)
    ], OrderDetailsListComponent.prototype, "filterComponent", void 0);
    OrderDetailsListComponent = __decorate([
        core_1.Component({
            selector: 'my-OrderDetails',
            template: __webpack_require__(1068),
            providers: [OrderDetails_service_1.OrderDetailsService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof OrderDetails_service_1.OrderDetailsService !== 'undefined' && OrderDetails_service_1.OrderDetailsService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], OrderDetailsListComponent);
    return OrderDetailsListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.OrderDetailsListComponent = OrderDetailsListComponent;


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderDetailsSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: OrderDetailsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var OrderDetails_service_1 = __webpack_require__(82);
var Products_service_1 = __webpack_require__(44);
var Orders_service_1 = __webpack_require__(43);
var OrderDetailsSearchComponent = (function () {
    function OrderDetailsSearchComponent(route, router, OrderDetailsService, ProductsService, OrdersService) {
        this.route = route;
        this.router = router;
        this.OrderDetailsService = OrderDetailsService;
        this.ProductsService = ProductsService;
        this.OrdersService = OrdersService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objOrderDetails = new OrderDetails_service_1.OrderDetailsData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(OrderDetailsSearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderDetailsSearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    OrderDetailsSearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    OrderDetailsSearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objOrderDetails = new OrderDetails_service_1.OrderDetailsData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    OrderDetailsSearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    OrderDetailsSearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objOrderDetails.OrderID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND OrderID = " + this.objOrderDetails.OrderID;
            else
                this.filterExpression = "OrderID = " + this.objOrderDetails.OrderID;
        }
        if (this.objOrderDetails.ProductID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ProductID = " + this.objOrderDetails.ProductID;
            else
                this.filterExpression = "ProductID = " + this.objOrderDetails.ProductID;
        }
        if (this.objOrderDetails.UnitPrice) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND UnitPrice = " + this.objOrderDetails.UnitPrice;
            else
                this.filterExpression = "UnitPrice = " + this.objOrderDetails.UnitPrice;
        }
        if (this.objOrderDetails.Quantity) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Quantity = " + this.objOrderDetails.Quantity;
            else
                this.filterExpression = "Quantity = " + this.objOrderDetails.Quantity;
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    // Get Lookup List for Products
    OrderDetailsSearchComponent.prototype.getProducts = function () {
        var _this = this;
        this.ProductsService.getAll().subscribe(function (records) { return _this.ProductsList = records; });
    };
    // Get Lookup List for Orders
    OrderDetailsSearchComponent.prototype.getOrders = function () {
        var _this = this;
        this.OrdersService.getAll().subscribe(function (records) { return _this.OrdersList = records; });
    };
    OrderDetailsSearchComponent.prototype.getLookups = function () {
        this.getProducts();
        this.getOrders();
    };
    OrderDetailsSearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], OrderDetailsSearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], OrderDetailsSearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], OrderDetailsSearchComponent.prototype, "display", null);
    OrderDetailsSearchComponent = __decorate([
        core_1.Component({
            selector: 'OrderDetailsSearch',
            template: __webpack_require__(1069),
            providers: [OrderDetails_service_1.OrderDetailsService,
                Products_service_1.ProductsService, Orders_service_1.OrdersService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof OrderDetails_service_1.OrderDetailsService !== 'undefined' && OrderDetails_service_1.OrderDetailsService) === 'function' && _c) || Object, (typeof (_d = typeof Products_service_1.ProductsService !== 'undefined' && Products_service_1.ProductsService) === 'function' && _d) || Object, (typeof (_e = typeof Orders_service_1.OrdersService !== 'undefined' && Orders_service_1.OrdersService) === 'function' && _e) || Object])
    ], OrderDetailsSearchComponent);
    return OrderDetailsSearchComponent;
    var _a, _b, _c, _d, _e;
}());
exports.OrderDetailsSearchComponent = OrderDetailsSearchComponent;


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderSubtotalsAddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: OrderSubtotalsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var OrderSubtotals_service_1 = __webpack_require__(146);
var OrderSubtotalsDetailsComponent = (function () {
    // Lookup Arrays
    function OrderSubtotalsDetailsComponent(route, router, toastr, OrderSubtotalsService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.OrderSubtotalsService = OrderSubtotalsService;
        // this.id = parseInt(params.get('id'));
        this.objOrderSubtotals = new OrderSubtotals_service_1.OrderSubtotalsData();
    }
    Object.defineProperty(OrderSubtotalsDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderSubtotalsDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    OrderSubtotalsDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.OrderSubtotalsService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objOrderSubtotals = item; });
        this.getLookups();
    };
    OrderSubtotalsDetailsComponent.prototype.deleteOrderSubtotals = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this OrderSubtotals?') == true) {
            this.OrderSubtotalsService.deleteOrderSubtotals(this.objOrderSubtotals.OrderID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/OrderSubtotals']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('OrderSubtotals record deleted successfully...'); });
        }
    };
    OrderSubtotalsDetailsComponent.prototype.gotoOrderSubtotalsEdit = function () {
        this.router.navigate(['/OrderSubtotals', this.objOrderSubtotals.OrderID]);
    };
    OrderSubtotalsDetailsComponent.prototype.gotoOrderSubtotals = function () {
        this.router.navigate(['/OrderSubtotals']);
    };
    OrderSubtotalsDetailsComponent.prototype.getLookups = function () {
    };
    OrderSubtotalsDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], OrderSubtotalsDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], OrderSubtotalsDetailsComponent.prototype, "display", null);
    OrderSubtotalsDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1070),
            providers: [OrderSubtotals_service_1.OrderSubtotalsService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof OrderSubtotals_service_1.OrderSubtotalsService !== 'undefined' && OrderSubtotals_service_1.OrderSubtotalsService) === 'function' && _d) || Object])
    ], OrderSubtotalsDetailsComponent);
    return OrderSubtotalsDetailsComponent;
    var _a, _b, _c, _d;
}());
exports.OrderSubtotalsDetailsComponent = OrderSubtotalsDetailsComponent;


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderSubtotalsListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: OrderSubtotalsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var OrderSubtotals_service_1 = __webpack_require__(146);
var OrderSubtotalsSearch_component_1 = __webpack_require__(417);
var OrderSubtotalsListComponent = (function () {
    function OrderSubtotalsListComponent(OrderSubtotalsService, route, router, toastr) {
        this.OrderSubtotalsService = OrderSubtotalsService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "OrderID";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newOrderSubtotals = new OrderSubtotals_service_1.OrderSubtotalsData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(OrderSubtotalsListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderSubtotalsListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    OrderSubtotalsListComponent.prototype.ngOnInit = function () {
        // this.OrderSubtotalsService.getAll().subscribe(record => this.OrderSubtotalsList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getOrderSubtotalsByPaging();
        /*
        this.OrderSubtotalsList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    OrderSubtotalsListComponent.prototype.getOrderSubtotals = function () {
        var _this = this;
        this.OrderSubtotalsService.getAll()
            .subscribe(function (data) { return _this.OrderSubtotalsList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on OrderSubtotalsSearch Component
    OrderSubtotalsListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getOrderSubtotalsByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getOrderSubtotalsByPaging();
    };
    OrderSubtotalsListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getOrderSubtotalsByPaging();
    };
    // Get records by paging
    OrderSubtotalsListComponent.prototype.getOrderSubtotalsByPaging = function () {
        var _this = this;
        this.OrderSubtotalsService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.OrderSubtotalsList = data.OrderSubtotalsList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    OrderSubtotalsListComponent.prototype.addOrderSubtotals = function () {
        this.OrderSubtotalsService.addOrderSubtotalsData(this.newOrderSubtotals).subscribe(function (record) { return console.log(record); });
        this.getOrderSubtotals();
    };
    // Updates existing record
    OrderSubtotalsListComponent.prototype.updateOrderSubtotals = function () {
        this.OrderSubtotalsService.updateOrderSubtotalsData(this.selectedOrderSubtotals).subscribe(function (record) { return console.log(record); });
        this.getOrderSubtotals();
    };
    // Deletes record with specified id
    OrderSubtotalsListComponent.prototype.deleteOrderSubtotals = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this OrderSubtotals?') == true) {
            this.OrderSubtotalsService.deleteOrderSubtotals(id)
                .subscribe(function (data) { return _this.getOrderSubtotals(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; });
        }
    };
    // Go to First Page
    OrderSubtotalsListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getOrderSubtotalsByPaging();
    };
    // Go to Previous Page
    OrderSubtotalsListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getOrderSubtotalsByPaging();
        }
    };
    // Go to Next Page
    OrderSubtotalsListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getOrderSubtotalsByPaging();
        }
    };
    // Go to Last Page
    OrderSubtotalsListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getOrderSubtotalsByPaging();
    };
    // Refresh - Go to First Page
    OrderSubtotalsListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // On Edit - Go to Edit page
    OrderSubtotalsListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/OrderSubtotals', item.OrderID]);
    };
    // On Details - Go to Details page
    OrderSubtotalsListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/OrderSubtotals/Details', item.OrderID]);
    };
    // Set record as selected
    OrderSubtotalsListComponent.prototype.SelectOrderSubtotals = function (item) {
        this.selectedOrderSubtotals = item;
    };
    // Submits form
    OrderSubtotalsListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    OrderSubtotalsListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], OrderSubtotalsListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], OrderSubtotalsListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(OrderSubtotalsSearch_component_1.OrderSubtotalsSearchComponent), 
        __metadata('design:type', (typeof (_a = typeof OrderSubtotalsSearch_component_1.OrderSubtotalsSearchComponent !== 'undefined' && OrderSubtotalsSearch_component_1.OrderSubtotalsSearchComponent) === 'function' && _a) || Object)
    ], OrderSubtotalsListComponent.prototype, "filterComponent", void 0);
    OrderSubtotalsListComponent = __decorate([
        core_1.Component({
            selector: 'my-OrderSubtotals',
            template: __webpack_require__(1071),
            providers: [OrderSubtotals_service_1.OrderSubtotalsService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof OrderSubtotals_service_1.OrderSubtotalsService !== 'undefined' && OrderSubtotals_service_1.OrderSubtotalsService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], OrderSubtotalsListComponent);
    return OrderSubtotalsListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.OrderSubtotalsListComponent = OrderSubtotalsListComponent;


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderSubtotalsSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: OrderSubtotalsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var OrderSubtotals_service_1 = __webpack_require__(146);
var OrderSubtotalsSearchComponent = (function () {
    // Lookup Arrays
    function OrderSubtotalsSearchComponent(route, router, OrderSubtotalsService) {
        this.route = route;
        this.router = router;
        this.OrderSubtotalsService = OrderSubtotalsService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objOrderSubtotals = new OrderSubtotals_service_1.OrderSubtotalsData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(OrderSubtotalsSearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderSubtotalsSearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    OrderSubtotalsSearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    OrderSubtotalsSearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objOrderSubtotals = new OrderSubtotals_service_1.OrderSubtotalsData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    OrderSubtotalsSearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    OrderSubtotalsSearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objOrderSubtotals.OrderID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND OrderID = " + this.objOrderSubtotals.OrderID;
            else
                this.filterExpression = "OrderID = " + this.objOrderSubtotals.OrderID;
        }
        if (this.objOrderSubtotals.Subtotal) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Subtotal = " + this.objOrderSubtotals.Subtotal;
            else
                this.filterExpression = "Subtotal = " + this.objOrderSubtotals.Subtotal;
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    OrderSubtotalsSearchComponent.prototype.getLookups = function () {
    };
    OrderSubtotalsSearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], OrderSubtotalsSearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], OrderSubtotalsSearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], OrderSubtotalsSearchComponent.prototype, "display", null);
    OrderSubtotalsSearchComponent = __decorate([
        core_1.Component({
            selector: 'OrderSubtotalsSearch',
            template: __webpack_require__(1072),
            providers: [OrderSubtotals_service_1.OrderSubtotalsService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof OrderSubtotals_service_1.OrderSubtotalsService !== 'undefined' && OrderSubtotals_service_1.OrderSubtotalsService) === 'function' && _c) || Object])
    ], OrderSubtotalsSearchComponent);
    return OrderSubtotalsSearchComponent;
    var _a, _b, _c;
}());
exports.OrderSubtotalsSearchComponent = OrderSubtotalsSearchComponent;


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrdersQryAddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: OrdersQryService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var OrdersQry_service_1 = __webpack_require__(147);
var OrdersQryDetailsComponent = (function () {
    // Lookup Arrays
    function OrdersQryDetailsComponent(route, router, toastr, OrdersQryService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.OrdersQryService = OrdersQryService;
        // this.id = parseInt(params.get('id'));
        this.objOrdersQry = new OrdersQry_service_1.OrdersQryData();
    }
    Object.defineProperty(OrdersQryDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrdersQryDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    OrdersQryDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.OrdersQryService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objOrdersQry = item; });
        this.getLookups();
    };
    OrdersQryDetailsComponent.prototype.deleteOrdersQry = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this OrdersQry?') == true) {
            this.OrdersQryService.deleteOrdersQry(this.objOrdersQry.OrderID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/OrdersQry']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('OrdersQry record deleted successfully...'); });
        }
    };
    OrdersQryDetailsComponent.prototype.gotoOrdersQryEdit = function () {
        this.router.navigate(['/OrdersQry', this.objOrdersQry.OrderID]);
    };
    OrdersQryDetailsComponent.prototype.gotoOrdersQry = function () {
        this.router.navigate(['/OrdersQry']);
    };
    OrdersQryDetailsComponent.prototype.getLookups = function () {
    };
    OrdersQryDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], OrdersQryDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], OrdersQryDetailsComponent.prototype, "display", null);
    OrdersQryDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1073),
            providers: [OrdersQry_service_1.OrdersQryService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof OrdersQry_service_1.OrdersQryService !== 'undefined' && OrdersQry_service_1.OrdersQryService) === 'function' && _d) || Object])
    ], OrdersQryDetailsComponent);
    return OrdersQryDetailsComponent;
    var _a, _b, _c, _d;
}());
exports.OrdersQryDetailsComponent = OrdersQryDetailsComponent;


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrdersQryListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: OrdersQryService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var OrdersQry_service_1 = __webpack_require__(147);
var OrdersQrySearch_component_1 = __webpack_require__(420);
var OrdersQryListComponent = (function () {
    function OrdersQryListComponent(OrdersQryService, route, router, toastr) {
        this.OrdersQryService = OrdersQryService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "OrderID";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newOrdersQry = new OrdersQry_service_1.OrdersQryData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(OrdersQryListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrdersQryListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    OrdersQryListComponent.prototype.ngOnInit = function () {
        // this.OrdersQryService.getAll().subscribe(record => this.OrdersQryList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getOrdersQryByPaging();
        /*
        this.OrdersQryList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    OrdersQryListComponent.prototype.getOrdersQry = function () {
        var _this = this;
        this.OrdersQryService.getAll()
            .subscribe(function (data) { return _this.OrdersQryList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on OrdersQrySearch Component
    OrdersQryListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getOrdersQryByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getOrdersQryByPaging();
    };
    OrdersQryListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getOrdersQryByPaging();
    };
    // Get records by paging
    OrdersQryListComponent.prototype.getOrdersQryByPaging = function () {
        var _this = this;
        this.OrdersQryService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.OrdersQryList = data.OrdersQryList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    OrdersQryListComponent.prototype.addOrdersQry = function () {
        this.OrdersQryService.addOrdersQryData(this.newOrdersQry).subscribe(function (record) { return console.log(record); });
        this.getOrdersQry();
    };
    // Updates existing record
    OrdersQryListComponent.prototype.updateOrdersQry = function () {
        this.OrdersQryService.updateOrdersQryData(this.selectedOrdersQry).subscribe(function (record) { return console.log(record); });
        this.getOrdersQry();
    };
    // Deletes record with specified id
    OrdersQryListComponent.prototype.deleteOrdersQry = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this OrdersQry?') == true) {
            this.OrdersQryService.deleteOrdersQry(id)
                .subscribe(function (data) { return _this.getOrdersQry(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; });
        }
    };
    // Go to First Page
    OrdersQryListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getOrdersQryByPaging();
    };
    // Go to Previous Page
    OrdersQryListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getOrdersQryByPaging();
        }
    };
    // Go to Next Page
    OrdersQryListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getOrdersQryByPaging();
        }
    };
    // Go to Last Page
    OrdersQryListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getOrdersQryByPaging();
    };
    // Refresh - Go to First Page
    OrdersQryListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // On Edit - Go to Edit page
    OrdersQryListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/OrdersQry', item.OrderID]);
    };
    // On Details - Go to Details page
    OrdersQryListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/OrdersQry/Details', item.OrderID]);
    };
    // Set record as selected
    OrdersQryListComponent.prototype.SelectOrdersQry = function (item) {
        this.selectedOrdersQry = item;
    };
    // Submits form
    OrdersQryListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    OrdersQryListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], OrdersQryListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], OrdersQryListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(OrdersQrySearch_component_1.OrdersQrySearchComponent), 
        __metadata('design:type', (typeof (_a = typeof OrdersQrySearch_component_1.OrdersQrySearchComponent !== 'undefined' && OrdersQrySearch_component_1.OrdersQrySearchComponent) === 'function' && _a) || Object)
    ], OrdersQryListComponent.prototype, "filterComponent", void 0);
    OrdersQryListComponent = __decorate([
        core_1.Component({
            selector: 'my-OrdersQry',
            template: __webpack_require__(1074),
            providers: [OrdersQry_service_1.OrdersQryService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof OrdersQry_service_1.OrdersQryService !== 'undefined' && OrdersQry_service_1.OrdersQryService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], OrdersQryListComponent);
    return OrdersQryListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.OrdersQryListComponent = OrdersQryListComponent;


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrdersQrySearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: OrdersQryService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var OrdersQry_service_1 = __webpack_require__(147);
var OrdersQrySearchComponent = (function () {
    // Lookup Arrays
    function OrdersQrySearchComponent(route, router, OrdersQryService) {
        this.route = route;
        this.router = router;
        this.OrdersQryService = OrdersQryService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objOrdersQry = new OrdersQry_service_1.OrdersQryData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(OrdersQrySearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrdersQrySearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    OrdersQrySearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    OrdersQrySearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objOrdersQry = new OrdersQry_service_1.OrdersQryData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    OrdersQrySearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    OrdersQrySearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objOrdersQry.OrderID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND OrderID = " + this.objOrdersQry.OrderID;
            else
                this.filterExpression = "OrderID = " + this.objOrdersQry.OrderID;
        }
        if (this.objOrdersQry.CustomerID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CustomerID like '%" + this.objOrdersQry.CustomerID + "%'";
            else
                this.filterExpression = "CustomerID like '%" + this.objOrdersQry.CustomerID + "%'";
        }
        if (this.objOrdersQry.EmployeeID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND EmployeeID = " + this.objOrdersQry.EmployeeID;
            else
                this.filterExpression = "EmployeeID = " + this.objOrdersQry.EmployeeID;
        }
        if (this.objOrdersQry.ShipVia) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ShipVia = " + this.objOrdersQry.ShipVia;
            else
                this.filterExpression = "ShipVia = " + this.objOrdersQry.ShipVia;
        }
        if (this.objOrdersQry.Freight) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Freight = " + this.objOrdersQry.Freight;
            else
                this.filterExpression = "Freight = " + this.objOrdersQry.Freight;
        }
        if (this.objOrdersQry.ShipName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ShipName like '%" + this.objOrdersQry.ShipName + "%'";
            else
                this.filterExpression = "ShipName like '%" + this.objOrdersQry.ShipName + "%'";
        }
        if (this.objOrdersQry.ShipAddress) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ShipAddress like '%" + this.objOrdersQry.ShipAddress + "%'";
            else
                this.filterExpression = "ShipAddress like '%" + this.objOrdersQry.ShipAddress + "%'";
        }
        if (this.objOrdersQry.ShipCity) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ShipCity like '%" + this.objOrdersQry.ShipCity + "%'";
            else
                this.filterExpression = "ShipCity like '%" + this.objOrdersQry.ShipCity + "%'";
        }
        if (this.objOrdersQry.ShipRegion) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ShipRegion like '%" + this.objOrdersQry.ShipRegion + "%'";
            else
                this.filterExpression = "ShipRegion like '%" + this.objOrdersQry.ShipRegion + "%'";
        }
        if (this.objOrdersQry.ShipPostalCode) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ShipPostalCode like '%" + this.objOrdersQry.ShipPostalCode + "%'";
            else
                this.filterExpression = "ShipPostalCode like '%" + this.objOrdersQry.ShipPostalCode + "%'";
        }
        if (this.objOrdersQry.ShipCountry) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ShipCountry like '%" + this.objOrdersQry.ShipCountry + "%'";
            else
                this.filterExpression = "ShipCountry like '%" + this.objOrdersQry.ShipCountry + "%'";
        }
        if (this.objOrdersQry.CompanyName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CompanyName like '%" + this.objOrdersQry.CompanyName + "%'";
            else
                this.filterExpression = "CompanyName like '%" + this.objOrdersQry.CompanyName + "%'";
        }
        if (this.objOrdersQry.Address) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Address like '%" + this.objOrdersQry.Address + "%'";
            else
                this.filterExpression = "Address like '%" + this.objOrdersQry.Address + "%'";
        }
        if (this.objOrdersQry.City) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND City like '%" + this.objOrdersQry.City + "%'";
            else
                this.filterExpression = "City like '%" + this.objOrdersQry.City + "%'";
        }
        if (this.objOrdersQry.Region) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Region like '%" + this.objOrdersQry.Region + "%'";
            else
                this.filterExpression = "Region like '%" + this.objOrdersQry.Region + "%'";
        }
        if (this.objOrdersQry.PostalCode) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND PostalCode like '%" + this.objOrdersQry.PostalCode + "%'";
            else
                this.filterExpression = "PostalCode like '%" + this.objOrdersQry.PostalCode + "%'";
        }
        if (this.objOrdersQry.Country) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Country like '%" + this.objOrdersQry.Country + "%'";
            else
                this.filterExpression = "Country like '%" + this.objOrdersQry.Country + "%'";
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    OrdersQrySearchComponent.prototype.getLookups = function () {
    };
    OrdersQrySearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], OrdersQrySearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], OrdersQrySearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], OrdersQrySearchComponent.prototype, "display", null);
    OrdersQrySearchComponent = __decorate([
        core_1.Component({
            selector: 'OrdersQrySearch',
            template: __webpack_require__(1075),
            providers: [OrdersQry_service_1.OrdersQryService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof OrdersQry_service_1.OrdersQryService !== 'undefined' && OrdersQry_service_1.OrdersQryService) === 'function' && _c) || Object])
    ], OrdersQrySearchComponent);
    return OrdersQrySearchComponent;
    var _a, _b, _c;
}());
exports.OrdersQrySearchComponent = OrdersQrySearchComponent;


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrdersAddComponent
 * Purpose		: This component allows to create new Orders record and save changes.
 * Dependency	: OrdersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Orders_service_1 = __webpack_require__(43);
var Shippers_service_1 = __webpack_require__(46);
var Employees_service_1 = __webpack_require__(28);
var OrdersAddComponent = (function () {
    function OrdersAddComponent(route, router, toastr, OrdersService, ShippersService, EmployeesService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.OrdersService = OrdersService;
        this.ShippersService = ShippersService;
        this.EmployeesService = EmployeesService;
        this.objOrders = new Orders_service_1.OrdersData();
    }
    Object.defineProperty(OrdersAddComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrdersAddComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    OrdersAddComponent.prototype.ngOnInit = function () {
        this.objOrders = new Orders_service_1.OrdersData();
        this.getLookups();
    };
    OrdersAddComponent.prototype.addOrders = function () {
        var _this = this;
        this.OrdersService.addOrdersData(this.objOrders)
            .subscribe(function (record) { return _this.router.navigate(['/Orders']); }, function (error) { return _this.errorMessage = 'There was an error while adding record. Error: ' + error; }, function () {
            _this.toastr.success('Orders record added successfully...', 'Add Orders');
            console.log('Orders record added successfully...');
        });
    };
    OrdersAddComponent.prototype.gotoOrders = function () {
        // let Id = this.objOrders ? this.objOrders.OrderID : null;
        this.router.navigate(['/Orders']);
    };
    // Get Lookup List for Shippers
    OrdersAddComponent.prototype.getShippers = function () {
        var _this = this;
        this.ShippersService.getAll().subscribe(function (records) { return _this.ShippersList = records; });
    };
    // Get Lookup List for Employees
    OrdersAddComponent.prototype.getEmployees = function () {
        var _this = this;
        this.EmployeesService.getAll().subscribe(function (records) { return _this.EmployeesList = records; });
    };
    OrdersAddComponent.prototype.getLookups = function () {
        this.getShippers();
        this.getEmployees();
    };
    OrdersAddComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], OrdersAddComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], OrdersAddComponent.prototype, "display", null);
    OrdersAddComponent = __decorate([
        core_1.Component({
            selector: 'my-Orders-add',
            template: __webpack_require__(1076),
            providers: [Orders_service_1.OrdersService,
                Shippers_service_1.ShippersService, Employees_service_1.EmployeesService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Orders_service_1.OrdersService !== 'undefined' && Orders_service_1.OrdersService) === 'function' && _d) || Object, (typeof (_e = typeof Shippers_service_1.ShippersService !== 'undefined' && Shippers_service_1.ShippersService) === 'function' && _e) || Object, (typeof (_f = typeof Employees_service_1.EmployeesService !== 'undefined' && Employees_service_1.EmployeesService) === 'function' && _f) || Object])
    ], OrdersAddComponent);
    return OrdersAddComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.OrdersAddComponent = OrdersAddComponent;


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Orders_service_1 = __webpack_require__(43);
var Shippers_service_1 = __webpack_require__(46);
var Employees_service_1 = __webpack_require__(28);
var OrdersDetailsComponent = (function () {
    function OrdersDetailsComponent(route, router, toastr, OrdersService, ShippersService, EmployeesService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.OrdersService = OrdersService;
        this.ShippersService = ShippersService;
        this.EmployeesService = EmployeesService;
        // this.id = parseInt(params.get('id'));
        this.objOrders = new Orders_service_1.OrdersData();
    }
    Object.defineProperty(OrdersDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrdersDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    OrdersDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.OrdersService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objOrders = item; });
        this.getLookups();
    };
    OrdersDetailsComponent.prototype.deleteOrders = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Orders?') == true) {
            this.OrdersService.deleteOrders(this.objOrders.OrderID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/Orders']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('Orders record deleted successfully...'); });
        }
    };
    OrdersDetailsComponent.prototype.gotoOrdersEdit = function () {
        this.router.navigate(['/Orders', this.objOrders.OrderID]);
    };
    OrdersDetailsComponent.prototype.gotoOrders = function () {
        this.router.navigate(['/Orders']);
    };
    // Get Lookup List for Shippers
    OrdersDetailsComponent.prototype.getShippers = function () {
        var _this = this;
        this.ShippersService.getAll().subscribe(function (records) { return _this.ShippersList = records; });
    };
    // Get Lookup List for Employees
    OrdersDetailsComponent.prototype.getEmployees = function () {
        var _this = this;
        this.EmployeesService.getAll().subscribe(function (records) { return _this.EmployeesList = records; });
    };
    OrdersDetailsComponent.prototype.getLookups = function () {
        this.getShippers();
        this.getEmployees();
    };
    OrdersDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], OrdersDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], OrdersDetailsComponent.prototype, "display", null);
    OrdersDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1077),
            providers: [Orders_service_1.OrdersService,
                Shippers_service_1.ShippersService, Employees_service_1.EmployeesService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Orders_service_1.OrdersService !== 'undefined' && Orders_service_1.OrdersService) === 'function' && _d) || Object, (typeof (_e = typeof Shippers_service_1.ShippersService !== 'undefined' && Shippers_service_1.ShippersService) === 'function' && _e) || Object, (typeof (_f = typeof Employees_service_1.EmployeesService !== 'undefined' && Employees_service_1.EmployeesService) === 'function' && _f) || Object])
    ], OrdersDetailsComponent);
    return OrdersDetailsComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.OrdersDetailsComponent = OrdersDetailsComponent;


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrdersEditComponent
 * Purpose		: This component retrieves data for the specified record id and allows to edit and save changes.
 * Dependency	: OrdersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Orders_service_1 = __webpack_require__(43);
var Shippers_service_1 = __webpack_require__(46);
var Employees_service_1 = __webpack_require__(28);
var OrdersEditComponent = (function () {
    function OrdersEditComponent(route, router, toastr, OrdersService, ShippersService, EmployeesService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.OrdersService = OrdersService;
        this.ShippersService = ShippersService;
        this.EmployeesService = EmployeesService;
        // this.id = parseInt(params.get('id'));
        this.objOrders = new Orders_service_1.OrdersData();
    }
    Object.defineProperty(OrdersEditComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrdersEditComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    OrdersEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.OrdersService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objOrders = item; });
        this.getLookups();
    };
    OrdersEditComponent.prototype.updateOrders = function () {
        var _this = this;
        this.OrdersService.updateOrdersData(this.objOrders)
            .subscribe(function (record) { return _this.router.navigate(['/Orders']); }, function (error) { return _this.errorMessage = 'There was an error while updating record. Error: ' + error; }, function () {
            _this.toastr.success('Orders record updated successfully...', 'Edit Orders');
            console.log('Orders record updated successfully...');
        });
    };
    OrdersEditComponent.prototype.deleteOrders = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Orders?') == true) {
            this.OrdersService.deleteOrders(this.objOrders.OrderID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/Orders']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('Orders record deleted successfully...', 'Delete Orders');
                console.log('Orders record deleted successfully...');
            });
        }
    };
    OrdersEditComponent.prototype.gotoOrders = function () {
        var Id = this.objOrders ? this.objOrders.OrderID : null;
        this.router.navigate(['/Orders']);
    };
    // Get Lookup List for Shippers
    OrdersEditComponent.prototype.getShippers = function () {
        var _this = this;
        this.ShippersService.getAll().subscribe(function (records) { return _this.ShippersList = records; });
    };
    // Get Lookup List for Employees
    OrdersEditComponent.prototype.getEmployees = function () {
        var _this = this;
        this.EmployeesService.getAll().subscribe(function (records) { return _this.EmployeesList = records; });
    };
    OrdersEditComponent.prototype.getLookups = function () {
        this.getShippers();
        this.getEmployees();
    };
    OrdersEditComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], OrdersEditComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], OrdersEditComponent.prototype, "display", null);
    OrdersEditComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1078),
            providers: [Orders_service_1.OrdersService,
                Shippers_service_1.ShippersService, Employees_service_1.EmployeesService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Orders_service_1.OrdersService !== 'undefined' && Orders_service_1.OrdersService) === 'function' && _d) || Object, (typeof (_e = typeof Shippers_service_1.ShippersService !== 'undefined' && Shippers_service_1.ShippersService) === 'function' && _e) || Object, (typeof (_f = typeof Employees_service_1.EmployeesService !== 'undefined' && Employees_service_1.EmployeesService) === 'function' && _f) || Object])
    ], OrdersEditComponent);
    return OrdersEditComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.OrdersEditComponent = OrdersEditComponent;


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrdersListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: OrdersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var Orders_service_1 = __webpack_require__(43);
var OrdersSearch_component_1 = __webpack_require__(425);
var OrdersListComponent = (function () {
    function OrdersListComponent(OrdersService, route, router, toastr) {
        this.OrdersService = OrdersService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "OrderID";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newOrders = new Orders_service_1.OrdersData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(OrdersListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrdersListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    OrdersListComponent.prototype.ngOnInit = function () {
        //this.OrdersService.getAll().subscribe(record => this.OrdersList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getOrdersByPaging();
        /*
        this.OrdersList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    OrdersListComponent.prototype.getOrders = function () {
        var _this = this;
        this.OrdersService.getAll()
            .subscribe(function (data) { return _this.OrdersList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on OrdersSearch Component
    OrdersListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getOrdersByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getOrdersByPaging();
    };
    OrdersListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getOrdersByPaging();
    };
    // Get records by paging
    OrdersListComponent.prototype.getOrdersByPaging = function () {
        var _this = this;
        this.OrdersService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.OrdersList = data.OrdersList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    OrdersListComponent.prototype.addOrders = function () {
        this.OrdersService.addOrdersData(this.newOrders).subscribe(function (record) { return console.log(record); });
        this.getOrders();
    };
    // Updates existing record
    OrdersListComponent.prototype.updateOrders = function () {
        this.OrdersService.updateOrdersData(this.selectedOrders).subscribe(function (record) { return console.log(record); });
        this.getOrders();
    };
    // Deletes record with specified id
    OrdersListComponent.prototype.deleteOrders = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Orders?') == true) {
            this.OrdersService.deleteOrders(id)
                .subscribe(function (data) { return _this.getOrders(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('Orders record deleted successfully...', 'Delete Orders');
                console.log('Orders record deleted successfully...');
            });
        }
    };
    // Go to First Page
    OrdersListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getOrdersByPaging();
    };
    // Go to Previous Page
    OrdersListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getOrdersByPaging();
        }
    };
    // Refresh - Go to First Page
    OrdersListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // Go to Next Page
    OrdersListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getOrdersByPaging();
        }
    };
    // Go to Last Page
    OrdersListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getOrdersByPaging();
    };
    // On Edit - Go to Edit page
    OrdersListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/Orders', item.OrderID]);
    };
    // On Details - Go to Details page
    OrdersListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/Orders/Details', item.OrderID]);
    };
    // Set record as selected
    OrdersListComponent.prototype.SelectOrders = function (item) {
        this.selectedOrders = item;
    };
    // Submits form
    OrdersListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    OrdersListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], OrdersListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], OrdersListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(OrdersSearch_component_1.OrdersSearchComponent), 
        __metadata('design:type', (typeof (_a = typeof OrdersSearch_component_1.OrdersSearchComponent !== 'undefined' && OrdersSearch_component_1.OrdersSearchComponent) === 'function' && _a) || Object)
    ], OrdersListComponent.prototype, "filterComponent", void 0);
    OrdersListComponent = __decorate([
        core_1.Component({
            selector: 'my-Orders',
            template: __webpack_require__(1079),
            providers: [Orders_service_1.OrdersService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof Orders_service_1.OrdersService !== 'undefined' && Orders_service_1.OrdersService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], OrdersListComponent);
    return OrdersListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.OrdersListComponent = OrdersListComponent;


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrdersSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: OrdersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var Orders_service_1 = __webpack_require__(43);
var Shippers_service_1 = __webpack_require__(46);
var Employees_service_1 = __webpack_require__(28);
var OrdersSearchComponent = (function () {
    function OrdersSearchComponent(route, router, OrdersService, ShippersService, EmployeesService) {
        this.route = route;
        this.router = router;
        this.OrdersService = OrdersService;
        this.ShippersService = ShippersService;
        this.EmployeesService = EmployeesService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objOrders = new Orders_service_1.OrdersData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(OrdersSearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrdersSearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    OrdersSearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    OrdersSearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objOrders = new Orders_service_1.OrdersData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    OrdersSearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    OrdersSearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objOrders.OrderID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND OrderID = " + this.objOrders.OrderID;
            else
                this.filterExpression = "OrderID = " + this.objOrders.OrderID;
        }
        if (this.objOrders.CustomerID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CustomerID like '%" + this.objOrders.CustomerID + "%'";
            else
                this.filterExpression = "CustomerID like '%" + this.objOrders.CustomerID + "%'";
        }
        if (this.objOrders.EmployeeID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND EmployeeID = " + this.objOrders.EmployeeID;
            else
                this.filterExpression = "EmployeeID = " + this.objOrders.EmployeeID;
        }
        if (this.objOrders.ShipVia) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ShipVia = " + this.objOrders.ShipVia;
            else
                this.filterExpression = "ShipVia = " + this.objOrders.ShipVia;
        }
        if (this.objOrders.Freight) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Freight = " + this.objOrders.Freight;
            else
                this.filterExpression = "Freight = " + this.objOrders.Freight;
        }
        if (this.objOrders.ShipName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ShipName like '%" + this.objOrders.ShipName + "%'";
            else
                this.filterExpression = "ShipName like '%" + this.objOrders.ShipName + "%'";
        }
        if (this.objOrders.ShipAddress) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ShipAddress like '%" + this.objOrders.ShipAddress + "%'";
            else
                this.filterExpression = "ShipAddress like '%" + this.objOrders.ShipAddress + "%'";
        }
        if (this.objOrders.ShipCity) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ShipCity like '%" + this.objOrders.ShipCity + "%'";
            else
                this.filterExpression = "ShipCity like '%" + this.objOrders.ShipCity + "%'";
        }
        if (this.objOrders.ShipRegion) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ShipRegion like '%" + this.objOrders.ShipRegion + "%'";
            else
                this.filterExpression = "ShipRegion like '%" + this.objOrders.ShipRegion + "%'";
        }
        if (this.objOrders.ShipPostalCode) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ShipPostalCode like '%" + this.objOrders.ShipPostalCode + "%'";
            else
                this.filterExpression = "ShipPostalCode like '%" + this.objOrders.ShipPostalCode + "%'";
        }
        if (this.objOrders.ShipCountry) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ShipCountry like '%" + this.objOrders.ShipCountry + "%'";
            else
                this.filterExpression = "ShipCountry like '%" + this.objOrders.ShipCountry + "%'";
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    // Get Lookup List for Shippers
    OrdersSearchComponent.prototype.getShippers = function () {
        var _this = this;
        this.ShippersService.getAll().subscribe(function (records) { return _this.ShippersList = records; });
    };
    // Get Lookup List for Employees
    OrdersSearchComponent.prototype.getEmployees = function () {
        var _this = this;
        this.EmployeesService.getAll().subscribe(function (records) { return _this.EmployeesList = records; });
    };
    OrdersSearchComponent.prototype.getLookups = function () {
        this.getShippers();
        this.getEmployees();
    };
    OrdersSearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], OrdersSearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], OrdersSearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], OrdersSearchComponent.prototype, "display", null);
    OrdersSearchComponent = __decorate([
        core_1.Component({
            selector: 'OrdersSearch',
            template: __webpack_require__(1080),
            providers: [Orders_service_1.OrdersService,
                Shippers_service_1.ShippersService, Employees_service_1.EmployeesService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof Orders_service_1.OrdersService !== 'undefined' && Orders_service_1.OrdersService) === 'function' && _c) || Object, (typeof (_d = typeof Shippers_service_1.ShippersService !== 'undefined' && Shippers_service_1.ShippersService) === 'function' && _d) || Object, (typeof (_e = typeof Employees_service_1.EmployeesService !== 'undefined' && Employees_service_1.EmployeesService) === 'function' && _e) || Object])
    ], OrdersSearchComponent);
    return OrdersSearchComponent;
    var _a, _b, _c, _d, _e;
}());
exports.OrdersSearchComponent = OrdersSearchComponent;


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductSalesfor1997AddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: ProductSalesfor1997Service
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var ProductSalesfor1997_service_1 = __webpack_require__(148);
var ProductSalesfor1997DetailsComponent = (function () {
    // Lookup Arrays
    function ProductSalesfor1997DetailsComponent(route, router, toastr, ProductSalesfor1997Service) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.ProductSalesfor1997Service = ProductSalesfor1997Service;
        // this.id = parseInt(params.get('id'));
        this.objProductSalesfor1997 = new ProductSalesfor1997_service_1.ProductSalesfor1997Data();
    }
    Object.defineProperty(ProductSalesfor1997DetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductSalesfor1997DetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    ProductSalesfor1997DetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.ProductSalesfor1997Service.getByID(params['id']); })
            .subscribe(function (item) { return _this.objProductSalesfor1997 = item; });
        this.getLookups();
    };
    ProductSalesfor1997DetailsComponent.prototype.deleteProductSalesfor1997 = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this ProductSalesfor1997?') == true) {
            this.ProductSalesfor1997Service.deleteProductSalesfor1997(this.objProductSalesfor1997.CategoryName.toString())
                .subscribe(function (record) { return _this.router.navigate(['/ProductSalesfor1997']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('ProductSalesfor1997 record deleted successfully...'); });
        }
    };
    ProductSalesfor1997DetailsComponent.prototype.gotoProductSalesfor1997Edit = function () {
        this.router.navigate(['/ProductSalesfor1997', this.objProductSalesfor1997.CategoryName]);
    };
    ProductSalesfor1997DetailsComponent.prototype.gotoProductSalesfor1997 = function () {
        this.router.navigate(['/ProductSalesfor1997']);
    };
    ProductSalesfor1997DetailsComponent.prototype.getLookups = function () {
    };
    ProductSalesfor1997DetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], ProductSalesfor1997DetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], ProductSalesfor1997DetailsComponent.prototype, "display", null);
    ProductSalesfor1997DetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1081),
            providers: [ProductSalesfor1997_service_1.ProductSalesfor1997Service
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof ProductSalesfor1997_service_1.ProductSalesfor1997Service !== 'undefined' && ProductSalesfor1997_service_1.ProductSalesfor1997Service) === 'function' && _d) || Object])
    ], ProductSalesfor1997DetailsComponent);
    return ProductSalesfor1997DetailsComponent;
    var _a, _b, _c, _d;
}());
exports.ProductSalesfor1997DetailsComponent = ProductSalesfor1997DetailsComponent;


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductSalesfor1997ListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: ProductSalesfor1997Service
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var ProductSalesfor1997_service_1 = __webpack_require__(148);
var ProductSalesfor1997Search_component_1 = __webpack_require__(428);
var ProductSalesfor1997ListComponent = (function () {
    function ProductSalesfor1997ListComponent(ProductSalesfor1997Service, route, router, toastr) {
        this.ProductSalesfor1997Service = ProductSalesfor1997Service;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "CategoryName";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newProductSalesfor1997 = new ProductSalesfor1997_service_1.ProductSalesfor1997Data();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(ProductSalesfor1997ListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductSalesfor1997ListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    ProductSalesfor1997ListComponent.prototype.ngOnInit = function () {
        // this.ProductSalesfor1997Service.getAll().subscribe(record => this.ProductSalesfor1997List=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getProductSalesfor1997ByPaging();
        /*
        this.ProductSalesfor1997List = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    ProductSalesfor1997ListComponent.prototype.getProductSalesfor1997 = function () {
        var _this = this;
        this.ProductSalesfor1997Service.getAll()
            .subscribe(function (data) { return _this.ProductSalesfor1997List = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on ProductSalesfor1997Search Component
    ProductSalesfor1997ListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getProductSalesfor1997ByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getProductSalesfor1997ByPaging();
    };
    ProductSalesfor1997ListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getProductSalesfor1997ByPaging();
    };
    // Get records by paging
    ProductSalesfor1997ListComponent.prototype.getProductSalesfor1997ByPaging = function () {
        var _this = this;
        this.ProductSalesfor1997Service.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.ProductSalesfor1997List = data.ProductSalesfor1997List;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    ProductSalesfor1997ListComponent.prototype.addProductSalesfor1997 = function () {
        this.ProductSalesfor1997Service.addProductSalesfor1997Data(this.newProductSalesfor1997).subscribe(function (record) { return console.log(record); });
        this.getProductSalesfor1997();
    };
    // Updates existing record
    ProductSalesfor1997ListComponent.prototype.updateProductSalesfor1997 = function () {
        this.ProductSalesfor1997Service.updateProductSalesfor1997Data(this.selectedProductSalesfor1997).subscribe(function (record) { return console.log(record); });
        this.getProductSalesfor1997();
    };
    // Deletes record with specified id
    ProductSalesfor1997ListComponent.prototype.deleteProductSalesfor1997 = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this ProductSalesfor1997?') == true) {
            this.ProductSalesfor1997Service.deleteProductSalesfor1997(id)
                .subscribe(function (data) { return _this.getProductSalesfor1997(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; });
        }
    };
    // Go to First Page
    ProductSalesfor1997ListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getProductSalesfor1997ByPaging();
    };
    // Go to Previous Page
    ProductSalesfor1997ListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getProductSalesfor1997ByPaging();
        }
    };
    // Go to Next Page
    ProductSalesfor1997ListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getProductSalesfor1997ByPaging();
        }
    };
    // Go to Last Page
    ProductSalesfor1997ListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getProductSalesfor1997ByPaging();
    };
    // Refresh - Go to First Page
    ProductSalesfor1997ListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // On Edit - Go to Edit page
    ProductSalesfor1997ListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/ProductSalesfor1997', item.CategoryName]);
    };
    // On Details - Go to Details page
    ProductSalesfor1997ListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/ProductSalesfor1997/Details', item.CategoryName]);
    };
    // Set record as selected
    ProductSalesfor1997ListComponent.prototype.SelectProductSalesfor1997 = function (item) {
        this.selectedProductSalesfor1997 = item;
    };
    // Submits form
    ProductSalesfor1997ListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    ProductSalesfor1997ListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], ProductSalesfor1997ListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], ProductSalesfor1997ListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(ProductSalesfor1997Search_component_1.ProductSalesfor1997SearchComponent), 
        __metadata('design:type', (typeof (_a = typeof ProductSalesfor1997Search_component_1.ProductSalesfor1997SearchComponent !== 'undefined' && ProductSalesfor1997Search_component_1.ProductSalesfor1997SearchComponent) === 'function' && _a) || Object)
    ], ProductSalesfor1997ListComponent.prototype, "filterComponent", void 0);
    ProductSalesfor1997ListComponent = __decorate([
        core_1.Component({
            selector: 'my-ProductSalesfor1997',
            template: __webpack_require__(1082),
            providers: [ProductSalesfor1997_service_1.ProductSalesfor1997Service],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof ProductSalesfor1997_service_1.ProductSalesfor1997Service !== 'undefined' && ProductSalesfor1997_service_1.ProductSalesfor1997Service) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], ProductSalesfor1997ListComponent);
    return ProductSalesfor1997ListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.ProductSalesfor1997ListComponent = ProductSalesfor1997ListComponent;


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductSalesfor1997SearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: ProductSalesfor1997Service
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ProductSalesfor1997_service_1 = __webpack_require__(148);
var ProductSalesfor1997SearchComponent = (function () {
    // Lookup Arrays
    function ProductSalesfor1997SearchComponent(route, router, ProductSalesfor1997Service) {
        this.route = route;
        this.router = router;
        this.ProductSalesfor1997Service = ProductSalesfor1997Service;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objProductSalesfor1997 = new ProductSalesfor1997_service_1.ProductSalesfor1997Data();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(ProductSalesfor1997SearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductSalesfor1997SearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    ProductSalesfor1997SearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    ProductSalesfor1997SearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objProductSalesfor1997 = new ProductSalesfor1997_service_1.ProductSalesfor1997Data();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    ProductSalesfor1997SearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    ProductSalesfor1997SearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objProductSalesfor1997.CategoryName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryName like '%" + this.objProductSalesfor1997.CategoryName + "%'";
            else
                this.filterExpression = "CategoryName like '%" + this.objProductSalesfor1997.CategoryName + "%'";
        }
        if (this.objProductSalesfor1997.ProductName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ProductName like '%" + this.objProductSalesfor1997.ProductName + "%'";
            else
                this.filterExpression = "ProductName like '%" + this.objProductSalesfor1997.ProductName + "%'";
        }
        if (this.objProductSalesfor1997.ProductSales) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ProductSales = " + this.objProductSalesfor1997.ProductSales;
            else
                this.filterExpression = "ProductSales = " + this.objProductSalesfor1997.ProductSales;
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    ProductSalesfor1997SearchComponent.prototype.getLookups = function () {
    };
    ProductSalesfor1997SearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], ProductSalesfor1997SearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], ProductSalesfor1997SearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], ProductSalesfor1997SearchComponent.prototype, "display", null);
    ProductSalesfor1997SearchComponent = __decorate([
        core_1.Component({
            selector: 'ProductSalesfor1997Search',
            template: __webpack_require__(1083),
            providers: [ProductSalesfor1997_service_1.ProductSalesfor1997Service
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ProductSalesfor1997_service_1.ProductSalesfor1997Service !== 'undefined' && ProductSalesfor1997_service_1.ProductSalesfor1997Service) === 'function' && _c) || Object])
    ], ProductSalesfor1997SearchComponent);
    return ProductSalesfor1997SearchComponent;
    var _a, _b, _c;
}());
exports.ProductSalesfor1997SearchComponent = ProductSalesfor1997SearchComponent;


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsAboveAveragePriceAddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: ProductsAboveAveragePriceService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var ProductsAboveAveragePrice_service_1 = __webpack_require__(149);
var ProductsAboveAveragePriceDetailsComponent = (function () {
    // Lookup Arrays
    function ProductsAboveAveragePriceDetailsComponent(route, router, toastr, ProductsAboveAveragePriceService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.ProductsAboveAveragePriceService = ProductsAboveAveragePriceService;
        // this.id = parseInt(params.get('id'));
        this.objProductsAboveAveragePrice = new ProductsAboveAveragePrice_service_1.ProductsAboveAveragePriceData();
    }
    Object.defineProperty(ProductsAboveAveragePriceDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductsAboveAveragePriceDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    ProductsAboveAveragePriceDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.ProductsAboveAveragePriceService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objProductsAboveAveragePrice = item; });
        this.getLookups();
    };
    ProductsAboveAveragePriceDetailsComponent.prototype.deleteProductsAboveAveragePrice = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this ProductsAboveAveragePrice?') == true) {
            this.ProductsAboveAveragePriceService.deleteProductsAboveAveragePrice(this.objProductsAboveAveragePrice.ProductName.toString())
                .subscribe(function (record) { return _this.router.navigate(['/ProductsAboveAveragePrice']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('ProductsAboveAveragePrice record deleted successfully...'); });
        }
    };
    ProductsAboveAveragePriceDetailsComponent.prototype.gotoProductsAboveAveragePriceEdit = function () {
        this.router.navigate(['/ProductsAboveAveragePrice', this.objProductsAboveAveragePrice.ProductName]);
    };
    ProductsAboveAveragePriceDetailsComponent.prototype.gotoProductsAboveAveragePrice = function () {
        this.router.navigate(['/ProductsAboveAveragePrice']);
    };
    ProductsAboveAveragePriceDetailsComponent.prototype.getLookups = function () {
    };
    ProductsAboveAveragePriceDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], ProductsAboveAveragePriceDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], ProductsAboveAveragePriceDetailsComponent.prototype, "display", null);
    ProductsAboveAveragePriceDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1084),
            providers: [ProductsAboveAveragePrice_service_1.ProductsAboveAveragePriceService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof ProductsAboveAveragePrice_service_1.ProductsAboveAveragePriceService !== 'undefined' && ProductsAboveAveragePrice_service_1.ProductsAboveAveragePriceService) === 'function' && _d) || Object])
    ], ProductsAboveAveragePriceDetailsComponent);
    return ProductsAboveAveragePriceDetailsComponent;
    var _a, _b, _c, _d;
}());
exports.ProductsAboveAveragePriceDetailsComponent = ProductsAboveAveragePriceDetailsComponent;


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsAboveAveragePriceListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: ProductsAboveAveragePriceService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var ProductsAboveAveragePrice_service_1 = __webpack_require__(149);
var ProductsAboveAveragePriceSearch_component_1 = __webpack_require__(431);
var ProductsAboveAveragePriceListComponent = (function () {
    function ProductsAboveAveragePriceListComponent(ProductsAboveAveragePriceService, route, router, toastr) {
        this.ProductsAboveAveragePriceService = ProductsAboveAveragePriceService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "ProductName";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newProductsAboveAveragePrice = new ProductsAboveAveragePrice_service_1.ProductsAboveAveragePriceData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(ProductsAboveAveragePriceListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductsAboveAveragePriceListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    ProductsAboveAveragePriceListComponent.prototype.ngOnInit = function () {
        // this.ProductsAboveAveragePriceService.getAll().subscribe(record => this.ProductsAboveAveragePriceList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getProductsAboveAveragePriceByPaging();
        /*
        this.ProductsAboveAveragePriceList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    ProductsAboveAveragePriceListComponent.prototype.getProductsAboveAveragePrice = function () {
        var _this = this;
        this.ProductsAboveAveragePriceService.getAll()
            .subscribe(function (data) { return _this.ProductsAboveAveragePriceList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on ProductsAboveAveragePriceSearch Component
    ProductsAboveAveragePriceListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getProductsAboveAveragePriceByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getProductsAboveAveragePriceByPaging();
    };
    ProductsAboveAveragePriceListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getProductsAboveAveragePriceByPaging();
    };
    // Get records by paging
    ProductsAboveAveragePriceListComponent.prototype.getProductsAboveAveragePriceByPaging = function () {
        var _this = this;
        this.ProductsAboveAveragePriceService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.ProductsAboveAveragePriceList = data.ProductsAboveAveragePriceList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    ProductsAboveAveragePriceListComponent.prototype.addProductsAboveAveragePrice = function () {
        this.ProductsAboveAveragePriceService.addProductsAboveAveragePriceData(this.newProductsAboveAveragePrice).subscribe(function (record) { return console.log(record); });
        this.getProductsAboveAveragePrice();
    };
    // Updates existing record
    ProductsAboveAveragePriceListComponent.prototype.updateProductsAboveAveragePrice = function () {
        this.ProductsAboveAveragePriceService.updateProductsAboveAveragePriceData(this.selectedProductsAboveAveragePrice).subscribe(function (record) { return console.log(record); });
        this.getProductsAboveAveragePrice();
    };
    // Deletes record with specified id
    ProductsAboveAveragePriceListComponent.prototype.deleteProductsAboveAveragePrice = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this ProductsAboveAveragePrice?') == true) {
            this.ProductsAboveAveragePriceService.deleteProductsAboveAveragePrice(id)
                .subscribe(function (data) { return _this.getProductsAboveAveragePrice(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; });
        }
    };
    // Go to First Page
    ProductsAboveAveragePriceListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getProductsAboveAveragePriceByPaging();
    };
    // Go to Previous Page
    ProductsAboveAveragePriceListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getProductsAboveAveragePriceByPaging();
        }
    };
    // Go to Next Page
    ProductsAboveAveragePriceListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getProductsAboveAveragePriceByPaging();
        }
    };
    // Go to Last Page
    ProductsAboveAveragePriceListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getProductsAboveAveragePriceByPaging();
    };
    // Refresh - Go to First Page
    ProductsAboveAveragePriceListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // On Edit - Go to Edit page
    ProductsAboveAveragePriceListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/ProductsAboveAveragePrice', item.ProductName]);
    };
    // On Details - Go to Details page
    ProductsAboveAveragePriceListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/ProductsAboveAveragePrice/Details', item.ProductName]);
    };
    // Set record as selected
    ProductsAboveAveragePriceListComponent.prototype.SelectProductsAboveAveragePrice = function (item) {
        this.selectedProductsAboveAveragePrice = item;
    };
    // Submits form
    ProductsAboveAveragePriceListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    ProductsAboveAveragePriceListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], ProductsAboveAveragePriceListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], ProductsAboveAveragePriceListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(ProductsAboveAveragePriceSearch_component_1.ProductsAboveAveragePriceSearchComponent), 
        __metadata('design:type', (typeof (_a = typeof ProductsAboveAveragePriceSearch_component_1.ProductsAboveAveragePriceSearchComponent !== 'undefined' && ProductsAboveAveragePriceSearch_component_1.ProductsAboveAveragePriceSearchComponent) === 'function' && _a) || Object)
    ], ProductsAboveAveragePriceListComponent.prototype, "filterComponent", void 0);
    ProductsAboveAveragePriceListComponent = __decorate([
        core_1.Component({
            selector: 'my-ProductsAboveAveragePrice',
            template: __webpack_require__(1085),
            providers: [ProductsAboveAveragePrice_service_1.ProductsAboveAveragePriceService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof ProductsAboveAveragePrice_service_1.ProductsAboveAveragePriceService !== 'undefined' && ProductsAboveAveragePrice_service_1.ProductsAboveAveragePriceService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], ProductsAboveAveragePriceListComponent);
    return ProductsAboveAveragePriceListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.ProductsAboveAveragePriceListComponent = ProductsAboveAveragePriceListComponent;


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsAboveAveragePriceSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: ProductsAboveAveragePriceService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ProductsAboveAveragePrice_service_1 = __webpack_require__(149);
var ProductsAboveAveragePriceSearchComponent = (function () {
    // Lookup Arrays
    function ProductsAboveAveragePriceSearchComponent(route, router, ProductsAboveAveragePriceService) {
        this.route = route;
        this.router = router;
        this.ProductsAboveAveragePriceService = ProductsAboveAveragePriceService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objProductsAboveAveragePrice = new ProductsAboveAveragePrice_service_1.ProductsAboveAveragePriceData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(ProductsAboveAveragePriceSearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductsAboveAveragePriceSearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    ProductsAboveAveragePriceSearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    ProductsAboveAveragePriceSearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objProductsAboveAveragePrice = new ProductsAboveAveragePrice_service_1.ProductsAboveAveragePriceData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    ProductsAboveAveragePriceSearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    ProductsAboveAveragePriceSearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objProductsAboveAveragePrice.ProductName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ProductName like '%" + this.objProductsAboveAveragePrice.ProductName + "%'";
            else
                this.filterExpression = "ProductName like '%" + this.objProductsAboveAveragePrice.ProductName + "%'";
        }
        if (this.objProductsAboveAveragePrice.UnitPrice) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND UnitPrice = " + this.objProductsAboveAveragePrice.UnitPrice;
            else
                this.filterExpression = "UnitPrice = " + this.objProductsAboveAveragePrice.UnitPrice;
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    ProductsAboveAveragePriceSearchComponent.prototype.getLookups = function () {
    };
    ProductsAboveAveragePriceSearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], ProductsAboveAveragePriceSearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], ProductsAboveAveragePriceSearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], ProductsAboveAveragePriceSearchComponent.prototype, "display", null);
    ProductsAboveAveragePriceSearchComponent = __decorate([
        core_1.Component({
            selector: 'ProductsAboveAveragePriceSearch',
            template: __webpack_require__(1086),
            providers: [ProductsAboveAveragePrice_service_1.ProductsAboveAveragePriceService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ProductsAboveAveragePrice_service_1.ProductsAboveAveragePriceService !== 'undefined' && ProductsAboveAveragePrice_service_1.ProductsAboveAveragePriceService) === 'function' && _c) || Object])
    ], ProductsAboveAveragePriceSearchComponent);
    return ProductsAboveAveragePriceSearchComponent;
    var _a, _b, _c;
}());
exports.ProductsAboveAveragePriceSearchComponent = ProductsAboveAveragePriceSearchComponent;


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsAddComponent
 * Purpose		: This component allows to create new Products record and save changes.
 * Dependency	: ProductsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Products_service_1 = __webpack_require__(44);
var Suppliers_service_1 = __webpack_require__(47);
var Categories_service_1 = __webpack_require__(41);
var ProductsAddComponent = (function () {
    function ProductsAddComponent(route, router, toastr, ProductsService, SuppliersService, CategoriesService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.ProductsService = ProductsService;
        this.SuppliersService = SuppliersService;
        this.CategoriesService = CategoriesService;
        this.objProducts = new Products_service_1.ProductsData();
    }
    Object.defineProperty(ProductsAddComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductsAddComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    ProductsAddComponent.prototype.ngOnInit = function () {
        this.objProducts = new Products_service_1.ProductsData();
        this.getLookups();
    };
    ProductsAddComponent.prototype.addProducts = function () {
        var _this = this;
        this.ProductsService.addProductsData(this.objProducts)
            .subscribe(function (record) { return _this.router.navigate(['/Products']); }, function (error) { return _this.errorMessage = 'There was an error while adding record. Error: ' + error; }, function () {
            _this.toastr.success('Products record added successfully...', 'Add Products');
            console.log('Products record added successfully...');
        });
    };
    ProductsAddComponent.prototype.gotoProducts = function () {
        // let Id = this.objProducts ? this.objProducts.ProductID : null;
        this.router.navigate(['/Products']);
    };
    // Get Lookup List for Suppliers
    ProductsAddComponent.prototype.getSuppliers = function () {
        var _this = this;
        this.SuppliersService.getAll().subscribe(function (records) { return _this.SuppliersList = records; });
    };
    // Get Lookup List for Categories
    ProductsAddComponent.prototype.getCategories = function () {
        var _this = this;
        this.CategoriesService.getAll().subscribe(function (records) { return _this.CategoriesList = records; });
    };
    ProductsAddComponent.prototype.getLookups = function () {
        this.getSuppliers();
        this.getCategories();
    };
    ProductsAddComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], ProductsAddComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], ProductsAddComponent.prototype, "display", null);
    ProductsAddComponent = __decorate([
        core_1.Component({
            selector: 'my-Products-add',
            template: __webpack_require__(1087),
            providers: [Products_service_1.ProductsService,
                Suppliers_service_1.SuppliersService, Categories_service_1.CategoriesService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Products_service_1.ProductsService !== 'undefined' && Products_service_1.ProductsService) === 'function' && _d) || Object, (typeof (_e = typeof Suppliers_service_1.SuppliersService !== 'undefined' && Suppliers_service_1.SuppliersService) === 'function' && _e) || Object, (typeof (_f = typeof Categories_service_1.CategoriesService !== 'undefined' && Categories_service_1.CategoriesService) === 'function' && _f) || Object])
    ], ProductsAddComponent);
    return ProductsAddComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.ProductsAddComponent = ProductsAddComponent;


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Products_service_1 = __webpack_require__(44);
var Suppliers_service_1 = __webpack_require__(47);
var Categories_service_1 = __webpack_require__(41);
var ProductsDetailsComponent = (function () {
    function ProductsDetailsComponent(route, router, toastr, ProductsService, SuppliersService, CategoriesService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.ProductsService = ProductsService;
        this.SuppliersService = SuppliersService;
        this.CategoriesService = CategoriesService;
        // this.id = parseInt(params.get('id'));
        this.objProducts = new Products_service_1.ProductsData();
    }
    Object.defineProperty(ProductsDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductsDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    ProductsDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.ProductsService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objProducts = item; });
        this.getLookups();
    };
    ProductsDetailsComponent.prototype.deleteProducts = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Products?') == true) {
            this.ProductsService.deleteProducts(this.objProducts.ProductID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/Products']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('Products record deleted successfully...'); });
        }
    };
    ProductsDetailsComponent.prototype.gotoProductsEdit = function () {
        this.router.navigate(['/Products', this.objProducts.ProductID]);
    };
    ProductsDetailsComponent.prototype.gotoProducts = function () {
        this.router.navigate(['/Products']);
    };
    // Get Lookup List for Suppliers
    ProductsDetailsComponent.prototype.getSuppliers = function () {
        var _this = this;
        this.SuppliersService.getAll().subscribe(function (records) { return _this.SuppliersList = records; });
    };
    // Get Lookup List for Categories
    ProductsDetailsComponent.prototype.getCategories = function () {
        var _this = this;
        this.CategoriesService.getAll().subscribe(function (records) { return _this.CategoriesList = records; });
    };
    ProductsDetailsComponent.prototype.getLookups = function () {
        this.getSuppliers();
        this.getCategories();
    };
    ProductsDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], ProductsDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], ProductsDetailsComponent.prototype, "display", null);
    ProductsDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1088),
            providers: [Products_service_1.ProductsService,
                Suppliers_service_1.SuppliersService, Categories_service_1.CategoriesService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Products_service_1.ProductsService !== 'undefined' && Products_service_1.ProductsService) === 'function' && _d) || Object, (typeof (_e = typeof Suppliers_service_1.SuppliersService !== 'undefined' && Suppliers_service_1.SuppliersService) === 'function' && _e) || Object, (typeof (_f = typeof Categories_service_1.CategoriesService !== 'undefined' && Categories_service_1.CategoriesService) === 'function' && _f) || Object])
    ], ProductsDetailsComponent);
    return ProductsDetailsComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.ProductsDetailsComponent = ProductsDetailsComponent;


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsEditComponent
 * Purpose		: This component retrieves data for the specified record id and allows to edit and save changes.
 * Dependency	: ProductsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Products_service_1 = __webpack_require__(44);
var Suppliers_service_1 = __webpack_require__(47);
var Categories_service_1 = __webpack_require__(41);
var ProductsEditComponent = (function () {
    function ProductsEditComponent(route, router, toastr, ProductsService, SuppliersService, CategoriesService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.ProductsService = ProductsService;
        this.SuppliersService = SuppliersService;
        this.CategoriesService = CategoriesService;
        // this.id = parseInt(params.get('id'));
        this.objProducts = new Products_service_1.ProductsData();
    }
    Object.defineProperty(ProductsEditComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductsEditComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    ProductsEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.ProductsService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objProducts = item; });
        this.getLookups();
    };
    ProductsEditComponent.prototype.updateProducts = function () {
        var _this = this;
        this.ProductsService.updateProductsData(this.objProducts)
            .subscribe(function (record) { return _this.router.navigate(['/Products']); }, function (error) { return _this.errorMessage = 'There was an error while updating record. Error: ' + error; }, function () {
            _this.toastr.success('Products record updated successfully...', 'Edit Products');
            console.log('Products record updated successfully...');
        });
    };
    ProductsEditComponent.prototype.deleteProducts = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Products?') == true) {
            this.ProductsService.deleteProducts(this.objProducts.ProductID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/Products']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('Products record deleted successfully...', 'Delete Products');
                console.log('Products record deleted successfully...');
            });
        }
    };
    ProductsEditComponent.prototype.gotoProducts = function () {
        var Id = this.objProducts ? this.objProducts.ProductID : null;
        this.router.navigate(['/Products']);
    };
    // Get Lookup List for Suppliers
    ProductsEditComponent.prototype.getSuppliers = function () {
        var _this = this;
        this.SuppliersService.getAll().subscribe(function (records) { return _this.SuppliersList = records; });
    };
    // Get Lookup List for Categories
    ProductsEditComponent.prototype.getCategories = function () {
        var _this = this;
        this.CategoriesService.getAll().subscribe(function (records) { return _this.CategoriesList = records; });
    };
    ProductsEditComponent.prototype.getLookups = function () {
        this.getSuppliers();
        this.getCategories();
    };
    ProductsEditComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], ProductsEditComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], ProductsEditComponent.prototype, "display", null);
    ProductsEditComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1089),
            providers: [Products_service_1.ProductsService,
                Suppliers_service_1.SuppliersService, Categories_service_1.CategoriesService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Products_service_1.ProductsService !== 'undefined' && Products_service_1.ProductsService) === 'function' && _d) || Object, (typeof (_e = typeof Suppliers_service_1.SuppliersService !== 'undefined' && Suppliers_service_1.SuppliersService) === 'function' && _e) || Object, (typeof (_f = typeof Categories_service_1.CategoriesService !== 'undefined' && Categories_service_1.CategoriesService) === 'function' && _f) || Object])
    ], ProductsEditComponent);
    return ProductsEditComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.ProductsEditComponent = ProductsEditComponent;


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: ProductsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var Products_service_1 = __webpack_require__(44);
var ProductsSearch_component_1 = __webpack_require__(436);
var ProductsListComponent = (function () {
    function ProductsListComponent(ProductsService, route, router, toastr) {
        this.ProductsService = ProductsService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "ProductID";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newProducts = new Products_service_1.ProductsData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(ProductsListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductsListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    ProductsListComponent.prototype.ngOnInit = function () {
        //this.ProductsService.getAll().subscribe(record => this.ProductsList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getProductsByPaging();
        /*
        this.ProductsList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    ProductsListComponent.prototype.getProducts = function () {
        var _this = this;
        this.ProductsService.getAll()
            .subscribe(function (data) { return _this.ProductsList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on ProductsSearch Component
    ProductsListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getProductsByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getProductsByPaging();
    };
    ProductsListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getProductsByPaging();
    };
    // Get records by paging
    ProductsListComponent.prototype.getProductsByPaging = function () {
        var _this = this;
        this.ProductsService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.ProductsList = data.ProductsList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    ProductsListComponent.prototype.addProducts = function () {
        this.ProductsService.addProductsData(this.newProducts).subscribe(function (record) { return console.log(record); });
        this.getProducts();
    };
    // Updates existing record
    ProductsListComponent.prototype.updateProducts = function () {
        this.ProductsService.updateProductsData(this.selectedProducts).subscribe(function (record) { return console.log(record); });
        this.getProducts();
    };
    // Deletes record with specified id
    ProductsListComponent.prototype.deleteProducts = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Products?') == true) {
            this.ProductsService.deleteProducts(id)
                .subscribe(function (data) { return _this.getProducts(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('Products record deleted successfully...', 'Delete Products');
                console.log('Products record deleted successfully...');
            });
        }
    };
    // Go to First Page
    ProductsListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getProductsByPaging();
    };
    // Go to Previous Page
    ProductsListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getProductsByPaging();
        }
    };
    // Refresh - Go to First Page
    ProductsListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // Go to Next Page
    ProductsListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getProductsByPaging();
        }
    };
    // Go to Last Page
    ProductsListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getProductsByPaging();
    };
    // On Edit - Go to Edit page
    ProductsListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/Products', item.ProductID]);
    };
    // On Details - Go to Details page
    ProductsListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/Products/Details', item.ProductID]);
    };
    // Set record as selected
    ProductsListComponent.prototype.SelectProducts = function (item) {
        this.selectedProducts = item;
    };
    // Submits form
    ProductsListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    ProductsListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], ProductsListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], ProductsListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(ProductsSearch_component_1.ProductsSearchComponent), 
        __metadata('design:type', (typeof (_a = typeof ProductsSearch_component_1.ProductsSearchComponent !== 'undefined' && ProductsSearch_component_1.ProductsSearchComponent) === 'function' && _a) || Object)
    ], ProductsListComponent.prototype, "filterComponent", void 0);
    ProductsListComponent = __decorate([
        core_1.Component({
            selector: 'my-Products',
            template: __webpack_require__(1090),
            providers: [Products_service_1.ProductsService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof Products_service_1.ProductsService !== 'undefined' && Products_service_1.ProductsService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], ProductsListComponent);
    return ProductsListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.ProductsListComponent = ProductsListComponent;


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: ProductsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var Products_service_1 = __webpack_require__(44);
var Suppliers_service_1 = __webpack_require__(47);
var Categories_service_1 = __webpack_require__(41);
var ProductsSearchComponent = (function () {
    function ProductsSearchComponent(route, router, ProductsService, SuppliersService, CategoriesService) {
        this.route = route;
        this.router = router;
        this.ProductsService = ProductsService;
        this.SuppliersService = SuppliersService;
        this.CategoriesService = CategoriesService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objProducts = new Products_service_1.ProductsData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(ProductsSearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductsSearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    ProductsSearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    ProductsSearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objProducts = new Products_service_1.ProductsData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    ProductsSearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    ProductsSearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objProducts.ProductID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ProductID = " + this.objProducts.ProductID;
            else
                this.filterExpression = "ProductID = " + this.objProducts.ProductID;
        }
        if (this.objProducts.ProductName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ProductName like '%" + this.objProducts.ProductName + "%'";
            else
                this.filterExpression = "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.SupplierID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        if (this.objProducts.CategoryID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.QuantityPerUnit) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND QuantityPerUnit like '%" + this.objProducts.QuantityPerUnit + "%'";
            else
                this.filterExpression = "QuantityPerUnit like '%" + this.objProducts.QuantityPerUnit + "%'";
        }
        if (this.objProducts.UnitPrice) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND UnitPrice = " + this.objProducts.UnitPrice;
            else
                this.filterExpression = "UnitPrice = " + this.objProducts.UnitPrice;
        }
        if (this.objProducts.UnitsInStock) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND UnitsInStock = " + this.objProducts.UnitsInStock;
            else
                this.filterExpression = "UnitsInStock = " + this.objProducts.UnitsInStock;
        }
        if (this.objProducts.UnitsOnOrder) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND UnitsOnOrder = " + this.objProducts.UnitsOnOrder;
            else
                this.filterExpression = "UnitsOnOrder = " + this.objProducts.UnitsOnOrder;
        }
        if (this.objProducts.ReorderLevel) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ReorderLevel = " + this.objProducts.ReorderLevel;
            else
                this.filterExpression = "ReorderLevel = " + this.objProducts.ReorderLevel;
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    // Get Lookup List for Suppliers
    ProductsSearchComponent.prototype.getSuppliers = function () {
        var _this = this;
        this.SuppliersService.getAll().subscribe(function (records) { return _this.SuppliersList = records; });
    };
    // Get Lookup List for Categories
    ProductsSearchComponent.prototype.getCategories = function () {
        var _this = this;
        this.CategoriesService.getAll().subscribe(function (records) { return _this.CategoriesList = records; });
    };
    ProductsSearchComponent.prototype.getLookups = function () {
        this.getSuppliers();
        this.getCategories();
    };
    ProductsSearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], ProductsSearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], ProductsSearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], ProductsSearchComponent.prototype, "display", null);
    ProductsSearchComponent = __decorate([
        core_1.Component({
            selector: 'ProductsSearch',
            template: __webpack_require__(1091),
            providers: [Products_service_1.ProductsService,
                Suppliers_service_1.SuppliersService, Categories_service_1.CategoriesService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof Products_service_1.ProductsService !== 'undefined' && Products_service_1.ProductsService) === 'function' && _c) || Object, (typeof (_d = typeof Suppliers_service_1.SuppliersService !== 'undefined' && Suppliers_service_1.SuppliersService) === 'function' && _d) || Object, (typeof (_e = typeof Categories_service_1.CategoriesService !== 'undefined' && Categories_service_1.CategoriesService) === 'function' && _e) || Object])
    ], ProductsSearchComponent);
    return ProductsSearchComponent;
    var _a, _b, _c, _d, _e;
}());
exports.ProductsSearchComponent = ProductsSearchComponent;


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsbyCategoryAddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: ProductsbyCategoryService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var ProductsbyCategory_service_1 = __webpack_require__(150);
var ProductsbyCategoryDetailsComponent = (function () {
    // Lookup Arrays
    function ProductsbyCategoryDetailsComponent(route, router, toastr, ProductsbyCategoryService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.ProductsbyCategoryService = ProductsbyCategoryService;
        // this.id = parseInt(params.get('id'));
        this.objProductsbyCategory = new ProductsbyCategory_service_1.ProductsbyCategoryData();
    }
    Object.defineProperty(ProductsbyCategoryDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductsbyCategoryDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    ProductsbyCategoryDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.ProductsbyCategoryService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objProductsbyCategory = item; });
        this.getLookups();
    };
    ProductsbyCategoryDetailsComponent.prototype.deleteProductsbyCategory = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this ProductsbyCategory?') == true) {
            this.ProductsbyCategoryService.deleteProductsbyCategory(this.objProductsbyCategory.CategoryName.toString())
                .subscribe(function (record) { return _this.router.navigate(['/ProductsbyCategory']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('ProductsbyCategory record deleted successfully...'); });
        }
    };
    ProductsbyCategoryDetailsComponent.prototype.gotoProductsbyCategoryEdit = function () {
        this.router.navigate(['/ProductsbyCategory', this.objProductsbyCategory.CategoryName]);
    };
    ProductsbyCategoryDetailsComponent.prototype.gotoProductsbyCategory = function () {
        this.router.navigate(['/ProductsbyCategory']);
    };
    ProductsbyCategoryDetailsComponent.prototype.getLookups = function () {
    };
    ProductsbyCategoryDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], ProductsbyCategoryDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], ProductsbyCategoryDetailsComponent.prototype, "display", null);
    ProductsbyCategoryDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1092),
            providers: [ProductsbyCategory_service_1.ProductsbyCategoryService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof ProductsbyCategory_service_1.ProductsbyCategoryService !== 'undefined' && ProductsbyCategory_service_1.ProductsbyCategoryService) === 'function' && _d) || Object])
    ], ProductsbyCategoryDetailsComponent);
    return ProductsbyCategoryDetailsComponent;
    var _a, _b, _c, _d;
}());
exports.ProductsbyCategoryDetailsComponent = ProductsbyCategoryDetailsComponent;


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsbyCategoryListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: ProductsbyCategoryService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var ProductsbyCategory_service_1 = __webpack_require__(150);
var ProductsbyCategorySearch_component_1 = __webpack_require__(439);
var ProductsbyCategoryListComponent = (function () {
    function ProductsbyCategoryListComponent(ProductsbyCategoryService, route, router, toastr) {
        this.ProductsbyCategoryService = ProductsbyCategoryService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "CategoryName";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newProductsbyCategory = new ProductsbyCategory_service_1.ProductsbyCategoryData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(ProductsbyCategoryListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductsbyCategoryListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    ProductsbyCategoryListComponent.prototype.ngOnInit = function () {
        // this.ProductsbyCategoryService.getAll().subscribe(record => this.ProductsbyCategoryList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getProductsbyCategoryByPaging();
        /*
        this.ProductsbyCategoryList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    ProductsbyCategoryListComponent.prototype.getProductsbyCategory = function () {
        var _this = this;
        this.ProductsbyCategoryService.getAll()
            .subscribe(function (data) { return _this.ProductsbyCategoryList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on ProductsbyCategorySearch Component
    ProductsbyCategoryListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getProductsbyCategoryByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getProductsbyCategoryByPaging();
    };
    ProductsbyCategoryListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getProductsbyCategoryByPaging();
    };
    // Get records by paging
    ProductsbyCategoryListComponent.prototype.getProductsbyCategoryByPaging = function () {
        var _this = this;
        this.ProductsbyCategoryService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.ProductsbyCategoryList = data.ProductsbyCategoryList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    ProductsbyCategoryListComponent.prototype.addProductsbyCategory = function () {
        this.ProductsbyCategoryService.addProductsbyCategoryData(this.newProductsbyCategory).subscribe(function (record) { return console.log(record); });
        this.getProductsbyCategory();
    };
    // Updates existing record
    ProductsbyCategoryListComponent.prototype.updateProductsbyCategory = function () {
        this.ProductsbyCategoryService.updateProductsbyCategoryData(this.selectedProductsbyCategory).subscribe(function (record) { return console.log(record); });
        this.getProductsbyCategory();
    };
    // Deletes record with specified id
    ProductsbyCategoryListComponent.prototype.deleteProductsbyCategory = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this ProductsbyCategory?') == true) {
            this.ProductsbyCategoryService.deleteProductsbyCategory(id)
                .subscribe(function (data) { return _this.getProductsbyCategory(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; });
        }
    };
    // Go to First Page
    ProductsbyCategoryListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getProductsbyCategoryByPaging();
    };
    // Go to Previous Page
    ProductsbyCategoryListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getProductsbyCategoryByPaging();
        }
    };
    // Go to Next Page
    ProductsbyCategoryListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getProductsbyCategoryByPaging();
        }
    };
    // Go to Last Page
    ProductsbyCategoryListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getProductsbyCategoryByPaging();
    };
    // Refresh - Go to First Page
    ProductsbyCategoryListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // On Edit - Go to Edit page
    ProductsbyCategoryListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/ProductsbyCategory', item.CategoryName]);
    };
    // On Details - Go to Details page
    ProductsbyCategoryListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/ProductsbyCategory/Details', item.CategoryName]);
    };
    // Set record as selected
    ProductsbyCategoryListComponent.prototype.SelectProductsbyCategory = function (item) {
        this.selectedProductsbyCategory = item;
    };
    // Submits form
    ProductsbyCategoryListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    ProductsbyCategoryListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], ProductsbyCategoryListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], ProductsbyCategoryListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(ProductsbyCategorySearch_component_1.ProductsbyCategorySearchComponent), 
        __metadata('design:type', (typeof (_a = typeof ProductsbyCategorySearch_component_1.ProductsbyCategorySearchComponent !== 'undefined' && ProductsbyCategorySearch_component_1.ProductsbyCategorySearchComponent) === 'function' && _a) || Object)
    ], ProductsbyCategoryListComponent.prototype, "filterComponent", void 0);
    ProductsbyCategoryListComponent = __decorate([
        core_1.Component({
            selector: 'my-ProductsbyCategory',
            template: __webpack_require__(1093),
            providers: [ProductsbyCategory_service_1.ProductsbyCategoryService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof ProductsbyCategory_service_1.ProductsbyCategoryService !== 'undefined' && ProductsbyCategory_service_1.ProductsbyCategoryService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], ProductsbyCategoryListComponent);
    return ProductsbyCategoryListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.ProductsbyCategoryListComponent = ProductsbyCategoryListComponent;


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsbyCategorySearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: ProductsbyCategoryService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ProductsbyCategory_service_1 = __webpack_require__(150);
var ProductsbyCategorySearchComponent = (function () {
    // Lookup Arrays
    function ProductsbyCategorySearchComponent(route, router, ProductsbyCategoryService) {
        this.route = route;
        this.router = router;
        this.ProductsbyCategoryService = ProductsbyCategoryService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objProductsbyCategory = new ProductsbyCategory_service_1.ProductsbyCategoryData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(ProductsbyCategorySearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductsbyCategorySearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    ProductsbyCategorySearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    ProductsbyCategorySearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objProductsbyCategory = new ProductsbyCategory_service_1.ProductsbyCategoryData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    ProductsbyCategorySearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    ProductsbyCategorySearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objProductsbyCategory.CategoryName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryName like '%" + this.objProductsbyCategory.CategoryName + "%'";
            else
                this.filterExpression = "CategoryName like '%" + this.objProductsbyCategory.CategoryName + "%'";
        }
        if (this.objProductsbyCategory.ProductName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ProductName like '%" + this.objProductsbyCategory.ProductName + "%'";
            else
                this.filterExpression = "ProductName like '%" + this.objProductsbyCategory.ProductName + "%'";
        }
        if (this.objProductsbyCategory.QuantityPerUnit) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND QuantityPerUnit like '%" + this.objProductsbyCategory.QuantityPerUnit + "%'";
            else
                this.filterExpression = "QuantityPerUnit like '%" + this.objProductsbyCategory.QuantityPerUnit + "%'";
        }
        if (this.objProductsbyCategory.UnitsInStock) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND UnitsInStock = " + this.objProductsbyCategory.UnitsInStock;
            else
                this.filterExpression = "UnitsInStock = " + this.objProductsbyCategory.UnitsInStock;
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    ProductsbyCategorySearchComponent.prototype.getLookups = function () {
    };
    ProductsbyCategorySearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], ProductsbyCategorySearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], ProductsbyCategorySearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], ProductsbyCategorySearchComponent.prototype, "display", null);
    ProductsbyCategorySearchComponent = __decorate([
        core_1.Component({
            selector: 'ProductsbyCategorySearch',
            template: __webpack_require__(1094),
            providers: [ProductsbyCategory_service_1.ProductsbyCategoryService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ProductsbyCategory_service_1.ProductsbyCategoryService !== 'undefined' && ProductsbyCategory_service_1.ProductsbyCategoryService) === 'function' && _c) || Object])
    ], ProductsbyCategorySearchComponent);
    return ProductsbyCategorySearchComponent;
    var _a, _b, _c;
}());
exports.ProductsbyCategorySearchComponent = ProductsbyCategorySearchComponent;


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: QuarterlyOrdersAddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: QuarterlyOrdersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var QuarterlyOrders_service_1 = __webpack_require__(151);
var QuarterlyOrdersDetailsComponent = (function () {
    // Lookup Arrays
    function QuarterlyOrdersDetailsComponent(route, router, toastr, QuarterlyOrdersService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.QuarterlyOrdersService = QuarterlyOrdersService;
        // this.id = parseInt(params.get('id'));
        this.objQuarterlyOrders = new QuarterlyOrders_service_1.QuarterlyOrdersData();
    }
    Object.defineProperty(QuarterlyOrdersDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuarterlyOrdersDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    QuarterlyOrdersDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.QuarterlyOrdersService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objQuarterlyOrders = item; });
        this.getLookups();
    };
    QuarterlyOrdersDetailsComponent.prototype.deleteQuarterlyOrders = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this QuarterlyOrders?') == true) {
            this.QuarterlyOrdersService.deleteQuarterlyOrders(this.objQuarterlyOrders.CustomerID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/QuarterlyOrders']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('QuarterlyOrders record deleted successfully...'); });
        }
    };
    QuarterlyOrdersDetailsComponent.prototype.gotoQuarterlyOrdersEdit = function () {
        this.router.navigate(['/QuarterlyOrders', this.objQuarterlyOrders.CustomerID]);
    };
    QuarterlyOrdersDetailsComponent.prototype.gotoQuarterlyOrders = function () {
        this.router.navigate(['/QuarterlyOrders']);
    };
    QuarterlyOrdersDetailsComponent.prototype.getLookups = function () {
    };
    QuarterlyOrdersDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], QuarterlyOrdersDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], QuarterlyOrdersDetailsComponent.prototype, "display", null);
    QuarterlyOrdersDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1095),
            providers: [QuarterlyOrders_service_1.QuarterlyOrdersService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof QuarterlyOrders_service_1.QuarterlyOrdersService !== 'undefined' && QuarterlyOrders_service_1.QuarterlyOrdersService) === 'function' && _d) || Object])
    ], QuarterlyOrdersDetailsComponent);
    return QuarterlyOrdersDetailsComponent;
    var _a, _b, _c, _d;
}());
exports.QuarterlyOrdersDetailsComponent = QuarterlyOrdersDetailsComponent;


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: QuarterlyOrdersListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: QuarterlyOrdersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var QuarterlyOrders_service_1 = __webpack_require__(151);
var QuarterlyOrdersSearch_component_1 = __webpack_require__(442);
var QuarterlyOrdersListComponent = (function () {
    function QuarterlyOrdersListComponent(QuarterlyOrdersService, route, router, toastr) {
        this.QuarterlyOrdersService = QuarterlyOrdersService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "CustomerID";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newQuarterlyOrders = new QuarterlyOrders_service_1.QuarterlyOrdersData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(QuarterlyOrdersListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuarterlyOrdersListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    QuarterlyOrdersListComponent.prototype.ngOnInit = function () {
        // this.QuarterlyOrdersService.getAll().subscribe(record => this.QuarterlyOrdersList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getQuarterlyOrdersByPaging();
        /*
        this.QuarterlyOrdersList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    QuarterlyOrdersListComponent.prototype.getQuarterlyOrders = function () {
        var _this = this;
        this.QuarterlyOrdersService.getAll()
            .subscribe(function (data) { return _this.QuarterlyOrdersList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on QuarterlyOrdersSearch Component
    QuarterlyOrdersListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getQuarterlyOrdersByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getQuarterlyOrdersByPaging();
    };
    QuarterlyOrdersListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getQuarterlyOrdersByPaging();
    };
    // Get records by paging
    QuarterlyOrdersListComponent.prototype.getQuarterlyOrdersByPaging = function () {
        var _this = this;
        this.QuarterlyOrdersService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.QuarterlyOrdersList = data.QuarterlyOrdersList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    QuarterlyOrdersListComponent.prototype.addQuarterlyOrders = function () {
        this.QuarterlyOrdersService.addQuarterlyOrdersData(this.newQuarterlyOrders).subscribe(function (record) { return console.log(record); });
        this.getQuarterlyOrders();
    };
    // Updates existing record
    QuarterlyOrdersListComponent.prototype.updateQuarterlyOrders = function () {
        this.QuarterlyOrdersService.updateQuarterlyOrdersData(this.selectedQuarterlyOrders).subscribe(function (record) { return console.log(record); });
        this.getQuarterlyOrders();
    };
    // Deletes record with specified id
    QuarterlyOrdersListComponent.prototype.deleteQuarterlyOrders = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this QuarterlyOrders?') == true) {
            this.QuarterlyOrdersService.deleteQuarterlyOrders(id)
                .subscribe(function (data) { return _this.getQuarterlyOrders(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; });
        }
    };
    // Go to First Page
    QuarterlyOrdersListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getQuarterlyOrdersByPaging();
    };
    // Go to Previous Page
    QuarterlyOrdersListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getQuarterlyOrdersByPaging();
        }
    };
    // Go to Next Page
    QuarterlyOrdersListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getQuarterlyOrdersByPaging();
        }
    };
    // Go to Last Page
    QuarterlyOrdersListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getQuarterlyOrdersByPaging();
    };
    // Refresh - Go to First Page
    QuarterlyOrdersListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // On Edit - Go to Edit page
    QuarterlyOrdersListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/QuarterlyOrders', item.CustomerID]);
    };
    // On Details - Go to Details page
    QuarterlyOrdersListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/QuarterlyOrders/Details', item.CustomerID]);
    };
    // Set record as selected
    QuarterlyOrdersListComponent.prototype.SelectQuarterlyOrders = function (item) {
        this.selectedQuarterlyOrders = item;
    };
    // Submits form
    QuarterlyOrdersListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    QuarterlyOrdersListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], QuarterlyOrdersListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], QuarterlyOrdersListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(QuarterlyOrdersSearch_component_1.QuarterlyOrdersSearchComponent), 
        __metadata('design:type', (typeof (_a = typeof QuarterlyOrdersSearch_component_1.QuarterlyOrdersSearchComponent !== 'undefined' && QuarterlyOrdersSearch_component_1.QuarterlyOrdersSearchComponent) === 'function' && _a) || Object)
    ], QuarterlyOrdersListComponent.prototype, "filterComponent", void 0);
    QuarterlyOrdersListComponent = __decorate([
        core_1.Component({
            selector: 'my-QuarterlyOrders',
            template: __webpack_require__(1096),
            providers: [QuarterlyOrders_service_1.QuarterlyOrdersService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof QuarterlyOrders_service_1.QuarterlyOrdersService !== 'undefined' && QuarterlyOrders_service_1.QuarterlyOrdersService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], QuarterlyOrdersListComponent);
    return QuarterlyOrdersListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.QuarterlyOrdersListComponent = QuarterlyOrdersListComponent;


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: QuarterlyOrdersSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: QuarterlyOrdersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var QuarterlyOrders_service_1 = __webpack_require__(151);
var QuarterlyOrdersSearchComponent = (function () {
    // Lookup Arrays
    function QuarterlyOrdersSearchComponent(route, router, QuarterlyOrdersService) {
        this.route = route;
        this.router = router;
        this.QuarterlyOrdersService = QuarterlyOrdersService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objQuarterlyOrders = new QuarterlyOrders_service_1.QuarterlyOrdersData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(QuarterlyOrdersSearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuarterlyOrdersSearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    QuarterlyOrdersSearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    QuarterlyOrdersSearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objQuarterlyOrders = new QuarterlyOrders_service_1.QuarterlyOrdersData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    QuarterlyOrdersSearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    QuarterlyOrdersSearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objQuarterlyOrders.CustomerID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CustomerID like '%" + this.objQuarterlyOrders.CustomerID + "%'";
            else
                this.filterExpression = "CustomerID like '%" + this.objQuarterlyOrders.CustomerID + "%'";
        }
        if (this.objQuarterlyOrders.CompanyName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CompanyName like '%" + this.objQuarterlyOrders.CompanyName + "%'";
            else
                this.filterExpression = "CompanyName like '%" + this.objQuarterlyOrders.CompanyName + "%'";
        }
        if (this.objQuarterlyOrders.City) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND City like '%" + this.objQuarterlyOrders.City + "%'";
            else
                this.filterExpression = "City like '%" + this.objQuarterlyOrders.City + "%'";
        }
        if (this.objQuarterlyOrders.Country) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Country like '%" + this.objQuarterlyOrders.Country + "%'";
            else
                this.filterExpression = "Country like '%" + this.objQuarterlyOrders.Country + "%'";
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    QuarterlyOrdersSearchComponent.prototype.getLookups = function () {
    };
    QuarterlyOrdersSearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], QuarterlyOrdersSearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], QuarterlyOrdersSearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], QuarterlyOrdersSearchComponent.prototype, "display", null);
    QuarterlyOrdersSearchComponent = __decorate([
        core_1.Component({
            selector: 'QuarterlyOrdersSearch',
            template: __webpack_require__(1097),
            providers: [QuarterlyOrders_service_1.QuarterlyOrdersService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof QuarterlyOrders_service_1.QuarterlyOrdersService !== 'undefined' && QuarterlyOrders_service_1.QuarterlyOrdersService) === 'function' && _c) || Object])
    ], QuarterlyOrdersSearchComponent);
    return QuarterlyOrdersSearchComponent;
    var _a, _b, _c;
}());
exports.QuarterlyOrdersSearchComponent = QuarterlyOrdersSearchComponent;


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: RegionAddComponent
 * Purpose		: This component allows to create new Region record and save changes.
 * Dependency	: RegionService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Region_service_1 = __webpack_require__(45);
var RegionAddComponent = (function () {
    // Lookup Arrays
    function RegionAddComponent(route, router, toastr, RegionService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.RegionService = RegionService;
        this.objRegion = new Region_service_1.RegionData();
    }
    Object.defineProperty(RegionAddComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegionAddComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    RegionAddComponent.prototype.ngOnInit = function () {
        this.objRegion = new Region_service_1.RegionData();
        this.getLookups();
    };
    RegionAddComponent.prototype.addRegion = function () {
        var _this = this;
        this.RegionService.addRegionData(this.objRegion)
            .subscribe(function (record) { return _this.router.navigate(['/Region']); }, function (error) { return _this.errorMessage = 'There was an error while adding record. Error: ' + error; }, function () {
            _this.toastr.success('Region record added successfully...', 'Add Region');
            console.log('Region record added successfully...');
        });
    };
    RegionAddComponent.prototype.gotoRegion = function () {
        // let Id = this.objRegion ? this.objRegion.RegionID : null;
        this.router.navigate(['/Region']);
    };
    RegionAddComponent.prototype.getLookups = function () {
    };
    RegionAddComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], RegionAddComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], RegionAddComponent.prototype, "display", null);
    RegionAddComponent = __decorate([
        core_1.Component({
            selector: 'my-Region-add',
            template: __webpack_require__(1098),
            providers: [Region_service_1.RegionService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Region_service_1.RegionService !== 'undefined' && Region_service_1.RegionService) === 'function' && _d) || Object])
    ], RegionAddComponent);
    return RegionAddComponent;
    var _a, _b, _c, _d;
}());
exports.RegionAddComponent = RegionAddComponent;


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Region_service_1 = __webpack_require__(45);
var RegionDetailsComponent = (function () {
    // Lookup Arrays
    function RegionDetailsComponent(route, router, toastr, RegionService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.RegionService = RegionService;
        // this.id = parseInt(params.get('id'));
        this.objRegion = new Region_service_1.RegionData();
    }
    Object.defineProperty(RegionDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegionDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    RegionDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.RegionService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objRegion = item; });
        this.getLookups();
    };
    RegionDetailsComponent.prototype.deleteRegion = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Region?') == true) {
            this.RegionService.deleteRegion(this.objRegion.RegionID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/Region']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('Region record deleted successfully...'); });
        }
    };
    RegionDetailsComponent.prototype.gotoRegionEdit = function () {
        this.router.navigate(['/Region', this.objRegion.RegionID]);
    };
    RegionDetailsComponent.prototype.gotoRegion = function () {
        this.router.navigate(['/Region']);
    };
    RegionDetailsComponent.prototype.getLookups = function () {
    };
    RegionDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], RegionDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], RegionDetailsComponent.prototype, "display", null);
    RegionDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1099),
            providers: [Region_service_1.RegionService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Region_service_1.RegionService !== 'undefined' && Region_service_1.RegionService) === 'function' && _d) || Object])
    ], RegionDetailsComponent);
    return RegionDetailsComponent;
    var _a, _b, _c, _d;
}());
exports.RegionDetailsComponent = RegionDetailsComponent;


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: RegionEditComponent
 * Purpose		: This component retrieves data for the specified record id and allows to edit and save changes.
 * Dependency	: RegionService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Region_service_1 = __webpack_require__(45);
var RegionEditComponent = (function () {
    // Lookup Arrays
    function RegionEditComponent(route, router, toastr, RegionService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.RegionService = RegionService;
        // this.id = parseInt(params.get('id'));
        this.objRegion = new Region_service_1.RegionData();
    }
    Object.defineProperty(RegionEditComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegionEditComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    RegionEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.RegionService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objRegion = item; });
        this.getLookups();
    };
    RegionEditComponent.prototype.updateRegion = function () {
        var _this = this;
        this.RegionService.updateRegionData(this.objRegion)
            .subscribe(function (record) { return _this.router.navigate(['/Region']); }, function (error) { return _this.errorMessage = 'There was an error while updating record. Error: ' + error; }, function () {
            _this.toastr.success('Region record updated successfully...', 'Edit Region');
            console.log('Region record updated successfully...');
        });
    };
    RegionEditComponent.prototype.deleteRegion = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Region?') == true) {
            this.RegionService.deleteRegion(this.objRegion.RegionID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/Region']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('Region record deleted successfully...', 'Delete Region');
                console.log('Region record deleted successfully...');
            });
        }
    };
    RegionEditComponent.prototype.gotoRegion = function () {
        var Id = this.objRegion ? this.objRegion.RegionID : null;
        this.router.navigate(['/Region']);
    };
    RegionEditComponent.prototype.getLookups = function () {
    };
    RegionEditComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], RegionEditComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], RegionEditComponent.prototype, "display", null);
    RegionEditComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1100),
            providers: [Region_service_1.RegionService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Region_service_1.RegionService !== 'undefined' && Region_service_1.RegionService) === 'function' && _d) || Object])
    ], RegionEditComponent);
    return RegionEditComponent;
    var _a, _b, _c, _d;
}());
exports.RegionEditComponent = RegionEditComponent;


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: RegionListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: RegionService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var Region_service_1 = __webpack_require__(45);
var RegionSearch_component_1 = __webpack_require__(447);
var RegionListComponent = (function () {
    function RegionListComponent(RegionService, route, router, toastr) {
        this.RegionService = RegionService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "RegionID";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newRegion = new Region_service_1.RegionData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(RegionListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegionListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    RegionListComponent.prototype.ngOnInit = function () {
        //this.RegionService.getAll().subscribe(record => this.RegionList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getRegionByPaging();
        /*
        this.RegionList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    RegionListComponent.prototype.getRegion = function () {
        var _this = this;
        this.RegionService.getAll()
            .subscribe(function (data) { return _this.RegionList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on RegionSearch Component
    RegionListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getRegionByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getRegionByPaging();
    };
    RegionListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getRegionByPaging();
    };
    // Get records by paging
    RegionListComponent.prototype.getRegionByPaging = function () {
        var _this = this;
        this.RegionService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.RegionList = data.RegionList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    RegionListComponent.prototype.addRegion = function () {
        this.RegionService.addRegionData(this.newRegion).subscribe(function (record) { return console.log(record); });
        this.getRegion();
    };
    // Updates existing record
    RegionListComponent.prototype.updateRegion = function () {
        this.RegionService.updateRegionData(this.selectedRegion).subscribe(function (record) { return console.log(record); });
        this.getRegion();
    };
    // Deletes record with specified id
    RegionListComponent.prototype.deleteRegion = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Region?') == true) {
            this.RegionService.deleteRegion(id)
                .subscribe(function (data) { return _this.getRegion(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('Region record deleted successfully...', 'Delete Region');
                console.log('Region record deleted successfully...');
            });
        }
    };
    // Go to First Page
    RegionListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getRegionByPaging();
    };
    // Go to Previous Page
    RegionListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getRegionByPaging();
        }
    };
    // Refresh - Go to First Page
    RegionListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // Go to Next Page
    RegionListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getRegionByPaging();
        }
    };
    // Go to Last Page
    RegionListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getRegionByPaging();
    };
    // On Edit - Go to Edit page
    RegionListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/Region', item.RegionID]);
    };
    // On Details - Go to Details page
    RegionListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/Region/Details', item.RegionID]);
    };
    // Set record as selected
    RegionListComponent.prototype.SelectRegion = function (item) {
        this.selectedRegion = item;
    };
    // Submits form
    RegionListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    RegionListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], RegionListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], RegionListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(RegionSearch_component_1.RegionSearchComponent), 
        __metadata('design:type', (typeof (_a = typeof RegionSearch_component_1.RegionSearchComponent !== 'undefined' && RegionSearch_component_1.RegionSearchComponent) === 'function' && _a) || Object)
    ], RegionListComponent.prototype, "filterComponent", void 0);
    RegionListComponent = __decorate([
        core_1.Component({
            selector: 'my-Region',
            template: __webpack_require__(1101),
            providers: [Region_service_1.RegionService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof Region_service_1.RegionService !== 'undefined' && Region_service_1.RegionService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], RegionListComponent);
    return RegionListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.RegionListComponent = RegionListComponent;


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: RegionSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: RegionService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var Region_service_1 = __webpack_require__(45);
var RegionSearchComponent = (function () {
    // Lookup Arrays
    function RegionSearchComponent(route, router, RegionService) {
        this.route = route;
        this.router = router;
        this.RegionService = RegionService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objRegion = new Region_service_1.RegionData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(RegionSearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegionSearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    RegionSearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    RegionSearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objRegion = new Region_service_1.RegionData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    RegionSearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    RegionSearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objRegion.RegionID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND RegionID = " + this.objRegion.RegionID;
            else
                this.filterExpression = "RegionID = " + this.objRegion.RegionID;
        }
        if (this.objRegion.RegionDescription) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND RegionDescription like '%" + this.objRegion.RegionDescription + "%'";
            else
                this.filterExpression = "RegionDescription like '%" + this.objRegion.RegionDescription + "%'";
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    RegionSearchComponent.prototype.getLookups = function () {
    };
    RegionSearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], RegionSearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], RegionSearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], RegionSearchComponent.prototype, "display", null);
    RegionSearchComponent = __decorate([
        core_1.Component({
            selector: 'RegionSearch',
            template: __webpack_require__(1102),
            providers: [Region_service_1.RegionService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof Region_service_1.RegionService !== 'undefined' && Region_service_1.RegionService) === 'function' && _c) || Object])
    ], RegionSearchComponent);
    return RegionSearchComponent;
    var _a, _b, _c;
}());
exports.RegionSearchComponent = RegionSearchComponent;


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SalesTotalsbyAmountAddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: SalesTotalsbyAmountService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var SalesTotalsbyAmount_service_1 = __webpack_require__(152);
var SalesTotalsbyAmountDetailsComponent = (function () {
    // Lookup Arrays
    function SalesTotalsbyAmountDetailsComponent(route, router, toastr, SalesTotalsbyAmountService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.SalesTotalsbyAmountService = SalesTotalsbyAmountService;
        // this.id = parseInt(params.get('id'));
        this.objSalesTotalsbyAmount = new SalesTotalsbyAmount_service_1.SalesTotalsbyAmountData();
    }
    Object.defineProperty(SalesTotalsbyAmountDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesTotalsbyAmountDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    SalesTotalsbyAmountDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.SalesTotalsbyAmountService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objSalesTotalsbyAmount = item; });
        this.getLookups();
    };
    SalesTotalsbyAmountDetailsComponent.prototype.deleteSalesTotalsbyAmount = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this SalesTotalsbyAmount?') == true) {
            this.SalesTotalsbyAmountService.deleteSalesTotalsbyAmount(this.objSalesTotalsbyAmount.SaleAmount.toString())
                .subscribe(function (record) { return _this.router.navigate(['/SalesTotalsbyAmount']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('SalesTotalsbyAmount record deleted successfully...'); });
        }
    };
    SalesTotalsbyAmountDetailsComponent.prototype.gotoSalesTotalsbyAmountEdit = function () {
        this.router.navigate(['/SalesTotalsbyAmount', this.objSalesTotalsbyAmount.SaleAmount]);
    };
    SalesTotalsbyAmountDetailsComponent.prototype.gotoSalesTotalsbyAmount = function () {
        this.router.navigate(['/SalesTotalsbyAmount']);
    };
    SalesTotalsbyAmountDetailsComponent.prototype.getLookups = function () {
    };
    SalesTotalsbyAmountDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], SalesTotalsbyAmountDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], SalesTotalsbyAmountDetailsComponent.prototype, "display", null);
    SalesTotalsbyAmountDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1103),
            providers: [SalesTotalsbyAmount_service_1.SalesTotalsbyAmountService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof SalesTotalsbyAmount_service_1.SalesTotalsbyAmountService !== 'undefined' && SalesTotalsbyAmount_service_1.SalesTotalsbyAmountService) === 'function' && _d) || Object])
    ], SalesTotalsbyAmountDetailsComponent);
    return SalesTotalsbyAmountDetailsComponent;
    var _a, _b, _c, _d;
}());
exports.SalesTotalsbyAmountDetailsComponent = SalesTotalsbyAmountDetailsComponent;


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SalesTotalsbyAmountListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: SalesTotalsbyAmountService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var SalesTotalsbyAmount_service_1 = __webpack_require__(152);
var SalesTotalsbyAmountSearch_component_1 = __webpack_require__(450);
var SalesTotalsbyAmountListComponent = (function () {
    function SalesTotalsbyAmountListComponent(SalesTotalsbyAmountService, route, router, toastr) {
        this.SalesTotalsbyAmountService = SalesTotalsbyAmountService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "SaleAmount";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newSalesTotalsbyAmount = new SalesTotalsbyAmount_service_1.SalesTotalsbyAmountData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(SalesTotalsbyAmountListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesTotalsbyAmountListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    SalesTotalsbyAmountListComponent.prototype.ngOnInit = function () {
        // this.SalesTotalsbyAmountService.getAll().subscribe(record => this.SalesTotalsbyAmountList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getSalesTotalsbyAmountByPaging();
        /*
        this.SalesTotalsbyAmountList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    SalesTotalsbyAmountListComponent.prototype.getSalesTotalsbyAmount = function () {
        var _this = this;
        this.SalesTotalsbyAmountService.getAll()
            .subscribe(function (data) { return _this.SalesTotalsbyAmountList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on SalesTotalsbyAmountSearch Component
    SalesTotalsbyAmountListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getSalesTotalsbyAmountByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getSalesTotalsbyAmountByPaging();
    };
    SalesTotalsbyAmountListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getSalesTotalsbyAmountByPaging();
    };
    // Get records by paging
    SalesTotalsbyAmountListComponent.prototype.getSalesTotalsbyAmountByPaging = function () {
        var _this = this;
        this.SalesTotalsbyAmountService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.SalesTotalsbyAmountList = data.SalesTotalsbyAmountList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    SalesTotalsbyAmountListComponent.prototype.addSalesTotalsbyAmount = function () {
        this.SalesTotalsbyAmountService.addSalesTotalsbyAmountData(this.newSalesTotalsbyAmount).subscribe(function (record) { return console.log(record); });
        this.getSalesTotalsbyAmount();
    };
    // Updates existing record
    SalesTotalsbyAmountListComponent.prototype.updateSalesTotalsbyAmount = function () {
        this.SalesTotalsbyAmountService.updateSalesTotalsbyAmountData(this.selectedSalesTotalsbyAmount).subscribe(function (record) { return console.log(record); });
        this.getSalesTotalsbyAmount();
    };
    // Deletes record with specified id
    SalesTotalsbyAmountListComponent.prototype.deleteSalesTotalsbyAmount = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this SalesTotalsbyAmount?') == true) {
            this.SalesTotalsbyAmountService.deleteSalesTotalsbyAmount(id)
                .subscribe(function (data) { return _this.getSalesTotalsbyAmount(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; });
        }
    };
    // Go to First Page
    SalesTotalsbyAmountListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getSalesTotalsbyAmountByPaging();
    };
    // Go to Previous Page
    SalesTotalsbyAmountListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getSalesTotalsbyAmountByPaging();
        }
    };
    // Go to Next Page
    SalesTotalsbyAmountListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getSalesTotalsbyAmountByPaging();
        }
    };
    // Go to Last Page
    SalesTotalsbyAmountListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getSalesTotalsbyAmountByPaging();
    };
    // Refresh - Go to First Page
    SalesTotalsbyAmountListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // On Edit - Go to Edit page
    SalesTotalsbyAmountListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/SalesTotalsbyAmount', item.SaleAmount]);
    };
    // On Details - Go to Details page
    SalesTotalsbyAmountListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/SalesTotalsbyAmount/Details', item.SaleAmount]);
    };
    // Set record as selected
    SalesTotalsbyAmountListComponent.prototype.SelectSalesTotalsbyAmount = function (item) {
        this.selectedSalesTotalsbyAmount = item;
    };
    // Submits form
    SalesTotalsbyAmountListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    SalesTotalsbyAmountListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], SalesTotalsbyAmountListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], SalesTotalsbyAmountListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(SalesTotalsbyAmountSearch_component_1.SalesTotalsbyAmountSearchComponent), 
        __metadata('design:type', (typeof (_a = typeof SalesTotalsbyAmountSearch_component_1.SalesTotalsbyAmountSearchComponent !== 'undefined' && SalesTotalsbyAmountSearch_component_1.SalesTotalsbyAmountSearchComponent) === 'function' && _a) || Object)
    ], SalesTotalsbyAmountListComponent.prototype, "filterComponent", void 0);
    SalesTotalsbyAmountListComponent = __decorate([
        core_1.Component({
            selector: 'my-SalesTotalsbyAmount',
            template: __webpack_require__(1104),
            providers: [SalesTotalsbyAmount_service_1.SalesTotalsbyAmountService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof SalesTotalsbyAmount_service_1.SalesTotalsbyAmountService !== 'undefined' && SalesTotalsbyAmount_service_1.SalesTotalsbyAmountService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], SalesTotalsbyAmountListComponent);
    return SalesTotalsbyAmountListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.SalesTotalsbyAmountListComponent = SalesTotalsbyAmountListComponent;


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SalesTotalsbyAmountSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: SalesTotalsbyAmountService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var SalesTotalsbyAmount_service_1 = __webpack_require__(152);
var SalesTotalsbyAmountSearchComponent = (function () {
    // Lookup Arrays
    function SalesTotalsbyAmountSearchComponent(route, router, SalesTotalsbyAmountService) {
        this.route = route;
        this.router = router;
        this.SalesTotalsbyAmountService = SalesTotalsbyAmountService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objSalesTotalsbyAmount = new SalesTotalsbyAmount_service_1.SalesTotalsbyAmountData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(SalesTotalsbyAmountSearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesTotalsbyAmountSearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    SalesTotalsbyAmountSearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    SalesTotalsbyAmountSearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objSalesTotalsbyAmount = new SalesTotalsbyAmount_service_1.SalesTotalsbyAmountData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    SalesTotalsbyAmountSearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    SalesTotalsbyAmountSearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objSalesTotalsbyAmount.SaleAmount) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SaleAmount = " + this.objSalesTotalsbyAmount.SaleAmount;
            else
                this.filterExpression = "SaleAmount = " + this.objSalesTotalsbyAmount.SaleAmount;
        }
        if (this.objSalesTotalsbyAmount.OrderID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND OrderID = " + this.objSalesTotalsbyAmount.OrderID;
            else
                this.filterExpression = "OrderID = " + this.objSalesTotalsbyAmount.OrderID;
        }
        if (this.objSalesTotalsbyAmount.CompanyName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CompanyName like '%" + this.objSalesTotalsbyAmount.CompanyName + "%'";
            else
                this.filterExpression = "CompanyName like '%" + this.objSalesTotalsbyAmount.CompanyName + "%'";
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    SalesTotalsbyAmountSearchComponent.prototype.getLookups = function () {
    };
    SalesTotalsbyAmountSearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], SalesTotalsbyAmountSearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], SalesTotalsbyAmountSearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], SalesTotalsbyAmountSearchComponent.prototype, "display", null);
    SalesTotalsbyAmountSearchComponent = __decorate([
        core_1.Component({
            selector: 'SalesTotalsbyAmountSearch',
            template: __webpack_require__(1105),
            providers: [SalesTotalsbyAmount_service_1.SalesTotalsbyAmountService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof SalesTotalsbyAmount_service_1.SalesTotalsbyAmountService !== 'undefined' && SalesTotalsbyAmount_service_1.SalesTotalsbyAmountService) === 'function' && _c) || Object])
    ], SalesTotalsbyAmountSearchComponent);
    return SalesTotalsbyAmountSearchComponent;
    var _a, _b, _c;
}());
exports.SalesTotalsbyAmountSearchComponent = SalesTotalsbyAmountSearchComponent;


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SalesbyCategoryAddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: SalesbyCategoryService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var SalesbyCategory_service_1 = __webpack_require__(153);
var SalesbyCategoryDetailsComponent = (function () {
    // Lookup Arrays
    function SalesbyCategoryDetailsComponent(route, router, toastr, SalesbyCategoryService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.SalesbyCategoryService = SalesbyCategoryService;
        // this.id = parseInt(params.get('id'));
        this.objSalesbyCategory = new SalesbyCategory_service_1.SalesbyCategoryData();
    }
    Object.defineProperty(SalesbyCategoryDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesbyCategoryDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    SalesbyCategoryDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.SalesbyCategoryService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objSalesbyCategory = item; });
        this.getLookups();
    };
    SalesbyCategoryDetailsComponent.prototype.deleteSalesbyCategory = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this SalesbyCategory?') == true) {
            this.SalesbyCategoryService.deleteSalesbyCategory(this.objSalesbyCategory.CategoryID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/SalesbyCategory']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('SalesbyCategory record deleted successfully...'); });
        }
    };
    SalesbyCategoryDetailsComponent.prototype.gotoSalesbyCategoryEdit = function () {
        this.router.navigate(['/SalesbyCategory', this.objSalesbyCategory.CategoryID]);
    };
    SalesbyCategoryDetailsComponent.prototype.gotoSalesbyCategory = function () {
        this.router.navigate(['/SalesbyCategory']);
    };
    SalesbyCategoryDetailsComponent.prototype.getLookups = function () {
    };
    SalesbyCategoryDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], SalesbyCategoryDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], SalesbyCategoryDetailsComponent.prototype, "display", null);
    SalesbyCategoryDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1106),
            providers: [SalesbyCategory_service_1.SalesbyCategoryService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof SalesbyCategory_service_1.SalesbyCategoryService !== 'undefined' && SalesbyCategory_service_1.SalesbyCategoryService) === 'function' && _d) || Object])
    ], SalesbyCategoryDetailsComponent);
    return SalesbyCategoryDetailsComponent;
    var _a, _b, _c, _d;
}());
exports.SalesbyCategoryDetailsComponent = SalesbyCategoryDetailsComponent;


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SalesbyCategoryListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: SalesbyCategoryService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var SalesbyCategory_service_1 = __webpack_require__(153);
var SalesbyCategorySearch_component_1 = __webpack_require__(453);
var SalesbyCategoryListComponent = (function () {
    function SalesbyCategoryListComponent(SalesbyCategoryService, route, router, toastr) {
        this.SalesbyCategoryService = SalesbyCategoryService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "CategoryID";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newSalesbyCategory = new SalesbyCategory_service_1.SalesbyCategoryData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(SalesbyCategoryListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesbyCategoryListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    SalesbyCategoryListComponent.prototype.ngOnInit = function () {
        // this.SalesbyCategoryService.getAll().subscribe(record => this.SalesbyCategoryList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getSalesbyCategoryByPaging();
        /*
        this.SalesbyCategoryList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    SalesbyCategoryListComponent.prototype.getSalesbyCategory = function () {
        var _this = this;
        this.SalesbyCategoryService.getAll()
            .subscribe(function (data) { return _this.SalesbyCategoryList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on SalesbyCategorySearch Component
    SalesbyCategoryListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getSalesbyCategoryByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getSalesbyCategoryByPaging();
    };
    SalesbyCategoryListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getSalesbyCategoryByPaging();
    };
    // Get records by paging
    SalesbyCategoryListComponent.prototype.getSalesbyCategoryByPaging = function () {
        var _this = this;
        this.SalesbyCategoryService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.SalesbyCategoryList = data.SalesbyCategoryList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    SalesbyCategoryListComponent.prototype.addSalesbyCategory = function () {
        this.SalesbyCategoryService.addSalesbyCategoryData(this.newSalesbyCategory).subscribe(function (record) { return console.log(record); });
        this.getSalesbyCategory();
    };
    // Updates existing record
    SalesbyCategoryListComponent.prototype.updateSalesbyCategory = function () {
        this.SalesbyCategoryService.updateSalesbyCategoryData(this.selectedSalesbyCategory).subscribe(function (record) { return console.log(record); });
        this.getSalesbyCategory();
    };
    // Deletes record with specified id
    SalesbyCategoryListComponent.prototype.deleteSalesbyCategory = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this SalesbyCategory?') == true) {
            this.SalesbyCategoryService.deleteSalesbyCategory(id)
                .subscribe(function (data) { return _this.getSalesbyCategory(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; });
        }
    };
    // Go to First Page
    SalesbyCategoryListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getSalesbyCategoryByPaging();
    };
    // Go to Previous Page
    SalesbyCategoryListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getSalesbyCategoryByPaging();
        }
    };
    // Go to Next Page
    SalesbyCategoryListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getSalesbyCategoryByPaging();
        }
    };
    // Go to Last Page
    SalesbyCategoryListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getSalesbyCategoryByPaging();
    };
    // Refresh - Go to First Page
    SalesbyCategoryListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // On Edit - Go to Edit page
    SalesbyCategoryListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/SalesbyCategory', item.CategoryID]);
    };
    // On Details - Go to Details page
    SalesbyCategoryListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/SalesbyCategory/Details', item.CategoryID]);
    };
    // Set record as selected
    SalesbyCategoryListComponent.prototype.SelectSalesbyCategory = function (item) {
        this.selectedSalesbyCategory = item;
    };
    // Submits form
    SalesbyCategoryListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    SalesbyCategoryListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], SalesbyCategoryListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], SalesbyCategoryListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(SalesbyCategorySearch_component_1.SalesbyCategorySearchComponent), 
        __metadata('design:type', (typeof (_a = typeof SalesbyCategorySearch_component_1.SalesbyCategorySearchComponent !== 'undefined' && SalesbyCategorySearch_component_1.SalesbyCategorySearchComponent) === 'function' && _a) || Object)
    ], SalesbyCategoryListComponent.prototype, "filterComponent", void 0);
    SalesbyCategoryListComponent = __decorate([
        core_1.Component({
            selector: 'my-SalesbyCategory',
            template: __webpack_require__(1107),
            providers: [SalesbyCategory_service_1.SalesbyCategoryService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof SalesbyCategory_service_1.SalesbyCategoryService !== 'undefined' && SalesbyCategory_service_1.SalesbyCategoryService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], SalesbyCategoryListComponent);
    return SalesbyCategoryListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.SalesbyCategoryListComponent = SalesbyCategoryListComponent;


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SalesbyCategorySearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: SalesbyCategoryService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var SalesbyCategory_service_1 = __webpack_require__(153);
var SalesbyCategorySearchComponent = (function () {
    // Lookup Arrays
    function SalesbyCategorySearchComponent(route, router, SalesbyCategoryService) {
        this.route = route;
        this.router = router;
        this.SalesbyCategoryService = SalesbyCategoryService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objSalesbyCategory = new SalesbyCategory_service_1.SalesbyCategoryData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(SalesbyCategorySearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesbyCategorySearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    SalesbyCategorySearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    SalesbyCategorySearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objSalesbyCategory = new SalesbyCategory_service_1.SalesbyCategoryData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    SalesbyCategorySearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    SalesbyCategorySearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objSalesbyCategory.CategoryID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objSalesbyCategory.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objSalesbyCategory.CategoryID;
        }
        if (this.objSalesbyCategory.CategoryName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryName like '%" + this.objSalesbyCategory.CategoryName + "%'";
            else
                this.filterExpression = "CategoryName like '%" + this.objSalesbyCategory.CategoryName + "%'";
        }
        if (this.objSalesbyCategory.ProductName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ProductName like '%" + this.objSalesbyCategory.ProductName + "%'";
            else
                this.filterExpression = "ProductName like '%" + this.objSalesbyCategory.ProductName + "%'";
        }
        if (this.objSalesbyCategory.ProductSales) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ProductSales = " + this.objSalesbyCategory.ProductSales;
            else
                this.filterExpression = "ProductSales = " + this.objSalesbyCategory.ProductSales;
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    SalesbyCategorySearchComponent.prototype.getLookups = function () {
    };
    SalesbyCategorySearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], SalesbyCategorySearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], SalesbyCategorySearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], SalesbyCategorySearchComponent.prototype, "display", null);
    SalesbyCategorySearchComponent = __decorate([
        core_1.Component({
            selector: 'SalesbyCategorySearch',
            template: __webpack_require__(1108),
            providers: [SalesbyCategory_service_1.SalesbyCategoryService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof SalesbyCategory_service_1.SalesbyCategoryService !== 'undefined' && SalesbyCategory_service_1.SalesbyCategoryService) === 'function' && _c) || Object])
    ], SalesbyCategorySearchComponent);
    return SalesbyCategorySearchComponent;
    var _a, _b, _c;
}());
exports.SalesbyCategorySearchComponent = SalesbyCategorySearchComponent;


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ShippersAddComponent
 * Purpose		: This component allows to create new Shippers record and save changes.
 * Dependency	: ShippersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Shippers_service_1 = __webpack_require__(46);
var ShippersAddComponent = (function () {
    // Lookup Arrays
    function ShippersAddComponent(route, router, toastr, ShippersService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.ShippersService = ShippersService;
        this.objShippers = new Shippers_service_1.ShippersData();
    }
    Object.defineProperty(ShippersAddComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShippersAddComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    ShippersAddComponent.prototype.ngOnInit = function () {
        this.objShippers = new Shippers_service_1.ShippersData();
        this.getLookups();
    };
    ShippersAddComponent.prototype.addShippers = function () {
        var _this = this;
        this.ShippersService.addShippersData(this.objShippers)
            .subscribe(function (record) { return _this.router.navigate(['/Shippers']); }, function (error) { return _this.errorMessage = 'There was an error while adding record. Error: ' + error; }, function () {
            _this.toastr.success('Shippers record added successfully...', 'Add Shippers');
            console.log('Shippers record added successfully...');
        });
    };
    ShippersAddComponent.prototype.gotoShippers = function () {
        // let Id = this.objShippers ? this.objShippers.ShipperID : null;
        this.router.navigate(['/Shippers']);
    };
    ShippersAddComponent.prototype.getLookups = function () {
    };
    ShippersAddComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], ShippersAddComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], ShippersAddComponent.prototype, "display", null);
    ShippersAddComponent = __decorate([
        core_1.Component({
            selector: 'my-Shippers-add',
            template: __webpack_require__(1109),
            providers: [Shippers_service_1.ShippersService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Shippers_service_1.ShippersService !== 'undefined' && Shippers_service_1.ShippersService) === 'function' && _d) || Object])
    ], ShippersAddComponent);
    return ShippersAddComponent;
    var _a, _b, _c, _d;
}());
exports.ShippersAddComponent = ShippersAddComponent;


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Shippers_service_1 = __webpack_require__(46);
var ShippersDetailsComponent = (function () {
    // Lookup Arrays
    function ShippersDetailsComponent(route, router, toastr, ShippersService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.ShippersService = ShippersService;
        // this.id = parseInt(params.get('id'));
        this.objShippers = new Shippers_service_1.ShippersData();
    }
    Object.defineProperty(ShippersDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShippersDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    ShippersDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.ShippersService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objShippers = item; });
        this.getLookups();
    };
    ShippersDetailsComponent.prototype.deleteShippers = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Shippers?') == true) {
            this.ShippersService.deleteShippers(this.objShippers.ShipperID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/Shippers']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('Shippers record deleted successfully...'); });
        }
    };
    ShippersDetailsComponent.prototype.gotoShippersEdit = function () {
        this.router.navigate(['/Shippers', this.objShippers.ShipperID]);
    };
    ShippersDetailsComponent.prototype.gotoShippers = function () {
        this.router.navigate(['/Shippers']);
    };
    ShippersDetailsComponent.prototype.getLookups = function () {
    };
    ShippersDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], ShippersDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], ShippersDetailsComponent.prototype, "display", null);
    ShippersDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1110),
            providers: [Shippers_service_1.ShippersService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Shippers_service_1.ShippersService !== 'undefined' && Shippers_service_1.ShippersService) === 'function' && _d) || Object])
    ], ShippersDetailsComponent);
    return ShippersDetailsComponent;
    var _a, _b, _c, _d;
}());
exports.ShippersDetailsComponent = ShippersDetailsComponent;


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ShippersEditComponent
 * Purpose		: This component retrieves data for the specified record id and allows to edit and save changes.
 * Dependency	: ShippersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Shippers_service_1 = __webpack_require__(46);
var ShippersEditComponent = (function () {
    // Lookup Arrays
    function ShippersEditComponent(route, router, toastr, ShippersService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.ShippersService = ShippersService;
        // this.id = parseInt(params.get('id'));
        this.objShippers = new Shippers_service_1.ShippersData();
    }
    Object.defineProperty(ShippersEditComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShippersEditComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    ShippersEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.ShippersService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objShippers = item; });
        this.getLookups();
    };
    ShippersEditComponent.prototype.updateShippers = function () {
        var _this = this;
        this.ShippersService.updateShippersData(this.objShippers)
            .subscribe(function (record) { return _this.router.navigate(['/Shippers']); }, function (error) { return _this.errorMessage = 'There was an error while updating record. Error: ' + error; }, function () {
            _this.toastr.success('Shippers record updated successfully...', 'Edit Shippers');
            console.log('Shippers record updated successfully...');
        });
    };
    ShippersEditComponent.prototype.deleteShippers = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Shippers?') == true) {
            this.ShippersService.deleteShippers(this.objShippers.ShipperID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/Shippers']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('Shippers record deleted successfully...', 'Delete Shippers');
                console.log('Shippers record deleted successfully...');
            });
        }
    };
    ShippersEditComponent.prototype.gotoShippers = function () {
        var Id = this.objShippers ? this.objShippers.ShipperID : null;
        this.router.navigate(['/Shippers']);
    };
    ShippersEditComponent.prototype.getLookups = function () {
    };
    ShippersEditComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], ShippersEditComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], ShippersEditComponent.prototype, "display", null);
    ShippersEditComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1111),
            providers: [Shippers_service_1.ShippersService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Shippers_service_1.ShippersService !== 'undefined' && Shippers_service_1.ShippersService) === 'function' && _d) || Object])
    ], ShippersEditComponent);
    return ShippersEditComponent;
    var _a, _b, _c, _d;
}());
exports.ShippersEditComponent = ShippersEditComponent;


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ShippersListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: ShippersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var Shippers_service_1 = __webpack_require__(46);
var ShippersSearch_component_1 = __webpack_require__(458);
var ShippersListComponent = (function () {
    function ShippersListComponent(ShippersService, route, router, toastr) {
        this.ShippersService = ShippersService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "ShipperID";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newShippers = new Shippers_service_1.ShippersData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(ShippersListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShippersListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    ShippersListComponent.prototype.ngOnInit = function () {
        //this.ShippersService.getAll().subscribe(record => this.ShippersList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getShippersByPaging();
        /*
        this.ShippersList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    ShippersListComponent.prototype.getShippers = function () {
        var _this = this;
        this.ShippersService.getAll()
            .subscribe(function (data) { return _this.ShippersList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on ShippersSearch Component
    ShippersListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getShippersByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getShippersByPaging();
    };
    ShippersListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getShippersByPaging();
    };
    // Get records by paging
    ShippersListComponent.prototype.getShippersByPaging = function () {
        var _this = this;
        this.ShippersService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.ShippersList = data.ShippersList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    ShippersListComponent.prototype.addShippers = function () {
        this.ShippersService.addShippersData(this.newShippers).subscribe(function (record) { return console.log(record); });
        this.getShippers();
    };
    // Updates existing record
    ShippersListComponent.prototype.updateShippers = function () {
        this.ShippersService.updateShippersData(this.selectedShippers).subscribe(function (record) { return console.log(record); });
        this.getShippers();
    };
    // Deletes record with specified id
    ShippersListComponent.prototype.deleteShippers = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Shippers?') == true) {
            this.ShippersService.deleteShippers(id)
                .subscribe(function (data) { return _this.getShippers(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('Shippers record deleted successfully...', 'Delete Shippers');
                console.log('Shippers record deleted successfully...');
            });
        }
    };
    // Go to First Page
    ShippersListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getShippersByPaging();
    };
    // Go to Previous Page
    ShippersListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getShippersByPaging();
        }
    };
    // Refresh - Go to First Page
    ShippersListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // Go to Next Page
    ShippersListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getShippersByPaging();
        }
    };
    // Go to Last Page
    ShippersListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getShippersByPaging();
    };
    // On Edit - Go to Edit page
    ShippersListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/Shippers', item.ShipperID]);
    };
    // On Details - Go to Details page
    ShippersListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/Shippers/Details', item.ShipperID]);
    };
    // Set record as selected
    ShippersListComponent.prototype.SelectShippers = function (item) {
        this.selectedShippers = item;
    };
    // Submits form
    ShippersListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    ShippersListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], ShippersListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], ShippersListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(ShippersSearch_component_1.ShippersSearchComponent), 
        __metadata('design:type', (typeof (_a = typeof ShippersSearch_component_1.ShippersSearchComponent !== 'undefined' && ShippersSearch_component_1.ShippersSearchComponent) === 'function' && _a) || Object)
    ], ShippersListComponent.prototype, "filterComponent", void 0);
    ShippersListComponent = __decorate([
        core_1.Component({
            selector: 'my-Shippers',
            template: __webpack_require__(1112),
            providers: [Shippers_service_1.ShippersService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof Shippers_service_1.ShippersService !== 'undefined' && Shippers_service_1.ShippersService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], ShippersListComponent);
    return ShippersListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.ShippersListComponent = ShippersListComponent;


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ShippersSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: ShippersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var Shippers_service_1 = __webpack_require__(46);
var ShippersSearchComponent = (function () {
    // Lookup Arrays
    function ShippersSearchComponent(route, router, ShippersService) {
        this.route = route;
        this.router = router;
        this.ShippersService = ShippersService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objShippers = new Shippers_service_1.ShippersData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(ShippersSearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShippersSearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    ShippersSearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    ShippersSearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objShippers = new Shippers_service_1.ShippersData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    ShippersSearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    ShippersSearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objShippers.ShipperID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ShipperID = " + this.objShippers.ShipperID;
            else
                this.filterExpression = "ShipperID = " + this.objShippers.ShipperID;
        }
        if (this.objShippers.CompanyName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CompanyName like '%" + this.objShippers.CompanyName + "%'";
            else
                this.filterExpression = "CompanyName like '%" + this.objShippers.CompanyName + "%'";
        }
        if (this.objShippers.Phone) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Phone like '%" + this.objShippers.Phone + "%'";
            else
                this.filterExpression = "Phone like '%" + this.objShippers.Phone + "%'";
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    ShippersSearchComponent.prototype.getLookups = function () {
    };
    ShippersSearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], ShippersSearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], ShippersSearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], ShippersSearchComponent.prototype, "display", null);
    ShippersSearchComponent = __decorate([
        core_1.Component({
            selector: 'ShippersSearch',
            template: __webpack_require__(1113),
            providers: [Shippers_service_1.ShippersService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof Shippers_service_1.ShippersService !== 'undefined' && Shippers_service_1.ShippersService) === 'function' && _c) || Object])
    ], ShippersSearchComponent);
    return ShippersSearchComponent;
    var _a, _b, _c;
}());
exports.ShippersSearchComponent = ShippersSearchComponent;


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SummaryofSalesbyQuarterAddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: SummaryofSalesbyQuarterService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var SummaryofSalesbyQuarter_service_1 = __webpack_require__(154);
var SummaryofSalesbyQuarterDetailsComponent = (function () {
    // Lookup Arrays
    function SummaryofSalesbyQuarterDetailsComponent(route, router, toastr, SummaryofSalesbyQuarterService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.SummaryofSalesbyQuarterService = SummaryofSalesbyQuarterService;
        // this.id = parseInt(params.get('id'));
        this.objSummaryofSalesbyQuarter = new SummaryofSalesbyQuarter_service_1.SummaryofSalesbyQuarterData();
    }
    Object.defineProperty(SummaryofSalesbyQuarterDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryofSalesbyQuarterDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    SummaryofSalesbyQuarterDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.SummaryofSalesbyQuarterService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objSummaryofSalesbyQuarter = item; });
        this.getLookups();
    };
    SummaryofSalesbyQuarterDetailsComponent.prototype.deleteSummaryofSalesbyQuarter = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this SummaryofSalesbyQuarter?') == true) {
            this.SummaryofSalesbyQuarterService.deleteSummaryofSalesbyQuarter(this.objSummaryofSalesbyQuarter.ShippedDate.toString())
                .subscribe(function (record) { return _this.router.navigate(['/SummaryofSalesbyQuarter']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('SummaryofSalesbyQuarter record deleted successfully...'); });
        }
    };
    SummaryofSalesbyQuarterDetailsComponent.prototype.gotoSummaryofSalesbyQuarterEdit = function () {
        this.router.navigate(['/SummaryofSalesbyQuarter', this.objSummaryofSalesbyQuarter.ShippedDate]);
    };
    SummaryofSalesbyQuarterDetailsComponent.prototype.gotoSummaryofSalesbyQuarter = function () {
        this.router.navigate(['/SummaryofSalesbyQuarter']);
    };
    SummaryofSalesbyQuarterDetailsComponent.prototype.getLookups = function () {
    };
    SummaryofSalesbyQuarterDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], SummaryofSalesbyQuarterDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], SummaryofSalesbyQuarterDetailsComponent.prototype, "display", null);
    SummaryofSalesbyQuarterDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1114),
            providers: [SummaryofSalesbyQuarter_service_1.SummaryofSalesbyQuarterService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof SummaryofSalesbyQuarter_service_1.SummaryofSalesbyQuarterService !== 'undefined' && SummaryofSalesbyQuarter_service_1.SummaryofSalesbyQuarterService) === 'function' && _d) || Object])
    ], SummaryofSalesbyQuarterDetailsComponent);
    return SummaryofSalesbyQuarterDetailsComponent;
    var _a, _b, _c, _d;
}());
exports.SummaryofSalesbyQuarterDetailsComponent = SummaryofSalesbyQuarterDetailsComponent;


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SummaryofSalesbyQuarterListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: SummaryofSalesbyQuarterService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var SummaryofSalesbyQuarter_service_1 = __webpack_require__(154);
var SummaryofSalesbyQuarterSearch_component_1 = __webpack_require__(461);
var SummaryofSalesbyQuarterListComponent = (function () {
    function SummaryofSalesbyQuarterListComponent(SummaryofSalesbyQuarterService, route, router, toastr) {
        this.SummaryofSalesbyQuarterService = SummaryofSalesbyQuarterService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "ShippedDate";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newSummaryofSalesbyQuarter = new SummaryofSalesbyQuarter_service_1.SummaryofSalesbyQuarterData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(SummaryofSalesbyQuarterListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryofSalesbyQuarterListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    SummaryofSalesbyQuarterListComponent.prototype.ngOnInit = function () {
        // this.SummaryofSalesbyQuarterService.getAll().subscribe(record => this.SummaryofSalesbyQuarterList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getSummaryofSalesbyQuarterByPaging();
        /*
        this.SummaryofSalesbyQuarterList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    SummaryofSalesbyQuarterListComponent.prototype.getSummaryofSalesbyQuarter = function () {
        var _this = this;
        this.SummaryofSalesbyQuarterService.getAll()
            .subscribe(function (data) { return _this.SummaryofSalesbyQuarterList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on SummaryofSalesbyQuarterSearch Component
    SummaryofSalesbyQuarterListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getSummaryofSalesbyQuarterByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getSummaryofSalesbyQuarterByPaging();
    };
    SummaryofSalesbyQuarterListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getSummaryofSalesbyQuarterByPaging();
    };
    // Get records by paging
    SummaryofSalesbyQuarterListComponent.prototype.getSummaryofSalesbyQuarterByPaging = function () {
        var _this = this;
        this.SummaryofSalesbyQuarterService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.SummaryofSalesbyQuarterList = data.SummaryofSalesbyQuarterList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    SummaryofSalesbyQuarterListComponent.prototype.addSummaryofSalesbyQuarter = function () {
        this.SummaryofSalesbyQuarterService.addSummaryofSalesbyQuarterData(this.newSummaryofSalesbyQuarter).subscribe(function (record) { return console.log(record); });
        this.getSummaryofSalesbyQuarter();
    };
    // Updates existing record
    SummaryofSalesbyQuarterListComponent.prototype.updateSummaryofSalesbyQuarter = function () {
        this.SummaryofSalesbyQuarterService.updateSummaryofSalesbyQuarterData(this.selectedSummaryofSalesbyQuarter).subscribe(function (record) { return console.log(record); });
        this.getSummaryofSalesbyQuarter();
    };
    // Deletes record with specified id
    SummaryofSalesbyQuarterListComponent.prototype.deleteSummaryofSalesbyQuarter = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this SummaryofSalesbyQuarter?') == true) {
            this.SummaryofSalesbyQuarterService.deleteSummaryofSalesbyQuarter(id)
                .subscribe(function (data) { return _this.getSummaryofSalesbyQuarter(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; });
        }
    };
    // Go to First Page
    SummaryofSalesbyQuarterListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getSummaryofSalesbyQuarterByPaging();
    };
    // Go to Previous Page
    SummaryofSalesbyQuarterListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getSummaryofSalesbyQuarterByPaging();
        }
    };
    // Go to Next Page
    SummaryofSalesbyQuarterListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getSummaryofSalesbyQuarterByPaging();
        }
    };
    // Go to Last Page
    SummaryofSalesbyQuarterListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getSummaryofSalesbyQuarterByPaging();
    };
    // Refresh - Go to First Page
    SummaryofSalesbyQuarterListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // On Edit - Go to Edit page
    SummaryofSalesbyQuarterListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/SummaryofSalesbyQuarter', item.ShippedDate]);
    };
    // On Details - Go to Details page
    SummaryofSalesbyQuarterListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/SummaryofSalesbyQuarter/Details', item.ShippedDate]);
    };
    // Set record as selected
    SummaryofSalesbyQuarterListComponent.prototype.SelectSummaryofSalesbyQuarter = function (item) {
        this.selectedSummaryofSalesbyQuarter = item;
    };
    // Submits form
    SummaryofSalesbyQuarterListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    SummaryofSalesbyQuarterListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], SummaryofSalesbyQuarterListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], SummaryofSalesbyQuarterListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(SummaryofSalesbyQuarterSearch_component_1.SummaryofSalesbyQuarterSearchComponent), 
        __metadata('design:type', (typeof (_a = typeof SummaryofSalesbyQuarterSearch_component_1.SummaryofSalesbyQuarterSearchComponent !== 'undefined' && SummaryofSalesbyQuarterSearch_component_1.SummaryofSalesbyQuarterSearchComponent) === 'function' && _a) || Object)
    ], SummaryofSalesbyQuarterListComponent.prototype, "filterComponent", void 0);
    SummaryofSalesbyQuarterListComponent = __decorate([
        core_1.Component({
            selector: 'my-SummaryofSalesbyQuarter',
            template: __webpack_require__(1115),
            providers: [SummaryofSalesbyQuarter_service_1.SummaryofSalesbyQuarterService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof SummaryofSalesbyQuarter_service_1.SummaryofSalesbyQuarterService !== 'undefined' && SummaryofSalesbyQuarter_service_1.SummaryofSalesbyQuarterService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], SummaryofSalesbyQuarterListComponent);
    return SummaryofSalesbyQuarterListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.SummaryofSalesbyQuarterListComponent = SummaryofSalesbyQuarterListComponent;


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SummaryofSalesbyQuarterSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: SummaryofSalesbyQuarterService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var SummaryofSalesbyQuarter_service_1 = __webpack_require__(154);
var SummaryofSalesbyQuarterSearchComponent = (function () {
    // Lookup Arrays
    function SummaryofSalesbyQuarterSearchComponent(route, router, SummaryofSalesbyQuarterService) {
        this.route = route;
        this.router = router;
        this.SummaryofSalesbyQuarterService = SummaryofSalesbyQuarterService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objSummaryofSalesbyQuarter = new SummaryofSalesbyQuarter_service_1.SummaryofSalesbyQuarterData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(SummaryofSalesbyQuarterSearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryofSalesbyQuarterSearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    SummaryofSalesbyQuarterSearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    SummaryofSalesbyQuarterSearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objSummaryofSalesbyQuarter = new SummaryofSalesbyQuarter_service_1.SummaryofSalesbyQuarterData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    SummaryofSalesbyQuarterSearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    SummaryofSalesbyQuarterSearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objSummaryofSalesbyQuarter.OrderID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND OrderID = " + this.objSummaryofSalesbyQuarter.OrderID;
            else
                this.filterExpression = "OrderID = " + this.objSummaryofSalesbyQuarter.OrderID;
        }
        if (this.objSummaryofSalesbyQuarter.Subtotal) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Subtotal = " + this.objSummaryofSalesbyQuarter.Subtotal;
            else
                this.filterExpression = "Subtotal = " + this.objSummaryofSalesbyQuarter.Subtotal;
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    SummaryofSalesbyQuarterSearchComponent.prototype.getLookups = function () {
    };
    SummaryofSalesbyQuarterSearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], SummaryofSalesbyQuarterSearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], SummaryofSalesbyQuarterSearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], SummaryofSalesbyQuarterSearchComponent.prototype, "display", null);
    SummaryofSalesbyQuarterSearchComponent = __decorate([
        core_1.Component({
            selector: 'SummaryofSalesbyQuarterSearch',
            template: __webpack_require__(1116),
            providers: [SummaryofSalesbyQuarter_service_1.SummaryofSalesbyQuarterService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof SummaryofSalesbyQuarter_service_1.SummaryofSalesbyQuarterService !== 'undefined' && SummaryofSalesbyQuarter_service_1.SummaryofSalesbyQuarterService) === 'function' && _c) || Object])
    ], SummaryofSalesbyQuarterSearchComponent);
    return SummaryofSalesbyQuarterSearchComponent;
    var _a, _b, _c;
}());
exports.SummaryofSalesbyQuarterSearchComponent = SummaryofSalesbyQuarterSearchComponent;


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SummaryofSalesbyYearAddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: SummaryofSalesbyYearService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var SummaryofSalesbyYear_service_1 = __webpack_require__(155);
var SummaryofSalesbyYearDetailsComponent = (function () {
    // Lookup Arrays
    function SummaryofSalesbyYearDetailsComponent(route, router, toastr, SummaryofSalesbyYearService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.SummaryofSalesbyYearService = SummaryofSalesbyYearService;
        // this.id = parseInt(params.get('id'));
        this.objSummaryofSalesbyYear = new SummaryofSalesbyYear_service_1.SummaryofSalesbyYearData();
    }
    Object.defineProperty(SummaryofSalesbyYearDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryofSalesbyYearDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    SummaryofSalesbyYearDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.SummaryofSalesbyYearService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objSummaryofSalesbyYear = item; });
        this.getLookups();
    };
    SummaryofSalesbyYearDetailsComponent.prototype.deleteSummaryofSalesbyYear = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this SummaryofSalesbyYear?') == true) {
            this.SummaryofSalesbyYearService.deleteSummaryofSalesbyYear(this.objSummaryofSalesbyYear.ShippedDate.toString())
                .subscribe(function (record) { return _this.router.navigate(['/SummaryofSalesbyYear']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('SummaryofSalesbyYear record deleted successfully...'); });
        }
    };
    SummaryofSalesbyYearDetailsComponent.prototype.gotoSummaryofSalesbyYearEdit = function () {
        this.router.navigate(['/SummaryofSalesbyYear', this.objSummaryofSalesbyYear.ShippedDate]);
    };
    SummaryofSalesbyYearDetailsComponent.prototype.gotoSummaryofSalesbyYear = function () {
        this.router.navigate(['/SummaryofSalesbyYear']);
    };
    SummaryofSalesbyYearDetailsComponent.prototype.getLookups = function () {
    };
    SummaryofSalesbyYearDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], SummaryofSalesbyYearDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], SummaryofSalesbyYearDetailsComponent.prototype, "display", null);
    SummaryofSalesbyYearDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1117),
            providers: [SummaryofSalesbyYear_service_1.SummaryofSalesbyYearService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof SummaryofSalesbyYear_service_1.SummaryofSalesbyYearService !== 'undefined' && SummaryofSalesbyYear_service_1.SummaryofSalesbyYearService) === 'function' && _d) || Object])
    ], SummaryofSalesbyYearDetailsComponent);
    return SummaryofSalesbyYearDetailsComponent;
    var _a, _b, _c, _d;
}());
exports.SummaryofSalesbyYearDetailsComponent = SummaryofSalesbyYearDetailsComponent;


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SummaryofSalesbyYearListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: SummaryofSalesbyYearService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var SummaryofSalesbyYear_service_1 = __webpack_require__(155);
var SummaryofSalesbyYearSearch_component_1 = __webpack_require__(464);
var SummaryofSalesbyYearListComponent = (function () {
    function SummaryofSalesbyYearListComponent(SummaryofSalesbyYearService, route, router, toastr) {
        this.SummaryofSalesbyYearService = SummaryofSalesbyYearService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "ShippedDate";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newSummaryofSalesbyYear = new SummaryofSalesbyYear_service_1.SummaryofSalesbyYearData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(SummaryofSalesbyYearListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryofSalesbyYearListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    SummaryofSalesbyYearListComponent.prototype.ngOnInit = function () {
        // this.SummaryofSalesbyYearService.getAll().subscribe(record => this.SummaryofSalesbyYearList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getSummaryofSalesbyYearByPaging();
        /*
        this.SummaryofSalesbyYearList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    SummaryofSalesbyYearListComponent.prototype.getSummaryofSalesbyYear = function () {
        var _this = this;
        this.SummaryofSalesbyYearService.getAll()
            .subscribe(function (data) { return _this.SummaryofSalesbyYearList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on SummaryofSalesbyYearSearch Component
    SummaryofSalesbyYearListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getSummaryofSalesbyYearByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getSummaryofSalesbyYearByPaging();
    };
    SummaryofSalesbyYearListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getSummaryofSalesbyYearByPaging();
    };
    // Get records by paging
    SummaryofSalesbyYearListComponent.prototype.getSummaryofSalesbyYearByPaging = function () {
        var _this = this;
        this.SummaryofSalesbyYearService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.SummaryofSalesbyYearList = data.SummaryofSalesbyYearList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    SummaryofSalesbyYearListComponent.prototype.addSummaryofSalesbyYear = function () {
        this.SummaryofSalesbyYearService.addSummaryofSalesbyYearData(this.newSummaryofSalesbyYear).subscribe(function (record) { return console.log(record); });
        this.getSummaryofSalesbyYear();
    };
    // Updates existing record
    SummaryofSalesbyYearListComponent.prototype.updateSummaryofSalesbyYear = function () {
        this.SummaryofSalesbyYearService.updateSummaryofSalesbyYearData(this.selectedSummaryofSalesbyYear).subscribe(function (record) { return console.log(record); });
        this.getSummaryofSalesbyYear();
    };
    // Deletes record with specified id
    SummaryofSalesbyYearListComponent.prototype.deleteSummaryofSalesbyYear = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this SummaryofSalesbyYear?') == true) {
            this.SummaryofSalesbyYearService.deleteSummaryofSalesbyYear(id)
                .subscribe(function (data) { return _this.getSummaryofSalesbyYear(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; });
        }
    };
    // Go to First Page
    SummaryofSalesbyYearListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getSummaryofSalesbyYearByPaging();
    };
    // Go to Previous Page
    SummaryofSalesbyYearListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getSummaryofSalesbyYearByPaging();
        }
    };
    // Go to Next Page
    SummaryofSalesbyYearListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getSummaryofSalesbyYearByPaging();
        }
    };
    // Go to Last Page
    SummaryofSalesbyYearListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getSummaryofSalesbyYearByPaging();
    };
    // Refresh - Go to First Page
    SummaryofSalesbyYearListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // On Edit - Go to Edit page
    SummaryofSalesbyYearListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/SummaryofSalesbyYear', item.ShippedDate]);
    };
    // On Details - Go to Details page
    SummaryofSalesbyYearListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/SummaryofSalesbyYear/Details', item.ShippedDate]);
    };
    // Set record as selected
    SummaryofSalesbyYearListComponent.prototype.SelectSummaryofSalesbyYear = function (item) {
        this.selectedSummaryofSalesbyYear = item;
    };
    // Submits form
    SummaryofSalesbyYearListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    SummaryofSalesbyYearListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], SummaryofSalesbyYearListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], SummaryofSalesbyYearListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(SummaryofSalesbyYearSearch_component_1.SummaryofSalesbyYearSearchComponent), 
        __metadata('design:type', (typeof (_a = typeof SummaryofSalesbyYearSearch_component_1.SummaryofSalesbyYearSearchComponent !== 'undefined' && SummaryofSalesbyYearSearch_component_1.SummaryofSalesbyYearSearchComponent) === 'function' && _a) || Object)
    ], SummaryofSalesbyYearListComponent.prototype, "filterComponent", void 0);
    SummaryofSalesbyYearListComponent = __decorate([
        core_1.Component({
            selector: 'my-SummaryofSalesbyYear',
            template: __webpack_require__(1118),
            providers: [SummaryofSalesbyYear_service_1.SummaryofSalesbyYearService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof SummaryofSalesbyYear_service_1.SummaryofSalesbyYearService !== 'undefined' && SummaryofSalesbyYear_service_1.SummaryofSalesbyYearService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], SummaryofSalesbyYearListComponent);
    return SummaryofSalesbyYearListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.SummaryofSalesbyYearListComponent = SummaryofSalesbyYearListComponent;


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SummaryofSalesbyYearSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: SummaryofSalesbyYearService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var SummaryofSalesbyYear_service_1 = __webpack_require__(155);
var SummaryofSalesbyYearSearchComponent = (function () {
    // Lookup Arrays
    function SummaryofSalesbyYearSearchComponent(route, router, SummaryofSalesbyYearService) {
        this.route = route;
        this.router = router;
        this.SummaryofSalesbyYearService = SummaryofSalesbyYearService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objSummaryofSalesbyYear = new SummaryofSalesbyYear_service_1.SummaryofSalesbyYearData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(SummaryofSalesbyYearSearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryofSalesbyYearSearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    SummaryofSalesbyYearSearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    SummaryofSalesbyYearSearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objSummaryofSalesbyYear = new SummaryofSalesbyYear_service_1.SummaryofSalesbyYearData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    SummaryofSalesbyYearSearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    SummaryofSalesbyYearSearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objSummaryofSalesbyYear.OrderID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND OrderID = " + this.objSummaryofSalesbyYear.OrderID;
            else
                this.filterExpression = "OrderID = " + this.objSummaryofSalesbyYear.OrderID;
        }
        if (this.objSummaryofSalesbyYear.Subtotal) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Subtotal = " + this.objSummaryofSalesbyYear.Subtotal;
            else
                this.filterExpression = "Subtotal = " + this.objSummaryofSalesbyYear.Subtotal;
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    SummaryofSalesbyYearSearchComponent.prototype.getLookups = function () {
    };
    SummaryofSalesbyYearSearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], SummaryofSalesbyYearSearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], SummaryofSalesbyYearSearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], SummaryofSalesbyYearSearchComponent.prototype, "display", null);
    SummaryofSalesbyYearSearchComponent = __decorate([
        core_1.Component({
            selector: 'SummaryofSalesbyYearSearch',
            template: __webpack_require__(1119),
            providers: [SummaryofSalesbyYear_service_1.SummaryofSalesbyYearService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof SummaryofSalesbyYear_service_1.SummaryofSalesbyYearService !== 'undefined' && SummaryofSalesbyYear_service_1.SummaryofSalesbyYearService) === 'function' && _c) || Object])
    ], SummaryofSalesbyYearSearchComponent);
    return SummaryofSalesbyYearSearchComponent;
    var _a, _b, _c;
}());
exports.SummaryofSalesbyYearSearchComponent = SummaryofSalesbyYearSearchComponent;


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SuppliersAddComponent
 * Purpose		: This component allows to create new Suppliers record and save changes.
 * Dependency	: SuppliersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Suppliers_service_1 = __webpack_require__(47);
var SuppliersAddComponent = (function () {
    // Lookup Arrays
    function SuppliersAddComponent(route, router, toastr, SuppliersService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.SuppliersService = SuppliersService;
        this.objSuppliers = new Suppliers_service_1.SuppliersData();
    }
    Object.defineProperty(SuppliersAddComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SuppliersAddComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    SuppliersAddComponent.prototype.ngOnInit = function () {
        this.objSuppliers = new Suppliers_service_1.SuppliersData();
        this.getLookups();
    };
    SuppliersAddComponent.prototype.addSuppliers = function () {
        var _this = this;
        this.SuppliersService.addSuppliersData(this.objSuppliers)
            .subscribe(function (record) { return _this.router.navigate(['/Suppliers']); }, function (error) { return _this.errorMessage = 'There was an error while adding record. Error: ' + error; }, function () {
            _this.toastr.success('Suppliers record added successfully...', 'Add Suppliers');
            console.log('Suppliers record added successfully...');
        });
    };
    SuppliersAddComponent.prototype.gotoSuppliers = function () {
        // let Id = this.objSuppliers ? this.objSuppliers.SupplierID : null;
        this.router.navigate(['/Suppliers']);
    };
    SuppliersAddComponent.prototype.getLookups = function () {
    };
    SuppliersAddComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], SuppliersAddComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], SuppliersAddComponent.prototype, "display", null);
    SuppliersAddComponent = __decorate([
        core_1.Component({
            selector: 'my-Suppliers-add',
            template: __webpack_require__(1120),
            providers: [Suppliers_service_1.SuppliersService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Suppliers_service_1.SuppliersService !== 'undefined' && Suppliers_service_1.SuppliersService) === 'function' && _d) || Object])
    ], SuppliersAddComponent);
    return SuppliersAddComponent;
    var _a, _b, _c, _d;
}());
exports.SuppliersAddComponent = SuppliersAddComponent;


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Suppliers_service_1 = __webpack_require__(47);
var SuppliersDetailsComponent = (function () {
    // Lookup Arrays
    function SuppliersDetailsComponent(route, router, toastr, SuppliersService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.SuppliersService = SuppliersService;
        // this.id = parseInt(params.get('id'));
        this.objSuppliers = new Suppliers_service_1.SuppliersData();
    }
    Object.defineProperty(SuppliersDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SuppliersDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    SuppliersDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.SuppliersService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objSuppliers = item; });
        this.getLookups();
    };
    SuppliersDetailsComponent.prototype.deleteSuppliers = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Suppliers?') == true) {
            this.SuppliersService.deleteSuppliers(this.objSuppliers.SupplierID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/Suppliers']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('Suppliers record deleted successfully...'); });
        }
    };
    SuppliersDetailsComponent.prototype.gotoSuppliersEdit = function () {
        this.router.navigate(['/Suppliers', this.objSuppliers.SupplierID]);
    };
    SuppliersDetailsComponent.prototype.gotoSuppliers = function () {
        this.router.navigate(['/Suppliers']);
    };
    SuppliersDetailsComponent.prototype.getLookups = function () {
    };
    SuppliersDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], SuppliersDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], SuppliersDetailsComponent.prototype, "display", null);
    SuppliersDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1121),
            providers: [Suppliers_service_1.SuppliersService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Suppliers_service_1.SuppliersService !== 'undefined' && Suppliers_service_1.SuppliersService) === 'function' && _d) || Object])
    ], SuppliersDetailsComponent);
    return SuppliersDetailsComponent;
    var _a, _b, _c, _d;
}());
exports.SuppliersDetailsComponent = SuppliersDetailsComponent;


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SuppliersEditComponent
 * Purpose		: This component retrieves data for the specified record id and allows to edit and save changes.
 * Dependency	: SuppliersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Suppliers_service_1 = __webpack_require__(47);
var SuppliersEditComponent = (function () {
    // Lookup Arrays
    function SuppliersEditComponent(route, router, toastr, SuppliersService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.SuppliersService = SuppliersService;
        // this.id = parseInt(params.get('id'));
        this.objSuppliers = new Suppliers_service_1.SuppliersData();
    }
    Object.defineProperty(SuppliersEditComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SuppliersEditComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    SuppliersEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.SuppliersService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objSuppliers = item; });
        this.getLookups();
    };
    SuppliersEditComponent.prototype.updateSuppliers = function () {
        var _this = this;
        this.SuppliersService.updateSuppliersData(this.objSuppliers)
            .subscribe(function (record) { return _this.router.navigate(['/Suppliers']); }, function (error) { return _this.errorMessage = 'There was an error while updating record. Error: ' + error; }, function () {
            _this.toastr.success('Suppliers record updated successfully...', 'Edit Suppliers');
            console.log('Suppliers record updated successfully...');
        });
    };
    SuppliersEditComponent.prototype.deleteSuppliers = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Suppliers?') == true) {
            this.SuppliersService.deleteSuppliers(this.objSuppliers.SupplierID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/Suppliers']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('Suppliers record deleted successfully...', 'Delete Suppliers');
                console.log('Suppliers record deleted successfully...');
            });
        }
    };
    SuppliersEditComponent.prototype.gotoSuppliers = function () {
        var Id = this.objSuppliers ? this.objSuppliers.SupplierID : null;
        this.router.navigate(['/Suppliers']);
    };
    SuppliersEditComponent.prototype.getLookups = function () {
    };
    SuppliersEditComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], SuppliersEditComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], SuppliersEditComponent.prototype, "display", null);
    SuppliersEditComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1122),
            providers: [Suppliers_service_1.SuppliersService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Suppliers_service_1.SuppliersService !== 'undefined' && Suppliers_service_1.SuppliersService) === 'function' && _d) || Object])
    ], SuppliersEditComponent);
    return SuppliersEditComponent;
    var _a, _b, _c, _d;
}());
exports.SuppliersEditComponent = SuppliersEditComponent;


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SuppliersListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: SuppliersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var Suppliers_service_1 = __webpack_require__(47);
var SuppliersSearch_component_1 = __webpack_require__(469);
var SuppliersListComponent = (function () {
    function SuppliersListComponent(SuppliersService, route, router, toastr) {
        this.SuppliersService = SuppliersService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "SupplierID";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newSuppliers = new Suppliers_service_1.SuppliersData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(SuppliersListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SuppliersListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    SuppliersListComponent.prototype.ngOnInit = function () {
        //this.SuppliersService.getAll().subscribe(record => this.SuppliersList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getSuppliersByPaging();
        /*
        this.SuppliersList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    SuppliersListComponent.prototype.getSuppliers = function () {
        var _this = this;
        this.SuppliersService.getAll()
            .subscribe(function (data) { return _this.SuppliersList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on SuppliersSearch Component
    SuppliersListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getSuppliersByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getSuppliersByPaging();
    };
    SuppliersListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getSuppliersByPaging();
    };
    // Get records by paging
    SuppliersListComponent.prototype.getSuppliersByPaging = function () {
        var _this = this;
        this.SuppliersService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.SuppliersList = data.SuppliersList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    SuppliersListComponent.prototype.addSuppliers = function () {
        this.SuppliersService.addSuppliersData(this.newSuppliers).subscribe(function (record) { return console.log(record); });
        this.getSuppliers();
    };
    // Updates existing record
    SuppliersListComponent.prototype.updateSuppliers = function () {
        this.SuppliersService.updateSuppliersData(this.selectedSuppliers).subscribe(function (record) { return console.log(record); });
        this.getSuppliers();
    };
    // Deletes record with specified id
    SuppliersListComponent.prototype.deleteSuppliers = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Suppliers?') == true) {
            this.SuppliersService.deleteSuppliers(id)
                .subscribe(function (data) { return _this.getSuppliers(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('Suppliers record deleted successfully...', 'Delete Suppliers');
                console.log('Suppliers record deleted successfully...');
            });
        }
    };
    // Go to First Page
    SuppliersListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getSuppliersByPaging();
    };
    // Go to Previous Page
    SuppliersListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getSuppliersByPaging();
        }
    };
    // Refresh - Go to First Page
    SuppliersListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // Go to Next Page
    SuppliersListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getSuppliersByPaging();
        }
    };
    // Go to Last Page
    SuppliersListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getSuppliersByPaging();
    };
    // On Edit - Go to Edit page
    SuppliersListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/Suppliers', item.SupplierID]);
    };
    // On Details - Go to Details page
    SuppliersListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/Suppliers/Details', item.SupplierID]);
    };
    // Set record as selected
    SuppliersListComponent.prototype.SelectSuppliers = function (item) {
        this.selectedSuppliers = item;
    };
    // Submits form
    SuppliersListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    SuppliersListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], SuppliersListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], SuppliersListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(SuppliersSearch_component_1.SuppliersSearchComponent), 
        __metadata('design:type', (typeof (_a = typeof SuppliersSearch_component_1.SuppliersSearchComponent !== 'undefined' && SuppliersSearch_component_1.SuppliersSearchComponent) === 'function' && _a) || Object)
    ], SuppliersListComponent.prototype, "filterComponent", void 0);
    SuppliersListComponent = __decorate([
        core_1.Component({
            selector: 'my-Suppliers',
            template: __webpack_require__(1123),
            providers: [Suppliers_service_1.SuppliersService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof Suppliers_service_1.SuppliersService !== 'undefined' && Suppliers_service_1.SuppliersService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], SuppliersListComponent);
    return SuppliersListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.SuppliersListComponent = SuppliersListComponent;


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SuppliersSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: SuppliersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var Suppliers_service_1 = __webpack_require__(47);
var SuppliersSearchComponent = (function () {
    // Lookup Arrays
    function SuppliersSearchComponent(route, router, SuppliersService) {
        this.route = route;
        this.router = router;
        this.SuppliersService = SuppliersService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objSuppliers = new Suppliers_service_1.SuppliersData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(SuppliersSearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SuppliersSearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    SuppliersSearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    SuppliersSearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objSuppliers = new Suppliers_service_1.SuppliersData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    SuppliersSearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    SuppliersSearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objSuppliers.SupplierID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objSuppliers.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objSuppliers.SupplierID;
        }
        if (this.objSuppliers.CompanyName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CompanyName like '%" + this.objSuppliers.CompanyName + "%'";
            else
                this.filterExpression = "CompanyName like '%" + this.objSuppliers.CompanyName + "%'";
        }
        if (this.objSuppliers.ContactName) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ContactName like '%" + this.objSuppliers.ContactName + "%'";
            else
                this.filterExpression = "ContactName like '%" + this.objSuppliers.ContactName + "%'";
        }
        if (this.objSuppliers.ContactTitle) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND ContactTitle like '%" + this.objSuppliers.ContactTitle + "%'";
            else
                this.filterExpression = "ContactTitle like '%" + this.objSuppliers.ContactTitle + "%'";
        }
        if (this.objSuppliers.Address) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Address like '%" + this.objSuppliers.Address + "%'";
            else
                this.filterExpression = "Address like '%" + this.objSuppliers.Address + "%'";
        }
        if (this.objSuppliers.City) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND City like '%" + this.objSuppliers.City + "%'";
            else
                this.filterExpression = "City like '%" + this.objSuppliers.City + "%'";
        }
        if (this.objSuppliers.Region) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Region like '%" + this.objSuppliers.Region + "%'";
            else
                this.filterExpression = "Region like '%" + this.objSuppliers.Region + "%'";
        }
        if (this.objSuppliers.PostalCode) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND PostalCode like '%" + this.objSuppliers.PostalCode + "%'";
            else
                this.filterExpression = "PostalCode like '%" + this.objSuppliers.PostalCode + "%'";
        }
        if (this.objSuppliers.Country) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Country like '%" + this.objSuppliers.Country + "%'";
            else
                this.filterExpression = "Country like '%" + this.objSuppliers.Country + "%'";
        }
        if (this.objSuppliers.Phone) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Phone like '%" + this.objSuppliers.Phone + "%'";
            else
                this.filterExpression = "Phone like '%" + this.objSuppliers.Phone + "%'";
        }
        if (this.objSuppliers.Fax) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND Fax like '%" + this.objSuppliers.Fax + "%'";
            else
                this.filterExpression = "Fax like '%" + this.objSuppliers.Fax + "%'";
        }
        if (this.objSuppliers.HomePage) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND HomePage like '%" + this.objSuppliers.HomePage + "%'";
            else
                this.filterExpression = "HomePage like '%" + this.objSuppliers.HomePage + "%'";
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    SuppliersSearchComponent.prototype.getLookups = function () {
    };
    SuppliersSearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], SuppliersSearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], SuppliersSearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], SuppliersSearchComponent.prototype, "display", null);
    SuppliersSearchComponent = __decorate([
        core_1.Component({
            selector: 'SuppliersSearch',
            template: __webpack_require__(1124),
            providers: [Suppliers_service_1.SuppliersService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof Suppliers_service_1.SuppliersService !== 'undefined' && Suppliers_service_1.SuppliersService) === 'function' && _c) || Object])
    ], SuppliersSearchComponent);
    return SuppliersSearchComponent;
    var _a, _b, _c;
}());
exports.SuppliersSearchComponent = SuppliersSearchComponent;


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: TerritoriesAddComponent
 * Purpose		: This component allows to create new Territories record and save changes.
 * Dependency	: TerritoriesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Territories_service_1 = __webpack_require__(48);
var Region_service_1 = __webpack_require__(45);
var TerritoriesAddComponent = (function () {
    function TerritoriesAddComponent(route, router, toastr, TerritoriesService, RegionService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.TerritoriesService = TerritoriesService;
        this.RegionService = RegionService;
        this.objTerritories = new Territories_service_1.TerritoriesData();
    }
    Object.defineProperty(TerritoriesAddComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TerritoriesAddComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    TerritoriesAddComponent.prototype.ngOnInit = function () {
        this.objTerritories = new Territories_service_1.TerritoriesData();
        this.getLookups();
    };
    TerritoriesAddComponent.prototype.addTerritories = function () {
        var _this = this;
        this.TerritoriesService.addTerritoriesData(this.objTerritories)
            .subscribe(function (record) { return _this.router.navigate(['/Territories']); }, function (error) { return _this.errorMessage = 'There was an error while adding record. Error: ' + error; }, function () {
            _this.toastr.success('Territories record added successfully...', 'Add Territories');
            console.log('Territories record added successfully...');
        });
    };
    TerritoriesAddComponent.prototype.gotoTerritories = function () {
        // let Id = this.objTerritories ? this.objTerritories.TerritoryID : null;
        this.router.navigate(['/Territories']);
    };
    // Get Lookup List for Region
    TerritoriesAddComponent.prototype.getRegion = function () {
        var _this = this;
        this.RegionService.getAll().subscribe(function (records) { return _this.RegionList = records; });
    };
    TerritoriesAddComponent.prototype.getLookups = function () {
        this.getRegion();
    };
    TerritoriesAddComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], TerritoriesAddComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], TerritoriesAddComponent.prototype, "display", null);
    TerritoriesAddComponent = __decorate([
        core_1.Component({
            selector: 'my-Territories-add',
            template: __webpack_require__(1125),
            providers: [Territories_service_1.TerritoriesService,
                Region_service_1.RegionService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Territories_service_1.TerritoriesService !== 'undefined' && Territories_service_1.TerritoriesService) === 'function' && _d) || Object, (typeof (_e = typeof Region_service_1.RegionService !== 'undefined' && Region_service_1.RegionService) === 'function' && _e) || Object])
    ], TerritoriesAddComponent);
    return TerritoriesAddComponent;
    var _a, _b, _c, _d, _e;
}());
exports.TerritoriesAddComponent = TerritoriesAddComponent;


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Territories_service_1 = __webpack_require__(48);
var Region_service_1 = __webpack_require__(45);
var TerritoriesDetailsComponent = (function () {
    function TerritoriesDetailsComponent(route, router, toastr, TerritoriesService, RegionService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.TerritoriesService = TerritoriesService;
        this.RegionService = RegionService;
        // this.id = parseInt(params.get('id'));
        this.objTerritories = new Territories_service_1.TerritoriesData();
    }
    Object.defineProperty(TerritoriesDetailsComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TerritoriesDetailsComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    TerritoriesDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.TerritoriesService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objTerritories = item; });
        this.getLookups();
    };
    TerritoriesDetailsComponent.prototype.deleteTerritories = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Territories?') == true) {
            this.TerritoriesService.deleteTerritories(this.objTerritories.TerritoryID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/Territories']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () { console.log('Territories record deleted successfully...'); });
        }
    };
    TerritoriesDetailsComponent.prototype.gotoTerritoriesEdit = function () {
        this.router.navigate(['/Territories', this.objTerritories.TerritoryID]);
    };
    TerritoriesDetailsComponent.prototype.gotoTerritories = function () {
        this.router.navigate(['/Territories']);
    };
    // Get Lookup List for Region
    TerritoriesDetailsComponent.prototype.getRegion = function () {
        var _this = this;
        this.RegionService.getAll().subscribe(function (records) { return _this.RegionList = records; });
    };
    TerritoriesDetailsComponent.prototype.getLookups = function () {
        this.getRegion();
    };
    TerritoriesDetailsComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], TerritoriesDetailsComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], TerritoriesDetailsComponent.prototype, "display", null);
    TerritoriesDetailsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1126),
            providers: [Territories_service_1.TerritoriesService,
                Region_service_1.RegionService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Territories_service_1.TerritoriesService !== 'undefined' && Territories_service_1.TerritoriesService) === 'function' && _d) || Object, (typeof (_e = typeof Region_service_1.RegionService !== 'undefined' && Region_service_1.RegionService) === 'function' && _e) || Object])
    ], TerritoriesDetailsComponent);
    return TerritoriesDetailsComponent;
    var _a, _b, _c, _d, _e;
}());
exports.TerritoriesDetailsComponent = TerritoriesDetailsComponent;


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: TerritoriesEditComponent
 * Purpose		: This component retrieves data for the specified record id and allows to edit and save changes.
 * Dependency	: TerritoriesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var ng2_toastr_1 = __webpack_require__(6);
var Territories_service_1 = __webpack_require__(48);
var Region_service_1 = __webpack_require__(45);
var TerritoriesEditComponent = (function () {
    function TerritoriesEditComponent(route, router, toastr, TerritoriesService, RegionService) {
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.TerritoriesService = TerritoriesService;
        this.RegionService = RegionService;
        // this.id = parseInt(params.get('id'));
        this.objTerritories = new Territories_service_1.TerritoriesData();
    }
    Object.defineProperty(TerritoriesEditComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TerritoriesEditComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    TerritoriesEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.TerritoriesService.getByID(params['id']); })
            .subscribe(function (item) { return _this.objTerritories = item; });
        this.getLookups();
    };
    TerritoriesEditComponent.prototype.updateTerritories = function () {
        var _this = this;
        this.TerritoriesService.updateTerritoriesData(this.objTerritories)
            .subscribe(function (record) { return _this.router.navigate(['/Territories']); }, function (error) { return _this.errorMessage = 'There was an error while updating record. Error: ' + error; }, function () {
            _this.toastr.success('Territories record updated successfully...', 'Edit Territories');
            console.log('Territories record updated successfully...');
        });
    };
    TerritoriesEditComponent.prototype.deleteTerritories = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Territories?') == true) {
            this.TerritoriesService.deleteTerritories(this.objTerritories.TerritoryID.toString())
                .subscribe(function (record) { return _this.router.navigate(['/Territories']); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('Territories record deleted successfully...', 'Delete Territories');
                console.log('Territories record deleted successfully...');
            });
        }
    };
    TerritoriesEditComponent.prototype.gotoTerritories = function () {
        var Id = this.objTerritories ? this.objTerritories.TerritoryID : null;
        this.router.navigate(['/Territories']);
    };
    // Get Lookup List for Region
    TerritoriesEditComponent.prototype.getRegion = function () {
        var _this = this;
        this.RegionService.getAll().subscribe(function (records) { return _this.RegionList = records; });
    };
    TerritoriesEditComponent.prototype.getLookups = function () {
        this.getRegion();
    };
    TerritoriesEditComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], TerritoriesEditComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], TerritoriesEditComponent.prototype, "display", null);
    TerritoriesEditComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1127),
            providers: [Territories_service_1.TerritoriesService,
                Region_service_1.RegionService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.2s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _c) || Object, (typeof (_d = typeof Territories_service_1.TerritoriesService !== 'undefined' && Territories_service_1.TerritoriesService) === 'function' && _d) || Object, (typeof (_e = typeof Region_service_1.RegionService !== 'undefined' && Region_service_1.RegionService) === 'function' && _e) || Object])
    ], TerritoriesEditComponent);
    return TerritoriesEditComponent;
    var _a, _b, _c, _d, _e;
}());
exports.TerritoriesEditComponent = TerritoriesEditComponent;


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: TerritoriesListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: TerritoriesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
__webpack_require__(3);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var myGlobals = __webpack_require__(7);
var Territories_service_1 = __webpack_require__(48);
var TerritoriesSearch_component_1 = __webpack_require__(474);
var TerritoriesListComponent = (function () {
    function TerritoriesListComponent(TerritoriesService, route, router, toastr) {
        this.TerritoriesService = TerritoriesService;
        this.route = route;
        this.router = router;
        this.toastr = toastr;
        this.sortExpression = "TerritoryID";
        this.filterExpression = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.newTerritories = new Territories_service_1.TerritoriesData();
        this.pageSize = myGlobals.pageSize;
    }
    Object.defineProperty(TerritoriesListComponent.prototype, "routeAnimation", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TerritoriesListComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    TerritoriesListComponent.prototype.ngOnInit = function () {
        //this.TerritoriesService.getAll().subscribe(record => this.TerritoriesList=record);
        this.pageIndex = 1;
        this.isFirstPage = true;
        this.getTerritoriesByPaging();
        /*
        this.TerritoriesList = this.route.params
            .switchMap((params: Params) => {
                this.selectedId = +params['id'];
                return this.service.getAll();
            });
        */
    };
    // Get all records
    TerritoriesListComponent.prototype.getTerritories = function () {
        var _this = this;
        this.TerritoriesService.getAll()
            .subscribe(function (data) { return _this.TerritoriesList = data; }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // On Search CLick on TerritoriesSearch Component
    TerritoriesListComponent.prototype.onSearch = function (searchText) {
        // 1. Update this.filterExpression
        this.filterExpression = searchText;
        // 2. call getTerritoriesByPaging method that will refresh the data
        this.pageIndex = 1;
        this.getTerritoriesByPaging();
    };
    TerritoriesListComponent.prototype.onSort = function (event, sortColumn) {
        // var target = event.target || event.srcElement || event.currentTarget;
        // var parent = target.parentNode;
        if (this.sortExpression === sortColumn)
            this.sortExpression = sortColumn + ' desc';
        else if (this.sortExpression === sortColumn + ' desc')
            this.sortExpression = sortColumn;
        else
            this.sortExpression = sortColumn;
        this.getTerritoriesByPaging();
    };
    // Get records by paging
    TerritoriesListComponent.prototype.getTerritoriesByPaging = function () {
        var _this = this;
        this.TerritoriesService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
            .subscribe(function (data) {
            _this.TerritoriesList = data.TerritoriesList;
            _this.rowsCount = data.RowsCount;
            _this.pageCount = Math.ceil(_this.rowsCount / _this.pageSize);
            if (_this.pageIndex == 1)
                _this.isFirstPage = true;
            else
                _this.isFirstPage = false;
            if (_this.pageIndex == _this.pageCount)
                _this.endRowIndex = _this.rowsCount;
            else
                _this.endRowIndex = _this.pageIndex * _this.pageSize;
        }, function (error) { return _this.errorMessage = 'There was an error while retrieving records. Error: ' + error; });
    };
    // Adds new record
    TerritoriesListComponent.prototype.addTerritories = function () {
        this.TerritoriesService.addTerritoriesData(this.newTerritories).subscribe(function (record) { return console.log(record); });
        this.getTerritories();
    };
    // Updates existing record
    TerritoriesListComponent.prototype.updateTerritories = function () {
        this.TerritoriesService.updateTerritoriesData(this.selectedTerritories).subscribe(function (record) { return console.log(record); });
        this.getTerritories();
    };
    // Deletes record with specified id
    TerritoriesListComponent.prototype.deleteTerritories = function (id) {
        var _this = this;
        if (window.confirm('Are you sure you want to delete this Territories?') == true) {
            this.TerritoriesService.deleteTerritories(id)
                .subscribe(function (data) { return _this.getTerritories(); }, function (error) { return _this.errorMessage = 'There was an error while deleting record. Error: ' + error; }, function () {
                _this.toastr.success('Territories record deleted successfully...', 'Delete Territories');
                console.log('Territories record deleted successfully...');
            });
        }
    };
    // Go to First Page
    TerritoriesListComponent.prototype.onFirstPage = function () {
        this.pageIndex = 1;
        this.getTerritoriesByPaging();
    };
    // Go to Previous Page
    TerritoriesListComponent.prototype.onPreviousPage = function () {
        if (this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.getTerritoriesByPaging();
        }
    };
    // Refresh - Go to First Page
    TerritoriesListComponent.prototype.onRefresh = function () {
        this.onFirstPage();
    };
    // Go to Next Page
    TerritoriesListComponent.prototype.onNextPage = function () {
        if (this.pageIndex < this.pageCount) {
            this.pageIndex = this.pageIndex + 1;
            this.getTerritoriesByPaging();
        }
    };
    // Go to Last Page
    TerritoriesListComponent.prototype.onLastPage = function () {
        this.pageIndex = this.pageCount;
        this.getTerritoriesByPaging();
    };
    // On Edit - Go to Edit page
    TerritoriesListComponent.prototype.onSelect = function (item) {
        this.router.navigate(['/Territories', item.TerritoryID]);
    };
    // On Details - Go to Details page
    TerritoriesListComponent.prototype.onSelectDetails = function (item) {
        this.router.navigate(['/Territories/Details', item.TerritoryID]);
    };
    // Set record as selected
    TerritoriesListComponent.prototype.SelectTerritories = function (item) {
        this.selectedTerritories = item;
    };
    // Submits form
    TerritoriesListComponent.prototype.submitForm = function (data) {
        console.log(data);
    };
    // Logs message onto Console
    TerritoriesListComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], TerritoriesListComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], TerritoriesListComponent.prototype, "display", null);
    __decorate([
        core_1.ViewChild(TerritoriesSearch_component_1.TerritoriesSearchComponent), 
        __metadata('design:type', (typeof (_a = typeof TerritoriesSearch_component_1.TerritoriesSearchComponent !== 'undefined' && TerritoriesSearch_component_1.TerritoriesSearchComponent) === 'function' && _a) || Object)
    ], TerritoriesListComponent.prototype, "filterComponent", void 0);
    TerritoriesListComponent = __decorate([
        core_1.Component({
            selector: 'my-Territories',
            template: __webpack_require__(1128),
            providers: [Territories_service_1.TerritoriesService],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(-100%)'
                        }),
                        core_1.animate('0.4s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.7s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof Territories_service_1.TerritoriesService !== 'undefined' && Territories_service_1.TerritoriesService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _e) || Object])
    ], TerritoriesListComponent);
    return TerritoriesListComponent;
    var _a, _b, _c, _d, _e;
}());
exports.TerritoriesListComponent = TerritoriesListComponent;


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: TerritoriesSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: TerritoriesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(3);
var Territories_service_1 = __webpack_require__(48);
var Region_service_1 = __webpack_require__(45);
var TerritoriesSearchComponent = (function () {
    function TerritoriesSearchComponent(route, router, TerritoriesService, RegionService) {
        this.route = route;
        this.router = router;
        this.TerritoriesService = TerritoriesService;
        this.RegionService = RegionService;
        this.filterCriteria = new core_1.EventEmitter();
        // this.id = parseInt(params.get('id'));
        this.objTerritories = new Territories_service_1.TerritoriesData();
        /* Initialize Lookup field values
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.filterCriteria = new core_1.EventEmitter();
    }
    Object.defineProperty(TerritoriesSearchComponent.prototype, "routeAnimation", {
        /* Animation for Search section */
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TerritoriesSearchComponent.prototype, "display", {
        get: function () {
            return 'block';
        },
        enumerable: true,
        configurable: true
    });
    TerritoriesSearchComponent.prototype.ngOnInit = function () {
        // Getting lookup data
        this.getLookups();
    };
    TerritoriesSearchComponent.prototype.clearCriteria = function () {
        /* To empty values in textbox and dropdown lists
        this.objProducts.ProductName = '';
        this.objProducts.CategoryID = 0;
        this.objProducts.SupplierID = 0;
        */
        this.objTerritories = new Territories_service_1.TerritoriesData();
        this.filterExpression = '';
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    TerritoriesSearchComponent.prototype.onExpandCollapse = function () {
        this.showSearch = !this.showSearch;
    };
    TerritoriesSearchComponent.prototype.searchProducts = function () {
        // Updating filterExpression on Search button click
        this.filterExpression = '';
        if (this.objTerritories.TerritoryID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND TerritoryID like '%" + this.objTerritories.TerritoryID + "%'";
            else
                this.filterExpression = "TerritoryID like '%" + this.objTerritories.TerritoryID + "%'";
        }
        if (this.objTerritories.TerritoryDescription) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND TerritoryDescription like '%" + this.objTerritories.TerritoryDescription + "%'";
            else
                this.filterExpression = "TerritoryDescription like '%" + this.objTerritories.TerritoryDescription + "%'";
        }
        if (this.objTerritories.RegionID) {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND RegionID = " + this.objTerritories.RegionID;
            else
                this.filterExpression = "RegionID = " + this.objTerritories.RegionID;
        }
        /* Build Search here
        if (this.objProducts.ProductName)
        {
            this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
        }
        if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
            else
                this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
        }
        if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
        {
            if (this.filterExpression.length > 0)
                this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
            else
                this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
        }
        */
        event.preventDefault();
        console.log("Filter Changed: " + this.filterExpression);
        this.filterCriteria.emit(this.filterExpression);
    };
    // Get Lookup List for Region
    TerritoriesSearchComponent.prototype.getRegion = function () {
        var _this = this;
        this.RegionService.getAll().subscribe(function (records) { return _this.RegionList = records; });
    };
    TerritoriesSearchComponent.prototype.getLookups = function () {
        this.getRegion();
    };
    TerritoriesSearchComponent.prototype.log = function (msg) {
        this.messages.splice(0, 0, msg);
        console.log(msg);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], TerritoriesSearchComponent.prototype, "filterCriteria", void 0);
    __decorate([
        core_1.HostBinding('@routeAnimation'), 
        __metadata('design:type', Object)
    ], TerritoriesSearchComponent.prototype, "routeAnimation", null);
    __decorate([
        core_1.HostBinding('style.display'), 
        __metadata('design:type', Object)
    ], TerritoriesSearchComponent.prototype, "display", null);
    TerritoriesSearchComponent = __decorate([
        core_1.Component({
            selector: 'TerritoriesSearch',
            template: __webpack_require__(1129),
            providers: [Territories_service_1.TerritoriesService,
                Region_service_1.RegionService
            ],
            animations: [
                core_1.trigger('routeAnimation', [
                    core_1.state('*', core_1.style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    core_1.transition(':enter', [
                        core_1.style({
                            opacity: 0,
                            transform: 'translateX(100%)'
                        }),
                        core_1.animate('0.9s ease-in')
                    ]),
                    core_1.transition(':leave', [
                        core_1.animate('0.5s ease-out', core_1.style({
                            opacity: 0,
                            transform: 'translateY(100%)'
                        }))
                    ])
                ])
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof Territories_service_1.TerritoriesService !== 'undefined' && Territories_service_1.TerritoriesService) === 'function' && _c) || Object, (typeof (_d = typeof Region_service_1.RegionService !== 'undefined' && Region_service_1.RegionService) === 'function' && _d) || Object])
    ], TerritoriesSearchComponent);
    return TerritoriesSearchComponent;
    var _a, _b, _c, _d;
}());
exports.TerritoriesSearchComponent = TerritoriesSearchComponent;


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var auth_service_1 = __webpack_require__(68);
var ForgotPasswordComponent = (function () {
    function ForgotPasswordComponent(authService, router) {
        this.authService = authService;
        this.router = router;
        //this.setMessage();
    }
    ForgotPasswordComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1130)
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
    ], ForgotPasswordComponent);
    return ForgotPasswordComponent;
    var _a, _b;
}());
exports.ForgotPasswordComponent = ForgotPasswordComponent;


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var auth_service_1 = __webpack_require__(68);
var LoginComponent = (function () {
    function LoginComponent(authService, router) {
        this.authService = authService;
        this.router = router;
        this.setMessage();
    }
    LoginComponent.prototype.setMessage = function () {
        this.message = 'Logged ' + (this.authService.isLoggedIn ? 'in' : 'out');
    };
    LoginComponent.prototype.login = function () {
        var _this = this;
        this.message = 'Trying to log in ...';
        this.authService.login().subscribe(function () {
            _this.setMessage();
            if (_this.authService.isLoggedIn) {
                // Get the redirect URL from our auth service
                // If no redirect has been set, use the default
                var redirect = _this.authService.redirectUrl ? _this.authService.redirectUrl : '/admin';
                // Set our navigation extras object
                // that passes on our global query params and fragment
                var navigationExtras = {
                    preserveQueryParams: true,
                    preserveFragment: true
                };
                // Redirect the user
                _this.router.navigate([redirect], navigationExtras);
            }
        });
    };
    LoginComponent.prototype.logout = function () {
        this.authService.logout();
        this.setMessage();
    };
    LoginComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1131)
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
    ], LoginComponent);
    return LoginComponent;
    var _a, _b;
}());
exports.LoginComponent = LoginComponent;
/*
Copyright 2016 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/ 


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var auth_service_1 = __webpack_require__(68);
var RegisterComponent = (function () {
    function RegisterComponent(authService, router) {
        this.authService = authService;
        this.router = router;
        //this.setMessage();
    }
    RegisterComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1132)
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
    ], RegisterComponent);
    return RegisterComponent;
    var _a, _b;
}());
exports.RegisterComponent = RegisterComponent;
/*
Copyright 2016 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/ 


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var selective_preload_strategy_1 = __webpack_require__(486);
__webpack_require__(261);
var AdminDashboardComponent = (function () {
    function AdminDashboardComponent(route, preloadStrategy) {
        this.route = route;
        this.preloadStrategy = preloadStrategy;
        this.modules = preloadStrategy.preloadedModules;
    }
    AdminDashboardComponent.prototype.ngOnInit = function () {
        // Capture the session ID if available
        this.sessionId = this.route
            .queryParams
            .map(function (params) { return params['session_id'] || 'None'; });
        // Capture the fragment if available
        this.token = this.route
            .fragment
            .map(function (fragment) { return fragment || 'None'; });
    };
    AdminDashboardComponent = __decorate([
        core_1.Component({
            template: "\n    <p>Dashboard</p>\n\n    <p>Session ID: {{ sessionId | async }}</p>\n    <a id=\"anchor\"></a>\n    <p>Token: {{ token | async }}</p>\n\n    Preloaded Modules\n    <ul>\n      <li *ngFor=\"let module of modules\">{{ module }}</li>\n    </ul>\n  "
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof selective_preload_strategy_1.PreloadSelectedModules !== 'undefined' && selective_preload_strategy_1.PreloadSelectedModules) === 'function' && _b) || Object])
    ], AdminDashboardComponent);
    return AdminDashboardComponent;
    var _a, _b;
}());
exports.AdminDashboardComponent = AdminDashboardComponent;
/*
Copyright 2016 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/ 


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var AdminComponent = (function () {
    function AdminComponent() {
    }
    AdminComponent = __decorate([
        core_1.Component({
            template: "\n    <h3>ADMIN</h3>\n    <nav>\n      <a routerLink=\"./\" routerLinkActive=\"active\"\n        [routerLinkActiveOptions]=\"{ exact: true }\">Dashboard</a>\n      <a routerLink=\"./users\" routerLinkActive=\"active\">Manage Users</a>\n      <a routerLink=\"./roles\" routerLinkActive=\"active\">Manage Roles</a>\n    </nav>\n    <router-outlet></router-outlet>\n  "
        }), 
        __metadata('design:paramtypes', [])
    ], AdminComponent);
    return AdminComponent;
}());
exports.AdminComponent = AdminComponent;
/*
Copyright 2016 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/ 


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var ManageRolesComponent = (function () {
    function ManageRolesComponent() {
    }
    ManageRolesComponent = __decorate([
        core_1.Component({
            template: "\n    <p>Manage your roles here</p>\n  "
        }), 
        __metadata('design:paramtypes', [])
    ], ManageRolesComponent);
    return ManageRolesComponent;
}());
exports.ManageRolesComponent = ManageRolesComponent;
/*
Copyright 2016 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/ 


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var ManageUsersComponent = (function () {
    function ManageUsersComponent() {
    }
    ManageUsersComponent = __decorate([
        core_1.Component({
            template: "\n    <p>Manage your users here</p>\n  "
        }), 
        __metadata('design:paramtypes', [])
    ], ManageUsersComponent);
    return ManageUsersComponent;
}());
exports.ManageUsersComponent = ManageUsersComponent;
/*
Copyright 2016 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/ 


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
// TODO SOMEDAY: Feature Componetized like CrisisCenter
__webpack_require__(3);
var core_1 = __webpack_require__(0);
var SettingsComponent = (function () {
    function SettingsComponent() {
    }
    SettingsComponent.prototype.ngOnInit = function () {
    };
    SettingsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1134)
        }), 
        __metadata('design:paramtypes', [])
    ], SettingsComponent);
    return SettingsComponent;
}());
exports.SettingsComponent = SettingsComponent;


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
// TODO SOMEDAY: Feature Componetized like CrisisCenter
__webpack_require__(3);
var core_1 = __webpack_require__(0);
var CalendarComponent = (function () {
    function CalendarComponent() {
    }
    CalendarComponent.prototype.ngOnInit = function () {
    };
    CalendarComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1136)
        }), 
        __metadata('design:paramtypes', [])
    ], CalendarComponent);
    return CalendarComponent;
}());
exports.CalendarComponent = CalendarComponent;


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
// TODO SOMEDAY: Feature Componetized like CrisisCenter
__webpack_require__(3);
var core_1 = __webpack_require__(0);
var GraphsComponent = (function () {
    function GraphsComponent() {
        // 1. LINE CHART
        this.lineChartData = [
            { data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A' },
            { data: [28, 48, 40, 19, 86, 27, 90], label: 'Series B' },
            { data: [18, 48, 77, 9, 100, 27, 40], label: 'Series C' }
        ];
        this.lineChartLabels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
        this.lineChartOptions = {
            animation: false,
            responsive: true
        };
        this.lineChartColors = [
            {
                backgroundColor: 'rgba(148,159,177,0.2)',
                borderColor: 'rgba(148,159,177,1)',
                pointBackgroundColor: 'rgba(148,159,177,1)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgba(148,159,177,0.8)'
            },
            {
                backgroundColor: 'rgba(77,83,96,0.2)',
                borderColor: 'rgba(77,83,96,1)',
                pointBackgroundColor: 'rgba(77,83,96,1)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgba(77,83,96,1)'
            },
            {
                backgroundColor: 'rgba(148,159,177,0.2)',
                borderColor: 'rgba(148,159,177,1)',
                pointBackgroundColor: 'rgba(148,159,177,1)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgba(148,159,177,0.8)'
            }
        ];
        this.lineChartLegend = true;
        this.lineChartType = 'line';
        // 2. BAR CHART
        this.barChartOptions = {
            scaleShowVerticalLines: false,
            responsive: true
        };
        this.barChartLabels = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
        this.barChartType = 'bar';
        this.barChartLegend = true;
        this.barChartData = [
            { data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A' },
            { data: [28, 48, 40, 19, 86, 27, 90], label: 'Series B' }
        ];
        // 3. DOUGHNUT CHART
        this.doughnutChartLabels = ['Download Sales', 'In-Store Sales', 'Mail-Order Sales'];
        this.doughnutChartData = [350, 450, 100];
        this.doughnutChartType = 'doughnut';
        // 4. RADAR CHART
        this.radarChartLabels = ['Eating', 'Drinking', 'Sleeping', 'Designing', 'Coding', 'Cycling', 'Running'];
        this.radarChartData = [
            { data: [65, 59, 90, 81, 56, 55, 40], label: 'Series A' },
            { data: [28, 48, 40, 19, 96, 27, 100], label: 'Series B' }
        ];
        this.radarChartType = 'radar';
        // 4. PIE CHART
        this.pieChartLabels = ['Download Sales', 'In-Store Sales', 'Mail Sales'];
        this.pieChartData = [300, 500, 100];
        this.pieChartType = 'pie';
        // 5. POLAR AREA CHART
        this.polarAreaChartLabels = ['Download Sales', 'In-Store Sales', 'Mail Sales', 'Telesales', 'Corporate Sales'];
        this.polarAreaChartData = [300, 500, 100, 40, 120];
        this.polarAreaLegend = true;
        this.polarAreaChartType = 'polarArea';
        // 6. DYNAMIC CHARTS
        this.dynamicLineChartData = [
            [65, 59, 80, 81, 56, 55, 40],
            [28, 48, 40, 19, 86, 27, 90]
        ];
        this.dynamicLineChartLabels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
        this.dynamicLineChartType = 'line';
        this.dynamicPieChartType = 'pie';
        // Pie
        this.dynamicPieChartLabels = ['Download Sales', 'In-Store Sales', 'Mail Sales'];
        this.dynamicPieChartData = [300, 500, 100];
    }
    GraphsComponent.prototype.randomizeLine = function () {
        var _lineChartData = new Array(this.lineChartData.length);
        for (var i = 0; i < this.lineChartData.length; i++) {
            _lineChartData[i] = { data: new Array(this.lineChartData[i].data.length), label: this.lineChartData[i].label };
            for (var j = 0; j < this.lineChartData[i].data.length; j++) {
                _lineChartData[i].data[j] = Math.floor((Math.random() * 100) + 1);
            }
        }
        this.lineChartData = _lineChartData;
    };
    // events
    GraphsComponent.prototype.lineChartClicked = function (e) {
        console.log(e);
    };
    GraphsComponent.prototype.lineChartHovered = function (e) {
        console.log(e);
    };
    // events
    GraphsComponent.prototype.barChartClicked = function (e) {
        console.log(e);
    };
    GraphsComponent.prototype.barChartHovered = function (e) {
        console.log(e);
    };
    GraphsComponent.prototype.randomizeBar = function () {
        // Only Change 3 values
        var data = [
            Math.round(Math.random() * 100),
            59,
            80,
            (Math.random() * 100),
            56,
            (Math.random() * 100),
            40];
        var clone = JSON.parse(JSON.stringify(this.barChartData));
        clone[0].data = data;
        this.barChartData = clone;
    };
    // events
    GraphsComponent.prototype.doughnutChartClicked = function (e) {
        console.log(e);
    };
    GraphsComponent.prototype.doughnutchartHovered = function (e) {
        console.log(e);
    };
    // events
    GraphsComponent.prototype.radarChartClicked = function (e) {
        console.log(e);
    };
    GraphsComponent.prototype.radarChartHovered = function (e) {
        console.log(e);
    };
    // events
    GraphsComponent.prototype.pieChartClicked = function (e) {
        console.log(e);
    };
    GraphsComponent.prototype.pieChartHovered = function (e) {
        console.log(e);
    };
    // events
    GraphsComponent.prototype.polarAreaChartClicked = function (e) {
        console.log(e);
    };
    GraphsComponent.prototype.polarAreaChartHovered = function (e) {
        console.log(e);
    };
    GraphsComponent.prototype.randomizeType = function () {
        this.dynamicLineChartType = this.dynamicLineChartType === 'line' ? 'bar' : 'line';
        this.dynamicPieChartType = this.dynamicPieChartType === 'doughnut' ? 'pie' : 'doughnut';
    };
    GraphsComponent.prototype.dynamicChartClicked = function (e) {
        console.log(e);
    };
    GraphsComponent.prototype.dynamicChartHovered = function (e) {
        console.log(e);
    };
    GraphsComponent.prototype.ngOnInit = function () {
    };
    GraphsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1138)
        }), 
        __metadata('design:paramtypes', [])
    ], GraphsComponent);
    return GraphsComponent;
}());
exports.GraphsComponent = GraphsComponent;


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
// TODO SOMEDAY: Feature Componetized like CrisisCenter
__webpack_require__(3);
var core_1 = __webpack_require__(0);
var InboxComponent = (function () {
    function InboxComponent() {
    }
    InboxComponent.prototype.ngOnInit = function () {
    };
    InboxComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(1140)
        }), 
        __metadata('design:paramtypes', [])
    ], InboxComponent);
    return InboxComponent;
}());
exports.InboxComponent = InboxComponent;


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
__webpack_require__(260);
var core_1 = __webpack_require__(0);
var Observable_1 = __webpack_require__(1);
var PreloadSelectedModules = (function () {
    function PreloadSelectedModules() {
        this.preloadedModules = [];
    }
    PreloadSelectedModules.prototype.preload = function (route, load) {
        if (route.data && route.data['preload']) {
            // add the route path to our preloaded module array
            this.preloadedModules.push(route.path);
            // log the route path to the console
            console.log('Preloaded: ' + route.path);
            return load();
        }
        else {
            return Observable_1.Observable.of(null);
        }
    };
    PreloadSelectedModules = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [])
    ], PreloadSelectedModules);
    return PreloadSelectedModules;
}());
exports.PreloadSelectedModules = PreloadSelectedModules;


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(943));


/***/ },
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {"use strict";
var core_1 = __webpack_require__(0);
var accordion_component_1 = __webpack_require__(231);
/* tslint:disable-next-line */
var MouseEvent = global.MouseEvent;
/* tslint:disable:component-selector-name */
var AccordionPanelComponent = (function () {
    function AccordionPanelComponent(accordion) {
        this.accordion = accordion;
    }
    Object.defineProperty(AccordionPanelComponent.prototype, "isOpen", {
        // Questionable, maybe .panel-open should be on child div.panel element?
        get: function () {
            return this._isOpen;
        },
        set: function (value) {
            this._isOpen = value;
            if (value) {
                this.accordion.closeOtherPanels(this);
            }
        },
        enumerable: true,
        configurable: true
    });
    AccordionPanelComponent.prototype.ngOnInit = function () {
        this.panelClass = this.panelClass || 'panel-default';
        this.accordion.addGroup(this);
    };
    AccordionPanelComponent.prototype.ngOnDestroy = function () {
        this.accordion.removeGroup(this);
    };
    AccordionPanelComponent.prototype.toggleOpen = function (event) {
        event.preventDefault();
        if (!this.isDisabled) {
            this.isOpen = !this.isOpen;
        }
    };
    AccordionPanelComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'accordion-group, accordion-panel',
                    template: "\n    <div class=\"panel\" [ngClass]=\"panelClass\">\n      <div class=\"panel-heading\" (click)=\"toggleOpen($event)\">\n        <h4 class=\"panel-title\">\n          <a href tabindex=\"0\" class=\"accordion-toggle\">\n            <span *ngIf=\"heading\" [ngClass]=\"{'text-muted': isDisabled}\">{{heading}}</span>\n            <ng-content select=\"[accordion-heading]\"></ng-content>\n          </a>\n        </h4>\n      </div>\n      <div class=\"panel-collapse collapse\" [collapse]=\"!isOpen\">\n        <div class=\"panel-body\">\n          <ng-content></ng-content>\n        </div>\n      </div>\n    </div>\n  "
                },] },
    ];
    /** @nocollapse */
    AccordionPanelComponent.ctorParameters = [
        { type: accordion_component_1.AccordionComponent, decorators: [{ type: core_1.Inject, args: [accordion_component_1.AccordionComponent,] },] },
    ];
    AccordionPanelComponent.propDecorators = {
        'heading': [{ type: core_1.Input },],
        'panelClass': [{ type: core_1.Input },],
        'isDisabled': [{ type: core_1.Input },],
        'isOpen': [{ type: core_1.HostBinding, args: ['class.panel-open',] }, { type: core_1.Input },],
    };
    return AccordionPanelComponent;
}());
exports.AccordionPanelComponent = AccordionPanelComponent;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23)))

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var ALERT_TEMPLATE = "\n  <div class=\"alert\" role=\"alert\" [ngClass]=\"classes\" *ngIf=\"!closed\">\n    <button *ngIf=\"dismissible\" type=\"button\" class=\"close\" (click)=\"onClose()\" (touch)=\"onClose()\">\n      <span aria-hidden=\"true\">&times;</span>\n      <span class=\"sr-only\">Close</span>\n    </button>\n    <ng-content></ng-content>\n  </div>\n  ";
// TODO: templateUrl
var AlertComponent = (function () {
    function AlertComponent() {
        this.type = 'warning';
        this.close = new core_1.EventEmitter(false);
        this.classes = [];
    }
    AlertComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.classes[0] = "alert-" + this.type;
        if (this.dismissible) {
            this.classes[1] = 'alert-dismissible';
        }
        else {
            this.classes.length = 1;
        }
        if (this.dismissOnTimeout) {
            setTimeout(function () { return _this.onClose(); }, this.dismissOnTimeout);
        }
    };
    // todo: mouse event + touch + pointer
    AlertComponent.prototype.onClose = function () {
        this.closed = true;
        this.close.emit(this);
    };
    AlertComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'alert',
                    template: ALERT_TEMPLATE
                },] },
    ];
    /** @nocollapse */
    AlertComponent.ctorParameters = [];
    AlertComponent.propDecorators = {
        'type': [{ type: core_1.Input },],
        'dismissible': [{ type: core_1.Input },],
        'dismissOnTimeout': [{ type: core_1.Input },],
        'close': [{ type: core_1.Output },],
    };
    return AlertComponent;
}());
exports.AlertComponent = AlertComponent;


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(10);
// TODO: config: activeClass - Class to apply to the checked buttons.
var ButtonCheckboxDirective = (function () {
    function ButtonCheckboxDirective(cd) {
        this.state = false;
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
        this.cd = cd;
        // hack !
        cd.valueAccessor = this;
    }
    // view -> model
    ButtonCheckboxDirective.prototype.onClick = function () {
        this.toggle(!this.state);
        this.cd.viewToModelUpdate(this.value);
    };
    ButtonCheckboxDirective.prototype.ngOnInit = function () {
        this.toggle(this.trueValue === this.value);
    };
    Object.defineProperty(ButtonCheckboxDirective.prototype, "trueValue", {
        get: function () {
            return typeof this.btnCheckboxTrue !== 'undefined'
                ? this.btnCheckboxTrue
                : true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonCheckboxDirective.prototype, "falseValue", {
        get: function () {
            return typeof this.btnCheckboxFalse !== 'undefined'
                ? this.btnCheckboxFalse
                : false;
        },
        enumerable: true,
        configurable: true
    });
    ButtonCheckboxDirective.prototype.toggle = function (state) {
        this.state = state;
        this.value = this.state ? this.trueValue : this.falseValue;
    };
    // ControlValueAccessor
    // model -> view
    ButtonCheckboxDirective.prototype.writeValue = function (value) {
        this.state = this.trueValue === value;
        this.value = value;
    };
    ButtonCheckboxDirective.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    ButtonCheckboxDirective.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    ButtonCheckboxDirective.decorators = [
        { type: core_1.Directive, args: [{ selector: '[btnCheckbox][ngModel]' },] },
    ];
    /** @nocollapse */
    ButtonCheckboxDirective.ctorParameters = [
        { type: forms_1.NgModel, decorators: [{ type: core_1.Self },] },
    ];
    ButtonCheckboxDirective.propDecorators = {
        'btnCheckboxTrue': [{ type: core_1.Input },],
        'btnCheckboxFalse': [{ type: core_1.Input },],
        'state': [{ type: core_1.HostBinding, args: ['class.active',] },],
        'onClick': [{ type: core_1.HostListener, args: ['click',] },],
    };
    return ButtonCheckboxDirective;
}());
exports.ButtonCheckboxDirective = ButtonCheckboxDirective;


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(10);
/* tslint:disable */
exports.RADIO_CONTROL_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(function () { return ButtonRadioDirective; }),
    multi: true
};
/* tslint:enable */
var ButtonRadioDirective = (function () {
    function ButtonRadioDirective(el) {
        this.el = el;
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
    }
    Object.defineProperty(ButtonRadioDirective.prototype, "isActive", {
        get: function () {
            return this.btnRadio === this.value;
        },
        enumerable: true,
        configurable: true
    });
    ButtonRadioDirective.prototype.onClick = function () {
        if (this.el.nativeElement.attributes.disabled) {
            return;
        }
        if (this.uncheckable && this.btnRadio === this.value) {
            this.value = undefined;
        }
        else {
            this.value = this.btnRadio;
        }
        this.onTouched();
        this.onChange(this.value);
    };
    ButtonRadioDirective.prototype.ngOnInit = function () {
        this.uncheckable = typeof this.uncheckable !== 'undefined';
    };
    ButtonRadioDirective.prototype.onBlur = function () {
        this.onTouched();
    };
    // ControlValueAccessor
    // model -> view
    ButtonRadioDirective.prototype.writeValue = function (value) {
        this.value = value;
    };
    ButtonRadioDirective.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    ButtonRadioDirective.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    ButtonRadioDirective.decorators = [
        { type: core_1.Directive, args: [{ selector: '[btnRadio]', providers: [exports.RADIO_CONTROL_VALUE_ACCESSOR] },] },
    ];
    /** @nocollapse */
    ButtonRadioDirective.ctorParameters = [
        { type: core_1.ElementRef, },
    ];
    ButtonRadioDirective.propDecorators = {
        'btnRadio': [{ type: core_1.Input },],
        'uncheckable': [{ type: core_1.Input },],
        'value': [{ type: core_1.Input },],
        'isActive': [{ type: core_1.HostBinding, args: ['class.active',] },],
        'onClick': [{ type: core_1.HostListener, args: ['click',] },],
    };
    return ButtonRadioDirective;
}());
exports.ButtonRadioDirective = ButtonRadioDirective;


/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var carousel_component_1 = __webpack_require__(235);
var SlideComponent = (function () {
    function SlideComponent(carousel) {
        this.addClass = true;
        this.carousel = carousel;
    }
    SlideComponent.prototype.ngOnInit = function () {
        this.carousel.addSlide(this);
    };
    SlideComponent.prototype.ngOnDestroy = function () {
        this.carousel.removeSlide(this);
    };
    SlideComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'slide',
                    template: "\n    <div [class.active]=\"active\" class=\"item\">\n      <ng-content></ng-content>\n    </div>\n  "
                },] },
    ];
    /** @nocollapse */
    SlideComponent.ctorParameters = [
        { type: carousel_component_1.CarouselComponent, },
    ];
    SlideComponent.propDecorators = {
        'index': [{ type: core_1.Input },],
        'direction': [{ type: core_1.Input },],
        'active': [{ type: core_1.HostBinding, args: ['class.active',] }, { type: core_1.Input },],
        'addClass': [{ type: core_1.HostBinding, args: ['class.item',] }, { type: core_1.HostBinding, args: ['class.carousel-item',] },],
    };
    return SlideComponent;
}());
exports.SlideComponent = SlideComponent;


/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
// FIX: in order to update to rc.1 had to disable animation, sorry
var core_1 = __webpack_require__(0);
// import {AnimationBuilder} from '@angular/platform-browser/src/animate/animation_builder';
// import {animate, animation, state, style, transition} from '@angular/core';
/*@Directive({
 selector: '[collapse]',
 // templateUrl: 'app/panel.html',
 // styleUrls: ['app/panel.css'],
 animations: [
 animation('active', [
 state('void', style({ height: 0 })),
 state('closed', style({ height: 0 })),
 state('open', style({ height: '*' })),
 transition('void => closed', [ animate(0) ]),
 transition('closed => open', [ animate('350ms ease-out') ]),
 transition('open => closed', [ animate('350ms ease-out') ])
 ])
 ]
 })*/
// fix: replace with // '@angular/animate';
// when https://github.com/angular/angular/issues/5984 will be fixed
// TODO: remove ElementRef
// TODO: add on change
// TODO: #576 add callbacks: expanding, collapsing after adding animation
var CollapseDirective = (function () {
    function CollapseDirective(/*_ab:AnimationBuilder, */ _el, _renderer) {
        // private animation:any;
        this.collapsed = new core_1.EventEmitter(false);
        this.expanded = new core_1.EventEmitter(false);
        // shown
        this.isExpanded = true;
        // hidden
        this.isCollapsed = false;
        // stale state
        this.isCollapse = true;
        // animation state
        this.isCollapsing = false;
        // this._ab = _ab;
        this._el = _el;
        this._renderer = _renderer;
    }
    Object.defineProperty(CollapseDirective.prototype, "collapse", {
        get: function () {
            return this.isExpanded;
        },
        // @Input() private transitionDuration:number = 500; // Duration in ms
        set: function (value) {
            this.isExpanded = value;
            this.toggle();
        },
        enumerable: true,
        configurable: true
    });
    CollapseDirective.prototype.ngOnInit = function () {
        // this.animation = this._ab.css();
        // this.animation.setDuration(this.transitionDuration);
    };
    CollapseDirective.prototype.toggle = function () {
        // this.open = !this.open;
        if (this.isExpanded) {
            this.hide();
        }
        else {
            this.show();
        }
    };
    CollapseDirective.prototype.hide = function () {
        this.isCollapse = false;
        this.isCollapsing = true;
        this.isExpanded = false;
        this.isCollapsed = true;
        this.isCollapse = true;
        this.isCollapsing = false;
        this.display = 'none';
        this.collapsed.emit(this);
        /*  setTimeout(() => {
         // this.height = '0';
         // this.isCollapse = true;
         // this.isCollapsing = false;
         this.animation
         .setFromStyles({
         height: this._el.nativeElement.scrollHeight + 'px'
         })
         .setToStyles({
         height: '0',
         overflow: 'hidden'
         });
    
         this.animation.start(this._el.nativeElement)
         .onComplete(() => {
         if (this._el.nativeElement.offsetHeight === 0) {
         this.display = 'none';
         }
    
         this.isCollapse = true;
         this.isCollapsing = false;
         });
         }, 4);*/
    };
    CollapseDirective.prototype.show = function () {
        this.isCollapse = false;
        this.isCollapsing = true;
        this.isExpanded = true;
        this.isCollapsed = false;
        this.display = 'block';
        // this.height = 'auto';
        this.isCollapse = true;
        this.isCollapsing = false;
        this._renderer.setElementStyle(this._el.nativeElement, 'overflow', 'visible');
        this._renderer.setElementStyle(this._el.nativeElement, 'height', 'auto');
        this.expanded.emit(this);
        /*setTimeout(() => {
         // this.height = 'auto';
         // this.isCollapse = true;
         // this.isCollapsing = false;
         this.animation
         .setFromStyles({
         height: this._el.nativeElement.offsetHeight,
         overflow: 'hidden'
         })
         .setToStyles({
         height: this._el.nativeElement.scrollHeight + 'px'
         });
    
         this.animation.start(this._el.nativeElement)
         .onComplete(() => {
         this.isCollapse = true;
         this.isCollapsing = false;
         this._renderer.setElementStyle(this._el.nativeElement, 'overflow', 'visible');
         this._renderer.setElementStyle(this._el.nativeElement, 'height', 'auto');
         });
         }, 4);*/
    };
    CollapseDirective.decorators = [
        { type: core_1.Directive, args: [{ selector: '[collapse]' },] },
    ];
    /** @nocollapse */
    CollapseDirective.ctorParameters = [
        { type: core_1.ElementRef, },
        { type: core_1.Renderer, },
    ];
    CollapseDirective.propDecorators = {
        'collapsed': [{ type: core_1.Output },],
        'expanded': [{ type: core_1.Output },],
        'display': [{ type: core_1.HostBinding, args: ['style.display',] },],
        'isExpanded': [{ type: core_1.HostBinding, args: ['class.in',] }, { type: core_1.HostBinding, args: ['attr.aria-expanded',] },],
        'isCollapsed': [{ type: core_1.HostBinding, args: ['attr.aria-hidden',] },],
        'isCollapse': [{ type: core_1.HostBinding, args: ['class.collapse',] },],
        'isCollapsing': [{ type: core_1.HostBinding, args: ['class.collapsing',] },],
        'collapse': [{ type: core_1.Input },],
    };
    return CollapseDirective;
}());
exports.CollapseDirective = CollapseDirective;


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var NgTranscludeDirective = (function () {
    function NgTranscludeDirective(_viewRef) {
        this._viewRef = _viewRef;
        this.viewRef = _viewRef;
    }
    Object.defineProperty(NgTranscludeDirective.prototype, "ngTransclude", {
        get: function () {
            return this._ngTransclude;
        },
        set: function (templateRef) {
            this._ngTransclude = templateRef;
            if (templateRef) {
                this.viewRef.createEmbeddedView(templateRef);
            }
        },
        enumerable: true,
        configurable: true
    });
    NgTranscludeDirective.decorators = [
        { type: core_1.Directive, args: [{
                    selector: '[ngTransclude]'
                },] },
    ];
    /** @nocollapse */
    NgTranscludeDirective.ctorParameters = [
        { type: core_1.ViewContainerRef, },
    ];
    NgTranscludeDirective.propDecorators = {
        'ngTransclude': [{ type: core_1.Input },],
    };
    return NgTranscludeDirective;
}());
exports.NgTranscludeDirective = NgTranscludeDirective;


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var moment = __webpack_require__(5);
var DateFormatter = (function () {
    function DateFormatter() {
    }
    DateFormatter.prototype.format = function (date, format) {
        return moment(date.getTime()).format(format);
    };
    return DateFormatter;
}());
exports.DateFormatter = DateFormatter;


/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var datepicker_inner_component_1 = __webpack_require__(102);
var forms_1 = __webpack_require__(10);
/* tslint:disable:component-selector-name component-selector-type */
/* tslint:enable:component-selector-name component-selector-type */
var DatePickerComponent = (function () {
    function DatePickerComponent(cd) {
        this.selectionDone = new core_1.EventEmitter(undefined);
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
        this._now = new Date();
        this.cd = cd;
        // hack
        cd.valueAccessor = this;
    }
    Object.defineProperty(DatePickerComponent.prototype, "activeDate", {
        get: function () {
            return this._activeDate || this._now;
        },
        set: function (value) {
            this._activeDate = value;
        },
        enumerable: true,
        configurable: true
    });
    DatePickerComponent.prototype.onUpdate = function (event) {
        this.cd.viewToModelUpdate(event);
    };
    DatePickerComponent.prototype.onSelectionDone = function (event) {
        this.selectionDone.emit(event);
    };
    // todo: support null value
    DatePickerComponent.prototype.writeValue = function (value) {
        if (this._datePicker.compare(value, this._activeDate) === 0) {
            return;
        }
        if (value && value instanceof Date) {
            this.activeDate = value;
            this._datePicker.select(value, false);
            return;
        }
        this.activeDate = value ? new Date(value) : void 0;
    };
    DatePickerComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    DatePickerComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    DatePickerComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'datepicker[ngModel]',
                    template: "\n    <datepicker-inner [activeDate]=\"activeDate\"\n                      (update)=\"onUpdate($event)\"\n                      [datepickerMode]=\"datepickerMode\"\n                      [initDate]=\"initDate\"\n                      [minDate]=\"minDate\"\n                      [maxDate]=\"maxDate\"\n                      [minMode]=\"minMode\"\n                      [maxMode]=\"maxMode\"\n                      [showWeeks]=\"showWeeks\"\n                      [formatDay]=\"formatDay\"\n                      [formatMonth]=\"formatMonth\"\n                      [formatYear]=\"formatYear\"\n                      [formatDayHeader]=\"formatDayHeader\"\n                      [formatDayTitle]=\"formatDayTitle\"\n                      [formatMonthTitle]=\"formatMonthTitle\"\n                      [startingDay]=\"startingDay\"\n                      [yearRange]=\"yearRange\"\n                      [customClass]=\"customClass\"\n                      [dateDisabled]=\"dateDisabled\"\n                      [onlyCurrentMonth]=\"onlyCurrentMonth\"\n                      [shortcutPropagation]=\"shortcutPropagation\"\n                      [monthColLimit]=\"monthColLimit\"\n                      [yearColLimit]=\"yearColLimit\"\n                      (selectionDone)=\"onSelectionDone($event)\">\n      <daypicker tabindex=\"0\"></daypicker>\n      <monthpicker tabindex=\"0\"></monthpicker>\n      <yearpicker tabindex=\"0\"></yearpicker>\n    </datepicker-inner>\n    ",
                    providers: [forms_1.NgModel]
                },] },
    ];
    /** @nocollapse */
    DatePickerComponent.ctorParameters = [
        { type: forms_1.NgModel, decorators: [{ type: core_1.Self },] },
    ];
    DatePickerComponent.propDecorators = {
        'datepickerMode': [{ type: core_1.Input },],
        'initDate': [{ type: core_1.Input },],
        'minDate': [{ type: core_1.Input },],
        'maxDate': [{ type: core_1.Input },],
        'minMode': [{ type: core_1.Input },],
        'maxMode': [{ type: core_1.Input },],
        'showWeeks': [{ type: core_1.Input },],
        'formatDay': [{ type: core_1.Input },],
        'formatMonth': [{ type: core_1.Input },],
        'formatYear': [{ type: core_1.Input },],
        'formatDayHeader': [{ type: core_1.Input },],
        'formatDayTitle': [{ type: core_1.Input },],
        'formatMonthTitle': [{ type: core_1.Input },],
        'startingDay': [{ type: core_1.Input },],
        'yearRange': [{ type: core_1.Input },],
        'onlyCurrentMonth': [{ type: core_1.Input },],
        'shortcutPropagation': [{ type: core_1.Input },],
        'customClass': [{ type: core_1.Input },],
        'monthColLimit': [{ type: core_1.Input },],
        'yearColLimit': [{ type: core_1.Input },],
        'dateDisabled': [{ type: core_1.Input },],
        'selectionDone': [{ type: core_1.Output },],
        '_datePicker': [{ type: core_1.ViewChild, args: [datepicker_inner_component_1.DatePickerInnerComponent,] },],
        'activeDate': [{ type: core_1.Input },],
    };
    return DatePickerComponent;
}());
exports.DatePickerComponent = DatePickerComponent;


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var ng2_bootstrap_config_1 = __webpack_require__(83);
var datepicker_inner_component_1 = __webpack_require__(102);
// write an interface for template options
var TEMPLATE_OPTIONS = (_a = {},
    _a[ng2_bootstrap_config_1.Ng2BootstrapTheme.BS4] = {
        ARROW_LEFT: '&lt;',
        ARROW_RIGHT: '&gt;'
    },
    _a[ng2_bootstrap_config_1.Ng2BootstrapTheme.BS3] = {
        ARROW_LEFT: "\n    <i class=\"glyphicon glyphicon-chevron-left\"></i>\n    ",
        ARROW_RIGHT: "\n    <i class=\"glyphicon glyphicon-chevron-right\"></i>\n    "
    },
    _a
);
var DayPickerComponent = (function () {
    function DayPickerComponent(datePicker) {
        this.labels = [];
        this.rows = [];
        this.weekNumbers = [];
        this.CURRENT_THEME_TEMPLATE = TEMPLATE_OPTIONS[ng2_bootstrap_config_1.Ng2BootstrapConfig.theme || ng2_bootstrap_config_1.Ng2BootstrapTheme.BS3];
        this.datePicker = datePicker;
    }
    Object.defineProperty(DayPickerComponent.prototype, "isBS4", {
        get: function () {
            return ng2_bootstrap_config_1.Ng2BootstrapConfig.theme === ng2_bootstrap_config_1.Ng2BootstrapTheme.BS4;
        },
        enumerable: true,
        configurable: true
    });
    /*private getDaysInMonth(year:number, month:number) {
     return ((month === 1) && (year % 4 === 0) &&
     ((year % 100 !== 0) || (year % 400 === 0))) ? 29 : DAYS_IN_MONTH[month];
     }*/
    DayPickerComponent.prototype.ngOnInit = function () {
        var self = this;
        this.datePicker.stepDay = { months: 1 };
        this.datePicker.setRefreshViewHandler(function () {
            var year = this.activeDate.getFullYear();
            var month = this.activeDate.getMonth();
            var firstDayOfMonth = new Date(year, month, 1);
            var difference = this.startingDay - firstDayOfMonth.getDay();
            var numDisplayedFromPreviousMonth = (difference > 0)
                ? 7 - difference
                : -difference;
            var firstDate = new Date(firstDayOfMonth.getTime());
            if (numDisplayedFromPreviousMonth > 0) {
                firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
            }
            // 42 is the number of days on a six-week calendar
            var _days = self.getDates(firstDate, 42);
            var days = [];
            for (var i = 0; i < 42; i++) {
                var _dateObject = this.createDateObject(_days[i], this.formatDay);
                _dateObject.secondary = _days[i].getMonth() !== month;
                _dateObject.uid = this.uniqueId + '-' + i;
                days[i] = _dateObject;
            }
            self.labels = [];
            for (var j = 0; j < 7; j++) {
                self.labels[j] = {};
                self.labels[j].abbr = this.dateFilter(days[j].date, this.formatDayHeader);
                self.labels[j].full = this.dateFilter(days[j].date, 'EEEE');
            }
            self.title = this.dateFilter(this.activeDate, this.formatDayTitle);
            self.rows = this.split(days, 7);
            if (this.showWeeks) {
                self.weekNumbers = [];
                var thursdayIndex = (4 + 7 - this.startingDay) % 7;
                var numWeeks = self.rows.length;
                for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
                    self.weekNumbers.push(self.getISO8601WeekNumber(self.rows[curWeek][thursdayIndex].date));
                }
            }
        }, 'day');
        this.datePicker.setCompareHandler(function (date1, date2) {
            var d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
            var d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
            return d1.getTime() - d2.getTime();
        }, 'day');
        this.datePicker.refreshView();
    };
    DayPickerComponent.prototype.getDates = function (startDate, n) {
        var dates = new Array(n);
        var current = new Date(startDate.getTime());
        var i = 0;
        var date;
        while (i < n) {
            date = new Date(current.getTime());
            date = this.datePicker.fixTimeZone(date);
            dates[i++] = date;
            current = new Date(current.getFullYear(), current.getMonth(), current.getDate() + 1);
        }
        return dates;
    };
    DayPickerComponent.prototype.getISO8601WeekNumber = function (date) {
        var checkDate = new Date(date.getTime());
        // Thursday
        checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));
        var time = checkDate.getTime();
        // Compare with Jan 1
        checkDate.setMonth(0);
        checkDate.setDate(1);
        return Math.floor(Math.round((time - checkDate.getTime()) / 86400000) / 7) + 1;
    };
    // todo: key events implementation
    DayPickerComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'daypicker',
                    template: "\n<table *ngIf=\"datePicker.datepickerMode==='day'\" role=\"grid\" [attr.aria-labelledby]=\"datePicker.uniqueId+'-title'\" aria-activedescendant=\"activeDateId\">\n  <thead>\n    <tr>\n      <th>\n        <button type=\"button\" \n                class=\"btn btn-default btn-secondary btn-sm pull-left\" \n                (click)=\"datePicker.move(-1)\" \n                tabindex=\"-1\"\n                [innerHTML]=\"CURRENT_THEME_TEMPLATE.ARROW_LEFT\">\n        </button>\n      </th>\n      <th [attr.colspan]=\"5 + (datePicker.showWeeks ? 1 : 0)\">\n        <button [id]=\"datePicker.uniqueId + '-title'\"\n                type=\"button\" class=\"btn btn-default btn-secondary btn-sm\"\n                (click)=\"datePicker.toggleMode()\"\n                [disabled]=\"datePicker.datepickerMode === datePicker.maxMode\"\n                [ngClass]=\"{disabled: datePicker.datepickerMode === datePicker.maxMode}\" tabindex=\"-1\" style=\"width:100%;\">\n          <strong>{{title}}</strong>\n        </button>\n      </th>\n      <th>\n        <button type=\"button\" \n                class=\"btn btn-default btn-secondary btn-sm pull-right\" \n                (click)=\"datePicker.move(1)\" \n                tabindex=\"-1\"\n                [innerHTML]=\"CURRENT_THEME_TEMPLATE.ARROW_RIGHT\">\n        </button>\n      </th>\n    </tr>\n    <tr>\n      <th *ngIf=\"datePicker.showWeeks\"></th>\n      <th *ngFor=\"let labelz of labels\" [ngClass]=\"{'text-xs-center':isBS4, 'text-center': !isBS4}\">\n        <small aria-label=\"labelz.full\"><b>{{labelz.abbr}}</b></small>\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n    <template ngFor [ngForOf]=\"rows\" let-rowz=\"$implicit\" let-index=\"index\">\n      <tr *ngIf=\"!(datePicker.onlyCurrentMonth && rowz[0].secondary && rowz[6].secondary)\">\n        <td *ngIf=\"datePicker.showWeeks\" class=\"h6\" [ngClass]=\"{'text-xs-center':isBS4, 'text-center': !isBS4}\">\n          <em>{{ weekNumbers[index] }}</em>\n        </td>\n        <td *ngFor=\"let dtz of rowz\" [ngClass]=\"{'text-xs-center':isBS4, 'text-center': !isBS4}\" role=\"gridcell\" [id]=\"dtz.uid\">\n          <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-sm {{dtz.customClass}}\"\n                  *ngIf=\"!(datePicker.onlyCurrentMonth && dtz.secondary)\"\n                  [ngClass]=\"{'btn-secondary': isBS4 && !dtz.selected && !datePicker.isActive(dtz), 'btn-info': dtz.selected, disabled: dtz.disabled, active: !isBS4 && datePicker.isActive(dtz), 'btn-default': !isBS4}\"\n                  [disabled]=\"dtz.disabled\"\n                  (click)=\"datePicker.select(dtz.date)\" tabindex=\"-1\">\n            <span [ngClass]=\"{'text-muted': dtz.secondary || dtz.current, 'text-info': !isBS4 && dtz.current}\">{{dtz.label}}</span>\n          </button>\n        </td>\n      </tr>\n    </template>\n  </tbody>\n</table>\n  "
                },] },
    ];
    /** @nocollapse */
    DayPickerComponent.ctorParameters = [
        { type: datepicker_inner_component_1.DatePickerInnerComponent, },
    ];
    return DayPickerComponent;
}());
exports.DayPickerComponent = DayPickerComponent;
var _a;


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var ng2_bootstrap_config_1 = __webpack_require__(83);
var datepicker_inner_component_1 = __webpack_require__(102);
var MonthPickerComponent = (function () {
    function MonthPickerComponent(datePicker) {
        this.rows = [];
        this.datePicker = datePicker;
    }
    Object.defineProperty(MonthPickerComponent.prototype, "isBS4", {
        get: function () {
            return ng2_bootstrap_config_1.Ng2BootstrapConfig.theme === ng2_bootstrap_config_1.Ng2BootstrapTheme.BS4;
        },
        enumerable: true,
        configurable: true
    });
    MonthPickerComponent.prototype.ngOnInit = function () {
        var self = this;
        this.datePicker.stepMonth = { years: 1 };
        this.datePicker.setRefreshViewHandler(function () {
            var months = new Array(12);
            var year = this.activeDate.getFullYear();
            var date;
            for (var i = 0; i < 12; i++) {
                date = new Date(year, i, 1);
                date = this.fixTimeZone(date);
                months[i] = this.createDateObject(date, this.formatMonth);
                months[i].uid = this.uniqueId + '-' + i;
            }
            self.title = this.dateFilter(this.activeDate, this.formatMonthTitle);
            self.rows = this.split(months, self.datePicker.monthColLimit);
        }, 'month');
        this.datePicker.setCompareHandler(function (date1, date2) {
            var d1 = new Date(date1.getFullYear(), date1.getMonth());
            var d2 = new Date(date2.getFullYear(), date2.getMonth());
            return d1.getTime() - d2.getTime();
        }, 'month');
        this.datePicker.refreshView();
    };
    // todo: key events implementation
    MonthPickerComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'monthpicker',
                    template: "\n<table *ngIf=\"datePicker.datepickerMode==='month'\" role=\"grid\">\n  <thead>\n    <tr>\n      <th>\n        <button type=\"button\" class=\"btn btn-default btn-sm pull-left\"\n                (click)=\"datePicker.move(-1)\" tabindex=\"-1\">\n          <i class=\"glyphicon glyphicon-chevron-left\"></i>\n        </button></th>\n      <th [attr.colspan]=\"((datePicker.monthColLimit - 2) <= 0) ? 1 : datePicker.monthColLimit - 2\">\n        <button [id]=\"datePicker.uniqueId + '-title'\"\n                type=\"button\" class=\"btn btn-default btn-sm\"\n                (click)=\"datePicker.toggleMode()\"\n                [disabled]=\"datePicker.datepickerMode === maxMode\"\n                [ngClass]=\"{disabled: datePicker.datepickerMode === maxMode}\" tabindex=\"-1\" style=\"width:100%;\">\n          <strong>{{title}}</strong>\n        </button>\n      </th>\n      <th>\n        <button type=\"button\" class=\"btn btn-default btn-sm pull-right\"\n                (click)=\"datePicker.move(1)\" tabindex=\"-1\">\n          <i class=\"glyphicon glyphicon-chevron-right\"></i>\n        </button>\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr *ngFor=\"let rowz of rows\">\n      <td *ngFor=\"let dtz of rowz\" class=\"text-center\" role=\"gridcell\" id=\"{{dtz.uid}}\" [ngClass]=\"dtz.customClass\">\n        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\"\n                [ngClass]=\"{'btn-link': isBS4 && !dtz.selected && !datePicker.isActive(dtz), 'btn-info': dtz.selected || (isBS4 && !dtz.selected && datePicker.isActive(dtz)), disabled: dtz.disabled, active: !isBS4 && datePicker.isActive(dtz)}\"\n                [disabled]=\"dtz.disabled\"\n                (click)=\"datePicker.select(dtz.date)\" tabindex=\"-1\">\n          <span [ngClass]=\"{'text-success': isBS4 && dtz.current, 'text-info': !isBS4 && dtz.current}\">{{dtz.label}}</span>\n        </button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n  "
                },] },
    ];
    /** @nocollapse */
    MonthPickerComponent.ctorParameters = [
        { type: datepicker_inner_component_1.DatePickerInnerComponent, },
    ];
    return MonthPickerComponent;
}());
exports.MonthPickerComponent = MonthPickerComponent;


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var ng2_bootstrap_config_1 = __webpack_require__(83);
var datepicker_inner_component_1 = __webpack_require__(102);
var YearPickerComponent = (function () {
    function YearPickerComponent(datePicker) {
        this.rows = [];
        this.datePicker = datePicker;
    }
    Object.defineProperty(YearPickerComponent.prototype, "isBS4", {
        get: function () {
            return ng2_bootstrap_config_1.Ng2BootstrapConfig.theme === ng2_bootstrap_config_1.Ng2BootstrapTheme.BS4;
        },
        enumerable: true,
        configurable: true
    });
    YearPickerComponent.prototype.ngOnInit = function () {
        var self = this;
        this.datePicker.stepYear = { years: this.datePicker.yearRange };
        this.datePicker.setRefreshViewHandler(function () {
            var years = new Array(this.yearRange);
            var date;
            var start = self.getStartingYear(this.activeDate.getFullYear());
            for (var i = 0; i < this.yearRange; i++) {
                date = new Date(start + i, 0, 1);
                date = this.fixTimeZone(date);
                years[i] = this.createDateObject(date, this.formatYear);
                years[i].uid = this.uniqueId + '-' + i;
            }
            self.title = [years[0].label,
                years[this.yearRange - 1].label].join(' - ');
            self.rows = this.split(years, self.datePicker.yearColLimit);
        }, 'year');
        this.datePicker.setCompareHandler(function (date1, date2) {
            return date1.getFullYear() - date2.getFullYear();
        }, 'year');
        this.datePicker.refreshView();
    };
    YearPickerComponent.prototype.getStartingYear = function (year) {
        // todo: parseInt
        return ((year - 1) / this.datePicker.yearRange) * this.datePicker.yearRange + 1;
    };
    YearPickerComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'yearpicker',
                    template: "\n<table *ngIf=\"datePicker.datepickerMode==='year'\" role=\"grid\">\n  <thead>\n    <tr>\n      <th>\n        <button type=\"button\" class=\"btn btn-default btn-sm pull-left\"\n                (click)=\"datePicker.move(-1)\" tabindex=\"-1\">\n          <i class=\"glyphicon glyphicon-chevron-left\"></i>\n        </button>\n      </th>\n      <th [attr.colspan]=\"((datePicker.yearColLimit - 2) <= 0) ? 1 : datePicker.yearColLimit - 2\">\n        <button [id]=\"datePicker.uniqueId + '-title'\" role=\"heading\"\n                type=\"button\" class=\"btn btn-default btn-sm\"\n                (click)=\"datePicker.toggleMode()\"\n                [disabled]=\"datePicker.datepickerMode === datePicker.maxMode\"\n                [ngClass]=\"{disabled: datePicker.datepickerMode === datePicker.maxMode}\" tabindex=\"-1\" style=\"width:100%;\">\n          <strong>{{title}}</strong>\n        </button>\n      </th>\n      <th>\n        <button type=\"button\" class=\"btn btn-default btn-sm pull-right\"\n                (click)=\"datePicker.move(1)\" tabindex=\"-1\">\n          <i class=\"glyphicon glyphicon-chevron-right\"></i>\n        </button>\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr *ngFor=\"let rowz of rows\">\n      <td *ngFor=\"let dtz of rowz\" class=\"text-center\" role=\"gridcell\">\n        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\"\n                [ngClass]=\"{'btn-link': isBS4 && !dtz.selected && !datePicker.isActive(dtz), 'btn-info': dtz.selected || (isBS4 && !dtz.selected && datePicker.isActive(dtz)), disabled: dtz.disabled, active: !isBS4 && datePicker.isActive(dtz)}\"\n                [disabled]=\"dtz.disabled\"\n                (click)=\"datePicker.select(dtz.date)\" tabindex=\"-1\">\n          <span [ngClass]=\"{'text-success': isBS4 && dtz.current, 'text-info': !isBS4 && dtz.current}\">{{dtz.label}}</span>\n        </button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n  "
                },] },
    ];
    /** @nocollapse */
    YearPickerComponent.ctorParameters = [
        { type: datepicker_inner_component_1.DatePickerInnerComponent, },
    ];
    return YearPickerComponent;
}());
exports.YearPickerComponent = YearPickerComponent;


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var dropdown_directive_1 = __webpack_require__(157);
var DropdownMenuDirective = (function () {
    /* tslint:enable:no-unused-variable */
    function DropdownMenuDirective(dropdown, el) {
        /* tslint:disable:no-unused-variable */
        this.addClass = true;
        this.dropdown = dropdown;
        this.el = el;
    }
    DropdownMenuDirective.prototype.ngOnInit = function () {
        this.dropdown.dropDownMenu = this;
    };
    DropdownMenuDirective.decorators = [
        { type: core_1.Directive, args: [{
                    selector: '[dropdownMenu]',
                    exportAs: 'bs-dropdown-menu'
                },] },
    ];
    /** @nocollapse */
    DropdownMenuDirective.ctorParameters = [
        { type: dropdown_directive_1.DropdownDirective, decorators: [{ type: core_1.Host },] },
        { type: core_1.ElementRef, },
    ];
    DropdownMenuDirective.propDecorators = {
        'addClass': [{ type: core_1.HostBinding, args: ['class.dropdown-menu',] },],
    };
    return DropdownMenuDirective;
}());
exports.DropdownMenuDirective = DropdownMenuDirective;


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {"use strict";
var core_1 = __webpack_require__(0);
var dropdown_directive_1 = __webpack_require__(157);
/* tslint:disable-next-line */
var MouseEvent = global.MouseEvent;
var DropdownToggleDirective = (function () {
    function DropdownToggleDirective(dropdown, el) {
        this.isDisabled = false;
        this.addToggleClass = true;
        this.addClass = true;
        this.dropdown = dropdown;
        this.el = el;
    }
    DropdownToggleDirective.prototype.ngOnInit = function () {
        this.dropdown.dropDownToggle = this;
    };
    Object.defineProperty(DropdownToggleDirective.prototype, "isOpen", {
        get: function () {
            return this.dropdown.isOpen;
        },
        enumerable: true,
        configurable: true
    });
    DropdownToggleDirective.prototype.toggleDropdown = function (event) {
        event.stopPropagation();
        if (!this.isDisabled) {
            this.dropdown.toggle();
        }
        return false;
    };
    DropdownToggleDirective.decorators = [
        { type: core_1.Directive, args: [{
                    selector: '[dropdownToggle]',
                    exportAs: 'bs-dropdown-toggle'
                },] },
    ];
    /** @nocollapse */
    DropdownToggleDirective.ctorParameters = [
        { type: dropdown_directive_1.DropdownDirective, decorators: [{ type: core_1.Host },] },
        { type: core_1.ElementRef, },
    ];
    DropdownToggleDirective.propDecorators = {
        'isDisabled': [{ type: core_1.HostBinding, args: ['class.disabled',] }, { type: core_1.Input },],
        'addToggleClass': [{ type: core_1.HostBinding, args: ['class.dropdown-toggle',] }, { type: core_1.Input },],
        'addClass': [{ type: core_1.HostBinding, args: ['attr.aria-haspopup',] },],
        'isOpen': [{ type: core_1.HostBinding, args: ['attr.aria-expanded',] },],
        'toggleDropdown': [{ type: core_1.HostListener, args: ['click', ['$event'],] },],
    };
    return DropdownToggleDirective;
}());
exports.DropdownToggleDirective = DropdownToggleDirective;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23)))

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {"use strict";
exports.ALWAYS = 'always';
exports.DISABLED = 'disabled';
exports.OUTSIDECLICK = 'outsideClick';
exports.NONINPUT = 'nonInput';
/* tslint:disable-next-line */
var KeyboardEvent = global.KeyboardEvent;
/* tslint:disable-next-line */
var MouseEvent = global.MouseEvent;
var DropdownService = (function () {
    function DropdownService() {
        this.closeDropdownBind = this.closeDropdown.bind(this);
        this.keybindFilterBind = this.keybindFilter.bind(this);
    }
    DropdownService.prototype.open = function (dropdownScope) {
        if (!this.openScope) {
            window.document.addEventListener('click', this.closeDropdownBind, true);
            window.document.addEventListener('keydown', this.keybindFilterBind);
        }
        if (this.openScope && this.openScope !== dropdownScope) {
            this.openScope.isOpen = false;
        }
        this.openScope = dropdownScope;
    };
    DropdownService.prototype.close = function (dropdownScope) {
        if (this.openScope !== dropdownScope) {
            return;
        }
        this.openScope = void 0;
        window.document.removeEventListener('click', this.closeDropdownBind, true);
        window.document.removeEventListener('keydown', this.keybindFilterBind);
    };
    DropdownService.prototype.closeDropdown = function (event) {
        if (!this.openScope) {
            return;
        }
        if (event && this.openScope.autoClose === exports.DISABLED) {
            return;
        }
        if (event && this.openScope.toggleEl &&
            this.openScope.toggleEl.nativeElement.contains(event.target)) {
            return;
        }
        if (event && this.openScope.autoClose === exports.NONINPUT &&
            this.openScope.menuEl &&
            /input|textarea/i.test(event.target.tagName) &&
            this.openScope.menuEl.nativeElement.contains(event.target)) {
            return;
        }
        if (event && this.openScope.autoClose === exports.OUTSIDECLICK &&
            this.openScope.menuEl &&
            this.openScope.menuEl.nativeElement.contains(event.target)) {
            return;
        }
        this.openScope.isOpen = false;
    };
    DropdownService.prototype.keybindFilter = function (event) {
        if (event.which === 27) {
            this.openScope.focusToggleElement();
            this.closeDropdown(void 0);
            return;
        }
        if (this.openScope.keyboardNav && this.openScope.isOpen &&
            (event.which === 38 || event.which === 40)) {
            event.preventDefault();
            event.stopPropagation();
            this.openScope.focusDropdownEntry(event.which);
        }
    };
    return DropdownService;
}());
exports.DropdownService = DropdownService;
exports.dropdownService = new DropdownService();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23)))

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
// todo: should we support enforce focus in?
// todo: in original bs there are was a way to prevent modal from showing
// todo: original modal had resize events
"use strict";
var core_1 = __webpack_require__(0);
var components_helper_service_1 = __webpack_require__(53);
var utils_class_1 = __webpack_require__(1011);
var modal_backdrop_component_1 = __webpack_require__(239);
var modal_options_class_1 = __webpack_require__(240);
var browser_1 = __webpack_require__(258);
var TRANSITION_DURATION = 300;
var BACKDROP_TRANSITION_DURATION = 150;
var ModalDirective = (function () {
    function ModalDirective(element, renderer, componentsHelper) {
        this.element = element;
        this.renderer = renderer;
        this.componentsHelper = componentsHelper;
        this.onShow = new core_1.EventEmitter();
        this.onShown = new core_1.EventEmitter();
        this.onHide = new core_1.EventEmitter();
        this.onHidden = new core_1.EventEmitter();
        // seems like an Options
        this.isAnimated = true;
        this._isShown = false;
        this.isBodyOverflowing = false;
        this.originalBodyPadding = 0;
        this.scrollbarWidth = 0;
        this.timerHideModal = 0;
        this.timerRmBackDrop = 0;
    }
    Object.defineProperty(ModalDirective.prototype, "config", {
        get: function () {
            return this._config;
        },
        set: function (conf) {
            this._config = this.getConfig(conf);
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ModalDirective.prototype, "isShown", {
        get: function () {
            return this._isShown;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModalDirective.prototype, "document", {
        get: function () {
            return this.componentsHelper.getDocument();
        },
        enumerable: true,
        configurable: true
    });
    ;
    /** Host element manipulations */
    // @HostBinding(`class.${ClassName.IN}`) private _addClassIn:boolean;
    ModalDirective.prototype.onClick = function (event) {
        if (this.config.ignoreBackdropClick || this.config.backdrop === 'static' || event.target !== this.element.nativeElement) {
            return;
        }
        this.hide(event);
    };
    // todo: consider preventing default and stopping propagation
    ModalDirective.prototype.onEsc = function () {
        if (this.config.keyboard) {
            this.hide();
        }
    };
    ModalDirective.prototype.ngOnDestroy = function () {
        this.config = void 0;
        // this._element             = null
        // this._dialog              = null
        // this._backdrop            = null
        if (this._isShown) {
            this._isShown = false;
            this.hideModal();
        }
        this._isShown = void 0;
        this.isBodyOverflowing = void 0;
        this.originalBodyPadding = void 0;
        this.scrollbarWidth = void 0;
        this.timerHideModal = void 0;
        this.timerRmBackDrop = void 0;
    };
    ModalDirective.prototype.ngAfterViewInit = function () {
        this._config = this._config || this.getConfig();
    };
    /** Public methods */
    ModalDirective.prototype.toggle = function () {
        return this._isShown ? this.hide() : this.show();
    };
    ModalDirective.prototype.show = function () {
        var _this = this;
        this.onShow.emit(this);
        if (this._isShown) {
            return;
        }
        clearTimeout(this.timerHideModal);
        clearTimeout(this.timerRmBackDrop);
        this._isShown = true;
        this.checkScrollbar();
        this.setScrollbar();
        if (this.document && this.document.body) {
            this.renderer.setElementClass(this.document.body, modal_options_class_1.ClassName.OPEN, true);
        }
        this.showBackdrop(function () {
            _this.showElement();
        });
    };
    ModalDirective.prototype.hide = function (event) {
        var _this = this;
        if (event) {
            event.preventDefault();
        }
        this.onHide.emit(this);
        // todo: add an option to prevent hiding
        if (!this._isShown) {
            return;
        }
        clearTimeout(this.timerHideModal);
        clearTimeout(this.timerRmBackDrop);
        this._isShown = false;
        this.renderer.setElementClass(this.element.nativeElement, modal_options_class_1.ClassName.IN, false);
        // this._addClassIn = false;
        if (this.isAnimated) {
            this.timerHideModal = setTimeout(function () { return _this.hideModal(); }, TRANSITION_DURATION);
        }
        else {
            this.hideModal();
        }
    };
    /** Private methods */
    ModalDirective.prototype.getConfig = function (config) {
        return Object.assign({}, modal_options_class_1.modalConfigDefaults, config);
    };
    /**
     *  Show dialog
     */
    ModalDirective.prototype.showElement = function () {
        var _this = this;
        // todo: replace this with component helper usage `add to root`
        if (!this.element.nativeElement.parentNode ||
            (this.element.nativeElement.parentNode.nodeType !== Node.ELEMENT_NODE)) {
            // don't move modals dom position
            if (this.document && this.document.body) {
                this.document.body.appendChild(this.element.nativeElement);
            }
        }
        this.renderer.setElementAttribute(this.element.nativeElement, 'aria-hidden', 'false');
        this.renderer.setElementStyle(this.element.nativeElement, 'display', 'block');
        this.renderer.setElementProperty(this.element.nativeElement, 'scrollTop', 0);
        if (this.isAnimated) {
            utils_class_1.Utils.reflow(this.element.nativeElement);
        }
        // this._addClassIn = true;
        this.renderer.setElementClass(this.element.nativeElement, modal_options_class_1.ClassName.IN, true);
        var transitionComplete = function () {
            if (_this._config.focus) {
                _this.element.nativeElement.focus();
            }
            _this.onShown.emit(_this);
        };
        if (this.isAnimated) {
            setTimeout(transitionComplete, TRANSITION_DURATION);
        }
        else {
            transitionComplete();
        }
    };
    ModalDirective.prototype.hideModal = function () {
        var _this = this;
        this.renderer.setElementAttribute(this.element.nativeElement, 'aria-hidden', 'true');
        this.renderer.setElementStyle(this.element.nativeElement, 'display', 'none');
        this.showBackdrop(function () {
            if (_this.document && _this.document.body) {
                _this.renderer.setElementClass(_this.document.body, modal_options_class_1.ClassName.OPEN, false);
            }
            _this.resetAdjustments();
            _this.resetScrollbar();
            _this.onHidden.emit(_this);
        });
    };
    // todo: original show was calling a callback when done, but we can use promise
    ModalDirective.prototype.showBackdrop = function (callback) {
        var _this = this;
        if (this._isShown && this.config.backdrop && (!this.backdrop || !this.backdrop.instance.isShown)) {
            this.removeBackdrop();
            this.backdrop = this.componentsHelper
                .appendNextToRoot(modal_backdrop_component_1.ModalBackdropComponent, modal_backdrop_component_1.ModalBackdropOptions, new modal_backdrop_component_1.ModalBackdropOptions({ animate: false }));
            if (this.isAnimated) {
                this.backdrop.instance.isAnimated = this.isAnimated;
                utils_class_1.Utils.reflow(this.backdrop.instance.element.nativeElement);
            }
            this.backdrop.instance.isShown = true;
            if (!callback) {
                return;
            }
            if (!this.isAnimated) {
                callback();
                return;
            }
            setTimeout(callback, BACKDROP_TRANSITION_DURATION);
        }
        else if (!this._isShown && this.backdrop) {
            this.backdrop.instance.isShown = false;
            var callbackRemove = function () {
                _this.removeBackdrop();
                if (callback) {
                    callback();
                }
            };
            if (this.backdrop.instance.isAnimated) {
                this.timerRmBackDrop = setTimeout(callbackRemove, BACKDROP_TRANSITION_DURATION);
            }
            else {
                callbackRemove();
            }
        }
        else if (callback) {
            callback();
        }
    };
    ModalDirective.prototype.removeBackdrop = function () {
        if (this.backdrop) {
            this.backdrop.destroy();
            this.backdrop = void 0;
        }
    };
    /** Events tricks */
    // no need for it
    // private setEscapeEvent():void {
    //   if (this._isShown && this._config.keyboard) {
    //     $(this._element).on(Event.KEYDOWN_DISMISS, (event) => {
    //       if (event.which === 27) {
    //         this.hide()
    //       }
    //     })
    //
    //   } else if (!this._isShown) {
    //     $(this._element).off(Event.KEYDOWN_DISMISS)
    //   }
    // }
    // private setResizeEvent():void {
    // console.log(this.renderer.listenGlobal('', Event.RESIZE));
    // if (this._isShown) {
    //   $(window).on(Event.RESIZE, $.proxy(this._handleUpdate, this))
    // } else {
    //   $(window).off(Event.RESIZE)
    // }
    // }
    ModalDirective.prototype.resetAdjustments = function () {
        this.renderer.setElementStyle(this.element.nativeElement, 'paddingLeft', '');
        this.renderer.setElementStyle(this.element.nativeElement, 'paddingRight', '');
    };
    /** Scroll bar tricks */
    ModalDirective.prototype.checkScrollbar = function () {
        this.isBodyOverflowing = this.document.body.clientWidth < browser_1.window.innerWidth;
        this.scrollbarWidth = this.getScrollbarWidth();
    };
    ModalDirective.prototype.setScrollbar = function () {
        if (!this.document) {
            return;
        }
        var fixedEl = this.document.querySelector(modal_options_class_1.Selector.FIXED_CONTENT);
        if (!fixedEl) {
            return;
        }
        var bodyPadding = parseInt(utils_class_1.Utils.getStyles(fixedEl).paddingRight || 0, 10);
        this.originalBodyPadding = parseInt(this.document.body.style.paddingRight || 0, 10);
        if (this.isBodyOverflowing) {
            this.document.body.style.paddingRight = (bodyPadding + this.scrollbarWidth) + "px";
        }
    };
    ModalDirective.prototype.resetScrollbar = function () {
        this.document.body.style.paddingRight = this.originalBodyPadding;
    };
    // thx d.walsh
    ModalDirective.prototype.getScrollbarWidth = function () {
        var scrollDiv = this.renderer.createElement(this.document.body, 'div', void 0);
        scrollDiv.className = modal_options_class_1.ClassName.SCROLLBAR_MEASURER;
        var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        this.document.body.removeChild(scrollDiv);
        return scrollbarWidth;
    };
    ModalDirective.decorators = [
        { type: core_1.Directive, args: [{
                    selector: '[bsModal]',
                    exportAs: 'bs-modal'
                },] },
    ];
    /** @nocollapse */
    ModalDirective.ctorParameters = [
        { type: core_1.ElementRef, },
        { type: core_1.Renderer, },
        { type: components_helper_service_1.ComponentsHelper, },
    ];
    ModalDirective.propDecorators = {
        'config': [{ type: core_1.Input },],
        'onShow': [{ type: core_1.Output },],
        'onShown': [{ type: core_1.Output },],
        'onHide': [{ type: core_1.Output },],
        'onHidden': [{ type: core_1.Output },],
        'onClick': [{ type: core_1.HostListener, args: ['click', ['$event'],] },],
        'onEsc': [{ type: core_1.HostListener, args: ['keydown.esc',] },],
    };
    return ModalDirective;
}());
exports.ModalDirective = ModalDirective;


/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(10);
var pagination_component_1 = __webpack_require__(242);
var pagerConfig = {
    itemsPerPage: 10,
    previousText: '« Previous',
    nextText: 'Next »',
    pageBtnClass: '',
    align: true
};
var PAGER_TEMPLATE = "\n    <ul class=\"pager\">\n      <li [class.disabled]=\"noPrevious()\" [class.previous]=\"align\" [ngClass]=\"{'pull-right': align}\" class=\"{{ pageBtnClass }}\">\n        <a href (click)=\"selectPage(page - 1, $event)\">{{getText('previous')}}</a>\n      </li>\n      <li [class.disabled]=\"noNext()\" [class.next]=\"align\" [ngClass]=\"{'pull-right': align}\" class=\"{{ pageBtnClass }}\">\n        <a href (click)=\"selectPage(page + 1, $event)\">{{getText('next')}}</a>\n      </li>\n  </ul>\n";
/* tslint:disable */
/* tslint:enable */
var PagerComponent = (function (_super) {
    __extends(PagerComponent, _super);
    function PagerComponent(cd, renderer, elementRef) {
        _super.call(this, cd, renderer, elementRef);
        this.config = pagerConfig;
    }
    PagerComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'pager[ngModel]',
                    template: PAGER_TEMPLATE,
                    providers: [forms_1.NgModel]
                },] },
    ];
    /** @nocollapse */
    PagerComponent.ctorParameters = [
        { type: forms_1.NgModel, decorators: [{ type: core_1.Self },] },
        { type: core_1.Renderer, },
        { type: core_1.ElementRef, },
    ];
    return PagerComponent;
}(pagination_component_1.PaginationComponent));
exports.PagerComponent = PagerComponent;


/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var progress_directive_1 = __webpack_require__(245);
// todo: number pipe
// todo: use query from progress?
var BarComponent = (function () {
    function BarComponent(progress) {
        this.percent = 0;
        this.progress = progress;
    }
    Object.defineProperty(BarComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (v) {
            if (!v && v !== 0) {
                return;
            }
            this._value = v;
            this.recalculatePercentage();
        },
        enumerable: true,
        configurable: true
    });
    BarComponent.prototype.ngOnInit = function () {
        this.progress.addBar(this);
    };
    BarComponent.prototype.ngOnDestroy = function () {
        this.progress.removeBar(this);
    };
    BarComponent.prototype.recalculatePercentage = function () {
        this.percent = +(100 * this.value / this.progress.max).toFixed(2);
        var totalPercentage = this.progress.bars.reduce(function (total, bar) {
            return total + bar.percent;
        }, 0);
        if (totalPercentage > 100) {
            this.percent -= totalPercentage - 100;
        }
    };
    BarComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'bar',
                    template: "\n  <div class=\"progress-bar\"\n    style=\"min-width: 0;\"\n    role=\"progressbar\"\n    [ngClass]=\"type && 'progress-bar-' + type\"\n    [ngStyle]=\"{width: (percent < 100 ? percent : 100) + '%', transition: transition}\"\n    aria-valuemin=\"0\"\n    [attr.aria-valuenow]=\"value\"\n    [attr.aria-valuetext]=\"percent.toFixed(0) + '%'\"\n    [attr.aria-valuemax]=\"max\"><ng-content></ng-content></div>\n"
                },] },
    ];
    /** @nocollapse */
    BarComponent.ctorParameters = [
        { type: progress_directive_1.ProgressDirective, decorators: [{ type: core_1.Host },] },
    ];
    BarComponent.propDecorators = {
        'type': [{ type: core_1.Input },],
        'value': [{ type: core_1.Input },],
    };
    return BarComponent;
}());
exports.BarComponent = BarComponent;


/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var ProgressbarComponent = (function () {
    function ProgressbarComponent() {
    }
    ProgressbarComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'progressbar',
                    template: "\n    <div progress [animate]=\"animate\" [max]=\"max\">\n      <bar [type]=\"type\" [value]=\"value\">\n          <ng-content></ng-content>\n      </bar>\n    </div>\n  "
                },] },
    ];
    /** @nocollapse */
    ProgressbarComponent.ctorParameters = [];
    ProgressbarComponent.propDecorators = {
        'animate': [{ type: core_1.Input },],
        'max': [{ type: core_1.Input },],
        'type': [{ type: core_1.Input },],
        'value': [{ type: core_1.Input },],
    };
    return ProgressbarComponent;
}());
exports.ProgressbarComponent = ProgressbarComponent;


/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {"use strict";
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(10);
/* tslint:disable-next-line */
var KeyboardEvent = global.KeyboardEvent;
var RatingComponent = (function () {
    function RatingComponent(cd) {
        this.onHover = new core_1.EventEmitter(false);
        this.onLeave = new core_1.EventEmitter(false);
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
        this.cd = cd;
        cd.valueAccessor = this;
    }
    RatingComponent.prototype.onKeydown = function (event) {
        if ([37, 38, 39, 40].indexOf(event.which) === -1) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        var sign = event.which === 38 || event.which === 39 ? 1 : -1;
        this.rate(this.value + sign);
    };
    RatingComponent.prototype.ngOnInit = function () {
        this.max = typeof this.max !== 'undefined' ? this.max : 5;
        this.readonly = this.readonly === true;
        this.stateOn = typeof this.stateOn !== 'undefined'
            ? this.stateOn
            : 'glyphicon-star';
        this.stateOff = typeof this.stateOff !== 'undefined'
            ? this.stateOff
            : 'glyphicon-star-empty';
        this.titles = typeof this.titles !== 'undefined' && this.titles.length > 0
            ? this.titles
            : ['one', 'two', 'three', 'four', 'five'];
        this.range = this.buildTemplateObjects(this.ratingStates, this.max);
    };
    // model -> view
    RatingComponent.prototype.writeValue = function (value) {
        if (value % 1 !== value) {
            this.value = Math.round(value);
            this.preValue = value;
            return;
        }
        this.preValue = value;
        this.value = value;
    };
    RatingComponent.prototype.enter = function (value) {
        if (!this.readonly) {
            this.value = value;
            this.onHover.emit(value);
        }
    };
    RatingComponent.prototype.reset = function () {
        this.value = this.preValue;
        this.onLeave.emit(this.value);
    };
    RatingComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    RatingComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    RatingComponent.prototype.buildTemplateObjects = function (ratingStates, max) {
        ratingStates = ratingStates || [];
        var count = ratingStates.length || max;
        var result = [];
        for (var i = 0; i < count; i++) {
            result.push(Object.assign({
                index: i,
                stateOn: this.stateOn,
                stateOff: this.stateOff,
                title: this.titles[i] || i + 1
            }, ratingStates[i] || {}));
        }
        return result;
    };
    RatingComponent.prototype.rate = function (value) {
        if (!this.readonly && value >= 0 && value <= this.range.length) {
            this.writeValue(value);
            this.cd.viewToModelUpdate(value);
        }
    };
    RatingComponent.decorators = [
        { type: core_1.Component, args: [{
                    /* tslint:disable */
                    selector: 'rating[ngModel]',
                    /* tslint:enable */
                    template: "\n    <span (mouseleave)=\"reset()\" (keydown)=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" [attr.aria-valuemax]=\"range.length\" [attr.aria-valuenow]=\"value\">\n      <template ngFor let-r [ngForOf]=\"range\" let-index=\"index\">\n        <span class=\"sr-only\">({{ index < value ? '*' : ' ' }})</span>\n        <i (mouseenter)=\"enter(index + 1)\" (click)=\"rate(index + 1)\" class=\"glyphicon\" [ngClass]=\"index < value ? r.stateOn : r.stateOff\" [title]=\"r.title\" ></i>\n      </template>\n    </span>\n  ",
                    providers: [forms_1.NgModel]
                },] },
    ];
    /** @nocollapse */
    RatingComponent.ctorParameters = [
        { type: forms_1.NgModel, decorators: [{ type: core_1.Self },] },
    ];
    RatingComponent.propDecorators = {
        'max': [{ type: core_1.Input },],
        'stateOn': [{ type: core_1.Input },],
        'stateOff': [{ type: core_1.Input },],
        'readonly': [{ type: core_1.Input },],
        'titles': [{ type: core_1.Input },],
        'ratingStates': [{ type: core_1.Input },],
        'onHover': [{ type: core_1.Output },],
        'onLeave': [{ type: core_1.Output },],
        'onKeydown': [{ type: core_1.HostListener, args: ['keydown', ['$event'],] },],
    };
    return RatingComponent;
}());
exports.RatingComponent = RatingComponent;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23)))

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var tab_directive_1 = __webpack_require__(248);
var TabHeadingDirective = (function () {
    function TabHeadingDirective(templateRef, tab) {
        tab.headingRef = templateRef;
    }
    TabHeadingDirective.decorators = [
        { type: core_1.Directive, args: [{ selector: '[tabHeading]' },] },
    ];
    /** @nocollapse */
    TabHeadingDirective.ctorParameters = [
        { type: core_1.TemplateRef, },
        { type: tab_directive_1.TabDirective, },
    ];
    return TabHeadingDirective;
}());
exports.TabHeadingDirective = TabHeadingDirective;


/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(10);
// todo: implement global configuration via DI
// todo: refactor directive has to many functions! (extract to stateless helper)
// todo: use moment js?
// todo: implement `time` validator
// todo: replace increment/decrement blockers with getters, or extract
// todo: unify work with selected
exports.timepickerConfig = {
    hourStep: 1,
    minuteStep: 1,
    showMeridian: true,
    meridians: void 0,
    readonlyInput: false,
    mousewheel: true,
    arrowkeys: true,
    showSpinners: true,
    min: void 0,
    max: void 0
};
function isDefined(value) {
    return typeof value !== 'undefined';
}
function def(value, fn, defaultValue) {
    return fn(value) ? value : defaultValue;
}
function addMinutes(date, minutes) {
    var dt = new Date(date.getTime() + minutes * 60000);
    var newDate = new Date(date);
    newDate.setHours(dt.getHours(), dt.getMinutes());
    return newDate;
}
var TimepickerComponent = (function () {
    function TimepickerComponent(cd) {
        this.meridians = ['AM', 'PM']; // ??
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
        // result value
        this._selected = new Date();
        this.cd = cd;
        cd.valueAccessor = this;
    }
    Object.defineProperty(TimepickerComponent.prototype, "showMeridian", {
        get: function () {
            return this._showMeridian;
        },
        set: function (value) {
            this._showMeridian = value;
            // || !this.$error.time
            // if (true) {
            this.updateTemplate();
            return;
            // }
            // Evaluate from template
            /*let hours = this.getHoursFromTemplate();
             let minutes = this.getMinutesFromTemplate();
             if (isDefined(hours) && isDefined(minutes)) {
             this.selected.setHours(hours);
             this.refresh();
             }*/
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimepickerComponent.prototype, "selected", {
        get: function () {
            return this._selected;
        },
        set: function (v) {
            if (v) {
                this._selected = v;
                this.updateTemplate();
                this.cd.viewToModelUpdate(this.selected);
            }
        },
        enumerable: true,
        configurable: true
    });
    // todo: add formatter value to Date object
    TimepickerComponent.prototype.ngOnInit = function () {
        // todo: take in account $locale.DATETIME_FORMATS.AMPMS;
        this.meridians = def(this.meridians, isDefined, exports.timepickerConfig.meridians) || ['AM',
            'PM'];
        this.mousewheel = def(this.mousewheel, isDefined, exports.timepickerConfig.mousewheel);
        if (this.mousewheel) {
        }
        this.arrowkeys = def(this.arrowkeys, isDefined, exports.timepickerConfig.arrowkeys);
        if (this.arrowkeys) {
        }
        this.readonlyInput = def(this.readonlyInput, isDefined, exports.timepickerConfig.readonlyInput);
        // this.setupInputEvents();
        this.hourStep = def(this.hourStep, isDefined, exports.timepickerConfig.hourStep);
        this.minuteStep = def(this.minuteStep, isDefined, exports.timepickerConfig.minuteStep);
        this.min = def(this.min, isDefined, exports.timepickerConfig.min);
        this.max = def(this.max, isDefined, exports.timepickerConfig.max);
        // 12H / 24H mode
        this.showMeridian = def(this.showMeridian, isDefined, exports.timepickerConfig.showMeridian);
        this.showSpinners = def(this.showSpinners, isDefined, exports.timepickerConfig.showSpinners);
    };
    TimepickerComponent.prototype.writeValue = function (v) {
        if (v === this.selected) {
            return;
        }
        if (v && v instanceof Date) {
            this.selected = v;
            return;
        }
        this.selected = v ? new Date(v) : void 0;
    };
    TimepickerComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    TimepickerComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    TimepickerComponent.prototype.setDisabledState = function (isDisabled) {
        this.readonlyInput = isDisabled;
    };
    TimepickerComponent.prototype.updateHours = function () {
        if (this.readonlyInput) {
            return;
        }
        var hours = this.getHoursFromTemplate();
        var minutes = this.getMinutesFromTemplate();
        this.invalidHours = !isDefined(hours);
        this.invalidMinutes = !isDefined(minutes);
        if (this.invalidHours || this.invalidMinutes) {
            // TODO: needed a validation functionality.
            return;
        }
        this.selected.setHours(hours);
        this.invalidHours = (this.selected < this.min || this.selected > this.max);
        if (this.invalidHours) {
            // todo: validation?
            // invalidate(true);
            return;
        }
        else {
            this.refresh();
        }
    };
    // tslint:disable-next-line:no-unused-variable
    TimepickerComponent.prototype.hoursOnBlur = function (event) {
        if (this.readonlyInput) {
            return;
        }
        // todo: binded with validation
        if (!this.invalidHours && parseInt(this.hours, 10) < 10) {
            this.hours = this.pad(this.hours);
        }
    };
    TimepickerComponent.prototype.updateMinutes = function () {
        if (this.readonlyInput) {
            return;
        }
        var minutes = this.getMinutesFromTemplate();
        var hours = this.getHoursFromTemplate();
        this.invalidMinutes = !isDefined(minutes);
        this.invalidHours = !isDefined(hours);
        if (this.invalidMinutes || this.invalidHours) {
            // TODO: needed a validation functionality.
            return;
        }
        this.selected.setMinutes(minutes);
        this.invalidMinutes = (this.selected < this.min || this.selected > this.max);
        if (this.invalidMinutes) {
            // todo: validation
            // invalidate(undefined, true);
            return;
        }
        else {
            this.refresh();
        }
    };
    // tslint:disable-next-line:no-unused-variable
    TimepickerComponent.prototype.minutesOnBlur = function (event) {
        if (this.readonlyInput) {
            return;
        }
        if (!this.invalidMinutes && parseInt(this.minutes, 10) < 10) {
            this.minutes = this.pad(this.minutes);
        }
    };
    TimepickerComponent.prototype.incrementHours = function () {
        if (!this.noIncrementHours()) {
            this.addMinutesToSelected(this.hourStep * 60);
        }
    };
    TimepickerComponent.prototype.decrementHours = function () {
        if (!this.noDecrementHours()) {
            this.addMinutesToSelected(-this.hourStep * 60);
        }
    };
    TimepickerComponent.prototype.incrementMinutes = function () {
        if (!this.noIncrementMinutes()) {
            this.addMinutesToSelected(this.minuteStep);
        }
    };
    TimepickerComponent.prototype.decrementMinutes = function () {
        if (!this.noDecrementMinutes()) {
            this.addMinutesToSelected(-this.minuteStep);
        }
    };
    TimepickerComponent.prototype.noIncrementHours = function () {
        var incrementedSelected = addMinutes(this.selected, this.hourStep * 60);
        return incrementedSelected > this.max ||
            (incrementedSelected < this.selected && incrementedSelected < this.min);
    };
    TimepickerComponent.prototype.noDecrementHours = function () {
        var decrementedSelected = addMinutes(this.selected, -this.hourStep * 60);
        return decrementedSelected < this.min ||
            (decrementedSelected > this.selected && decrementedSelected > this.max);
    };
    TimepickerComponent.prototype.noIncrementMinutes = function () {
        var incrementedSelected = addMinutes(this.selected, this.minuteStep);
        return incrementedSelected > this.max ||
            (incrementedSelected < this.selected && incrementedSelected < this.min);
    };
    TimepickerComponent.prototype.noDecrementMinutes = function () {
        var decrementedSelected = addMinutes(this.selected, -this.minuteStep);
        return decrementedSelected < this.min ||
            (decrementedSelected > this.selected && decrementedSelected > this.max);
    };
    TimepickerComponent.prototype.toggleMeridian = function () {
        if (!this.noToggleMeridian()) {
            var sign = this.selected.getHours() < 12 ? 1 : -1;
            this.addMinutesToSelected(12 * 60 * sign);
        }
    };
    TimepickerComponent.prototype.refresh = function () {
        // this.makeValid();
        this.updateTemplate();
        this.cd.viewToModelUpdate(this.selected);
    };
    TimepickerComponent.prototype.updateTemplate = function () {
        var hours = this.selected.getHours();
        var minutes = this.selected.getMinutes();
        if (this.showMeridian) {
            // Convert 24 to 12 hour system
            hours = (hours === 0 || hours === 12) ? 12 : hours % 12;
        }
        // this.hours = keyboardChange === 'h' ? hours : this.pad(hours);
        // if (keyboardChange !== 'm') {
        //  this.minutes = this.pad(minutes);
        // }
        this.hours = this.pad(hours);
        this.minutes = this.pad(minutes);
        this.meridian = this.selected.getHours() < 12
            ? this.meridians[0]
            : this.meridians[1];
    };
    TimepickerComponent.prototype.getHoursFromTemplate = function () {
        var hours = parseInt(this.hours, 10);
        var valid = this.showMeridian
            ? (hours > 0 && hours < 13)
            : (hours >= 0 && hours < 24);
        if (!valid) {
            return void 0;
        }
        if (this.showMeridian) {
            if (hours === 12) {
                hours = 0;
            }
            if (this.meridian === this.meridians[1]) {
                hours = hours + 12;
            }
        }
        return hours;
    };
    TimepickerComponent.prototype.getMinutesFromTemplate = function () {
        var minutes = parseInt(this.minutes, 10);
        return (minutes >= 0 && minutes < 60) ? minutes : undefined;
    };
    TimepickerComponent.prototype.pad = function (value) {
        return (isDefined(value) && value.toString().length < 2)
            ? '0' + value
            : value.toString();
    };
    TimepickerComponent.prototype.addMinutesToSelected = function (minutes) {
        this.selected = addMinutes(this.selected, minutes);
        this.refresh();
    };
    TimepickerComponent.prototype.noToggleMeridian = function () {
        if (this.readonlyInput) {
            return true;
        }
        if (this.selected.getHours() < 13) {
            return addMinutes(this.selected, 12 * 60) > this.max;
        }
        else {
            return addMinutes(this.selected, -12 * 60) < this.min;
        }
    };
    TimepickerComponent.decorators = [
        { type: core_1.Component, args: [{
                    /* tslint:disable */
                    selector: 'timepicker[ngModel]',
                    /* tslint:enable */
                    template: "\n    <table>\n      <tbody>\n        <tr class=\"text-center\" [ngClass]=\"{hidden: !showSpinners || readonlyInput}\">\n          <td><a (click)=\"incrementHours()\" [ngClass]=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n          <td>&nbsp;</td>\n          <td><a (click)=\"incrementMinutes()\" [ngClass]=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n          <td [ngClass]=\"{hidden: !showMeridian}\" *ngIf=\"showMeridian\"></td>\n        </tr>\n        <tr>\n          <td class=\"form-group\" [ngClass]=\"{'has-error': invalidHours}\">\n            <input style=\"width:50px;\" type=\"text\" [(ngModel)]=\"hours\" (change)=\"updateHours()\" class=\"form-control text-center\" [readonly]=\"readonlyInput\" (blur)=\"hoursOnBlur($event)\" maxlength=\"2\">\n          </td>\n          <td>:</td>\n          <td class=\"form-group\" [ngClass]=\"{'has-error': invalidMinutes}\">\n            <input style=\"width:50px;\" type=\"text\" [(ngModel)]=\"minutes\" (change)=\"updateMinutes()\" class=\"form-control text-center\" [readonly]=\"readonlyInput\" (blur)=\"minutesOnBlur($event)\" maxlength=\"2\">\n          </td>\n          <td [ngClass]=\"{hidden: !showMeridian}\" *ngIf=\"showMeridian\"><button type=\"button\" [ngClass]=\"{disabled: noToggleMeridian() || readonlyInput}\" class=\"btn btn-default text-center\" (click)=\"toggleMeridian()\">{{meridian}}</button></td>\n        </tr>\n        <tr class=\"text-center\" [ngClass]=\"{hidden: !showSpinners || readonlyInput}\">\n          <td><a (click)=\"decrementHours()\" [ngClass]=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n          <td>&nbsp;</td>\n          <td><a (click)=\"decrementMinutes()\" [ngClass]=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n          <td [ngClass]=\"{hidden: !showMeridian}\" *ngIf=\"showMeridian\"></td>\n        </tr>\n      </tbody>\n    </table>\n  ",
                    providers: [forms_1.NgModel]
                },] },
    ];
    /** @nocollapse */
    TimepickerComponent.ctorParameters = [
        { type: forms_1.NgModel, decorators: [{ type: core_1.Self },] },
    ];
    TimepickerComponent.propDecorators = {
        'hourStep': [{ type: core_1.Input },],
        'minuteStep': [{ type: core_1.Input },],
        'readonlyInput': [{ type: core_1.Input },],
        'mousewheel': [{ type: core_1.Input },],
        'arrowkeys': [{ type: core_1.Input },],
        'showSpinners': [{ type: core_1.Input },],
        'min': [{ type: core_1.Input },],
        'max': [{ type: core_1.Input },],
        'meridians': [{ type: core_1.Input },],
        'showMeridian': [{ type: core_1.Input },],
    };
    return TimepickerComponent;
}());
exports.TimepickerComponent = TimepickerComponent;


/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var TooltipOptions = (function () {
    function TooltipOptions(options) {
        Object.assign(this, options);
    }
    TooltipOptions.decorators = [
        { type: core_1.Injectable },
    ];
    /** @nocollapse */
    TooltipOptions.ctorParameters = [
        { type: Object, },
    ];
    return TooltipOptions;
}());
exports.TooltipOptions = TooltipOptions;


/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var tooltip_container_component_1 = __webpack_require__(252);
var tooltip_options_class_1 = __webpack_require__(618);
var components_helper_service_1 = __webpack_require__(53);
/* tslint:disable */
/* tslint:enable */
var TooltipDirective = (function () {
    function TooltipDirective(viewContainerRef, componentsHelper, changeDetectorRef) {
        this.placement = 'top';
        this.enable = true;
        this.animation = true;
        this.appendToBody = false;
        this.delay = 0;
        /* tslint:enable */
        this.tooltipStateChanged = new core_1.EventEmitter();
        this.visible = false;
        this.viewContainerRef = viewContainerRef;
        this.componentsHelper = componentsHelper;
        this.changeDetectorRef = changeDetectorRef;
    }
    // todo: filter triggers
    // params: event, target
    TooltipDirective.prototype.show = function () {
        var _this = this;
        if (this.visible || !this.enable || this.delayTimeoutId) {
            return;
        }
        var showTooltip = function () {
            _this.visible = true;
            var options = new tooltip_options_class_1.TooltipOptions({
                content: _this.content,
                htmlContent: _this.htmlContent,
                placement: _this.placement,
                animation: _this.animation,
                appendToBody: _this.appendToBody,
                hostEl: _this.viewContainerRef.element,
                popupClass: _this.popupClass,
                context: _this.tooltipContext
            });
            if (_this.appendToBody) {
                _this.tooltip = _this.componentsHelper
                    .appendNextToRoot(tooltip_container_component_1.TooltipContainerComponent, tooltip_options_class_1.TooltipOptions, options);
            }
            else {
                var binding = core_1.ReflectiveInjector.resolve([
                    { provide: tooltip_options_class_1.TooltipOptions, useValue: options }
                ]);
                _this.tooltip = _this.componentsHelper
                    .appendNextToLocation(tooltip_container_component_1.TooltipContainerComponent, _this.viewContainerRef, binding);
            }
            _this.changeDetectorRef.markForCheck();
            _this.triggerStateChanged();
        };
        if (this.delay) {
            this.delayTimeoutId = setTimeout(function () { showTooltip(); }, this.delay);
        }
        else {
            showTooltip();
        }
    };
    // params event, target
    TooltipDirective.prototype.hide = function () {
        if (this.delayTimeoutId) {
            clearTimeout(this.delayTimeoutId);
            this.delayTimeoutId = undefined;
        }
        if (!this.visible) {
            return;
        }
        this.visible = false;
        this.tooltip.destroy();
        this.triggerStateChanged();
    };
    TooltipDirective.prototype.triggerStateChanged = function () {
        this.tooltipStateChanged.emit(this.visible);
    };
    TooltipDirective.decorators = [
        { type: core_1.Directive, args: [{
                    selector: '[tooltip], [tooltipHtml]',
                    exportAs: 'bs-tooltip'
                },] },
    ];
    /** @nocollapse */
    TooltipDirective.ctorParameters = [
        { type: core_1.ViewContainerRef, },
        { type: components_helper_service_1.ComponentsHelper, },
        { type: core_1.ChangeDetectorRef, },
    ];
    TooltipDirective.propDecorators = {
        'content': [{ type: core_1.Input, args: ['tooltip',] },],
        'htmlContent': [{ type: core_1.Input, args: ['tooltipHtml',] },],
        'placement': [{ type: core_1.Input, args: ['tooltipPlacement',] },],
        'isOpen': [{ type: core_1.Input, args: ['tooltipIsOpen',] },],
        'enable': [{ type: core_1.Input, args: ['tooltipEnable',] },],
        'animation': [{ type: core_1.Input, args: ['tooltipAnimation',] },],
        'appendToBody': [{ type: core_1.Input, args: ['tooltipAppendToBody',] },],
        'popupClass': [{ type: core_1.Input, args: ['tooltipClass',] },],
        'tooltipContext': [{ type: core_1.Input, args: ['tooltipContext',] },],
        'delay': [{ type: core_1.Input, args: ['tooltipPopupDelay',] },],
        'tooltipStateChanged': [{ type: core_1.Output },],
        'show': [{ type: core_1.HostListener, args: ['focusin',] }, { type: core_1.HostListener, args: ['mouseenter',] },],
        'hide': [{ type: core_1.HostListener, args: ['focusout',] }, { type: core_1.HostListener, args: ['mouseleave',] },],
    };
    return TooltipDirective;
}());
exports.TooltipDirective = TooltipDirective;


/***/ },
/* 620 */
/***/ function(module, exports) {

"use strict";
"use strict";
var TypeaheadMatch = (function () {
    function TypeaheadMatch(item, value, header) {
        if (value === void 0) { value = item; }
        if (header === void 0) { header = false; }
        this.item = item;
        this.value = value;
        this.header = header;
    }
    TypeaheadMatch.prototype.isHeader = function () {
        return this.header;
    };
    TypeaheadMatch.prototype.toString = function () {
        return this.value;
    };
    return TypeaheadMatch;
}());
exports.TypeaheadMatch = TypeaheadMatch;


/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {"use strict";
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(10);
var typeahead_container_component_1 = __webpack_require__(254);
var typeahead_options_class_1 = __webpack_require__(255);
var typeahead_utils_1 = __webpack_require__(256);
var Observable_1 = __webpack_require__(1);
__webpack_require__(729);
__webpack_require__(730);
__webpack_require__(733);
__webpack_require__(261);
__webpack_require__(734);
__webpack_require__(735);
var components_helper_service_1 = __webpack_require__(53);
var typeahead_match_class_1 = __webpack_require__(620);
/* tslint:disable-next-line */
var KeyboardEvent = global.KeyboardEvent;
var TypeaheadDirective = (function () {
    function TypeaheadDirective(control, viewContainerRef, element, renderer, componentsHelper) {
        this.typeaheadLoading = new core_1.EventEmitter(false);
        this.typeaheadNoResults = new core_1.EventEmitter(false);
        this.typeaheadOnSelect = new core_1.EventEmitter(false);
        this.typeaheadMinLength = void 0;
        this.typeaheadAsync = void 0;
        this.typeaheadLatinize = true;
        this.typeaheadSingleWords = true;
        this.typeaheadWordDelimiters = ' ';
        this.typeaheadPhraseDelimiters = '\'"';
        this.isTypeaheadOptionsListActive = false;
        this.keyUpEventEmitter = new core_1.EventEmitter();
        this.placement = 'bottom-left';
        this.element = element;
        this.ngControl = control;
        this.viewContainerRef = viewContainerRef;
        this.renderer = renderer;
        this.componentsHelper = componentsHelper;
    }
    TypeaheadDirective.prototype.onChange = function (e) {
        if (this.container) {
            // esc
            if (e.keyCode === 27) {
                this.hide();
                return;
            }
            // up
            if (e.keyCode === 38) {
                this.container.prevActiveMatch();
                return;
            }
            // down
            if (e.keyCode === 40) {
                this.container.nextActiveMatch();
                return;
            }
            // enter
            if (e.keyCode === 13) {
                this.container.selectActiveMatch();
                return;
            }
        }
        // For `<input>`s, use the `value` property. For others that don't have a
        // `value` (such as `<span contenteditable="true">`, use `innerText`.
        var value = e.target.value !== undefined ? e.target.value : e.target.innerText;
        if (value.trim().length >= this.typeaheadMinLength) {
            this.typeaheadLoading.emit(true);
            this.keyUpEventEmitter.emit(e.target.value);
        }
        else {
            this.typeaheadLoading.emit(false);
            this.typeaheadNoResults.emit(false);
            this.hide();
        }
    };
    TypeaheadDirective.prototype.onFocus = function () {
        if (this.typeaheadMinLength === 0) {
            this.typeaheadLoading.emit(true);
            this.keyUpEventEmitter.emit('');
        }
    };
    TypeaheadDirective.prototype.onBlur = function () {
        if (this.container && !this.container.isFocused) {
            this.hide();
        }
    };
    TypeaheadDirective.prototype.onKeydown = function (e) {
        // no container - no problems
        if (!this.container) {
            return;
        }
        // if items is visible - prevent form submition
        if (e.keyCode === 13) {
            e.preventDefault();
            return;
        }
        // if tab default browser behavior will select next input field, and therefore we should close the items list
        if (e.keyCode === 9) {
            this.hide();
            return;
        }
    };
    TypeaheadDirective.prototype.ngOnInit = function () {
        this.typeaheadOptionsLimit = this.typeaheadOptionsLimit || 20;
        this.typeaheadMinLength = this.typeaheadMinLength === void 0 ? 1 : this.typeaheadMinLength;
        this.typeaheadWaitMs = this.typeaheadWaitMs || 0;
        // async should be false in case of array
        if (this.typeaheadAsync === undefined && !(this.typeahead instanceof Observable_1.Observable)) {
            this.typeaheadAsync = false;
        }
        if (this.typeahead instanceof Observable_1.Observable) {
            this.typeaheadAsync = true;
        }
        if (this.typeaheadAsync) {
            this.asyncActions();
        }
        else {
            this.syncActions();
        }
    };
    TypeaheadDirective.prototype.changeModel = function (match) {
        var valueStr = match.value;
        this.ngControl.viewToModelUpdate(valueStr);
        this.ngControl.control.setValue(valueStr);
        this.hide();
    };
    Object.defineProperty(TypeaheadDirective.prototype, "matches", {
        get: function () {
            return this._matches;
        },
        enumerable: true,
        configurable: true
    });
    TypeaheadDirective.prototype.show = function () {
        var options = new typeahead_options_class_1.TypeaheadOptions({
            typeaheadRef: this,
            placement: this.placement,
            animation: false
        });
        var binding = core_1.ReflectiveInjector.resolve([
            { provide: typeahead_options_class_1.TypeaheadOptions, useValue: options }
        ]);
        this.popup = this.componentsHelper
            .appendNextToLocation(typeahead_container_component_1.TypeaheadContainerComponent, this.viewContainerRef, binding);
        this.popup.instance.position(this.viewContainerRef.element);
        this.container = this.popup.instance;
        this.container.parent = this;
        // This improves the speed as it won't have to be done for each list item
        var normalizedQuery = (this.typeaheadLatinize
            ? typeahead_utils_1.TypeaheadUtils.latinize(this.ngControl.control.value)
            : this.ngControl.control.value).toString()
            .toLowerCase();
        this.container.query = this.typeaheadSingleWords
            ? typeahead_utils_1.TypeaheadUtils.tokenize(normalizedQuery, this.typeaheadWordDelimiters, this.typeaheadPhraseDelimiters)
            : normalizedQuery;
        this.container.matches = this._matches;
        this.element.nativeElement.focus();
    };
    TypeaheadDirective.prototype.hide = function () {
        if (this.container) {
            this.popup.destroy();
            this.container = void 0;
        }
    };
    TypeaheadDirective.prototype.asyncActions = function () {
        var _this = this;
        this.keyUpEventEmitter
            .debounceTime(this.typeaheadWaitMs)
            .mergeMap(function () { return _this.typeahead; })
            .subscribe(function (matches) {
            _this.finalizeAsyncCall(matches);
        }, function (err) {
            console.error(err);
        });
    };
    TypeaheadDirective.prototype.syncActions = function () {
        var _this = this;
        this.keyUpEventEmitter
            .debounceTime(this.typeaheadWaitMs)
            .mergeMap(function (value) {
            var normalizedQuery = _this.normalizeQuery(value);
            return Observable_1.Observable.from(_this.typeahead)
                .filter(function (option) {
                return option && _this.testMatch(_this.normalizeOption(option), normalizedQuery);
            })
                .toArray();
        })
            .subscribe(function (matches) {
            _this.finalizeAsyncCall(matches);
        }, function (err) {
            console.error(err);
        });
    };
    TypeaheadDirective.prototype.normalizeOption = function (option) {
        var optionValue = typeahead_utils_1.TypeaheadUtils.getValueFromObject(option, this.typeaheadOptionField);
        var normalizedOption = this.typeaheadLatinize ? typeahead_utils_1.TypeaheadUtils.latinize(optionValue) : optionValue;
        return normalizedOption.toLowerCase();
    };
    TypeaheadDirective.prototype.normalizeQuery = function (value) {
        // If singleWords, break model here to not be doing extra work on each iteration
        var normalizedQuery = (this.typeaheadLatinize ? typeahead_utils_1.TypeaheadUtils.latinize(value) : value)
            .toString()
            .toLowerCase();
        normalizedQuery = this.typeaheadSingleWords ?
            typeahead_utils_1.TypeaheadUtils.tokenize(normalizedQuery, this.typeaheadWordDelimiters, this.typeaheadPhraseDelimiters) :
            normalizedQuery;
        return normalizedQuery;
    };
    TypeaheadDirective.prototype.testMatch = function (match, test) {
        var spaceLength;
        if (typeof test === 'object') {
            spaceLength = test.length;
            for (var i = 0; i < spaceLength; i += 1) {
                if (test[i].length > 0 && match.indexOf(test[i]) < 0) {
                    return false;
                }
            }
            return true;
        }
        else {
            return match.indexOf(test) >= 0;
        }
    };
    TypeaheadDirective.prototype.finalizeAsyncCall = function (matches) {
        this.prepareMatches(matches);
        this.typeaheadLoading.emit(false);
        this.typeaheadNoResults.emit(!this.hasMatches());
        if (!this.hasMatches()) {
            this.hide();
            return;
        }
        if (this.container) {
            // This improves the speed as it won't have to be done for each list item
            var normalizedQuery = (this.typeaheadLatinize
                ? typeahead_utils_1.TypeaheadUtils.latinize(this.ngControl.control.value)
                : this.ngControl.control.value).toString()
                .toLowerCase();
            this.container.query = this.typeaheadSingleWords
                ? typeahead_utils_1.TypeaheadUtils.tokenize(normalizedQuery, this.typeaheadWordDelimiters, this.typeaheadPhraseDelimiters)
                : normalizedQuery;
            this.container.matches = this._matches;
        }
        else {
            this.show();
        }
    };
    TypeaheadDirective.prototype.prepareMatches = function (options) {
        var _this = this;
        var limited = options.slice(0, this.typeaheadOptionsLimit);
        if (this.typeaheadGroupField) {
            var matches_1 = [];
            // extract all group names
            var groups = limited
                .map(function (option) { return typeahead_utils_1.TypeaheadUtils.getValueFromObject(option, _this.typeaheadGroupField); })
                .filter(function (v, i, a) { return a.indexOf(v) === i; });
            groups.forEach(function (group) {
                // add group header to array of matches
                matches_1.push(new typeahead_match_class_1.TypeaheadMatch(group, group, true));
                // add each item of group to array of matches
                matches_1 = matches_1.concat(limited
                    .filter(function (option) { return typeahead_utils_1.TypeaheadUtils.getValueFromObject(option, _this.typeaheadGroupField) === group; })
                    .map(function (option) { return new typeahead_match_class_1.TypeaheadMatch(option, typeahead_utils_1.TypeaheadUtils.getValueFromObject(option, _this.typeaheadOptionField)); }));
            });
            this._matches = matches_1;
        }
        else {
            this._matches = limited.map(function (option) { return new typeahead_match_class_1.TypeaheadMatch(option, typeahead_utils_1.TypeaheadUtils.getValueFromObject(option, _this.typeaheadOptionField)); });
        }
    };
    TypeaheadDirective.prototype.hasMatches = function () {
        return this._matches.length > 0;
    };
    TypeaheadDirective.decorators = [
        { type: core_1.Directive, args: [{
                    /* tslint:disable */
                    selector: '[typeahead][ngModel],[typeahead][formControlName]'
                },] },
    ];
    /** @nocollapse */
    TypeaheadDirective.ctorParameters = [
        { type: forms_1.NgControl, },
        { type: core_1.ViewContainerRef, },
        { type: core_1.ElementRef, },
        { type: core_1.Renderer, },
        { type: components_helper_service_1.ComponentsHelper, },
    ];
    TypeaheadDirective.propDecorators = {
        'typeaheadLoading': [{ type: core_1.Output },],
        'typeaheadNoResults': [{ type: core_1.Output },],
        'typeaheadOnSelect': [{ type: core_1.Output },],
        'typeahead': [{ type: core_1.Input },],
        'typeaheadMinLength': [{ type: core_1.Input },],
        'typeaheadWaitMs': [{ type: core_1.Input },],
        'typeaheadOptionsLimit': [{ type: core_1.Input },],
        'typeaheadOptionField': [{ type: core_1.Input },],
        'typeaheadGroupField': [{ type: core_1.Input },],
        'typeaheadAsync': [{ type: core_1.Input },],
        'typeaheadLatinize': [{ type: core_1.Input },],
        'typeaheadSingleWords': [{ type: core_1.Input },],
        'typeaheadWordDelimiters': [{ type: core_1.Input },],
        'typeaheadPhraseDelimiters': [{ type: core_1.Input },],
        'typeaheadItemTemplate': [{ type: core_1.Input },],
        'onChange': [{ type: core_1.HostListener, args: ['keyup', ['$event'],] },],
        'onFocus': [{ type: core_1.HostListener, args: ['focus',] },],
        'onBlur': [{ type: core_1.HostListener, args: ['blur',] },],
        'onKeydown': [{ type: core_1.HostListener, args: ['keydown', ['$event'],] },],
    };
    return TypeaheadDirective;
}());
exports.TypeaheadDirective = TypeaheadDirective;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23)))

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var af = moment.defineLocale('af', {
        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM : function (input) {
            return /^nm$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Vandag om] LT',
            nextDay : '[Môre om] LT',
            nextWeek : 'dddd [om] LT',
            lastDay : '[Gister om] LT',
            lastWeek : '[Laas] dddd [om] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'oor %s',
            past : '%s gelede',
            s : '\'n paar sekondes',
            m : '\'n minuut',
            mm : '%d minute',
            h : '\'n uur',
            hh : '%d ure',
            d : '\'n dag',
            dd : '%d dae',
            M : '\'n maand',
            MM : '%d maande',
            y : '\'n jaar',
            yy : '%d jaar'
        },
        ordinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week : {
            dow : 1, // Maandag is die eerste dag van die week.
            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        }
    });

    return af;

}));

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var symbolMap = {
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var ar_ly = moment.defineLocale('ar-ly', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/\u200f/g, '').replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ar_ly;

}));

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var ar_ma = moment.defineLocale('ar-ma', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ar_ma;

}));

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    };

    var ar_sa = moment.defineLocale('ar-sa', {
        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ar_sa;

}));

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var ar_tn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ar_tn;

}));

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'كانون الثاني يناير',
        'شباط فبراير',
        'آذار مارس',
        'نيسان أبريل',
        'أيار مايو',
        'حزيران يونيو',
        'تموز يوليو',
        'آب أغسطس',
        'أيلول سبتمبر',
        'تشرين الأول أكتوبر',
        'تشرين الثاني نوفمبر',
        'كانون الأول ديسمبر'
    ];

    var ar = moment.defineLocale('ar', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ar;

}));

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı'
    };

    var az = moment.defineLocale('az', {
        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[sabah saat] LT',
            nextWeek : '[gələn həftə] dddd [saat] LT',
            lastDay : '[dünən] LT',
            lastWeek : '[keçən həftə] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s əvvəl',
            s : 'birneçə saniyyə',
            m : 'bir dəqiqə',
            mm : '%d dəqiqə',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir il',
            yy : '%d il'
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM : function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        ordinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal : function (number) {
            if (number === 0) {  // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return az;

}));

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            'dd': 'дзень_дні_дзён',
            'MM': 'месяц_месяцы_месяцаў',
            'yy': 'год_гады_гадоў'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months : {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
        },
        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays : {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
            isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
        },
        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., HH:mm',
            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
        },
        calendar : {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'праз %s',
            past : '%s таму',
            s : 'некалькі секунд',
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithPlural,
            hh : relativeTimeWithPlural,
            d : 'дзень',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM : function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        ordinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return be;

}));

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var bg = moment.defineLocale('bg', {
        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Днес в] LT',
            nextDay : '[Утре в] LT',
            nextWeek : 'dddd [в] LT',
            lastDay : '[Вчера в] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[В изминалата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[В изминалия] dddd [в] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'след %s',
            past : 'преди %s',
            s : 'няколко секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дни',
            M : 'месец',
            MM : '%d месеца',
            y : 'година',
            yy : '%d години'
        },
        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bg;

}));

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var symbolMap = {
        '1': '১',
        '2': '২',
        '3': '৩',
        '4': '৪',
        '5': '৫',
        '6': '৬',
        '7': '৭',
        '8': '৮',
        '9': '৯',
        '0': '০'
    },
    numberMap = {
        '১': '1',
        '২': '2',
        '৩': '3',
        '৪': '4',
        '৫': '5',
        '৬': '6',
        '৭': '7',
        '৮': '8',
        '৯': '9',
        '০': '0'
    };

    var bn = moment.defineLocale('bn', {
        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
        longDateFormat : {
            LT : 'A h:mm সময়',
            LTS : 'A h:mm:ss সময়',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm সময়',
            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
        },
        calendar : {
            sameDay : '[আজ] LT',
            nextDay : '[আগামীকাল] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[গতকাল] LT',
            lastWeek : '[গত] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s পরে',
            past : '%s আগে',
            s : 'কয়েক সেকেন্ড',
            m : 'এক মিনিট',
            mm : '%d মিনিট',
            h : 'এক ঘন্টা',
            hh : '%d ঘন্টা',
            d : 'এক দিন',
            dd : '%d দিন',
            M : 'এক মাস',
            MM : '%d মাস',
            y : 'এক বছর',
            yy : '%d বছর'
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'রাত' && hour >= 4) ||
                    (meridiem === 'দুপুর' && hour < 5) ||
                    meridiem === 'বিকাল') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bn;

}));

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var symbolMap = {
        '1': '༡',
        '2': '༢',
        '3': '༣',
        '4': '༤',
        '5': '༥',
        '6': '༦',
        '7': '༧',
        '8': '༨',
        '9': '༩',
        '0': '༠'
    },
    numberMap = {
        '༡': '1',
        '༢': '2',
        '༣': '3',
        '༤': '4',
        '༥': '5',
        '༦': '6',
        '༧': '7',
        '༨': '8',
        '༩': '9',
        '༠': '0'
    };

    var bo = moment.defineLocale('bo', {
        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[དི་རིང] LT',
            nextDay : '[སང་ཉིན] LT',
            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay : '[ཁ་སང] LT',
            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ལ་',
            past : '%s སྔན་ལ',
            s : 'ལམ་སང',
            m : 'སྐར་མ་གཅིག',
            mm : '%d སྐར་མ',
            h : 'ཆུ་ཚོད་གཅིག',
            hh : '%d ཆུ་ཚོད',
            d : 'ཉིན་གཅིག',
            dd : '%d ཉིན་',
            M : 'ཟླ་བ་གཅིག',
            MM : '%d ཟླ་བ',
            y : 'ལོ་གཅིག',
            yy : '%d ལོ'
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
                    meridiem === 'དགོང་དག') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bo;

}));

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            'mm': 'munutenn',
            'MM': 'miz',
            'dd': 'devezh'
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            'm': 'v',
            'b': 'v',
            'd': 'z'
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var br = moment.defineLocale('br', {
        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h[e]mm A',
            LTS : 'h[e]mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [a viz] MMMM YYYY',
            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
        },
        calendar : {
            sameDay : '[Hiziv da] LT',
            nextDay : '[Warc\'hoazh da] LT',
            nextWeek : 'dddd [da] LT',
            lastDay : '[Dec\'h da] LT',
            lastWeek : 'dddd [paset da] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'a-benn %s',
            past : '%s \'zo',
            s : 'un nebeud segondennoù',
            m : 'ur vunutenn',
            mm : relativeTimeWithMutation,
            h : 'un eur',
            hh : '%d eur',
            d : 'un devezh',
            dd : relativeTimeWithMutation,
            M : 'ur miz',
            MM : relativeTimeWithMutation,
            y : 'ur bloaz',
            yy : specialMutationForYears
        },
        ordinalParse: /\d{1,2}(añ|vet)/,
        ordinal : function (number) {
            var output = (number === 1) ? 'añ' : 'vet';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return br;

}));

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bs;

}));

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var ca = moment.defineLocale('ca', {
        months : 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
        monthsShort : 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextDay : function () {
                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastDay : function () {
                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'fa %s',
            s : 'uns segons',
            m : 'un minut',
            mm : '%d minuts',
            h : 'una hora',
            hh : '%d hores',
            d : 'un dia',
            dd : '%d dies',
            M : 'un mes',
            MM : '%d mesos',
            y : 'un any',
            yy : '%d anys'
        },
        ordinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal : function (number, period) {
            var output = (number === 1) ? 'r' :
                (number === 2) ? 'n' :
                (number === 3) ? 'r' :
                (number === 4) ? 't' : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ca;

}));

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
    function plural(n) {
        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
                break;
        }
    }

    var cs = moment.defineLocale('cs', {
        months : months,
        monthsShort : monthsShort,
        monthsParse : (function (months, monthsShort) {
            var i, _monthsParse = [];
            for (i = 0; i < 12; i++) {
                // use custom parser to solve problem with July (červenec)
                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
            }
            return _monthsParse;
        }(months, monthsShort)),
        shortMonthsParse : (function (monthsShort) {
            var i, _shortMonthsParse = [];
            for (i = 0; i < 12; i++) {
                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
            }
            return _shortMonthsParse;
        }(monthsShort)),
        longMonthsParse : (function (months) {
            var i, _longMonthsParse = [];
            for (i = 0; i < 12; i++) {
                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
            }
            return _longMonthsParse;
        }(months)),
        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm',
            l : 'D. M. YYYY'
        },
        calendar : {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'před %s',
            s : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        ordinalParse : /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cs;

}));

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var cv = moment.defineLocale('cv', {
        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
        },
        calendar : {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L'
        },
        relativeTime : {
            future : function (output) {
                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
                return output + affix;
            },
            past : '%s каялла',
            s : 'пӗр-ик ҫеккунт',
            m : 'пӗр минут',
            mm : '%d минут',
            h : 'пӗр сехет',
            hh : '%d сехет',
            d : 'пӗр кун',
            dd : '%d кун',
            M : 'пӗр уйӑх',
            MM : '%d уйӑх',
            y : 'пӗр ҫул',
            yy : '%d ҫул'
        },
        ordinalParse: /\d{1,2}-мӗш/,
        ordinal : '%d-мӗш',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return cv;

}));

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS : 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd'
        },
        ordinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cy;

}));

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var da = moment.defineLocale('da', {
        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd [d.] D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[I dag kl.] LT',
            nextDay : '[I morgen kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[I går kl.] LT',
            lastWeek : '[sidste] dddd [kl] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'få sekunder',
            m : 'et minut',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dage',
            M : 'en måned',
            MM : '%d måneder',
            y : 'et år',
            yy : '%d år'
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return da;

}));

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de_at = moment.defineLocale('de-at', {
        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return de_at;

}));

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return de;

}));

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var months = [
        'ޖެނުއަރީ',
        'ފެބްރުއަރީ',
        'މާރިޗު',
        'އޭޕްރީލު',
        'މޭ',
        'ޖޫން',
        'ޖުލައި',
        'އޯގަސްޓު',
        'ސެޕްޓެމްބަރު',
        'އޮކްޓޯބަރު',
        'ނޮވެމްބަރު',
        'ޑިސެމްބަރު'
    ], weekdays = [
        'އާދިއްތަ',
        'ހޯމަ',
        'އަންގާރަ',
        'ބުދަ',
        'ބުރާސްފަތި',
        'ހުކުރު',
        'ހޮނިހިރު'
    ];

    var dv = moment.defineLocale('dv', {
        months : months,
        monthsShort : months,
        weekdays : weekdays,
        weekdaysShort : weekdays,
        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat : {

            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/M/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /މކ|މފ/,
        isPM : function (input) {
            return 'މފ' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar : {
            sameDay : '[މިއަދު] LT',
            nextDay : '[މާދަމާ] LT',
            nextWeek : 'dddd LT',
            lastDay : '[އިއްޔެ] LT',
            lastWeek : '[ފާއިތުވި] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ތެރޭގައި %s',
            past : 'ކުރިން %s',
            s : 'ސިކުންތުކޮޅެއް',
            m : 'މިނިޓެއް',
            mm : 'މިނިޓު %d',
            h : 'ގަޑިއިރެއް',
            hh : 'ގަޑިއިރު %d',
            d : 'ދުވަހެއް',
            dd : 'ދުވަސް %d',
            M : 'މަހެއް',
            MM : 'މަސް %d',
            y : 'އަހަރެއް',
            yy : 'އަހަރު %d'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 7,  // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return dv;

}));

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }


    var el = moment.defineLocale('el', {
        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
        months : function (momentToFormat, format) {
            if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM : function (input) {
            return ((input + '').toLowerCase()[0] === 'μ');
        },
        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendarEl : {
            sameDay : '[Σήμερα {}] LT',
            nextDay : '[Αύριο {}] LT',
            nextWeek : 'dddd [{}] LT',
            lastDay : '[Χθες {}] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse : 'L'
        },
        calendar : function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
        },
        relativeTime : {
            future : 'σε %s',
            past : '%s πριν',
            s : 'λίγα δευτερόλεπτα',
            m : 'ένα λεπτό',
            mm : '%d λεπτά',
            h : 'μία ώρα',
            hh : '%d ώρες',
            d : 'μία μέρα',
            dd : '%d μέρες',
            M : 'ένας μήνας',
            MM : '%d μήνες',
            y : 'ένας χρόνος',
            yy : '%d χρόνια'
        },
        ordinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4st is the first week of the year.
        }
    });

    return el;

}));

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var en_au = moment.defineLocale('en-au', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return en_au;

}));

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var en_ca = moment.defineLocale('en-ca', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'YYYY-MM-DD',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY h:mm A',
            LLLL : 'dddd, MMMM D, YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return en_ca;

}));

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var en_gb = moment.defineLocale('en-gb', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return en_gb;

}));

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var en_ie = moment.defineLocale('en-ie', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return en_ie;

}));

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var en_nz = moment.defineLocale('en-nz', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return en_nz;

}));

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
//!          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var eo = moment.defineLocale('eo', {
        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
        weekdays : 'Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato'.split('_'),
        weekdaysShort : 'Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab'.split('_'),
        weekdaysMin : 'Di_Lu_Ma_Me_Ĵa_Ve_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D[-an de] MMMM, YYYY',
            LLL : 'D[-an de] MMMM, YYYY HH:mm',
            LLLL : 'dddd, [la] D[-an de] MMMM, YYYY HH:mm'
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar : {
            sameDay : '[Hodiaŭ je] LT',
            nextDay : '[Morgaŭ je] LT',
            nextWeek : 'dddd [je] LT',
            lastDay : '[Hieraŭ je] LT',
            lastWeek : '[pasinta] dddd [je] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'je %s',
            past : 'antaŭ %s',
            s : 'sekundoj',
            m : 'minuto',
            mm : '%d minutoj',
            h : 'horo',
            hh : '%d horoj',
            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
            dd : '%d tagoj',
            M : 'monato',
            MM : '%d monatoj',
            y : 'jaro',
            yy : '%d jaroj'
        },
        ordinalParse: /\d{1,2}a/,
        ordinal : '%da',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return eo;

}));

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var es_do = moment.defineLocale('es-do', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsParseExact : true,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY h:mm A',
            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        ordinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es_do;

}));

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var es = moment.defineLocale('es', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsParseExact : true,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        ordinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es;

}));

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            'm' : ['ühe minuti', 'üks minut'],
            'mm': [number + ' minuti', number + ' minutit'],
            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
            'hh': [number + ' tunni', number + ' tundi'],
            'd' : ['ühe päeva', 'üks päev'],
            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
            'MM': [number + ' kuu', number + ' kuud'],
            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
            'yy': [number + ' aasta', number + ' aastat']
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat : {
            LT   : 'H:mm',
            LTS : 'H:mm:ss',
            L    : 'DD.MM.YYYY',
            LL   : 'D. MMMM YYYY',
            LLL  : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[Täna,] LT',
            nextDay  : '[Homme,] LT',
            nextWeek : '[Järgmine] dddd LT',
            lastDay  : '[Eile,] LT',
            lastWeek : '[Eelmine] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s pärast',
            past   : '%s tagasi',
            s      : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : '%d päeva',
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return et;

}));

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var eu = moment.defineLocale('eu', {
        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
        monthsParseExact : true,
        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY[ko] MMMM[ren] D[a]',
            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l : 'YYYY-M-D',
            ll : 'YYYY[ko] MMM D[a]',
            lll : 'YYYY[ko] MMM D[a] HH:mm',
            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
        },
        calendar : {
            sameDay : '[gaur] LT[etan]',
            nextDay : '[bihar] LT[etan]',
            nextWeek : 'dddd LT[etan]',
            lastDay : '[atzo] LT[etan]',
            lastWeek : '[aurreko] dddd LT[etan]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s barru',
            past : 'duela %s',
            s : 'segundo batzuk',
            m : 'minutu bat',
            mm : '%d minutu',
            h : 'ordu bat',
            hh : '%d ordu',
            d : 'egun bat',
            dd : '%d egun',
            M : 'hilabete bat',
            MM : '%d hilabete',
            y : 'urte bat',
            yy : '%d urte'
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return eu;

}));

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var symbolMap = {
        '1': '۱',
        '2': '۲',
        '3': '۳',
        '4': '۴',
        '5': '۵',
        '6': '۶',
        '7': '۷',
        '8': '۸',
        '9': '۹',
        '0': '۰'
    }, numberMap = {
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',
        '۰': '0'
    };

    var fa = moment.defineLocale('fa', {
        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar : {
            sameDay : '[امروز ساعت] LT',
            nextDay : '[فردا ساعت] LT',
            nextWeek : 'dddd [ساعت] LT',
            lastDay : '[دیروز ساعت] LT',
            lastWeek : 'dddd [پیش] [ساعت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'در %s',
            past : '%s پیش',
            s : 'چندین ثانیه',
            m : 'یک دقیقه',
            mm : '%d دقیقه',
            h : 'یک ساعت',
            hh : '%d ساعت',
            d : 'یک روز',
            dd : '%d روز',
            M : 'یک ماه',
            MM : '%d ماه',
            y : 'یک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/[۰-۹]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        ordinalParse: /\d{1,2}م/,
        ordinal : '%dم',
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return fa;

}));

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
        numbersFuture = [
            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
            numbersPast[7], numbersPast[8], numbersPast[9]
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
    }

    var fi = moment.defineLocale('fi', {
        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'Do MMMM[ta] YYYY',
            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l : 'D.M.YYYY',
            ll : 'Do MMM YYYY',
            lll : 'Do MMM YYYY, [klo] HH.mm',
            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
        },
        calendar : {
            sameDay : '[tänään] [klo] LT',
            nextDay : '[huomenna] [klo] LT',
            nextWeek : 'dddd [klo] LT',
            lastDay : '[eilen] [klo] LT',
            lastWeek : '[viime] dddd[na] [klo] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s päästä',
            past : '%s sitten',
            s : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fi;

}));

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var fo = moment.defineLocale('fo', {
        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D. MMMM, YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Í dag kl.] LT',
            nextDay : '[Í morgin kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[Í gjár kl.] LT',
            lastWeek : '[síðstu] dddd [kl] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'um %s',
            past : '%s síðani',
            s : 'fá sekund',
            m : 'ein minutt',
            mm : '%d minuttir',
            h : 'ein tími',
            hh : '%d tímar',
            d : 'ein dagur',
            dd : '%d dagar',
            M : 'ein mánaði',
            MM : '%d mánaðir',
            y : 'eitt ár',
            yy : '%d ár'
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fo;

}));

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var fr_ca = moment.defineLocale('fr-ca', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Aujourd\'hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        ordinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number) {
            return number + (number === 1 ? 'er' : 'e');
        }
    });

    return fr_ca;

}));

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var fr_ch = moment.defineLocale('fr-ch', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Aujourd\'hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        ordinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number) {
            return number + (number === 1 ? 'er' : 'e');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fr_ch;

}));

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var fr = moment.defineLocale('fr', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Aujourd\'hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        ordinalParse: /\d{1,2}(er|)/,
        ordinal : function (number) {
            return number + (number === 1 ? 'er' : '');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fr;

}));

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
        monthsShort : function (m, format) {
            if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact : true,
        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'oer %s',
            past : '%s lyn',
            s : 'in pear sekonden',
            m : 'ien minút',
            mm : '%d minuten',
            h : 'ien oere',
            hh : '%d oeren',
            d : 'ien dei',
            dd : '%d dagen',
            M : 'ien moanne',
            MM : '%d moannen',
            y : 'ien jier',
            yy : '%d jierren'
        },
        ordinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fy;

}));

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var months = [
        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
    ];

    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months : months,
        monthsShort : monthsShort,
        monthsParseExact : true,
        weekdays : weekdays,
        weekdaysShort : weekdaysShort,
        weekdaysMin : weekdaysMin,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[An-diugh aig] LT',
            nextDay : '[A-màireach aig] LT',
            nextWeek : 'dddd [aig] LT',
            lastDay : '[An-dè aig] LT',
            lastWeek : 'dddd [seo chaidh] [aig] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ann an %s',
            past : 'bho chionn %s',
            s : 'beagan diogan',
            m : 'mionaid',
            mm : '%d mionaidean',
            h : 'uair',
            hh : '%d uairean',
            d : 'latha',
            dd : '%d latha',
            M : 'mìos',
            MM : '%d mìosan',
            y : 'bliadhna',
            yy : '%d bliadhna'
        },
        ordinalParse : /\d{1,2}(d|na|mh)/,
        ordinal : function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gd;

}));

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var gl = moment.defineLocale('gl', {
        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextDay : function () {
                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            lastDay : function () {
                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
            },
            lastWeek : function () {
                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past : 'hai %s',
            s : 'uns segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'unha hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un ano',
            yy : '%d anos'
        },
        ordinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gl;

}));

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var he = moment.defineLocale('he', {
        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [ב]MMMM YYYY',
            LLL : 'D [ב]MMMM YYYY HH:mm',
            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
            l : 'D/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[היום ב־]LT',
            nextDay : '[מחר ב־]LT',
            nextWeek : 'dddd [בשעה] LT',
            lastDay : '[אתמול ב־]LT',
            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'בעוד %s',
            past : 'לפני %s',
            s : 'מספר שניות',
            m : 'דקה',
            mm : '%d דקות',
            h : 'שעה',
            hh : function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d : 'יום',
            dd : function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M : 'חודש',
            MM : function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y : 'שנה',
            yy : function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            }
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM : function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        }
    });

    return he;

}));

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var hi = moment.defineLocale('hi', {
        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        monthsParseExact: true,
        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm बजे',
            LTS : 'A h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[कल] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[कल] LT',
            lastWeek : '[पिछले] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s में',
            past : '%s पहले',
            s : 'कुछ ही क्षण',
            m : 'एक मिनट',
            mm : '%d मिनट',
            h : 'एक घंटा',
            hh : '%d घंटे',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महीने',
            MM : '%d महीने',
            y : 'एक वर्ष',
            yy : '%d वर्ष'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return hi;

}));

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months : {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
        },
        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return hr;

}));

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number,
            suffix;
        switch (key) {
            case 's':
                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
    }

    var hu = moment.defineLocale('hu', {
        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY. MMMM D.',
            LLL : 'YYYY. MMMM D. H:mm',
            LLLL : 'YYYY. MMMM D., dddd H:mm'
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar : {
            sameDay : '[ma] LT[-kor]',
            nextDay : '[holnap] LT[-kor]',
            nextWeek : function () {
                return week.call(this, true);
            },
            lastDay : '[tegnap] LT[-kor]',
            lastWeek : function () {
                return week.call(this, false);
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s múlva',
            past : '%s',
            s : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return hu;

}));

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var hy_am = moment.defineLocale('hy-am', {
        months : {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
        },
        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY թ.',
            LLL : 'D MMMM YYYY թ., HH:mm',
            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
        },
        calendar : {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s հետո',
            past : '%s առաջ',
            s : 'մի քանի վայրկյան',
            m : 'րոպե',
            mm : '%d րոպե',
            h : 'ժամ',
            hh : '%d ժամ',
            d : 'օր',
            dd : '%d օր',
            M : 'ամիս',
            MM : '%d ամիս',
            y : 'տարի',
            yy : '%d տարի'
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem : function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        ordinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return hy_am;

}));

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var id = moment.defineLocale('id', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Besok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kemarin pukul] LT',
            lastWeek : 'dddd [lalu pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lalu',
            s : 'beberapa detik',
            m : 'semenit',
            mm : '%d menit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return id;

}));

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
        },
        calendar : {
            sameDay : '[í dag kl.] LT',
            nextDay : '[á morgun kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[í gær kl.] LT',
            lastWeek : '[síðasta] dddd [kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'eftir %s',
            past : 'fyrir %s síðan',
            s : translate,
            m : translate,
            mm : translate,
            h : 'klukkustund',
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return is;

}));

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var it = moment.defineLocale('it', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
        weekdaysShort : 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
        weekdaysMin : 'Do_Lu_Ma_Me_Gi_Ve_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        ordinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return it;

}));

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var ja = moment.defineLocale('ja', {
        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
        longDateFormat : {
            LT : 'Ah時m分',
            LTS : 'Ah時m分s秒',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日Ah時m分',
            LLLL : 'YYYY年M月D日Ah時m分 dddd'
        },
        meridiemParse: /午前|午後/i,
        isPM : function (input) {
            return input === '午後';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar : {
            sameDay : '[今日] LT',
            nextDay : '[明日] LT',
            nextWeek : '[来週]dddd LT',
            lastDay : '[昨日] LT',
            lastWeek : '[前週]dddd LT',
            sameElse : 'L'
        },
        ordinalParse : /\d{1,2}日/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s後',
            past : '%s前',
            s : '数秒',
            m : '1分',
            mm : '%d分',
            h : '1時間',
            hh : '%d時間',
            d : '1日',
            dd : '%d日',
            M : '1ヶ月',
            MM : '%dヶ月',
            y : '1年',
            yy : '%d年'
        }
    });

    return ja;

}));

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var jv = moment.defineLocale('jv', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar : {
            sameDay : '[Dinten puniko pukul] LT',
            nextDay : '[Mbenjang pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kala wingi pukul] LT',
            lastWeek : 'dddd [kepengker pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'wonten ing %s',
            past : '%s ingkang kepengker',
            s : 'sawetawis detik',
            m : 'setunggal menit',
            mm : '%d menit',
            h : 'setunggal jam',
            hh : '%d jam',
            d : 'sedinten',
            dd : '%d dinten',
            M : 'sewulan',
            MM : '%d wulan',
            y : 'setaun',
            yy : '%d taun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return jv;

}));

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var ka = moment.defineLocale('ka', {
        months : {
            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
        },
        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays : {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
            isFormat: /(წინა|შემდეგ)/
        },
        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[დღეს] LT[-ზე]',
            nextDay : '[ხვალ] LT[-ზე]',
            lastDay : '[გუშინ] LT[-ზე]',
            nextWeek : '[შემდეგ] dddd LT[-ზე]',
            lastWeek : '[წინა] dddd LT-ზე',
            sameElse : 'L'
        },
        relativeTime : {
            future : function (s) {
                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                    s.replace(/ი$/, 'ში') :
                    s + 'ში';
            },
            past : function (s) {
                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if ((/წელი/).test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
            },
            s : 'რამდენიმე წამი',
            m : 'წუთი',
            mm : '%d წუთი',
            h : 'საათი',
            hh : '%d საათი',
            d : 'დღე',
            dd : '%d დღე',
            M : 'თვე',
            MM : '%d თვე',
            y : 'წელი',
            yy : '%d წელი'
        },
        ordinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal : function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week : {
            dow : 1,
            doy : 7
        }
    });

    return ka;

}));

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші'
    };

    var kk = moment.defineLocale('kk', {
        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгін сағат] LT',
            nextDay : '[Ертең сағат] LT',
            nextWeek : 'dddd [сағат] LT',
            lastDay : '[Кеше сағат] LT',
            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ішінде',
            past : '%s бұрын',
            s : 'бірнеше секунд',
            m : 'бір минут',
            mm : '%d минут',
            h : 'бір сағат',
            hh : '%d сағат',
            d : 'бір күн',
            dd : '%d күн',
            M : 'бір ай',
            MM : '%d ай',
            y : 'бір жыл',
            yy : '%d жыл'
        },
        ordinalParse: /\d{1,2}-(ші|шы)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return kk;

}));

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS : 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return km;

}));

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var ko = moment.defineLocale('ko', {
        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
        longDateFormat : {
            LT : 'A h시 m분',
            LTS : 'A h시 m분 s초',
            L : 'YYYY.MM.DD',
            LL : 'YYYY년 MMMM D일',
            LLL : 'YYYY년 MMMM D일 A h시 m분',
            LLLL : 'YYYY년 MMMM D일 dddd A h시 m분'
        },
        calendar : {
            sameDay : '오늘 LT',
            nextDay : '내일 LT',
            nextWeek : 'dddd LT',
            lastDay : '어제 LT',
            lastWeek : '지난주 dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s 후',
            past : '%s 전',
            s : '몇 초',
            ss : '%d초',
            m : '일분',
            mm : '%d분',
            h : '한 시간',
            hh : '%d시간',
            d : '하루',
            dd : '%d일',
            M : '한 달',
            MM : '%d달',
            y : '일 년',
            yy : '%d년'
        },
        ordinalParse : /\d{1,2}일/,
        ordinal : '%d일',
        meridiemParse : /오전|오후/,
        isPM : function (token) {
            return token === '오후';
        },
        meridiem : function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        }
    });

    return ko;

}));

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';



    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү'
    };

    var ky = moment.defineLocale('ky', {
        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгүн саат] LT',
            nextDay : '[Эртең саат] LT',
            nextWeek : 'dddd [саат] LT',
            lastDay : '[Кече саат] LT',
            lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ичинде',
            past : '%s мурун',
            s : 'бирнече секунд',
            m : 'бир мүнөт',
            mm : '%d мүнөт',
            h : 'бир саат',
            hh : '%d саат',
            d : 'бир күн',
            dd : '%d күн',
            M : 'бир ай',
            MM : '%d ай',
            y : 'бир жыл',
            yy : '%d жыл'
        },
        ordinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ky;

}));

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eng Minutt', 'enger Minutt'],
            'h': ['eng Stonn', 'enger Stonn'],
            'd': ['een Dag', 'engem Dag'],
            'M': ['ee Mount', 'engem Mount'],
            'y': ['ee Joer', 'engem Joer']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10, firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            }
        },
        relativeTime : {
            future : processFutureTime,
            past : processPastTime,
            s : 'e puer Sekonnen',
            m : processRelativeTime,
            mm : '%d Minutten',
            h : processRelativeTime,
            hh : '%d Stonnen',
            d : processRelativeTime,
            dd : '%d Deeg',
            M : processRelativeTime,
            MM : '%d Méint',
            y : processRelativeTime,
            yy : '%d Joer'
        },
        ordinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lb;

}));

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var lo = moment.defineLocale('lo', {
        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar : {
            sameDay : '[ມື້ນີ້ເວລາ] LT',
            nextDay : '[ມື້ອື່ນເວລາ] LT',
            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ອີກ %s',
            past : '%sຜ່ານມາ',
            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
            m : '1 ນາທີ',
            mm : '%d ນາທີ',
            h : '1 ຊົ່ວໂມງ',
            hh : '%d ຊົ່ວໂມງ',
            d : '1 ມື້',
            dd : '%d ມື້',
            M : '1 ເດືອນ',
            MM : '%d ເດືອນ',
            y : '1 ປີ',
            yy : '%d ປີ'
        },
        ordinalParse: /(ທີ່)\d{1,2}/,
        ordinal : function (number) {
            return 'ທີ່' + number;
        }
    });

    return lo;

}));

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var units = {
        'm' : 'minutė_minutės_minutę',
        'mm': 'minutės_minučių_minutes',
        'h' : 'valanda_valandos_valandą',
        'hh': 'valandos_valandų_valandas',
        'd' : 'diena_dienos_dieną',
        'dd': 'dienos_dienų_dienas',
        'M' : 'mėnuo_mėnesio_mėnesį',
        'MM': 'mėnesiai_mėnesių_mėnesius',
        'y' : 'metai_metų_metus',
        'yy': 'metai_metų_metus'
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months : {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?|MMMM?(\[[^\[\]]*\]|\s+)+D[oD]?/
        },
        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays : {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
            isFormat: /dddd HH:mm/
        },
        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY [m.] MMMM D [d.]',
            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l : 'YYYY-MM-DD',
            ll : 'YYYY [m.] MMMM D [d.]',
            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
        },
        calendar : {
            sameDay : '[Šiandien] LT',
            nextDay : '[Rytoj] LT',
            nextWeek : 'dddd LT',
            lastDay : '[Vakar] LT',
            lastWeek : '[Praėjusį] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'po %s',
            past : 'prieš %s',
            s : translateSeconds,
            m : translateSingular,
            mm : translate,
            h : translateSingular,
            hh : translate,
            d : translateSingular,
            dd : translate,
            M : translateSingular,
            MM : translate,
            y : translateSingular,
            yy : translate
        },
        ordinalParse: /\d{1,2}-oji/,
        ordinal : function (number) {
            return number + '-oji';
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lt;

}));

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var units = {
        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'h': 'stundas_stundām_stunda_stundas'.split('_'),
        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
        'd': 'dienas_dienām_diena_dienas'.split('_'),
        'dd': 'dienas_dienām_diena_dienas'.split('_'),
        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'y': 'gada_gadiem_gads_gadi'.split('_'),
        'yy': 'gada_gadiem_gads_gadi'.split('_')
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY.',
            LL : 'YYYY. [gada] D. MMMM',
            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
        },
        calendar : {
            sameDay : '[Šodien pulksten] LT',
            nextDay : '[Rīt pulksten] LT',
            nextWeek : 'dddd [pulksten] LT',
            lastDay : '[Vakar pulksten] LT',
            lastWeek : '[Pagājušā] dddd [pulksten] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'pēc %s',
            past : 'pirms %s',
            s : relativeSeconds,
            m : relativeTimeWithSingular,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithSingular,
            hh : relativeTimeWithPlural,
            d : relativeTimeWithSingular,
            dd : relativeTimeWithPlural,
            M : relativeTimeWithSingular,
            MM : relativeTimeWithPlural,
            y : relativeTimeWithSingular,
            yy : relativeTimeWithPlural
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lv;

}));

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact : true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'nekoliko sekundi',
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mjesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return me;

}));

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau'
        },
        ordinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mi;

}));

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var mk = moment.defineLocale('mk', {
        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Денес во] LT',
            nextDay : '[Утре во] LT',
            nextWeek : '[Во] dddd [во] LT',
            lastDay : '[Вчера во] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'после %s',
            past : 'пред %s',
            s : 'неколку секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дена',
            M : 'месец',
            MM : '%d месеци',
            y : 'година',
            yy : '%d години'
        },
        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return mk;

}));

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var ml = moment.defineLocale('ml', {
        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm -നു',
            LTS : 'A h:mm:ss -നു',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm -നു',
            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
        },
        calendar : {
            sameDay : '[ഇന്ന്] LT',
            nextDay : '[നാളെ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ഇന്നലെ] LT',
            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s കഴിഞ്ഞ്',
            past : '%s മുൻപ്',
            s : 'അൽപ നിമിഷങ്ങൾ',
            m : 'ഒരു മിനിറ്റ്',
            mm : '%d മിനിറ്റ്',
            h : 'ഒരു മണിക്കൂർ',
            hh : '%d മണിക്കൂർ',
            d : 'ഒരു ദിവസം',
            dd : '%d ദിവസം',
            M : 'ഒരു മാസം',
            MM : '%d മാസം',
            y : 'ഒരു വർഷം',
            yy : '%d വർഷം'
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'രാത്രി' && hour >= 4) ||
                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                    meridiem === 'വൈകുന്നേരം') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        }
    });

    return ml;

}));

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    function relativeTimeMr(number, withoutSuffix, string, isFuture)
    {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's': output = 'काही सेकंद'; break;
                case 'm': output = 'एक मिनिट'; break;
                case 'mm': output = '%d मिनिटे'; break;
                case 'h': output = 'एक तास'; break;
                case 'hh': output = '%d तास'; break;
                case 'd': output = 'एक दिवस'; break;
                case 'dd': output = '%d दिवस'; break;
                case 'M': output = 'एक महिना'; break;
                case 'MM': output = '%d महिने'; break;
                case 'y': output = 'एक वर्ष'; break;
                case 'yy': output = '%d वर्षे'; break;
            }
        }
        else {
            switch (string) {
                case 's': output = 'काही सेकंदां'; break;
                case 'm': output = 'एका मिनिटा'; break;
                case 'mm': output = '%d मिनिटां'; break;
                case 'h': output = 'एका तासा'; break;
                case 'hh': output = '%d तासां'; break;
                case 'd': output = 'एका दिवसा'; break;
                case 'dd': output = '%d दिवसां'; break;
                case 'M': output = 'एका महिन्या'; break;
                case 'MM': output = '%d महिन्यां'; break;
                case 'y': output = 'एका वर्षा'; break;
                case 'yy': output = '%d वर्षां'; break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
        monthsParseExact : true,
        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm वाजता',
            LTS : 'A h:mm:ss वाजता',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm वाजता',
            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[उद्या] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात्री') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळी') {
                return hour;
            } else if (meridiem === 'दुपारी') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'सायंकाळी') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात्री';
            } else if (hour < 10) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return mr;

}));

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var ms_my = moment.defineLocale('ms-my', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ms_my;

}));

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var ms = moment.defineLocale('ms', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ms;

}));

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var symbolMap = {
        '1': '၁',
        '2': '၂',
        '3': '၃',
        '4': '၄',
        '5': '၅',
        '6': '၆',
        '7': '၇',
        '8': '၈',
        '9': '၉',
        '0': '၀'
    }, numberMap = {
        '၁': '1',
        '၂': '2',
        '၃': '3',
        '၄': '4',
        '၅': '5',
        '၆': '6',
        '၇': '7',
        '၈': '8',
        '၉': '9',
        '၀': '0'
    };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်'
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return my;

}));

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var nb = moment.defineLocale('nb', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'noen sekunder',
            m : 'ett minutt',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dager',
            M : 'en måned',
            MM : '%d måneder',
            y : 'ett år',
            yy : '%d år'
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nb;

}));

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var ne = moment.defineLocale('ne', {
        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
        monthsParseExact : true,
        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'Aको h:mm बजे',
            LTS : 'Aको h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, Aको h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[भोलि] LT',
            nextWeek : '[आउँदो] dddd[,] LT',
            lastDay : '[हिजो] LT',
            lastWeek : '[गएको] dddd[,] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sमा',
            past : '%s अगाडि',
            s : 'केही क्षण',
            m : 'एक मिनेट',
            mm : '%d मिनेट',
            h : 'एक घण्टा',
            hh : '%d घण्टा',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महिना',
            MM : '%d महिना',
            y : 'एक बर्ष',
            yy : '%d बर्ष'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ne;

}));

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        ordinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nl;

}));

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! author : https://github.com/mechuwind

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var nn = moment.defineLocale('nn', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s sidan',
            s : 'nokre sekund',
            m : 'eit minutt',
            mm : '%d minutt',
            h : 'ein time',
            hh : '%d timar',
            d : 'ein dag',
            dd : '%d dagar',
            M : 'ein månad',
            MM : '%d månader',
            y : 'eit år',
            yy : '%d år'
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nn;

}));

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var symbolMap = {
        '1': '੧',
        '2': '੨',
        '3': '੩',
        '4': '੪',
        '5': '੫',
        '6': '੬',
        '7': '੭',
        '8': '੮',
        '9': '੯',
        '0': '੦'
    },
    numberMap = {
        '੧': '1',
        '੨': '2',
        '੩': '3',
        '੪': '4',
        '੫': '5',
        '੬': '6',
        '੭': '7',
        '੮': '8',
        '੯': '9',
        '੦': '0'
    };

    var pa_in = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm ਵਜੇ',
            LTS : 'A h:mm:ss ਵਜੇ',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
        },
        calendar : {
            sameDay : '[ਅਜ] LT',
            nextDay : '[ਕਲ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ਕਲ] LT',
            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ਵਿੱਚ',
            past : '%s ਪਿਛਲੇ',
            s : 'ਕੁਝ ਸਕਿੰਟ',
            m : 'ਇਕ ਮਿੰਟ',
            mm : '%d ਮਿੰਟ',
            h : 'ਇੱਕ ਘੰਟਾ',
            hh : '%d ਘੰਟੇ',
            d : 'ਇੱਕ ਦਿਨ',
            dd : '%d ਦਿਨ',
            M : 'ਇੱਕ ਮਹੀਨਾ',
            MM : '%d ਮਹੀਨੇ',
            y : 'ਇੱਕ ਸਾਲ',
            yy : '%d ਸਾਲ'
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return pa_in;

}));

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
    function plural(n) {
        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix  ? 'godzina'  : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months : function (momentToFormat, format) {
            if (format === '') {
                // Hack: if format empty we know this is used to generate
                // RegExp by moment. Give then back both valid forms of months
                // in RegExp ready format.
                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort : 'nie_pon_wt_śr_czw_pt_sb'.split('_'),
        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: '[W] dddd [o] LT',
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : '%s temu',
            s : 'kilka sekund',
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : '1 dzień',
            dd : '%d dni',
            M : 'miesiąc',
            MM : translate,
            y : 'rok',
            yy : translate
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pl;

}));

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var pt_br = moment.defineLocale('pt-br', {
        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : '%s atrás',
            s : 'poucos segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        ordinalParse: /\d{1,2}º/,
        ordinal : '%dº'
    });

    return pt_br;

}));

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var pt = moment.defineLocale('pt', {
        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        ordinalParse: /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pt;

}));

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                'mm': 'minute',
                'hh': 'ore',
                'dd': 'zile',
                'MM': 'luni',
                'yy': 'ani'
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'peste %s',
            past : '%s în urmă',
            s : 'câteva secunde',
            m : 'un minut',
            mm : relativeTimeWithPlural,
            h : 'o oră',
            hh : relativeTimeWithPlural,
            d : 'o zi',
            dd : relativeTimeWithPlural,
            M : 'o lună',
            MM : relativeTimeWithPlural,
            y : 'un an',
            yy : relativeTimeWithPlural
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ro;

}));

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! Author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            'hh': 'час_часа_часов',
            'dd': 'день_дня_дней',
            'MM': 'месяц_месяца_месяцев',
            'yy': 'год_года_лет'
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months : {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
        },
        monthsShort : {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
        },
        weekdays : {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
        },
        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соотвествует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., HH:mm',
            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
        },
        calendar : {
            sameDay: '[Сегодня в] LT',
            nextDay: '[Завтра в] LT',
            lastDay: '[Вчера в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd [в] LT';
                    } else {
                        return '[В] dddd [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd [в] LT';
                    } else {
                        return '[В] dddd [в] LT';
                    }
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'через %s',
            past : '%s назад',
            s : 'несколько секунд',
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'час',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM : function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        ordinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ru;

}));

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';



    var se = moment.defineLocale('se', {
        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'MMMM D. [b.] YYYY',
            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
        },
        calendar : {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s geažes',
            past : 'maŋit %s',
            s : 'moadde sekunddat',
            m : 'okta minuhta',
            mm : '%d minuhtat',
            h : 'okta diimmu',
            hh : '%d diimmut',
            d : 'okta beaivi',
            dd : '%d beaivvit',
            M : 'okta mánnu',
            MM : '%d mánut',
            y : 'okta jahki',
            yy : '%d jagit'
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return se;

}));

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'a h:mm',
            LTS : 'a h:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY MMMM D',
            LLL : 'YYYY MMMM D, a h:mm',
            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
        },
        calendar : {
            sameDay : '[අද] LT[ට]',
            nextDay : '[හෙට] LT[ට]',
            nextWeek : 'dddd LT[ට]',
            lastDay : '[ඊයේ] LT[ට]',
            lastWeek : '[පසුගිය] dddd LT[ට]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sකින්',
            past : '%sකට පෙර',
            s : 'තත්පර කිහිපය',
            m : 'මිනිත්තුව',
            mm : 'මිනිත්තු %d',
            h : 'පැය',
            hh : 'පැය %d',
            d : 'දිනය',
            dd : 'දින %d',
            M : 'මාසය',
            MM : 'මාස %d',
            y : 'වසර',
            yy : 'වසර %d'
        },
        ordinalParse: /\d{1,2} වැනි/,
        ordinal : function (number) {
            return number + ' වැනි';
        },
        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM : function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        }
    });

    return si;

}));

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return (n > 1) && (n < 5);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
                break;
        }
    }

    var sk = moment.defineLocale('sk', {
        months : months,
        monthsShort : monthsShort,
        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'pred %s',
            s : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sk;

}));

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danes ob] LT',
            nextDay  : '[jutri ob] LT',

            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay  : '[včeraj ob] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'čez %s',
            past   : 'pred %s',
            s      : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : processRelativeTime,
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return sl;

}));

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var sq = moment.defineLocale('sq', {
        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem : function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Sot në] LT',
            nextDay : '[Nesër në] LT',
            nextWeek : 'dddd [në] LT',
            lastDay : '[Dje në] LT',
            lastWeek : 'dddd [e kaluar në] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'në %s',
            past : '%s më parë',
            s : 'disa sekonda',
            m : 'një minutë',
            mm : '%d minuta',
            h : 'një orë',
            hh : '%d orë',
            d : 'një ditë',
            dd : '%d ditë',
            M : 'një muaj',
            MM : '%d muaj',
            y : 'një vit',
            yy : '%d vite'
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sq;

}));

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var sr_cyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay  : '[јуче у] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'за %s',
            past   : 'пре %s',
            s      : 'неколико секунди',
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'дан',
            dd     : translator.translate,
            M      : 'месец',
            MM     : translator.translate,
            y      : 'годину',
            yy     : translator.translate
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return sr_cyrl;

}));

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'pre %s',
            s      : 'nekoliko sekundi',
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return sr;

}));

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';



    var ss = moment.defineLocale('ss', {
        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Namuhla nga] LT',
            nextDay : '[Kusasa nga] LT',
            nextWeek : 'dddd [nga] LT',
            lastDay : '[Itolo nga] LT',
            lastWeek : 'dddd [leliphelile] [nga] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'nga %s',
            past : 'wenteka nga %s',
            s : 'emizuzwana lomcane',
            m : 'umzuzu',
            mm : '%d emizuzu',
            h : 'lihora',
            hh : '%d emahora',
            d : 'lilanga',
            dd : '%d emalanga',
            M : 'inyanga',
            MM : '%d tinyanga',
            y : 'umnyaka',
            yy : '%d iminyaka'
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        ordinalParse: /\d{1,2}/,
        ordinal : '%d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ss;

}));

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var sv = moment.defineLocale('sv', {
        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : 'för %s sedan',
            s : 'några sekunder',
            m : 'en minut',
            mm : '%d minuter',
            h : 'en timme',
            hh : '%d timmar',
            d : 'en dag',
            dd : '%d dagar',
            M : 'en månad',
            MM : '%d månader',
            y : 'ett år',
            yy : '%d år'
        },
        ordinalParse: /\d{1,2}(e|a)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'e' :
                (b === 1) ? 'a' :
                (b === 2) ? 'a' :
                (b === 3) ? 'e' : 'e';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sv;

}));

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var sw = moment.defineLocale('sw', {
        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[leo saa] LT',
            nextDay : '[kesho saa] LT',
            nextWeek : '[wiki ijayo] dddd [saat] LT',
            lastDay : '[jana] LT',
            lastWeek : '[wiki iliyopita] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s baadaye',
            past : 'tokea %s',
            s : 'hivi punde',
            m : 'dakika moja',
            mm : 'dakika %d',
            h : 'saa limoja',
            hh : 'masaa %d',
            d : 'siku moja',
            dd : 'masiku %d',
            M : 'mwezi mmoja',
            MM : 'miezi %d',
            y : 'mwaka mmoja',
            yy : 'miaka %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return sw;

}));

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var symbolMap = {
        '1': '௧',
        '2': '௨',
        '3': '௩',
        '4': '௪',
        '5': '௫',
        '6': '௬',
        '7': '௭',
        '8': '௮',
        '9': '௯',
        '0': '௦'
    }, numberMap = {
        '௧': '1',
        '௨': '2',
        '௩': '3',
        '௪': '4',
        '௫': '5',
        '௬': '6',
        '௭': '7',
        '௮': '8',
        '௯': '9',
        '௦': '0'
    };

    var ta = moment.defineLocale('ta', {
        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, HH:mm',
            LLLL : 'dddd, D MMMM YYYY, HH:mm'
        },
        calendar : {
            sameDay : '[இன்று] LT',
            nextDay : '[நாளை] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[நேற்று] LT',
            lastWeek : '[கடந்த வாரம்] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s இல்',
            past : '%s முன்',
            s : 'ஒரு சில விநாடிகள்',
            m : 'ஒரு நிமிடம்',
            mm : '%d நிமிடங்கள்',
            h : 'ஒரு மணி நேரம்',
            hh : '%d மணி நேரம்',
            d : 'ஒரு நாள்',
            dd : '%d நாட்கள்',
            M : 'ஒரு மாதம்',
            MM : '%d மாதங்கள்',
            y : 'ஒரு வருடம்',
            yy : '%d ஆண்டுகள்'
        },
        ordinalParse: /\d{1,2}வது/,
        ordinal : function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem : function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை';  // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ta;

}));

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var te = moment.defineLocale('te', {
        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[నేడు] LT',
            nextDay : '[రేపు] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[నిన్న] LT',
            lastWeek : '[గత] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s లో',
            past : '%s క్రితం',
            s : 'కొన్ని క్షణాలు',
            m : 'ఒక నిమిషం',
            mm : '%d నిమిషాలు',
            h : 'ఒక గంట',
            hh : '%d గంటలు',
            d : 'ఒక రోజు',
            dd : '%d రోజులు',
            M : 'ఒక నెల',
            MM : '%d నెలలు',
            y : 'ఒక సంవత్సరం',
            yy : '%d సంవత్సరాలు'
        },
        ordinalParse : /\d{1,2}వ/,
        ordinal : '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return te;

}));

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var th = moment.defineLocale('th', {
        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
        monthsParseExact: true,
        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY เวลา H:mm',
            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar : {
            sameDay : '[วันนี้ เวลา] LT',
            nextDay : '[พรุ่งนี้ เวลา] LT',
            nextWeek : 'dddd[หน้า เวลา] LT',
            lastDay : '[เมื่อวานนี้ เวลา] LT',
            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'อีก %s',
            past : '%sที่แล้ว',
            s : 'ไม่กี่วินาที',
            m : '1 นาที',
            mm : '%d นาที',
            h : '1 ชั่วโมง',
            hh : '%d ชั่วโมง',
            d : '1 วัน',
            dd : '%d วัน',
            M : '1 เดือน',
            MM : '%d เดือน',
            y : '1 ปี',
            yy : '%d ปี'
        }
    });

    return th;

}));

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var tl_ph = moment.defineLocale('tl-ph', {
        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'MM/D/YYYY',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY HH:mm',
            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Ngayon sa] LT',
            nextDay: '[Bukas sa] LT',
            nextWeek: 'dddd [sa] LT',
            lastDay: '[Kahapon sa] LT',
            lastWeek: 'dddd [huling linggo] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'sa loob ng %s',
            past : '%s ang nakalipas',
            s : 'ilang segundo',
            m : 'isang minuto',
            mm : '%d minuto',
            h : 'isang oras',
            hh : '%d oras',
            d : 'isang araw',
            dd : '%d araw',
            M : 'isang buwan',
            MM : '%d buwan',
            y : 'isang taon',
            yy : '%d taon'
        },
        ordinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tl_ph;

}));

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'leS' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'waQ' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'nem' :
        time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'Hu’' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'wen' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'ben' :
        time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
        ten = Math.floor((number % 100) / 10),
        one = number % 10,
        word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
        }
        return (word === '') ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
        monthsParseExact : true,
        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L'
        },
        relativeTime : {
            future : translateFuture,
            past : translatePast,
            s : 'puS lup',
            m : 'wa’ tup',
            mm : translate,
            h : 'wa’ rep',
            hh : translate,
            d : 'wa’ jaj',
            dd : translate,
            M : 'wa’ jar',
            MM : translate,
            y : 'wa’ DIS',
            yy : translate
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlh;

}));

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var suffixes = {
        1: '\'inci',
        5: '\'inci',
        8: '\'inci',
        70: '\'inci',
        80: '\'inci',
        2: '\'nci',
        7: '\'nci',
        20: '\'nci',
        50: '\'nci',
        3: '\'üncü',
        4: '\'üncü',
        100: '\'üncü',
        6: '\'ncı',
        9: '\'uncu',
        10: '\'uncu',
        30: '\'uncu',
        60: '\'ıncı',
        90: '\'ıncı'
    };

    var tr = moment.defineLocale('tr', {
        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[yarın saat] LT',
            nextWeek : '[haftaya] dddd [saat] LT',
            lastDay : '[dün] LT',
            lastWeek : '[geçen hafta] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s önce',
            s : 'birkaç saniye',
            m : 'bir dakika',
            mm : '%d dakika',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir yıl',
            yy : '%d yıl'
        },
        ordinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
        ordinal : function (number) {
            if (number === 0) {  // special case for zero
                return number + '\'ıncı';
            }
            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return tr;

}));

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM [dallas] YYYY',
            LLL : 'D. MMMM [dallas] YYYY HH.mm',
            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM : function (input) {
            return 'd\'o' === input.toLowerCase();
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'd\'o' : 'D\'O';
            } else {
                return isLower ? 'd\'a' : 'D\'A';
            }
        },
        calendar : {
            sameDay : '[oxhi à] LT',
            nextDay : '[demà à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[ieiri à] LT',
            lastWeek : '[sür el] dddd [lasteu à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'osprei %s',
            past : 'ja%s',
            s : processRelativeTime,
            m : processRelativeTime,
            mm : processRelativeTime,
            h : processRelativeTime,
            hh : processRelativeTime,
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['viensas secunds', '\'iensas secunds'],
            'm': ['\'n míut', '\'iens míut'],
            'mm': [number + ' míuts', '' + number + ' míuts'],
            'h': ['\'n þora', '\'iensa þora'],
            'hh': [number + ' þoras', '' + number + ' þoras'],
            'd': ['\'n ziua', '\'iensa ziua'],
            'dd': [number + ' ziuas', '' + number + ' ziuas'],
            'M': ['\'n mes', '\'iens mes'],
            'MM': [number + ' mesen', '' + number + ' mesen'],
            'y': ['\'n ar', '\'iens ar'],
            'yy': [number + ' ars', '' + number + ' ars']
        };
        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
    }

    return tzl;

}));

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var tzm_latn = moment.defineLocale('tzm-latn', {
        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'dadkh s yan %s',
            past : 'yan %s',
            s : 'imik',
            m : 'minuḍ',
            mm : '%d minuḍ',
            h : 'saɛa',
            hh : '%d tassaɛin',
            d : 'ass',
            dd : '%d ossan',
            M : 'ayowr',
            MM : '%d iyyirn',
            y : 'asgas',
            yy : '%d isgasn'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return tzm_latn;

}));

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var tzm = moment.defineLocale('tzm', {
        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past : 'ⵢⴰⵏ %s',
            s : 'ⵉⵎⵉⴽ',
            m : 'ⵎⵉⵏⵓⴺ',
            mm : '%d ⵎⵉⵏⵓⴺ',
            h : 'ⵙⴰⵄⴰ',
            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d : 'ⴰⵙⵙ',
            dd : '%d oⵙⵙⴰⵏ',
            M : 'ⴰⵢoⵓⵔ',
            MM : '%d ⵉⵢⵢⵉⵔⵏ',
            y : 'ⴰⵙⴳⴰⵙ',
            yy : '%d ⵉⵙⴳⴰⵙⵏ'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return tzm;

}));

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            'dd': 'день_дні_днів',
            'MM': 'місяць_місяці_місяців',
            'yy': 'рік_роки_років'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
        },
        nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
            'accusative' :
            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
                'genitive' :
                'nominative');
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months : {
            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
        },
        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
        weekdays : weekdaysCaseReplace,
        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY р.',
            LLL : 'D MMMM YYYY р., HH:mm',
            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
        },
        calendar : {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'за %s',
            past : '%s тому',
            s : 'декілька секунд',
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'годину',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'місяць',
            MM : relativeTimeWithPlural,
            y : 'рік',
            yy : relativeTimeWithPlural
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        ordinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return uk;

}));

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var uz = moment.defineLocale('uz', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Бугун соат] LT [да]',
            nextDay : '[Эртага] LT [да]',
            nextWeek : 'dddd [куни соат] LT [да]',
            lastDay : '[Кеча соат] LT [да]',
            lastWeek : '[Утган] dddd [куни соат] LT [да]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Якин %s ичида',
            past : 'Бир неча %s олдин',
            s : 'фурсат',
            m : 'бир дакика',
            mm : '%d дакика',
            h : 'бир соат',
            hh : '%d соат',
            d : 'бир кун',
            dd : '%d кун',
            M : 'бир ой',
            MM : '%d ой',
            y : 'бир йил',
            yy : '%d йил'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return uz;

}));

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var vi = moment.defineLocale('vi', {
        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
        monthsParseExact : true,
        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /sa|ch/i,
        isPM : function (input) {
            return /^ch$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [năm] YYYY',
            LLL : 'D MMMM [năm] YYYY HH:mm',
            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
            l : 'DD/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần rồi lúc] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s tới',
            past : '%s trước',
            s : 'vài giây',
            m : 'một phút',
            mm : '%d phút',
            h : 'một giờ',
            hh : '%d giờ',
            d : 'một ngày',
            dd : '%d ngày',
            M : 'một tháng',
            MM : '%d tháng',
            y : 'một năm',
            yy : '%d năm'
        },
        ordinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return vi;

}));

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var x_pseudo = moment.defineLocale('x-pseudo', {
        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
        monthsParseExact : true,
        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[T~ódá~ý át] LT',
            nextDay : '[T~ómó~rró~w át] LT',
            nextWeek : 'dddd [át] LT',
            lastDay : '[Ý~ést~érdá~ý át] LT',
            lastWeek : '[L~ást] dddd [át] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'í~ñ %s',
            past : '%s á~gó',
            s : 'á ~féw ~sécó~ñds',
            m : 'á ~míñ~úté',
            mm : '%d m~íñú~tés',
            h : 'á~ñ hó~úr',
            hh : '%d h~óúrs',
            d : 'á ~dáý',
            dd : '%d d~áýs',
            M : 'á ~móñ~th',
            MM : '%d m~óñt~hs',
            y : 'á ~ýéár',
            yy : '%d ý~éárs'
        },
        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return x_pseudo;

}));

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var zh_cn = moment.defineLocale('zh-cn', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'Ah点mm分',
            LTS : 'Ah点m分s秒',
            L : 'YYYY-MM-DD',
            LL : 'YYYY年MMMD日',
            LLL : 'YYYY年MMMD日Ah点mm分',
            LLLL : 'YYYY年MMMD日ddddAh点mm分',
            l : 'YYYY-MM-DD',
            ll : 'YYYY年MMMD日',
            lll : 'YYYY年MMMD日Ah点mm分',
            llll : 'YYYY年MMMD日ddddAh点mm分'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' ||
                    meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : function () {
                return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
            },
            nextDay : function () {
                return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
            },
            lastDay : function () {
                return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
            },
            nextWeek : function () {
                var startOfWeek, prefix;
                startOfWeek = moment().startOf('week');
                prefix = this.diff(startOfWeek, 'days') >= 7 ? '[下]' : '[本]';
                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
            },
            lastWeek : function () {
                var startOfWeek, prefix;
                startOfWeek = moment().startOf('week');
                prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
            },
            sameElse : 'LL'
        },
        ordinalParse: /\d{1,2}(日|月|周)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s内',
            past : '%s前',
            s : '几秒',
            m : '1 分钟',
            mm : '%d 分钟',
            h : '1 小时',
            hh : '%d 小时',
            d : '1 天',
            dd : '%d 天',
            M : '1 个月',
            MM : '%d 个月',
            y : '1 年',
            yy : '%d 年'
        },
        week : {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return zh_cn;

}));

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var zh_hk = moment.defineLocale('zh-hk', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'Ah點mm分',
            LTS : 'Ah點m分s秒',
            L : 'YYYY年MMMD日',
            LL : 'YYYY年MMMD日',
            LLL : 'YYYY年MMMD日Ah點mm分',
            LLLL : 'YYYY年MMMD日ddddAh點mm分',
            l : 'YYYY年MMMD日',
            ll : 'YYYY年MMMD日',
            lll : 'YYYY年MMMD日Ah點mm分',
            llll : 'YYYY年MMMD日ddddAh點mm分'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        ordinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zh_hk;

}));

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var zh_tw = moment.defineLocale('zh-tw', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'Ah點mm分',
            LTS : 'Ah點m分s秒',
            L : 'YYYY年MMMD日',
            LL : 'YYYY年MMMD日',
            LLL : 'YYYY年MMMD日Ah點mm分',
            LLLL : 'YYYY年MMMD日ddddAh點mm分',
            l : 'YYYY年MMMD日',
            ll : 'YYYY年MMMD日',
            lll : 'YYYY年MMMD日Ah點mm分',
            llll : 'YYYY年MMMD日ddddAh點mm分'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        ordinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zh_tw;

}));

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var toast_container_component_1 = __webpack_require__(259);
var toast_options_1 = __webpack_require__(158);
var toast_1 = __webpack_require__(727);
var Subject_1 = __webpack_require__(18);
var ToastsManager = (function () {
    function ToastsManager(componentFactoryResolver, appRef, options) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.appRef = appRef;
        this.options = {};
        this.index = 0;
        this.toastClicked = new Subject_1.Subject();
        if (options) {
            Object.assign(this.options, options);
        }
    }
    ToastsManager.prototype.setRootViewContainerRef = function (vRef) {
        this._rootViewContainerRef = vRef;
    };
    ToastsManager.prototype.onClickToast = function () {
        return this.toastClicked.asObservable();
    };
    ToastsManager.prototype.show = function (toast, options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!_this.container) {
                if (!_this.appRef['_rootComponents'].length) {
                    var err = new Error('Application root component cannot be found. Try accessing application reference in the later life cycle of angular app.');
                    console.error(err);
                    reject(err);
                }
                // get app root view component ref
                if (!_this._rootViewContainerRef) {
                    _this._rootViewContainerRef = _this.appRef['_rootComponents'][0]['_hostElement'].vcRef;
                }
                // get options providers
                var providers = core_1.ReflectiveInjector.resolve([
                    { provide: toast_options_1.ToastOptions, useValue: _this.options }
                ]);
                // create and load ToastContainer
                var toastFactory = _this.componentFactoryResolver.resolveComponentFactory(toast_container_component_1.ToastContainer);
                var childInjector = core_1.ReflectiveInjector.fromResolvedProviders(providers, _this._rootViewContainerRef.parentInjector);
                _this.container = _this._rootViewContainerRef.createComponent(toastFactory, _this._rootViewContainerRef.length, childInjector);
                _this.container.instance.onToastClicked = function (toast) {
                    _this._onToastClicked(toast);
                };
            }
            resolve(_this.setupToast(toast, options));
        });
    };
    ToastsManager.prototype.createTimeout = function (toast) {
        var _this = this;
        var task = setTimeout(function () {
            _this.clearToast(toast);
        }, toast.config.toastLife);
        return task.toString();
    };
    ToastsManager.prototype.setupToast = function (toast, options) {
        var _this = this;
        toast.id = ++this.index;
        Object.keys(toast.config).forEach(function (k) {
            if (_this.options.hasOwnProperty(k)) {
                toast.config[k] = _this.options[k];
            }
            if (options && options.hasOwnProperty(k)) {
                toast.config[k] = options[k];
            }
        });
        if (toast.config.dismiss === 'auto') {
            toast.timeoutId = this.createTimeout(toast);
        }
        this.container.instance.addToast(toast);
        return toast;
    };
    ToastsManager.prototype._onToastClicked = function (toast) {
        this.toastClicked.next(toast);
        if (toast.config.dismiss === 'click') {
            this.clearToast(toast);
        }
    };
    ToastsManager.prototype.dismissToast = function (toast) {
        this.clearToast(toast);
    };
    ToastsManager.prototype.clearToast = function (toast) {
        if (this.container) {
            var instance = this.container.instance;
            instance.removeToast(toast);
            if (!instance.anyToast()) {
                this.dispose();
            }
        }
    };
    ToastsManager.prototype.clearAllToasts = function () {
        if (this.container) {
            var instance = this.container.instance;
            instance.removeAllToasts();
            this.dispose();
        }
    };
    ToastsManager.prototype.dispose = function () {
        var _this = this;
        // using timeout to allow animation to finish
        setTimeout(function () {
            if (_this.container && !_this.container.instance.anyToast()) {
                _this.container.destroy();
                _this.container = null;
            }
        }, 2000);
    };
    ToastsManager.prototype.error = function (message, title, options) {
        var data = options && options.data ? options.data : null;
        var toast = new toast_1.Toast('error', message, title, data);
        return this.show(toast, options);
    };
    ToastsManager.prototype.info = function (message, title, options) {
        var data = options && options.data ? options.data : null;
        var toast = new toast_1.Toast('info', message, title, data);
        return this.show(toast, options);
    };
    ToastsManager.prototype.success = function (message, title, options) {
        var data = options && options.data ? options.data : null;
        var toast = new toast_1.Toast('success', message, title, data);
        return this.show(toast, options);
    };
    ToastsManager.prototype.warning = function (message, title, options) {
        var data = options && options.data ? options.data : null;
        var toast = new toast_1.Toast('warning', message, title, data);
        return this.show(toast, options);
    };
    // allow user define custom background color and image
    ToastsManager.prototype.custom = function (message, title, options) {
        var data = options && options.data ? options.data : null;
        var toast = new toast_1.Toast('custom', message, title, data);
        return this.show(toast, options);
    };
    ToastsManager.decorators = [
        { type: core_1.Injectable },
    ];
    /** @nocollapse */
    ToastsManager.ctorParameters = [
        { type: core_1.ComponentFactoryResolver, },
        { type: core_1.ApplicationRef, },
        { type: toast_options_1.ToastOptions, decorators: [{ type: core_1.Optional },] },
    ];
    return ToastsManager;
}());
exports.ToastsManager = ToastsManager;
//# sourceMappingURL=toast-manager.js.map

/***/ },
/* 727 */
/***/ function(module, exports) {

"use strict";
"use strict";
var Toast = (function () {
    function Toast(type, message, title, data) {
        this.type = type;
        this.message = message;
        this.title = title;
        this.data = data;
        this.config = {
            dismiss: 'auto',
            enableHTML: false,
            titleClass: '',
            messageClass: '',
            toastLife: 3000,
            showCloseButton: false,
        };
    }
    return Toast;
}());
exports.Toast = Toast;
//# sourceMappingURL=toast.js.map

/***/ },
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(62);
var http_1 = __webpack_require__(15);
var forms_1 = __webpack_require__(10);
var ng2_toastr_1 = __webpack_require__(6);
var app_component_1 = __webpack_require__(936);
var app_routing_1 = __webpack_require__(937);
var home_module_1 = __webpack_require__(941);
var login_routing_module_1 = __webpack_require__(942);
var login_component_1 = __webpack_require__(476);
var register_component_1 = __webpack_require__(477);
var forgotpassword_component_1 = __webpack_require__(475);
var shared_1 = __webpack_require__(487);
var auth_service_1 = __webpack_require__(68);
var admin_module_1 = __webpack_require__(935);
var dialog_service_1 = __webpack_require__(939);
var hmr_1 = __webpack_require__(277);
var Categories_module_1 = __webpack_require__(879);
var CustomerCustomerDemo_module_1 = __webpack_require__(885);
var CustomerDemographics_module_1 = __webpack_require__(887);
var Customers_module_1 = __webpack_require__(891);
var Employees_module_1 = __webpack_require__(895);
var EmployeeTerritories_module_1 = __webpack_require__(893);
var OrderDetails_module_1 = __webpack_require__(901);
var Orders_module_1 = __webpack_require__(907);
var Products_module_1 = __webpack_require__(913);
var Region_module_1 = __webpack_require__(919);
var Shippers_module_1 = __webpack_require__(925);
var Suppliers_module_1 = __webpack_require__(931);
var Territories_module_1 = __webpack_require__(933);
var Alphabeticallistofproducts_module_1 = __webpack_require__(877);
var CategorySalesfor1997_module_1 = __webpack_require__(881);
var CurrentProductList_module_1 = __webpack_require__(883);
var CustomerandSuppliersbyCity_module_1 = __webpack_require__(889);
var Invoices_module_1 = __webpack_require__(897);
var OrderDetailsExtended_module_1 = __webpack_require__(899);
var OrderSubtotals_module_1 = __webpack_require__(903);
var OrdersQry_module_1 = __webpack_require__(905);
var ProductSalesfor1997_module_1 = __webpack_require__(909);
var ProductsAboveAveragePrice_module_1 = __webpack_require__(911);
var ProductsbyCategory_module_1 = __webpack_require__(915);
var QuarterlyOrders_module_1 = __webpack_require__(917);
var SalesbyCategory_module_1 = __webpack_require__(923);
var SalesTotalsbyAmount_module_1 = __webpack_require__(921);
var SummaryofSalesbyQuarter_module_1 = __webpack_require__(927);
var SummaryofSalesbyYear_module_1 = __webpack_require__(929);
var AppModule = (function () {
    function AppModule(appRef) {
        this.appRef = appRef;
    }
    AppModule.prototype.hmrOnInit = function (store) {
        console.log('HMR store', store);
    };
    AppModule.prototype.hmrOnDestroy = function (store) {
        var cmpLocation = this.appRef.components.map(function (cmp) { return cmp.location.nativeElement; });
        // recreate elements
        store.disposeOldHosts = hmr_1.createNewHosts(cmpLocation);
        // remove styles
        hmr_1.removeNgStyles();
    };
    AppModule.prototype.hmrAfterDestroy = function (store) {
        // display new elements
        store.disposeOldHosts();
        delete store.disposeOldHosts;
    };
    AppModule = __decorate([
        core_1.NgModule({
            imports: [
                platform_browser_1.BrowserModule,
                http_1.HttpModule,
                forms_1.FormsModule,
                ng2_toastr_1.ToastModule,
                home_module_1.HomeModule,
                admin_module_1.AdminModule,
                app_routing_1.AppRoutingModule,
                login_routing_module_1.LoginRoutingModule,
                Categories_module_1.CategoriesModule,
                CustomerCustomerDemo_module_1.CustomerCustomerDemoModule,
                CustomerDemographics_module_1.CustomerDemographicsModule,
                Customers_module_1.CustomersModule,
                Employees_module_1.EmployeesModule,
                EmployeeTerritories_module_1.EmployeeTerritoriesModule,
                OrderDetails_module_1.OrderDetailsModule,
                Orders_module_1.OrdersModule,
                Products_module_1.ProductsModule,
                Region_module_1.RegionModule,
                Shippers_module_1.ShippersModule,
                Suppliers_module_1.SuppliersModule,
                Territories_module_1.TerritoriesModule,
                Alphabeticallistofproducts_module_1.AlphabeticallistofproductsModule,
                CategorySalesfor1997_module_1.CategorySalesfor1997Module,
                CurrentProductList_module_1.CurrentProductListModule,
                CustomerandSuppliersbyCity_module_1.CustomerandSuppliersbyCityModule,
                Invoices_module_1.InvoicesModule,
                OrderDetailsExtended_module_1.OrderDetailsExtendedModule,
                OrderSubtotals_module_1.OrderSubtotalsModule,
                OrdersQry_module_1.OrdersQryModule,
                ProductSalesfor1997_module_1.ProductSalesfor1997Module,
                ProductsAboveAveragePrice_module_1.ProductsAboveAveragePriceModule,
                ProductsbyCategory_module_1.ProductsbyCategoryModule,
                QuarterlyOrders_module_1.QuarterlyOrdersModule,
                SalesbyCategory_module_1.SalesbyCategoryModule,
                SalesTotalsbyAmount_module_1.SalesTotalsbyAmountModule,
                SummaryofSalesbyQuarter_module_1.SummaryofSalesbyQuarterModule,
                SummaryofSalesbyYear_module_1.SummaryofSalesbyYearModule,
            ],
            declarations: [
                app_component_1.AppComponent,
                login_component_1.LoginComponent,
                register_component_1.RegisterComponent,
                forgotpassword_component_1.ForgotPasswordComponent
            ],
            providers: [
                shared_1.ApiService,
                auth_service_1.AuthService,
                dialog_service_1.DialogService
            ],
            bootstrap: [app_component_1.AppComponent]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.ApplicationRef !== 'undefined' && core_1.ApplicationRef) === 'function' && _a) || Object])
    ], AppModule);
    return AppModule;
    var _a;
}());
exports.AppModule = AppModule;


/***/ },
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_checkbox_value_accessor__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_default_value_accessor__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_ng_control_status__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_ng_form__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directives_ng_model__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives_ng_model_group__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives_number_value_accessor__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__directives_radio_control_value_accessor__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__directives_range_value_accessor__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__directives_reactive_directives_form_control_directive__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__directives_reactive_directives_form_control_name__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_reactive_directives_form_group_directive__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__directives_reactive_directives_form_group_name__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__directives_select_control_value_accessor__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__directives_select_multiple_control_value_accessor__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__directives_validators__ = __webpack_require__(214);
/* unused harmony reexport CheckboxControlValueAccessor */
/* unused harmony reexport DefaultValueAccessor */
/* unused harmony reexport NgControl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__directives_ng_control__ = __webpack_require__(66);
/* unused harmony reexport NgControlStatus */
/* unused harmony reexport NgControlStatusGroup */
/* unused harmony reexport NgForm */
/* unused harmony reexport NgModel */
/* unused harmony reexport NgModelGroup */
/* unused harmony reexport NumberValueAccessor */
/* unused harmony reexport RadioControlValueAccessor */
/* unused harmony reexport RangeValueAccessor */
/* unused harmony reexport FormControlDirective */
/* unused harmony reexport FormControlName */
/* unused harmony reexport FormGroupDirective */
/* unused harmony reexport FormArrayName */
/* unused harmony reexport FormGroupName */
/* unused harmony reexport NgSelectOption */
/* unused harmony reexport SelectControlValueAccessor */
/* unused harmony reexport SelectMultipleControlValueAccessor */
/* unused harmony reexport NgSelectMultipleOption */
/* unused harmony reexport MinLengthValidator */
/* unused harmony reexport PatternValidator */
/* unused harmony reexport RequiredValidator */
/* unused harmony reexport MaxLengthValidator */
/* unused harmony export SHARED_FORM_DIRECTIVES */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return TEMPLATE_DRIVEN_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return REACTIVE_DRIVEN_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return InternalFormsSharedModule; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


































var SHARED_FORM_DIRECTIVES = [
    __WEBPACK_IMPORTED_MODULE_14__directives_select_control_value_accessor__["b" /* NgSelectOption */], __WEBPACK_IMPORTED_MODULE_15__directives_select_multiple_control_value_accessor__["b" /* NgSelectMultipleOption */], __WEBPACK_IMPORTED_MODULE_2__directives_default_value_accessor__["a" /* DefaultValueAccessor */], __WEBPACK_IMPORTED_MODULE_7__directives_number_value_accessor__["a" /* NumberValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_9__directives_range_value_accessor__["a" /* RangeValueAccessor */], __WEBPACK_IMPORTED_MODULE_1__directives_checkbox_value_accessor__["a" /* CheckboxControlValueAccessor */], __WEBPACK_IMPORTED_MODULE_14__directives_select_control_value_accessor__["a" /* SelectControlValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_15__directives_select_multiple_control_value_accessor__["a" /* SelectMultipleControlValueAccessor */], __WEBPACK_IMPORTED_MODULE_8__directives_radio_control_value_accessor__["a" /* RadioControlValueAccessor */], __WEBPACK_IMPORTED_MODULE_3__directives_ng_control_status__["a" /* NgControlStatus */],
    __WEBPACK_IMPORTED_MODULE_3__directives_ng_control_status__["b" /* NgControlStatusGroup */], __WEBPACK_IMPORTED_MODULE_16__directives_validators__["a" /* RequiredValidator */], __WEBPACK_IMPORTED_MODULE_16__directives_validators__["b" /* MinLengthValidator */], __WEBPACK_IMPORTED_MODULE_16__directives_validators__["c" /* MaxLengthValidator */], __WEBPACK_IMPORTED_MODULE_16__directives_validators__["d" /* PatternValidator */]
];
var TEMPLATE_DRIVEN_DIRECTIVES = [__WEBPACK_IMPORTED_MODULE_5__directives_ng_model__["a" /* NgModel */], __WEBPACK_IMPORTED_MODULE_6__directives_ng_model_group__["a" /* NgModelGroup */], __WEBPACK_IMPORTED_MODULE_4__directives_ng_form__["a" /* NgForm */]];
var REACTIVE_DRIVEN_DIRECTIVES = [__WEBPACK_IMPORTED_MODULE_10__directives_reactive_directives_form_control_directive__["a" /* FormControlDirective */], __WEBPACK_IMPORTED_MODULE_12__directives_reactive_directives_form_group_directive__["a" /* FormGroupDirective */], __WEBPACK_IMPORTED_MODULE_11__directives_reactive_directives_form_control_name__["a" /* FormControlName */], __WEBPACK_IMPORTED_MODULE_13__directives_reactive_directives_form_group_name__["a" /* FormGroupName */], __WEBPACK_IMPORTED_MODULE_13__directives_reactive_directives_form_group_name__["b" /* FormArrayName */]];
/**
 * Internal module used for sharing directives between FormsModule and ReactiveFormsModule
 */
var InternalFormsSharedModule = (function () {
    function InternalFormsSharedModule() {
    }
    InternalFormsSharedModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    declarations: SHARED_FORM_DIRECTIVES,
                    exports: SHARED_FORM_DIRECTIVES,
                },] },
    ];
    /** @nocollapse */
    InternalFormsSharedModule.ctorParameters = [];
    return InternalFormsSharedModule;
}());
//# sourceMappingURL=directives.js.map

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ exports["a"] = normalizeValidator;
/* harmony export (immutable) */ exports["b"] = normalizeAsyncValidator;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function normalizeValidator(validator) {
    if (validator.validate) {
        return function (c) { return validator.validate(c); };
    }
    else {
        return validator;
    }
}
function normalizeAsyncValidator(validator) {
    if (validator.validate) {
        return function (c) { return validator.validate(c); };
    }
    else {
        return validator;
    }
}
//# sourceMappingURL=normalize_validator.js.map

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_radio_control_value_accessor__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_builder__ = __webpack_require__(338);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormsModule; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return ReactiveFormsModule; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */




/**
 * The ng module for forms.
 * @stable
 */
var FormsModule = (function () {
    function FormsModule() {
    }
    FormsModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    declarations: __WEBPACK_IMPORTED_MODULE_1__directives__["a" /* TEMPLATE_DRIVEN_DIRECTIVES */],
                    providers: [__WEBPACK_IMPORTED_MODULE_2__directives_radio_control_value_accessor__["b" /* RadioControlRegistry */]],
                    exports: [__WEBPACK_IMPORTED_MODULE_1__directives__["b" /* InternalFormsSharedModule */], __WEBPACK_IMPORTED_MODULE_1__directives__["a" /* TEMPLATE_DRIVEN_DIRECTIVES */]]
                },] },
    ];
    /** @nocollapse */
    FormsModule.ctorParameters = [];
    return FormsModule;
}());
/**
 * The ng module for reactive forms.
 * @stable
 */
var ReactiveFormsModule = (function () {
    function ReactiveFormsModule() {
    }
    ReactiveFormsModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    declarations: [__WEBPACK_IMPORTED_MODULE_1__directives__["c" /* REACTIVE_DRIVEN_DIRECTIVES */]],
                    providers: [__WEBPACK_IMPORTED_MODULE_3__form_builder__["a" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_2__directives_radio_control_value_accessor__["b" /* RadioControlRegistry */]],
                    exports: [__WEBPACK_IMPORTED_MODULE_1__directives__["b" /* InternalFormsSharedModule */], __WEBPACK_IMPORTED_MODULE_1__directives__["c" /* REACTIVE_DRIVEN_DIRECTIVES */]]
                },] },
    ];
    /** @nocollapse */
    ReactiveFormsModule.ctorParameters = [];
    return ReactiveFormsModule;
}());
//# sourceMappingURL=form_providers.js.map

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_abstract_control_directive__ = __webpack_require__(207);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__directives_abstract_control_directive__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__directives_abstract_form_group_directive__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_abstract_form_group_directive__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_checkbox_value_accessor__ = __webpack_require__(128);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__directives_checkbox_value_accessor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__directives_control_container__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_control_container__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_control_value_accessor__ = __webpack_require__(34);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__directives_control_value_accessor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__directives_default_value_accessor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directives_default_value_accessor__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives_ng_control__ = __webpack_require__(66);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__directives_ng_control__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives_ng_control_status__ = __webpack_require__(208);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__directives_ng_control_status__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__directives_ng_control_status__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__directives_ng_form__ = __webpack_require__(94);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "j", function() { return __WEBPACK_IMPORTED_MODULE_8__directives_ng_form__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "k", function() { return __WEBPACK_IMPORTED_MODULE_9__directives_ng_model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__directives_ng_model__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__directives_ng_model_group__ = __webpack_require__(130);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "l", function() { return __WEBPACK_IMPORTED_MODULE_10__directives_ng_model_group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__directives_radio_control_value_accessor__ = __webpack_require__(95);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "m", function() { return __WEBPACK_IMPORTED_MODULE_11__directives_radio_control_value_accessor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_reactive_directives_form_control_directive__ = __webpack_require__(212);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "n", function() { return __WEBPACK_IMPORTED_MODULE_12__directives_reactive_directives_form_control_directive__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__directives_reactive_directives_form_control_name__ = __webpack_require__(213);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "o", function() { return __WEBPACK_IMPORTED_MODULE_13__directives_reactive_directives_form_control_name__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__directives_reactive_directives_form_group_directive__ = __webpack_require__(96);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "p", function() { return __WEBPACK_IMPORTED_MODULE_14__directives_reactive_directives_form_group_directive__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "q", function() { return __WEBPACK_IMPORTED_MODULE_15__directives_reactive_directives_form_group_name__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__directives_reactive_directives_form_group_name__ = __webpack_require__(97);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "r", function() { return __WEBPACK_IMPORTED_MODULE_15__directives_reactive_directives_form_group_name__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "s", function() { return __WEBPACK_IMPORTED_MODULE_16__directives_select_control_value_accessor__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "t", function() { return __WEBPACK_IMPORTED_MODULE_16__directives_select_control_value_accessor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__directives_select_control_value_accessor__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__directives_select_multiple_control_value_accessor__ = __webpack_require__(133);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "u", function() { return __WEBPACK_IMPORTED_MODULE_17__directives_select_multiple_control_value_accessor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__directives_validators__ = __webpack_require__(214);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "v", function() { return __WEBPACK_IMPORTED_MODULE_18__directives_validators__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "w", function() { return __WEBPACK_IMPORTED_MODULE_18__directives_validators__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "x", function() { return __WEBPACK_IMPORTED_MODULE_18__directives_validators__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "y", function() { return __WEBPACK_IMPORTED_MODULE_18__directives_validators__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__form_builder__ = __webpack_require__(338);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "z", function() { return __WEBPACK_IMPORTED_MODULE_19__form_builder__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__model__ = __webpack_require__(134);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "A", function() { return __WEBPACK_IMPORTED_MODULE_20__model__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "B", function() { return __WEBPACK_IMPORTED_MODULE_20__model__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "C", function() { return __WEBPACK_IMPORTED_MODULE_20__model__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "D", function() { return __WEBPACK_IMPORTED_MODULE_20__model__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__validators__ = __webpack_require__(38);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "E", function() { return __WEBPACK_IMPORTED_MODULE_21__validators__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "F", function() { return __WEBPACK_IMPORTED_MODULE_21__validators__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "G", function() { return __WEBPACK_IMPORTED_MODULE_21__validators__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__form_providers__ = __webpack_require__(846);
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "H", function() { return __WEBPACK_IMPORTED_MODULE_22__form_providers__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "I", function() { return __WEBPACK_IMPORTED_MODULE_22__form_providers__["b"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * This module is used for handling user input, by defining and building a {@link FormGroup} that
 * consists of {@link FormControl} objects, and mapping them onto the DOM. {@link FormControl}
 * objects can then be used to read information from the form DOM elements.
 *
 * Forms providers are not included in default providers; you must import these providers
 * explicitly.
 */
























//# sourceMappingURL=forms.js.map

/***/ },
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: AlphabeticallistofproductsRoutingModule
 * Purpose		: Routing module for Alphabeticallistofproducts.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var AlphabeticallistofproductsList_component_1 = __webpack_require__(363);
var AlphabeticallistofproductsDetails_component_1 = __webpack_require__(362);
var AlphabeticallistofproductsRoutes = [
    { path: 'Alphabeticallistofproducts', component: AlphabeticallistofproductsList_component_1.AlphabeticallistofproductsListComponent },
    { path: 'Alphabeticallistofproducts/Details/:id', component: AlphabeticallistofproductsDetails_component_1.AlphabeticallistofproductsDetailsComponent },
];
var AlphabeticallistofproductsRoutingModule = (function () {
    function AlphabeticallistofproductsRoutingModule() {
    }
    AlphabeticallistofproductsRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(AlphabeticallistofproductsRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], AlphabeticallistofproductsRoutingModule);
    return AlphabeticallistofproductsRoutingModule;
}());
exports.AlphabeticallistofproductsRoutingModule = AlphabeticallistofproductsRoutingModule;


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: AlphabeticallistofproductsModule
 * Purpose		: Module for Alphabeticallistofproducts.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var Alphabeticallistofproducts_service_1 = __webpack_require__(140);
var AlphabeticallistofproductsList_component_1 = __webpack_require__(363);
var AlphabeticallistofproductsSearch_component_1 = __webpack_require__(364);
var AlphabeticallistofproductsDetails_component_1 = __webpack_require__(362);
var Alphabeticallistofproducts_routing_module_1 = __webpack_require__(876);
var AlphabeticallistofproductsModule = (function () {
    function AlphabeticallistofproductsModule() {
    }
    AlphabeticallistofproductsModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                Alphabeticallistofproducts_routing_module_1.AlphabeticallistofproductsRoutingModule
            ],
            declarations: [
                AlphabeticallistofproductsList_component_1.AlphabeticallistofproductsListComponent,
                AlphabeticallistofproductsSearch_component_1.AlphabeticallistofproductsSearchComponent,
                AlphabeticallistofproductsDetails_component_1.AlphabeticallistofproductsDetailsComponent
            ],
            providers: [
                Alphabeticallistofproducts_service_1.AlphabeticallistofproductsService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], AlphabeticallistofproductsModule);
    return AlphabeticallistofproductsModule;
}());
exports.AlphabeticallistofproductsModule = AlphabeticallistofproductsModule;


/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CategoriesRoutingModule
 * Purpose		: Routing module for Categories.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var CategoriesList_component_1 = __webpack_require__(368);
var CategoriesAdd_component_1 = __webpack_require__(365);
var CategoriesEdit_component_1 = __webpack_require__(367);
var CategoriesDetails_component_1 = __webpack_require__(366);
var CategoriesRoutes = [
    { path: 'Categories', component: CategoriesList_component_1.CategoriesListComponent },
    { path: 'Categories/add', component: CategoriesAdd_component_1.CategoriesAddComponent },
    { path: 'Categories/:id', component: CategoriesEdit_component_1.CategoriesEditComponent },
    { path: 'Categories/Details/:id', component: CategoriesDetails_component_1.CategoriesDetailsComponent },
];
var CategoriesRoutingModule = (function () {
    function CategoriesRoutingModule() {
    }
    CategoriesRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(CategoriesRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], CategoriesRoutingModule);
    return CategoriesRoutingModule;
}());
exports.CategoriesRoutingModule = CategoriesRoutingModule;


/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CategoriesModule
 * Purpose		: Module for Categories.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var Categories_service_1 = __webpack_require__(41);
var CategoriesList_component_1 = __webpack_require__(368);
var CategoriesSearch_component_1 = __webpack_require__(369);
var CategoriesAdd_component_1 = __webpack_require__(365);
var CategoriesEdit_component_1 = __webpack_require__(367);
var CategoriesDetails_component_1 = __webpack_require__(366);
var Categories_routing_module_1 = __webpack_require__(878);
var CategoriesModule = (function () {
    function CategoriesModule() {
    }
    CategoriesModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                Categories_routing_module_1.CategoriesRoutingModule
            ],
            declarations: [
                CategoriesList_component_1.CategoriesListComponent,
                CategoriesSearch_component_1.CategoriesSearchComponent,
                CategoriesEdit_component_1.CategoriesEditComponent,
                CategoriesAdd_component_1.CategoriesAddComponent,
                CategoriesDetails_component_1.CategoriesDetailsComponent
            ],
            providers: [
                Categories_service_1.CategoriesService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], CategoriesModule);
    return CategoriesModule;
}());
exports.CategoriesModule = CategoriesModule;


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CategorySalesfor1997RoutingModule
 * Purpose		: Routing module for CategorySalesfor1997.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var CategorySalesfor1997List_component_1 = __webpack_require__(371);
var CategorySalesfor1997Details_component_1 = __webpack_require__(370);
var CategorySalesfor1997Routes = [
    { path: 'CategorySalesfor1997', component: CategorySalesfor1997List_component_1.CategorySalesfor1997ListComponent },
    { path: 'CategorySalesfor1997/Details/:id', component: CategorySalesfor1997Details_component_1.CategorySalesfor1997DetailsComponent },
];
var CategorySalesfor1997RoutingModule = (function () {
    function CategorySalesfor1997RoutingModule() {
    }
    CategorySalesfor1997RoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(CategorySalesfor1997Routes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], CategorySalesfor1997RoutingModule);
    return CategorySalesfor1997RoutingModule;
}());
exports.CategorySalesfor1997RoutingModule = CategorySalesfor1997RoutingModule;


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CategorySalesfor1997Module
 * Purpose		: Module for CategorySalesfor1997.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var CategorySalesfor1997_service_1 = __webpack_require__(141);
var CategorySalesfor1997List_component_1 = __webpack_require__(371);
var CategorySalesfor1997Search_component_1 = __webpack_require__(372);
var CategorySalesfor1997Details_component_1 = __webpack_require__(370);
var CategorySalesfor1997_routing_module_1 = __webpack_require__(880);
var CategorySalesfor1997Module = (function () {
    function CategorySalesfor1997Module() {
    }
    CategorySalesfor1997Module = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                CategorySalesfor1997_routing_module_1.CategorySalesfor1997RoutingModule
            ],
            declarations: [
                CategorySalesfor1997List_component_1.CategorySalesfor1997ListComponent,
                CategorySalesfor1997Search_component_1.CategorySalesfor1997SearchComponent,
                CategorySalesfor1997Details_component_1.CategorySalesfor1997DetailsComponent
            ],
            providers: [
                CategorySalesfor1997_service_1.CategorySalesfor1997Service
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], CategorySalesfor1997Module);
    return CategorySalesfor1997Module;
}());
exports.CategorySalesfor1997Module = CategorySalesfor1997Module;


/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CurrentProductListRoutingModule
 * Purpose		: Routing module for CurrentProductList.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var CurrentProductListList_component_1 = __webpack_require__(374);
var CurrentProductListDetails_component_1 = __webpack_require__(373);
var CurrentProductListRoutes = [
    { path: 'CurrentProductList', component: CurrentProductListList_component_1.CurrentProductListListComponent },
    { path: 'CurrentProductList/Details/:id', component: CurrentProductListDetails_component_1.CurrentProductListDetailsComponent },
];
var CurrentProductListRoutingModule = (function () {
    function CurrentProductListRoutingModule() {
    }
    CurrentProductListRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(CurrentProductListRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], CurrentProductListRoutingModule);
    return CurrentProductListRoutingModule;
}());
exports.CurrentProductListRoutingModule = CurrentProductListRoutingModule;


/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CurrentProductListModule
 * Purpose		: Module for CurrentProductList.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var CurrentProductList_service_1 = __webpack_require__(142);
var CurrentProductListList_component_1 = __webpack_require__(374);
var CurrentProductListSearch_component_1 = __webpack_require__(375);
var CurrentProductListDetails_component_1 = __webpack_require__(373);
var CurrentProductList_routing_module_1 = __webpack_require__(882);
var CurrentProductListModule = (function () {
    function CurrentProductListModule() {
    }
    CurrentProductListModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                CurrentProductList_routing_module_1.CurrentProductListRoutingModule
            ],
            declarations: [
                CurrentProductListList_component_1.CurrentProductListListComponent,
                CurrentProductListSearch_component_1.CurrentProductListSearchComponent,
                CurrentProductListDetails_component_1.CurrentProductListDetailsComponent
            ],
            providers: [
                CurrentProductList_service_1.CurrentProductListService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], CurrentProductListModule);
    return CurrentProductListModule;
}());
exports.CurrentProductListModule = CurrentProductListModule;


/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerCustomerDemoRoutingModule
 * Purpose		: Routing module for CustomerCustomerDemo.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var CustomerCustomerDemoList_component_1 = __webpack_require__(379);
var CustomerCustomerDemoAdd_component_1 = __webpack_require__(376);
var CustomerCustomerDemoEdit_component_1 = __webpack_require__(378);
var CustomerCustomerDemoDetails_component_1 = __webpack_require__(377);
var CustomerCustomerDemoRoutes = [
    { path: 'CustomerCustomerDemo', component: CustomerCustomerDemoList_component_1.CustomerCustomerDemoListComponent },
    { path: 'CustomerCustomerDemo/add', component: CustomerCustomerDemoAdd_component_1.CustomerCustomerDemoAddComponent },
    { path: 'CustomerCustomerDemo/:id', component: CustomerCustomerDemoEdit_component_1.CustomerCustomerDemoEditComponent },
    { path: 'CustomerCustomerDemo/Details/:id', component: CustomerCustomerDemoDetails_component_1.CustomerCustomerDemoDetailsComponent },
];
var CustomerCustomerDemoRoutingModule = (function () {
    function CustomerCustomerDemoRoutingModule() {
    }
    CustomerCustomerDemoRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(CustomerCustomerDemoRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], CustomerCustomerDemoRoutingModule);
    return CustomerCustomerDemoRoutingModule;
}());
exports.CustomerCustomerDemoRoutingModule = CustomerCustomerDemoRoutingModule;


/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerCustomerDemoModule
 * Purpose		: Module for CustomerCustomerDemo.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var CustomerCustomerDemo_service_1 = __webpack_require__(79);
var CustomerCustomerDemoList_component_1 = __webpack_require__(379);
var CustomerCustomerDemoSearch_component_1 = __webpack_require__(380);
var CustomerCustomerDemoAdd_component_1 = __webpack_require__(376);
var CustomerCustomerDemoEdit_component_1 = __webpack_require__(378);
var CustomerCustomerDemoDetails_component_1 = __webpack_require__(377);
var CustomerCustomerDemo_routing_module_1 = __webpack_require__(884);
var CustomerCustomerDemoModule = (function () {
    function CustomerCustomerDemoModule() {
    }
    CustomerCustomerDemoModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                CustomerCustomerDemo_routing_module_1.CustomerCustomerDemoRoutingModule
            ],
            declarations: [
                CustomerCustomerDemoList_component_1.CustomerCustomerDemoListComponent,
                CustomerCustomerDemoSearch_component_1.CustomerCustomerDemoSearchComponent,
                CustomerCustomerDemoEdit_component_1.CustomerCustomerDemoEditComponent,
                CustomerCustomerDemoAdd_component_1.CustomerCustomerDemoAddComponent,
                CustomerCustomerDemoDetails_component_1.CustomerCustomerDemoDetailsComponent
            ],
            providers: [
                CustomerCustomerDemo_service_1.CustomerCustomerDemoService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], CustomerCustomerDemoModule);
    return CustomerCustomerDemoModule;
}());
exports.CustomerCustomerDemoModule = CustomerCustomerDemoModule;


/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerDemographicsRoutingModule
 * Purpose		: Routing module for CustomerDemographics.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var CustomerDemographicsList_component_1 = __webpack_require__(384);
var CustomerDemographicsAdd_component_1 = __webpack_require__(381);
var CustomerDemographicsEdit_component_1 = __webpack_require__(383);
var CustomerDemographicsDetails_component_1 = __webpack_require__(382);
var CustomerDemographicsRoutes = [
    { path: 'CustomerDemographics', component: CustomerDemographicsList_component_1.CustomerDemographicsListComponent },
    { path: 'CustomerDemographics/add', component: CustomerDemographicsAdd_component_1.CustomerDemographicsAddComponent },
    { path: 'CustomerDemographics/:id', component: CustomerDemographicsEdit_component_1.CustomerDemographicsEditComponent },
    { path: 'CustomerDemographics/Details/:id', component: CustomerDemographicsDetails_component_1.CustomerDemographicsDetailsComponent },
];
var CustomerDemographicsRoutingModule = (function () {
    function CustomerDemographicsRoutingModule() {
    }
    CustomerDemographicsRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(CustomerDemographicsRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], CustomerDemographicsRoutingModule);
    return CustomerDemographicsRoutingModule;
}());
exports.CustomerDemographicsRoutingModule = CustomerDemographicsRoutingModule;


/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerDemographicsModule
 * Purpose		: Module for CustomerDemographics.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var CustomerDemographics_service_1 = __webpack_require__(80);
var CustomerDemographicsList_component_1 = __webpack_require__(384);
var CustomerDemographicsSearch_component_1 = __webpack_require__(385);
var CustomerDemographicsAdd_component_1 = __webpack_require__(381);
var CustomerDemographicsEdit_component_1 = __webpack_require__(383);
var CustomerDemographicsDetails_component_1 = __webpack_require__(382);
var CustomerDemographics_routing_module_1 = __webpack_require__(886);
var CustomerDemographicsModule = (function () {
    function CustomerDemographicsModule() {
    }
    CustomerDemographicsModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                CustomerDemographics_routing_module_1.CustomerDemographicsRoutingModule
            ],
            declarations: [
                CustomerDemographicsList_component_1.CustomerDemographicsListComponent,
                CustomerDemographicsSearch_component_1.CustomerDemographicsSearchComponent,
                CustomerDemographicsEdit_component_1.CustomerDemographicsEditComponent,
                CustomerDemographicsAdd_component_1.CustomerDemographicsAddComponent,
                CustomerDemographicsDetails_component_1.CustomerDemographicsDetailsComponent
            ],
            providers: [
                CustomerDemographics_service_1.CustomerDemographicsService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], CustomerDemographicsModule);
    return CustomerDemographicsModule;
}());
exports.CustomerDemographicsModule = CustomerDemographicsModule;


/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerandSuppliersbyCityRoutingModule
 * Purpose		: Routing module for CustomerandSuppliersbyCity.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var CustomerandSuppliersbyCityList_component_1 = __webpack_require__(387);
var CustomerandSuppliersbyCityDetails_component_1 = __webpack_require__(386);
var CustomerandSuppliersbyCityRoutes = [
    { path: 'CustomerandSuppliersbyCity', component: CustomerandSuppliersbyCityList_component_1.CustomerandSuppliersbyCityListComponent },
    { path: 'CustomerandSuppliersbyCity/Details/:id', component: CustomerandSuppliersbyCityDetails_component_1.CustomerandSuppliersbyCityDetailsComponent },
];
var CustomerandSuppliersbyCityRoutingModule = (function () {
    function CustomerandSuppliersbyCityRoutingModule() {
    }
    CustomerandSuppliersbyCityRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(CustomerandSuppliersbyCityRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], CustomerandSuppliersbyCityRoutingModule);
    return CustomerandSuppliersbyCityRoutingModule;
}());
exports.CustomerandSuppliersbyCityRoutingModule = CustomerandSuppliersbyCityRoutingModule;


/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerandSuppliersbyCityModule
 * Purpose		: Module for CustomerandSuppliersbyCity.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var CustomerandSuppliersbyCity_service_1 = __webpack_require__(143);
var CustomerandSuppliersbyCityList_component_1 = __webpack_require__(387);
var CustomerandSuppliersbyCitySearch_component_1 = __webpack_require__(388);
var CustomerandSuppliersbyCityDetails_component_1 = __webpack_require__(386);
var CustomerandSuppliersbyCity_routing_module_1 = __webpack_require__(888);
var CustomerandSuppliersbyCityModule = (function () {
    function CustomerandSuppliersbyCityModule() {
    }
    CustomerandSuppliersbyCityModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                CustomerandSuppliersbyCity_routing_module_1.CustomerandSuppliersbyCityRoutingModule
            ],
            declarations: [
                CustomerandSuppliersbyCityList_component_1.CustomerandSuppliersbyCityListComponent,
                CustomerandSuppliersbyCitySearch_component_1.CustomerandSuppliersbyCitySearchComponent,
                CustomerandSuppliersbyCityDetails_component_1.CustomerandSuppliersbyCityDetailsComponent
            ],
            providers: [
                CustomerandSuppliersbyCity_service_1.CustomerandSuppliersbyCityService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], CustomerandSuppliersbyCityModule);
    return CustomerandSuppliersbyCityModule;
}());
exports.CustomerandSuppliersbyCityModule = CustomerandSuppliersbyCityModule;


/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomersRoutingModule
 * Purpose		: Routing module for Customers.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var CustomersList_component_1 = __webpack_require__(392);
var CustomersAdd_component_1 = __webpack_require__(389);
var CustomersEdit_component_1 = __webpack_require__(391);
var CustomersDetails_component_1 = __webpack_require__(390);
var CustomersRoutes = [
    { path: 'Customers', component: CustomersList_component_1.CustomersListComponent },
    { path: 'Customers/add', component: CustomersAdd_component_1.CustomersAddComponent },
    { path: 'Customers/:id', component: CustomersEdit_component_1.CustomersEditComponent },
    { path: 'Customers/Details/:id', component: CustomersDetails_component_1.CustomersDetailsComponent },
];
var CustomersRoutingModule = (function () {
    function CustomersRoutingModule() {
    }
    CustomersRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(CustomersRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], CustomersRoutingModule);
    return CustomersRoutingModule;
}());
exports.CustomersRoutingModule = CustomersRoutingModule;


/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomersModule
 * Purpose		: Module for Customers.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var Customers_service_1 = __webpack_require__(42);
var CustomersList_component_1 = __webpack_require__(392);
var CustomersSearch_component_1 = __webpack_require__(393);
var CustomersAdd_component_1 = __webpack_require__(389);
var CustomersEdit_component_1 = __webpack_require__(391);
var CustomersDetails_component_1 = __webpack_require__(390);
var Customers_routing_module_1 = __webpack_require__(890);
var CustomersModule = (function () {
    function CustomersModule() {
    }
    CustomersModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                Customers_routing_module_1.CustomersRoutingModule
            ],
            declarations: [
                CustomersList_component_1.CustomersListComponent,
                CustomersSearch_component_1.CustomersSearchComponent,
                CustomersEdit_component_1.CustomersEditComponent,
                CustomersAdd_component_1.CustomersAddComponent,
                CustomersDetails_component_1.CustomersDetailsComponent
            ],
            providers: [
                Customers_service_1.CustomersService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], CustomersModule);
    return CustomersModule;
}());
exports.CustomersModule = CustomersModule;


/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeeTerritoriesRoutingModule
 * Purpose		: Routing module for EmployeeTerritories.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var EmployeeTerritoriesList_component_1 = __webpack_require__(397);
var EmployeeTerritoriesAdd_component_1 = __webpack_require__(394);
var EmployeeTerritoriesEdit_component_1 = __webpack_require__(396);
var EmployeeTerritoriesDetails_component_1 = __webpack_require__(395);
var EmployeeTerritoriesRoutes = [
    { path: 'EmployeeTerritories', component: EmployeeTerritoriesList_component_1.EmployeeTerritoriesListComponent },
    { path: 'EmployeeTerritories/add', component: EmployeeTerritoriesAdd_component_1.EmployeeTerritoriesAddComponent },
    { path: 'EmployeeTerritories/:id', component: EmployeeTerritoriesEdit_component_1.EmployeeTerritoriesEditComponent },
    { path: 'EmployeeTerritories/Details/:id', component: EmployeeTerritoriesDetails_component_1.EmployeeTerritoriesDetailsComponent },
];
var EmployeeTerritoriesRoutingModule = (function () {
    function EmployeeTerritoriesRoutingModule() {
    }
    EmployeeTerritoriesRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(EmployeeTerritoriesRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], EmployeeTerritoriesRoutingModule);
    return EmployeeTerritoriesRoutingModule;
}());
exports.EmployeeTerritoriesRoutingModule = EmployeeTerritoriesRoutingModule;


/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeeTerritoriesModule
 * Purpose		: Module for EmployeeTerritories.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var EmployeeTerritories_service_1 = __webpack_require__(81);
var EmployeeTerritoriesList_component_1 = __webpack_require__(397);
var EmployeeTerritoriesSearch_component_1 = __webpack_require__(398);
var EmployeeTerritoriesAdd_component_1 = __webpack_require__(394);
var EmployeeTerritoriesEdit_component_1 = __webpack_require__(396);
var EmployeeTerritoriesDetails_component_1 = __webpack_require__(395);
var EmployeeTerritories_routing_module_1 = __webpack_require__(892);
var EmployeeTerritoriesModule = (function () {
    function EmployeeTerritoriesModule() {
    }
    EmployeeTerritoriesModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                EmployeeTerritories_routing_module_1.EmployeeTerritoriesRoutingModule
            ],
            declarations: [
                EmployeeTerritoriesList_component_1.EmployeeTerritoriesListComponent,
                EmployeeTerritoriesSearch_component_1.EmployeeTerritoriesSearchComponent,
                EmployeeTerritoriesEdit_component_1.EmployeeTerritoriesEditComponent,
                EmployeeTerritoriesAdd_component_1.EmployeeTerritoriesAddComponent,
                EmployeeTerritoriesDetails_component_1.EmployeeTerritoriesDetailsComponent
            ],
            providers: [
                EmployeeTerritories_service_1.EmployeeTerritoriesService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], EmployeeTerritoriesModule);
    return EmployeeTerritoriesModule;
}());
exports.EmployeeTerritoriesModule = EmployeeTerritoriesModule;


/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeesRoutingModule
 * Purpose		: Routing module for Employees.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var EmployeesList_component_1 = __webpack_require__(402);
var EmployeesAdd_component_1 = __webpack_require__(399);
var EmployeesEdit_component_1 = __webpack_require__(401);
var EmployeesDetails_component_1 = __webpack_require__(400);
var EmployeesRoutes = [
    { path: 'Employees', component: EmployeesList_component_1.EmployeesListComponent },
    { path: 'Employees/add', component: EmployeesAdd_component_1.EmployeesAddComponent },
    { path: 'Employees/:id', component: EmployeesEdit_component_1.EmployeesEditComponent },
    { path: 'Employees/Details/:id', component: EmployeesDetails_component_1.EmployeesDetailsComponent },
];
var EmployeesRoutingModule = (function () {
    function EmployeesRoutingModule() {
    }
    EmployeesRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(EmployeesRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], EmployeesRoutingModule);
    return EmployeesRoutingModule;
}());
exports.EmployeesRoutingModule = EmployeesRoutingModule;


/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeesModule
 * Purpose		: Module for Employees.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var Employees_service_1 = __webpack_require__(28);
var EmployeesList_component_1 = __webpack_require__(402);
var EmployeesSearch_component_1 = __webpack_require__(403);
var EmployeesAdd_component_1 = __webpack_require__(399);
var EmployeesEdit_component_1 = __webpack_require__(401);
var EmployeesDetails_component_1 = __webpack_require__(400);
var Employees_routing_module_1 = __webpack_require__(894);
var EmployeesModule = (function () {
    function EmployeesModule() {
    }
    EmployeesModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                Employees_routing_module_1.EmployeesRoutingModule
            ],
            declarations: [
                EmployeesList_component_1.EmployeesListComponent,
                EmployeesSearch_component_1.EmployeesSearchComponent,
                EmployeesEdit_component_1.EmployeesEditComponent,
                EmployeesAdd_component_1.EmployeesAddComponent,
                EmployeesDetails_component_1.EmployeesDetailsComponent
            ],
            providers: [
                Employees_service_1.EmployeesService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], EmployeesModule);
    return EmployeesModule;
}());
exports.EmployeesModule = EmployeesModule;


/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: InvoicesRoutingModule
 * Purpose		: Routing module for Invoices.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var InvoicesList_component_1 = __webpack_require__(405);
var InvoicesDetails_component_1 = __webpack_require__(404);
var InvoicesRoutes = [
    { path: 'Invoices', component: InvoicesList_component_1.InvoicesListComponent },
    { path: 'Invoices/Details/:id', component: InvoicesDetails_component_1.InvoicesDetailsComponent },
];
var InvoicesRoutingModule = (function () {
    function InvoicesRoutingModule() {
    }
    InvoicesRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(InvoicesRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], InvoicesRoutingModule);
    return InvoicesRoutingModule;
}());
exports.InvoicesRoutingModule = InvoicesRoutingModule;


/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: InvoicesModule
 * Purpose		: Module for Invoices.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var Invoices_service_1 = __webpack_require__(144);
var InvoicesList_component_1 = __webpack_require__(405);
var InvoicesSearch_component_1 = __webpack_require__(406);
var InvoicesDetails_component_1 = __webpack_require__(404);
var Invoices_routing_module_1 = __webpack_require__(896);
var InvoicesModule = (function () {
    function InvoicesModule() {
    }
    InvoicesModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                Invoices_routing_module_1.InvoicesRoutingModule
            ],
            declarations: [
                InvoicesList_component_1.InvoicesListComponent,
                InvoicesSearch_component_1.InvoicesSearchComponent,
                InvoicesDetails_component_1.InvoicesDetailsComponent
            ],
            providers: [
                Invoices_service_1.InvoicesService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], InvoicesModule);
    return InvoicesModule;
}());
exports.InvoicesModule = InvoicesModule;


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderDetailsExtendedRoutingModule
 * Purpose		: Routing module for OrderDetailsExtended.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var OrderDetailsExtendedList_component_1 = __webpack_require__(408);
var OrderDetailsExtendedDetails_component_1 = __webpack_require__(407);
var OrderDetailsExtendedRoutes = [
    { path: 'OrderDetailsExtended', component: OrderDetailsExtendedList_component_1.OrderDetailsExtendedListComponent },
    { path: 'OrderDetailsExtended/Details/:id', component: OrderDetailsExtendedDetails_component_1.OrderDetailsExtendedDetailsComponent },
];
var OrderDetailsExtendedRoutingModule = (function () {
    function OrderDetailsExtendedRoutingModule() {
    }
    OrderDetailsExtendedRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(OrderDetailsExtendedRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], OrderDetailsExtendedRoutingModule);
    return OrderDetailsExtendedRoutingModule;
}());
exports.OrderDetailsExtendedRoutingModule = OrderDetailsExtendedRoutingModule;


/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderDetailsExtendedModule
 * Purpose		: Module for OrderDetailsExtended.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var OrderDetailsExtended_service_1 = __webpack_require__(145);
var OrderDetailsExtendedList_component_1 = __webpack_require__(408);
var OrderDetailsExtendedSearch_component_1 = __webpack_require__(409);
var OrderDetailsExtendedDetails_component_1 = __webpack_require__(407);
var OrderDetailsExtended_routing_module_1 = __webpack_require__(898);
var OrderDetailsExtendedModule = (function () {
    function OrderDetailsExtendedModule() {
    }
    OrderDetailsExtendedModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                OrderDetailsExtended_routing_module_1.OrderDetailsExtendedRoutingModule
            ],
            declarations: [
                OrderDetailsExtendedList_component_1.OrderDetailsExtendedListComponent,
                OrderDetailsExtendedSearch_component_1.OrderDetailsExtendedSearchComponent,
                OrderDetailsExtendedDetails_component_1.OrderDetailsExtendedDetailsComponent
            ],
            providers: [
                OrderDetailsExtended_service_1.OrderDetailsExtendedService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], OrderDetailsExtendedModule);
    return OrderDetailsExtendedModule;
}());
exports.OrderDetailsExtendedModule = OrderDetailsExtendedModule;


/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderDetailsRoutingModule
 * Purpose		: Routing module for OrderDetails.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var OrderDetailsList_component_1 = __webpack_require__(413);
var OrderDetailsAdd_component_1 = __webpack_require__(410);
var OrderDetailsEdit_component_1 = __webpack_require__(412);
var OrderDetailsDetails_component_1 = __webpack_require__(411);
var OrderDetailsRoutes = [
    { path: 'OrderDetails', component: OrderDetailsList_component_1.OrderDetailsListComponent },
    { path: 'OrderDetails/add', component: OrderDetailsAdd_component_1.OrderDetailsAddComponent },
    { path: 'OrderDetails/:id', component: OrderDetailsEdit_component_1.OrderDetailsEditComponent },
    { path: 'OrderDetails/Details/:id', component: OrderDetailsDetails_component_1.OrderDetailsDetailsComponent },
];
var OrderDetailsRoutingModule = (function () {
    function OrderDetailsRoutingModule() {
    }
    OrderDetailsRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(OrderDetailsRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], OrderDetailsRoutingModule);
    return OrderDetailsRoutingModule;
}());
exports.OrderDetailsRoutingModule = OrderDetailsRoutingModule;


/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderDetailsModule
 * Purpose		: Module for OrderDetails.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var OrderDetails_service_1 = __webpack_require__(82);
var OrderDetailsList_component_1 = __webpack_require__(413);
var OrderDetailsSearch_component_1 = __webpack_require__(414);
var OrderDetailsAdd_component_1 = __webpack_require__(410);
var OrderDetailsEdit_component_1 = __webpack_require__(412);
var OrderDetailsDetails_component_1 = __webpack_require__(411);
var OrderDetails_routing_module_1 = __webpack_require__(900);
var OrderDetailsModule = (function () {
    function OrderDetailsModule() {
    }
    OrderDetailsModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                OrderDetails_routing_module_1.OrderDetailsRoutingModule
            ],
            declarations: [
                OrderDetailsList_component_1.OrderDetailsListComponent,
                OrderDetailsSearch_component_1.OrderDetailsSearchComponent,
                OrderDetailsEdit_component_1.OrderDetailsEditComponent,
                OrderDetailsAdd_component_1.OrderDetailsAddComponent,
                OrderDetailsDetails_component_1.OrderDetailsDetailsComponent
            ],
            providers: [
                OrderDetails_service_1.OrderDetailsService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], OrderDetailsModule);
    return OrderDetailsModule;
}());
exports.OrderDetailsModule = OrderDetailsModule;


/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderSubtotalsRoutingModule
 * Purpose		: Routing module for OrderSubtotals.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var OrderSubtotalsList_component_1 = __webpack_require__(416);
var OrderSubtotalsDetails_component_1 = __webpack_require__(415);
var OrderSubtotalsRoutes = [
    { path: 'OrderSubtotals', component: OrderSubtotalsList_component_1.OrderSubtotalsListComponent },
    { path: 'OrderSubtotals/Details/:id', component: OrderSubtotalsDetails_component_1.OrderSubtotalsDetailsComponent },
];
var OrderSubtotalsRoutingModule = (function () {
    function OrderSubtotalsRoutingModule() {
    }
    OrderSubtotalsRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(OrderSubtotalsRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], OrderSubtotalsRoutingModule);
    return OrderSubtotalsRoutingModule;
}());
exports.OrderSubtotalsRoutingModule = OrderSubtotalsRoutingModule;


/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderSubtotalsModule
 * Purpose		: Module for OrderSubtotals.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var OrderSubtotals_service_1 = __webpack_require__(146);
var OrderSubtotalsList_component_1 = __webpack_require__(416);
var OrderSubtotalsSearch_component_1 = __webpack_require__(417);
var OrderSubtotalsDetails_component_1 = __webpack_require__(415);
var OrderSubtotals_routing_module_1 = __webpack_require__(902);
var OrderSubtotalsModule = (function () {
    function OrderSubtotalsModule() {
    }
    OrderSubtotalsModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                OrderSubtotals_routing_module_1.OrderSubtotalsRoutingModule
            ],
            declarations: [
                OrderSubtotalsList_component_1.OrderSubtotalsListComponent,
                OrderSubtotalsSearch_component_1.OrderSubtotalsSearchComponent,
                OrderSubtotalsDetails_component_1.OrderSubtotalsDetailsComponent
            ],
            providers: [
                OrderSubtotals_service_1.OrderSubtotalsService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], OrderSubtotalsModule);
    return OrderSubtotalsModule;
}());
exports.OrderSubtotalsModule = OrderSubtotalsModule;


/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrdersQryRoutingModule
 * Purpose		: Routing module for OrdersQry.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var OrdersQryList_component_1 = __webpack_require__(419);
var OrdersQryDetails_component_1 = __webpack_require__(418);
var OrdersQryRoutes = [
    { path: 'OrdersQry', component: OrdersQryList_component_1.OrdersQryListComponent },
    { path: 'OrdersQry/Details/:id', component: OrdersQryDetails_component_1.OrdersQryDetailsComponent },
];
var OrdersQryRoutingModule = (function () {
    function OrdersQryRoutingModule() {
    }
    OrdersQryRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(OrdersQryRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], OrdersQryRoutingModule);
    return OrdersQryRoutingModule;
}());
exports.OrdersQryRoutingModule = OrdersQryRoutingModule;


/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrdersQryModule
 * Purpose		: Module for OrdersQry.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var OrdersQry_service_1 = __webpack_require__(147);
var OrdersQryList_component_1 = __webpack_require__(419);
var OrdersQrySearch_component_1 = __webpack_require__(420);
var OrdersQryDetails_component_1 = __webpack_require__(418);
var OrdersQry_routing_module_1 = __webpack_require__(904);
var OrdersQryModule = (function () {
    function OrdersQryModule() {
    }
    OrdersQryModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                OrdersQry_routing_module_1.OrdersQryRoutingModule
            ],
            declarations: [
                OrdersQryList_component_1.OrdersQryListComponent,
                OrdersQrySearch_component_1.OrdersQrySearchComponent,
                OrdersQryDetails_component_1.OrdersQryDetailsComponent
            ],
            providers: [
                OrdersQry_service_1.OrdersQryService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], OrdersQryModule);
    return OrdersQryModule;
}());
exports.OrdersQryModule = OrdersQryModule;


/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrdersRoutingModule
 * Purpose		: Routing module for Orders.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var OrdersList_component_1 = __webpack_require__(424);
var OrdersAdd_component_1 = __webpack_require__(421);
var OrdersEdit_component_1 = __webpack_require__(423);
var OrdersDetails_component_1 = __webpack_require__(422);
var OrdersRoutes = [
    { path: 'Orders', component: OrdersList_component_1.OrdersListComponent },
    { path: 'Orders/add', component: OrdersAdd_component_1.OrdersAddComponent },
    { path: 'Orders/:id', component: OrdersEdit_component_1.OrdersEditComponent },
    { path: 'Orders/Details/:id', component: OrdersDetails_component_1.OrdersDetailsComponent },
];
var OrdersRoutingModule = (function () {
    function OrdersRoutingModule() {
    }
    OrdersRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(OrdersRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], OrdersRoutingModule);
    return OrdersRoutingModule;
}());
exports.OrdersRoutingModule = OrdersRoutingModule;


/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrdersModule
 * Purpose		: Module for Orders.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var Orders_service_1 = __webpack_require__(43);
var OrdersList_component_1 = __webpack_require__(424);
var OrdersSearch_component_1 = __webpack_require__(425);
var OrdersAdd_component_1 = __webpack_require__(421);
var OrdersEdit_component_1 = __webpack_require__(423);
var OrdersDetails_component_1 = __webpack_require__(422);
var Orders_routing_module_1 = __webpack_require__(906);
var OrdersModule = (function () {
    function OrdersModule() {
    }
    OrdersModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                Orders_routing_module_1.OrdersRoutingModule
            ],
            declarations: [
                OrdersList_component_1.OrdersListComponent,
                OrdersSearch_component_1.OrdersSearchComponent,
                OrdersEdit_component_1.OrdersEditComponent,
                OrdersAdd_component_1.OrdersAddComponent,
                OrdersDetails_component_1.OrdersDetailsComponent
            ],
            providers: [
                Orders_service_1.OrdersService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], OrdersModule);
    return OrdersModule;
}());
exports.OrdersModule = OrdersModule;


/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductSalesfor1997RoutingModule
 * Purpose		: Routing module for ProductSalesfor1997.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ProductSalesfor1997List_component_1 = __webpack_require__(427);
var ProductSalesfor1997Details_component_1 = __webpack_require__(426);
var ProductSalesfor1997Routes = [
    { path: 'ProductSalesfor1997', component: ProductSalesfor1997List_component_1.ProductSalesfor1997ListComponent },
    { path: 'ProductSalesfor1997/Details/:id', component: ProductSalesfor1997Details_component_1.ProductSalesfor1997DetailsComponent },
];
var ProductSalesfor1997RoutingModule = (function () {
    function ProductSalesfor1997RoutingModule() {
    }
    ProductSalesfor1997RoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(ProductSalesfor1997Routes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], ProductSalesfor1997RoutingModule);
    return ProductSalesfor1997RoutingModule;
}());
exports.ProductSalesfor1997RoutingModule = ProductSalesfor1997RoutingModule;


/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductSalesfor1997Module
 * Purpose		: Module for ProductSalesfor1997.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var ProductSalesfor1997_service_1 = __webpack_require__(148);
var ProductSalesfor1997List_component_1 = __webpack_require__(427);
var ProductSalesfor1997Search_component_1 = __webpack_require__(428);
var ProductSalesfor1997Details_component_1 = __webpack_require__(426);
var ProductSalesfor1997_routing_module_1 = __webpack_require__(908);
var ProductSalesfor1997Module = (function () {
    function ProductSalesfor1997Module() {
    }
    ProductSalesfor1997Module = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                ProductSalesfor1997_routing_module_1.ProductSalesfor1997RoutingModule
            ],
            declarations: [
                ProductSalesfor1997List_component_1.ProductSalesfor1997ListComponent,
                ProductSalesfor1997Search_component_1.ProductSalesfor1997SearchComponent,
                ProductSalesfor1997Details_component_1.ProductSalesfor1997DetailsComponent
            ],
            providers: [
                ProductSalesfor1997_service_1.ProductSalesfor1997Service
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], ProductSalesfor1997Module);
    return ProductSalesfor1997Module;
}());
exports.ProductSalesfor1997Module = ProductSalesfor1997Module;


/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsAboveAveragePriceRoutingModule
 * Purpose		: Routing module for ProductsAboveAveragePrice.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ProductsAboveAveragePriceList_component_1 = __webpack_require__(430);
var ProductsAboveAveragePriceDetails_component_1 = __webpack_require__(429);
var ProductsAboveAveragePriceRoutes = [
    { path: 'ProductsAboveAveragePrice', component: ProductsAboveAveragePriceList_component_1.ProductsAboveAveragePriceListComponent },
    { path: 'ProductsAboveAveragePrice/Details/:id', component: ProductsAboveAveragePriceDetails_component_1.ProductsAboveAveragePriceDetailsComponent },
];
var ProductsAboveAveragePriceRoutingModule = (function () {
    function ProductsAboveAveragePriceRoutingModule() {
    }
    ProductsAboveAveragePriceRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(ProductsAboveAveragePriceRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], ProductsAboveAveragePriceRoutingModule);
    return ProductsAboveAveragePriceRoutingModule;
}());
exports.ProductsAboveAveragePriceRoutingModule = ProductsAboveAveragePriceRoutingModule;


/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsAboveAveragePriceModule
 * Purpose		: Module for ProductsAboveAveragePrice.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var ProductsAboveAveragePrice_service_1 = __webpack_require__(149);
var ProductsAboveAveragePriceList_component_1 = __webpack_require__(430);
var ProductsAboveAveragePriceSearch_component_1 = __webpack_require__(431);
var ProductsAboveAveragePriceDetails_component_1 = __webpack_require__(429);
var ProductsAboveAveragePrice_routing_module_1 = __webpack_require__(910);
var ProductsAboveAveragePriceModule = (function () {
    function ProductsAboveAveragePriceModule() {
    }
    ProductsAboveAveragePriceModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                ProductsAboveAveragePrice_routing_module_1.ProductsAboveAveragePriceRoutingModule
            ],
            declarations: [
                ProductsAboveAveragePriceList_component_1.ProductsAboveAveragePriceListComponent,
                ProductsAboveAveragePriceSearch_component_1.ProductsAboveAveragePriceSearchComponent,
                ProductsAboveAveragePriceDetails_component_1.ProductsAboveAveragePriceDetailsComponent
            ],
            providers: [
                ProductsAboveAveragePrice_service_1.ProductsAboveAveragePriceService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], ProductsAboveAveragePriceModule);
    return ProductsAboveAveragePriceModule;
}());
exports.ProductsAboveAveragePriceModule = ProductsAboveAveragePriceModule;


/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsRoutingModule
 * Purpose		: Routing module for Products.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ProductsList_component_1 = __webpack_require__(435);
var ProductsAdd_component_1 = __webpack_require__(432);
var ProductsEdit_component_1 = __webpack_require__(434);
var ProductsDetails_component_1 = __webpack_require__(433);
var ProductsRoutes = [
    { path: 'Products', component: ProductsList_component_1.ProductsListComponent },
    { path: 'Products/add', component: ProductsAdd_component_1.ProductsAddComponent },
    { path: 'Products/:id', component: ProductsEdit_component_1.ProductsEditComponent },
    { path: 'Products/Details/:id', component: ProductsDetails_component_1.ProductsDetailsComponent },
];
var ProductsRoutingModule = (function () {
    function ProductsRoutingModule() {
    }
    ProductsRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(ProductsRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], ProductsRoutingModule);
    return ProductsRoutingModule;
}());
exports.ProductsRoutingModule = ProductsRoutingModule;


/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsModule
 * Purpose		: Module for Products.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var Products_service_1 = __webpack_require__(44);
var ProductsList_component_1 = __webpack_require__(435);
var ProductsSearch_component_1 = __webpack_require__(436);
var ProductsAdd_component_1 = __webpack_require__(432);
var ProductsEdit_component_1 = __webpack_require__(434);
var ProductsDetails_component_1 = __webpack_require__(433);
var Products_routing_module_1 = __webpack_require__(912);
var ProductsModule = (function () {
    function ProductsModule() {
    }
    ProductsModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                Products_routing_module_1.ProductsRoutingModule
            ],
            declarations: [
                ProductsList_component_1.ProductsListComponent,
                ProductsSearch_component_1.ProductsSearchComponent,
                ProductsEdit_component_1.ProductsEditComponent,
                ProductsAdd_component_1.ProductsAddComponent,
                ProductsDetails_component_1.ProductsDetailsComponent
            ],
            providers: [
                Products_service_1.ProductsService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], ProductsModule);
    return ProductsModule;
}());
exports.ProductsModule = ProductsModule;


/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsbyCategoryRoutingModule
 * Purpose		: Routing module for ProductsbyCategory.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ProductsbyCategoryList_component_1 = __webpack_require__(438);
var ProductsbyCategoryDetails_component_1 = __webpack_require__(437);
var ProductsbyCategoryRoutes = [
    { path: 'ProductsbyCategory', component: ProductsbyCategoryList_component_1.ProductsbyCategoryListComponent },
    { path: 'ProductsbyCategory/Details/:id', component: ProductsbyCategoryDetails_component_1.ProductsbyCategoryDetailsComponent },
];
var ProductsbyCategoryRoutingModule = (function () {
    function ProductsbyCategoryRoutingModule() {
    }
    ProductsbyCategoryRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(ProductsbyCategoryRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], ProductsbyCategoryRoutingModule);
    return ProductsbyCategoryRoutingModule;
}());
exports.ProductsbyCategoryRoutingModule = ProductsbyCategoryRoutingModule;


/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsbyCategoryModule
 * Purpose		: Module for ProductsbyCategory.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var ProductsbyCategory_service_1 = __webpack_require__(150);
var ProductsbyCategoryList_component_1 = __webpack_require__(438);
var ProductsbyCategorySearch_component_1 = __webpack_require__(439);
var ProductsbyCategoryDetails_component_1 = __webpack_require__(437);
var ProductsbyCategory_routing_module_1 = __webpack_require__(914);
var ProductsbyCategoryModule = (function () {
    function ProductsbyCategoryModule() {
    }
    ProductsbyCategoryModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                ProductsbyCategory_routing_module_1.ProductsbyCategoryRoutingModule
            ],
            declarations: [
                ProductsbyCategoryList_component_1.ProductsbyCategoryListComponent,
                ProductsbyCategorySearch_component_1.ProductsbyCategorySearchComponent,
                ProductsbyCategoryDetails_component_1.ProductsbyCategoryDetailsComponent
            ],
            providers: [
                ProductsbyCategory_service_1.ProductsbyCategoryService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], ProductsbyCategoryModule);
    return ProductsbyCategoryModule;
}());
exports.ProductsbyCategoryModule = ProductsbyCategoryModule;


/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: QuarterlyOrdersRoutingModule
 * Purpose		: Routing module for QuarterlyOrders.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var QuarterlyOrdersList_component_1 = __webpack_require__(441);
var QuarterlyOrdersDetails_component_1 = __webpack_require__(440);
var QuarterlyOrdersRoutes = [
    { path: 'QuarterlyOrders', component: QuarterlyOrdersList_component_1.QuarterlyOrdersListComponent },
    { path: 'QuarterlyOrders/Details/:id', component: QuarterlyOrdersDetails_component_1.QuarterlyOrdersDetailsComponent },
];
var QuarterlyOrdersRoutingModule = (function () {
    function QuarterlyOrdersRoutingModule() {
    }
    QuarterlyOrdersRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(QuarterlyOrdersRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], QuarterlyOrdersRoutingModule);
    return QuarterlyOrdersRoutingModule;
}());
exports.QuarterlyOrdersRoutingModule = QuarterlyOrdersRoutingModule;


/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: QuarterlyOrdersModule
 * Purpose		: Module for QuarterlyOrders.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var QuarterlyOrders_service_1 = __webpack_require__(151);
var QuarterlyOrdersList_component_1 = __webpack_require__(441);
var QuarterlyOrdersSearch_component_1 = __webpack_require__(442);
var QuarterlyOrdersDetails_component_1 = __webpack_require__(440);
var QuarterlyOrders_routing_module_1 = __webpack_require__(916);
var QuarterlyOrdersModule = (function () {
    function QuarterlyOrdersModule() {
    }
    QuarterlyOrdersModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                QuarterlyOrders_routing_module_1.QuarterlyOrdersRoutingModule
            ],
            declarations: [
                QuarterlyOrdersList_component_1.QuarterlyOrdersListComponent,
                QuarterlyOrdersSearch_component_1.QuarterlyOrdersSearchComponent,
                QuarterlyOrdersDetails_component_1.QuarterlyOrdersDetailsComponent
            ],
            providers: [
                QuarterlyOrders_service_1.QuarterlyOrdersService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], QuarterlyOrdersModule);
    return QuarterlyOrdersModule;
}());
exports.QuarterlyOrdersModule = QuarterlyOrdersModule;


/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: RegionRoutingModule
 * Purpose		: Routing module for Region.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var RegionList_component_1 = __webpack_require__(446);
var RegionAdd_component_1 = __webpack_require__(443);
var RegionEdit_component_1 = __webpack_require__(445);
var RegionDetails_component_1 = __webpack_require__(444);
var RegionRoutes = [
    { path: 'Region', component: RegionList_component_1.RegionListComponent },
    { path: 'Region/add', component: RegionAdd_component_1.RegionAddComponent },
    { path: 'Region/:id', component: RegionEdit_component_1.RegionEditComponent },
    { path: 'Region/Details/:id', component: RegionDetails_component_1.RegionDetailsComponent },
];
var RegionRoutingModule = (function () {
    function RegionRoutingModule() {
    }
    RegionRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(RegionRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], RegionRoutingModule);
    return RegionRoutingModule;
}());
exports.RegionRoutingModule = RegionRoutingModule;


/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: RegionModule
 * Purpose		: Module for Region.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var Region_service_1 = __webpack_require__(45);
var RegionList_component_1 = __webpack_require__(446);
var RegionSearch_component_1 = __webpack_require__(447);
var RegionAdd_component_1 = __webpack_require__(443);
var RegionEdit_component_1 = __webpack_require__(445);
var RegionDetails_component_1 = __webpack_require__(444);
var Region_routing_module_1 = __webpack_require__(918);
var RegionModule = (function () {
    function RegionModule() {
    }
    RegionModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                Region_routing_module_1.RegionRoutingModule
            ],
            declarations: [
                RegionList_component_1.RegionListComponent,
                RegionSearch_component_1.RegionSearchComponent,
                RegionEdit_component_1.RegionEditComponent,
                RegionAdd_component_1.RegionAddComponent,
                RegionDetails_component_1.RegionDetailsComponent
            ],
            providers: [
                Region_service_1.RegionService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], RegionModule);
    return RegionModule;
}());
exports.RegionModule = RegionModule;


/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SalesTotalsbyAmountRoutingModule
 * Purpose		: Routing module for SalesTotalsbyAmount.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var SalesTotalsbyAmountList_component_1 = __webpack_require__(449);
var SalesTotalsbyAmountDetails_component_1 = __webpack_require__(448);
var SalesTotalsbyAmountRoutes = [
    { path: 'SalesTotalsbyAmount', component: SalesTotalsbyAmountList_component_1.SalesTotalsbyAmountListComponent },
    { path: 'SalesTotalsbyAmount/Details/:id', component: SalesTotalsbyAmountDetails_component_1.SalesTotalsbyAmountDetailsComponent },
];
var SalesTotalsbyAmountRoutingModule = (function () {
    function SalesTotalsbyAmountRoutingModule() {
    }
    SalesTotalsbyAmountRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(SalesTotalsbyAmountRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], SalesTotalsbyAmountRoutingModule);
    return SalesTotalsbyAmountRoutingModule;
}());
exports.SalesTotalsbyAmountRoutingModule = SalesTotalsbyAmountRoutingModule;


/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SalesTotalsbyAmountModule
 * Purpose		: Module for SalesTotalsbyAmount.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var SalesTotalsbyAmount_service_1 = __webpack_require__(152);
var SalesTotalsbyAmountList_component_1 = __webpack_require__(449);
var SalesTotalsbyAmountSearch_component_1 = __webpack_require__(450);
var SalesTotalsbyAmountDetails_component_1 = __webpack_require__(448);
var SalesTotalsbyAmount_routing_module_1 = __webpack_require__(920);
var SalesTotalsbyAmountModule = (function () {
    function SalesTotalsbyAmountModule() {
    }
    SalesTotalsbyAmountModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                SalesTotalsbyAmount_routing_module_1.SalesTotalsbyAmountRoutingModule
            ],
            declarations: [
                SalesTotalsbyAmountList_component_1.SalesTotalsbyAmountListComponent,
                SalesTotalsbyAmountSearch_component_1.SalesTotalsbyAmountSearchComponent,
                SalesTotalsbyAmountDetails_component_1.SalesTotalsbyAmountDetailsComponent
            ],
            providers: [
                SalesTotalsbyAmount_service_1.SalesTotalsbyAmountService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], SalesTotalsbyAmountModule);
    return SalesTotalsbyAmountModule;
}());
exports.SalesTotalsbyAmountModule = SalesTotalsbyAmountModule;


/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SalesbyCategoryRoutingModule
 * Purpose		: Routing module for SalesbyCategory.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var SalesbyCategoryList_component_1 = __webpack_require__(452);
var SalesbyCategoryDetails_component_1 = __webpack_require__(451);
var SalesbyCategoryRoutes = [
    { path: 'SalesbyCategory', component: SalesbyCategoryList_component_1.SalesbyCategoryListComponent },
    { path: 'SalesbyCategory/Details/:id', component: SalesbyCategoryDetails_component_1.SalesbyCategoryDetailsComponent },
];
var SalesbyCategoryRoutingModule = (function () {
    function SalesbyCategoryRoutingModule() {
    }
    SalesbyCategoryRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(SalesbyCategoryRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], SalesbyCategoryRoutingModule);
    return SalesbyCategoryRoutingModule;
}());
exports.SalesbyCategoryRoutingModule = SalesbyCategoryRoutingModule;


/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SalesbyCategoryModule
 * Purpose		: Module for SalesbyCategory.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var SalesbyCategory_service_1 = __webpack_require__(153);
var SalesbyCategoryList_component_1 = __webpack_require__(452);
var SalesbyCategorySearch_component_1 = __webpack_require__(453);
var SalesbyCategoryDetails_component_1 = __webpack_require__(451);
var SalesbyCategory_routing_module_1 = __webpack_require__(922);
var SalesbyCategoryModule = (function () {
    function SalesbyCategoryModule() {
    }
    SalesbyCategoryModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                SalesbyCategory_routing_module_1.SalesbyCategoryRoutingModule
            ],
            declarations: [
                SalesbyCategoryList_component_1.SalesbyCategoryListComponent,
                SalesbyCategorySearch_component_1.SalesbyCategorySearchComponent,
                SalesbyCategoryDetails_component_1.SalesbyCategoryDetailsComponent
            ],
            providers: [
                SalesbyCategory_service_1.SalesbyCategoryService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], SalesbyCategoryModule);
    return SalesbyCategoryModule;
}());
exports.SalesbyCategoryModule = SalesbyCategoryModule;


/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ShippersRoutingModule
 * Purpose		: Routing module for Shippers.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ShippersList_component_1 = __webpack_require__(457);
var ShippersAdd_component_1 = __webpack_require__(454);
var ShippersEdit_component_1 = __webpack_require__(456);
var ShippersDetails_component_1 = __webpack_require__(455);
var ShippersRoutes = [
    { path: 'Shippers', component: ShippersList_component_1.ShippersListComponent },
    { path: 'Shippers/add', component: ShippersAdd_component_1.ShippersAddComponent },
    { path: 'Shippers/:id', component: ShippersEdit_component_1.ShippersEditComponent },
    { path: 'Shippers/Details/:id', component: ShippersDetails_component_1.ShippersDetailsComponent },
];
var ShippersRoutingModule = (function () {
    function ShippersRoutingModule() {
    }
    ShippersRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(ShippersRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], ShippersRoutingModule);
    return ShippersRoutingModule;
}());
exports.ShippersRoutingModule = ShippersRoutingModule;


/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ShippersModule
 * Purpose		: Module for Shippers.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var Shippers_service_1 = __webpack_require__(46);
var ShippersList_component_1 = __webpack_require__(457);
var ShippersSearch_component_1 = __webpack_require__(458);
var ShippersAdd_component_1 = __webpack_require__(454);
var ShippersEdit_component_1 = __webpack_require__(456);
var ShippersDetails_component_1 = __webpack_require__(455);
var Shippers_routing_module_1 = __webpack_require__(924);
var ShippersModule = (function () {
    function ShippersModule() {
    }
    ShippersModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                Shippers_routing_module_1.ShippersRoutingModule
            ],
            declarations: [
                ShippersList_component_1.ShippersListComponent,
                ShippersSearch_component_1.ShippersSearchComponent,
                ShippersEdit_component_1.ShippersEditComponent,
                ShippersAdd_component_1.ShippersAddComponent,
                ShippersDetails_component_1.ShippersDetailsComponent
            ],
            providers: [
                Shippers_service_1.ShippersService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], ShippersModule);
    return ShippersModule;
}());
exports.ShippersModule = ShippersModule;


/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SummaryofSalesbyQuarterRoutingModule
 * Purpose		: Routing module for SummaryofSalesbyQuarter.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var SummaryofSalesbyQuarterList_component_1 = __webpack_require__(460);
var SummaryofSalesbyQuarterDetails_component_1 = __webpack_require__(459);
var SummaryofSalesbyQuarterRoutes = [
    { path: 'SummaryofSalesbyQuarter', component: SummaryofSalesbyQuarterList_component_1.SummaryofSalesbyQuarterListComponent },
    { path: 'SummaryofSalesbyQuarter/Details/:id', component: SummaryofSalesbyQuarterDetails_component_1.SummaryofSalesbyQuarterDetailsComponent },
];
var SummaryofSalesbyQuarterRoutingModule = (function () {
    function SummaryofSalesbyQuarterRoutingModule() {
    }
    SummaryofSalesbyQuarterRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(SummaryofSalesbyQuarterRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], SummaryofSalesbyQuarterRoutingModule);
    return SummaryofSalesbyQuarterRoutingModule;
}());
exports.SummaryofSalesbyQuarterRoutingModule = SummaryofSalesbyQuarterRoutingModule;


/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SummaryofSalesbyQuarterModule
 * Purpose		: Module for SummaryofSalesbyQuarter.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var SummaryofSalesbyQuarter_service_1 = __webpack_require__(154);
var SummaryofSalesbyQuarterList_component_1 = __webpack_require__(460);
var SummaryofSalesbyQuarterSearch_component_1 = __webpack_require__(461);
var SummaryofSalesbyQuarterDetails_component_1 = __webpack_require__(459);
var SummaryofSalesbyQuarter_routing_module_1 = __webpack_require__(926);
var SummaryofSalesbyQuarterModule = (function () {
    function SummaryofSalesbyQuarterModule() {
    }
    SummaryofSalesbyQuarterModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                SummaryofSalesbyQuarter_routing_module_1.SummaryofSalesbyQuarterRoutingModule
            ],
            declarations: [
                SummaryofSalesbyQuarterList_component_1.SummaryofSalesbyQuarterListComponent,
                SummaryofSalesbyQuarterSearch_component_1.SummaryofSalesbyQuarterSearchComponent,
                SummaryofSalesbyQuarterDetails_component_1.SummaryofSalesbyQuarterDetailsComponent
            ],
            providers: [
                SummaryofSalesbyQuarter_service_1.SummaryofSalesbyQuarterService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], SummaryofSalesbyQuarterModule);
    return SummaryofSalesbyQuarterModule;
}());
exports.SummaryofSalesbyQuarterModule = SummaryofSalesbyQuarterModule;


/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SummaryofSalesbyYearRoutingModule
 * Purpose		: Routing module for SummaryofSalesbyYear.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var SummaryofSalesbyYearList_component_1 = __webpack_require__(463);
var SummaryofSalesbyYearDetails_component_1 = __webpack_require__(462);
var SummaryofSalesbyYearRoutes = [
    { path: 'SummaryofSalesbyYear', component: SummaryofSalesbyYearList_component_1.SummaryofSalesbyYearListComponent },
    { path: 'SummaryofSalesbyYear/Details/:id', component: SummaryofSalesbyYearDetails_component_1.SummaryofSalesbyYearDetailsComponent },
];
var SummaryofSalesbyYearRoutingModule = (function () {
    function SummaryofSalesbyYearRoutingModule() {
    }
    SummaryofSalesbyYearRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(SummaryofSalesbyYearRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], SummaryofSalesbyYearRoutingModule);
    return SummaryofSalesbyYearRoutingModule;
}());
exports.SummaryofSalesbyYearRoutingModule = SummaryofSalesbyYearRoutingModule;


/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SummaryofSalesbyYearModule
 * Purpose		: Module for SummaryofSalesbyYear.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var SummaryofSalesbyYear_service_1 = __webpack_require__(155);
var SummaryofSalesbyYearList_component_1 = __webpack_require__(463);
var SummaryofSalesbyYearSearch_component_1 = __webpack_require__(464);
var SummaryofSalesbyYearDetails_component_1 = __webpack_require__(462);
var SummaryofSalesbyYear_routing_module_1 = __webpack_require__(928);
var SummaryofSalesbyYearModule = (function () {
    function SummaryofSalesbyYearModule() {
    }
    SummaryofSalesbyYearModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                SummaryofSalesbyYear_routing_module_1.SummaryofSalesbyYearRoutingModule
            ],
            declarations: [
                SummaryofSalesbyYearList_component_1.SummaryofSalesbyYearListComponent,
                SummaryofSalesbyYearSearch_component_1.SummaryofSalesbyYearSearchComponent,
                SummaryofSalesbyYearDetails_component_1.SummaryofSalesbyYearDetailsComponent
            ],
            providers: [
                SummaryofSalesbyYear_service_1.SummaryofSalesbyYearService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], SummaryofSalesbyYearModule);
    return SummaryofSalesbyYearModule;
}());
exports.SummaryofSalesbyYearModule = SummaryofSalesbyYearModule;


/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SuppliersRoutingModule
 * Purpose		: Routing module for Suppliers.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var SuppliersList_component_1 = __webpack_require__(468);
var SuppliersAdd_component_1 = __webpack_require__(465);
var SuppliersEdit_component_1 = __webpack_require__(467);
var SuppliersDetails_component_1 = __webpack_require__(466);
var SuppliersRoutes = [
    { path: 'Suppliers', component: SuppliersList_component_1.SuppliersListComponent },
    { path: 'Suppliers/add', component: SuppliersAdd_component_1.SuppliersAddComponent },
    { path: 'Suppliers/:id', component: SuppliersEdit_component_1.SuppliersEditComponent },
    { path: 'Suppliers/Details/:id', component: SuppliersDetails_component_1.SuppliersDetailsComponent },
];
var SuppliersRoutingModule = (function () {
    function SuppliersRoutingModule() {
    }
    SuppliersRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(SuppliersRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], SuppliersRoutingModule);
    return SuppliersRoutingModule;
}());
exports.SuppliersRoutingModule = SuppliersRoutingModule;


/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SuppliersModule
 * Purpose		: Module for Suppliers.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var Suppliers_service_1 = __webpack_require__(47);
var SuppliersList_component_1 = __webpack_require__(468);
var SuppliersSearch_component_1 = __webpack_require__(469);
var SuppliersAdd_component_1 = __webpack_require__(465);
var SuppliersEdit_component_1 = __webpack_require__(467);
var SuppliersDetails_component_1 = __webpack_require__(466);
var Suppliers_routing_module_1 = __webpack_require__(930);
var SuppliersModule = (function () {
    function SuppliersModule() {
    }
    SuppliersModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                Suppliers_routing_module_1.SuppliersRoutingModule
            ],
            declarations: [
                SuppliersList_component_1.SuppliersListComponent,
                SuppliersSearch_component_1.SuppliersSearchComponent,
                SuppliersEdit_component_1.SuppliersEditComponent,
                SuppliersAdd_component_1.SuppliersAddComponent,
                SuppliersDetails_component_1.SuppliersDetailsComponent
            ],
            providers: [
                Suppliers_service_1.SuppliersService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], SuppliersModule);
    return SuppliersModule;
}());
exports.SuppliersModule = SuppliersModule;


/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: TerritoriesRoutingModule
 * Purpose		: Routing module for Territories.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var TerritoriesList_component_1 = __webpack_require__(473);
var TerritoriesAdd_component_1 = __webpack_require__(470);
var TerritoriesEdit_component_1 = __webpack_require__(472);
var TerritoriesDetails_component_1 = __webpack_require__(471);
var TerritoriesRoutes = [
    { path: 'Territories', component: TerritoriesList_component_1.TerritoriesListComponent },
    { path: 'Territories/add', component: TerritoriesAdd_component_1.TerritoriesAddComponent },
    { path: 'Territories/:id', component: TerritoriesEdit_component_1.TerritoriesEditComponent },
    { path: 'Territories/Details/:id', component: TerritoriesDetails_component_1.TerritoriesDetailsComponent },
];
var TerritoriesRoutingModule = (function () {
    function TerritoriesRoutingModule() {
    }
    TerritoriesRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(TerritoriesRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], TerritoriesRoutingModule);
    return TerritoriesRoutingModule;
}());
exports.TerritoriesRoutingModule = TerritoriesRoutingModule;


/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: TerritoriesModule
 * Purpose		: Module for Territories.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var Shared_module_1 = __webpack_require__(16);
var Territories_service_1 = __webpack_require__(48);
var TerritoriesList_component_1 = __webpack_require__(473);
var TerritoriesSearch_component_1 = __webpack_require__(474);
var TerritoriesAdd_component_1 = __webpack_require__(470);
var TerritoriesEdit_component_1 = __webpack_require__(472);
var TerritoriesDetails_component_1 = __webpack_require__(471);
var Territories_routing_module_1 = __webpack_require__(932);
var TerritoriesModule = (function () {
    function TerritoriesModule() {
    }
    TerritoriesModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                Shared_module_1.SharedModule,
                Territories_routing_module_1.TerritoriesRoutingModule
            ],
            declarations: [
                TerritoriesList_component_1.TerritoriesListComponent,
                TerritoriesSearch_component_1.TerritoriesSearchComponent,
                TerritoriesEdit_component_1.TerritoriesEditComponent,
                TerritoriesAdd_component_1.TerritoriesAddComponent,
                TerritoriesDetails_component_1.TerritoriesDetailsComponent
            ],
            providers: [
                Territories_service_1.TerritoriesService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], TerritoriesModule);
    return TerritoriesModule;
}());
exports.TerritoriesModule = TerritoriesModule;


/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var admin_component_1 = __webpack_require__(479);
var admin_dashboard_component_1 = __webpack_require__(478);
var manage_users_component_1 = __webpack_require__(481);
var manage_roles_component_1 = __webpack_require__(480);
var auth_guard_service_1 = __webpack_require__(227);
var adminRoutes = [
    {
        path: 'admin',
        component: admin_component_1.AdminComponent,
        canActivate: [auth_guard_service_1.AuthGuard],
        children: [
            {
                path: '',
                canActivateChild: [auth_guard_service_1.AuthGuard],
                children: [
                    { path: 'users', component: manage_users_component_1.ManageUsersComponent },
                    { path: 'roles', component: manage_roles_component_1.ManageRolesComponent },
                    { path: '', component: admin_dashboard_component_1.AdminDashboardComponent }
                ]
            }
        ]
    }
];
var AdminRoutingModule = (function () {
    function AdminRoutingModule() {
    }
    AdminRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(adminRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], AdminRoutingModule);
    return AdminRoutingModule;
}());
exports.AdminRoutingModule = AdminRoutingModule;
/*
Copyright 2016 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/ 


/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var admin_component_1 = __webpack_require__(479);
var admin_dashboard_component_1 = __webpack_require__(478);
var manage_users_component_1 = __webpack_require__(481);
var manage_roles_component_1 = __webpack_require__(480);
var admin_routing_module_1 = __webpack_require__(934);
var AdminModule = (function () {
    function AdminModule() {
    }
    AdminModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                admin_routing_module_1.AdminRoutingModule
            ],
            declarations: [
                admin_component_1.AdminComponent,
                admin_dashboard_component_1.AdminDashboardComponent,
                manage_users_component_1.ManageUsersComponent,
                manage_roles_component_1.ManageRolesComponent
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], AdminModule);
    return AdminModule;
}());
exports.AdminModule = AdminModule;
/*
Copyright 2016 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/ 


/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng2_toastr_1 = __webpack_require__(6);
var shared_1 = __webpack_require__(487);
var auth_service_1 = __webpack_require__(68);
// import '../style/app.scss';
__webpack_require__(991);
__webpack_require__(989);
__webpack_require__(990);
var AppComponent = (function () {
    function AppComponent(authService, router, api, _toastr, vRef) {
        this.authService = authService;
        this.router = router;
        this.api = api;
        this._toastr = _toastr;
        this.url = 'http://www.codebhagat.com/';
        this.setMessage();
        this._toastr.setRootViewContainerRef(vRef);
        // Do something with api
    }
    AppComponent.prototype.setMessage = function () {
        this.message = 'Logged ' + (this.authService.isLoggedIn ? 'in' : 'out');
    };
    AppComponent.prototype.logout = function () {
        this.authService.logout();
        // Redirect the user
        this.router.navigate(['/home']);
    };
    AppComponent = __decorate([
        core_1.Component({
            selector: 'my-app',
            template: __webpack_require__(1133),
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof shared_1.ApiService !== 'undefined' && shared_1.ApiService) === 'function' && _c) || Object, (typeof (_d = typeof ng2_toastr_1.ToastsManager !== 'undefined' && ng2_toastr_1.ToastsManager) === 'function' && _d) || Object, (typeof (_e = typeof core_1.ViewContainerRef !== 'undefined' && core_1.ViewContainerRef) === 'function' && _e) || Object])
    ], AppComponent);
    return AppComponent;
    var _a, _b, _c, _d, _e;
}());
exports.AppComponent = AppComponent;


/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var can_deactivate_guard_service_1 = __webpack_require__(938);
var auth_guard_service_1 = __webpack_require__(227);
var selective_preload_strategy_1 = __webpack_require__(486);
var home_component_1 = __webpack_require__(230);
var about_component_1 = __webpack_require__(228);
var contact_component_1 = __webpack_require__(229);
var routes = [
    { path: '', component: home_component_1.HomeComponent },
    { path: 'home', component: home_component_1.HomeComponent },
    { path: 'about', component: about_component_1.AboutComponent },
    { path: 'contact', component: contact_component_1.ContactComponent },
    {
        path: 'admin',
        loadChildren: 'app/admin/admin.module#AdminModule',
        canLoad: [auth_guard_service_1.AuthGuard]
    },
];
//export const routing = RouterModule.forRoot(routes);
var AppRoutingModule = (function () {
    function AppRoutingModule() {
    }
    AppRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forRoot(routes, { preloadingStrategy: selective_preload_strategy_1.PreloadSelectedModules })
            ],
            exports: [
                router_1.RouterModule
            ],
            providers: [
                can_deactivate_guard_service_1.CanDeactivateGuard,
                selective_preload_strategy_1.PreloadSelectedModules
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], AppRoutingModule);
    return AppRoutingModule;
}());
exports.AppRoutingModule = AppRoutingModule;


/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var CanDeactivateGuard = (function () {
    function CanDeactivateGuard() {
    }
    CanDeactivateGuard.prototype.canDeactivate = function (component) {
        return component.canDeactivate ? component.canDeactivate() : true;
    };
    CanDeactivateGuard = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [])
    ], CanDeactivateGuard);
    return CanDeactivateGuard;
}());
exports.CanDeactivateGuard = CanDeactivateGuard;


/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
/**
 * Async modal dialog service
 * DialogService makes this app easier to test by faking this service.
 * TODO: better modal implementation that doesn't use window.confirm
 */
var DialogService = (function () {
    function DialogService() {
    }
    /**
     * Ask user to confirm an action. `message` explains the action and choices.
     * Returns promise resolving to `true`=confirm or `false`=cancel
     */
    DialogService.prototype.confirm = function (message) {
        return new Promise(function (resolve) {
            return resolve(window.confirm(message || 'Is it OK?'));
        });
    };
    ;
    DialogService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [])
    ], DialogService);
    return DialogService;
}());
exports.DialogService = DialogService;


/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var home_component_1 = __webpack_require__(230);
var about_component_1 = __webpack_require__(228);
var contact_component_1 = __webpack_require__(229);
var inbox_component_1 = __webpack_require__(485);
var graphs_component_1 = __webpack_require__(484);
var calendar_component_1 = __webpack_require__(483);
var Settings_component_1 = __webpack_require__(482);
var homeRoutes = [
    { path: '', pathMatch: 'prefix', component: home_component_1.HomeComponent },
    { path: 'about', component: about_component_1.AboutComponent },
    { path: 'contact', component: contact_component_1.ContactComponent },
    { path: 'inbox', component: inbox_component_1.InboxComponent },
    { path: 'graphs', component: graphs_component_1.GraphsComponent },
    { path: 'calendar', component: calendar_component_1.CalendarComponent },
    { path: 'settings', component: Settings_component_1.SettingsComponent },
];
var HomeRoutingModule = (function () {
    function HomeRoutingModule() {
    }
    HomeRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(homeRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], HomeRoutingModule);
    return HomeRoutingModule;
}());
exports.HomeRoutingModule = HomeRoutingModule;


/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var forms_1 = __webpack_require__(10);
var ng2_charts_1 = __webpack_require__(1015);
var home_routing_module_1 = __webpack_require__(940);
var home_component_1 = __webpack_require__(230);
var about_component_1 = __webpack_require__(228);
var contact_component_1 = __webpack_require__(229);
var inbox_component_1 = __webpack_require__(485);
var graphs_component_1 = __webpack_require__(484);
var calendar_component_1 = __webpack_require__(483);
var Settings_component_1 = __webpack_require__(482);
var HomeModule = (function () {
    function HomeModule() {
    }
    HomeModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                home_routing_module_1.HomeRoutingModule,
                ng2_charts_1.ChartsModule
            ],
            declarations: [
                home_component_1.HomeComponent,
                about_component_1.AboutComponent,
                contact_component_1.ContactComponent,
                inbox_component_1.InboxComponent,
                graphs_component_1.GraphsComponent,
                calendar_component_1.CalendarComponent,
                Settings_component_1.SettingsComponent
            ],
            providers: []
        }), 
        __metadata('design:paramtypes', [])
    ], HomeModule);
    return HomeModule;
}());
exports.HomeModule = HomeModule;


/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var auth_guard_service_1 = __webpack_require__(227);
var auth_service_1 = __webpack_require__(68);
var login_component_1 = __webpack_require__(476);
var register_component_1 = __webpack_require__(477);
var forgotpassword_component_1 = __webpack_require__(475);
var loginRoutes = [
    { path: 'login', component: login_component_1.LoginComponent },
    { path: 'register', component: register_component_1.RegisterComponent },
    { path: 'forgotpassword', component: forgotpassword_component_1.ForgotPasswordComponent }
];
var LoginRoutingModule = (function () {
    function LoginRoutingModule() {
    }
    LoginRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(loginRoutes)
            ],
            exports: [
                router_1.RouterModule
            ],
            providers: [
                auth_guard_service_1.AuthGuard,
                auth_service_1.AuthService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], LoginRoutingModule);
    return LoginRoutingModule;
}());
exports.LoginRoutingModule = LoginRoutingModule;


/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var ApiService = (function () {
    function ApiService() {
        this.title = 'Angular 2';
    }
    ApiService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [])
    ], ApiService);
    return ApiService;
}());
exports.ApiService = ApiService;


/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var Observable_1 = __webpack_require__(1);
var forms_1 = __webpack_require__(10);
var moment = __webpack_require__(4);
var globals_1 = __webpack_require__(7);
moment.locale(globals_1.languare);
var noop = function () { };
var DATE_PICKER_CONTROL_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(function () { return DatePickerDropDownComponent; }),
    multi: true
};
var DATE_PICKER_CONTROL_VALIDATORS = {
    provide: forms_1.NG_VALIDATORS,
    useExisting: core_1.forwardRef(function () { return DatePickerDropDownComponent; }),
    multi: true
};
// Input value: DateTime in JSON format
var DatePickerDropDownComponent = (function () {
    function DatePickerDropDownComponent(_renderer) {
        var _this = this;
        this._renderer = _renderer;
        this._value = null;
        this.showing = false;
        this._model = null;
        this.languare = globals_1.languare;
        this.format = "L";
        this.inputCss = "form-control";
        this.validate = function (c) {
            if (c instanceof forms_1.FormControl) {
                var required_result = { required: { valid: false } };
                if (_this.required && (!_this._value || !_this.model)) {
                    return required_result;
                }
            }
            return null;
        };
        //The internal data model
        this._focused = false;
        /** Callback registered via registerOnTouched (ControlValueAccessor) */
        this._onTouchedCallback = noop;
        /** Callback registered via registerOnChange (ControlValueAccessor) */
        this._onChangeCallback = noop;
        this._blurEmitter = new core_1.EventEmitter();
        this._focusEmitter = new core_1.EventEmitter();
        this._changeEmitter = new core_1.EventEmitter();
        this._hideCalendarTimeoutHandler = null;
    }
    DatePickerDropDownComponent.prototype.validator = function (c) {
        var _this = this;
        var result;
        var control_names = Object.keys(c);
        var controls = control_names.map(function (name) { return c[name]; });
        if (!controls.every(function (control) {
            result = _this.validator(control);
            if (result) {
                return false;
            }
            return true;
        })) {
            return result;
            ;
        }
        return null;
    };
    Object.defineProperty(DatePickerDropDownComponent.prototype, "model", {
        get: function () {
            return this._model;
        },
        set: function (value) {
            this._model = value;
            var new_date = null;
            var is_new_value = false;
            var json_date = null;
            if (value) {
                var mm_new_date = moment(this.model, this.format);
                new_date = mm_new_date.toDate();
                if (new_date.getTime() && (!this._value || new_date.getTime() != this._value.getTime())) {
                    this._value = new_date;
                    json_date = mm_new_date.toISOString();
                    is_new_value = true;
                }
            }
            else {
                if (this._value != null) {
                    this._value = null;
                    is_new_value = true;
                }
            }
            if (is_new_value) {
                this._changeEmitter.emit(json_date);
                this._onChangeCallback(new_date);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePickerDropDownComponent.prototype, "bindValue", {
        get: function () {
            if (this._value) {
                return this._value;
            }
            return null;
        },
        set: function (v) {
            var new_date = null;
            if (typeof v === "string" && v) {
                new_date = moment(v).toDate();
            }
            else if (v instanceof Date) {
                new_date = v;
            }
            if (new_date instanceof Date
                && (!this._value || new_date.getTime() != this._value.getTime())) {
                this._value = new_date;
                var mm_current_date = moment(this._model).toDate();
                if (mm_current_date != new_date) {
                    this.model = moment(new_date).format(this.format);
                }
                var json_date = null;
                if (this._value) {
                    json_date = mm_current_date.toISOString();
                }
                this._changeEmitter.emit(json_date);
                this._onChangeCallback(this._value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePickerDropDownComponent.prototype, "focused", {
        /** Readonly properties. */
        get: function () { return this._focused; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePickerDropDownComponent.prototype, "onBlur", {
        get: function () {
            return this._blurEmitter.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePickerDropDownComponent.prototype, "onFocus", {
        get: function () {
            return this._focusEmitter.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePickerDropDownComponent.prototype, "onChange", {
        get: function () {
            return this._changeEmitter.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    /** Set focus on input */
    DatePickerDropDownComponent.prototype.focus = function () {
        this._renderer.invokeElementMethod(this._inputElement.nativeElement, 'focus');
        this.showing = true;
    };
    /**
    * Implemented as part of ControlValueAccessor.
    * TODO: internal
    */
    DatePickerDropDownComponent.prototype.registerOnChange = function (fn) {
        this._onChangeCallback = fn;
    };
    /**
     * Implemented as part of ControlValueAccessor.
     * TODO: internal
     */
    DatePickerDropDownComponent.prototype.registerOnTouched = function (fn) {
        this._onTouchedCallback = fn;
    };
    DatePickerDropDownComponent.prototype._delayHideCalendar = function () {
        this.showing = false;
        this._onTouchedCallback();
    };
    DatePickerDropDownComponent.prototype._calendarClick = function () {
        if (this._hideCalendarTimeoutHandler) {
            clearTimeout(this._hideCalendarTimeoutHandler);
            this._hideCalendarTimeoutHandler = null;
        }
    };
    DatePickerDropDownComponent.prototype._handleFocus = function (event) {
        this._focused = true;
        this._focusEmitter.emit(event);
    };
    DatePickerDropDownComponent.prototype._handleBlur = function (event) {
        this._focused = false;
        this._blurEmitter.emit(event);
        this._hideCalendarTimeoutHandler = setTimeout(this._delayHideCalendar.bind(this), 200);
    };
    DatePickerDropDownComponent.prototype._handleChange = function (newValue) {
        if (!this._value || this._value.getTime() != newValue.getTime()) {
            this._value = newValue;
            var mm_current_date = moment(newValue);
            this.model = mm_current_date.format(this.format);
            var json_date = null;
            if (this._value) {
                json_date = mm_current_date.toISOString();
            }
            this._changeEmitter.emit(json_date);
            this._onChangeCallback(this._value);
            this._onTouchedCallback();
            this.showing = false;
        }
    };
    /**
   * Implemented as part of ControlValueAccessor.
   * System bind data from model [ngModel]
   */
    DatePickerDropDownComponent.prototype.writeValue = function (inputValue) {
        var new_value = null;
        if (typeof inputValue === "string" && inputValue) {
            new_value = moment(inputValue).toDate();
        }
        else if (inputValue instanceof Date) {
            new_value = inputValue;
        }
        if (new_value != this._value) {
            this.model = moment(new_value).format(this.format);
            this._value = new_value;
        }
    };
    /** TODO: internal */
    DatePickerDropDownComponent.prototype.ngAfterContentInit = function () {
        // this._validateConstraints();
    };
    /** TODO: internal */
    DatePickerDropDownComponent.prototype.ngOnChanges = function (changes) {
        // this._validateConstraints();
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Boolean)
    ], DatePickerDropDownComponent.prototype, "required", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', (typeof (_a = typeof forms_1.NgControl !== 'undefined' && forms_1.NgControl) === 'function' && _a) || Object)
    ], DatePickerDropDownComponent.prototype, "control", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], DatePickerDropDownComponent.prototype, "format", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], DatePickerDropDownComponent.prototype, "inputCss", void 0);
    __decorate([
        core_1.ViewChild('input'), 
        __metadata('design:type', (typeof (_b = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _b) || Object)
    ], DatePickerDropDownComponent.prototype, "_inputElement", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], DatePickerDropDownComponent.prototype, "bindValue", null);
    __decorate([
        core_1.Output('blur'), 
        __metadata('design:type', (typeof (_c = typeof Observable_1.Observable !== 'undefined' && Observable_1.Observable) === 'function' && _c) || Object)
    ], DatePickerDropDownComponent.prototype, "onBlur", null);
    __decorate([
        core_1.Output('focus'), 
        __metadata('design:type', (typeof (_d = typeof Observable_1.Observable !== 'undefined' && Observable_1.Observable) === 'function' && _d) || Object)
    ], DatePickerDropDownComponent.prototype, "onFocus", null);
    __decorate([
        core_1.Output("change"), 
        __metadata('design:type', (typeof (_e = typeof Observable_1.Observable !== 'undefined' && Observable_1.Observable) === 'function' && _e) || Object)
    ], DatePickerDropDownComponent.prototype, "onChange", null);
    DatePickerDropDownComponent = __decorate([
        core_1.Component({
            selector: 'datepicker-dropdown',
            template: "\n    <div class=\"container-fluid\" >\n        <div class=\"row\">\n            <input #input type=\"text\" [attr.class]=\"inputCss\" [(ngModel)]=\"model\" (blur)=\"_handleBlur($event)\" (forcus)=\"_handleFocus($event)\" />\n        </div>\n        <div class=\"row\" style=\"display:inline-block;\" *ngIf=\"showing\" (click)=\"_calendarClick()\" >\n            <datepicker [(ngModel)]=\"bindValue\" (selectionDone)=\"_handleChange($event)\" ></datepicker>\n        </div>\n    </div>\n    ",
            providers: [DATE_PICKER_CONTROL_VALUE_ACCESSOR, DATE_PICKER_CONTROL_VALIDATORS],
            styles: [],
            host: { '(click)': 'focus()' }
        }), 
        __metadata('design:paramtypes', [(typeof (_f = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _f) || Object])
    ], DatePickerDropDownComponent);
    return DatePickerDropDownComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.DatePickerDropDownComponent = DatePickerDropDownComponent;


/***/ },
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 990 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 991 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 992 */,
/* 993 */,
/* 994 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var accordion_group_component_1 = __webpack_require__(596);
exports.AccordionPanelComponent = accordion_group_component_1.AccordionPanelComponent;
var accordion_component_1 = __webpack_require__(231);
exports.AccordionComponent = accordion_component_1.AccordionComponent;
var accordion_module_1 = __webpack_require__(232);
exports.AccordionModule = accordion_module_1.AccordionModule;


/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var alert_component_1 = __webpack_require__(597);
exports.AlertComponent = alert_component_1.AlertComponent;
var alert_module_1 = __webpack_require__(233);
exports.AlertModule = alert_module_1.AlertModule;


/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var button_checkbox_directive_1 = __webpack_require__(598);
exports.ButtonCheckboxDirective = button_checkbox_directive_1.ButtonCheckboxDirective;
var button_radio_directive_1 = __webpack_require__(599);
exports.ButtonRadioDirective = button_radio_directive_1.ButtonRadioDirective;
var buttons_module_1 = __webpack_require__(234);
exports.ButtonsModule = buttons_module_1.ButtonsModule;


/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var carousel_component_1 = __webpack_require__(235);
exports.CarouselComponent = carousel_component_1.CarouselComponent;
var carousel_module_1 = __webpack_require__(236);
exports.CarouselModule = carousel_module_1.CarouselModule;
var slide_component_1 = __webpack_require__(600);
exports.SlideComponent = slide_component_1.SlideComponent;


/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var collapse_directive_1 = __webpack_require__(601);
exports.CollapseDirective = collapse_directive_1.CollapseDirective;
var collapse_module_1 = __webpack_require__(156);
exports.CollapseModule = collapse_module_1.CollapseModule;


/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
/*
 todo: general:
 1. Popup
 2. Keyboard support
 3. custom-class attribute support
 4. date-disabled attribute support
 5. template-url attribute support
 */
var datepicker_component_1 = __webpack_require__(604);
exports.DatePickerComponent = datepicker_component_1.DatePickerComponent;
var datepicker_module_1 = __webpack_require__(237);
exports.DatepickerModule = datepicker_module_1.DatepickerModule;
var daypicker_component_1 = __webpack_require__(605);
exports.DayPickerComponent = daypicker_component_1.DayPickerComponent;
var monthpicker_component_1 = __webpack_require__(606);
exports.MonthPickerComponent = monthpicker_component_1.MonthPickerComponent;
var yearpicker_component_1 = __webpack_require__(607);
exports.YearPickerComponent = yearpicker_component_1.YearPickerComponent;
var date_formatter_1 = __webpack_require__(603);
exports.DateFormatter = date_formatter_1.DateFormatter;


/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var dropdown_menu_directive_1 = __webpack_require__(608);
exports.DropdownMenuDirective = dropdown_menu_directive_1.DropdownMenuDirective;
var dropdown_toggle_directive_1 = __webpack_require__(609);
exports.DropdownToggleDirective = dropdown_toggle_directive_1.DropdownToggleDirective;
var dropdown_directive_1 = __webpack_require__(157);
exports.DropdownDirective = dropdown_directive_1.DropdownDirective;
var dropdown_service_1 = __webpack_require__(610);
exports.DropdownService = dropdown_service_1.DropdownService;
var dropdown_module_1 = __webpack_require__(238);
exports.DropdownModule = dropdown_module_1.DropdownModule;


/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var accordion_module_1 = __webpack_require__(232);
var alert_module_1 = __webpack_require__(233);
var buttons_module_1 = __webpack_require__(234);
var carousel_module_1 = __webpack_require__(236);
var collapse_module_1 = __webpack_require__(156);
var datepicker_module_1 = __webpack_require__(237);
var dropdown_module_1 = __webpack_require__(238);
var modal_module_1 = __webpack_require__(241);
var pagination_module_1 = __webpack_require__(243);
var progressbar_module_1 = __webpack_require__(246);
var rating_module_1 = __webpack_require__(247);
var tabs_module_1 = __webpack_require__(249);
var timepicker_module_1 = __webpack_require__(251);
var tooltip_module_1 = __webpack_require__(253);
var typeahead_module_1 = __webpack_require__(257);
var components_helper_service_1 = __webpack_require__(53);
var Ng2BootstrapModule = (function () {
    function Ng2BootstrapModule() {
    }
    Ng2BootstrapModule.decorators = [
        { type: core_1.NgModule, args: [{
                    exports: [
                        accordion_module_1.AccordionModule, alert_module_1.AlertModule, buttons_module_1.ButtonsModule, carousel_module_1.CarouselModule, collapse_module_1.CollapseModule, datepicker_module_1.DatepickerModule, dropdown_module_1.DropdownModule,
                        modal_module_1.ModalModule, pagination_module_1.PaginationModule, progressbar_module_1.ProgressbarModule, rating_module_1.RatingModule, tabs_module_1.TabsModule, timepicker_module_1.TimepickerModule, tooltip_module_1.TooltipModule,
                        typeahead_module_1.TypeaheadModule
                    ],
                    providers: [
                        { provide: components_helper_service_1.ComponentsHelper, useClass: components_helper_service_1.ComponentsHelper }
                    ]
                },] },
    ];
    /** @nocollapse */
    Ng2BootstrapModule.ctorParameters = [];
    return Ng2BootstrapModule;
}());
exports.Ng2BootstrapModule = Ng2BootstrapModule;


/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(239));
__export(__webpack_require__(240));
__export(__webpack_require__(611));
var modal_module_1 = __webpack_require__(241);
exports.ModalModule = modal_module_1.ModalModule;


/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var pager_component_1 = __webpack_require__(612);
exports.PagerComponent = pager_component_1.PagerComponent;
var pagination_component_1 = __webpack_require__(242);
exports.PaginationComponent = pagination_component_1.PaginationComponent;
var pagination_module_1 = __webpack_require__(243);
exports.PaginationModule = pagination_module_1.PaginationModule;


/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var bar_component_1 = __webpack_require__(613);
exports.BarComponent = bar_component_1.BarComponent;
var progress_directive_1 = __webpack_require__(245);
exports.ProgressDirective = progress_directive_1.ProgressDirective;
var progressbar_component_1 = __webpack_require__(614);
exports.ProgressbarComponent = progressbar_component_1.ProgressbarComponent;
var progressbar_module_1 = __webpack_require__(246);
exports.ProgressbarModule = progressbar_module_1.ProgressbarModule;


/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var rating_component_1 = __webpack_require__(615);
exports.RatingComponent = rating_component_1.RatingComponent;
var rating_module_1 = __webpack_require__(247);
exports.RatingModule = rating_module_1.RatingModule;


/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var tab_heading_directive_1 = __webpack_require__(616);
exports.TabHeadingDirective = tab_heading_directive_1.TabHeadingDirective;
var tabset_component_1 = __webpack_require__(250);
exports.TabsetComponent = tabset_component_1.TabsetComponent;
var tab_directive_1 = __webpack_require__(248);
exports.TabDirective = tab_directive_1.TabDirective;
var tabs_module_1 = __webpack_require__(249);
exports.TabsModule = tabs_module_1.TabsModule;


/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var timepicker_component_1 = __webpack_require__(617);
exports.TimepickerComponent = timepicker_component_1.TimepickerComponent;
var timepicker_module_1 = __webpack_require__(251);
exports.TimepickerModule = timepicker_module_1.TimepickerModule;


/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var tooltip_container_component_1 = __webpack_require__(252);
exports.TooltipContainerComponent = tooltip_container_component_1.TooltipContainerComponent;
var tooltip_directive_1 = __webpack_require__(619);
exports.TooltipDirective = tooltip_directive_1.TooltipDirective;
var tooltip_module_1 = __webpack_require__(253);
exports.TooltipModule = tooltip_module_1.TooltipModule;


/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var typeahead_match_class_1 = __webpack_require__(620);
exports.TypeaheadMatch = typeahead_match_class_1.TypeaheadMatch;
var typeahead_options_class_1 = __webpack_require__(255);
exports.TypeaheadOptions = typeahead_options_class_1.TypeaheadOptions;
var typeahead_utils_1 = __webpack_require__(256);
exports.TypeaheadUtils = typeahead_utils_1.TypeaheadUtils;
var typeahead_container_component_1 = __webpack_require__(254);
exports.TypeaheadContainerComponent = typeahead_container_component_1.TypeaheadContainerComponent;
var typeahead_directive_1 = __webpack_require__(621);
exports.TypeaheadDirective = typeahead_directive_1.TypeaheadDirective;
var typeahead_module_1 = __webpack_require__(257);
exports.TypeaheadModule = typeahead_module_1.TypeaheadModule;


/***/ },
/* 1010 */
/***/ function(module, exports) {

"use strict";
"use strict";
exports.latinMap = {
    'Á': 'A',
    'Ă': 'A',
    'Ắ': 'A',
    'Ặ': 'A',
    'Ằ': 'A',
    'Ẳ': 'A',
    'Ẵ': 'A',
    'Ǎ': 'A',
    'Â': 'A',
    'Ấ': 'A',
    'Ậ': 'A',
    'Ầ': 'A',
    'Ẩ': 'A',
    'Ẫ': 'A',
    'Ä': 'A',
    'Ǟ': 'A',
    'Ȧ': 'A',
    'Ǡ': 'A',
    'Ạ': 'A',
    'Ȁ': 'A',
    'À': 'A',
    'Ả': 'A',
    'Ȃ': 'A',
    'Ā': 'A',
    'Ą': 'A',
    'Å': 'A',
    'Ǻ': 'A',
    'Ḁ': 'A',
    'Ⱥ': 'A',
    'Ã': 'A',
    'Ꜳ': 'AA',
    'Æ': 'AE',
    'Ǽ': 'AE',
    'Ǣ': 'AE',
    'Ꜵ': 'AO',
    'Ꜷ': 'AU',
    'Ꜹ': 'AV',
    'Ꜻ': 'AV',
    'Ꜽ': 'AY',
    'Ḃ': 'B',
    'Ḅ': 'B',
    'Ɓ': 'B',
    'Ḇ': 'B',
    'Ƀ': 'B',
    'Ƃ': 'B',
    'Ć': 'C',
    'Č': 'C',
    'Ç': 'C',
    'Ḉ': 'C',
    'Ĉ': 'C',
    'Ċ': 'C',
    'Ƈ': 'C',
    'Ȼ': 'C',
    'Ď': 'D',
    'Ḑ': 'D',
    'Ḓ': 'D',
    'Ḋ': 'D',
    'Ḍ': 'D',
    'Ɗ': 'D',
    'Ḏ': 'D',
    'ǲ': 'D',
    'ǅ': 'D',
    'Đ': 'D',
    'Ƌ': 'D',
    'Ǳ': 'DZ',
    'Ǆ': 'DZ',
    'É': 'E',
    'Ĕ': 'E',
    'Ě': 'E',
    'Ȩ': 'E',
    'Ḝ': 'E',
    'Ê': 'E',
    'Ế': 'E',
    'Ệ': 'E',
    'Ề': 'E',
    'Ể': 'E',
    'Ễ': 'E',
    'Ḙ': 'E',
    'Ë': 'E',
    'Ė': 'E',
    'Ẹ': 'E',
    'Ȅ': 'E',
    'È': 'E',
    'Ẻ': 'E',
    'Ȇ': 'E',
    'Ē': 'E',
    'Ḗ': 'E',
    'Ḕ': 'E',
    'Ę': 'E',
    'Ɇ': 'E',
    'Ẽ': 'E',
    'Ḛ': 'E',
    'Ꝫ': 'ET',
    'Ḟ': 'F',
    'Ƒ': 'F',
    'Ǵ': 'G',
    'Ğ': 'G',
    'Ǧ': 'G',
    'Ģ': 'G',
    'Ĝ': 'G',
    'Ġ': 'G',
    'Ɠ': 'G',
    'Ḡ': 'G',
    'Ǥ': 'G',
    'Ḫ': 'H',
    'Ȟ': 'H',
    'Ḩ': 'H',
    'Ĥ': 'H',
    'Ⱨ': 'H',
    'Ḧ': 'H',
    'Ḣ': 'H',
    'Ḥ': 'H',
    'Ħ': 'H',
    'Í': 'I',
    'Ĭ': 'I',
    'Ǐ': 'I',
    'Î': 'I',
    'Ï': 'I',
    'Ḯ': 'I',
    'İ': 'I',
    'Ị': 'I',
    'Ȉ': 'I',
    'Ì': 'I',
    'Ỉ': 'I',
    'Ȋ': 'I',
    'Ī': 'I',
    'Į': 'I',
    'Ɨ': 'I',
    'Ĩ': 'I',
    'Ḭ': 'I',
    'Ꝺ': 'D',
    'Ꝼ': 'F',
    'Ᵹ': 'G',
    'Ꞃ': 'R',
    'Ꞅ': 'S',
    'Ꞇ': 'T',
    'Ꝭ': 'IS',
    'Ĵ': 'J',
    'Ɉ': 'J',
    'Ḱ': 'K',
    'Ǩ': 'K',
    'Ķ': 'K',
    'Ⱪ': 'K',
    'Ꝃ': 'K',
    'Ḳ': 'K',
    'Ƙ': 'K',
    'Ḵ': 'K',
    'Ꝁ': 'K',
    'Ꝅ': 'K',
    'Ĺ': 'L',
    'Ƚ': 'L',
    'Ľ': 'L',
    'Ļ': 'L',
    'Ḽ': 'L',
    'Ḷ': 'L',
    'Ḹ': 'L',
    'Ⱡ': 'L',
    'Ꝉ': 'L',
    'Ḻ': 'L',
    'Ŀ': 'L',
    'Ɫ': 'L',
    'ǈ': 'L',
    'Ł': 'L',
    'Ǉ': 'LJ',
    'Ḿ': 'M',
    'Ṁ': 'M',
    'Ṃ': 'M',
    'Ɱ': 'M',
    'Ń': 'N',
    'Ň': 'N',
    'Ņ': 'N',
    'Ṋ': 'N',
    'Ṅ': 'N',
    'Ṇ': 'N',
    'Ǹ': 'N',
    'Ɲ': 'N',
    'Ṉ': 'N',
    'Ƞ': 'N',
    'ǋ': 'N',
    'Ñ': 'N',
    'Ǌ': 'NJ',
    'Ó': 'O',
    'Ŏ': 'O',
    'Ǒ': 'O',
    'Ô': 'O',
    'Ố': 'O',
    'Ộ': 'O',
    'Ồ': 'O',
    'Ổ': 'O',
    'Ỗ': 'O',
    'Ö': 'O',
    'Ȫ': 'O',
    'Ȯ': 'O',
    'Ȱ': 'O',
    'Ọ': 'O',
    'Ő': 'O',
    'Ȍ': 'O',
    'Ò': 'O',
    'Ỏ': 'O',
    'Ơ': 'O',
    'Ớ': 'O',
    'Ợ': 'O',
    'Ờ': 'O',
    'Ở': 'O',
    'Ỡ': 'O',
    'Ȏ': 'O',
    'Ꝋ': 'O',
    'Ꝍ': 'O',
    'Ō': 'O',
    'Ṓ': 'O',
    'Ṑ': 'O',
    'Ɵ': 'O',
    'Ǫ': 'O',
    'Ǭ': 'O',
    'Ø': 'O',
    'Ǿ': 'O',
    'Õ': 'O',
    'Ṍ': 'O',
    'Ṏ': 'O',
    'Ȭ': 'O',
    'Ƣ': 'OI',
    'Ꝏ': 'OO',
    'Ɛ': 'E',
    'Ɔ': 'O',
    'Ȣ': 'OU',
    'Ṕ': 'P',
    'Ṗ': 'P',
    'Ꝓ': 'P',
    'Ƥ': 'P',
    'Ꝕ': 'P',
    'Ᵽ': 'P',
    'Ꝑ': 'P',
    'Ꝙ': 'Q',
    'Ꝗ': 'Q',
    'Ŕ': 'R',
    'Ř': 'R',
    'Ŗ': 'R',
    'Ṙ': 'R',
    'Ṛ': 'R',
    'Ṝ': 'R',
    'Ȑ': 'R',
    'Ȓ': 'R',
    'Ṟ': 'R',
    'Ɍ': 'R',
    'Ɽ': 'R',
    'Ꜿ': 'C',
    'Ǝ': 'E',
    'Ś': 'S',
    'Ṥ': 'S',
    'Š': 'S',
    'Ṧ': 'S',
    'Ş': 'S',
    'Ŝ': 'S',
    'Ș': 'S',
    'Ṡ': 'S',
    'Ṣ': 'S',
    'Ṩ': 'S',
    'Ť': 'T',
    'Ţ': 'T',
    'Ṱ': 'T',
    'Ț': 'T',
    'Ⱦ': 'T',
    'Ṫ': 'T',
    'Ṭ': 'T',
    'Ƭ': 'T',
    'Ṯ': 'T',
    'Ʈ': 'T',
    'Ŧ': 'T',
    'Ɐ': 'A',
    'Ꞁ': 'L',
    'Ɯ': 'M',
    'Ʌ': 'V',
    'Ꜩ': 'TZ',
    'Ú': 'U',
    'Ŭ': 'U',
    'Ǔ': 'U',
    'Û': 'U',
    'Ṷ': 'U',
    'Ü': 'U',
    'Ǘ': 'U',
    'Ǚ': 'U',
    'Ǜ': 'U',
    'Ǖ': 'U',
    'Ṳ': 'U',
    'Ụ': 'U',
    'Ű': 'U',
    'Ȕ': 'U',
    'Ù': 'U',
    'Ủ': 'U',
    'Ư': 'U',
    'Ứ': 'U',
    'Ự': 'U',
    'Ừ': 'U',
    'Ử': 'U',
    'Ữ': 'U',
    'Ȗ': 'U',
    'Ū': 'U',
    'Ṻ': 'U',
    'Ų': 'U',
    'Ů': 'U',
    'Ũ': 'U',
    'Ṹ': 'U',
    'Ṵ': 'U',
    'Ꝟ': 'V',
    'Ṿ': 'V',
    'Ʋ': 'V',
    'Ṽ': 'V',
    'Ꝡ': 'VY',
    'Ẃ': 'W',
    'Ŵ': 'W',
    'Ẅ': 'W',
    'Ẇ': 'W',
    'Ẉ': 'W',
    'Ẁ': 'W',
    'Ⱳ': 'W',
    'Ẍ': 'X',
    'Ẋ': 'X',
    'Ý': 'Y',
    'Ŷ': 'Y',
    'Ÿ': 'Y',
    'Ẏ': 'Y',
    'Ỵ': 'Y',
    'Ỳ': 'Y',
    'Ƴ': 'Y',
    'Ỷ': 'Y',
    'Ỿ': 'Y',
    'Ȳ': 'Y',
    'Ɏ': 'Y',
    'Ỹ': 'Y',
    'Ź': 'Z',
    'Ž': 'Z',
    'Ẑ': 'Z',
    'Ⱬ': 'Z',
    'Ż': 'Z',
    'Ẓ': 'Z',
    'Ȥ': 'Z',
    'Ẕ': 'Z',
    'Ƶ': 'Z',
    'Ĳ': 'IJ',
    'Œ': 'OE',
    'ᴀ': 'A',
    'ᴁ': 'AE',
    'ʙ': 'B',
    'ᴃ': 'B',
    'ᴄ': 'C',
    'ᴅ': 'D',
    'ᴇ': 'E',
    'ꜰ': 'F',
    'ɢ': 'G',
    'ʛ': 'G',
    'ʜ': 'H',
    'ɪ': 'I',
    'ʁ': 'R',
    'ᴊ': 'J',
    'ᴋ': 'K',
    'ʟ': 'L',
    'ᴌ': 'L',
    'ᴍ': 'M',
    'ɴ': 'N',
    'ᴏ': 'O',
    'ɶ': 'OE',
    'ᴐ': 'O',
    'ᴕ': 'OU',
    'ᴘ': 'P',
    'ʀ': 'R',
    'ᴎ': 'N',
    'ᴙ': 'R',
    'ꜱ': 'S',
    'ᴛ': 'T',
    'ⱻ': 'E',
    'ᴚ': 'R',
    'ᴜ': 'U',
    'ᴠ': 'V',
    'ᴡ': 'W',
    'ʏ': 'Y',
    'ᴢ': 'Z',
    'á': 'a',
    'ă': 'a',
    'ắ': 'a',
    'ặ': 'a',
    'ằ': 'a',
    'ẳ': 'a',
    'ẵ': 'a',
    'ǎ': 'a',
    'â': 'a',
    'ấ': 'a',
    'ậ': 'a',
    'ầ': 'a',
    'ẩ': 'a',
    'ẫ': 'a',
    'ä': 'a',
    'ǟ': 'a',
    'ȧ': 'a',
    'ǡ': 'a',
    'ạ': 'a',
    'ȁ': 'a',
    'à': 'a',
    'ả': 'a',
    'ȃ': 'a',
    'ā': 'a',
    'ą': 'a',
    'ᶏ': 'a',
    'ẚ': 'a',
    'å': 'a',
    'ǻ': 'a',
    'ḁ': 'a',
    'ⱥ': 'a',
    'ã': 'a',
    'ꜳ': 'aa',
    'æ': 'ae',
    'ǽ': 'ae',
    'ǣ': 'ae',
    'ꜵ': 'ao',
    'ꜷ': 'au',
    'ꜹ': 'av',
    'ꜻ': 'av',
    'ꜽ': 'ay',
    'ḃ': 'b',
    'ḅ': 'b',
    'ɓ': 'b',
    'ḇ': 'b',
    'ᵬ': 'b',
    'ᶀ': 'b',
    'ƀ': 'b',
    'ƃ': 'b',
    'ɵ': 'o',
    'ć': 'c',
    'č': 'c',
    'ç': 'c',
    'ḉ': 'c',
    'ĉ': 'c',
    'ɕ': 'c',
    'ċ': 'c',
    'ƈ': 'c',
    'ȼ': 'c',
    'ď': 'd',
    'ḑ': 'd',
    'ḓ': 'd',
    'ȡ': 'd',
    'ḋ': 'd',
    'ḍ': 'd',
    'ɗ': 'd',
    'ᶑ': 'd',
    'ḏ': 'd',
    'ᵭ': 'd',
    'ᶁ': 'd',
    'đ': 'd',
    'ɖ': 'd',
    'ƌ': 'd',
    'ı': 'i',
    'ȷ': 'j',
    'ɟ': 'j',
    'ʄ': 'j',
    'ǳ': 'dz',
    'ǆ': 'dz',
    'é': 'e',
    'ĕ': 'e',
    'ě': 'e',
    'ȩ': 'e',
    'ḝ': 'e',
    'ê': 'e',
    'ế': 'e',
    'ệ': 'e',
    'ề': 'e',
    'ể': 'e',
    'ễ': 'e',
    'ḙ': 'e',
    'ë': 'e',
    'ė': 'e',
    'ẹ': 'e',
    'ȅ': 'e',
    'è': 'e',
    'ẻ': 'e',
    'ȇ': 'e',
    'ē': 'e',
    'ḗ': 'e',
    'ḕ': 'e',
    'ⱸ': 'e',
    'ę': 'e',
    'ᶒ': 'e',
    'ɇ': 'e',
    'ẽ': 'e',
    'ḛ': 'e',
    'ꝫ': 'et',
    'ḟ': 'f',
    'ƒ': 'f',
    'ᵮ': 'f',
    'ᶂ': 'f',
    'ǵ': 'g',
    'ğ': 'g',
    'ǧ': 'g',
    'ģ': 'g',
    'ĝ': 'g',
    'ġ': 'g',
    'ɠ': 'g',
    'ḡ': 'g',
    'ᶃ': 'g',
    'ǥ': 'g',
    'ḫ': 'h',
    'ȟ': 'h',
    'ḩ': 'h',
    'ĥ': 'h',
    'ⱨ': 'h',
    'ḧ': 'h',
    'ḣ': 'h',
    'ḥ': 'h',
    'ɦ': 'h',
    'ẖ': 'h',
    'ħ': 'h',
    'ƕ': 'hv',
    'í': 'i',
    'ĭ': 'i',
    'ǐ': 'i',
    'î': 'i',
    'ï': 'i',
    'ḯ': 'i',
    'ị': 'i',
    'ȉ': 'i',
    'ì': 'i',
    'ỉ': 'i',
    'ȋ': 'i',
    'ī': 'i',
    'į': 'i',
    'ᶖ': 'i',
    'ɨ': 'i',
    'ĩ': 'i',
    'ḭ': 'i',
    'ꝺ': 'd',
    'ꝼ': 'f',
    'ᵹ': 'g',
    'ꞃ': 'r',
    'ꞅ': 's',
    'ꞇ': 't',
    'ꝭ': 'is',
    'ǰ': 'j',
    'ĵ': 'j',
    'ʝ': 'j',
    'ɉ': 'j',
    'ḱ': 'k',
    'ǩ': 'k',
    'ķ': 'k',
    'ⱪ': 'k',
    'ꝃ': 'k',
    'ḳ': 'k',
    'ƙ': 'k',
    'ḵ': 'k',
    'ᶄ': 'k',
    'ꝁ': 'k',
    'ꝅ': 'k',
    'ĺ': 'l',
    'ƚ': 'l',
    'ɬ': 'l',
    'ľ': 'l',
    'ļ': 'l',
    'ḽ': 'l',
    'ȴ': 'l',
    'ḷ': 'l',
    'ḹ': 'l',
    'ⱡ': 'l',
    'ꝉ': 'l',
    'ḻ': 'l',
    'ŀ': 'l',
    'ɫ': 'l',
    'ᶅ': 'l',
    'ɭ': 'l',
    'ł': 'l',
    'ǉ': 'lj',
    'ſ': 's',
    'ẜ': 's',
    'ẛ': 's',
    'ẝ': 's',
    'ḿ': 'm',
    'ṁ': 'm',
    'ṃ': 'm',
    'ɱ': 'm',
    'ᵯ': 'm',
    'ᶆ': 'm',
    'ń': 'n',
    'ň': 'n',
    'ņ': 'n',
    'ṋ': 'n',
    'ȵ': 'n',
    'ṅ': 'n',
    'ṇ': 'n',
    'ǹ': 'n',
    'ɲ': 'n',
    'ṉ': 'n',
    'ƞ': 'n',
    'ᵰ': 'n',
    'ᶇ': 'n',
    'ɳ': 'n',
    'ñ': 'n',
    'ǌ': 'nj',
    'ó': 'o',
    'ŏ': 'o',
    'ǒ': 'o',
    'ô': 'o',
    'ố': 'o',
    'ộ': 'o',
    'ồ': 'o',
    'ổ': 'o',
    'ỗ': 'o',
    'ö': 'o',
    'ȫ': 'o',
    'ȯ': 'o',
    'ȱ': 'o',
    'ọ': 'o',
    'ő': 'o',
    'ȍ': 'o',
    'ò': 'o',
    'ỏ': 'o',
    'ơ': 'o',
    'ớ': 'o',
    'ợ': 'o',
    'ờ': 'o',
    'ở': 'o',
    'ỡ': 'o',
    'ȏ': 'o',
    'ꝋ': 'o',
    'ꝍ': 'o',
    'ⱺ': 'o',
    'ō': 'o',
    'ṓ': 'o',
    'ṑ': 'o',
    'ǫ': 'o',
    'ǭ': 'o',
    'ø': 'o',
    'ǿ': 'o',
    'õ': 'o',
    'ṍ': 'o',
    'ṏ': 'o',
    'ȭ': 'o',
    'ƣ': 'oi',
    'ꝏ': 'oo',
    'ɛ': 'e',
    'ᶓ': 'e',
    'ɔ': 'o',
    'ᶗ': 'o',
    'ȣ': 'ou',
    'ṕ': 'p',
    'ṗ': 'p',
    'ꝓ': 'p',
    'ƥ': 'p',
    'ᵱ': 'p',
    'ᶈ': 'p',
    'ꝕ': 'p',
    'ᵽ': 'p',
    'ꝑ': 'p',
    'ꝙ': 'q',
    'ʠ': 'q',
    'ɋ': 'q',
    'ꝗ': 'q',
    'ŕ': 'r',
    'ř': 'r',
    'ŗ': 'r',
    'ṙ': 'r',
    'ṛ': 'r',
    'ṝ': 'r',
    'ȑ': 'r',
    'ɾ': 'r',
    'ᵳ': 'r',
    'ȓ': 'r',
    'ṟ': 'r',
    'ɼ': 'r',
    'ᵲ': 'r',
    'ᶉ': 'r',
    'ɍ': 'r',
    'ɽ': 'r',
    'ↄ': 'c',
    'ꜿ': 'c',
    'ɘ': 'e',
    'ɿ': 'r',
    'ś': 's',
    'ṥ': 's',
    'š': 's',
    'ṧ': 's',
    'ş': 's',
    'ŝ': 's',
    'ș': 's',
    'ṡ': 's',
    'ṣ': 's',
    'ṩ': 's',
    'ʂ': 's',
    'ᵴ': 's',
    'ᶊ': 's',
    'ȿ': 's',
    'ɡ': 'g',
    'ᴑ': 'o',
    'ᴓ': 'o',
    'ᴝ': 'u',
    'ť': 't',
    'ţ': 't',
    'ṱ': 't',
    'ț': 't',
    'ȶ': 't',
    'ẗ': 't',
    'ⱦ': 't',
    'ṫ': 't',
    'ṭ': 't',
    'ƭ': 't',
    'ṯ': 't',
    'ᵵ': 't',
    'ƫ': 't',
    'ʈ': 't',
    'ŧ': 't',
    'ᵺ': 'th',
    'ɐ': 'a',
    'ᴂ': 'ae',
    'ǝ': 'e',
    'ᵷ': 'g',
    'ɥ': 'h',
    'ʮ': 'h',
    'ʯ': 'h',
    'ᴉ': 'i',
    'ʞ': 'k',
    'ꞁ': 'l',
    'ɯ': 'm',
    'ɰ': 'm',
    'ᴔ': 'oe',
    'ɹ': 'r',
    'ɻ': 'r',
    'ɺ': 'r',
    'ⱹ': 'r',
    'ʇ': 't',
    'ʌ': 'v',
    'ʍ': 'w',
    'ʎ': 'y',
    'ꜩ': 'tz',
    'ú': 'u',
    'ŭ': 'u',
    'ǔ': 'u',
    'û': 'u',
    'ṷ': 'u',
    'ü': 'u',
    'ǘ': 'u',
    'ǚ': 'u',
    'ǜ': 'u',
    'ǖ': 'u',
    'ṳ': 'u',
    'ụ': 'u',
    'ű': 'u',
    'ȕ': 'u',
    'ù': 'u',
    'ủ': 'u',
    'ư': 'u',
    'ứ': 'u',
    'ự': 'u',
    'ừ': 'u',
    'ử': 'u',
    'ữ': 'u',
    'ȗ': 'u',
    'ū': 'u',
    'ṻ': 'u',
    'ų': 'u',
    'ᶙ': 'u',
    'ů': 'u',
    'ũ': 'u',
    'ṹ': 'u',
    'ṵ': 'u',
    'ᵫ': 'ue',
    'ꝸ': 'um',
    'ⱴ': 'v',
    'ꝟ': 'v',
    'ṿ': 'v',
    'ʋ': 'v',
    'ᶌ': 'v',
    'ⱱ': 'v',
    'ṽ': 'v',
    'ꝡ': 'vy',
    'ẃ': 'w',
    'ŵ': 'w',
    'ẅ': 'w',
    'ẇ': 'w',
    'ẉ': 'w',
    'ẁ': 'w',
    'ⱳ': 'w',
    'ẘ': 'w',
    'ẍ': 'x',
    'ẋ': 'x',
    'ᶍ': 'x',
    'ý': 'y',
    'ŷ': 'y',
    'ÿ': 'y',
    'ẏ': 'y',
    'ỵ': 'y',
    'ỳ': 'y',
    'ƴ': 'y',
    'ỷ': 'y',
    'ỿ': 'y',
    'ȳ': 'y',
    'ẙ': 'y',
    'ɏ': 'y',
    'ỹ': 'y',
    'ź': 'z',
    'ž': 'z',
    'ẑ': 'z',
    'ʑ': 'z',
    'ⱬ': 'z',
    'ż': 'z',
    'ẓ': 'z',
    'ȥ': 'z',
    'ẕ': 'z',
    'ᵶ': 'z',
    'ᶎ': 'z',
    'ʐ': 'z',
    'ƶ': 'z',
    'ɀ': 'z',
    'ﬀ': 'ff',
    'ﬃ': 'ffi',
    'ﬄ': 'ffl',
    'ﬁ': 'fi',
    'ﬂ': 'fl',
    'ĳ': 'ij',
    'œ': 'oe',
    'ﬆ': 'st',
    'ₐ': 'a',
    'ₑ': 'e',
    'ᵢ': 'i',
    'ⱼ': 'j',
    'ₒ': 'o',
    'ᵣ': 'r',
    'ᵤ': 'u',
    'ᵥ': 'v',
    'ₓ': 'x'
};


/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var browser_1 = __webpack_require__(258);
var Utils = (function () {
    function Utils() {
    }
    Utils.reflow = function (element) {
        new Function('bs', 'return bs')(element.offsetHeight);
    };
    // source: https://github.com/jquery/jquery/blob/master/src/css/var/getStyles.js
    Utils.getStyles = function (elem) {
        // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) {
            view = browser_1.window;
        }
        return view.getComputedStyle(elem);
    };
    return Utils;
}());
exports.Utils = Utils;


/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(994));
__export(__webpack_require__(995));
__export(__webpack_require__(996));
__export(__webpack_require__(997));
__export(__webpack_require__(998));
__export(__webpack_require__(999));
__export(__webpack_require__(1002));
__export(__webpack_require__(1000));
__export(__webpack_require__(1003));
__export(__webpack_require__(1004));
__export(__webpack_require__(1005));
__export(__webpack_require__(1006));
__export(__webpack_require__(1007));
__export(__webpack_require__(1008));
__export(__webpack_require__(1009));
__export(__webpack_require__(244));
__export(__webpack_require__(602));
__export(__webpack_require__(83));
var accordion_module_1 = __webpack_require__(232);
exports.AccordionModule = accordion_module_1.AccordionModule;
var alert_module_1 = __webpack_require__(233);
exports.AlertModule = alert_module_1.AlertModule;
var buttons_module_1 = __webpack_require__(234);
exports.ButtonsModule = buttons_module_1.ButtonsModule;
var carousel_module_1 = __webpack_require__(236);
exports.CarouselModule = carousel_module_1.CarouselModule;
var collapse_module_1 = __webpack_require__(156);
exports.CollapseModule = collapse_module_1.CollapseModule;
var datepicker_module_1 = __webpack_require__(237);
exports.DatepickerModule = datepicker_module_1.DatepickerModule;
var dropdown_module_1 = __webpack_require__(238);
exports.DropdownModule = dropdown_module_1.DropdownModule;
var modal_module_1 = __webpack_require__(241);
exports.ModalModule = modal_module_1.ModalModule;
var pagination_module_1 = __webpack_require__(243);
exports.PaginationModule = pagination_module_1.PaginationModule;
var progressbar_module_1 = __webpack_require__(246);
exports.ProgressbarModule = progressbar_module_1.ProgressbarModule;
var rating_module_1 = __webpack_require__(247);
exports.RatingModule = rating_module_1.RatingModule;
var tabs_module_1 = __webpack_require__(249);
exports.TabsModule = tabs_module_1.TabsModule;
var timepicker_module_1 = __webpack_require__(251);
exports.TimepickerModule = timepicker_module_1.TimepickerModule;
var tooltip_module_1 = __webpack_require__(253);
exports.TooltipModule = tooltip_module_1.TooltipModule;
var typeahead_module_1 = __webpack_require__(257);
exports.TypeaheadModule = typeahead_module_1.TypeaheadModule;
var components_helper_service_1 = __webpack_require__(53);
exports.ComponentsHelper = components_helper_service_1.ComponentsHelper;
var index_1 = __webpack_require__(1001);
exports.Ng2BootstrapModule = index_1.Ng2BootstrapModule;


/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

var map = {
	"./af": 622,
	"./af.js": 622,
	"./ar": 627,
	"./ar-ly": 623,
	"./ar-ly.js": 623,
	"./ar-ma": 624,
	"./ar-ma.js": 624,
	"./ar-sa": 625,
	"./ar-sa.js": 625,
	"./ar-tn": 626,
	"./ar-tn.js": 626,
	"./ar.js": 627,
	"./az": 628,
	"./az.js": 628,
	"./be": 629,
	"./be.js": 629,
	"./bg": 630,
	"./bg.js": 630,
	"./bn": 631,
	"./bn.js": 631,
	"./bo": 632,
	"./bo.js": 632,
	"./br": 633,
	"./br.js": 633,
	"./bs": 634,
	"./bs.js": 634,
	"./ca": 635,
	"./ca.js": 635,
	"./cs": 636,
	"./cs.js": 636,
	"./cv": 637,
	"./cv.js": 637,
	"./cy": 638,
	"./cy.js": 638,
	"./da": 639,
	"./da.js": 639,
	"./de": 641,
	"./de-at": 640,
	"./de-at.js": 640,
	"./de.js": 641,
	"./dv": 642,
	"./dv.js": 642,
	"./el": 643,
	"./el.js": 643,
	"./en-au": 644,
	"./en-au.js": 644,
	"./en-ca": 645,
	"./en-ca.js": 645,
	"./en-gb": 646,
	"./en-gb.js": 646,
	"./en-ie": 647,
	"./en-ie.js": 647,
	"./en-nz": 648,
	"./en-nz.js": 648,
	"./eo": 649,
	"./eo.js": 649,
	"./es": 651,
	"./es-do": 650,
	"./es-do.js": 650,
	"./es.js": 651,
	"./et": 652,
	"./et.js": 652,
	"./eu": 653,
	"./eu.js": 653,
	"./fa": 654,
	"./fa.js": 654,
	"./fi": 655,
	"./fi.js": 655,
	"./fo": 656,
	"./fo.js": 656,
	"./fr": 659,
	"./fr-ca": 657,
	"./fr-ca.js": 657,
	"./fr-ch": 658,
	"./fr-ch.js": 658,
	"./fr.js": 659,
	"./fy": 660,
	"./fy.js": 660,
	"./gd": 661,
	"./gd.js": 661,
	"./gl": 662,
	"./gl.js": 662,
	"./he": 663,
	"./he.js": 663,
	"./hi": 664,
	"./hi.js": 664,
	"./hr": 665,
	"./hr.js": 665,
	"./hu": 666,
	"./hu.js": 666,
	"./hy-am": 667,
	"./hy-am.js": 667,
	"./id": 668,
	"./id.js": 668,
	"./is": 669,
	"./is.js": 669,
	"./it": 670,
	"./it.js": 670,
	"./ja": 671,
	"./ja.js": 671,
	"./jv": 672,
	"./jv.js": 672,
	"./ka": 673,
	"./ka.js": 673,
	"./kk": 674,
	"./kk.js": 674,
	"./km": 675,
	"./km.js": 675,
	"./ko": 676,
	"./ko.js": 676,
	"./ky": 677,
	"./ky.js": 677,
	"./lb": 678,
	"./lb.js": 678,
	"./lo": 679,
	"./lo.js": 679,
	"./lt": 680,
	"./lt.js": 680,
	"./lv": 681,
	"./lv.js": 681,
	"./me": 682,
	"./me.js": 682,
	"./mi": 683,
	"./mi.js": 683,
	"./mk": 684,
	"./mk.js": 684,
	"./ml": 685,
	"./ml.js": 685,
	"./mr": 686,
	"./mr.js": 686,
	"./ms": 688,
	"./ms-my": 687,
	"./ms-my.js": 687,
	"./ms.js": 688,
	"./my": 689,
	"./my.js": 689,
	"./nb": 690,
	"./nb.js": 690,
	"./ne": 691,
	"./ne.js": 691,
	"./nl": 692,
	"./nl.js": 692,
	"./nn": 693,
	"./nn.js": 693,
	"./pa-in": 694,
	"./pa-in.js": 694,
	"./pl": 695,
	"./pl.js": 695,
	"./pt": 697,
	"./pt-br": 696,
	"./pt-br.js": 696,
	"./pt.js": 697,
	"./ro": 698,
	"./ro.js": 698,
	"./ru": 699,
	"./ru.js": 699,
	"./se": 700,
	"./se.js": 700,
	"./si": 701,
	"./si.js": 701,
	"./sk": 702,
	"./sk.js": 702,
	"./sl": 703,
	"./sl.js": 703,
	"./sq": 704,
	"./sq.js": 704,
	"./sr": 706,
	"./sr-cyrl": 705,
	"./sr-cyrl.js": 705,
	"./sr.js": 706,
	"./ss": 707,
	"./ss.js": 707,
	"./sv": 708,
	"./sv.js": 708,
	"./sw": 709,
	"./sw.js": 709,
	"./ta": 710,
	"./ta.js": 710,
	"./te": 711,
	"./te.js": 711,
	"./th": 712,
	"./th.js": 712,
	"./tl-ph": 713,
	"./tl-ph.js": 713,
	"./tlh": 714,
	"./tlh.js": 714,
	"./tr": 715,
	"./tr.js": 715,
	"./tzl": 716,
	"./tzl.js": 716,
	"./tzm": 718,
	"./tzm-latn": 717,
	"./tzm-latn.js": 717,
	"./tzm.js": 718,
	"./uk": 719,
	"./uk.js": 719,
	"./uz": 720,
	"./uz.js": 720,
	"./vi": 721,
	"./vi.js": 721,
	"./x-pseudo": 722,
	"./x-pseudo.js": 722,
	"./zh-cn": 723,
	"./zh-cn.js": 723,
	"./zh-hk": 724,
	"./zh-hk.js": 724,
	"./zh-tw": 725,
	"./zh-tw.js": 725
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1013;


/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
/* tslint:disable-next-line */
var BaseChartDirective = (function () {
    function BaseChartDirective(element) {
        this.labels = [];
        this.options = {};
        this.chartClick = new core_1.EventEmitter();
        this.chartHover = new core_1.EventEmitter();
        this.initFlag = false;
        this.element = element;
    }
    BaseChartDirective.prototype.ngOnInit = function () {
        this.ctx = this.element.nativeElement.getContext('2d');
        this.cvs = this.element.nativeElement;
        this.initFlag = true;
        if (this.data || this.datasets) {
            this.refresh();
        }
    };
    BaseChartDirective.prototype.ngOnChanges = function (changes) {
        if (this.initFlag) {
            // Check if the changes are in the data or datasets
            if (changes.hasOwnProperty('data') || changes.hasOwnProperty('datasets') || changes.hasOwnProperty('labels')) {
                this.chart.data.datasets = this.getDatasets();
                this.chart.data.labels = this.labels;
                this.chart.update();
            }
            else {
                this.refresh();
            }
        }
    };
    BaseChartDirective.prototype.ngOnDestroy = function () {
        if (this.chart) {
            this.chart.destroy();
            this.chart = void 0;
        }
    };
    BaseChartDirective.prototype.getChartBuilder = function (ctx /*, data:Array<any>, options:any*/) {
        var _this = this;
        var datasets = this.getDatasets();
        var options = Object.assign({}, this.options);
        if (this.legend === false) {
            options.legend = { display: false };
        }
        // hock for onHover and onClick events
        options.hover = options.hover || {};
        if (!options.hover.onHover) {
            options.hover.onHover = function (active) {
                if (active && !active.length) {
                    return;
                }
                _this.chartHover.emit({ active: active });
            };
        }
        if (!options.onClick) {
            options.onClick = function (event, active) {
                _this.chartClick.emit({ event: event, active: active });
            };
        }
        var opts = {
            type: this.chartType,
            data: {
                labels: this.labels,
                datasets: datasets
            },
            options: options
        };
        if (typeof Chart === 'undefined') {
            throw new Error('ng2-charts configuration issue: Embedding Chart.js lib is mandatory');
        }
        return new Chart(ctx, opts);
    };
    BaseChartDirective.prototype.getDatasets = function () {
        var _this = this;
        var datasets = void 0;
        // in case if datasets is not provided, but data is present
        if (!this.datasets || !this.datasets.length && (this.data && this.data.length)) {
            if (Array.isArray(this.data[0])) {
                datasets = this.data.map(function (data, index) {
                    return { data: data, label: _this.labels[index] || "Label " + index };
                });
            }
            else {
                datasets = [{ data: this.data, label: "Label 0" }];
            }
        }
        if (this.datasets && this.datasets.length ||
            (datasets && datasets.length)) {
            datasets = (this.datasets || datasets)
                .map(function (elm, index) {
                var newElm = Object.assign({}, elm);
                if (_this.colors && _this.colors.length) {
                    Object.assign(newElm, _this.colors[index]);
                }
                else {
                    Object.assign(newElm, getColors(_this.chartType, index, newElm.data.length));
                }
                return newElm;
            });
        }
        if (!datasets) {
            throw new Error("ng-charts configuration error,\n      data or datasets field are required to render char " + this.chartType);
        }
        return datasets;
    };
    BaseChartDirective.prototype.refresh = function () {
        // if (this.options && this.options.responsive) {
        //   setTimeout(() => this.refresh(), 50);
        // }
        // todo: remove this line, it is producing flickering
        this.ngOnDestroy();
        this.chart = this.getChartBuilder(this.ctx /*, data, this.options*/);
    };
    BaseChartDirective.defaultColors = [
        [255, 99, 132],
        [54, 162, 235],
        [255, 206, 86],
        [231, 233, 237],
        [75, 192, 192],
        [151, 187, 205],
        [220, 220, 220],
        [247, 70, 74],
        [70, 191, 189],
        [253, 180, 92],
        [148, 159, 177],
        [77, 83, 96]
    ];
    BaseChartDirective.decorators = [
        { type: core_1.Directive, args: [{ selector: 'canvas[baseChart]', exportAs: 'base-chart' },] },
    ];
    /** @nocollapse */
    BaseChartDirective.ctorParameters = [
        { type: core_1.ElementRef, },
    ];
    BaseChartDirective.propDecorators = {
        'data': [{ type: core_1.Input },],
        'datasets': [{ type: core_1.Input },],
        'labels': [{ type: core_1.Input },],
        'options': [{ type: core_1.Input },],
        'chartType': [{ type: core_1.Input },],
        'colors': [{ type: core_1.Input },],
        'legend': [{ type: core_1.Input },],
        'chartClick': [{ type: core_1.Output },],
        'chartHover': [{ type: core_1.Output },],
    };
    return BaseChartDirective;
}());
exports.BaseChartDirective = BaseChartDirective;
function rgba(colour, alpha) {
    return 'rgba(' + colour.concat(alpha).join(',') + ')';
}
function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
function formatLineColor(colors) {
    return {
        backgroundColor: rgba(colors, 0.4),
        borderColor: rgba(colors, 1),
        pointBackgroundColor: rgba(colors, 1),
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: rgba(colors, 0.8)
    };
}
function formatBarColor(colors) {
    return {
        backgroundColor: rgba(colors, 0.6),
        borderColor: rgba(colors, 1),
        hoverBackgroundColor: rgba(colors, 0.8),
        hoverBorderColor: rgba(colors, 1)
    };
}
function formatPieColors(colors) {
    return {
        backgroundColor: colors.map(function (color) { return rgba(color, 0.6); }),
        borderColor: colors.map(function () { return '#fff'; }),
        pointBackgroundColor: colors.map(function (color) { return rgba(color, 1); }),
        pointBorderColor: colors.map(function () { return '#fff'; }),
        pointHoverBackgroundColor: colors.map(function (color) { return rgba(color, 1); }),
        pointHoverBorderColor: colors.map(function (color) { return rgba(color, 1); })
    };
}
function formatPolarAreaColors(colors) {
    return {
        backgroundColor: colors.map(function (color) { return rgba(color, 0.6); }),
        borderColor: colors.map(function (color) { return rgba(color, 1); }),
        hoverBackgroundColor: colors.map(function (color) { return rgba(color, 0.8); }),
        hoverBorderColor: colors.map(function (color) { return rgba(color, 1); })
    };
}
function getRandomColor() {
    return [getRandomInt(0, 255), getRandomInt(0, 255), getRandomInt(0, 255)];
}
/**
 * Generate colors for line|bar charts
 * @param index
 * @returns {number[]|Color}
 */
function generateColor(index) {
    return BaseChartDirective.defaultColors[index] || getRandomColor();
}
/**
 * Generate colors for pie|doughnut charts
 * @param count
 * @returns {Colors}
 */
function generateColors(count) {
    var colorsArr = new Array(count);
    for (var i = 0; i < count; i++) {
        colorsArr[i] = BaseChartDirective.defaultColors[i] || getRandomColor();
    }
    return colorsArr;
}
/**
 * Generate colors by chart type
 * @param chartType
 * @param index
 * @param count
 * @returns {Color}
 */
function getColors(chartType, index, count) {
    if (chartType === 'pie' || chartType === 'doughnut') {
        return formatPieColors(generateColors(count));
    }
    if (chartType === 'polarArea') {
        return formatPolarAreaColors(generateColors(count));
    }
    if (chartType === 'line' || chartType === 'radar') {
        return formatLineColor(generateColor(index));
    }
    if (chartType === 'bar' || chartType === 'horizontalBar') {
        return formatBarColor(generateColor(index));
    }
    return generateColor(index);
}
var ChartsModule = (function () {
    function ChartsModule() {
    }
    ChartsModule.decorators = [
        { type: core_1.NgModule, args: [{
                    declarations: [
                        BaseChartDirective
                    ],
                    exports: [
                        BaseChartDirective
                    ],
                    imports: []
                },] },
    ];
    /** @nocollapse */
    ChartsModule.ctorParameters = [];
    return ChartsModule;
}());
exports.ChartsModule = ChartsModule;


/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(1014));


/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(9);
var toast_container_component_1 = __webpack_require__(259);
var toast_manager_1 = __webpack_require__(726);
var toast_options_1 = __webpack_require__(158);
var ToastModule = (function () {
    function ToastModule() {
    }
    ToastModule.forRoot = function (config) {
        return {
            ngModule: ToastModule,
            providers: [
                { provide: toast_options_1.ToastOptions, useValue: config }
            ]
        };
    };
    ToastModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [common_1.CommonModule],
                    declarations: [toast_container_component_1.ToastContainer],
                    exports: [toast_container_component_1.ToastContainer],
                    providers: [toast_manager_1.ToastsManager],
                    entryComponents: [toast_container_component_1.ToastContainer]
                },] },
    ];
    /** @nocollapse */
    ToastModule.ctorParameters = [];
    return ToastModule;
}());
exports.ToastModule = ToastModule;
//# sourceMappingURL=toast.module.js.map

/***/ },
/* 1017 */
/***/ function(module, exports) {

module.exports = "<h2>Alphabeticallistofproducts Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Alphabeticallistofproducts Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ProductID\" class=\"col-xs-3 col-sm-2 control-label\">Product Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ProductID\" name=\"ProductID\" placeholder=\"Product Id\" [(ngModel)]=\"objAlphabeticallistofproducts.ProductID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ProductName\" class=\"col-xs-3 col-sm-2 control-label\">Product Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ProductName\" name=\"ProductName\" placeholder=\"Product Name\" [(ngModel)]=\"objAlphabeticallistofproducts.ProductName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"SupplierID\" class=\"col-xs-3 col-sm-2 control-label\">Supplier Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"SupplierID\" name=\"SupplierID\" placeholder=\"Supplier Id\" [(ngModel)]=\"objAlphabeticallistofproducts.SupplierID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CategoryID\" class=\"col-xs-3 col-sm-2 control-label\">Category Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CategoryID\" name=\"CategoryID\" placeholder=\"Category Id\" [(ngModel)]=\"objAlphabeticallistofproducts.CategoryID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"QuantityPerUnit\" class=\"col-xs-3 col-sm-2 control-label\">Quantityperunit:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"QuantityPerUnit\" name=\"QuantityPerUnit\" placeholder=\"Quantityperunit\" [(ngModel)]=\"objAlphabeticallistofproducts.QuantityPerUnit\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"UnitPrice\" class=\"col-xs-3 col-sm-2 control-label\">Unitprice:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"UnitPrice\" name=\"UnitPrice\" placeholder=\"Unitprice\" [(ngModel)]=\"objAlphabeticallistofproducts.UnitPrice\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"UnitsInStock\" class=\"col-xs-3 col-sm-2 control-label\">Unitsinstock:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"UnitsInStock\" name=\"UnitsInStock\" placeholder=\"Unitsinstock\" [(ngModel)]=\"objAlphabeticallistofproducts.UnitsInStock\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"UnitsOnOrder\" class=\"col-xs-3 col-sm-2 control-label\">Unitsonorder:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"UnitsOnOrder\" name=\"UnitsOnOrder\" placeholder=\"Unitsonorder\" [(ngModel)]=\"objAlphabeticallistofproducts.UnitsOnOrder\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ReorderLevel\" class=\"col-xs-3 col-sm-2 control-label\">Reorderlevel:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ReorderLevel\" name=\"ReorderLevel\" placeholder=\"Reorderlevel\" [(ngModel)]=\"objAlphabeticallistofproducts.ReorderLevel\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Discontinued\" class=\"col-xs-3 col-sm-2 control-label\">Discontinued:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Discontinued\" name=\"Discontinued\" placeholder=\"Discontinued\" [(ngModel)]=\"objAlphabeticallistofproducts.Discontinued\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CategoryName\" class=\"col-xs-3 col-sm-2 control-label\">Category Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CategoryName\" name=\"CategoryName\" placeholder=\"Category Name\" [(ngModel)]=\"objAlphabeticallistofproducts.CategoryName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoAlphabeticallistofproducts()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1018 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>Alphabeticallistofproducts List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\t\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<AlphabeticallistofproductsSearch (filterCriteria)=\"onSearch($event)\" ></AlphabeticallistofproductsSearch>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}\r\n\t\t\t\t</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr> \r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ProductID')\">Product Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ProductName')\">Product Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'SupplierID')\">Supplier Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CategoryID')\">Category Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'QuantityPerUnit')\">Quantityperunit</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'UnitPrice')\">Unitprice</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'UnitsInStock')\">Unitsinstock</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'UnitsOnOrder')\">Unitsonorder</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ReorderLevel')\">Reorderlevel</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Discontinued')\">Discontinued</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CategoryName')\">Category Name</a></th>\r\n\r\n\t\t</tr>\r\n\t\t\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of AlphabeticallistofproductsList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelectDetails(item)\">Details</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.ProductID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ProductName}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.SupplierID}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.CategoryID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.QuantityPerUnit}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.UnitPrice}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.UnitsInStock}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.UnitsOnOrder}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.ReorderLevel}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Discontinued}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.CategoryName}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1019 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch Alphabeticallistofproducts\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ProductID.touched && ProductID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ProductID\" class=\"col-xs-3 col-sm-2 control-label\">Product Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ProductID=\"ngModel\" name=\"ProductID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Product Id\" [(ngModel)]=\"objAlphabeticallistofproducts.ProductID\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ProductID.touched && ProductID.invalid\">Product Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ProductName.touched && ProductName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ProductName\" class=\"col-xs-3 col-sm-2 control-label\">Product Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ProductName=\"ngModel\" name=\"ProductName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Product Name\" [(ngModel)]=\"objAlphabeticallistofproducts.ProductName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ProductName.touched && ProductName.invalid\">Product Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"SupplierID.touched && SupplierID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"SupplierID\" class=\"col-xs-3 col-sm-2 control-label\">Supplier Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #SupplierID=\"ngModel\" name=\"SupplierID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Supplier Id\" [(ngModel)]=\"objAlphabeticallistofproducts.SupplierID\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"SupplierID.touched && SupplierID.invalid\">Supplier Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CategoryID.touched && CategoryID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CategoryID\" class=\"col-xs-3 col-sm-2 control-label\">Category Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CategoryID=\"ngModel\" name=\"CategoryID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Category Id\" [(ngModel)]=\"objAlphabeticallistofproducts.CategoryID\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CategoryID.touched && CategoryID.invalid\">Category Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"QuantityPerUnit.touched && QuantityPerUnit.invalid\" >\r\n\t\t\t\t\t\t<label for=\"QuantityPerUnit\" class=\"col-xs-3 col-sm-2 control-label\">Quantityperunit:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #QuantityPerUnit=\"ngModel\" name=\"QuantityPerUnit\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Quantityperunit\" [(ngModel)]=\"objAlphabeticallistofproducts.QuantityPerUnit\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"QuantityPerUnit.touched && QuantityPerUnit.invalid\">Quantityperunit is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"UnitPrice.touched && UnitPrice.invalid\" >\r\n\t\t\t\t\t\t<label for=\"UnitPrice\" class=\"col-xs-3 col-sm-2 control-label\">Unitprice:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #UnitPrice=\"ngModel\" name=\"UnitPrice\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Unitprice\" [(ngModel)]=\"objAlphabeticallistofproducts.UnitPrice\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"UnitPrice.touched && UnitPrice.invalid\">Unitprice must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"UnitsInStock.touched && UnitsInStock.invalid\" >\r\n\t\t\t\t\t\t<label for=\"UnitsInStock\" class=\"col-xs-3 col-sm-2 control-label\">Unitsinstock:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #UnitsInStock=\"ngModel\" name=\"UnitsInStock\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Unitsinstock\" [(ngModel)]=\"objAlphabeticallistofproducts.UnitsInStock\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"UnitsInStock.touched && UnitsInStock.invalid\">Unitsinstock must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"UnitsOnOrder.touched && UnitsOnOrder.invalid\" >\r\n\t\t\t\t\t\t<label for=\"UnitsOnOrder\" class=\"col-xs-3 col-sm-2 control-label\">Unitsonorder:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #UnitsOnOrder=\"ngModel\" name=\"UnitsOnOrder\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Unitsonorder\" [(ngModel)]=\"objAlphabeticallistofproducts.UnitsOnOrder\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"UnitsOnOrder.touched && UnitsOnOrder.invalid\">Unitsonorder must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ReorderLevel.touched && ReorderLevel.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ReorderLevel\" class=\"col-xs-3 col-sm-2 control-label\">Reorderlevel:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ReorderLevel=\"ngModel\" name=\"ReorderLevel\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Reorderlevel\" [(ngModel)]=\"objAlphabeticallistofproducts.ReorderLevel\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ReorderLevel.touched && ReorderLevel.invalid\">Reorderlevel must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"chkDiscontinued\" class=\"col-xs-3 col-sm-2 control-label\">Discontinued:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t\t\t\t\t<input id=\"chkDiscontinued\" name=\"chkDiscontinued\" type=\"checkbox\" placeholder=\"Discontinued\" [(ngModel)]=\"objAlphabeticallistofproducts.Discontinued\">\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CategoryName.touched && CategoryName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CategoryName\" class=\"col-xs-3 col-sm-2 control-label\">Category Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CategoryName=\"ngModel\" name=\"CategoryName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Category Name\" [(ngModel)]=\"objAlphabeticallistofproducts.CategoryName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CategoryName.touched && CategoryName.invalid\">Category Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1020 */
/***/ function(module, exports) {

module.exports = "<h2>Add Categories</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Categories Add</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CategoryID.touched && CategoryID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CategoryID\" class=\"col-xs-3 col-sm-2 control-label\">Category Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CategoryID=\"ngModel\" name=\"CategoryID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Category Id\" [(ngModel)]=\"objCategories.CategoryID\" pattern=\"^(0|[1-9][0-9]*)$\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CategoryID.touched && CategoryID.invalid\">Category Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CategoryName.touched && CategoryName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CategoryName\" class=\"col-xs-3 col-sm-2 control-label\">Category Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CategoryName=\"ngModel\" name=\"CategoryName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Category Name\" [(ngModel)]=\"objCategories.CategoryName\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CategoryName.touched && CategoryName.invalid\">Category Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Description.touched && Description.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Description\" class=\"col-xs-3 col-sm-2 control-label\">Description:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<textarea #Description=\"ngModel\" name=\"Description\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Description\" [(ngModel)]=\"objCategories.Description\"  rows=\"4\"> </textarea>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Description.touched && Description.invalid\">Description is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Picture.touched && Picture.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Picture\" class=\"col-xs-3 col-sm-2 control-label\">Picture:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Picture=\"ngModel\" name=\"Picture\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Picture\" [(ngModel)]=\"objCategories.Picture\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Picture.touched && Picture.invalid\">Picture must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"addCategories()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoCategories()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1021 */
/***/ function(module, exports) {

module.exports = "<h2>Categories Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Categories Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CategoryID\" class=\"col-xs-3 col-sm-2 control-label\">Category Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CategoryID\" name=\"CategoryID\" placeholder=\"Category Id\" [(ngModel)]=\"objCategories.CategoryID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CategoryName\" class=\"col-xs-3 col-sm-2 control-label\">Category Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CategoryName\" name=\"CategoryName\" placeholder=\"Category Name\" [(ngModel)]=\"objCategories.CategoryName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Description\" class=\"col-xs-3 col-sm-2 control-label\">Description:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Description\" name=\"Description\" placeholder=\"Description\" [(ngModel)]=\"objCategories.Description\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Picture\" class=\"col-xs-3 col-sm-2 control-label\">Picture:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Picture\" name=\"Picture\" placeholder=\"Picture\" [(ngModel)]=\"objCategories.Picture\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"gotoCategoriesEdit()\">Edit</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoCategories()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" (click)=\"deleteCategories(objCategories.CategoryID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1022 */
/***/ function(module, exports) {

module.exports = "<h2>Edit Categories</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Categories Edit</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CategoryID.touched && CategoryID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CategoryID\" class=\"col-xs-3 col-sm-2 control-label\">Category Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CategoryID=\"ngModel\" name=\"CategoryID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Category Id\" [(ngModel)]=\"objCategories.CategoryID\" pattern=\"^(0|[1-9][0-9]*)$\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CategoryID.touched && CategoryID.invalid\">Category Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CategoryName.touched && CategoryName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CategoryName\" class=\"col-xs-3 col-sm-2 control-label\">Category Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CategoryName=\"ngModel\" name=\"CategoryName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Category Name\" [(ngModel)]=\"objCategories.CategoryName\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CategoryName.touched && CategoryName.invalid\">Category Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Description.touched && Description.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Description\" class=\"col-xs-3 col-sm-2 control-label\">Description:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<textarea #Description=\"ngModel\" name=\"Description\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Description\" [(ngModel)]=\"objCategories.Description\"  rows=\"4\"> </textarea>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Description.touched && Description.invalid\">Description is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Picture.touched && Picture.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Picture\" class=\"col-xs-3 col-sm-2 control-label\">Picture:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Picture=\"ngModel\" name=\"Picture\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Picture\" [(ngModel)]=\"objCategories.Picture\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Picture.touched && Picture.invalid\">Picture must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"updateCategories()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoCategories()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" type=\"submit\" (click)=\"deleteCategories(objCategories.CategoryID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1023 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>Categories List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<CategoriesSearch (filterCriteria)=\"onSearch($event)\" ></CategoriesSearch>\r\n\t\t</div>\r\n\t</div>\r\n\t\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" routerLink=\"/Categories/add\" routerLinkActive=\"active\" title=\"Add Categories\"><i class=\"glyphicon glyphicon-plus\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Delete List(s)\"><i class=\"glyphicon glyphicon-remove\"></i></a-->\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr>\r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CategoryID')\">Category Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CategoryName')\">Category Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Description')\">Description</a></th>\r\n\r\n\t\t</tr>\r\n\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of CategoriesList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelect(item)\">Edit</a>\r\n\t\t\t\t\t<a (click)=\"deleteCategories(item.CategoryID)\">Delete</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.CategoryID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.CategoryName}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Description}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1024 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch Categories\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CategoryID.touched && CategoryID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CategoryID\" class=\"col-xs-3 col-sm-2 control-label\">Category Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CategoryID=\"ngModel\" name=\"CategoryID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Category Id\" [(ngModel)]=\"objCategories.CategoryID\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CategoryID.touched && CategoryID.invalid\">Category Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CategoryName.touched && CategoryName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CategoryName\" class=\"col-xs-3 col-sm-2 control-label\">Category Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CategoryName=\"ngModel\" name=\"CategoryName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Category Name\" [(ngModel)]=\"objCategories.CategoryName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CategoryName.touched && CategoryName.invalid\">Category Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Description.touched && Description.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Description\" class=\"col-xs-3 col-sm-2 control-label\">Description:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<textarea #Description=\"ngModel\" name=\"Description\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Description\" [(ngModel)]=\"objCategories.Description\"  rows=\"4\"> </textarea>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Description.touched && Description.invalid\">Description is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Picture.touched && Picture.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Picture\" class=\"col-xs-3 col-sm-2 control-label\">Picture:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Picture=\"ngModel\" name=\"Picture\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Picture\" [(ngModel)]=\"objCategories.Picture\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Picture.touched && Picture.invalid\">Picture must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1025 */
/***/ function(module, exports) {

module.exports = "<h2>CategorySalesfor1997 Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">CategorySalesfor1997 Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CategoryName\" class=\"col-xs-3 col-sm-2 control-label\">Category Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CategoryName\" name=\"CategoryName\" placeholder=\"Category Name\" [(ngModel)]=\"objCategorySalesfor1997.CategoryName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CategorySales\" class=\"col-xs-3 col-sm-2 control-label\">Categorysales:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CategorySales\" name=\"CategorySales\" placeholder=\"Categorysales\" [(ngModel)]=\"objCategorySalesfor1997.CategorySales\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoCategorySalesfor1997()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1026 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>CategorySalesfor1997 List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\t\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<CategorySalesfor1997Search (filterCriteria)=\"onSearch($event)\" ></CategorySalesfor1997Search>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}\r\n\t\t\t\t</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr> \r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CategoryName')\">Category Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CategorySales')\">Categorysales</a></th>\r\n\r\n\t\t</tr>\r\n\t\t\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of CategorySalesfor1997List\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelectDetails(item)\">Details</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.CategoryName}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.CategorySales}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1027 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch CategorySalesfor1997\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CategoryName.touched && CategoryName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CategoryName\" class=\"col-xs-3 col-sm-2 control-label\">Category Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CategoryName=\"ngModel\" name=\"CategoryName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Category Name\" [(ngModel)]=\"objCategorySalesfor1997.CategoryName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CategoryName.touched && CategoryName.invalid\">Category Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CategorySales.touched && CategorySales.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CategorySales\" class=\"col-xs-3 col-sm-2 control-label\">Categorysales:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CategorySales=\"ngModel\" name=\"CategorySales\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Categorysales\" [(ngModel)]=\"objCategorySalesfor1997.CategorySales\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CategorySales.touched && CategorySales.invalid\">Categorysales must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1028 */
/***/ function(module, exports) {

module.exports = "<h2>CurrentProductList Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">CurrentProductList Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ProductID\" class=\"col-xs-3 col-sm-2 control-label\">Product Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ProductID\" name=\"ProductID\" placeholder=\"Product Id\" [(ngModel)]=\"objCurrentProductList.ProductID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ProductName\" class=\"col-xs-3 col-sm-2 control-label\">Product Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ProductName\" name=\"ProductName\" placeholder=\"Product Name\" [(ngModel)]=\"objCurrentProductList.ProductName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoCurrentProductList()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1029 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>CurrentProductList List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\t\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<CurrentProductListSearch (filterCriteria)=\"onSearch($event)\" ></CurrentProductListSearch>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}\r\n\t\t\t\t</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr> \r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ProductID')\">Product Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ProductName')\">Product Name</a></th>\r\n\r\n\t\t</tr>\r\n\t\t\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of CurrentProductListList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelectDetails(item)\">Details</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.ProductID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ProductName}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1030 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch CurrentProductList\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ProductID.touched && ProductID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ProductID\" class=\"col-xs-3 col-sm-2 control-label\">Product Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ProductID=\"ngModel\" name=\"ProductID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Product Id\" [(ngModel)]=\"objCurrentProductList.ProductID\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ProductID.touched && ProductID.invalid\">Product Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ProductName.touched && ProductName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ProductName\" class=\"col-xs-3 col-sm-2 control-label\">Product Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ProductName=\"ngModel\" name=\"ProductName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Product Name\" [(ngModel)]=\"objCurrentProductList.ProductName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ProductName.touched && ProductName.invalid\">Product Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1031 */
/***/ function(module, exports) {

module.exports = "<h2>Add CustomerCustomerDemo</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">CustomerCustomerDemo Add</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CustomerID.touched && CustomerID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CustomerID\" class=\"col-xs-3 col-sm-2 control-label\">Customer Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CustomerID=\"ngModel\" name=\"CustomerID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Customer Id\" [(ngModel)]=\"objCustomerCustomerDemo.CustomerID\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CustomerID.touched && CustomerID.invalid\">Customer Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CustomerTypeID.touched && CustomerTypeID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CustomerTypeID\" class=\"col-xs-3 col-sm-2 control-label\">Customertype Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CustomerTypeID=\"ngModel\" name=\"CustomerTypeID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Customertype Id\" [(ngModel)]=\"objCustomerCustomerDemo.CustomerTypeID\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CustomerTypeID.touched && CustomerTypeID.invalid\">Customertype Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"addCustomerCustomerDemo()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoCustomerCustomerDemo()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1032 */
/***/ function(module, exports) {

module.exports = "<h2>CustomerCustomerDemo Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">CustomerCustomerDemo Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CustomerID\" class=\"col-xs-3 col-sm-2 control-label\">Customer Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CustomerID\" name=\"CustomerID\" placeholder=\"Customer Id\" [(ngModel)]=\"objCustomerCustomerDemo.CustomerID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CustomerTypeID\" class=\"col-xs-3 col-sm-2 control-label\">Customertype Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CustomerTypeID\" name=\"CustomerTypeID\" placeholder=\"Customertype Id\" [(ngModel)]=\"objCustomerCustomerDemo.CustomerTypeID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"gotoCustomerCustomerDemoEdit()\">Edit</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoCustomerCustomerDemo()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" (click)=\"deleteCustomerCustomerDemo(objCustomerCustomerDemo.CustomerID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1033 */
/***/ function(module, exports) {

module.exports = "<h2>Edit CustomerCustomerDemo</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">CustomerCustomerDemo Edit</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CustomerID.touched && CustomerID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CustomerID\" class=\"col-xs-3 col-sm-2 control-label\">Customer Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CustomerID=\"ngModel\" name=\"CustomerID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Customer Id\" [(ngModel)]=\"objCustomerCustomerDemo.CustomerID\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CustomerID.touched && CustomerID.invalid\">Customer Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CustomerTypeID.touched && CustomerTypeID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CustomerTypeID\" class=\"col-xs-3 col-sm-2 control-label\">Customertype Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CustomerTypeID=\"ngModel\" name=\"CustomerTypeID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Customertype Id\" [(ngModel)]=\"objCustomerCustomerDemo.CustomerTypeID\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CustomerTypeID.touched && CustomerTypeID.invalid\">Customertype Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"updateCustomerCustomerDemo()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoCustomerCustomerDemo()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" type=\"submit\" (click)=\"deleteCustomerCustomerDemo(objCustomerCustomerDemo.CustomerID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1034 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>CustomerCustomerDemo List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<CustomerCustomerDemoSearch (filterCriteria)=\"onSearch($event)\" ></CustomerCustomerDemoSearch>\r\n\t\t</div>\r\n\t</div>\r\n\t\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" routerLink=\"/CustomerCustomerDemo/add\" routerLinkActive=\"active\" title=\"Add CustomerCustomerDemo\"><i class=\"glyphicon glyphicon-plus\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Delete List(s)\"><i class=\"glyphicon glyphicon-remove\"></i></a-->\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr>\r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CustomerID')\">Customer Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CustomerTypeID')\">Customertype Id</a></th>\r\n\r\n\t\t</tr>\r\n\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of CustomerCustomerDemoList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelect(item)\">Edit</a>\r\n\t\t\t\t\t<a (click)=\"deleteCustomerCustomerDemo(item.CustomerID)\">Delete</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.CustomerID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.CustomerTypeID}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1035 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch CustomerCustomerDemo\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CustomerID.touched && CustomerID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CustomerID\" class=\"col-xs-3 col-sm-2 control-label\">Customer Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CustomerID=\"ngModel\" name=\"CustomerID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Customer Id\" [(ngModel)]=\"objCustomerCustomerDemo.CustomerID\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CustomerID.touched && CustomerID.invalid\">Customer Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CustomerTypeID.touched && CustomerTypeID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CustomerTypeID\" class=\"col-xs-3 col-sm-2 control-label\">Customertype Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CustomerTypeID=\"ngModel\" name=\"CustomerTypeID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Customertype Id\" [(ngModel)]=\"objCustomerCustomerDemo.CustomerTypeID\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CustomerTypeID.touched && CustomerTypeID.invalid\">Customertype Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1036 */
/***/ function(module, exports) {

module.exports = "<h2>Add CustomerDemographics</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">CustomerDemographics Add</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CustomerTypeID.touched && CustomerTypeID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CustomerTypeID\" class=\"col-xs-3 col-sm-2 control-label\">Customertype Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CustomerTypeID=\"ngModel\" name=\"CustomerTypeID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Customertype Id\" [(ngModel)]=\"objCustomerDemographics.CustomerTypeID\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CustomerTypeID.touched && CustomerTypeID.invalid\">Customertype Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CustomerDesc.touched && CustomerDesc.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CustomerDesc\" class=\"col-xs-3 col-sm-2 control-label\">Customer Description:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<textarea #CustomerDesc=\"ngModel\" name=\"CustomerDesc\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Customer Description\" [(ngModel)]=\"objCustomerDemographics.CustomerDesc\"  rows=\"4\"> </textarea>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CustomerDesc.touched && CustomerDesc.invalid\">Customer Description is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"addCustomerDemographics()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoCustomerDemographics()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1037 */
/***/ function(module, exports) {

module.exports = "<h2>CustomerDemographics Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">CustomerDemographics Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CustomerTypeID\" class=\"col-xs-3 col-sm-2 control-label\">Customertype Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CustomerTypeID\" name=\"CustomerTypeID\" placeholder=\"Customertype Id\" [(ngModel)]=\"objCustomerDemographics.CustomerTypeID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CustomerDesc\" class=\"col-xs-3 col-sm-2 control-label\">Customer Description:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CustomerDesc\" name=\"CustomerDesc\" placeholder=\"Customer Description\" [(ngModel)]=\"objCustomerDemographics.CustomerDesc\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"gotoCustomerDemographicsEdit()\">Edit</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoCustomerDemographics()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" (click)=\"deleteCustomerDemographics(objCustomerDemographics.CustomerTypeID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1038 */
/***/ function(module, exports) {

module.exports = "<h2>Edit CustomerDemographics</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">CustomerDemographics Edit</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CustomerTypeID.touched && CustomerTypeID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CustomerTypeID\" class=\"col-xs-3 col-sm-2 control-label\">Customertype Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CustomerTypeID=\"ngModel\" name=\"CustomerTypeID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Customertype Id\" [(ngModel)]=\"objCustomerDemographics.CustomerTypeID\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CustomerTypeID.touched && CustomerTypeID.invalid\">Customertype Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CustomerDesc.touched && CustomerDesc.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CustomerDesc\" class=\"col-xs-3 col-sm-2 control-label\">Customer Description:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<textarea #CustomerDesc=\"ngModel\" name=\"CustomerDesc\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Customer Description\" [(ngModel)]=\"objCustomerDemographics.CustomerDesc\"  rows=\"4\"> </textarea>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CustomerDesc.touched && CustomerDesc.invalid\">Customer Description is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"updateCustomerDemographics()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoCustomerDemographics()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" type=\"submit\" (click)=\"deleteCustomerDemographics(objCustomerDemographics.CustomerTypeID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1039 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>CustomerDemographics List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<CustomerDemographicsSearch (filterCriteria)=\"onSearch($event)\" ></CustomerDemographicsSearch>\r\n\t\t</div>\r\n\t</div>\r\n\t\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" routerLink=\"/CustomerDemographics/add\" routerLinkActive=\"active\" title=\"Add CustomerDemographics\"><i class=\"glyphicon glyphicon-plus\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Delete List(s)\"><i class=\"glyphicon glyphicon-remove\"></i></a-->\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr>\r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CustomerTypeID')\">Customertype Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CustomerDesc')\">Customer Description</a></th>\r\n\r\n\t\t</tr>\r\n\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of CustomerDemographicsList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelect(item)\">Edit</a>\r\n\t\t\t\t\t<a (click)=\"deleteCustomerDemographics(item.CustomerTypeID)\">Delete</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.CustomerTypeID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.CustomerDesc}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1040 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch CustomerDemographics\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CustomerTypeID.touched && CustomerTypeID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CustomerTypeID\" class=\"col-xs-3 col-sm-2 control-label\">Customertype Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CustomerTypeID=\"ngModel\" name=\"CustomerTypeID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Customertype Id\" [(ngModel)]=\"objCustomerDemographics.CustomerTypeID\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CustomerTypeID.touched && CustomerTypeID.invalid\">Customertype Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CustomerDesc.touched && CustomerDesc.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CustomerDesc\" class=\"col-xs-3 col-sm-2 control-label\">Customer Description:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<textarea #CustomerDesc=\"ngModel\" name=\"CustomerDesc\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Customer Description\" [(ngModel)]=\"objCustomerDemographics.CustomerDesc\"  rows=\"4\"> </textarea>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CustomerDesc.touched && CustomerDesc.invalid\">Customer Description is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1041 */
/***/ function(module, exports) {

module.exports = "<h2>CustomerandSuppliersbyCity Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">CustomerandSuppliersbyCity Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"City\" class=\"col-xs-3 col-sm-2 control-label\">City:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"City\" name=\"City\" placeholder=\"City\" [(ngModel)]=\"objCustomerandSuppliersbyCity.City\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CompanyName\" class=\"col-xs-3 col-sm-2 control-label\">Company Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CompanyName\" name=\"CompanyName\" placeholder=\"Company Name\" [(ngModel)]=\"objCustomerandSuppliersbyCity.CompanyName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ContactName\" class=\"col-xs-3 col-sm-2 control-label\">Contact Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ContactName\" name=\"ContactName\" placeholder=\"Contact Name\" [(ngModel)]=\"objCustomerandSuppliersbyCity.ContactName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Relationship\" class=\"col-xs-3 col-sm-2 control-label\">Relationship:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Relationship\" name=\"Relationship\" placeholder=\"Relationship\" [(ngModel)]=\"objCustomerandSuppliersbyCity.Relationship\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoCustomerandSuppliersbyCity()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1042 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>CustomerandSuppliersbyCity List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\t\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<CustomerandSuppliersbyCitySearch (filterCriteria)=\"onSearch($event)\" ></CustomerandSuppliersbyCitySearch>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}\r\n\t\t\t\t</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr> \r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'City')\">City</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CompanyName')\">Company Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ContactName')\">Contact Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Relationship')\">Relationship</a></th>\r\n\r\n\t\t</tr>\r\n\t\t\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of CustomerandSuppliersbyCityList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelectDetails(item)\">Details</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.City}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.CompanyName}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ContactName}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Relationship}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1043 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch CustomerandSuppliersbyCity\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"City.touched && City.invalid\" >\r\n\t\t\t\t\t\t<label for=\"City\" class=\"col-xs-3 col-sm-2 control-label\">City:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #City=\"ngModel\" name=\"City\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"City\" [(ngModel)]=\"objCustomerandSuppliersbyCity.City\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"City.touched && City.invalid\">City is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CompanyName.touched && CompanyName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CompanyName\" class=\"col-xs-3 col-sm-2 control-label\">Company Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CompanyName=\"ngModel\" name=\"CompanyName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Company Name\" [(ngModel)]=\"objCustomerandSuppliersbyCity.CompanyName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CompanyName.touched && CompanyName.invalid\">Company Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ContactName.touched && ContactName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ContactName\" class=\"col-xs-3 col-sm-2 control-label\">Contact Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ContactName=\"ngModel\" name=\"ContactName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Contact Name\" [(ngModel)]=\"objCustomerandSuppliersbyCity.ContactName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ContactName.touched && ContactName.invalid\">Contact Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Relationship.touched && Relationship.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Relationship\" class=\"col-xs-3 col-sm-2 control-label\">Relationship:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Relationship=\"ngModel\" name=\"Relationship\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Relationship\" [(ngModel)]=\"objCustomerandSuppliersbyCity.Relationship\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Relationship.touched && Relationship.invalid\">Relationship is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1044 */
/***/ function(module, exports) {

module.exports = "<h2>Add Customers</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Customers Add</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CustomerID.touched && CustomerID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CustomerID\" class=\"col-xs-3 col-sm-2 control-label\">Customer Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CustomerID=\"ngModel\" name=\"CustomerID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Customer Id\" [(ngModel)]=\"objCustomers.CustomerID\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CustomerID.touched && CustomerID.invalid\">Customer Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CompanyName.touched && CompanyName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CompanyName\" class=\"col-xs-3 col-sm-2 control-label\">Company Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CompanyName=\"ngModel\" name=\"CompanyName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Company Name\" [(ngModel)]=\"objCustomers.CompanyName\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CompanyName.touched && CompanyName.invalid\">Company Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ContactName.touched && ContactName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ContactName\" class=\"col-xs-3 col-sm-2 control-label\">Contact Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ContactName=\"ngModel\" name=\"ContactName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Contact Name\" [(ngModel)]=\"objCustomers.ContactName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ContactName.touched && ContactName.invalid\">Contact Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ContactTitle.touched && ContactTitle.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ContactTitle\" class=\"col-xs-3 col-sm-2 control-label\">Contact Title:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ContactTitle=\"ngModel\" name=\"ContactTitle\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Contact Title\" [(ngModel)]=\"objCustomers.ContactTitle\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ContactTitle.touched && ContactTitle.invalid\">Contact Title is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Address.touched && Address.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Address\" class=\"col-xs-3 col-sm-2 control-label\">Address:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Address=\"ngModel\" name=\"Address\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Address\" [(ngModel)]=\"objCustomers.Address\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Address.touched && Address.invalid\">Address is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"City.touched && City.invalid\" >\r\n\t\t\t\t\t\t<label for=\"City\" class=\"col-xs-3 col-sm-2 control-label\">City:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #City=\"ngModel\" name=\"City\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"City\" [(ngModel)]=\"objCustomers.City\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"City.touched && City.invalid\">City is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Region.touched && Region.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Region\" class=\"col-xs-3 col-sm-2 control-label\">Region:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Region=\"ngModel\" name=\"Region\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Region\" [(ngModel)]=\"objCustomers.Region\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Region.touched && Region.invalid\">Region is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"PostalCode.touched && PostalCode.invalid\" >\r\n\t\t\t\t\t\t<label for=\"PostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Postal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #PostalCode=\"ngModel\" name=\"PostalCode\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Postal Code\" [(ngModel)]=\"objCustomers.PostalCode\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"PostalCode.touched && PostalCode.invalid\">Postal Code is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Country.touched && Country.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Country\" class=\"col-xs-3 col-sm-2 control-label\">Country:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Country=\"ngModel\" name=\"Country\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Country\" [(ngModel)]=\"objCustomers.Country\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Country.touched && Country.invalid\">Country is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Phone.touched && Phone.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Phone\" class=\"col-xs-3 col-sm-2 control-label\">Phone:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Phone=\"ngModel\" name=\"Phone\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Phone\" [(ngModel)]=\"objCustomers.Phone\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Phone.touched && Phone.invalid\">Phone is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Fax.touched && Fax.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Fax\" class=\"col-xs-3 col-sm-2 control-label\">Fax:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Fax=\"ngModel\" name=\"Fax\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Fax\" [(ngModel)]=\"objCustomers.Fax\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Fax.touched && Fax.invalid\">Fax is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"addCustomers()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoCustomers()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1045 */
/***/ function(module, exports) {

module.exports = "<h2>Customers Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Customers Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CustomerID\" class=\"col-xs-3 col-sm-2 control-label\">Customer Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CustomerID\" name=\"CustomerID\" placeholder=\"Customer Id\" [(ngModel)]=\"objCustomers.CustomerID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CompanyName\" class=\"col-xs-3 col-sm-2 control-label\">Company Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CompanyName\" name=\"CompanyName\" placeholder=\"Company Name\" [(ngModel)]=\"objCustomers.CompanyName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ContactName\" class=\"col-xs-3 col-sm-2 control-label\">Contact Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ContactName\" name=\"ContactName\" placeholder=\"Contact Name\" [(ngModel)]=\"objCustomers.ContactName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ContactTitle\" class=\"col-xs-3 col-sm-2 control-label\">Contact Title:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ContactTitle\" name=\"ContactTitle\" placeholder=\"Contact Title\" [(ngModel)]=\"objCustomers.ContactTitle\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Address\" class=\"col-xs-3 col-sm-2 control-label\">Address:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Address\" name=\"Address\" placeholder=\"Address\" [(ngModel)]=\"objCustomers.Address\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"City\" class=\"col-xs-3 col-sm-2 control-label\">City:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"City\" name=\"City\" placeholder=\"City\" [(ngModel)]=\"objCustomers.City\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Region\" class=\"col-xs-3 col-sm-2 control-label\">Region:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Region\" name=\"Region\" placeholder=\"Region\" [(ngModel)]=\"objCustomers.Region\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"PostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Postal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"PostalCode\" name=\"PostalCode\" placeholder=\"Postal Code\" [(ngModel)]=\"objCustomers.PostalCode\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Country\" class=\"col-xs-3 col-sm-2 control-label\">Country:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Country\" name=\"Country\" placeholder=\"Country\" [(ngModel)]=\"objCustomers.Country\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Phone\" class=\"col-xs-3 col-sm-2 control-label\">Phone:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Phone\" name=\"Phone\" placeholder=\"Phone\" [(ngModel)]=\"objCustomers.Phone\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Fax\" class=\"col-xs-3 col-sm-2 control-label\">Fax:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Fax\" name=\"Fax\" placeholder=\"Fax\" [(ngModel)]=\"objCustomers.Fax\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"gotoCustomersEdit()\">Edit</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoCustomers()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" (click)=\"deleteCustomers(objCustomers.CustomerID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1046 */
/***/ function(module, exports) {

module.exports = "<h2>Edit Customers</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Customers Edit</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CustomerID.touched && CustomerID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CustomerID\" class=\"col-xs-3 col-sm-2 control-label\">Customer Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CustomerID=\"ngModel\" name=\"CustomerID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Customer Id\" [(ngModel)]=\"objCustomers.CustomerID\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CustomerID.touched && CustomerID.invalid\">Customer Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CompanyName.touched && CompanyName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CompanyName\" class=\"col-xs-3 col-sm-2 control-label\">Company Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CompanyName=\"ngModel\" name=\"CompanyName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Company Name\" [(ngModel)]=\"objCustomers.CompanyName\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CompanyName.touched && CompanyName.invalid\">Company Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ContactName.touched && ContactName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ContactName\" class=\"col-xs-3 col-sm-2 control-label\">Contact Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ContactName=\"ngModel\" name=\"ContactName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Contact Name\" [(ngModel)]=\"objCustomers.ContactName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ContactName.touched && ContactName.invalid\">Contact Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ContactTitle.touched && ContactTitle.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ContactTitle\" class=\"col-xs-3 col-sm-2 control-label\">Contact Title:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ContactTitle=\"ngModel\" name=\"ContactTitle\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Contact Title\" [(ngModel)]=\"objCustomers.ContactTitle\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ContactTitle.touched && ContactTitle.invalid\">Contact Title is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Address.touched && Address.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Address\" class=\"col-xs-3 col-sm-2 control-label\">Address:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Address=\"ngModel\" name=\"Address\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Address\" [(ngModel)]=\"objCustomers.Address\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Address.touched && Address.invalid\">Address is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"City.touched && City.invalid\" >\r\n\t\t\t\t\t\t<label for=\"City\" class=\"col-xs-3 col-sm-2 control-label\">City:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #City=\"ngModel\" name=\"City\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"City\" [(ngModel)]=\"objCustomers.City\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"City.touched && City.invalid\">City is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Region.touched && Region.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Region\" class=\"col-xs-3 col-sm-2 control-label\">Region:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Region=\"ngModel\" name=\"Region\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Region\" [(ngModel)]=\"objCustomers.Region\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Region.touched && Region.invalid\">Region is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"PostalCode.touched && PostalCode.invalid\" >\r\n\t\t\t\t\t\t<label for=\"PostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Postal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #PostalCode=\"ngModel\" name=\"PostalCode\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Postal Code\" [(ngModel)]=\"objCustomers.PostalCode\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"PostalCode.touched && PostalCode.invalid\">Postal Code is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Country.touched && Country.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Country\" class=\"col-xs-3 col-sm-2 control-label\">Country:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Country=\"ngModel\" name=\"Country\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Country\" [(ngModel)]=\"objCustomers.Country\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Country.touched && Country.invalid\">Country is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Phone.touched && Phone.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Phone\" class=\"col-xs-3 col-sm-2 control-label\">Phone:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Phone=\"ngModel\" name=\"Phone\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Phone\" [(ngModel)]=\"objCustomers.Phone\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Phone.touched && Phone.invalid\">Phone is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Fax.touched && Fax.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Fax\" class=\"col-xs-3 col-sm-2 control-label\">Fax:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Fax=\"ngModel\" name=\"Fax\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Fax\" [(ngModel)]=\"objCustomers.Fax\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Fax.touched && Fax.invalid\">Fax is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"updateCustomers()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoCustomers()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" type=\"submit\" (click)=\"deleteCustomers(objCustomers.CustomerID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1047 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>Customers List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<CustomersSearch (filterCriteria)=\"onSearch($event)\" ></CustomersSearch>\r\n\t\t</div>\r\n\t</div>\r\n\t\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" routerLink=\"/Customers/add\" routerLinkActive=\"active\" title=\"Add Customers\"><i class=\"glyphicon glyphicon-plus\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Delete List(s)\"><i class=\"glyphicon glyphicon-remove\"></i></a-->\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr>\r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CustomerID')\">Customer Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CompanyName')\">Company Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ContactName')\">Contact Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ContactTitle')\">Contact Title</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Address')\">Address</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'City')\">City</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Region')\">Region</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'PostalCode')\">Postal Code</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Country')\">Country</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Phone')\">Phone</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Fax')\">Fax</a></th>\r\n\r\n\t\t</tr>\r\n\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of CustomersList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelect(item)\">Edit</a>\r\n\t\t\t\t\t<a (click)=\"deleteCustomers(item.CustomerID)\">Delete</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.CustomerID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.CompanyName}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ContactName}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ContactTitle}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Address}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.City}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Region}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.PostalCode}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Country}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Phone}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Fax}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1048 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch Customers\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CustomerID.touched && CustomerID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CustomerID\" class=\"col-xs-3 col-sm-2 control-label\">Customer Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CustomerID=\"ngModel\" name=\"CustomerID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Customer Id\" [(ngModel)]=\"objCustomers.CustomerID\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CustomerID.touched && CustomerID.invalid\">Customer Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CompanyName.touched && CompanyName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CompanyName\" class=\"col-xs-3 col-sm-2 control-label\">Company Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CompanyName=\"ngModel\" name=\"CompanyName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Company Name\" [(ngModel)]=\"objCustomers.CompanyName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CompanyName.touched && CompanyName.invalid\">Company Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ContactName.touched && ContactName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ContactName\" class=\"col-xs-3 col-sm-2 control-label\">Contact Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ContactName=\"ngModel\" name=\"ContactName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Contact Name\" [(ngModel)]=\"objCustomers.ContactName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ContactName.touched && ContactName.invalid\">Contact Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ContactTitle.touched && ContactTitle.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ContactTitle\" class=\"col-xs-3 col-sm-2 control-label\">Contact Title:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ContactTitle=\"ngModel\" name=\"ContactTitle\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Contact Title\" [(ngModel)]=\"objCustomers.ContactTitle\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ContactTitle.touched && ContactTitle.invalid\">Contact Title is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Address.touched && Address.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Address\" class=\"col-xs-3 col-sm-2 control-label\">Address:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Address=\"ngModel\" name=\"Address\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Address\" [(ngModel)]=\"objCustomers.Address\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Address.touched && Address.invalid\">Address is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"City.touched && City.invalid\" >\r\n\t\t\t\t\t\t<label for=\"City\" class=\"col-xs-3 col-sm-2 control-label\">City:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #City=\"ngModel\" name=\"City\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"City\" [(ngModel)]=\"objCustomers.City\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"City.touched && City.invalid\">City is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Region.touched && Region.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Region\" class=\"col-xs-3 col-sm-2 control-label\">Region:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Region=\"ngModel\" name=\"Region\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Region\" [(ngModel)]=\"objCustomers.Region\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Region.touched && Region.invalid\">Region is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"PostalCode.touched && PostalCode.invalid\" >\r\n\t\t\t\t\t\t<label for=\"PostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Postal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #PostalCode=\"ngModel\" name=\"PostalCode\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Postal Code\" [(ngModel)]=\"objCustomers.PostalCode\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"PostalCode.touched && PostalCode.invalid\">Postal Code is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Country.touched && Country.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Country\" class=\"col-xs-3 col-sm-2 control-label\">Country:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Country=\"ngModel\" name=\"Country\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Country\" [(ngModel)]=\"objCustomers.Country\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Country.touched && Country.invalid\">Country is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Phone.touched && Phone.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Phone\" class=\"col-xs-3 col-sm-2 control-label\">Phone:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Phone=\"ngModel\" name=\"Phone\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Phone\" [(ngModel)]=\"objCustomers.Phone\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Phone.touched && Phone.invalid\">Phone is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Fax.touched && Fax.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Fax\" class=\"col-xs-3 col-sm-2 control-label\">Fax:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Fax=\"ngModel\" name=\"Fax\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Fax\" [(ngModel)]=\"objCustomers.Fax\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Fax.touched && Fax.invalid\">Fax is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1049 */
/***/ function(module, exports) {

module.exports = "<h2>Add EmployeeTerritories</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">EmployeeTerritories Add</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"EmployeeID.touched && EmployeeID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"EmployeeID\" class=\"col-xs-3 col-sm-2 control-label\">Employee Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #EmployeeID=\"ngModel\" name=\"EmployeeID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Employee Id\" [(ngModel)]=\"objEmployeeTerritories.EmployeeID\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"EmployeeID.touched && EmployeeID.invalid\">Employee Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Territory Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"TerritoryID\" name=\"TerritoryID\" class=\"form-control\" [(ngModel)]=\"objEmployeeTerritories.TerritoryID\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objEmployeeTerritories.TerritoryID\" *ngIf=\"!objEmployeeTerritories.TerritoryID\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of TerritoriesList\" [value]=\"item.TerritoryID\">\r\n\t\t\t\t\t\t\t\t\t{{item.TerritoryDescription}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"addEmployeeTerritories()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoEmployeeTerritories()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1050 */
/***/ function(module, exports) {

module.exports = "<h2>EmployeeTerritories Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">EmployeeTerritories Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"EmployeeID\" class=\"col-xs-3 col-sm-2 control-label\">Employee Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"EmployeeID\" name=\"EmployeeID\" placeholder=\"Employee Id\" [(ngModel)]=\"objEmployeeTerritories.EmployeeID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"TerritoryID\" class=\"col-xs-3 col-sm-2 control-label\">Territory Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"TerritoryID\" name=\"TerritoryID\" placeholder=\"Territory Id\" [(ngModel)]=\"objEmployeeTerritories.TerritoryID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"gotoEmployeeTerritoriesEdit()\">Edit</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoEmployeeTerritories()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" (click)=\"deleteEmployeeTerritories(objEmployeeTerritories.EmployeeID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1051 */
/***/ function(module, exports) {

module.exports = "<h2>Edit EmployeeTerritories</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">EmployeeTerritories Edit</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"EmployeeID.touched && EmployeeID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"EmployeeID\" class=\"col-xs-3 col-sm-2 control-label\">Employee Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #EmployeeID=\"ngModel\" name=\"EmployeeID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Employee Id\" [(ngModel)]=\"objEmployeeTerritories.EmployeeID\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"EmployeeID.touched && EmployeeID.invalid\">Employee Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Territory Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"TerritoryID\" name=\"TerritoryID\" class=\"form-control\" [(ngModel)]=\"objEmployeeTerritories.TerritoryID\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objEmployeeTerritories.TerritoryID\" *ngIf=\"!objEmployeeTerritories.TerritoryID\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of TerritoriesList\" [value]=\"item.TerritoryID\">\r\n\t\t\t\t\t\t\t\t\t{{item.TerritoryDescription}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"updateEmployeeTerritories()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoEmployeeTerritories()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" type=\"submit\" (click)=\"deleteEmployeeTerritories(objEmployeeTerritories.EmployeeID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1052 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>EmployeeTerritories List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<EmployeeTerritoriesSearch (filterCriteria)=\"onSearch($event)\" ></EmployeeTerritoriesSearch>\r\n\t\t</div>\r\n\t</div>\r\n\t\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" routerLink=\"/EmployeeTerritories/add\" routerLinkActive=\"active\" title=\"Add EmployeeTerritories\"><i class=\"glyphicon glyphicon-plus\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Delete List(s)\"><i class=\"glyphicon glyphicon-remove\"></i></a-->\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr>\r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'EmployeeID')\">Employee Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'TerritoryID')\">Territory Id</a></th>\r\n\r\n\t\t</tr>\r\n\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of EmployeeTerritoriesList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelect(item)\">Edit</a>\r\n\t\t\t\t\t<a (click)=\"deleteEmployeeTerritories(item.EmployeeID)\">Delete</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.EmployeeID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.TerritoryID}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1053 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch EmployeeTerritories\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"EmployeeID.touched && EmployeeID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"EmployeeID\" class=\"col-xs-3 col-sm-2 control-label\">Employee Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #EmployeeID=\"ngModel\" name=\"EmployeeID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Employee Id\" [(ngModel)]=\"objEmployeeTerritories.EmployeeID\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"EmployeeID.touched && EmployeeID.invalid\">Employee Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Territory Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"TerritoryID\" name=\"TerritoryID\" class=\"form-control\" [(ngModel)]=\"objEmployeeTerritories.TerritoryID\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objEmployeeTerritories.TerritoryID\" *ngIf=\"!objEmployeeTerritories.TerritoryID\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of TerritoriesList\" [value]=\"item.TerritoryID\">\r\n\t\t\t\t\t\t\t\t\t{{item.TerritoryDescription}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1054 */
/***/ function(module, exports) {

module.exports = "<h2>Add Employees</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Employees Add</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"EmployeeID.touched && EmployeeID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"EmployeeID\" class=\"col-xs-3 col-sm-2 control-label\">Employee Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #EmployeeID=\"ngModel\" name=\"EmployeeID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Employee Id\" [(ngModel)]=\"objEmployees.EmployeeID\" pattern=\"^(0|[1-9][0-9]*)$\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"EmployeeID.touched && EmployeeID.invalid\">Employee Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"LastName.touched && LastName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"LastName\" class=\"col-xs-3 col-sm-2 control-label\">Last Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #LastName=\"ngModel\" name=\"LastName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Last Name\" [(ngModel)]=\"objEmployees.LastName\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"LastName.touched && LastName.invalid\">Last Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"FirstName.touched && FirstName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"FirstName\" class=\"col-xs-3 col-sm-2 control-label\">First Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #FirstName=\"ngModel\" name=\"FirstName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"First Name\" [(ngModel)]=\"objEmployees.FirstName\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"FirstName.touched && FirstName.invalid\">First Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Title.touched && Title.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Title\" class=\"col-xs-3 col-sm-2 control-label\">Title:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Title=\"ngModel\" name=\"Title\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Title\" [(ngModel)]=\"objEmployees.Title\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Title.touched && Title.invalid\">Title is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"TitleOfCourtesy.touched && TitleOfCourtesy.invalid\" >\r\n\t\t\t\t\t\t<label for=\"TitleOfCourtesy\" class=\"col-xs-3 col-sm-2 control-label\">Titleofcourtesy:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #TitleOfCourtesy=\"ngModel\" name=\"TitleOfCourtesy\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Titleofcourtesy\" [(ngModel)]=\"objEmployees.TitleOfCourtesy\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"TitleOfCourtesy.touched && TitleOfCourtesy.invalid\">Titleofcourtesy is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"BirthDate.touched && BirthDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"BirthDate\" class=\"col-xs-3 col-sm-2 control-label\">Birth Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<datepicker-dropdown #BirthDate=\"ngModel\" [control]=\"BirthDate\"  \r\n\t\t\t\t\t\t\t\t\t[(ngModel)]=\"objEmployees.BirthDate\" name=\"BirthDate\" [required]=\"true\" ></datepicker-dropdown>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"BirthDate.touched && BirthDate.errors && BirthDate.errors.required\">Birth Date is required.</div>\r\n\t\t\t\t\t\t\t<!--\r\n\t\t\t\t\t\t\t<input #BirthDate=\"ngModel\" name=\"BirthDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Birth Date\" [(ngModel)]=\"objEmployees.BirthDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"BirthDate.touched && BirthDate.invalid\">Birth Date is required.</div>\r\n\t\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"HireDate.touched && HireDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"HireDate\" class=\"col-xs-3 col-sm-2 control-label\">Hire Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<datepicker-dropdown #HireDate=\"ngModel\" [control]=\"HireDate\"  \r\n\t\t\t\t\t\t\t\t\t[(ngModel)]=\"objEmployees.HireDate\" name=\"HireDate\" [required]=\"true\" ></datepicker-dropdown>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"HireDate.touched && HireDate.errors && HireDate.errors.required\">Hire Date is required.</div>\r\n\t\t\t\t\t\t\t<!--\r\n\t\t\t\t\t\t\t<input #HireDate=\"ngModel\" name=\"HireDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Hire Date\" [(ngModel)]=\"objEmployees.HireDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"HireDate.touched && HireDate.invalid\">Hire Date is required.</div>\r\n\t\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Address.touched && Address.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Address\" class=\"col-xs-3 col-sm-2 control-label\">Address:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Address=\"ngModel\" name=\"Address\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Address\" [(ngModel)]=\"objEmployees.Address\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Address.touched && Address.invalid\">Address is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"City.touched && City.invalid\" >\r\n\t\t\t\t\t\t<label for=\"City\" class=\"col-xs-3 col-sm-2 control-label\">City:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #City=\"ngModel\" name=\"City\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"City\" [(ngModel)]=\"objEmployees.City\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"City.touched && City.invalid\">City is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Region.touched && Region.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Region\" class=\"col-xs-3 col-sm-2 control-label\">Region:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Region=\"ngModel\" name=\"Region\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Region\" [(ngModel)]=\"objEmployees.Region\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Region.touched && Region.invalid\">Region is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"PostalCode.touched && PostalCode.invalid\" >\r\n\t\t\t\t\t\t<label for=\"PostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Postal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #PostalCode=\"ngModel\" name=\"PostalCode\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Postal Code\" [(ngModel)]=\"objEmployees.PostalCode\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"PostalCode.touched && PostalCode.invalid\">Postal Code is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Country.touched && Country.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Country\" class=\"col-xs-3 col-sm-2 control-label\">Country:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Country=\"ngModel\" name=\"Country\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Country\" [(ngModel)]=\"objEmployees.Country\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Country.touched && Country.invalid\">Country is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"HomePhone.touched && HomePhone.invalid\" >\r\n\t\t\t\t\t\t<label for=\"HomePhone\" class=\"col-xs-3 col-sm-2 control-label\">Homephone:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #HomePhone=\"ngModel\" name=\"HomePhone\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Homephone\" [(ngModel)]=\"objEmployees.HomePhone\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"HomePhone.touched && HomePhone.invalid\">Homephone is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Extension.touched && Extension.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Extension\" class=\"col-xs-3 col-sm-2 control-label\">Extension:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Extension=\"ngModel\" name=\"Extension\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Extension\" [(ngModel)]=\"objEmployees.Extension\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Extension.touched && Extension.invalid\">Extension is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Photo.touched && Photo.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Photo\" class=\"col-xs-3 col-sm-2 control-label\">Photo:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Photo=\"ngModel\" name=\"Photo\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Photo\" [(ngModel)]=\"objEmployees.Photo\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Photo.touched && Photo.invalid\">Photo must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Notes.touched && Notes.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Notes\" class=\"col-xs-3 col-sm-2 control-label\">Notes:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<textarea #Notes=\"ngModel\" name=\"Notes\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Notes\" [(ngModel)]=\"objEmployees.Notes\"  rows=\"4\"> </textarea>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Notes.touched && Notes.invalid\">Notes is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Reportsto:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"ReportsTo\" name=\"ReportsTo\" class=\"form-control\" [(ngModel)]=\"objEmployees.ReportsTo\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objEmployees.ReportsTo\" *ngIf=\"!objEmployees.ReportsTo\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of EmployeesList\" [value]=\"item.EmployeeID\">\r\n\t\t\t\t\t\t\t\t\t{{item.LastName}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"PhotoPath.touched && PhotoPath.invalid\" >\r\n\t\t\t\t\t\t<label for=\"PhotoPath\" class=\"col-xs-3 col-sm-2 control-label\">Photopath:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<textarea #PhotoPath=\"ngModel\" name=\"PhotoPath\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Photopath\" [(ngModel)]=\"objEmployees.PhotoPath\"  rows=\"4\"> </textarea>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"PhotoPath.touched && PhotoPath.invalid\">Photopath is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"addEmployees()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoEmployees()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1055 */
/***/ function(module, exports) {

module.exports = "<h2>Employees Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Employees Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"EmployeeID\" class=\"col-xs-3 col-sm-2 control-label\">Employee Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"EmployeeID\" name=\"EmployeeID\" placeholder=\"Employee Id\" [(ngModel)]=\"objEmployees.EmployeeID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"LastName\" class=\"col-xs-3 col-sm-2 control-label\">Last Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"LastName\" name=\"LastName\" placeholder=\"Last Name\" [(ngModel)]=\"objEmployees.LastName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"FirstName\" class=\"col-xs-3 col-sm-2 control-label\">First Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"FirstName\" name=\"FirstName\" placeholder=\"First Name\" [(ngModel)]=\"objEmployees.FirstName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Title\" class=\"col-xs-3 col-sm-2 control-label\">Title:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Title\" name=\"Title\" placeholder=\"Title\" [(ngModel)]=\"objEmployees.Title\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"TitleOfCourtesy\" class=\"col-xs-3 col-sm-2 control-label\">Titleofcourtesy:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"TitleOfCourtesy\" name=\"TitleOfCourtesy\" placeholder=\"Titleofcourtesy\" [(ngModel)]=\"objEmployees.TitleOfCourtesy\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"BirthDate\" class=\"col-xs-3 col-sm-2 control-label\">Birth Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"BirthDate\" name=\"BirthDate\" placeholder=\"Birth Date\" [(ngModel)]=\"objEmployees.BirthDate\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"HireDate\" class=\"col-xs-3 col-sm-2 control-label\">Hire Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"HireDate\" name=\"HireDate\" placeholder=\"Hire Date\" [(ngModel)]=\"objEmployees.HireDate\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Address\" class=\"col-xs-3 col-sm-2 control-label\">Address:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Address\" name=\"Address\" placeholder=\"Address\" [(ngModel)]=\"objEmployees.Address\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"City\" class=\"col-xs-3 col-sm-2 control-label\">City:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"City\" name=\"City\" placeholder=\"City\" [(ngModel)]=\"objEmployees.City\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Region\" class=\"col-xs-3 col-sm-2 control-label\">Region:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Region\" name=\"Region\" placeholder=\"Region\" [(ngModel)]=\"objEmployees.Region\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"PostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Postal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"PostalCode\" name=\"PostalCode\" placeholder=\"Postal Code\" [(ngModel)]=\"objEmployees.PostalCode\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Country\" class=\"col-xs-3 col-sm-2 control-label\">Country:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Country\" name=\"Country\" placeholder=\"Country\" [(ngModel)]=\"objEmployees.Country\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"HomePhone\" class=\"col-xs-3 col-sm-2 control-label\">Homephone:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"HomePhone\" name=\"HomePhone\" placeholder=\"Homephone\" [(ngModel)]=\"objEmployees.HomePhone\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Extension\" class=\"col-xs-3 col-sm-2 control-label\">Extension:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Extension\" name=\"Extension\" placeholder=\"Extension\" [(ngModel)]=\"objEmployees.Extension\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Photo\" class=\"col-xs-3 col-sm-2 control-label\">Photo:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Photo\" name=\"Photo\" placeholder=\"Photo\" [(ngModel)]=\"objEmployees.Photo\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Notes\" class=\"col-xs-3 col-sm-2 control-label\">Notes:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Notes\" name=\"Notes\" placeholder=\"Notes\" [(ngModel)]=\"objEmployees.Notes\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ReportsTo\" class=\"col-xs-3 col-sm-2 control-label\">Reportsto:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ReportsTo\" name=\"ReportsTo\" placeholder=\"Reportsto\" [(ngModel)]=\"objEmployees.ReportsTo\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"PhotoPath\" class=\"col-xs-3 col-sm-2 control-label\">Photopath:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"PhotoPath\" name=\"PhotoPath\" placeholder=\"Photopath\" [(ngModel)]=\"objEmployees.PhotoPath\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"gotoEmployeesEdit()\">Edit</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoEmployees()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" (click)=\"deleteEmployees(objEmployees.EmployeeID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1056 */
/***/ function(module, exports) {

module.exports = "<h2>Edit Employees</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Employees Edit</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"EmployeeID.touched && EmployeeID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"EmployeeID\" class=\"col-xs-3 col-sm-2 control-label\">Employee Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #EmployeeID=\"ngModel\" name=\"EmployeeID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Employee Id\" [(ngModel)]=\"objEmployees.EmployeeID\" pattern=\"^(0|[1-9][0-9]*)$\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"EmployeeID.touched && EmployeeID.invalid\">Employee Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"LastName.touched && LastName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"LastName\" class=\"col-xs-3 col-sm-2 control-label\">Last Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #LastName=\"ngModel\" name=\"LastName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Last Name\" [(ngModel)]=\"objEmployees.LastName\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"LastName.touched && LastName.invalid\">Last Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"FirstName.touched && FirstName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"FirstName\" class=\"col-xs-3 col-sm-2 control-label\">First Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #FirstName=\"ngModel\" name=\"FirstName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"First Name\" [(ngModel)]=\"objEmployees.FirstName\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"FirstName.touched && FirstName.invalid\">First Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Title.touched && Title.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Title\" class=\"col-xs-3 col-sm-2 control-label\">Title:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Title=\"ngModel\" name=\"Title\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Title\" [(ngModel)]=\"objEmployees.Title\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Title.touched && Title.invalid\">Title is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"TitleOfCourtesy.touched && TitleOfCourtesy.invalid\" >\r\n\t\t\t\t\t\t<label for=\"TitleOfCourtesy\" class=\"col-xs-3 col-sm-2 control-label\">Titleofcourtesy:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #TitleOfCourtesy=\"ngModel\" name=\"TitleOfCourtesy\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Titleofcourtesy\" [(ngModel)]=\"objEmployees.TitleOfCourtesy\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"TitleOfCourtesy.touched && TitleOfCourtesy.invalid\">Titleofcourtesy is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"BirthDate.touched && BirthDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"BirthDate\" class=\"col-xs-3 col-sm-2 control-label\">Birth Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<datepicker-dropdown #BirthDate=\"ngModel\" [control]=\"BirthDate\"  \r\n\t\t\t\t\t\t\t\t\t[(ngModel)]=\"objEmployees.BirthDate\" name=\"BirthDate\" [required]=\"true\" ></datepicker-dropdown>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"BirthDate.touched && BirthDate.errors && BirthDate.errors.required\">Birth Date is required.</div>\r\n\t\t\t\t\t\t\t<!--\r\n\t\t\t\t\t\t\t<input #BirthDate=\"ngModel\" name=\"BirthDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Birth Date\" [(ngModel)]=\"objEmployees.BirthDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"BirthDate.touched && BirthDate.invalid\">Birth Date is required.</div>\r\n\t\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"HireDate.touched && HireDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"HireDate\" class=\"col-xs-3 col-sm-2 control-label\">Hire Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<datepicker-dropdown #HireDate=\"ngModel\" [control]=\"HireDate\"  \r\n\t\t\t\t\t\t\t\t\t[(ngModel)]=\"objEmployees.HireDate\" name=\"HireDate\" [required]=\"true\" ></datepicker-dropdown>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"HireDate.touched && HireDate.errors && HireDate.errors.required\">Hire Date is required.</div>\r\n\t\t\t\t\t\t\t<!--\r\n\t\t\t\t\t\t\t<input #HireDate=\"ngModel\" name=\"HireDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Hire Date\" [(ngModel)]=\"objEmployees.HireDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"HireDate.touched && HireDate.invalid\">Hire Date is required.</div>\r\n\t\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Address.touched && Address.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Address\" class=\"col-xs-3 col-sm-2 control-label\">Address:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Address=\"ngModel\" name=\"Address\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Address\" [(ngModel)]=\"objEmployees.Address\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Address.touched && Address.invalid\">Address is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"City.touched && City.invalid\" >\r\n\t\t\t\t\t\t<label for=\"City\" class=\"col-xs-3 col-sm-2 control-label\">City:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #City=\"ngModel\" name=\"City\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"City\" [(ngModel)]=\"objEmployees.City\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"City.touched && City.invalid\">City is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Region.touched && Region.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Region\" class=\"col-xs-3 col-sm-2 control-label\">Region:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Region=\"ngModel\" name=\"Region\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Region\" [(ngModel)]=\"objEmployees.Region\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Region.touched && Region.invalid\">Region is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"PostalCode.touched && PostalCode.invalid\" >\r\n\t\t\t\t\t\t<label for=\"PostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Postal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #PostalCode=\"ngModel\" name=\"PostalCode\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Postal Code\" [(ngModel)]=\"objEmployees.PostalCode\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"PostalCode.touched && PostalCode.invalid\">Postal Code is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Country.touched && Country.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Country\" class=\"col-xs-3 col-sm-2 control-label\">Country:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Country=\"ngModel\" name=\"Country\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Country\" [(ngModel)]=\"objEmployees.Country\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Country.touched && Country.invalid\">Country is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"HomePhone.touched && HomePhone.invalid\" >\r\n\t\t\t\t\t\t<label for=\"HomePhone\" class=\"col-xs-3 col-sm-2 control-label\">Homephone:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #HomePhone=\"ngModel\" name=\"HomePhone\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Homephone\" [(ngModel)]=\"objEmployees.HomePhone\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"HomePhone.touched && HomePhone.invalid\">Homephone is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Extension.touched && Extension.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Extension\" class=\"col-xs-3 col-sm-2 control-label\">Extension:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Extension=\"ngModel\" name=\"Extension\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Extension\" [(ngModel)]=\"objEmployees.Extension\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Extension.touched && Extension.invalid\">Extension is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Photo.touched && Photo.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Photo\" class=\"col-xs-3 col-sm-2 control-label\">Photo:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Photo=\"ngModel\" name=\"Photo\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Photo\" [(ngModel)]=\"objEmployees.Photo\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Photo.touched && Photo.invalid\">Photo must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Notes.touched && Notes.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Notes\" class=\"col-xs-3 col-sm-2 control-label\">Notes:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<textarea #Notes=\"ngModel\" name=\"Notes\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Notes\" [(ngModel)]=\"objEmployees.Notes\"  rows=\"4\"> </textarea>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Notes.touched && Notes.invalid\">Notes is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Reportsto:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"ReportsTo\" name=\"ReportsTo\" class=\"form-control\" [(ngModel)]=\"objEmployees.ReportsTo\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objEmployees.ReportsTo\" *ngIf=\"!objEmployees.ReportsTo\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of EmployeesList\" [value]=\"item.EmployeeID\">\r\n\t\t\t\t\t\t\t\t\t{{item.LastName}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"PhotoPath.touched && PhotoPath.invalid\" >\r\n\t\t\t\t\t\t<label for=\"PhotoPath\" class=\"col-xs-3 col-sm-2 control-label\">Photopath:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<textarea #PhotoPath=\"ngModel\" name=\"PhotoPath\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Photopath\" [(ngModel)]=\"objEmployees.PhotoPath\"  rows=\"4\"> </textarea>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"PhotoPath.touched && PhotoPath.invalid\">Photopath is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"updateEmployees()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoEmployees()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" type=\"submit\" (click)=\"deleteEmployees(objEmployees.EmployeeID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1057 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>Employees List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<EmployeesSearch (filterCriteria)=\"onSearch($event)\" ></EmployeesSearch>\r\n\t\t</div>\r\n\t</div>\r\n\t\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" routerLink=\"/Employees/add\" routerLinkActive=\"active\" title=\"Add Employees\"><i class=\"glyphicon glyphicon-plus\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Delete List(s)\"><i class=\"glyphicon glyphicon-remove\"></i></a-->\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr>\r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'EmployeeID')\">Employee Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'LastName')\">Last Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'FirstName')\">First Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Title')\">Title</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'TitleOfCourtesy')\">Titleofcourtesy</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'BirthDate')\">Birth Date</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'HireDate')\">Hire Date</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Address')\">Address</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'City')\">City</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Region')\">Region</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'PostalCode')\">Postal Code</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Country')\">Country</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'HomePhone')\">Homephone</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Extension')\">Extension</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Notes')\">Notes</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ReportsTo')\">Reportsto</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'PhotoPath')\">Photopath</a></th>\r\n\r\n\t\t</tr>\r\n\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of EmployeesList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelect(item)\">Edit</a>\r\n\t\t\t\t\t<a (click)=\"deleteEmployees(item.EmployeeID)\">Delete</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.EmployeeID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.LastName}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.FirstName}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Title}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.TitleOfCourtesy}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.BirthDate}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.HireDate}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Address}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.City}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Region}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.PostalCode}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Country}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.HomePhone}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Extension}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Notes}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.ReportsTo}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.PhotoPath}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1058 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch Employees\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"EmployeeID.touched && EmployeeID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"EmployeeID\" class=\"col-xs-3 col-sm-2 control-label\">Employee Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #EmployeeID=\"ngModel\" name=\"EmployeeID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Employee Id\" [(ngModel)]=\"objEmployees.EmployeeID\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"EmployeeID.touched && EmployeeID.invalid\">Employee Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"LastName.touched && LastName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"LastName\" class=\"col-xs-3 col-sm-2 control-label\">Last Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #LastName=\"ngModel\" name=\"LastName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Last Name\" [(ngModel)]=\"objEmployees.LastName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"LastName.touched && LastName.invalid\">Last Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"FirstName.touched && FirstName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"FirstName\" class=\"col-xs-3 col-sm-2 control-label\">First Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #FirstName=\"ngModel\" name=\"FirstName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"First Name\" [(ngModel)]=\"objEmployees.FirstName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"FirstName.touched && FirstName.invalid\">First Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Title.touched && Title.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Title\" class=\"col-xs-3 col-sm-2 control-label\">Title:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Title=\"ngModel\" name=\"Title\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Title\" [(ngModel)]=\"objEmployees.Title\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Title.touched && Title.invalid\">Title is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"TitleOfCourtesy.touched && TitleOfCourtesy.invalid\" >\r\n\t\t\t\t\t\t<label for=\"TitleOfCourtesy\" class=\"col-xs-3 col-sm-2 control-label\">Titleofcourtesy:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #TitleOfCourtesy=\"ngModel\" name=\"TitleOfCourtesy\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Titleofcourtesy\" [(ngModel)]=\"objEmployees.TitleOfCourtesy\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"TitleOfCourtesy.touched && TitleOfCourtesy.invalid\">Titleofcourtesy is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"BirthDate.touched && BirthDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"BirthDate\" class=\"col-xs-3 col-sm-2 control-label\">Birth Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<datepicker-dropdown #BirthDate=\"ngModel\" [control]=\"BirthDate\"  \r\n\t\t\t\t\t\t\t\t\t[(ngModel)]=\"objEmployees.BirthDate\" name=\"BirthDate\" [required]=\"true\" ></datepicker-dropdown>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"BirthDate.touched && BirthDate.errors && BirthDate.errors.required\">Birth Date is required.</div>\r\n\t\t\t\t\t\t\t<!--\r\n\t\t\t\t\t\t\t<input #BirthDate=\"ngModel\" name=\"BirthDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Birth Date\" [(ngModel)]=\"objEmployees.BirthDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"BirthDate.touched && BirthDate.invalid\">Birth Date is required.</div>\r\n\t\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"HireDate.touched && HireDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"HireDate\" class=\"col-xs-3 col-sm-2 control-label\">Hire Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<datepicker-dropdown #HireDate=\"ngModel\" [control]=\"HireDate\"  \r\n\t\t\t\t\t\t\t\t\t[(ngModel)]=\"objEmployees.HireDate\" name=\"HireDate\" [required]=\"true\" ></datepicker-dropdown>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"HireDate.touched && HireDate.errors && HireDate.errors.required\">Hire Date is required.</div>\r\n\t\t\t\t\t\t\t<!--\r\n\t\t\t\t\t\t\t<input #HireDate=\"ngModel\" name=\"HireDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Hire Date\" [(ngModel)]=\"objEmployees.HireDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"HireDate.touched && HireDate.invalid\">Hire Date is required.</div>\r\n\t\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Address.touched && Address.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Address\" class=\"col-xs-3 col-sm-2 control-label\">Address:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Address=\"ngModel\" name=\"Address\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Address\" [(ngModel)]=\"objEmployees.Address\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Address.touched && Address.invalid\">Address is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"City.touched && City.invalid\" >\r\n\t\t\t\t\t\t<label for=\"City\" class=\"col-xs-3 col-sm-2 control-label\">City:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #City=\"ngModel\" name=\"City\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"City\" [(ngModel)]=\"objEmployees.City\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"City.touched && City.invalid\">City is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Region.touched && Region.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Region\" class=\"col-xs-3 col-sm-2 control-label\">Region:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Region=\"ngModel\" name=\"Region\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Region\" [(ngModel)]=\"objEmployees.Region\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Region.touched && Region.invalid\">Region is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"PostalCode.touched && PostalCode.invalid\" >\r\n\t\t\t\t\t\t<label for=\"PostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Postal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #PostalCode=\"ngModel\" name=\"PostalCode\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Postal Code\" [(ngModel)]=\"objEmployees.PostalCode\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"PostalCode.touched && PostalCode.invalid\">Postal Code is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Country.touched && Country.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Country\" class=\"col-xs-3 col-sm-2 control-label\">Country:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Country=\"ngModel\" name=\"Country\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Country\" [(ngModel)]=\"objEmployees.Country\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Country.touched && Country.invalid\">Country is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"HomePhone.touched && HomePhone.invalid\" >\r\n\t\t\t\t\t\t<label for=\"HomePhone\" class=\"col-xs-3 col-sm-2 control-label\">Homephone:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #HomePhone=\"ngModel\" name=\"HomePhone\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Homephone\" [(ngModel)]=\"objEmployees.HomePhone\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"HomePhone.touched && HomePhone.invalid\">Homephone is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Extension.touched && Extension.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Extension\" class=\"col-xs-3 col-sm-2 control-label\">Extension:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Extension=\"ngModel\" name=\"Extension\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Extension\" [(ngModel)]=\"objEmployees.Extension\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Extension.touched && Extension.invalid\">Extension is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Photo.touched && Photo.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Photo\" class=\"col-xs-3 col-sm-2 control-label\">Photo:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Photo=\"ngModel\" name=\"Photo\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Photo\" [(ngModel)]=\"objEmployees.Photo\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Photo.touched && Photo.invalid\">Photo must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Notes.touched && Notes.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Notes\" class=\"col-xs-3 col-sm-2 control-label\">Notes:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<textarea #Notes=\"ngModel\" name=\"Notes\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Notes\" [(ngModel)]=\"objEmployees.Notes\"  rows=\"4\"> </textarea>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Notes.touched && Notes.invalid\">Notes is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Reportsto:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"ReportsTo\" name=\"ReportsTo\" class=\"form-control\" [(ngModel)]=\"objEmployees.ReportsTo\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objEmployees.ReportsTo\" *ngIf=\"!objEmployees.ReportsTo\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of EmployeesList\" [value]=\"item.EmployeeID\">\r\n\t\t\t\t\t\t\t\t\t{{item.LastName}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"PhotoPath.touched && PhotoPath.invalid\" >\r\n\t\t\t\t\t\t<label for=\"PhotoPath\" class=\"col-xs-3 col-sm-2 control-label\">Photopath:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<textarea #PhotoPath=\"ngModel\" name=\"PhotoPath\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Photopath\" [(ngModel)]=\"objEmployees.PhotoPath\"  rows=\"4\"> </textarea>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"PhotoPath.touched && PhotoPath.invalid\">Photopath is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1059 */
/***/ function(module, exports) {

module.exports = "<h2>Invoices Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Invoices Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShipName\" class=\"col-xs-3 col-sm-2 control-label\">Ship Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShipName\" name=\"ShipName\" placeholder=\"Ship Name\" [(ngModel)]=\"objInvoices.ShipName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShipAddress\" class=\"col-xs-3 col-sm-2 control-label\">Shipaddress:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShipAddress\" name=\"ShipAddress\" placeholder=\"Shipaddress\" [(ngModel)]=\"objInvoices.ShipAddress\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShipCity\" class=\"col-xs-3 col-sm-2 control-label\">Shipcity:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShipCity\" name=\"ShipCity\" placeholder=\"Shipcity\" [(ngModel)]=\"objInvoices.ShipCity\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShipRegion\" class=\"col-xs-3 col-sm-2 control-label\">Shipregion:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShipRegion\" name=\"ShipRegion\" placeholder=\"Shipregion\" [(ngModel)]=\"objInvoices.ShipRegion\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShipPostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Shippostal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShipPostalCode\" name=\"ShipPostalCode\" placeholder=\"Shippostal Code\" [(ngModel)]=\"objInvoices.ShipPostalCode\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShipCountry\" class=\"col-xs-3 col-sm-2 control-label\">Shipcountry:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShipCountry\" name=\"ShipCountry\" placeholder=\"Shipcountry\" [(ngModel)]=\"objInvoices.ShipCountry\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CustomerID\" class=\"col-xs-3 col-sm-2 control-label\">Customer Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CustomerID\" name=\"CustomerID\" placeholder=\"Customer Id\" [(ngModel)]=\"objInvoices.CustomerID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CustomerName\" class=\"col-xs-3 col-sm-2 control-label\">Customer Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CustomerName\" name=\"CustomerName\" placeholder=\"Customer Name\" [(ngModel)]=\"objInvoices.CustomerName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Address\" class=\"col-xs-3 col-sm-2 control-label\">Address:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Address\" name=\"Address\" placeholder=\"Address\" [(ngModel)]=\"objInvoices.Address\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"City\" class=\"col-xs-3 col-sm-2 control-label\">City:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"City\" name=\"City\" placeholder=\"City\" [(ngModel)]=\"objInvoices.City\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Region\" class=\"col-xs-3 col-sm-2 control-label\">Region:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Region\" name=\"Region\" placeholder=\"Region\" [(ngModel)]=\"objInvoices.Region\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"PostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Postal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"PostalCode\" name=\"PostalCode\" placeholder=\"Postal Code\" [(ngModel)]=\"objInvoices.PostalCode\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Country\" class=\"col-xs-3 col-sm-2 control-label\">Country:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Country\" name=\"Country\" placeholder=\"Country\" [(ngModel)]=\"objInvoices.Country\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Salesperson\" class=\"col-xs-3 col-sm-2 control-label\">Salesperson:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Salesperson\" name=\"Salesperson\" placeholder=\"Salesperson\" [(ngModel)]=\"objInvoices.Salesperson\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"OrderID\" class=\"col-xs-3 col-sm-2 control-label\">Order Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"OrderID\" name=\"OrderID\" placeholder=\"Order Id\" [(ngModel)]=\"objInvoices.OrderID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"OrderDate\" class=\"col-xs-3 col-sm-2 control-label\">Order Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"OrderDate\" name=\"OrderDate\" placeholder=\"Order Date\" [(ngModel)]=\"objInvoices.OrderDate\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"RequiredDate\" class=\"col-xs-3 col-sm-2 control-label\">Required Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"RequiredDate\" name=\"RequiredDate\" placeholder=\"Required Date\" [(ngModel)]=\"objInvoices.RequiredDate\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShippedDate\" class=\"col-xs-3 col-sm-2 control-label\">Shipped Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShippedDate\" name=\"ShippedDate\" placeholder=\"Shipped Date\" [(ngModel)]=\"objInvoices.ShippedDate\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShipperName\" class=\"col-xs-3 col-sm-2 control-label\">Shipper Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShipperName\" name=\"ShipperName\" placeholder=\"Shipper Name\" [(ngModel)]=\"objInvoices.ShipperName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ProductID\" class=\"col-xs-3 col-sm-2 control-label\">Product Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ProductID\" name=\"ProductID\" placeholder=\"Product Id\" [(ngModel)]=\"objInvoices.ProductID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ProductName\" class=\"col-xs-3 col-sm-2 control-label\">Product Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ProductName\" name=\"ProductName\" placeholder=\"Product Name\" [(ngModel)]=\"objInvoices.ProductName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"UnitPrice\" class=\"col-xs-3 col-sm-2 control-label\">Unitprice:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"UnitPrice\" name=\"UnitPrice\" placeholder=\"Unitprice\" [(ngModel)]=\"objInvoices.UnitPrice\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Quantity\" class=\"col-xs-3 col-sm-2 control-label\">Quantity:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Quantity\" name=\"Quantity\" placeholder=\"Quantity\" [(ngModel)]=\"objInvoices.Quantity\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Discount\" class=\"col-xs-3 col-sm-2 control-label\">Discount:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Discount\" name=\"Discount\" placeholder=\"Discount\" [(ngModel)]=\"objInvoices.Discount\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ExtendedPrice\" class=\"col-xs-3 col-sm-2 control-label\">Extendedprice:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ExtendedPrice\" name=\"ExtendedPrice\" placeholder=\"Extendedprice\" [(ngModel)]=\"objInvoices.ExtendedPrice\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Freight\" class=\"col-xs-3 col-sm-2 control-label\">Freight:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Freight\" name=\"Freight\" placeholder=\"Freight\" [(ngModel)]=\"objInvoices.Freight\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoInvoices()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1060 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>Invoices List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\t\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<InvoicesSearch (filterCriteria)=\"onSearch($event)\" ></InvoicesSearch>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}\r\n\t\t\t\t</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr> \r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShipName')\">Ship Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShipAddress')\">Shipaddress</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShipCity')\">Shipcity</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShipRegion')\">Shipregion</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShipPostalCode')\">Shippostal Code</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShipCountry')\">Shipcountry</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CustomerID')\">Customer Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CustomerName')\">Customer Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Address')\">Address</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'City')\">City</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Region')\">Region</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'PostalCode')\">Postal Code</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Country')\">Country</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Salesperson')\">Salesperson</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'OrderID')\">Order Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'OrderDate')\">Order Date</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'RequiredDate')\">Required Date</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShippedDate')\">Shipped Date</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShipperName')\">Shipper Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ProductID')\">Product Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ProductName')\">Product Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'UnitPrice')\">Unitprice</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Quantity')\">Quantity</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Discount')\">Discount</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ExtendedPrice')\">Extendedprice</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Freight')\">Freight</a></th>\r\n\r\n\t\t</tr>\r\n\t\t\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of InvoicesList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelectDetails(item)\">Details</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShipName}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShipAddress}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShipCity}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShipRegion}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShipPostalCode}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShipCountry}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.CustomerID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.CustomerName}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Address}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.City}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Region}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.PostalCode}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Country}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Salesperson}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.OrderID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.OrderDate}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.RequiredDate}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShippedDate}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShipperName}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.ProductID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ProductName}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.UnitPrice}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.Quantity}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Discount}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.ExtendedPrice}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.Freight}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1061 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch Invoices\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipName.touched && ShipName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipName\" class=\"col-xs-3 col-sm-2 control-label\">Ship Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipName=\"ngModel\" name=\"ShipName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Ship Name\" [(ngModel)]=\"objInvoices.ShipName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipName.touched && ShipName.invalid\">Ship Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipAddress.touched && ShipAddress.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipAddress\" class=\"col-xs-3 col-sm-2 control-label\">Shipaddress:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipAddress=\"ngModel\" name=\"ShipAddress\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipaddress\" [(ngModel)]=\"objInvoices.ShipAddress\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipAddress.touched && ShipAddress.invalid\">Shipaddress is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipCity.touched && ShipCity.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipCity\" class=\"col-xs-3 col-sm-2 control-label\">Shipcity:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipCity=\"ngModel\" name=\"ShipCity\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipcity\" [(ngModel)]=\"objInvoices.ShipCity\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipCity.touched && ShipCity.invalid\">Shipcity is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipRegion.touched && ShipRegion.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipRegion\" class=\"col-xs-3 col-sm-2 control-label\">Shipregion:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipRegion=\"ngModel\" name=\"ShipRegion\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipregion\" [(ngModel)]=\"objInvoices.ShipRegion\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipRegion.touched && ShipRegion.invalid\">Shipregion is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipPostalCode.touched && ShipPostalCode.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipPostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Shippostal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipPostalCode=\"ngModel\" name=\"ShipPostalCode\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shippostal Code\" [(ngModel)]=\"objInvoices.ShipPostalCode\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipPostalCode.touched && ShipPostalCode.invalid\">Shippostal Code is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipCountry.touched && ShipCountry.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipCountry\" class=\"col-xs-3 col-sm-2 control-label\">Shipcountry:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipCountry=\"ngModel\" name=\"ShipCountry\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipcountry\" [(ngModel)]=\"objInvoices.ShipCountry\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipCountry.touched && ShipCountry.invalid\">Shipcountry is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CustomerID.touched && CustomerID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CustomerID\" class=\"col-xs-3 col-sm-2 control-label\">Customer Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CustomerID=\"ngModel\" name=\"CustomerID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Customer Id\" [(ngModel)]=\"objInvoices.CustomerID\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CustomerID.touched && CustomerID.invalid\">Customer Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CustomerName.touched && CustomerName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CustomerName\" class=\"col-xs-3 col-sm-2 control-label\">Customer Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CustomerName=\"ngModel\" name=\"CustomerName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Customer Name\" [(ngModel)]=\"objInvoices.CustomerName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CustomerName.touched && CustomerName.invalid\">Customer Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Address.touched && Address.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Address\" class=\"col-xs-3 col-sm-2 control-label\">Address:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Address=\"ngModel\" name=\"Address\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Address\" [(ngModel)]=\"objInvoices.Address\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Address.touched && Address.invalid\">Address is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"City.touched && City.invalid\" >\r\n\t\t\t\t\t\t<label for=\"City\" class=\"col-xs-3 col-sm-2 control-label\">City:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #City=\"ngModel\" name=\"City\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"City\" [(ngModel)]=\"objInvoices.City\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"City.touched && City.invalid\">City is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Region.touched && Region.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Region\" class=\"col-xs-3 col-sm-2 control-label\">Region:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Region=\"ngModel\" name=\"Region\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Region\" [(ngModel)]=\"objInvoices.Region\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Region.touched && Region.invalid\">Region is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"PostalCode.touched && PostalCode.invalid\" >\r\n\t\t\t\t\t\t<label for=\"PostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Postal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #PostalCode=\"ngModel\" name=\"PostalCode\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Postal Code\" [(ngModel)]=\"objInvoices.PostalCode\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"PostalCode.touched && PostalCode.invalid\">Postal Code is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Country.touched && Country.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Country\" class=\"col-xs-3 col-sm-2 control-label\">Country:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Country=\"ngModel\" name=\"Country\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Country\" [(ngModel)]=\"objInvoices.Country\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Country.touched && Country.invalid\">Country is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Salesperson.touched && Salesperson.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Salesperson\" class=\"col-xs-3 col-sm-2 control-label\">Salesperson:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Salesperson=\"ngModel\" name=\"Salesperson\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Salesperson\" [(ngModel)]=\"objInvoices.Salesperson\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Salesperson.touched && Salesperson.invalid\">Salesperson is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"OrderID.touched && OrderID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"OrderID\" class=\"col-xs-3 col-sm-2 control-label\">Order Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #OrderID=\"ngModel\" name=\"OrderID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Order Id\" [(ngModel)]=\"objInvoices.OrderID\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"OrderID.touched && OrderID.invalid\">Order Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"OrderDate.touched && OrderDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"OrderDate\" class=\"col-xs-3 col-sm-2 control-label\">Order Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<datepicker-dropdown #OrderDate=\"ngModel\" [control]=\"OrderDate\"  \r\n\t\t\t\t\t\t\t\t\t[(ngModel)]=\"objInvoices.OrderDate\" name=\"OrderDate\" [required]=\"true\" ></datepicker-dropdown>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"OrderDate.touched && OrderDate.errors && OrderDate.errors.required\">Order Date is required.</div>\r\n\t\t\t\t\t\t\t<!--\r\n\t\t\t\t\t\t\t<input #OrderDate=\"ngModel\" name=\"OrderDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Order Date\" [(ngModel)]=\"objInvoices.OrderDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"OrderDate.touched && OrderDate.invalid\">Order Date is required.</div>\r\n\t\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"RequiredDate.touched && RequiredDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"RequiredDate\" class=\"col-xs-3 col-sm-2 control-label\">Required Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<datepicker-dropdown #RequiredDate=\"ngModel\" [control]=\"RequiredDate\"  \r\n\t\t\t\t\t\t\t\t\t[(ngModel)]=\"objInvoices.RequiredDate\" name=\"RequiredDate\" [required]=\"true\" ></datepicker-dropdown>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"RequiredDate.touched && RequiredDate.errors && RequiredDate.errors.required\">Required Date is required.</div>\r\n\t\t\t\t\t\t\t<!--\r\n\t\t\t\t\t\t\t<input #RequiredDate=\"ngModel\" name=\"RequiredDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Required Date\" [(ngModel)]=\"objInvoices.RequiredDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"RequiredDate.touched && RequiredDate.invalid\">Required Date is required.</div>\r\n\t\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShippedDate.touched && ShippedDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShippedDate\" class=\"col-xs-3 col-sm-2 control-label\">Shipped Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<datepicker-dropdown #ShippedDate=\"ngModel\" [control]=\"ShippedDate\"  \r\n\t\t\t\t\t\t\t\t\t[(ngModel)]=\"objInvoices.ShippedDate\" name=\"ShippedDate\" [required]=\"true\" ></datepicker-dropdown>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShippedDate.touched && ShippedDate.errors && ShippedDate.errors.required\">Shipped Date is required.</div>\r\n\t\t\t\t\t\t\t<!--\r\n\t\t\t\t\t\t\t<input #ShippedDate=\"ngModel\" name=\"ShippedDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipped Date\" [(ngModel)]=\"objInvoices.ShippedDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShippedDate.touched && ShippedDate.invalid\">Shipped Date is required.</div>\r\n\t\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipperName.touched && ShipperName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipperName\" class=\"col-xs-3 col-sm-2 control-label\">Shipper Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipperName=\"ngModel\" name=\"ShipperName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipper Name\" [(ngModel)]=\"objInvoices.ShipperName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipperName.touched && ShipperName.invalid\">Shipper Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ProductID.touched && ProductID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ProductID\" class=\"col-xs-3 col-sm-2 control-label\">Product Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ProductID=\"ngModel\" name=\"ProductID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Product Id\" [(ngModel)]=\"objInvoices.ProductID\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ProductID.touched && ProductID.invalid\">Product Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ProductName.touched && ProductName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ProductName\" class=\"col-xs-3 col-sm-2 control-label\">Product Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ProductName=\"ngModel\" name=\"ProductName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Product Name\" [(ngModel)]=\"objInvoices.ProductName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ProductName.touched && ProductName.invalid\">Product Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"UnitPrice.touched && UnitPrice.invalid\" >\r\n\t\t\t\t\t\t<label for=\"UnitPrice\" class=\"col-xs-3 col-sm-2 control-label\">Unitprice:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #UnitPrice=\"ngModel\" name=\"UnitPrice\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Unitprice\" [(ngModel)]=\"objInvoices.UnitPrice\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"UnitPrice.touched && UnitPrice.invalid\">Unitprice must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Quantity.touched && Quantity.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Quantity\" class=\"col-xs-3 col-sm-2 control-label\">Quantity:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Quantity=\"ngModel\" name=\"Quantity\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Quantity\" [(ngModel)]=\"objInvoices.Quantity\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Quantity.touched && Quantity.invalid\">Quantity must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Discount.touched && Discount.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Discount\" class=\"col-xs-3 col-sm-2 control-label\">Discount:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Discount=\"ngModel\" name=\"Discount\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Discount\" [(ngModel)]=\"objInvoices.Discount\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Discount.touched && Discount.invalid\">Discount must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ExtendedPrice.touched && ExtendedPrice.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ExtendedPrice\" class=\"col-xs-3 col-sm-2 control-label\">Extendedprice:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ExtendedPrice=\"ngModel\" name=\"ExtendedPrice\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Extendedprice\" [(ngModel)]=\"objInvoices.ExtendedPrice\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ExtendedPrice.touched && ExtendedPrice.invalid\">Extendedprice must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Freight.touched && Freight.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Freight\" class=\"col-xs-3 col-sm-2 control-label\">Freight:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Freight=\"ngModel\" name=\"Freight\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Freight\" [(ngModel)]=\"objInvoices.Freight\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Freight.touched && Freight.invalid\">Freight must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1062 */
/***/ function(module, exports) {

module.exports = "<h2>OrderDetailsExtended Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">OrderDetailsExtended Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"OrderID\" class=\"col-xs-3 col-sm-2 control-label\">Order Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"OrderID\" name=\"OrderID\" placeholder=\"Order Id\" [(ngModel)]=\"objOrderDetailsExtended.OrderID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ProductID\" class=\"col-xs-3 col-sm-2 control-label\">Product Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ProductID\" name=\"ProductID\" placeholder=\"Product Id\" [(ngModel)]=\"objOrderDetailsExtended.ProductID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ProductName\" class=\"col-xs-3 col-sm-2 control-label\">Product Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ProductName\" name=\"ProductName\" placeholder=\"Product Name\" [(ngModel)]=\"objOrderDetailsExtended.ProductName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"UnitPrice\" class=\"col-xs-3 col-sm-2 control-label\">Unitprice:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"UnitPrice\" name=\"UnitPrice\" placeholder=\"Unitprice\" [(ngModel)]=\"objOrderDetailsExtended.UnitPrice\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Quantity\" class=\"col-xs-3 col-sm-2 control-label\">Quantity:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Quantity\" name=\"Quantity\" placeholder=\"Quantity\" [(ngModel)]=\"objOrderDetailsExtended.Quantity\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Discount\" class=\"col-xs-3 col-sm-2 control-label\">Discount:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Discount\" name=\"Discount\" placeholder=\"Discount\" [(ngModel)]=\"objOrderDetailsExtended.Discount\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ExtendedPrice\" class=\"col-xs-3 col-sm-2 control-label\">Extendedprice:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ExtendedPrice\" name=\"ExtendedPrice\" placeholder=\"Extendedprice\" [(ngModel)]=\"objOrderDetailsExtended.ExtendedPrice\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoOrderDetailsExtended()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1063 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>OrderDetailsExtended List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\t\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<OrderDetailsExtendedSearch (filterCriteria)=\"onSearch($event)\" ></OrderDetailsExtendedSearch>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}\r\n\t\t\t\t</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr> \r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'OrderID')\">Order Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ProductID')\">Product Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ProductName')\">Product Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'UnitPrice')\">Unitprice</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Quantity')\">Quantity</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Discount')\">Discount</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ExtendedPrice')\">Extendedprice</a></th>\r\n\r\n\t\t</tr>\r\n\t\t\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of OrderDetailsExtendedList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelectDetails(item)\">Details</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.OrderID}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.ProductID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ProductName}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.UnitPrice}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.Quantity}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Discount}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.ExtendedPrice}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1064 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch OrderDetailsExtended\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"OrderID.touched && OrderID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"OrderID\" class=\"col-xs-3 col-sm-2 control-label\">Order Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #OrderID=\"ngModel\" name=\"OrderID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Order Id\" [(ngModel)]=\"objOrderDetailsExtended.OrderID\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"OrderID.touched && OrderID.invalid\">Order Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ProductID.touched && ProductID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ProductID\" class=\"col-xs-3 col-sm-2 control-label\">Product Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ProductID=\"ngModel\" name=\"ProductID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Product Id\" [(ngModel)]=\"objOrderDetailsExtended.ProductID\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ProductID.touched && ProductID.invalid\">Product Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ProductName.touched && ProductName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ProductName\" class=\"col-xs-3 col-sm-2 control-label\">Product Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ProductName=\"ngModel\" name=\"ProductName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Product Name\" [(ngModel)]=\"objOrderDetailsExtended.ProductName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ProductName.touched && ProductName.invalid\">Product Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"UnitPrice.touched && UnitPrice.invalid\" >\r\n\t\t\t\t\t\t<label for=\"UnitPrice\" class=\"col-xs-3 col-sm-2 control-label\">Unitprice:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #UnitPrice=\"ngModel\" name=\"UnitPrice\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Unitprice\" [(ngModel)]=\"objOrderDetailsExtended.UnitPrice\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"UnitPrice.touched && UnitPrice.invalid\">Unitprice must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Quantity.touched && Quantity.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Quantity\" class=\"col-xs-3 col-sm-2 control-label\">Quantity:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Quantity=\"ngModel\" name=\"Quantity\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Quantity\" [(ngModel)]=\"objOrderDetailsExtended.Quantity\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Quantity.touched && Quantity.invalid\">Quantity must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Discount.touched && Discount.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Discount\" class=\"col-xs-3 col-sm-2 control-label\">Discount:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Discount=\"ngModel\" name=\"Discount\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Discount\" [(ngModel)]=\"objOrderDetailsExtended.Discount\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Discount.touched && Discount.invalid\">Discount must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ExtendedPrice.touched && ExtendedPrice.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ExtendedPrice\" class=\"col-xs-3 col-sm-2 control-label\">Extendedprice:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ExtendedPrice=\"ngModel\" name=\"ExtendedPrice\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Extendedprice\" [(ngModel)]=\"objOrderDetailsExtended.ExtendedPrice\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ExtendedPrice.touched && ExtendedPrice.invalid\">Extendedprice must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1065 */
/***/ function(module, exports) {

module.exports = "<h2>Add OrderDetails</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">OrderDetails Add</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"OrderID.touched && OrderID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"OrderID\" class=\"col-xs-3 col-sm-2 control-label\">Order Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #OrderID=\"ngModel\" name=\"OrderID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Order Id\" [(ngModel)]=\"objOrderDetails.OrderID\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"OrderID.touched && OrderID.invalid\">Order Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Product Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"ProductID\" name=\"ProductID\" class=\"form-control\" [(ngModel)]=\"objOrderDetails.ProductID\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objOrderDetails.ProductID\" *ngIf=\"!objOrderDetails.ProductID\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of ProductsList\" [value]=\"item.ProductID\">\r\n\t\t\t\t\t\t\t\t\t{{item.ProductName}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"UnitPrice.touched && UnitPrice.invalid\" >\r\n\t\t\t\t\t\t<label for=\"UnitPrice\" class=\"col-xs-3 col-sm-2 control-label\">Unitprice:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #UnitPrice=\"ngModel\" name=\"UnitPrice\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Unitprice\" [(ngModel)]=\"objOrderDetails.UnitPrice\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"UnitPrice.touched && UnitPrice.invalid\">Unitprice must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Quantity.touched && Quantity.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Quantity\" class=\"col-xs-3 col-sm-2 control-label\">Quantity:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Quantity=\"ngModel\" name=\"Quantity\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Quantity\" [(ngModel)]=\"objOrderDetails.Quantity\" pattern=\"^(0|[1-9][0-9]*)$\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Quantity.touched && Quantity.invalid\">Quantity must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Discount.touched && Discount.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Discount\" class=\"col-xs-3 col-sm-2 control-label\">Discount:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Discount=\"ngModel\" name=\"Discount\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Discount\" [(ngModel)]=\"objOrderDetails.Discount\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Discount.touched && Discount.invalid\">Discount must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"addOrderDetails()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoOrderDetails()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1066 */
/***/ function(module, exports) {

module.exports = "<h2>OrderDetails Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">OrderDetails Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"OrderID\" class=\"col-xs-3 col-sm-2 control-label\">Order Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"OrderID\" name=\"OrderID\" placeholder=\"Order Id\" [(ngModel)]=\"objOrderDetails.OrderID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ProductID\" class=\"col-xs-3 col-sm-2 control-label\">Product Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ProductID\" name=\"ProductID\" placeholder=\"Product Id\" [(ngModel)]=\"objOrderDetails.ProductID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"UnitPrice\" class=\"col-xs-3 col-sm-2 control-label\">Unitprice:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"UnitPrice\" name=\"UnitPrice\" placeholder=\"Unitprice\" [(ngModel)]=\"objOrderDetails.UnitPrice\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Quantity\" class=\"col-xs-3 col-sm-2 control-label\">Quantity:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Quantity\" name=\"Quantity\" placeholder=\"Quantity\" [(ngModel)]=\"objOrderDetails.Quantity\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Discount\" class=\"col-xs-3 col-sm-2 control-label\">Discount:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Discount\" name=\"Discount\" placeholder=\"Discount\" [(ngModel)]=\"objOrderDetails.Discount\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"gotoOrderDetailsEdit()\">Edit</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoOrderDetails()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" (click)=\"deleteOrderDetails(objOrderDetails.OrderID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1067 */
/***/ function(module, exports) {

module.exports = "<h2>Edit OrderDetails</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">OrderDetails Edit</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"OrderID.touched && OrderID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"OrderID\" class=\"col-xs-3 col-sm-2 control-label\">Order Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #OrderID=\"ngModel\" name=\"OrderID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Order Id\" [(ngModel)]=\"objOrderDetails.OrderID\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"OrderID.touched && OrderID.invalid\">Order Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Product Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"ProductID\" name=\"ProductID\" class=\"form-control\" [(ngModel)]=\"objOrderDetails.ProductID\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objOrderDetails.ProductID\" *ngIf=\"!objOrderDetails.ProductID\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of ProductsList\" [value]=\"item.ProductID\">\r\n\t\t\t\t\t\t\t\t\t{{item.ProductName}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"UnitPrice.touched && UnitPrice.invalid\" >\r\n\t\t\t\t\t\t<label for=\"UnitPrice\" class=\"col-xs-3 col-sm-2 control-label\">Unitprice:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #UnitPrice=\"ngModel\" name=\"UnitPrice\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Unitprice\" [(ngModel)]=\"objOrderDetails.UnitPrice\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"UnitPrice.touched && UnitPrice.invalid\">Unitprice must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Quantity.touched && Quantity.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Quantity\" class=\"col-xs-3 col-sm-2 control-label\">Quantity:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Quantity=\"ngModel\" name=\"Quantity\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Quantity\" [(ngModel)]=\"objOrderDetails.Quantity\" pattern=\"^(0|[1-9][0-9]*)$\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Quantity.touched && Quantity.invalid\">Quantity must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Discount.touched && Discount.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Discount\" class=\"col-xs-3 col-sm-2 control-label\">Discount:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Discount=\"ngModel\" name=\"Discount\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Discount\" [(ngModel)]=\"objOrderDetails.Discount\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Discount.touched && Discount.invalid\">Discount must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"updateOrderDetails()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoOrderDetails()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" type=\"submit\" (click)=\"deleteOrderDetails(objOrderDetails.OrderID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1068 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>OrderDetails List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<OrderDetailsSearch (filterCriteria)=\"onSearch($event)\" ></OrderDetailsSearch>\r\n\t\t</div>\r\n\t</div>\r\n\t\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" routerLink=\"/OrderDetails/add\" routerLinkActive=\"active\" title=\"Add OrderDetails\"><i class=\"glyphicon glyphicon-plus\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Delete List(s)\"><i class=\"glyphicon glyphicon-remove\"></i></a-->\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr>\r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'OrderID')\">Order Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ProductID')\">Product Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'UnitPrice')\">Unitprice</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Quantity')\">Quantity</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Discount')\">Discount</a></th>\r\n\r\n\t\t</tr>\r\n\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of OrderDetailsList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelect(item)\">Edit</a>\r\n\t\t\t\t\t<a (click)=\"deleteOrderDetails(item.OrderID)\">Delete</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.OrderID}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.ProductID}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.UnitPrice}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.Quantity}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Discount}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1069 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch OrderDetails\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"OrderID.touched && OrderID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"OrderID\" class=\"col-xs-3 col-sm-2 control-label\">Order Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #OrderID=\"ngModel\" name=\"OrderID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Order Id\" [(ngModel)]=\"objOrderDetails.OrderID\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"OrderID.touched && OrderID.invalid\">Order Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Product Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"ProductID\" name=\"ProductID\" class=\"form-control\" [(ngModel)]=\"objOrderDetails.ProductID\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objOrderDetails.ProductID\" *ngIf=\"!objOrderDetails.ProductID\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of ProductsList\" [value]=\"item.ProductID\">\r\n\t\t\t\t\t\t\t\t\t{{item.ProductName}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"UnitPrice.touched && UnitPrice.invalid\" >\r\n\t\t\t\t\t\t<label for=\"UnitPrice\" class=\"col-xs-3 col-sm-2 control-label\">Unitprice:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #UnitPrice=\"ngModel\" name=\"UnitPrice\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Unitprice\" [(ngModel)]=\"objOrderDetails.UnitPrice\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"UnitPrice.touched && UnitPrice.invalid\">Unitprice must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Quantity.touched && Quantity.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Quantity\" class=\"col-xs-3 col-sm-2 control-label\">Quantity:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Quantity=\"ngModel\" name=\"Quantity\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Quantity\" [(ngModel)]=\"objOrderDetails.Quantity\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Quantity.touched && Quantity.invalid\">Quantity must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Discount.touched && Discount.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Discount\" class=\"col-xs-3 col-sm-2 control-label\">Discount:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Discount=\"ngModel\" name=\"Discount\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Discount\" [(ngModel)]=\"objOrderDetails.Discount\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Discount.touched && Discount.invalid\">Discount must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1070 */
/***/ function(module, exports) {

module.exports = "<h2>OrderSubtotals Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">OrderSubtotals Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"OrderID\" class=\"col-xs-3 col-sm-2 control-label\">Order Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"OrderID\" name=\"OrderID\" placeholder=\"Order Id\" [(ngModel)]=\"objOrderSubtotals.OrderID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Subtotal\" class=\"col-xs-3 col-sm-2 control-label\">Subtotal:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Subtotal\" name=\"Subtotal\" placeholder=\"Subtotal\" [(ngModel)]=\"objOrderSubtotals.Subtotal\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoOrderSubtotals()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1071 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>OrderSubtotals List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\t\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<OrderSubtotalsSearch (filterCriteria)=\"onSearch($event)\" ></OrderSubtotalsSearch>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}\r\n\t\t\t\t</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr> \r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'OrderID')\">Order Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Subtotal')\">Subtotal</a></th>\r\n\r\n\t\t</tr>\r\n\t\t\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of OrderSubtotalsList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelectDetails(item)\">Details</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.OrderID}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.Subtotal}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1072 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch OrderSubtotals\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"OrderID.touched && OrderID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"OrderID\" class=\"col-xs-3 col-sm-2 control-label\">Order Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #OrderID=\"ngModel\" name=\"OrderID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Order Id\" [(ngModel)]=\"objOrderSubtotals.OrderID\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"OrderID.touched && OrderID.invalid\">Order Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Subtotal.touched && Subtotal.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Subtotal\" class=\"col-xs-3 col-sm-2 control-label\">Subtotal:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Subtotal=\"ngModel\" name=\"Subtotal\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Subtotal\" [(ngModel)]=\"objOrderSubtotals.Subtotal\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Subtotal.touched && Subtotal.invalid\">Subtotal must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1073 */
/***/ function(module, exports) {

module.exports = "<h2>OrdersQry Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">OrdersQry Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"OrderID\" class=\"col-xs-3 col-sm-2 control-label\">Order Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"OrderID\" name=\"OrderID\" placeholder=\"Order Id\" [(ngModel)]=\"objOrdersQry.OrderID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CustomerID\" class=\"col-xs-3 col-sm-2 control-label\">Customer Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CustomerID\" name=\"CustomerID\" placeholder=\"Customer Id\" [(ngModel)]=\"objOrdersQry.CustomerID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"EmployeeID\" class=\"col-xs-3 col-sm-2 control-label\">Employee Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"EmployeeID\" name=\"EmployeeID\" placeholder=\"Employee Id\" [(ngModel)]=\"objOrdersQry.EmployeeID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"OrderDate\" class=\"col-xs-3 col-sm-2 control-label\">Order Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"OrderDate\" name=\"OrderDate\" placeholder=\"Order Date\" [(ngModel)]=\"objOrdersQry.OrderDate\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"RequiredDate\" class=\"col-xs-3 col-sm-2 control-label\">Required Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"RequiredDate\" name=\"RequiredDate\" placeholder=\"Required Date\" [(ngModel)]=\"objOrdersQry.RequiredDate\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShippedDate\" class=\"col-xs-3 col-sm-2 control-label\">Shipped Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShippedDate\" name=\"ShippedDate\" placeholder=\"Shipped Date\" [(ngModel)]=\"objOrdersQry.ShippedDate\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShipVia\" class=\"col-xs-3 col-sm-2 control-label\">Shipvia:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShipVia\" name=\"ShipVia\" placeholder=\"Shipvia\" [(ngModel)]=\"objOrdersQry.ShipVia\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Freight\" class=\"col-xs-3 col-sm-2 control-label\">Freight:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Freight\" name=\"Freight\" placeholder=\"Freight\" [(ngModel)]=\"objOrdersQry.Freight\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShipName\" class=\"col-xs-3 col-sm-2 control-label\">Ship Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShipName\" name=\"ShipName\" placeholder=\"Ship Name\" [(ngModel)]=\"objOrdersQry.ShipName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShipAddress\" class=\"col-xs-3 col-sm-2 control-label\">Shipaddress:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShipAddress\" name=\"ShipAddress\" placeholder=\"Shipaddress\" [(ngModel)]=\"objOrdersQry.ShipAddress\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShipCity\" class=\"col-xs-3 col-sm-2 control-label\">Shipcity:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShipCity\" name=\"ShipCity\" placeholder=\"Shipcity\" [(ngModel)]=\"objOrdersQry.ShipCity\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShipRegion\" class=\"col-xs-3 col-sm-2 control-label\">Shipregion:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShipRegion\" name=\"ShipRegion\" placeholder=\"Shipregion\" [(ngModel)]=\"objOrdersQry.ShipRegion\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShipPostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Shippostal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShipPostalCode\" name=\"ShipPostalCode\" placeholder=\"Shippostal Code\" [(ngModel)]=\"objOrdersQry.ShipPostalCode\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShipCountry\" class=\"col-xs-3 col-sm-2 control-label\">Shipcountry:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShipCountry\" name=\"ShipCountry\" placeholder=\"Shipcountry\" [(ngModel)]=\"objOrdersQry.ShipCountry\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CompanyName\" class=\"col-xs-3 col-sm-2 control-label\">Company Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CompanyName\" name=\"CompanyName\" placeholder=\"Company Name\" [(ngModel)]=\"objOrdersQry.CompanyName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Address\" class=\"col-xs-3 col-sm-2 control-label\">Address:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Address\" name=\"Address\" placeholder=\"Address\" [(ngModel)]=\"objOrdersQry.Address\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"City\" class=\"col-xs-3 col-sm-2 control-label\">City:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"City\" name=\"City\" placeholder=\"City\" [(ngModel)]=\"objOrdersQry.City\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Region\" class=\"col-xs-3 col-sm-2 control-label\">Region:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Region\" name=\"Region\" placeholder=\"Region\" [(ngModel)]=\"objOrdersQry.Region\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"PostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Postal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"PostalCode\" name=\"PostalCode\" placeholder=\"Postal Code\" [(ngModel)]=\"objOrdersQry.PostalCode\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Country\" class=\"col-xs-3 col-sm-2 control-label\">Country:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Country\" name=\"Country\" placeholder=\"Country\" [(ngModel)]=\"objOrdersQry.Country\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoOrdersQry()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1074 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>OrdersQry List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\t\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<OrdersQrySearch (filterCriteria)=\"onSearch($event)\" ></OrdersQrySearch>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}\r\n\t\t\t\t</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr> \r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'OrderID')\">Order Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CustomerID')\">Customer Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'EmployeeID')\">Employee Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'OrderDate')\">Order Date</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'RequiredDate')\">Required Date</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShippedDate')\">Shipped Date</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShipVia')\">Shipvia</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Freight')\">Freight</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShipName')\">Ship Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShipAddress')\">Shipaddress</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShipCity')\">Shipcity</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShipRegion')\">Shipregion</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShipPostalCode')\">Shippostal Code</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShipCountry')\">Shipcountry</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CompanyName')\">Company Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Address')\">Address</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'City')\">City</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Region')\">Region</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'PostalCode')\">Postal Code</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Country')\">Country</a></th>\r\n\r\n\t\t</tr>\r\n\t\t\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of OrdersQryList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelectDetails(item)\">Details</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.OrderID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.CustomerID}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.EmployeeID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.OrderDate}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.RequiredDate}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShippedDate}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.ShipVia}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.Freight}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShipName}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShipAddress}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShipCity}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShipRegion}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShipPostalCode}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShipCountry}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.CompanyName}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Address}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.City}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Region}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.PostalCode}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Country}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1075 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch OrdersQry\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"OrderID.touched && OrderID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"OrderID\" class=\"col-xs-3 col-sm-2 control-label\">Order Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #OrderID=\"ngModel\" name=\"OrderID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Order Id\" [(ngModel)]=\"objOrdersQry.OrderID\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"OrderID.touched && OrderID.invalid\">Order Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CustomerID.touched && CustomerID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CustomerID\" class=\"col-xs-3 col-sm-2 control-label\">Customer Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CustomerID=\"ngModel\" name=\"CustomerID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Customer Id\" [(ngModel)]=\"objOrdersQry.CustomerID\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CustomerID.touched && CustomerID.invalid\">Customer Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"EmployeeID.touched && EmployeeID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"EmployeeID\" class=\"col-xs-3 col-sm-2 control-label\">Employee Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #EmployeeID=\"ngModel\" name=\"EmployeeID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Employee Id\" [(ngModel)]=\"objOrdersQry.EmployeeID\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"EmployeeID.touched && EmployeeID.invalid\">Employee Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"OrderDate.touched && OrderDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"OrderDate\" class=\"col-xs-3 col-sm-2 control-label\">Order Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<datepicker-dropdown #OrderDate=\"ngModel\" [control]=\"OrderDate\"  \r\n\t\t\t\t\t\t\t\t\t[(ngModel)]=\"objOrdersQry.OrderDate\" name=\"OrderDate\" [required]=\"true\" ></datepicker-dropdown>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"OrderDate.touched && OrderDate.errors && OrderDate.errors.required\">Order Date is required.</div>\r\n\t\t\t\t\t\t\t<!--\r\n\t\t\t\t\t\t\t<input #OrderDate=\"ngModel\" name=\"OrderDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Order Date\" [(ngModel)]=\"objOrdersQry.OrderDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"OrderDate.touched && OrderDate.invalid\">Order Date is required.</div>\r\n\t\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"RequiredDate.touched && RequiredDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"RequiredDate\" class=\"col-xs-3 col-sm-2 control-label\">Required Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<datepicker-dropdown #RequiredDate=\"ngModel\" [control]=\"RequiredDate\"  \r\n\t\t\t\t\t\t\t\t\t[(ngModel)]=\"objOrdersQry.RequiredDate\" name=\"RequiredDate\" [required]=\"true\" ></datepicker-dropdown>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"RequiredDate.touched && RequiredDate.errors && RequiredDate.errors.required\">Required Date is required.</div>\r\n\t\t\t\t\t\t\t<!--\r\n\t\t\t\t\t\t\t<input #RequiredDate=\"ngModel\" name=\"RequiredDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Required Date\" [(ngModel)]=\"objOrdersQry.RequiredDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"RequiredDate.touched && RequiredDate.invalid\">Required Date is required.</div>\r\n\t\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShippedDate.touched && ShippedDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShippedDate\" class=\"col-xs-3 col-sm-2 control-label\">Shipped Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<datepicker-dropdown #ShippedDate=\"ngModel\" [control]=\"ShippedDate\"  \r\n\t\t\t\t\t\t\t\t\t[(ngModel)]=\"objOrdersQry.ShippedDate\" name=\"ShippedDate\" [required]=\"true\" ></datepicker-dropdown>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShippedDate.touched && ShippedDate.errors && ShippedDate.errors.required\">Shipped Date is required.</div>\r\n\t\t\t\t\t\t\t<!--\r\n\t\t\t\t\t\t\t<input #ShippedDate=\"ngModel\" name=\"ShippedDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipped Date\" [(ngModel)]=\"objOrdersQry.ShippedDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShippedDate.touched && ShippedDate.invalid\">Shipped Date is required.</div>\r\n\t\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipVia.touched && ShipVia.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipVia\" class=\"col-xs-3 col-sm-2 control-label\">Shipvia:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipVia=\"ngModel\" name=\"ShipVia\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipvia\" [(ngModel)]=\"objOrdersQry.ShipVia\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipVia.touched && ShipVia.invalid\">Shipvia must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Freight.touched && Freight.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Freight\" class=\"col-xs-3 col-sm-2 control-label\">Freight:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Freight=\"ngModel\" name=\"Freight\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Freight\" [(ngModel)]=\"objOrdersQry.Freight\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Freight.touched && Freight.invalid\">Freight must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipName.touched && ShipName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipName\" class=\"col-xs-3 col-sm-2 control-label\">Ship Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipName=\"ngModel\" name=\"ShipName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Ship Name\" [(ngModel)]=\"objOrdersQry.ShipName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipName.touched && ShipName.invalid\">Ship Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipAddress.touched && ShipAddress.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipAddress\" class=\"col-xs-3 col-sm-2 control-label\">Shipaddress:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipAddress=\"ngModel\" name=\"ShipAddress\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipaddress\" [(ngModel)]=\"objOrdersQry.ShipAddress\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipAddress.touched && ShipAddress.invalid\">Shipaddress is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipCity.touched && ShipCity.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipCity\" class=\"col-xs-3 col-sm-2 control-label\">Shipcity:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipCity=\"ngModel\" name=\"ShipCity\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipcity\" [(ngModel)]=\"objOrdersQry.ShipCity\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipCity.touched && ShipCity.invalid\">Shipcity is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipRegion.touched && ShipRegion.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipRegion\" class=\"col-xs-3 col-sm-2 control-label\">Shipregion:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipRegion=\"ngModel\" name=\"ShipRegion\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipregion\" [(ngModel)]=\"objOrdersQry.ShipRegion\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipRegion.touched && ShipRegion.invalid\">Shipregion is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipPostalCode.touched && ShipPostalCode.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipPostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Shippostal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipPostalCode=\"ngModel\" name=\"ShipPostalCode\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shippostal Code\" [(ngModel)]=\"objOrdersQry.ShipPostalCode\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipPostalCode.touched && ShipPostalCode.invalid\">Shippostal Code is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipCountry.touched && ShipCountry.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipCountry\" class=\"col-xs-3 col-sm-2 control-label\">Shipcountry:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipCountry=\"ngModel\" name=\"ShipCountry\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipcountry\" [(ngModel)]=\"objOrdersQry.ShipCountry\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipCountry.touched && ShipCountry.invalid\">Shipcountry is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CompanyName.touched && CompanyName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CompanyName\" class=\"col-xs-3 col-sm-2 control-label\">Company Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CompanyName=\"ngModel\" name=\"CompanyName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Company Name\" [(ngModel)]=\"objOrdersQry.CompanyName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CompanyName.touched && CompanyName.invalid\">Company Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Address.touched && Address.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Address\" class=\"col-xs-3 col-sm-2 control-label\">Address:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Address=\"ngModel\" name=\"Address\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Address\" [(ngModel)]=\"objOrdersQry.Address\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Address.touched && Address.invalid\">Address is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"City.touched && City.invalid\" >\r\n\t\t\t\t\t\t<label for=\"City\" class=\"col-xs-3 col-sm-2 control-label\">City:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #City=\"ngModel\" name=\"City\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"City\" [(ngModel)]=\"objOrdersQry.City\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"City.touched && City.invalid\">City is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Region.touched && Region.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Region\" class=\"col-xs-3 col-sm-2 control-label\">Region:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Region=\"ngModel\" name=\"Region\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Region\" [(ngModel)]=\"objOrdersQry.Region\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Region.touched && Region.invalid\">Region is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"PostalCode.touched && PostalCode.invalid\" >\r\n\t\t\t\t\t\t<label for=\"PostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Postal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #PostalCode=\"ngModel\" name=\"PostalCode\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Postal Code\" [(ngModel)]=\"objOrdersQry.PostalCode\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"PostalCode.touched && PostalCode.invalid\">Postal Code is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Country.touched && Country.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Country\" class=\"col-xs-3 col-sm-2 control-label\">Country:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Country=\"ngModel\" name=\"Country\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Country\" [(ngModel)]=\"objOrdersQry.Country\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Country.touched && Country.invalid\">Country is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1076 */
/***/ function(module, exports) {

module.exports = "<h2>Add Orders</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Orders Add</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"OrderID.touched && OrderID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"OrderID\" class=\"col-xs-3 col-sm-2 control-label\">Order Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #OrderID=\"ngModel\" name=\"OrderID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Order Id\" [(ngModel)]=\"objOrders.OrderID\" pattern=\"^(0|[1-9][0-9]*)$\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"OrderID.touched && OrderID.invalid\">Order Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CustomerID.touched && CustomerID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CustomerID\" class=\"col-xs-3 col-sm-2 control-label\">Customer Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CustomerID=\"ngModel\" name=\"CustomerID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Customer Id\" [(ngModel)]=\"objOrders.CustomerID\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CustomerID.touched && CustomerID.invalid\">Customer Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Employee Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"EmployeeID\" name=\"EmployeeID\" class=\"form-control\" [(ngModel)]=\"objOrders.EmployeeID\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objOrders.EmployeeID\" *ngIf=\"!objOrders.EmployeeID\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of EmployeesList\" [value]=\"item.EmployeeID\">\r\n\t\t\t\t\t\t\t\t\t{{item.LastName}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"OrderDate.touched && OrderDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"OrderDate\" class=\"col-xs-3 col-sm-2 control-label\">Order Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<datepicker-dropdown #OrderDate=\"ngModel\" [control]=\"OrderDate\"  \r\n\t\t\t\t\t\t\t\t\t[(ngModel)]=\"objOrders.OrderDate\" name=\"OrderDate\" [required]=\"true\" ></datepicker-dropdown>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"OrderDate.touched && OrderDate.errors && OrderDate.errors.required\">Order Date is required.</div>\r\n\t\t\t\t\t\t\t<!--\r\n\t\t\t\t\t\t\t<input #OrderDate=\"ngModel\" name=\"OrderDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Order Date\" [(ngModel)]=\"objOrders.OrderDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"OrderDate.touched && OrderDate.invalid\">Order Date is required.</div>\r\n\t\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"RequiredDate.touched && RequiredDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"RequiredDate\" class=\"col-xs-3 col-sm-2 control-label\">Required Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<datepicker-dropdown #RequiredDate=\"ngModel\" [control]=\"RequiredDate\"  \r\n\t\t\t\t\t\t\t\t\t[(ngModel)]=\"objOrders.RequiredDate\" name=\"RequiredDate\" [required]=\"true\" ></datepicker-dropdown>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"RequiredDate.touched && RequiredDate.errors && RequiredDate.errors.required\">Required Date is required.</div>\r\n\t\t\t\t\t\t\t<!--\r\n\t\t\t\t\t\t\t<input #RequiredDate=\"ngModel\" name=\"RequiredDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Required Date\" [(ngModel)]=\"objOrders.RequiredDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"RequiredDate.touched && RequiredDate.invalid\">Required Date is required.</div>\r\n\t\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShippedDate.touched && ShippedDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShippedDate\" class=\"col-xs-3 col-sm-2 control-label\">Shipped Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<datepicker-dropdown #ShippedDate=\"ngModel\" [control]=\"ShippedDate\"  \r\n\t\t\t\t\t\t\t\t\t[(ngModel)]=\"objOrders.ShippedDate\" name=\"ShippedDate\" [required]=\"true\" ></datepicker-dropdown>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShippedDate.touched && ShippedDate.errors && ShippedDate.errors.required\">Shipped Date is required.</div>\r\n\t\t\t\t\t\t\t<!--\r\n\t\t\t\t\t\t\t<input #ShippedDate=\"ngModel\" name=\"ShippedDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipped Date\" [(ngModel)]=\"objOrders.ShippedDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShippedDate.touched && ShippedDate.invalid\">Shipped Date is required.</div>\r\n\t\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Shipvia:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"ShipVia\" name=\"ShipVia\" class=\"form-control\" [(ngModel)]=\"objOrders.ShipVia\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objOrders.ShipVia\" *ngIf=\"!objOrders.ShipVia\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of ShippersList\" [value]=\"item.ShipperID\">\r\n\t\t\t\t\t\t\t\t\t{{item.CompanyName}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Freight.touched && Freight.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Freight\" class=\"col-xs-3 col-sm-2 control-label\">Freight:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Freight=\"ngModel\" name=\"Freight\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Freight\" [(ngModel)]=\"objOrders.Freight\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Freight.touched && Freight.invalid\">Freight must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipName.touched && ShipName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipName\" class=\"col-xs-3 col-sm-2 control-label\">Ship Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipName=\"ngModel\" name=\"ShipName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Ship Name\" [(ngModel)]=\"objOrders.ShipName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipName.touched && ShipName.invalid\">Ship Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipAddress.touched && ShipAddress.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipAddress\" class=\"col-xs-3 col-sm-2 control-label\">Shipaddress:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipAddress=\"ngModel\" name=\"ShipAddress\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipaddress\" [(ngModel)]=\"objOrders.ShipAddress\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipAddress.touched && ShipAddress.invalid\">Shipaddress is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipCity.touched && ShipCity.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipCity\" class=\"col-xs-3 col-sm-2 control-label\">Shipcity:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipCity=\"ngModel\" name=\"ShipCity\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipcity\" [(ngModel)]=\"objOrders.ShipCity\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipCity.touched && ShipCity.invalid\">Shipcity is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipRegion.touched && ShipRegion.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipRegion\" class=\"col-xs-3 col-sm-2 control-label\">Shipregion:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipRegion=\"ngModel\" name=\"ShipRegion\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipregion\" [(ngModel)]=\"objOrders.ShipRegion\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipRegion.touched && ShipRegion.invalid\">Shipregion is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipPostalCode.touched && ShipPostalCode.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipPostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Shippostal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipPostalCode=\"ngModel\" name=\"ShipPostalCode\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shippostal Code\" [(ngModel)]=\"objOrders.ShipPostalCode\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipPostalCode.touched && ShipPostalCode.invalid\">Shippostal Code is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipCountry.touched && ShipCountry.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipCountry\" class=\"col-xs-3 col-sm-2 control-label\">Shipcountry:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipCountry=\"ngModel\" name=\"ShipCountry\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipcountry\" [(ngModel)]=\"objOrders.ShipCountry\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipCountry.touched && ShipCountry.invalid\">Shipcountry is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"addOrders()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoOrders()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1077 */
/***/ function(module, exports) {

module.exports = "<h2>Orders Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Orders Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"OrderID\" class=\"col-xs-3 col-sm-2 control-label\">Order Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"OrderID\" name=\"OrderID\" placeholder=\"Order Id\" [(ngModel)]=\"objOrders.OrderID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CustomerID\" class=\"col-xs-3 col-sm-2 control-label\">Customer Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CustomerID\" name=\"CustomerID\" placeholder=\"Customer Id\" [(ngModel)]=\"objOrders.CustomerID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"EmployeeID\" class=\"col-xs-3 col-sm-2 control-label\">Employee Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"EmployeeID\" name=\"EmployeeID\" placeholder=\"Employee Id\" [(ngModel)]=\"objOrders.EmployeeID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"OrderDate\" class=\"col-xs-3 col-sm-2 control-label\">Order Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"OrderDate\" name=\"OrderDate\" placeholder=\"Order Date\" [(ngModel)]=\"objOrders.OrderDate\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"RequiredDate\" class=\"col-xs-3 col-sm-2 control-label\">Required Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"RequiredDate\" name=\"RequiredDate\" placeholder=\"Required Date\" [(ngModel)]=\"objOrders.RequiredDate\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShippedDate\" class=\"col-xs-3 col-sm-2 control-label\">Shipped Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShippedDate\" name=\"ShippedDate\" placeholder=\"Shipped Date\" [(ngModel)]=\"objOrders.ShippedDate\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShipVia\" class=\"col-xs-3 col-sm-2 control-label\">Shipvia:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShipVia\" name=\"ShipVia\" placeholder=\"Shipvia\" [(ngModel)]=\"objOrders.ShipVia\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Freight\" class=\"col-xs-3 col-sm-2 control-label\">Freight:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Freight\" name=\"Freight\" placeholder=\"Freight\" [(ngModel)]=\"objOrders.Freight\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShipName\" class=\"col-xs-3 col-sm-2 control-label\">Ship Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShipName\" name=\"ShipName\" placeholder=\"Ship Name\" [(ngModel)]=\"objOrders.ShipName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShipAddress\" class=\"col-xs-3 col-sm-2 control-label\">Shipaddress:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShipAddress\" name=\"ShipAddress\" placeholder=\"Shipaddress\" [(ngModel)]=\"objOrders.ShipAddress\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShipCity\" class=\"col-xs-3 col-sm-2 control-label\">Shipcity:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShipCity\" name=\"ShipCity\" placeholder=\"Shipcity\" [(ngModel)]=\"objOrders.ShipCity\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShipRegion\" class=\"col-xs-3 col-sm-2 control-label\">Shipregion:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShipRegion\" name=\"ShipRegion\" placeholder=\"Shipregion\" [(ngModel)]=\"objOrders.ShipRegion\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShipPostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Shippostal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShipPostalCode\" name=\"ShipPostalCode\" placeholder=\"Shippostal Code\" [(ngModel)]=\"objOrders.ShipPostalCode\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShipCountry\" class=\"col-xs-3 col-sm-2 control-label\">Shipcountry:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShipCountry\" name=\"ShipCountry\" placeholder=\"Shipcountry\" [(ngModel)]=\"objOrders.ShipCountry\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"gotoOrdersEdit()\">Edit</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoOrders()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" (click)=\"deleteOrders(objOrders.OrderID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1078 */
/***/ function(module, exports) {

module.exports = "<h2>Edit Orders</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Orders Edit</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"OrderID.touched && OrderID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"OrderID\" class=\"col-xs-3 col-sm-2 control-label\">Order Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #OrderID=\"ngModel\" name=\"OrderID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Order Id\" [(ngModel)]=\"objOrders.OrderID\" pattern=\"^(0|[1-9][0-9]*)$\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"OrderID.touched && OrderID.invalid\">Order Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CustomerID.touched && CustomerID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CustomerID\" class=\"col-xs-3 col-sm-2 control-label\">Customer Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CustomerID=\"ngModel\" name=\"CustomerID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Customer Id\" [(ngModel)]=\"objOrders.CustomerID\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CustomerID.touched && CustomerID.invalid\">Customer Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Employee Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"EmployeeID\" name=\"EmployeeID\" class=\"form-control\" [(ngModel)]=\"objOrders.EmployeeID\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objOrders.EmployeeID\" *ngIf=\"!objOrders.EmployeeID\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of EmployeesList\" [value]=\"item.EmployeeID\">\r\n\t\t\t\t\t\t\t\t\t{{item.LastName}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"OrderDate.touched && OrderDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"OrderDate\" class=\"col-xs-3 col-sm-2 control-label\">Order Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<datepicker-dropdown #OrderDate=\"ngModel\" [control]=\"OrderDate\"  \r\n\t\t\t\t\t\t\t\t\t[(ngModel)]=\"objOrders.OrderDate\" name=\"OrderDate\" [required]=\"true\" ></datepicker-dropdown>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"OrderDate.touched && OrderDate.errors && OrderDate.errors.required\">Order Date is required.</div>\r\n\t\t\t\t\t\t\t<!--\r\n\t\t\t\t\t\t\t<input #OrderDate=\"ngModel\" name=\"OrderDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Order Date\" [(ngModel)]=\"objOrders.OrderDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"OrderDate.touched && OrderDate.invalid\">Order Date is required.</div>\r\n\t\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"RequiredDate.touched && RequiredDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"RequiredDate\" class=\"col-xs-3 col-sm-2 control-label\">Required Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<datepicker-dropdown #RequiredDate=\"ngModel\" [control]=\"RequiredDate\"  \r\n\t\t\t\t\t\t\t\t\t[(ngModel)]=\"objOrders.RequiredDate\" name=\"RequiredDate\" [required]=\"true\" ></datepicker-dropdown>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"RequiredDate.touched && RequiredDate.errors && RequiredDate.errors.required\">Required Date is required.</div>\r\n\t\t\t\t\t\t\t<!--\r\n\t\t\t\t\t\t\t<input #RequiredDate=\"ngModel\" name=\"RequiredDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Required Date\" [(ngModel)]=\"objOrders.RequiredDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"RequiredDate.touched && RequiredDate.invalid\">Required Date is required.</div>\r\n\t\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShippedDate.touched && ShippedDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShippedDate\" class=\"col-xs-3 col-sm-2 control-label\">Shipped Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<datepicker-dropdown #ShippedDate=\"ngModel\" [control]=\"ShippedDate\"  \r\n\t\t\t\t\t\t\t\t\t[(ngModel)]=\"objOrders.ShippedDate\" name=\"ShippedDate\" [required]=\"true\" ></datepicker-dropdown>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShippedDate.touched && ShippedDate.errors && ShippedDate.errors.required\">Shipped Date is required.</div>\r\n\t\t\t\t\t\t\t<!--\r\n\t\t\t\t\t\t\t<input #ShippedDate=\"ngModel\" name=\"ShippedDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipped Date\" [(ngModel)]=\"objOrders.ShippedDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShippedDate.touched && ShippedDate.invalid\">Shipped Date is required.</div>\r\n\t\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Shipvia:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"ShipVia\" name=\"ShipVia\" class=\"form-control\" [(ngModel)]=\"objOrders.ShipVia\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objOrders.ShipVia\" *ngIf=\"!objOrders.ShipVia\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of ShippersList\" [value]=\"item.ShipperID\">\r\n\t\t\t\t\t\t\t\t\t{{item.CompanyName}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Freight.touched && Freight.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Freight\" class=\"col-xs-3 col-sm-2 control-label\">Freight:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Freight=\"ngModel\" name=\"Freight\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Freight\" [(ngModel)]=\"objOrders.Freight\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Freight.touched && Freight.invalid\">Freight must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipName.touched && ShipName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipName\" class=\"col-xs-3 col-sm-2 control-label\">Ship Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipName=\"ngModel\" name=\"ShipName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Ship Name\" [(ngModel)]=\"objOrders.ShipName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipName.touched && ShipName.invalid\">Ship Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipAddress.touched && ShipAddress.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipAddress\" class=\"col-xs-3 col-sm-2 control-label\">Shipaddress:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipAddress=\"ngModel\" name=\"ShipAddress\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipaddress\" [(ngModel)]=\"objOrders.ShipAddress\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipAddress.touched && ShipAddress.invalid\">Shipaddress is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipCity.touched && ShipCity.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipCity\" class=\"col-xs-3 col-sm-2 control-label\">Shipcity:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipCity=\"ngModel\" name=\"ShipCity\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipcity\" [(ngModel)]=\"objOrders.ShipCity\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipCity.touched && ShipCity.invalid\">Shipcity is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipRegion.touched && ShipRegion.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipRegion\" class=\"col-xs-3 col-sm-2 control-label\">Shipregion:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipRegion=\"ngModel\" name=\"ShipRegion\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipregion\" [(ngModel)]=\"objOrders.ShipRegion\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipRegion.touched && ShipRegion.invalid\">Shipregion is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipPostalCode.touched && ShipPostalCode.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipPostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Shippostal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipPostalCode=\"ngModel\" name=\"ShipPostalCode\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shippostal Code\" [(ngModel)]=\"objOrders.ShipPostalCode\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipPostalCode.touched && ShipPostalCode.invalid\">Shippostal Code is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipCountry.touched && ShipCountry.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipCountry\" class=\"col-xs-3 col-sm-2 control-label\">Shipcountry:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipCountry=\"ngModel\" name=\"ShipCountry\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipcountry\" [(ngModel)]=\"objOrders.ShipCountry\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipCountry.touched && ShipCountry.invalid\">Shipcountry is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"updateOrders()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoOrders()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" type=\"submit\" (click)=\"deleteOrders(objOrders.OrderID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1079 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>Orders List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<OrdersSearch (filterCriteria)=\"onSearch($event)\" ></OrdersSearch>\r\n\t\t</div>\r\n\t</div>\r\n\t\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" routerLink=\"/Orders/add\" routerLinkActive=\"active\" title=\"Add Orders\"><i class=\"glyphicon glyphicon-plus\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Delete List(s)\"><i class=\"glyphicon glyphicon-remove\"></i></a-->\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr>\r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'OrderID')\">Order Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CustomerID')\">Customer Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'EmployeeID')\">Employee Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'OrderDate')\">Order Date</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'RequiredDate')\">Required Date</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShippedDate')\">Shipped Date</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShipVia')\">Shipvia</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Freight')\">Freight</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShipName')\">Ship Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShipAddress')\">Shipaddress</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShipCity')\">Shipcity</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShipRegion')\">Shipregion</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShipPostalCode')\">Shippostal Code</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShipCountry')\">Shipcountry</a></th>\r\n\r\n\t\t</tr>\r\n\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of OrdersList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelect(item)\">Edit</a>\r\n\t\t\t\t\t<a (click)=\"deleteOrders(item.OrderID)\">Delete</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.OrderID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.CustomerID}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.EmployeeID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.OrderDate}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.RequiredDate}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShippedDate}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.ShipVia}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.Freight}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShipName}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShipAddress}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShipCity}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShipRegion}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShipPostalCode}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShipCountry}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1080 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch Orders\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"OrderID.touched && OrderID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"OrderID\" class=\"col-xs-3 col-sm-2 control-label\">Order Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #OrderID=\"ngModel\" name=\"OrderID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Order Id\" [(ngModel)]=\"objOrders.OrderID\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"OrderID.touched && OrderID.invalid\">Order Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CustomerID.touched && CustomerID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CustomerID\" class=\"col-xs-3 col-sm-2 control-label\">Customer Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CustomerID=\"ngModel\" name=\"CustomerID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Customer Id\" [(ngModel)]=\"objOrders.CustomerID\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CustomerID.touched && CustomerID.invalid\">Customer Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Employee Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"EmployeeID\" name=\"EmployeeID\" class=\"form-control\" [(ngModel)]=\"objOrders.EmployeeID\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objOrders.EmployeeID\" *ngIf=\"!objOrders.EmployeeID\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of EmployeesList\" [value]=\"item.EmployeeID\">\r\n\t\t\t\t\t\t\t\t\t{{item.LastName}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"OrderDate.touched && OrderDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"OrderDate\" class=\"col-xs-3 col-sm-2 control-label\">Order Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<datepicker-dropdown #OrderDate=\"ngModel\" [control]=\"OrderDate\"  \r\n\t\t\t\t\t\t\t\t\t[(ngModel)]=\"objOrders.OrderDate\" name=\"OrderDate\" [required]=\"true\" ></datepicker-dropdown>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"OrderDate.touched && OrderDate.errors && OrderDate.errors.required\">Order Date is required.</div>\r\n\t\t\t\t\t\t\t<!--\r\n\t\t\t\t\t\t\t<input #OrderDate=\"ngModel\" name=\"OrderDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Order Date\" [(ngModel)]=\"objOrders.OrderDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"OrderDate.touched && OrderDate.invalid\">Order Date is required.</div>\r\n\t\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"RequiredDate.touched && RequiredDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"RequiredDate\" class=\"col-xs-3 col-sm-2 control-label\">Required Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<datepicker-dropdown #RequiredDate=\"ngModel\" [control]=\"RequiredDate\"  \r\n\t\t\t\t\t\t\t\t\t[(ngModel)]=\"objOrders.RequiredDate\" name=\"RequiredDate\" [required]=\"true\" ></datepicker-dropdown>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"RequiredDate.touched && RequiredDate.errors && RequiredDate.errors.required\">Required Date is required.</div>\r\n\t\t\t\t\t\t\t<!--\r\n\t\t\t\t\t\t\t<input #RequiredDate=\"ngModel\" name=\"RequiredDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Required Date\" [(ngModel)]=\"objOrders.RequiredDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"RequiredDate.touched && RequiredDate.invalid\">Required Date is required.</div>\r\n\t\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShippedDate.touched && ShippedDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShippedDate\" class=\"col-xs-3 col-sm-2 control-label\">Shipped Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<datepicker-dropdown #ShippedDate=\"ngModel\" [control]=\"ShippedDate\"  \r\n\t\t\t\t\t\t\t\t\t[(ngModel)]=\"objOrders.ShippedDate\" name=\"ShippedDate\" [required]=\"true\" ></datepicker-dropdown>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShippedDate.touched && ShippedDate.errors && ShippedDate.errors.required\">Shipped Date is required.</div>\r\n\t\t\t\t\t\t\t<!--\r\n\t\t\t\t\t\t\t<input #ShippedDate=\"ngModel\" name=\"ShippedDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipped Date\" [(ngModel)]=\"objOrders.ShippedDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShippedDate.touched && ShippedDate.invalid\">Shipped Date is required.</div>\r\n\t\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Shipvia:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"ShipVia\" name=\"ShipVia\" class=\"form-control\" [(ngModel)]=\"objOrders.ShipVia\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objOrders.ShipVia\" *ngIf=\"!objOrders.ShipVia\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of ShippersList\" [value]=\"item.ShipperID\">\r\n\t\t\t\t\t\t\t\t\t{{item.CompanyName}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Freight.touched && Freight.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Freight\" class=\"col-xs-3 col-sm-2 control-label\">Freight:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Freight=\"ngModel\" name=\"Freight\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Freight\" [(ngModel)]=\"objOrders.Freight\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Freight.touched && Freight.invalid\">Freight must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipName.touched && ShipName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipName\" class=\"col-xs-3 col-sm-2 control-label\">Ship Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipName=\"ngModel\" name=\"ShipName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Ship Name\" [(ngModel)]=\"objOrders.ShipName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipName.touched && ShipName.invalid\">Ship Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipAddress.touched && ShipAddress.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipAddress\" class=\"col-xs-3 col-sm-2 control-label\">Shipaddress:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipAddress=\"ngModel\" name=\"ShipAddress\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipaddress\" [(ngModel)]=\"objOrders.ShipAddress\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipAddress.touched && ShipAddress.invalid\">Shipaddress is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipCity.touched && ShipCity.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipCity\" class=\"col-xs-3 col-sm-2 control-label\">Shipcity:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipCity=\"ngModel\" name=\"ShipCity\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipcity\" [(ngModel)]=\"objOrders.ShipCity\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipCity.touched && ShipCity.invalid\">Shipcity is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipRegion.touched && ShipRegion.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipRegion\" class=\"col-xs-3 col-sm-2 control-label\">Shipregion:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipRegion=\"ngModel\" name=\"ShipRegion\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipregion\" [(ngModel)]=\"objOrders.ShipRegion\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipRegion.touched && ShipRegion.invalid\">Shipregion is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipPostalCode.touched && ShipPostalCode.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipPostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Shippostal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipPostalCode=\"ngModel\" name=\"ShipPostalCode\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shippostal Code\" [(ngModel)]=\"objOrders.ShipPostalCode\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipPostalCode.touched && ShipPostalCode.invalid\">Shippostal Code is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipCountry.touched && ShipCountry.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipCountry\" class=\"col-xs-3 col-sm-2 control-label\">Shipcountry:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipCountry=\"ngModel\" name=\"ShipCountry\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipcountry\" [(ngModel)]=\"objOrders.ShipCountry\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipCountry.touched && ShipCountry.invalid\">Shipcountry is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1081 */
/***/ function(module, exports) {

module.exports = "<h2>ProductSalesfor1997 Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">ProductSalesfor1997 Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CategoryName\" class=\"col-xs-3 col-sm-2 control-label\">Category Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CategoryName\" name=\"CategoryName\" placeholder=\"Category Name\" [(ngModel)]=\"objProductSalesfor1997.CategoryName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ProductName\" class=\"col-xs-3 col-sm-2 control-label\">Product Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ProductName\" name=\"ProductName\" placeholder=\"Product Name\" [(ngModel)]=\"objProductSalesfor1997.ProductName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ProductSales\" class=\"col-xs-3 col-sm-2 control-label\">Productsales:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ProductSales\" name=\"ProductSales\" placeholder=\"Productsales\" [(ngModel)]=\"objProductSalesfor1997.ProductSales\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoProductSalesfor1997()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1082 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>ProductSalesfor1997 List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\t\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<ProductSalesfor1997Search (filterCriteria)=\"onSearch($event)\" ></ProductSalesfor1997Search>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}\r\n\t\t\t\t</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr> \r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CategoryName')\">Category Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ProductName')\">Product Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ProductSales')\">Productsales</a></th>\r\n\r\n\t\t</tr>\r\n\t\t\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of ProductSalesfor1997List\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelectDetails(item)\">Details</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.CategoryName}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ProductName}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.ProductSales}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1083 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch ProductSalesfor1997\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CategoryName.touched && CategoryName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CategoryName\" class=\"col-xs-3 col-sm-2 control-label\">Category Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CategoryName=\"ngModel\" name=\"CategoryName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Category Name\" [(ngModel)]=\"objProductSalesfor1997.CategoryName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CategoryName.touched && CategoryName.invalid\">Category Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ProductName.touched && ProductName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ProductName\" class=\"col-xs-3 col-sm-2 control-label\">Product Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ProductName=\"ngModel\" name=\"ProductName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Product Name\" [(ngModel)]=\"objProductSalesfor1997.ProductName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ProductName.touched && ProductName.invalid\">Product Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ProductSales.touched && ProductSales.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ProductSales\" class=\"col-xs-3 col-sm-2 control-label\">Productsales:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ProductSales=\"ngModel\" name=\"ProductSales\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Productsales\" [(ngModel)]=\"objProductSalesfor1997.ProductSales\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ProductSales.touched && ProductSales.invalid\">Productsales must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1084 */
/***/ function(module, exports) {

module.exports = "<h2>ProductsAboveAveragePrice Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">ProductsAboveAveragePrice Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ProductName\" class=\"col-xs-3 col-sm-2 control-label\">Product Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ProductName\" name=\"ProductName\" placeholder=\"Product Name\" [(ngModel)]=\"objProductsAboveAveragePrice.ProductName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"UnitPrice\" class=\"col-xs-3 col-sm-2 control-label\">Unitprice:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"UnitPrice\" name=\"UnitPrice\" placeholder=\"Unitprice\" [(ngModel)]=\"objProductsAboveAveragePrice.UnitPrice\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoProductsAboveAveragePrice()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1085 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>ProductsAboveAveragePrice List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\t\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<ProductsAboveAveragePriceSearch (filterCriteria)=\"onSearch($event)\" ></ProductsAboveAveragePriceSearch>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}\r\n\t\t\t\t</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr> \r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ProductName')\">Product Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'UnitPrice')\">Unitprice</a></th>\r\n\r\n\t\t</tr>\r\n\t\t\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of ProductsAboveAveragePriceList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelectDetails(item)\">Details</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ProductName}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.UnitPrice}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1086 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch ProductsAboveAveragePrice\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ProductName.touched && ProductName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ProductName\" class=\"col-xs-3 col-sm-2 control-label\">Product Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ProductName=\"ngModel\" name=\"ProductName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Product Name\" [(ngModel)]=\"objProductsAboveAveragePrice.ProductName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ProductName.touched && ProductName.invalid\">Product Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"UnitPrice.touched && UnitPrice.invalid\" >\r\n\t\t\t\t\t\t<label for=\"UnitPrice\" class=\"col-xs-3 col-sm-2 control-label\">Unitprice:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #UnitPrice=\"ngModel\" name=\"UnitPrice\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Unitprice\" [(ngModel)]=\"objProductsAboveAveragePrice.UnitPrice\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"UnitPrice.touched && UnitPrice.invalid\">Unitprice must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1087 */
/***/ function(module, exports) {

module.exports = "<h2>Add Products</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Products Add</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ProductID.touched && ProductID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ProductID\" class=\"col-xs-3 col-sm-2 control-label\">Product Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ProductID=\"ngModel\" name=\"ProductID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Product Id\" [(ngModel)]=\"objProducts.ProductID\" pattern=\"^(0|[1-9][0-9]*)$\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ProductID.touched && ProductID.invalid\">Product Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ProductName.touched && ProductName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ProductName\" class=\"col-xs-3 col-sm-2 control-label\">Product Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ProductName=\"ngModel\" name=\"ProductName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Product Name\" [(ngModel)]=\"objProducts.ProductName\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ProductName.touched && ProductName.invalid\">Product Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Supplier Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"SupplierID\" name=\"SupplierID\" class=\"form-control\" [(ngModel)]=\"objProducts.SupplierID\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objProducts.SupplierID\" *ngIf=\"!objProducts.SupplierID\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of SuppliersList\" [value]=\"item.SupplierID\">\r\n\t\t\t\t\t\t\t\t\t{{item.CompanyName}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Category Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"CategoryID\" name=\"CategoryID\" class=\"form-control\" [(ngModel)]=\"objProducts.CategoryID\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objProducts.CategoryID\" *ngIf=\"!objProducts.CategoryID\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of CategoriesList\" [value]=\"item.CategoryID\">\r\n\t\t\t\t\t\t\t\t\t{{item.CategoryName}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"QuantityPerUnit.touched && QuantityPerUnit.invalid\" >\r\n\t\t\t\t\t\t<label for=\"QuantityPerUnit\" class=\"col-xs-3 col-sm-2 control-label\">Quantityperunit:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #QuantityPerUnit=\"ngModel\" name=\"QuantityPerUnit\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Quantityperunit\" [(ngModel)]=\"objProducts.QuantityPerUnit\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"QuantityPerUnit.touched && QuantityPerUnit.invalid\">Quantityperunit is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"UnitPrice.touched && UnitPrice.invalid\" >\r\n\t\t\t\t\t\t<label for=\"UnitPrice\" class=\"col-xs-3 col-sm-2 control-label\">Unitprice:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #UnitPrice=\"ngModel\" name=\"UnitPrice\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Unitprice\" [(ngModel)]=\"objProducts.UnitPrice\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"UnitPrice.touched && UnitPrice.invalid\">Unitprice must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"UnitsInStock.touched && UnitsInStock.invalid\" >\r\n\t\t\t\t\t\t<label for=\"UnitsInStock\" class=\"col-xs-3 col-sm-2 control-label\">Unitsinstock:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #UnitsInStock=\"ngModel\" name=\"UnitsInStock\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Unitsinstock\" [(ngModel)]=\"objProducts.UnitsInStock\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"UnitsInStock.touched && UnitsInStock.invalid\">Unitsinstock must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"UnitsOnOrder.touched && UnitsOnOrder.invalid\" >\r\n\t\t\t\t\t\t<label for=\"UnitsOnOrder\" class=\"col-xs-3 col-sm-2 control-label\">Unitsonorder:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #UnitsOnOrder=\"ngModel\" name=\"UnitsOnOrder\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Unitsonorder\" [(ngModel)]=\"objProducts.UnitsOnOrder\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"UnitsOnOrder.touched && UnitsOnOrder.invalid\">Unitsonorder must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ReorderLevel.touched && ReorderLevel.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ReorderLevel\" class=\"col-xs-3 col-sm-2 control-label\">Reorderlevel:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ReorderLevel=\"ngModel\" name=\"ReorderLevel\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Reorderlevel\" [(ngModel)]=\"objProducts.ReorderLevel\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ReorderLevel.touched && ReorderLevel.invalid\">Reorderlevel must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"chkDiscontinued\" class=\"col-xs-3 col-sm-2 control-label\">Discontinued:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t\t\t\t\t<input id=\"chkDiscontinued\" name=\"chkDiscontinued\" type=\"checkbox\" placeholder=\"Discontinued\" [(ngModel)]=\"objProducts.Discontinued\">\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"addProducts()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoProducts()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1088 */
/***/ function(module, exports) {

module.exports = "<h2>Products Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Products Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ProductID\" class=\"col-xs-3 col-sm-2 control-label\">Product Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ProductID\" name=\"ProductID\" placeholder=\"Product Id\" [(ngModel)]=\"objProducts.ProductID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ProductName\" class=\"col-xs-3 col-sm-2 control-label\">Product Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ProductName\" name=\"ProductName\" placeholder=\"Product Name\" [(ngModel)]=\"objProducts.ProductName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"SupplierID\" class=\"col-xs-3 col-sm-2 control-label\">Supplier Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"SupplierID\" name=\"SupplierID\" placeholder=\"Supplier Id\" [(ngModel)]=\"objProducts.SupplierID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CategoryID\" class=\"col-xs-3 col-sm-2 control-label\">Category Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CategoryID\" name=\"CategoryID\" placeholder=\"Category Id\" [(ngModel)]=\"objProducts.CategoryID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"QuantityPerUnit\" class=\"col-xs-3 col-sm-2 control-label\">Quantityperunit:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"QuantityPerUnit\" name=\"QuantityPerUnit\" placeholder=\"Quantityperunit\" [(ngModel)]=\"objProducts.QuantityPerUnit\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"UnitPrice\" class=\"col-xs-3 col-sm-2 control-label\">Unitprice:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"UnitPrice\" name=\"UnitPrice\" placeholder=\"Unitprice\" [(ngModel)]=\"objProducts.UnitPrice\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"UnitsInStock\" class=\"col-xs-3 col-sm-2 control-label\">Unitsinstock:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"UnitsInStock\" name=\"UnitsInStock\" placeholder=\"Unitsinstock\" [(ngModel)]=\"objProducts.UnitsInStock\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"UnitsOnOrder\" class=\"col-xs-3 col-sm-2 control-label\">Unitsonorder:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"UnitsOnOrder\" name=\"UnitsOnOrder\" placeholder=\"Unitsonorder\" [(ngModel)]=\"objProducts.UnitsOnOrder\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ReorderLevel\" class=\"col-xs-3 col-sm-2 control-label\">Reorderlevel:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ReorderLevel\" name=\"ReorderLevel\" placeholder=\"Reorderlevel\" [(ngModel)]=\"objProducts.ReorderLevel\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Discontinued\" class=\"col-xs-3 col-sm-2 control-label\">Discontinued:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Discontinued\" name=\"Discontinued\" placeholder=\"Discontinued\" [(ngModel)]=\"objProducts.Discontinued\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"gotoProductsEdit()\">Edit</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoProducts()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" (click)=\"deleteProducts(objProducts.ProductID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1089 */
/***/ function(module, exports) {

module.exports = "<h2>Edit Products</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Products Edit</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ProductID.touched && ProductID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ProductID\" class=\"col-xs-3 col-sm-2 control-label\">Product Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ProductID=\"ngModel\" name=\"ProductID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Product Id\" [(ngModel)]=\"objProducts.ProductID\" pattern=\"^(0|[1-9][0-9]*)$\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ProductID.touched && ProductID.invalid\">Product Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ProductName.touched && ProductName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ProductName\" class=\"col-xs-3 col-sm-2 control-label\">Product Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ProductName=\"ngModel\" name=\"ProductName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Product Name\" [(ngModel)]=\"objProducts.ProductName\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ProductName.touched && ProductName.invalid\">Product Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Supplier Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"SupplierID\" name=\"SupplierID\" class=\"form-control\" [(ngModel)]=\"objProducts.SupplierID\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objProducts.SupplierID\" *ngIf=\"!objProducts.SupplierID\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of SuppliersList\" [value]=\"item.SupplierID\">\r\n\t\t\t\t\t\t\t\t\t{{item.CompanyName}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Category Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"CategoryID\" name=\"CategoryID\" class=\"form-control\" [(ngModel)]=\"objProducts.CategoryID\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objProducts.CategoryID\" *ngIf=\"!objProducts.CategoryID\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of CategoriesList\" [value]=\"item.CategoryID\">\r\n\t\t\t\t\t\t\t\t\t{{item.CategoryName}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"QuantityPerUnit.touched && QuantityPerUnit.invalid\" >\r\n\t\t\t\t\t\t<label for=\"QuantityPerUnit\" class=\"col-xs-3 col-sm-2 control-label\">Quantityperunit:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #QuantityPerUnit=\"ngModel\" name=\"QuantityPerUnit\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Quantityperunit\" [(ngModel)]=\"objProducts.QuantityPerUnit\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"QuantityPerUnit.touched && QuantityPerUnit.invalid\">Quantityperunit is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"UnitPrice.touched && UnitPrice.invalid\" >\r\n\t\t\t\t\t\t<label for=\"UnitPrice\" class=\"col-xs-3 col-sm-2 control-label\">Unitprice:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #UnitPrice=\"ngModel\" name=\"UnitPrice\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Unitprice\" [(ngModel)]=\"objProducts.UnitPrice\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"UnitPrice.touched && UnitPrice.invalid\">Unitprice must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"UnitsInStock.touched && UnitsInStock.invalid\" >\r\n\t\t\t\t\t\t<label for=\"UnitsInStock\" class=\"col-xs-3 col-sm-2 control-label\">Unitsinstock:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #UnitsInStock=\"ngModel\" name=\"UnitsInStock\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Unitsinstock\" [(ngModel)]=\"objProducts.UnitsInStock\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"UnitsInStock.touched && UnitsInStock.invalid\">Unitsinstock must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"UnitsOnOrder.touched && UnitsOnOrder.invalid\" >\r\n\t\t\t\t\t\t<label for=\"UnitsOnOrder\" class=\"col-xs-3 col-sm-2 control-label\">Unitsonorder:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #UnitsOnOrder=\"ngModel\" name=\"UnitsOnOrder\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Unitsonorder\" [(ngModel)]=\"objProducts.UnitsOnOrder\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"UnitsOnOrder.touched && UnitsOnOrder.invalid\">Unitsonorder must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ReorderLevel.touched && ReorderLevel.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ReorderLevel\" class=\"col-xs-3 col-sm-2 control-label\">Reorderlevel:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ReorderLevel=\"ngModel\" name=\"ReorderLevel\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Reorderlevel\" [(ngModel)]=\"objProducts.ReorderLevel\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ReorderLevel.touched && ReorderLevel.invalid\">Reorderlevel must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"chkDiscontinued\" class=\"col-xs-3 col-sm-2 control-label\">Discontinued:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t\t\t\t\t<input id=\"chkDiscontinued\" name=\"chkDiscontinued\" type=\"checkbox\" placeholder=\"Discontinued\" [(ngModel)]=\"objProducts.Discontinued\">\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"updateProducts()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoProducts()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" type=\"submit\" (click)=\"deleteProducts(objProducts.ProductID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1090 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>Products List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<ProductsSearch (filterCriteria)=\"onSearch($event)\" ></ProductsSearch>\r\n\t\t</div>\r\n\t</div>\r\n\t\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" routerLink=\"/Products/add\" routerLinkActive=\"active\" title=\"Add Products\"><i class=\"glyphicon glyphicon-plus\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Delete List(s)\"><i class=\"glyphicon glyphicon-remove\"></i></a-->\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr>\r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ProductID')\">Product Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ProductName')\">Product Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'SupplierID')\">Supplier Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CategoryID')\">Category Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'QuantityPerUnit')\">Quantityperunit</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'UnitPrice')\">Unitprice</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'UnitsInStock')\">Unitsinstock</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'UnitsOnOrder')\">Unitsonorder</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ReorderLevel')\">Reorderlevel</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Discontinued')\">Discontinued</a></th>\r\n\r\n\t\t</tr>\r\n\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of ProductsList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelect(item)\">Edit</a>\r\n\t\t\t\t\t<a (click)=\"deleteProducts(item.ProductID)\">Delete</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.ProductID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ProductName}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.SupplierID}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.CategoryID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.QuantityPerUnit}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.UnitPrice}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.UnitsInStock}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.UnitsOnOrder}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.ReorderLevel}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Discontinued}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1091 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch Products\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ProductID.touched && ProductID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ProductID\" class=\"col-xs-3 col-sm-2 control-label\">Product Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ProductID=\"ngModel\" name=\"ProductID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Product Id\" [(ngModel)]=\"objProducts.ProductID\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ProductID.touched && ProductID.invalid\">Product Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ProductName.touched && ProductName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ProductName\" class=\"col-xs-3 col-sm-2 control-label\">Product Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ProductName=\"ngModel\" name=\"ProductName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Product Name\" [(ngModel)]=\"objProducts.ProductName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ProductName.touched && ProductName.invalid\">Product Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Supplier Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"SupplierID\" name=\"SupplierID\" class=\"form-control\" [(ngModel)]=\"objProducts.SupplierID\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objProducts.SupplierID\" *ngIf=\"!objProducts.SupplierID\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of SuppliersList\" [value]=\"item.SupplierID\">\r\n\t\t\t\t\t\t\t\t\t{{item.CompanyName}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Category Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"CategoryID\" name=\"CategoryID\" class=\"form-control\" [(ngModel)]=\"objProducts.CategoryID\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objProducts.CategoryID\" *ngIf=\"!objProducts.CategoryID\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of CategoriesList\" [value]=\"item.CategoryID\">\r\n\t\t\t\t\t\t\t\t\t{{item.CategoryName}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"QuantityPerUnit.touched && QuantityPerUnit.invalid\" >\r\n\t\t\t\t\t\t<label for=\"QuantityPerUnit\" class=\"col-xs-3 col-sm-2 control-label\">Quantityperunit:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #QuantityPerUnit=\"ngModel\" name=\"QuantityPerUnit\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Quantityperunit\" [(ngModel)]=\"objProducts.QuantityPerUnit\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"QuantityPerUnit.touched && QuantityPerUnit.invalid\">Quantityperunit is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"UnitPrice.touched && UnitPrice.invalid\" >\r\n\t\t\t\t\t\t<label for=\"UnitPrice\" class=\"col-xs-3 col-sm-2 control-label\">Unitprice:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #UnitPrice=\"ngModel\" name=\"UnitPrice\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Unitprice\" [(ngModel)]=\"objProducts.UnitPrice\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"UnitPrice.touched && UnitPrice.invalid\">Unitprice must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"UnitsInStock.touched && UnitsInStock.invalid\" >\r\n\t\t\t\t\t\t<label for=\"UnitsInStock\" class=\"col-xs-3 col-sm-2 control-label\">Unitsinstock:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #UnitsInStock=\"ngModel\" name=\"UnitsInStock\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Unitsinstock\" [(ngModel)]=\"objProducts.UnitsInStock\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"UnitsInStock.touched && UnitsInStock.invalid\">Unitsinstock must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"UnitsOnOrder.touched && UnitsOnOrder.invalid\" >\r\n\t\t\t\t\t\t<label for=\"UnitsOnOrder\" class=\"col-xs-3 col-sm-2 control-label\">Unitsonorder:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #UnitsOnOrder=\"ngModel\" name=\"UnitsOnOrder\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Unitsonorder\" [(ngModel)]=\"objProducts.UnitsOnOrder\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"UnitsOnOrder.touched && UnitsOnOrder.invalid\">Unitsonorder must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ReorderLevel.touched && ReorderLevel.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ReorderLevel\" class=\"col-xs-3 col-sm-2 control-label\">Reorderlevel:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ReorderLevel=\"ngModel\" name=\"ReorderLevel\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Reorderlevel\" [(ngModel)]=\"objProducts.ReorderLevel\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ReorderLevel.touched && ReorderLevel.invalid\">Reorderlevel must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"chkDiscontinued\" class=\"col-xs-3 col-sm-2 control-label\">Discontinued:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t\t\t\t\t<input id=\"chkDiscontinued\" name=\"chkDiscontinued\" type=\"checkbox\" placeholder=\"Discontinued\" [(ngModel)]=\"objProducts.Discontinued\">\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1092 */
/***/ function(module, exports) {

module.exports = "<h2>ProductsbyCategory Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">ProductsbyCategory Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CategoryName\" class=\"col-xs-3 col-sm-2 control-label\">Category Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CategoryName\" name=\"CategoryName\" placeholder=\"Category Name\" [(ngModel)]=\"objProductsbyCategory.CategoryName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ProductName\" class=\"col-xs-3 col-sm-2 control-label\">Product Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ProductName\" name=\"ProductName\" placeholder=\"Product Name\" [(ngModel)]=\"objProductsbyCategory.ProductName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"QuantityPerUnit\" class=\"col-xs-3 col-sm-2 control-label\">Quantityperunit:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"QuantityPerUnit\" name=\"QuantityPerUnit\" placeholder=\"Quantityperunit\" [(ngModel)]=\"objProductsbyCategory.QuantityPerUnit\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"UnitsInStock\" class=\"col-xs-3 col-sm-2 control-label\">Unitsinstock:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"UnitsInStock\" name=\"UnitsInStock\" placeholder=\"Unitsinstock\" [(ngModel)]=\"objProductsbyCategory.UnitsInStock\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Discontinued\" class=\"col-xs-3 col-sm-2 control-label\">Discontinued:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Discontinued\" name=\"Discontinued\" placeholder=\"Discontinued\" [(ngModel)]=\"objProductsbyCategory.Discontinued\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoProductsbyCategory()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1093 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>ProductsbyCategory List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\t\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<ProductsbyCategorySearch (filterCriteria)=\"onSearch($event)\" ></ProductsbyCategorySearch>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}\r\n\t\t\t\t</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr> \r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CategoryName')\">Category Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ProductName')\">Product Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'QuantityPerUnit')\">Quantityperunit</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'UnitsInStock')\">Unitsinstock</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Discontinued')\">Discontinued</a></th>\r\n\r\n\t\t</tr>\r\n\t\t\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of ProductsbyCategoryList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelectDetails(item)\">Details</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.CategoryName}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ProductName}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.QuantityPerUnit}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.UnitsInStock}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Discontinued}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1094 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch ProductsbyCategory\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CategoryName.touched && CategoryName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CategoryName\" class=\"col-xs-3 col-sm-2 control-label\">Category Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CategoryName=\"ngModel\" name=\"CategoryName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Category Name\" [(ngModel)]=\"objProductsbyCategory.CategoryName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CategoryName.touched && CategoryName.invalid\">Category Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ProductName.touched && ProductName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ProductName\" class=\"col-xs-3 col-sm-2 control-label\">Product Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ProductName=\"ngModel\" name=\"ProductName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Product Name\" [(ngModel)]=\"objProductsbyCategory.ProductName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ProductName.touched && ProductName.invalid\">Product Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"QuantityPerUnit.touched && QuantityPerUnit.invalid\" >\r\n\t\t\t\t\t\t<label for=\"QuantityPerUnit\" class=\"col-xs-3 col-sm-2 control-label\">Quantityperunit:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #QuantityPerUnit=\"ngModel\" name=\"QuantityPerUnit\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Quantityperunit\" [(ngModel)]=\"objProductsbyCategory.QuantityPerUnit\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"QuantityPerUnit.touched && QuantityPerUnit.invalid\">Quantityperunit is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"UnitsInStock.touched && UnitsInStock.invalid\" >\r\n\t\t\t\t\t\t<label for=\"UnitsInStock\" class=\"col-xs-3 col-sm-2 control-label\">Unitsinstock:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #UnitsInStock=\"ngModel\" name=\"UnitsInStock\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Unitsinstock\" [(ngModel)]=\"objProductsbyCategory.UnitsInStock\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"UnitsInStock.touched && UnitsInStock.invalid\">Unitsinstock must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"chkDiscontinued\" class=\"col-xs-3 col-sm-2 control-label\">Discontinued:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t\t\t\t\t<input id=\"chkDiscontinued\" name=\"chkDiscontinued\" type=\"checkbox\" placeholder=\"Discontinued\" [(ngModel)]=\"objProductsbyCategory.Discontinued\">\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1095 */
/***/ function(module, exports) {

module.exports = "<h2>QuarterlyOrders Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">QuarterlyOrders Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CustomerID\" class=\"col-xs-3 col-sm-2 control-label\">Customer Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CustomerID\" name=\"CustomerID\" placeholder=\"Customer Id\" [(ngModel)]=\"objQuarterlyOrders.CustomerID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CompanyName\" class=\"col-xs-3 col-sm-2 control-label\">Company Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CompanyName\" name=\"CompanyName\" placeholder=\"Company Name\" [(ngModel)]=\"objQuarterlyOrders.CompanyName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"City\" class=\"col-xs-3 col-sm-2 control-label\">City:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"City\" name=\"City\" placeholder=\"City\" [(ngModel)]=\"objQuarterlyOrders.City\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Country\" class=\"col-xs-3 col-sm-2 control-label\">Country:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Country\" name=\"Country\" placeholder=\"Country\" [(ngModel)]=\"objQuarterlyOrders.Country\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoQuarterlyOrders()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1096 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>QuarterlyOrders List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\t\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<QuarterlyOrdersSearch (filterCriteria)=\"onSearch($event)\" ></QuarterlyOrdersSearch>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}\r\n\t\t\t\t</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr> \r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CustomerID')\">Customer Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CompanyName')\">Company Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'City')\">City</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Country')\">Country</a></th>\r\n\r\n\t\t</tr>\r\n\t\t\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of QuarterlyOrdersList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelectDetails(item)\">Details</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.CustomerID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.CompanyName}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.City}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Country}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1097 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch QuarterlyOrders\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CustomerID.touched && CustomerID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CustomerID\" class=\"col-xs-3 col-sm-2 control-label\">Customer Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CustomerID=\"ngModel\" name=\"CustomerID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Customer Id\" [(ngModel)]=\"objQuarterlyOrders.CustomerID\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CustomerID.touched && CustomerID.invalid\">Customer Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CompanyName.touched && CompanyName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CompanyName\" class=\"col-xs-3 col-sm-2 control-label\">Company Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CompanyName=\"ngModel\" name=\"CompanyName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Company Name\" [(ngModel)]=\"objQuarterlyOrders.CompanyName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CompanyName.touched && CompanyName.invalid\">Company Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"City.touched && City.invalid\" >\r\n\t\t\t\t\t\t<label for=\"City\" class=\"col-xs-3 col-sm-2 control-label\">City:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #City=\"ngModel\" name=\"City\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"City\" [(ngModel)]=\"objQuarterlyOrders.City\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"City.touched && City.invalid\">City is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Country.touched && Country.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Country\" class=\"col-xs-3 col-sm-2 control-label\">Country:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Country=\"ngModel\" name=\"Country\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Country\" [(ngModel)]=\"objQuarterlyOrders.Country\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Country.touched && Country.invalid\">Country is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1098 */
/***/ function(module, exports) {

module.exports = "<h2>Add Region</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Region Add</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"RegionID.touched && RegionID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"RegionID\" class=\"col-xs-3 col-sm-2 control-label\">Region Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #RegionID=\"ngModel\" name=\"RegionID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Region Id\" [(ngModel)]=\"objRegion.RegionID\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"RegionID.touched && RegionID.invalid\">Region Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"RegionDescription.touched && RegionDescription.invalid\" >\r\n\t\t\t\t\t\t<label for=\"RegionDescription\" class=\"col-xs-3 col-sm-2 control-label\">Region Description:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #RegionDescription=\"ngModel\" name=\"RegionDescription\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Region Description\" [(ngModel)]=\"objRegion.RegionDescription\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"RegionDescription.touched && RegionDescription.invalid\">Region Description is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"addRegion()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoRegion()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1099 */
/***/ function(module, exports) {

module.exports = "<h2>Region Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Region Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"RegionID\" class=\"col-xs-3 col-sm-2 control-label\">Region Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"RegionID\" name=\"RegionID\" placeholder=\"Region Id\" [(ngModel)]=\"objRegion.RegionID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"RegionDescription\" class=\"col-xs-3 col-sm-2 control-label\">Region Description:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"RegionDescription\" name=\"RegionDescription\" placeholder=\"Region Description\" [(ngModel)]=\"objRegion.RegionDescription\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"gotoRegionEdit()\">Edit</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoRegion()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" (click)=\"deleteRegion(objRegion.RegionID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1100 */
/***/ function(module, exports) {

module.exports = "<h2>Edit Region</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Region Edit</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"RegionID.touched && RegionID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"RegionID\" class=\"col-xs-3 col-sm-2 control-label\">Region Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #RegionID=\"ngModel\" name=\"RegionID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Region Id\" [(ngModel)]=\"objRegion.RegionID\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"RegionID.touched && RegionID.invalid\">Region Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"RegionDescription.touched && RegionDescription.invalid\" >\r\n\t\t\t\t\t\t<label for=\"RegionDescription\" class=\"col-xs-3 col-sm-2 control-label\">Region Description:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #RegionDescription=\"ngModel\" name=\"RegionDescription\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Region Description\" [(ngModel)]=\"objRegion.RegionDescription\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"RegionDescription.touched && RegionDescription.invalid\">Region Description is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"updateRegion()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoRegion()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" type=\"submit\" (click)=\"deleteRegion(objRegion.RegionID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1101 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>Region List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<RegionSearch (filterCriteria)=\"onSearch($event)\" ></RegionSearch>\r\n\t\t</div>\r\n\t</div>\r\n\t\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" routerLink=\"/Region/add\" routerLinkActive=\"active\" title=\"Add Region\"><i class=\"glyphicon glyphicon-plus\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Delete List(s)\"><i class=\"glyphicon glyphicon-remove\"></i></a-->\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr>\r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'RegionID')\">Region Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'RegionDescription')\">Region Description</a></th>\r\n\r\n\t\t</tr>\r\n\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of RegionList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelect(item)\">Edit</a>\r\n\t\t\t\t\t<a (click)=\"deleteRegion(item.RegionID)\">Delete</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.RegionID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.RegionDescription}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1102 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch Region\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"RegionID.touched && RegionID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"RegionID\" class=\"col-xs-3 col-sm-2 control-label\">Region Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #RegionID=\"ngModel\" name=\"RegionID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Region Id\" [(ngModel)]=\"objRegion.RegionID\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"RegionID.touched && RegionID.invalid\">Region Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"RegionDescription.touched && RegionDescription.invalid\" >\r\n\t\t\t\t\t\t<label for=\"RegionDescription\" class=\"col-xs-3 col-sm-2 control-label\">Region Description:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #RegionDescription=\"ngModel\" name=\"RegionDescription\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Region Description\" [(ngModel)]=\"objRegion.RegionDescription\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"RegionDescription.touched && RegionDescription.invalid\">Region Description is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1103 */
/***/ function(module, exports) {

module.exports = "<h2>SalesTotalsbyAmount Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">SalesTotalsbyAmount Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"SaleAmount\" class=\"col-xs-3 col-sm-2 control-label\">Saleamount:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"SaleAmount\" name=\"SaleAmount\" placeholder=\"Saleamount\" [(ngModel)]=\"objSalesTotalsbyAmount.SaleAmount\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"OrderID\" class=\"col-xs-3 col-sm-2 control-label\">Order Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"OrderID\" name=\"OrderID\" placeholder=\"Order Id\" [(ngModel)]=\"objSalesTotalsbyAmount.OrderID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CompanyName\" class=\"col-xs-3 col-sm-2 control-label\">Company Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CompanyName\" name=\"CompanyName\" placeholder=\"Company Name\" [(ngModel)]=\"objSalesTotalsbyAmount.CompanyName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShippedDate\" class=\"col-xs-3 col-sm-2 control-label\">Shipped Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShippedDate\" name=\"ShippedDate\" placeholder=\"Shipped Date\" [(ngModel)]=\"objSalesTotalsbyAmount.ShippedDate\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoSalesTotalsbyAmount()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1104 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>SalesTotalsbyAmount List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\t\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<SalesTotalsbyAmountSearch (filterCriteria)=\"onSearch($event)\" ></SalesTotalsbyAmountSearch>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}\r\n\t\t\t\t</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr> \r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'SaleAmount')\">Saleamount</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'OrderID')\">Order Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CompanyName')\">Company Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShippedDate')\">Shipped Date</a></th>\r\n\r\n\t\t</tr>\r\n\t\t\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of SalesTotalsbyAmountList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelectDetails(item)\">Details</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.SaleAmount}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.OrderID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.CompanyName}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShippedDate}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1105 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch SalesTotalsbyAmount\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"SaleAmount.touched && SaleAmount.invalid\" >\r\n\t\t\t\t\t\t<label for=\"SaleAmount\" class=\"col-xs-3 col-sm-2 control-label\">Saleamount:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #SaleAmount=\"ngModel\" name=\"SaleAmount\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Saleamount\" [(ngModel)]=\"objSalesTotalsbyAmount.SaleAmount\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"SaleAmount.touched && SaleAmount.invalid\">Saleamount is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"OrderID.touched && OrderID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"OrderID\" class=\"col-xs-3 col-sm-2 control-label\">Order Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #OrderID=\"ngModel\" name=\"OrderID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Order Id\" [(ngModel)]=\"objSalesTotalsbyAmount.OrderID\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"OrderID.touched && OrderID.invalid\">Order Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CompanyName.touched && CompanyName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CompanyName\" class=\"col-xs-3 col-sm-2 control-label\">Company Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CompanyName=\"ngModel\" name=\"CompanyName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Company Name\" [(ngModel)]=\"objSalesTotalsbyAmount.CompanyName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CompanyName.touched && CompanyName.invalid\">Company Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShippedDate.touched && ShippedDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShippedDate\" class=\"col-xs-3 col-sm-2 control-label\">Shipped Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<datepicker-dropdown #ShippedDate=\"ngModel\" [control]=\"ShippedDate\"  \r\n\t\t\t\t\t\t\t\t\t[(ngModel)]=\"objSalesTotalsbyAmount.ShippedDate\" name=\"ShippedDate\" [required]=\"true\" ></datepicker-dropdown>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShippedDate.touched && ShippedDate.errors && ShippedDate.errors.required\">Shipped Date is required.</div>\r\n\t\t\t\t\t\t\t<!--\r\n\t\t\t\t\t\t\t<input #ShippedDate=\"ngModel\" name=\"ShippedDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipped Date\" [(ngModel)]=\"objSalesTotalsbyAmount.ShippedDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShippedDate.touched && ShippedDate.invalid\">Shipped Date is required.</div>\r\n\t\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1106 */
/***/ function(module, exports) {

module.exports = "<h2>SalesbyCategory Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">SalesbyCategory Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CategoryID\" class=\"col-xs-3 col-sm-2 control-label\">Category Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CategoryID\" name=\"CategoryID\" placeholder=\"Category Id\" [(ngModel)]=\"objSalesbyCategory.CategoryID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CategoryName\" class=\"col-xs-3 col-sm-2 control-label\">Category Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CategoryName\" name=\"CategoryName\" placeholder=\"Category Name\" [(ngModel)]=\"objSalesbyCategory.CategoryName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ProductName\" class=\"col-xs-3 col-sm-2 control-label\">Product Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ProductName\" name=\"ProductName\" placeholder=\"Product Name\" [(ngModel)]=\"objSalesbyCategory.ProductName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ProductSales\" class=\"col-xs-3 col-sm-2 control-label\">Productsales:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ProductSales\" name=\"ProductSales\" placeholder=\"Productsales\" [(ngModel)]=\"objSalesbyCategory.ProductSales\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoSalesbyCategory()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1107 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>SalesbyCategory List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\t\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<SalesbyCategorySearch (filterCriteria)=\"onSearch($event)\" ></SalesbyCategorySearch>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}\r\n\t\t\t\t</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr> \r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CategoryID')\">Category Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CategoryName')\">Category Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ProductName')\">Product Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ProductSales')\">Productsales</a></th>\r\n\r\n\t\t</tr>\r\n\t\t\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of SalesbyCategoryList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelectDetails(item)\">Details</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.CategoryID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.CategoryName}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ProductName}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.ProductSales}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1108 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch SalesbyCategory\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CategoryID.touched && CategoryID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CategoryID\" class=\"col-xs-3 col-sm-2 control-label\">Category Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CategoryID=\"ngModel\" name=\"CategoryID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Category Id\" [(ngModel)]=\"objSalesbyCategory.CategoryID\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CategoryID.touched && CategoryID.invalid\">Category Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CategoryName.touched && CategoryName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CategoryName\" class=\"col-xs-3 col-sm-2 control-label\">Category Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CategoryName=\"ngModel\" name=\"CategoryName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Category Name\" [(ngModel)]=\"objSalesbyCategory.CategoryName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CategoryName.touched && CategoryName.invalid\">Category Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ProductName.touched && ProductName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ProductName\" class=\"col-xs-3 col-sm-2 control-label\">Product Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ProductName=\"ngModel\" name=\"ProductName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Product Name\" [(ngModel)]=\"objSalesbyCategory.ProductName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ProductName.touched && ProductName.invalid\">Product Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ProductSales.touched && ProductSales.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ProductSales\" class=\"col-xs-3 col-sm-2 control-label\">Productsales:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ProductSales=\"ngModel\" name=\"ProductSales\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Productsales\" [(ngModel)]=\"objSalesbyCategory.ProductSales\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ProductSales.touched && ProductSales.invalid\">Productsales must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1109 */
/***/ function(module, exports) {

module.exports = "<h2>Add Shippers</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Shippers Add</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipperID.touched && ShipperID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipperID\" class=\"col-xs-3 col-sm-2 control-label\">Shipper Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipperID=\"ngModel\" name=\"ShipperID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipper Id\" [(ngModel)]=\"objShippers.ShipperID\" pattern=\"^(0|[1-9][0-9]*)$\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipperID.touched && ShipperID.invalid\">Shipper Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CompanyName.touched && CompanyName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CompanyName\" class=\"col-xs-3 col-sm-2 control-label\">Company Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CompanyName=\"ngModel\" name=\"CompanyName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Company Name\" [(ngModel)]=\"objShippers.CompanyName\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CompanyName.touched && CompanyName.invalid\">Company Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Phone.touched && Phone.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Phone\" class=\"col-xs-3 col-sm-2 control-label\">Phone:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Phone=\"ngModel\" name=\"Phone\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Phone\" [(ngModel)]=\"objShippers.Phone\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Phone.touched && Phone.invalid\">Phone is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"addShippers()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoShippers()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1110 */
/***/ function(module, exports) {

module.exports = "<h2>Shippers Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Shippers Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShipperID\" class=\"col-xs-3 col-sm-2 control-label\">Shipper Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShipperID\" name=\"ShipperID\" placeholder=\"Shipper Id\" [(ngModel)]=\"objShippers.ShipperID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CompanyName\" class=\"col-xs-3 col-sm-2 control-label\">Company Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CompanyName\" name=\"CompanyName\" placeholder=\"Company Name\" [(ngModel)]=\"objShippers.CompanyName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Phone\" class=\"col-xs-3 col-sm-2 control-label\">Phone:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Phone\" name=\"Phone\" placeholder=\"Phone\" [(ngModel)]=\"objShippers.Phone\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"gotoShippersEdit()\">Edit</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoShippers()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" (click)=\"deleteShippers(objShippers.ShipperID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1111 */
/***/ function(module, exports) {

module.exports = "<h2>Edit Shippers</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Shippers Edit</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipperID.touched && ShipperID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipperID\" class=\"col-xs-3 col-sm-2 control-label\">Shipper Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipperID=\"ngModel\" name=\"ShipperID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipper Id\" [(ngModel)]=\"objShippers.ShipperID\" pattern=\"^(0|[1-9][0-9]*)$\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipperID.touched && ShipperID.invalid\">Shipper Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CompanyName.touched && CompanyName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CompanyName\" class=\"col-xs-3 col-sm-2 control-label\">Company Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CompanyName=\"ngModel\" name=\"CompanyName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Company Name\" [(ngModel)]=\"objShippers.CompanyName\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CompanyName.touched && CompanyName.invalid\">Company Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Phone.touched && Phone.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Phone\" class=\"col-xs-3 col-sm-2 control-label\">Phone:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Phone=\"ngModel\" name=\"Phone\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Phone\" [(ngModel)]=\"objShippers.Phone\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Phone.touched && Phone.invalid\">Phone is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"updateShippers()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoShippers()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" type=\"submit\" (click)=\"deleteShippers(objShippers.ShipperID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1112 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>Shippers List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<ShippersSearch (filterCriteria)=\"onSearch($event)\" ></ShippersSearch>\r\n\t\t</div>\r\n\t</div>\r\n\t\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" routerLink=\"/Shippers/add\" routerLinkActive=\"active\" title=\"Add Shippers\"><i class=\"glyphicon glyphicon-plus\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Delete List(s)\"><i class=\"glyphicon glyphicon-remove\"></i></a-->\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr>\r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShipperID')\">Shipper Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CompanyName')\">Company Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Phone')\">Phone</a></th>\r\n\r\n\t\t</tr>\r\n\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of ShippersList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelect(item)\">Edit</a>\r\n\t\t\t\t\t<a (click)=\"deleteShippers(item.ShipperID)\">Delete</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.ShipperID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.CompanyName}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Phone}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1113 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch Shippers\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShipperID.touched && ShipperID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShipperID\" class=\"col-xs-3 col-sm-2 control-label\">Shipper Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShipperID=\"ngModel\" name=\"ShipperID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipper Id\" [(ngModel)]=\"objShippers.ShipperID\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShipperID.touched && ShipperID.invalid\">Shipper Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CompanyName.touched && CompanyName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CompanyName\" class=\"col-xs-3 col-sm-2 control-label\">Company Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CompanyName=\"ngModel\" name=\"CompanyName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Company Name\" [(ngModel)]=\"objShippers.CompanyName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CompanyName.touched && CompanyName.invalid\">Company Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Phone.touched && Phone.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Phone\" class=\"col-xs-3 col-sm-2 control-label\">Phone:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Phone=\"ngModel\" name=\"Phone\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Phone\" [(ngModel)]=\"objShippers.Phone\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Phone.touched && Phone.invalid\">Phone is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1114 */
/***/ function(module, exports) {

module.exports = "<h2>SummaryofSalesbyQuarter Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">SummaryofSalesbyQuarter Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShippedDate\" class=\"col-xs-3 col-sm-2 control-label\">Shipped Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShippedDate\" name=\"ShippedDate\" placeholder=\"Shipped Date\" [(ngModel)]=\"objSummaryofSalesbyQuarter.ShippedDate\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"OrderID\" class=\"col-xs-3 col-sm-2 control-label\">Order Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"OrderID\" name=\"OrderID\" placeholder=\"Order Id\" [(ngModel)]=\"objSummaryofSalesbyQuarter.OrderID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Subtotal\" class=\"col-xs-3 col-sm-2 control-label\">Subtotal:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Subtotal\" name=\"Subtotal\" placeholder=\"Subtotal\" [(ngModel)]=\"objSummaryofSalesbyQuarter.Subtotal\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoSummaryofSalesbyQuarter()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1115 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>SummaryofSalesbyQuarter List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\t\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<SummaryofSalesbyQuarterSearch (filterCriteria)=\"onSearch($event)\" ></SummaryofSalesbyQuarterSearch>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}\r\n\t\t\t\t</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr> \r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShippedDate')\">Shipped Date</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'OrderID')\">Order Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Subtotal')\">Subtotal</a></th>\r\n\r\n\t\t</tr>\r\n\t\t\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of SummaryofSalesbyQuarterList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelectDetails(item)\">Details</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShippedDate}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.OrderID}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.Subtotal}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1116 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch SummaryofSalesbyQuarter\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShippedDate.touched && ShippedDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShippedDate\" class=\"col-xs-3 col-sm-2 control-label\">Shipped Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShippedDate=\"ngModel\" name=\"ShippedDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipped Date\" [(ngModel)]=\"objSummaryofSalesbyQuarter.ShippedDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShippedDate.touched && ShippedDate.invalid\">Shipped Date is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"OrderID.touched && OrderID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"OrderID\" class=\"col-xs-3 col-sm-2 control-label\">Order Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #OrderID=\"ngModel\" name=\"OrderID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Order Id\" [(ngModel)]=\"objSummaryofSalesbyQuarter.OrderID\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"OrderID.touched && OrderID.invalid\">Order Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Subtotal.touched && Subtotal.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Subtotal\" class=\"col-xs-3 col-sm-2 control-label\">Subtotal:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Subtotal=\"ngModel\" name=\"Subtotal\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Subtotal\" [(ngModel)]=\"objSummaryofSalesbyQuarter.Subtotal\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Subtotal.touched && Subtotal.invalid\">Subtotal must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1117 */
/***/ function(module, exports) {

module.exports = "<h2>SummaryofSalesbyYear Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">SummaryofSalesbyYear Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ShippedDate\" class=\"col-xs-3 col-sm-2 control-label\">Shipped Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ShippedDate\" name=\"ShippedDate\" placeholder=\"Shipped Date\" [(ngModel)]=\"objSummaryofSalesbyYear.ShippedDate\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"OrderID\" class=\"col-xs-3 col-sm-2 control-label\">Order Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"OrderID\" name=\"OrderID\" placeholder=\"Order Id\" [(ngModel)]=\"objSummaryofSalesbyYear.OrderID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Subtotal\" class=\"col-xs-3 col-sm-2 control-label\">Subtotal:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Subtotal\" name=\"Subtotal\" placeholder=\"Subtotal\" [(ngModel)]=\"objSummaryofSalesbyYear.Subtotal\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoSummaryofSalesbyYear()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1118 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>SummaryofSalesbyYear List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\t\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<SummaryofSalesbyYearSearch (filterCriteria)=\"onSearch($event)\" ></SummaryofSalesbyYearSearch>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}\r\n\t\t\t\t</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr> \r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ShippedDate')\">Shipped Date</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'OrderID')\">Order Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Subtotal')\">Subtotal</a></th>\r\n\r\n\t\t</tr>\r\n\t\t\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of SummaryofSalesbyYearList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelectDetails(item)\">Details</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ShippedDate}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.OrderID}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.Subtotal}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1119 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch SummaryofSalesbyYear\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ShippedDate.touched && ShippedDate.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ShippedDate\" class=\"col-xs-3 col-sm-2 control-label\">Shipped Date:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ShippedDate=\"ngModel\" name=\"ShippedDate\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Shipped Date\" [(ngModel)]=\"objSummaryofSalesbyYear.ShippedDate\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ShippedDate.touched && ShippedDate.invalid\">Shipped Date is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"OrderID.touched && OrderID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"OrderID\" class=\"col-xs-3 col-sm-2 control-label\">Order Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #OrderID=\"ngModel\" name=\"OrderID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Order Id\" [(ngModel)]=\"objSummaryofSalesbyYear.OrderID\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"OrderID.touched && OrderID.invalid\">Order Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Subtotal.touched && Subtotal.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Subtotal\" class=\"col-xs-3 col-sm-2 control-label\">Subtotal:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Subtotal=\"ngModel\" name=\"Subtotal\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Subtotal\" [(ngModel)]=\"objSummaryofSalesbyYear.Subtotal\" pattern=\"^\\d{1,10}(\\.\\d{1,2})?$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Subtotal.touched && Subtotal.invalid\">Subtotal must be decimal and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1120 */
/***/ function(module, exports) {

module.exports = "<h2>Add Suppliers</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Suppliers Add</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"SupplierID.touched && SupplierID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"SupplierID\" class=\"col-xs-3 col-sm-2 control-label\">Supplier Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #SupplierID=\"ngModel\" name=\"SupplierID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Supplier Id\" [(ngModel)]=\"objSuppliers.SupplierID\" pattern=\"^(0|[1-9][0-9]*)$\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"SupplierID.touched && SupplierID.invalid\">Supplier Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CompanyName.touched && CompanyName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CompanyName\" class=\"col-xs-3 col-sm-2 control-label\">Company Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CompanyName=\"ngModel\" name=\"CompanyName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Company Name\" [(ngModel)]=\"objSuppliers.CompanyName\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CompanyName.touched && CompanyName.invalid\">Company Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ContactName.touched && ContactName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ContactName\" class=\"col-xs-3 col-sm-2 control-label\">Contact Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ContactName=\"ngModel\" name=\"ContactName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Contact Name\" [(ngModel)]=\"objSuppliers.ContactName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ContactName.touched && ContactName.invalid\">Contact Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ContactTitle.touched && ContactTitle.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ContactTitle\" class=\"col-xs-3 col-sm-2 control-label\">Contact Title:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ContactTitle=\"ngModel\" name=\"ContactTitle\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Contact Title\" [(ngModel)]=\"objSuppliers.ContactTitle\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ContactTitle.touched && ContactTitle.invalid\">Contact Title is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Address.touched && Address.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Address\" class=\"col-xs-3 col-sm-2 control-label\">Address:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Address=\"ngModel\" name=\"Address\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Address\" [(ngModel)]=\"objSuppliers.Address\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Address.touched && Address.invalid\">Address is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"City.touched && City.invalid\" >\r\n\t\t\t\t\t\t<label for=\"City\" class=\"col-xs-3 col-sm-2 control-label\">City:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #City=\"ngModel\" name=\"City\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"City\" [(ngModel)]=\"objSuppliers.City\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"City.touched && City.invalid\">City is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Region.touched && Region.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Region\" class=\"col-xs-3 col-sm-2 control-label\">Region:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Region=\"ngModel\" name=\"Region\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Region\" [(ngModel)]=\"objSuppliers.Region\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Region.touched && Region.invalid\">Region is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"PostalCode.touched && PostalCode.invalid\" >\r\n\t\t\t\t\t\t<label for=\"PostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Postal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #PostalCode=\"ngModel\" name=\"PostalCode\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Postal Code\" [(ngModel)]=\"objSuppliers.PostalCode\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"PostalCode.touched && PostalCode.invalid\">Postal Code is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Country.touched && Country.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Country\" class=\"col-xs-3 col-sm-2 control-label\">Country:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Country=\"ngModel\" name=\"Country\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Country\" [(ngModel)]=\"objSuppliers.Country\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Country.touched && Country.invalid\">Country is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Phone.touched && Phone.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Phone\" class=\"col-xs-3 col-sm-2 control-label\">Phone:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Phone=\"ngModel\" name=\"Phone\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Phone\" [(ngModel)]=\"objSuppliers.Phone\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Phone.touched && Phone.invalid\">Phone is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Fax.touched && Fax.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Fax\" class=\"col-xs-3 col-sm-2 control-label\">Fax:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Fax=\"ngModel\" name=\"Fax\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Fax\" [(ngModel)]=\"objSuppliers.Fax\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Fax.touched && Fax.invalid\">Fax is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"HomePage.touched && HomePage.invalid\" >\r\n\t\t\t\t\t\t<label for=\"HomePage\" class=\"col-xs-3 col-sm-2 control-label\">Homepage:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<textarea #HomePage=\"ngModel\" name=\"HomePage\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Homepage\" [(ngModel)]=\"objSuppliers.HomePage\"  rows=\"4\"> </textarea>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"HomePage.touched && HomePage.invalid\">Homepage is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"addSuppliers()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoSuppliers()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1121 */
/***/ function(module, exports) {

module.exports = "<h2>Suppliers Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Suppliers Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"SupplierID\" class=\"col-xs-3 col-sm-2 control-label\">Supplier Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"SupplierID\" name=\"SupplierID\" placeholder=\"Supplier Id\" [(ngModel)]=\"objSuppliers.SupplierID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"CompanyName\" class=\"col-xs-3 col-sm-2 control-label\">Company Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"CompanyName\" name=\"CompanyName\" placeholder=\"Company Name\" [(ngModel)]=\"objSuppliers.CompanyName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ContactName\" class=\"col-xs-3 col-sm-2 control-label\">Contact Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ContactName\" name=\"ContactName\" placeholder=\"Contact Name\" [(ngModel)]=\"objSuppliers.ContactName\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"ContactTitle\" class=\"col-xs-3 col-sm-2 control-label\">Contact Title:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"ContactTitle\" name=\"ContactTitle\" placeholder=\"Contact Title\" [(ngModel)]=\"objSuppliers.ContactTitle\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Address\" class=\"col-xs-3 col-sm-2 control-label\">Address:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Address\" name=\"Address\" placeholder=\"Address\" [(ngModel)]=\"objSuppliers.Address\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"City\" class=\"col-xs-3 col-sm-2 control-label\">City:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"City\" name=\"City\" placeholder=\"City\" [(ngModel)]=\"objSuppliers.City\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Region\" class=\"col-xs-3 col-sm-2 control-label\">Region:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Region\" name=\"Region\" placeholder=\"Region\" [(ngModel)]=\"objSuppliers.Region\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"PostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Postal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"PostalCode\" name=\"PostalCode\" placeholder=\"Postal Code\" [(ngModel)]=\"objSuppliers.PostalCode\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Country\" class=\"col-xs-3 col-sm-2 control-label\">Country:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Country\" name=\"Country\" placeholder=\"Country\" [(ngModel)]=\"objSuppliers.Country\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Phone\" class=\"col-xs-3 col-sm-2 control-label\">Phone:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Phone\" name=\"Phone\" placeholder=\"Phone\" [(ngModel)]=\"objSuppliers.Phone\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"Fax\" class=\"col-xs-3 col-sm-2 control-label\">Fax:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"Fax\" name=\"Fax\" placeholder=\"Fax\" [(ngModel)]=\"objSuppliers.Fax\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"HomePage\" class=\"col-xs-3 col-sm-2 control-label\">Homepage:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"HomePage\" name=\"HomePage\" placeholder=\"Homepage\" [(ngModel)]=\"objSuppliers.HomePage\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"gotoSuppliersEdit()\">Edit</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoSuppliers()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" (click)=\"deleteSuppliers(objSuppliers.SupplierID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1122 */
/***/ function(module, exports) {

module.exports = "<h2>Edit Suppliers</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Suppliers Edit</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"SupplierID.touched && SupplierID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"SupplierID\" class=\"col-xs-3 col-sm-2 control-label\">Supplier Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #SupplierID=\"ngModel\" name=\"SupplierID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Supplier Id\" [(ngModel)]=\"objSuppliers.SupplierID\" pattern=\"^(0|[1-9][0-9]*)$\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"SupplierID.touched && SupplierID.invalid\">Supplier Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CompanyName.touched && CompanyName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CompanyName\" class=\"col-xs-3 col-sm-2 control-label\">Company Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CompanyName=\"ngModel\" name=\"CompanyName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Company Name\" [(ngModel)]=\"objSuppliers.CompanyName\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CompanyName.touched && CompanyName.invalid\">Company Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ContactName.touched && ContactName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ContactName\" class=\"col-xs-3 col-sm-2 control-label\">Contact Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ContactName=\"ngModel\" name=\"ContactName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Contact Name\" [(ngModel)]=\"objSuppliers.ContactName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ContactName.touched && ContactName.invalid\">Contact Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ContactTitle.touched && ContactTitle.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ContactTitle\" class=\"col-xs-3 col-sm-2 control-label\">Contact Title:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ContactTitle=\"ngModel\" name=\"ContactTitle\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Contact Title\" [(ngModel)]=\"objSuppliers.ContactTitle\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ContactTitle.touched && ContactTitle.invalid\">Contact Title is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Address.touched && Address.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Address\" class=\"col-xs-3 col-sm-2 control-label\">Address:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Address=\"ngModel\" name=\"Address\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Address\" [(ngModel)]=\"objSuppliers.Address\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Address.touched && Address.invalid\">Address is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"City.touched && City.invalid\" >\r\n\t\t\t\t\t\t<label for=\"City\" class=\"col-xs-3 col-sm-2 control-label\">City:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #City=\"ngModel\" name=\"City\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"City\" [(ngModel)]=\"objSuppliers.City\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"City.touched && City.invalid\">City is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Region.touched && Region.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Region\" class=\"col-xs-3 col-sm-2 control-label\">Region:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Region=\"ngModel\" name=\"Region\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Region\" [(ngModel)]=\"objSuppliers.Region\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Region.touched && Region.invalid\">Region is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"PostalCode.touched && PostalCode.invalid\" >\r\n\t\t\t\t\t\t<label for=\"PostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Postal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #PostalCode=\"ngModel\" name=\"PostalCode\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Postal Code\" [(ngModel)]=\"objSuppliers.PostalCode\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"PostalCode.touched && PostalCode.invalid\">Postal Code is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Country.touched && Country.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Country\" class=\"col-xs-3 col-sm-2 control-label\">Country:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Country=\"ngModel\" name=\"Country\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Country\" [(ngModel)]=\"objSuppliers.Country\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Country.touched && Country.invalid\">Country is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Phone.touched && Phone.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Phone\" class=\"col-xs-3 col-sm-2 control-label\">Phone:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Phone=\"ngModel\" name=\"Phone\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Phone\" [(ngModel)]=\"objSuppliers.Phone\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Phone.touched && Phone.invalid\">Phone is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Fax.touched && Fax.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Fax\" class=\"col-xs-3 col-sm-2 control-label\">Fax:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Fax=\"ngModel\" name=\"Fax\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Fax\" [(ngModel)]=\"objSuppliers.Fax\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Fax.touched && Fax.invalid\">Fax is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"HomePage.touched && HomePage.invalid\" >\r\n\t\t\t\t\t\t<label for=\"HomePage\" class=\"col-xs-3 col-sm-2 control-label\">Homepage:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<textarea #HomePage=\"ngModel\" name=\"HomePage\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Homepage\" [(ngModel)]=\"objSuppliers.HomePage\"  rows=\"4\"> </textarea>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"HomePage.touched && HomePage.invalid\">Homepage is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"updateSuppliers()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoSuppliers()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" type=\"submit\" (click)=\"deleteSuppliers(objSuppliers.SupplierID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1123 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>Suppliers List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<SuppliersSearch (filterCriteria)=\"onSearch($event)\" ></SuppliersSearch>\r\n\t\t</div>\r\n\t</div>\r\n\t\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" routerLink=\"/Suppliers/add\" routerLinkActive=\"active\" title=\"Add Suppliers\"><i class=\"glyphicon glyphicon-plus\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Delete List(s)\"><i class=\"glyphicon glyphicon-remove\"></i></a-->\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr>\r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'SupplierID')\">Supplier Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'CompanyName')\">Company Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ContactName')\">Contact Name</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'ContactTitle')\">Contact Title</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Address')\">Address</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'City')\">City</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Region')\">Region</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'PostalCode')\">Postal Code</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Country')\">Country</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Phone')\">Phone</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'Fax')\">Fax</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'HomePage')\">Homepage</a></th>\r\n\r\n\t\t</tr>\r\n\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of SuppliersList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelect(item)\">Edit</a>\r\n\t\t\t\t\t<a (click)=\"deleteSuppliers(item.SupplierID)\">Delete</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.SupplierID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.CompanyName}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ContactName}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.ContactTitle}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Address}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.City}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Region}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.PostalCode}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Country}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Phone}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.Fax}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.HomePage}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1124 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch Suppliers\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"SupplierID.touched && SupplierID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"SupplierID\" class=\"col-xs-3 col-sm-2 control-label\">Supplier Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #SupplierID=\"ngModel\" name=\"SupplierID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Supplier Id\" [(ngModel)]=\"objSuppliers.SupplierID\" pattern=\"^(0|[1-9][0-9]*)$\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"SupplierID.touched && SupplierID.invalid\">Supplier Id must be numeric and is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"CompanyName.touched && CompanyName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"CompanyName\" class=\"col-xs-3 col-sm-2 control-label\">Company Name:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #CompanyName=\"ngModel\" name=\"CompanyName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Company Name\" [(ngModel)]=\"objSuppliers.CompanyName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"CompanyName.touched && CompanyName.invalid\">Company Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ContactName.touched && ContactName.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ContactName\" class=\"col-xs-3 col-sm-2 control-label\">Contact Name:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ContactName=\"ngModel\" name=\"ContactName\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Contact Name\" [(ngModel)]=\"objSuppliers.ContactName\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ContactName.touched && ContactName.invalid\">Contact Name is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"ContactTitle.touched && ContactTitle.invalid\" >\r\n\t\t\t\t\t\t<label for=\"ContactTitle\" class=\"col-xs-3 col-sm-2 control-label\">Contact Title:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #ContactTitle=\"ngModel\" name=\"ContactTitle\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Contact Title\" [(ngModel)]=\"objSuppliers.ContactTitle\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"ContactTitle.touched && ContactTitle.invalid\">Contact Title is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Address.touched && Address.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Address\" class=\"col-xs-3 col-sm-2 control-label\">Address:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Address=\"ngModel\" name=\"Address\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Address\" [(ngModel)]=\"objSuppliers.Address\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Address.touched && Address.invalid\">Address is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"City.touched && City.invalid\" >\r\n\t\t\t\t\t\t<label for=\"City\" class=\"col-xs-3 col-sm-2 control-label\">City:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #City=\"ngModel\" name=\"City\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"City\" [(ngModel)]=\"objSuppliers.City\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"City.touched && City.invalid\">City is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Region.touched && Region.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Region\" class=\"col-xs-3 col-sm-2 control-label\">Region:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Region=\"ngModel\" name=\"Region\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Region\" [(ngModel)]=\"objSuppliers.Region\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Region.touched && Region.invalid\">Region is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"PostalCode.touched && PostalCode.invalid\" >\r\n\t\t\t\t\t\t<label for=\"PostalCode\" class=\"col-xs-3 col-sm-2 control-label\">Postal Code:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #PostalCode=\"ngModel\" name=\"PostalCode\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Postal Code\" [(ngModel)]=\"objSuppliers.PostalCode\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"PostalCode.touched && PostalCode.invalid\">Postal Code is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Country.touched && Country.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Country\" class=\"col-xs-3 col-sm-2 control-label\">Country:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Country=\"ngModel\" name=\"Country\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Country\" [(ngModel)]=\"objSuppliers.Country\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Country.touched && Country.invalid\">Country is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Phone.touched && Phone.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Phone\" class=\"col-xs-3 col-sm-2 control-label\">Phone:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Phone=\"ngModel\" name=\"Phone\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Phone\" [(ngModel)]=\"objSuppliers.Phone\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Phone.touched && Phone.invalid\">Phone is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"Fax.touched && Fax.invalid\" >\r\n\t\t\t\t\t\t<label for=\"Fax\" class=\"col-xs-3 col-sm-2 control-label\">Fax:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #Fax=\"ngModel\" name=\"Fax\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Fax\" [(ngModel)]=\"objSuppliers.Fax\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"Fax.touched && Fax.invalid\">Fax is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"HomePage.touched && HomePage.invalid\" >\r\n\t\t\t\t\t\t<label for=\"HomePage\" class=\"col-xs-3 col-sm-2 control-label\">Homepage:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<textarea #HomePage=\"ngModel\" name=\"HomePage\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Homepage\" [(ngModel)]=\"objSuppliers.HomePage\"  rows=\"4\"> </textarea>\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"HomePage.touched && HomePage.invalid\">Homepage is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1125 */
/***/ function(module, exports) {

module.exports = "<h2>Add Territories</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Territories Add</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"TerritoryID.touched && TerritoryID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"TerritoryID\" class=\"col-xs-3 col-sm-2 control-label\">Territory Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #TerritoryID=\"ngModel\" name=\"TerritoryID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Territory Id\" [(ngModel)]=\"objTerritories.TerritoryID\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"TerritoryID.touched && TerritoryID.invalid\">Territory Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"TerritoryDescription.touched && TerritoryDescription.invalid\" >\r\n\t\t\t\t\t\t<label for=\"TerritoryDescription\" class=\"col-xs-3 col-sm-2 control-label\">Territory Description:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #TerritoryDescription=\"ngModel\" name=\"TerritoryDescription\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Territory Description\" [(ngModel)]=\"objTerritories.TerritoryDescription\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"TerritoryDescription.touched && TerritoryDescription.invalid\">Territory Description is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Region Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"RegionID\" name=\"RegionID\" class=\"form-control\" [(ngModel)]=\"objTerritories.RegionID\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objTerritories.RegionID\" *ngIf=\"!objTerritories.RegionID\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of RegionList\" [value]=\"item.RegionID\">\r\n\t\t\t\t\t\t\t\t\t{{item.RegionDescription}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"addTerritories()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoTerritories()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1126 */
/***/ function(module, exports) {

module.exports = "<h2>Territories Details</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n\r\n<div class=\"grid grid-pad\">\r\n\t<form>\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Territories Details</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"TerritoryID\" class=\"col-xs-3 col-sm-2 control-label\">Territory Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"TerritoryID\" name=\"TerritoryID\" placeholder=\"Territory Id\" [(ngModel)]=\"objTerritories.TerritoryID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"TerritoryDescription\" class=\"col-xs-3 col-sm-2 control-label\">Territory Description:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"TerritoryDescription\" name=\"TerritoryDescription\" placeholder=\"Territory Description\" [(ngModel)]=\"objTerritories.TerritoryDescription\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label for=\"RegionID\" class=\"col-xs-3 col-sm-2 control-label\">Region Id:</label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"RegionID\" name=\"RegionID\" placeholder=\"Region Id\" [(ngModel)]=\"objTerritories.RegionID\" readonly />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"gotoTerritoriesEdit()\">Edit</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoTerritories()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" (click)=\"deleteTerritories(objTerritories.TerritoryID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1127 */
/***/ function(module, exports) {

module.exports = "<h2>Edit Territories</h2>\r\n<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n\t<strong>Error!</strong> {{errorMessage}}\r\n</div>\r\n<div *ngIf=\"false\">Is Form Valid: {{ form.valid}}</div>\r\n<div *ngIf=\"false\">Form Value: {{ form.value | json}}</div>\r\n<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\">Territories Edit</div>\r\n\t\t\t<div class=\"panel-body\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"TerritoryID.touched && TerritoryID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"TerritoryID\" class=\"col-xs-3 col-sm-2 control-label\">Territory Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #TerritoryID=\"ngModel\" name=\"TerritoryID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Territory Id\" [(ngModel)]=\"objTerritories.TerritoryID\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"TerritoryID.touched && TerritoryID.invalid\">Territory Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"TerritoryDescription.touched && TerritoryDescription.invalid\" >\r\n\t\t\t\t\t\t<label for=\"TerritoryDescription\" class=\"col-xs-3 col-sm-2 control-label\">Territory Description:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #TerritoryDescription=\"ngModel\" name=\"TerritoryDescription\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Territory Description\" [(ngModel)]=\"objTerritories.TerritoryDescription\" required />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"TerritoryDescription.touched && TerritoryDescription.invalid\">Territory Description is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Region Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"RegionID\" name=\"RegionID\" class=\"form-control\" [(ngModel)]=\"objTerritories.RegionID\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objTerritories.RegionID\" *ngIf=\"!objTerritories.RegionID\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of RegionList\" [value]=\"item.RegionID\">\r\n\t\t\t\t\t\t\t\t\t{{item.RegionDescription}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"updateTerritories()\" [disabled]=\"form.invalid\">Save</button>\r\n\t\t\t\t\t<a class=\"btn btn-primary\" (click)=\"gotoTerritories()\">Cancel</a>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"pull-left\">\r\n\t\t\t\t\t<a class=\"btn btn-danger\" type=\"submit\" (click)=\"deleteTerritories(objTerritories.TerritoryID)\">Delete</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1128 */
/***/ function(module, exports) {

module.exports = "<div class=\"grid grid-pad\">\r\n\t<h1>Territories List</h1>\r\n\r\n\t<!-- Error Messages -->\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>\r\n  \t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\r\n\t<!-- Search Panel -->\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\t<TerritoriesSearch (filterCriteria)=\"onSearch($event)\" ></TerritoriesSearch>\r\n\t\t</div>\r\n\t</div>\r\n\t\r\n\t<!-- Data Grid with Pagination -->\r\n\t<div class=\"table-responsive\" style=\"width: 100%;overflow: auto;\"> <!-- To add horizontal scrollbar when table width is too big -->\r\n\t<table class=\"table table-bordered table-striped table-condensed table-hover\">\r\n\t\t<!-- Grid Pagination -->\r\n        <caption>\r\n            <div class=\"row\" style=\"padding:2px;margin:0px;border:1px solid lightgray;background-color:lightblue;\">\r\n                <div class=\"col-md-4 text-left\">\r\n                    <div class=\"btn-toolbar\" role=\"toolbar\">\r\n                        <div class=\"btn-group\">\r\n                            <a class=\"btn-sm\" routerLink=\"/Territories/add\" routerLinkActive=\"active\" title=\"Add Territories\"><i class=\"glyphicon glyphicon-plus\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Delete List(s)\"><i class=\"glyphicon glyphicon-remove\"></i></a-->\r\n                            <a class=\"btn-sm\" title=\"Refresh List\" (click)=\"onRefresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a>\r\n                            <!--a class=\"btn-sm\" title=\"Export to Excel\"><i class=\"glyphicon glyphicon-list-alt\"></i></a-->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-4 text-center\" >Rows: {{pageIndex*pageSize-pageSize+1}} to {{endRowIndex}} of {{rowsCount}}</div>\r\n                <div class=\"col-md-4 text-right\" >Page Size: {{pageSize}}, \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onFirstPage()\"><span class=\"glyphicon glyphicon-backward\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onPreviousPage()\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span></a>\r\n\t\t\t\t\tPage: {{pageIndex}} \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Next Page\" (click)=\"onNextPage()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span></a> \r\n\t\t\t\t\t<a class=\"btn-sm\" title=\"Last Page\" (click)=\"onLastPage()\"><span class=\"glyphicon glyphicon-forward\" aria-hidden=\"true\"></span></a> of {{pageCount}}</div>\r\n            </div>\r\n        </caption>\r\n\r\n\t\t<!-- Grid Column Header -->\r\n\t\t<tr>\r\n\t\t\t<th>Action</th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'TerritoryID')\">Territory Id</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'TerritoryDescription')\">Territory Description</a></th>\r\n\t\t\t<th><a (click)=\"onSort($event, 'RegionID')\">Region Id</a></th>\r\n\r\n\t\t</tr>\r\n\r\n\t\t<!-- Grid Rows -->\r\n\t\t<tbody>\r\n\t\t\t<tr *ngFor=\"let item of TerritoriesList\">\r\n\t\t\t\t<td style=\"width: 100px\">\r\n\t\t\t\t\t<a (click)=\"onSelect(item)\">Edit</a>\r\n\t\t\t\t\t<a (click)=\"deleteTerritories(item.TerritoryID)\">Delete</a>\r\n\t\t\t\t</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.TerritoryID}}</td>\r\n\t\t\t\t<td class=\"text-left\">{{item.TerritoryDescription}}</td>\r\n\t\t\t\t<td class=\"text-right\">{{item.RegionID}}</td>\r\n\r\n\t\t\t</tr>\r\n\t\t</tbody>\r\n\t</table>\r\n\t</div>\r\n</div>\r\n\t"

/***/ },
/* 1129 */
/***/ function(module, exports) {

module.exports = "<div class=\"container\">\r\n\t<form #form=\"ngForm\">\r\n\t\t<div class=\"panel panel-primary\">\r\n\t\t\t<div class=\"panel-heading\" style=\"cursor: pointer;\" (click)=\"onExpandCollapse()\">\r\n\t\t\t\tSearch Territories\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<i [ngClass]=\"showSearch?'glyphicon glyphicon-resize-small':'glyphicon glyphicon-resize-full'\"></i>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-body\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"form-horizontal\">\r\n\t\t\t\t\t<div class=\"row has-error\">\r\n\t\t\t\t\t\t<span id=\"error\" class=\"help-block\"></span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"TerritoryID.touched && TerritoryID.invalid\" >\r\n\t\t\t\t\t\t<label for=\"TerritoryID\" class=\"col-xs-3 col-sm-2 control-label\">Territory Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #TerritoryID=\"ngModel\" name=\"TerritoryID\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Territory Id\" [(ngModel)]=\"objTerritories.TerritoryID\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"TerritoryID.touched && TerritoryID.invalid\">Territory Id is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\" [class.has-error]=\"TerritoryDescription.touched && TerritoryDescription.invalid\" >\r\n\t\t\t\t\t\t<label for=\"TerritoryDescription\" class=\"col-xs-3 col-sm-2 control-label\">Territory Description:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<input #TerritoryDescription=\"ngModel\" name=\"TerritoryDescription\" type=\"text\" class=\"form-control\" \r\n\t\t\t\t\t\t\t\t\tplaceholder=\"Territory Description\" [(ngModel)]=\"objTerritories.TerritoryDescription\"  />\r\n\t\t\t\t\t\t\t<div style=\"color:red\" *ngIf=\"TerritoryDescription.touched && TerritoryDescription.invalid\">Territory Description is required.</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<label class=\"col-xs-3 col-sm-2 control-label\">Region Id:<font color=\"red\">*&nbsp;</font></label>\r\n\t\t\t\t\t\t<div class=\"col-xs-9 col-sm-10\">\r\n\t\t\t\t\t\t\t<select id=\"RegionID\" name=\"RegionID\" class=\"form-control\" [(ngModel)]=\"objTerritories.RegionID\">\r\n\t\t\t\t\t\t\t\t<option [value]=\"objTerritories.RegionID\" *ngIf=\"!objTerritories.RegionID\">SELECT</option>\r\n\t\t\t\t\t\t\t\t<option *ngFor=\"let item of RegionList\" [value]=\"item.RegionID\">\r\n\t\t\t\t\t\t\t\t\t{{item.RegionDescription}}\r\n\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"panel-footer clearfix\" *ngIf=\"showSearch===true\">\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"searchProducts()\">Search</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"clearCriteria()\" >Clear</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>\r\n"

/***/ },
/* 1130 */
/***/ function(module, exports) {

module.exports = "<h2>Forgot your password?</h2>\r\n\r\n<div class=\"col-sm-12\" ng-controller=\"forgotPasswordController\">\r\n    <form class=\"form-horizontal\" role=\"form\">\r\n        <div class=\"form-group\">\r\n            <label>Email:</label>\r\n            <input class=\"form-control\" placeholder=\"Email Address\" data-ng-model=\"loginData.email\" required/>\r\n        </div>\r\n        <div class=\"form-group\">\r\n            <button type=\"submit\" class=\"btn btn-primary\" data-ng-click=\"forgotPassword()\">Email Password</button>\r\n        </div>\r\n    </form>\r\n</div>\r\n\r\n"

/***/ },
/* 1131 */
/***/ function(module, exports) {

module.exports = "<!-- Login: Startup.Auth.cs -->\r\n<!-- Call Web API: // POST /Token -->\r\n<!-- Check for line: TokenEndpointPath = new PathString(\"/Token\") -->\r\n<div class=\"col-sm-12\">\r\n    <h3>Log In</h3>\r\n\t<p>Status: {{message}}</p>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <div class=\"has-error\">\r\n                <div class=\"help-block\" id=\"loginFromMessage\" ng-bind=\"message\"></div>\r\n            </div>\r\n            <form class=\"form-login\" role=\"form\" data-bind=\"submit: login\">\r\n                <div class=\"form-group\">\r\n                    <label>Email</label>\r\n                    <input class=\"form-control\" type=\"text\" placeholder=\"Username\" required autofocus />\r\n                </div>\r\n                <div class=\"form-group\">\r\n                    <label>Password</label>\r\n                    <input class=\"form-control\" type=\"password\" placeholder=\"Password\" required />\r\n                </div>\r\n                <div class=\"form-group\">\r\n                    <button class=\"btn btn-primary\" (click)=\"login()\" *ngIf=\"!authService.isLoggedIn\">Log In</button>\r\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"logout()\" *ngIf=\"authService.isLoggedIn\">Logout</button>\r\n                </div>\r\n                <div class=\"form-group\">\r\n                    <a routerLink=\"/forgotpassword\" routerLinkActive=\"active\">Forgot Password</a>\r\n                </div>\r\n            </form>\r\n        </div>\r\n\t\t<div class=\"col-md-12\">\r\n\t\t\tYou may click on <strong>Login</strong> button to login without entering username and password.<br />\r\n\t\t\t<strong>Note</strong>: Authentication module is not integrated at this time!\r\n\t\t</div>\r\n    </div>\r\n    <!--\r\n\r\n\t\ttemplate: `\r\n    <h2>LOGIN</h2>\r\n    <p>{{message}}</p>\r\n    <p>\r\n      <button (click)=\"login()\"  *ngIf=\"!authService.isLoggedIn\">Login</button>\r\n      <button (click)=\"logout()\" *ngIf=\"authService.isLoggedIn\">Logout</button>\r\n    </p>`\r\n    <div style=\"padding:10px;margin:0px;border: 1px solid #ddd;\">\r\n        Please use one of the following accounts to login:<br />\r\n        <ul>\r\n            <li>Username: <b>Admin</b>, Password: <b>Admin123</b></li>\r\n            <li>Username: <b>User</b>, Password: <b>User123</b></li>\r\n        </ul>\r\n    </div>\r\n    -->\r\n</div>\r\n"

/***/ },
/* 1132 */
/***/ function(module, exports) {

module.exports = "<div class=\"col-sm-12\" ng-controller=\"signupController\">\r\n    <form class=\"form-login\" role=\"form\" data-bind=\"submit: register\">\r\n        <h3>Register</h3>\r\n        <div class=\"form-group\">\r\n            <label>Email</label>\r\n            <input class=\"form-control\" type=\"email\" placeholder=\"Email\" data-ng-model=\"registration.Email\" required autofocus data-bind=\"value: registerEmail\" />\r\n        </div>\r\n        <div class=\"form-group\">\r\n            <label>Password</label>\r\n            <input class=\"form-control\" type=\"password\" placeholder=\"Password\" data-ng-model=\"registration.password\" required data-bind=\"value: registerPassword\" />\r\n        </div>\r\n        <div class=\"form-group\">\r\n            <label>Confirm Password</label>\r\n            <input class=\"form-control\" type=\"password\" placeholder=\"Confirm Password\" data-ng-model=\"registration.confirmPassword\" required data-bind=\"value: registerPassword2\" />\r\n        </div>\r\n        <div class=\"form-group\">\r\n            <button type=\"submit\" class=\"btn btn-primary\" data-ng-click=\"signUp()\">Register</button>\r\n        </div>\r\n    </form>\r\n</div>\r\n"

/***/ },
/* 1133 */
/***/ function(module, exports) {

module.exports = "<div>\r\n    <div class=\"navbar navbar-inverse navbar-fixed-top\">\r\n        <a class=\"navbar-brand\" routerLink=\"\" routerLinkActive=\"active\" data-toggle=\"tooltip\" title=\"NorthwindNg2 Web Application\">NorthwindNg2</a>\r\n        <div class=\"navbar-header\">\r\n            <button type=\"button\" class=\"navbar-toggle\" data-toggle=\"#menu-toggle\" id=\"menu-toggle\">\r\n                <span class=\"icon-bar\"></span>\r\n                <span class=\"icon-bar\"></span>\r\n                <span class=\"icon-bar\"></span>\r\n            </button>\r\n        </div>\r\n        <div class=\"navbar-collapse collapse\">\r\n            <ul class=\"nav navbar-nav navbar-left\" style=\"padding-left:100px;\">\r\n                <li class=\"dropdown\">\r\n                    <a href=\"\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-expanded=\"false\"><span class=\"glyphicon glyphicon-envelope\"></span></a>\r\n                    <ul class=\"dropdown-menu\">\r\n                        <li><a href=\"#\">Action</a></li>\r\n                        <li><a href=\"#\">Another action</a></li>\r\n                        <li><a href=\"#\">Something else here</a></li>\r\n                        <li role=\"separator\" class=\"divider\"></li>\r\n                        <li><a href=\"#\">Separated link</a></li>\r\n                    </ul>\r\n                </li>\r\n            </ul>\r\n            <!-- If Not Authenticated, show below -->\r\n            <ul class=\"nav navbar-nav navbar-right\">\r\n                <li><a routerLink=\"/register\" routerLinkActive=\"active\" *ngIf=\"!authService.isLoggedIn\">Register</a> </li>\r\n                <li><a routerLink=\"/login\" routerLinkActive=\"active\" *ngIf=\"!authService.isLoggedIn\">Login</a> </li>\r\n            </ul>\r\n            <!-- If Authenticated, show below -->\r\n            <ul class=\"nav navbar-nav navbar-right\" *ngIf=\"authService.isLoggedIn\">\r\n                <li class=\"dropdown\">\r\n                    <a href=\"\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-expanded=\"false\">Hello Demo <span class=\"caret\"></span></a>\r\n                    <ul class=\"dropdown-menu\" role=\"menu\">\r\n                        <li><a id=\"editProfile\"><i class=\"glyphicon glyphicon-user\"></i> My Profile</a></li>\r\n                        <li><a id=\"changePassword\"><i class=\"glyphicon glyphicon-lock\"></i> Change Password</a> </li>\r\n                        <li class=\"divider\"></li>\r\n                        <li><a (click)=\"logout()\"><i class=\"glyphicon glyphicon-log-out\"></i> Log off</a></li>\r\n                    </ul>\r\n                </li>\r\n            </ul>\r\n            <ul class=\"nav navbar-nav navbar-right\">\r\n                <li class=\"dropdown\">\r\n                    <a href=\"#\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-expanded=\"false\"><span class=\"glyphicon glyphicon-bell\"></span></a>\r\n                    <ul class=\"dropdown-menu\">\r\n                        <li><a href=\"#\">Action</a></li>\r\n                        <li><a href=\"#\">Another action</a></li>\r\n                        <li><a href=\"#\">Something else here</a></li>\r\n                        <li role=\"separator\" class=\"divider\"></li>\r\n                        <li><a href=\"#\">Separated link</a></li>\r\n                    </ul>\r\n                </li>\r\n            </ul>\r\n            <ul class=\"nav navbar-nav navbar-right\">\r\n                <li class=\"dropdown\">\r\n                    <a href=\"#\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-expanded=\"false\"><i class=\"glyphicon glyphicon-question-sign\"></i></a>\r\n                    <ul class=\"dropdown-menu\">\r\n                        <li><a routerLink=\"about\" routerLinkActive=\"active\">About</a></li>\r\n                        <li><a routerLink=\"contact\" routerLinkActive=\"active\" >Contact</a></li>\r\n                    </ul>\r\n                </li>\r\n            </ul>\r\n        </div>\r\n    </div> \r\n    <div id=\"wrapper\" style=\"width:100%\">\r\n        <!-- Sidebar -->\r\n        <div id=\"sidebar-wrapper\">\r\n            <ul class=\"sidebar-nav\">\r\n                <li>\r\n                    <a routerLink=\"home\" routerLinkActive=\"active\"><i class=\"glyphicon glyphicon-home\"></i> Dashboard </a>\r\n                </li>\r\n                <li>\r\n                    <a data-toggle=\"collapse\" href=\"#tables\" id=\"tbl\"><i class=\"glyphicon glyphicon-list\"></i> Tables <span class=\"glyphicon glyphicon-collapse-down\"></span></a>\r\n                    <ul class=\"panel-collapse collapse\" id=\"tables\">\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['Categories']\">Categories</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['CustomerCustomerDemo']\">CustomerCustomerDemo</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['CustomerDemographics']\">CustomerDemographics</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['Customers']\">Customers</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['Employees']\">Employees</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['EmployeeTerritories']\">EmployeeTerritories</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['OrderDetails']\">OrderDetails</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['Orders']\">Orders</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['Products']\">Products</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['Region']\">Region</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['Shippers']\">Shippers</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['Suppliers']\">Suppliers</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['Territories']\">Territories</a></li>\r\n\r\n                    </ul>\r\n                </li>\r\n                <li>\r\n                    <a data-toggle=\"collapse\" href=\"#views\" id=\"tbl\"><i class=\"glyphicon glyphicon-list\"></i> Views <span class=\"glyphicon glyphicon-collapse-down\"></span></a>\r\n                    <ul class=\"panel-collapse collapse\" id=\"views\">\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['Alphabeticallistofproducts']\">Alphabeticallistofproducts</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['CategorySalesfor1997']\">CategorySalesfor1997</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['CurrentProductList']\">CurrentProductList</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['CustomerandSuppliersbyCity']\">CustomerandSuppliersbyCity</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['Invoices']\">Invoices</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['OrderDetailsExtended']\">OrderDetailsExtended</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['OrderSubtotals']\">OrderSubtotals</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['OrdersQry']\">OrdersQry</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['ProductSalesfor1997']\">ProductSalesfor1997</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['ProductsAboveAveragePrice']\">ProductsAboveAveragePrice</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['ProductsbyCategory']\">ProductsbyCategory</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['QuarterlyOrders']\">QuarterlyOrders</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['SalesbyCategory']\">SalesbyCategory</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['SalesTotalsbyAmount']\">SalesTotalsbyAmount</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['SummaryofSalesbyQuarter']\">SummaryofSalesbyQuarter</a></li>\r\n\t\t\t\t\t\t<li><a [routerLink]=\"['SummaryofSalesbyYear']\">SummaryofSalesbyYear</a></li>\r\n\r\n                    </ul>\r\n                </li>\r\n                <li>\r\n                    <a routerLink=\"/admin\" routerLinkActive=\"active\" *ngIf=\"authService.isLoggedIn\"><i class=\"glyphicon glyphicon-user\"></i> Admin</a>\r\n                </li>\r\n                <li><a href=\"http://northwindapi.codebhagat.com\" target=\"_blank\"><i class=\"glyphicon glyphicon-globe\"></i> APIs</a></li>\r\n                <li>\r\n                    <a routerLink=\"/inbox\" routerLinkActive=\"active\"><i class=\"glyphicon glyphicon-envelope\"></i> Inbox <span class=\"badge\">42</span></a>\r\n                </li>\r\n                <li>\r\n                    <a routerLink=\"/graphs\" routerLinkActive=\"active\"><i class=\"glyphicon glyphicon-align-left\"></i> Graphs </a>\r\n                </li>\r\n                <li>\r\n                    <a routerLink=\"/calendar\" routerLinkActive=\"active\"><i class=\"glyphicon glyphicon-calendar\"></i> Calendar </a>\r\n                </li>\r\n                <li>\r\n                    <a routerLink=\"/settings\" routerLinkActive=\"active\"><i class=\"glyphicon glyphicon-cog\"></i> Settings </a>\r\n                </li>\r\n                <li class=\"dropdown\">\r\n                    <a data-toggle=\"collapse\" href=\"#helpMenu\" id=\"help\"><i class=\"glyphicon glyphicon-question-sign\"></i> Help <span class=\"glyphicon glyphicon-collapse-down\"></span></a>\r\n                    <ul class=\"panel-collapse collapse\" id=\"helpMenu\">\r\n                        <li><a routerLink=\"/about\" routerLinkActive=\"active\" >About</a></li>\r\n                        <li><a routerLink=\"/contact\" routerLinkActive=\"active\" >Contact</a></li>\r\n                    </ul>\r\n                </li>\r\n            </ul>\r\n        </div>\r\n        \r\n\t\t<div id=\"page-content-wrapper\" style=\"padding:5px;\">\r\n            <div class=\"container-fluid\">\r\n                <div class=\"row\">\r\n                    <div class=\"col-lg-12\">\r\n                            <router-outlet></router-outlet>\r\n                        <footer style=\"position:fixed;height:60px;bottom:0;width: 100%;background-color:whitesmoke;padding:10px;\">\r\n                            <p><span>Copyright &copy; 2016 CodeBhagat LLC. All rights reserved. | NorthwindNg2 - Angular 2.0 Web Application </span> </p>\r\n                        </footer>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\t</div>\r\n</div>\r\n\r\n<!--\r\n<header>\r\n  <nav>\r\n    <a [routerLink]=\"['']\">Home</a>\r\n    <a [routerLink]=\"['about']\">About</a>\r\n  </nav>\r\n</header>\r\n<main>\r\n  <h1>Hello from {{api.title}}!!!</h1>\r\n\r\n  <!-- Images (and assets) are parsed and loaded from within the public directory -->\r\n  <!--\r\n  <img src=\"/img/angular.png\">\r\n\r\n  <router-outlet></router-outlet>\r\n</main>\r\n<footer>\r\n  <a [href]=\"url\">Webpack Angular 2 Starter</a>\r\n</footer>\r\n-->"

/***/ },
/* 1134 */
/***/ function(module, exports) {

module.exports = "<h2>Application Settings</h2>\r\n\r\nApplication Settings here..."

/***/ },
/* 1135 */
/***/ function(module, exports) {

module.exports = "<h2>About Us</h2>\r\n\r\n<p>Use this area to provide additional information.</p>\r\n\r\n<p>Aliquam scelerisque, nunc iaculis. Non diam purus, nascetur sodales sociis. Enim ac bibendum, adipiscing ut, adipiscing dolor id. Tincidunt pede, nunc tellus, justo qui iaculis. Nunc sit elit, ornare justo. Est consectetuer in. Vel justo montes. Ipsum mauris nec, integer vel quis. Dolor orci. Diam nulla nunc. Lectus urna cum, dui adipiscing, sollicitudin dictum.</p>\r\n<p>Lorem morbi. Hendrerit varius. Dignissim leo, vel tempus. Pellentesque a. Suspendisse neque, ligula suscipit. Fringilla viverra vel, venenatis pharetra, nostrum elit arcu. Ligula convallis et, at sociosqu, nisl semper. Nec quisque interdum, posuere tincidunt. Mauris in a. Dapibus curabitur.</p>\r\n<p>Lacinia est, orci lacus, non ad. Fugiat tristique, condimentum porttitor maecenas, pellentesque eu. Aenean vitae, interdum tortor risus. Purus et ac. Sed aliquid. Adipiscing malesuada, pellentesque libero mus. Consequat viverra diam. Et blandit, sed quis suscipit. Libero non ac.</p>\r\n<p>Aliquam purus sapien, phasellus nulla bibendum, dictum elit mi. Posuere sed, facilisi fuga sed. Faucibus sapien, wisi a consequat, non donec phasellus. Wisi tempor hendrerit, nunc tincidunt odio. Rutrum adipiscing pretium, dui sit, mauris magna varius. Sit cras sapien, ut pretium, eu morbi fames. Sed euismod sodales. Convallis erat. Luctus eu. Fames eu, velit nunc, aliquam nec ullamcorper. Eleifend ante, diam dui quis, proin fusce voluptatum.</p>\r\n"

/***/ },
/* 1136 */
/***/ function(module, exports) {

module.exports = "<h2>Calendar Events</h2>\r\n\r\nCalendar Events here..."

/***/ },
/* 1137 */
/***/ function(module, exports) {

module.exports = "<!-- Page Content -->\r\n<div class=\"container\">\r\n    <h1 class=\"page-header\">Contact Us\r\n        <small>We'd Love to Hear From You!</small>\r\n    </h1>\r\n    <div class=\"row\">\r\n        <div class=\"col-lg-12\">\r\n            <!-- Embedded Google Map using an iframe - to select your location find it on Google maps and paste the link as the iframe src. If you want to use the Google Maps API instead then have at it! -->\r\n            <iframe width=\"100%\" height=\"400px\" frameborder=\"0\" scrolling=\"no\" marginheight=\"0\" marginwidth=\"0\"\r\n                    src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d55400.16869942088!2d-95.86490942642848!3d29.791791385446597!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640dff9ae358adf%3A0x17966e0d7c2b1125!2sKaty%2C+TX!5e0!3m2!1sen!2sus!4v1480460890767\">\r\n            </iframe>\r\n        </div>\r\n    </div>\r\n    <!-- /.row -->\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-8\">\r\n            <h3>Send us a Message</h3>\r\n\r\n            <form role=\"form\" method=\"POST\" action=\"#\">\r\n                <div class=\"row\">\r\n                    <div class=\"form-group col-lg-4\">\r\n                        <label for=\"input1\">Name</label>\r\n                        <input type=\"text\" name=\"contact_name\" class=\"form-control\" id=\"input1\">\r\n                    </div>\r\n                    <div class=\"form-group col-lg-4\">\r\n                        <label for=\"input2\">Email Address</label>\r\n                        <input type=\"email\" name=\"contact_email\" class=\"form-control\" id=\"input2\">\r\n                    </div>\r\n                    <div class=\"form-group col-lg-4\">\r\n                        <label for=\"input3\">Phone Number</label>\r\n                        <input type=\"phone\" name=\"contact_phone\" class=\"form-control\" id=\"input3\">\r\n                    </div>\r\n                    <div class=\"clearfix\"></div>\r\n                    <div class=\"form-group col-lg-12\">\r\n                        <label for=\"input4\">Message</label>\r\n                        <textarea name=\"contact_message\" class=\"form-control\" rows=\"6\" id=\"input4\"></textarea>\r\n                    </div>\r\n                    <div class=\"form-group col-lg-12\">\r\n                        <input type=\"hidden\" name=\"save\" value=\"contact\">\r\n                        <button type=\"submit\" class=\"btn btn-primary\">Submit</button>\r\n                    </div>\r\n                </div>\r\n            </form>\r\n        </div>\r\n\r\n        <div class=\"col-sm-4\">\r\n            <h3>Let's Get In Touch!</h3>\r\n            <p>\r\n                One Microsoft Way<br>\r\n                Redmond, WA 98052-6399<br>\r\n            </p>\r\n\r\n            <p><i class=\"fa fa-phone\"></i> <abbr title=\"Phone\">P</abbr>: (987) 654-3210</p>\r\n            <p><i class=\"fa fa-fax\"></i> <abbr title=\"Fax\">F</abbr>: (987) 654-3210</p>\r\n\r\n            <p>\r\n                For General Inquiries,<br/>\r\n                <i class=\"fa fa-envelope-o\"></i> <abbr title=\"Email\">E</abbr>: <a href=\"mailto:info@codebhagat.com\">info@codebhagat.com</a>\r\n            </p>\r\n            <p>\r\n                For Support,<br />\r\n                <i class=\"fa fa-envelope-o\"></i> <abbr title=\"Email\">E</abbr>: <a href=\"mailto:support@codebhagat.com\">support@codebhagat.com</a>\r\n            </p>\r\n            <!--<p>\r\n                <i class=\"fa fa-envelope-o\"></i> <abbr title=\"Email\">E</abbr>: <a href=\"mailto:TeamCSS@smartabstractservices.com \">TeamCSS@smartabstractservices.com</a>\r\n            </p>-->\r\n            <p><i class=\"fa fa-clock-o\"></i> <abbr title=\"Hours\">H</abbr>: Monday - Friday: 8:00 AM to 6:00 PM</p>\r\n            <ul class=\"list-unstyled list-inline list-social-icons\">\r\n                <li class=\"tooltip-social facebook-link\"><a href=\"#facebook-page\" data-toggle=\"tooltip\"\r\n                                                            data-placement=\"top\" title=\"Facebook\"><i\r\n                        class=\"fa fa-facebook-square fa-2x\"></i></a></li>\r\n                <li class=\"tooltip-social linkedin-link\"><a href=\"#linkedin-company-page\" data-toggle=\"tooltip\"\r\n                                                            data-placement=\"top\" title=\"LinkedIn\"><i\r\n                        class=\"fa fa-linkedin-square fa-2x\"></i></a></li>\r\n                <li class=\"tooltip-social twitter-link\"><a href=\"#twitter-profile\" data-toggle=\"tooltip\"\r\n                                                           data-placement=\"top\" title=\"Twitter\"><i\r\n                        class=\"fa fa-twitter-square fa-2x\"></i></a></li>\r\n                <li class=\"tooltip-social google-plus-link\"><a href=\"#google-plus-page\" data-toggle=\"tooltip\"\r\n                                                               data-placement=\"top\" title=\"Google+\"><i\r\n                        class=\"fa fa-google-plus-square fa-2x\"></i></a></li>\r\n            </ul>\r\n        </div>\r\n\r\n    </div>\r\n    <!-- /.row -->\r\n\r\n</div><!-- /.container -->"

/***/ },
/* 1138 */
/***/ function(module, exports) {

module.exports = "<h2>Graphs</h2>\r\n\r\n<div class=\"row\">\r\n  <div class=\"col-md-6\">\r\n    <h3>1. Line Chart</h3>\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div style=\"display: block;\">\r\n          <canvas baseChart [datasets]=\"lineChartData\" [labels]=\"lineChartLabels\" [options]=\"lineChartOptions\" [colors]=\"lineChartColors\"\r\n            [legend]=\"lineChartLegend\" [chartType]=\"lineChartType\" (chartHover)=\"lineChartHovered($event)\" (chartClick)=\"lineChartClicked($event)\">\r\n          </canvas>\r\n          <button (click)=\"randomizeLine()\">RANDOMIZE LINE CHART</button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-md-6\">\r\n    <h3>2. Bar Chart</h3>\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div style=\"display: block\">\r\n          <canvas baseChart [datasets]=\"barChartData\" [labels]=\"barChartLabels\" [options]=\"barChartOptions\" [legend]=\"barChartLegend\"\r\n          [chartType]=\"barChartType\" (chartHover)=\"barChartHovered($event)\" (chartClick)=\"barChartClicked($event)\"></canvas>\r\n        </div>\r\n        <button (click)=\"randomizeBar()\">RANDOMIZE BAR CHART</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n  <div class=\"col-md-6\">\r\n    <h3>3. Doughnut Chart</h3>\r\n    <div style=\"display: block\">\r\n      <canvas baseChart [data]=\"doughnutChartData\" [labels]=\"doughnutChartLabels\" [chartType]=\"doughnutChartType\" (chartHover)=\"doughnutChartHovered($event)\"\r\n        (chartClick)=\"doughnutChartClicked($event)\"></canvas>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-md-6\">\r\n    <h3>4. Radar Chart</h3>\r\n    <div style=\"display: block\">\r\n      <canvas baseChart [datasets]=\"radarChartData\" [labels]=\"radarChartLabels\" [chartType]=\"radarChartType\" (chartHover)=\"radarChartHovered($event)\"\r\n        (chartClick)=\"radarChartClicked($event)\"></canvas>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n  <div class=\"col-md-6\">\r\n    <h3>5. Pie Chart</h3>\r\n    <div style=\"display: block\">\r\n      <canvas baseChart [data]=\"pieChartData\" [labels]=\"pieChartLabels\" [chartType]=\"pieChartType\" (chartHover)=\"pieChartHovered($event)\"\r\n        (chartClick)=\"pieChartClicked($event)\"></canvas>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-md-6\">\r\n    <h3>6. Polar Area Chart</h3>\r\n    <div style=\"display: block\">\r\n      <canvas baseChart [data]=\"polarAreaChartData\" [labels]=\"polarAreaChartLabels\" [legend]=\"polarAreaLegend\" [chartType]=\"polarAreaChartType\"\r\n        (chartHover)=\"polarAreaChartHovered($event)\" (chartClick)=\"polarAreaChartClicked($event)\"></canvas>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<h3>7. Dynamic Chart</h3>\r\n<div class=\"col-md-12 text-center\">\r\n  <button (click)=\"randomizeType()\" style=\"display: inline-block\">TOGGLE STYLE</button>\r\n</div>\r\n<div class=\"row\">\r\n<div class=\"col-md-6\">\r\n  <canvas baseChart [data]=\"dynamicLineChartData\" [labels]=\"dynamicLineChartLabels\" [options]=\"dynamicLineChartOptions\" [chartType]=\"dynamicLineChartType\"\r\n    (chartHover)=\"dynamicChartHovered($event)\" (chartClick)=\"dynamicChartClicked($event)\"></canvas>\r\n</div>\r\n<div class=\"col-md-6\">\r\n  <canvas baseChart [data]=\"dynamicPieChartData\" [labels]=\"dynamicPieChartLabels\" [chartType]=\"dynamicPieChartType\" (chartHover)=\"dynamicChartHovered($event)\"\r\n    (chartClick)=\"dynamicChartClicked($event)\"></canvas>\r\n</div>\r\n</div>\r\n"

/***/ },
/* 1139 */
/***/ function(module, exports) {

module.exports = "<h1 id=\"aa\">Angular2 Dashboard</h1>\r\n\r\n<div class=\"jumbotron\">\r\n    <h2>Welcome to Northwind - Angular 2.0 Web application</h2>\r\n    <p class=\"lead\">This application was generated using CodeBhagat source code generator for .NET. You can download CodeBhagat for .NET and use an Application generator to jump-start your new Angular 2.0 Web applications*.</p>\r\n    <p><a href=\"http://www.codebhagat.com\" class=\"btn btn-primary btn-lg\">Learn more &raquo;</a></p>\r\n</div>\r\n"

/***/ },
/* 1140 */
/***/ function(module, exports) {

module.exports = "<h2>Inbox</h2>\r\n\r\nYour sample inbox here...<br />\r\n\r\n<div class=\"row\">\r\n\t<div class=\"col-md-12\">\r\n\t\t<!-- Check all button -->\r\n\t\t<button class=\"btn btn-default btn-sm checkbox-toggle\"><i class=\"glyphicon glyphicon-unchecked\"></i></button>\r\n\t\t<div class=\"btn-group\">\r\n\t\t\t<button class=\"btn btn-default btn-sm\"><i class=\"glyphicon glyphicon-trash\"></i></button>\r\n\t\t\t<button class=\"btn btn-default btn-sm\"><i class=\"glyphicon glyphicon-arrow-left\"></i></button>\r\n\t\t\t<button class=\"btn btn-default btn-sm\"><i class=\"glyphicon glyphicon-share-alt\"></i></button>\r\n\t\t</div><!-- /.btn-group -->\r\n\t\t<button class=\"btn btn-default btn-sm\"><i class=\"glyphicon glyphicon-refresh\"></i></button>\r\n\t\t<div class=\"pull-right\">\r\n\t\t\t1-50/200\r\n\t\t\t<div class=\"btn-group\">\r\n\t\t\t\t<button class=\"btn btn-default btn-sm\"><i class=\"glyphicon glyphicon-arrow-left\"></i></button>\r\n\t\t\t\t<button class=\"btn btn-default btn-sm\"><i class=\"glyphicon glyphicon-arrow-right\"></i></button>\r\n\t\t\t</div><!-- /.btn-group -->\r\n\t\t</div><!-- /.pull-right -->\r\n\t</div>\r\n\t<hr>\r\n\t<div class=\"col-md-12\">\r\n\t\t<div class=\"table-responsive\">\r\n\t\t\t<table class=\"table table-hover table-bordered table-striped\">\r\n\t\t\t\t<tbody>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t<td><input type=\"checkbox\"></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-star\"><a href=\"#\"><i class=\"glyphicon glyphicon-star\"></i></a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-name\"><a href=\"#\">Hymenaeos turpis, malesuada leo, quam wisi fusce.</a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-subject\">Lorem ipsum dolor sit amet, nec pede suspendisse consectetuer, nulla ut nunc platea...</td>\r\n\t\t\t\t\t\t<td class=\"mailbox-attachment\"><i class=\"glyphicon glyphicon-paperclip\"></i></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-date\">5 mins ago</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t<td><input type=\"checkbox\"></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-star\"><a href=\"#\"><i class=\"fa fa-star-o text-yellow\"></i></a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-name\"><a href=\"#\">Quis neque pariatur, lacus sem etiam, facilisis sed</a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-subject\">Lorem ipsum dolor sit amet, purus ut ad diam, auctor odio dis enim, dignissim id vitae et velit, ridiculus leo sed faucibus arcu...</td>\r\n\t\t\t\t\t\t<td class=\"mailbox-attachment\"><i class=\"fa fa-paperclip\"></i></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-date\">28 mins ago</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t<td><input type=\"checkbox\"></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-star\"><a href=\"#\"><i class=\"fa fa-star-o text-yellow\"></i></a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-name\"><a href=\"#\">Ligula tortor lacus, dolor rhoncus.</a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-subject\">Lorem ipsum dolor sit amet, quam risus commodo vivamus at, tortor mattis cum nec....</td>\r\n\t\t\t\t\t\t<td class=\"mailbox-attachment\"><i class=\"fa fa-paperclip\"></i></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-date\">11 hours ago</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t<td><input type=\"checkbox\"></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-star\"><a href=\"#\"><i class=\"glyphicon glyphicon-star\"></i></a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-name\"><a href=\"#\">Malesuada arcu fringilla.</a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-subject\">Eros mattis quod praesent felis, semper turpis ac et, amet donec vel vulputate suscipit....</td>\r\n\t\t\t\t\t\t<td class=\"mailbox-attachment\"><i class=\"glyphicon glyphicon-paperclip\"></i></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-date\">15 hours ago</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t<td><input type=\"checkbox\"></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-star\"><a href=\"#\"><i class=\"fa fa-star text-yellow\"></i></a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-name\"><a href=\"#\">Lorem ipsum dolor sit amet, eleifend tincidunt</a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-subject\">Et lorem at non tortor, enim morbi fusce mus curabitur...</td>\r\n\t\t\t\t\t\t<td class=\"mailbox-attachment\"><i class=\"glyphicon glyphicon-paperclip\"></i></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-date\">Yesterday</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t<td><input type=\"checkbox\"></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-star\"><a href=\"#\"><i class=\"fa fa-star-o text-yellow\"></i></a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-name\"><a href=\"#\">Quisque ut, sit erat euismod, lectus perv</a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-subject\">Scelerisque magna nullam nisl, cum phasellus quis in, eget feugiat nulla minima gravida...</td>\r\n\t\t\t\t\t\t<td class=\"mailbox-attachment\"><i class=\"fa fa-paperclip\"></i></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-date\">2 days ago</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t<td><input type=\"checkbox\"></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-star\"><a href=\"#\"><i class=\"fa fa-star-o text-yellow\"></i></a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-name\"><a href=\"#\">Lorem ipsum dolor sit amet, platea nostrud ante</a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-subject\">Elit elit hendrerit in, donec congue feugiat velit leo, molestie magnis dictum donec, in magna mi ante...</td>\r\n\t\t\t\t\t\t<td class=\"mailbox-attachment\"><i class=\"fa fa-paperclip\"></i></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-date\">2 days ago</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t<td><input type=\"checkbox\"></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-star\"><a href=\"#\"><i class=\"fa fa-star text-yellow\"></i></a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-name\"><a href=\"#\">Lorem ipsum lectus odio quam.</a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-subject\">Amet wisi quis tempus neque, in eget vitae sed elit, et lacus etiam placerat amet...</td>\r\n\t\t\t\t\t\t<td class=\"mailbox-attachment\"></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-date\">2 days ago</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t<td><input type=\"checkbox\"></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-star\"><a href=\"#\"><i class=\"glyphicon glyphicon-star\"></i></a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-name\"><a href=\"#\">Lorem ipsum dolor sit amet, ante ante</a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-subject\">Lobortis massa porta interdum non, eum ipsum pellentesque pretium, urna duis amet aptent duis...</td>\r\n\t\t\t\t\t\t<td class=\"mailbox-attachment\"></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-date\">2 days ago</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t<td><input type=\"checkbox\"></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-star\"><a href=\"#\"><i class=\"fa fa-star-o text-yellow\"></i></a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-name\"><a href=\"#\">Lorem ipsum dolor sit amet, non ac.</a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-subject\">Esse praesent amet cum ante, nullam nulla ac ac volutpat, imperdiet elementum dis eget, elit inceptos et vulputate...</td>\r\n\t\t\t\t\t\t<td class=\"mailbox-attachment\"></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-date\">2 days ago</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t<td><input type=\"checkbox\"></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-star\"><a href=\"#\"><i class=\"fa fa-star-o text-yellow\"></i></a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-name\"><a href=\"#\">Lorem ipsum dolor sit amet, nulla pede.</a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-subject\">Non sed dis blandit suspendisse, sapien vel non nibh...</td>\r\n\t\t\t\t\t\t<td class=\"mailbox-attachment\"><i class=\"fa fa-paperclip\"></i></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-date\">4 days ago</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t<td><input type=\"checkbox\"></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-star\"><a href=\"#\"><i class=\"fa fa-star text-yellow\"></i></a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-name\"><a href=\"#\">WM06</a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-subject\">Tempor nulla nec urna, congue maecenas nec nullam nulla, sagittis leo duis dignissim, leo vivamus cras fusce...</td>\r\n\t\t\t\t\t\t<td class=\"mailbox-attachment\"><i class=\"glyphicon glyphicon-paperclip\"></i></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-date\">12 days ago</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t<td><input type=\"checkbox\"></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-star\"><a href=\"#\"><i class=\"fa fa-star-o text-yellow\"></i></a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-name\"><a href=\"#\">Lorem ipsum dolor sit amet</a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-subject\">Cras pede aliquam porta mauris, enim metus fames ac massa, torquent eleifend vel imperdiet, elementum non commodo congue...</td>\r\n\t\t\t\t\t\t<td class=\"mailbox-attachment\"><i class=\"fa fa-paperclip\"></i></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-date\">12 days ago</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t<td><input type=\"checkbox\"></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-star\"><a href=\"#\"><i class=\"fa fa-star text-yellow\"></i></a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-name\"><a href=\"#\">Lorem ipsum dolor sit amet, integer pede a</a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-subject\">Consectetuer commodo massa felis, sed egestas at dui, velit turpis ac in semper, litora justo mollis cras eros...</td>\r\n\t\t\t\t\t\t<td class=\"mailbox-attachment\"><i class=\"fa fa-paperclip\"></i></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-date\">14 days ago</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t<td><input type=\"checkbox\"></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-star\"><a href=\"#\"><i class=\"fa fa-star text-yellow\"></i></a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-name\"><a href=\"#\">Lorem ipsum dolor sit amet, odio rhoncus, sit ultrices.</a></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-subject\">Lacus pede sit nec, et quam mauris nulla purus, dictumst quam nostra quasi erat...</td>\r\n\t\t\t\t\t\t<td class=\"mailbox-attachment\"><i class=\"glyphicon glyphicon-paperclip\"></i></td>\r\n\t\t\t\t\t\t<td class=\"mailbox-date\">15 days ago</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t</tbody>\r\n\t\t\t</table><!-- /.table -->\r\n\t\t</div><!-- /.mail-box-messages -->\r\n\t</div>\r\n\t<div class=\"col-md-12\">\r\n\t\t<!-- Check all button -->\r\n\t\t<button class=\"btn btn-default btn-sm checkbox-toggle\"><i class=\"glyphicon glyphicon-unchecked\"></i></button>\r\n\t\t<div class=\"btn-group\">\r\n\t\t\t<button class=\"btn btn-default btn-sm\"><i class=\"glyphicon glyphicon-trash\"></i></button>\r\n\t\t\t<button class=\"btn btn-default btn-sm\"><i class=\"glyphicon glyphicon-arrow-left\"></i></button>\r\n\t\t\t<button class=\"btn btn-default btn-sm\"><i class=\"glyphicon glyphicon-share-alt\"></i></button>\r\n\t\t</div><!-- /.btn-group -->\r\n\t\t<button class=\"btn btn-default btn-sm\"><i class=\"glyphicon glyphicon-refresh\"></i></button>\r\n\t\t<div class=\"pull-right\">\r\n\t\t\t1-50/200\r\n\t\t\t<div class=\"btn-group\">\r\n\t\t\t\t<button class=\"btn btn-default btn-sm\"><i class=\"glyphicon glyphicon-arrow-left\"></i></button>\r\n\t\t\t\t<button class=\"btn btn-default btn-sm\"><i class=\"glyphicon glyphicon-arrow-right\"></i></button>\r\n\t\t\t</div><!-- /.btn-group -->\r\n\t\t</div><!-- /.pull-right -->\r\n\t</div>\r\n</div>\r\n"

/***/ },
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var platform_browser_dynamic_1 = __webpack_require__(168);
var app_module_1 = __webpack_require__(763);
// depending on the env mode, enable prod mode or add debugging modules
if (true) {
    core_1.enableProdMode();
}
function main() {
    return platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.AppModule).then(function (MODULE_REF) { if (false) {
        module["hot"]["accept"]();
        if (MODULE_REF.instance["hmrOnInit"]) {
            module["hot"]["data"] && MODULE_REF.instance["hmrOnInit"](module["hot"]["data"]);
        }
        if (MODULE_REF.instance["hmrOnStatus"]) {
            module["hot"]["apply"](function (status) { MODULE_REF.instance["hmrOnStatus"](status); });
        }
        if (MODULE_REF.instance["hmrOnCheck"]) {
            module["hot"]["check"](function (err, outdatedModules) { MODULE_REF.instance["hmrOnCheck"](err, outdatedModules); });
        }
        if (MODULE_REF.instance["hmrOnDecline"]) {
            module["hot"]["decline"](function (dependencies) { MODULE_REF.instance["hmrOnDecline"](dependencies); });
        }
        module["hot"]["dispose"](function (store) { MODULE_REF.instance["hmrOnDestroy"] && MODULE_REF.instance["hmrOnDestroy"](store); MODULE_REF.destroy(); MODULE_REF.instance["hmrAfterDestroy"] && MODULE_REF.instance["hmrAfterDestroy"](store); });
    } return MODULE_REF; });
}
exports.main = main;
if (document.readyState === 'complete') {
    main();
}
else {
    document.addEventListener('DOMContentLoaded', main);
}


/***/ }
],[1401]);


// WEBPACK FOOTER //
// js/app.ef0afbd0c04dde848c0d.js